(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gservicios.servicios', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_servicios', {
            url: '/root/servicios',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/gservicios/servicios/servicios.html',
                    controller: 'serviciosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/gservicios/servicios');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gservicios.servicios')
            .controller('serviciosController', serviciosController);

    /** @ngInject */
    function serviciosController(quantionApi, $mdDialog, $mdToast, $scope, $location, $rootScope, $filter, $mdSidenav, JSONconfig, FilePaths, $compile, $timeout)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_G_SERVICIOS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.showGroupedServices = localStorage['servicesGroupedByCategory'] === 'true';

        CargarServicios($location.search().select, $scope.showGroupedServices);
        function CargarServicios(srvType, groupByCategory) {
            pantallaCarga.lsEnable('LS.SERVICIOS');
            vm.listaServicios = {};
            vm.serviceMap = {};
            vm.allCategories = [];

            quantionApi.getTiposServicio().then(function (dataResponse) {
                $.each(dataResponse.data, function (index, value) {
                    vm.listaServicios[value] = [];
                });

                $scope.tiposServicio = dataResponse.data;
                $scope.tiposServicio.sort(function (a, b) {
                    return $filter('translate')('SERVICIOS.TIPOS.' + a).localeCompare($filter('translate')('SERVICIOS.TIPOS.' + b));
                });

                quantionApi.getServicios(false).then(function (dataResponse) {
                    pantallaCarga.lsDisable();

                    $.each($filter('orderBy')(dataResponse.data, 'name|formatNameDesc'), function (index, value) {
                        vm.listaServicios[value.type].push(value);
                        vm.serviceMap[value.idService] = value;

                        if (value.category && vm.allCategories.indexOf(value.category) < 0)
                            vm.allCategories.push(value.category);
                    });

                    if (srvType)
                        $scope.selectType(srvType, groupByCategory);
                    else
                        $scope.selectType($scope.tiposServicio[0], groupByCategory);
                }, function () {
                    pantallaCarga.lsDisable();
                });

            });
        }

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.listaIdiomas = dataResponse.data;
            vm.mapIdiomas = {};
            $.each(vm.listaIdiomas, function (index, value) {
                vm.mapIdiomas[value.idioma] = value;
            });
        });

        quantionApi.getCanalesTV().then(function (dataResponse) {
            vm.listaCanales = dataResponse.data;
        });

        quantionApi.getInstalacionThemes().then(function (dataResponse) {
            vm.listaTemas = dataResponse.data;
        });

        $scope.selectType = function (type, groupByCategory) {
            pantallaCarga.lsEnable('LS.SERVICIOS');

            localStorage['servicesGroupedByCategory'] = groupByCategory;

            if (groupByCategory) {
                var groupedServices = {};

                $.each(vm.listaServicios[type], function (index, value) {
                    var c = value.category || "";

                    if (!groupedServices[c])
                        groupedServices[c] = [];

                    groupedServices[c].push(value);
                });

                $timeout(function () {
                    $scope.selectedType = type;

                    var html = '';

                    var k = $filter('orderBy')(Object.keys(groupedServices));

                    $.each(k, function (index, category) {
                        if (category)
                            html += '<md-subheader class="margin-top-24">' + category + '</md-subheader>';

                        $.each(groupedServices[category], function (index, srvc) {
                            html += '<md-list-item class="md-3-line layout-wrap">' +
                                    '    <img src="' + $filter('replacePath')(srvc.logo) + '" on-error-image="/assets/quantionImagenes/img-error.png" ng-click="vm.imagenesServicio($event, ' + srvc.idService + ')"/>' +
                                    (srvc.active ? '<md-icon md-font-icon="icon-checkbox-marked-circle"></md-icon>' : '') +
                                    (srvc.lang ? '<img class="flag" src="' + $filter('replacePath')(vm.mapIdiomas[srvc.lang].rutaIcono) + '"/>' : '') +
                                    '    <div class="md-list-item-text layout-column flex">' +
                                    '        <h3><span>' + $filter('translate')("PAQUETES.NOMBRE") + '</span> ' + $filter('formatNameDesc')(srvc.name) + ' (' + srvc.acl + ')</h3>' +
                                    '        <h4><span>' + $filter('translate')("PAQUETES.DESCRIPCION") + '</span> ' + $filter('formatNameDesc')(srvc.description) + '</h4>';

                            if (srvc.elements)
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMELEMENTOS") + '</span> ' + srvc.elements.length + '</h4>';

                            if (srvc.samples)
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMARCHIVOS") + '</span> ' + srvc.samples.length + '</h4>';

                            if (srvc.countries)
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.PAISES") + '</span> ' + $filter('stringifyArray')(srvc.countries) + '</h4>';

                            if (srvc.cities)
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.CIUDADES") + '</span> ' + $filter('stringifyArray')(srvc.cities) + '</h4>';

                            if (srvc.channelList)
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMCANALES") + '</span> ' + srvc.channelList.length + '</h4>';

                            if (srvc.type === 'web' || srvc.type === 'game')
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.URL") + '</span> ' + $filter('parseJSON')(srvc.toAction.data, 'url') + '</h4>';

                            if (srvc.maxConnections)
                                html += '<h4><span>' + $filter('translate')("SERVICIOS.MAXCONEXIONES") + '</span> ' + srvc.maxConnections +
                                        (srvc.portal ? ('<span> - ' + $filter('translate')("SERVICIOS.MODALEDITAR.PORTAL") + '</span> ' + srvc.portal) : '') +
                                        '</h4>';

                            html += '</div><div layout="row" layout-wrap flex-xs="100" flex-sm="100">';

                            if (srvc.channelList)
                                html += '<md-button class="md-fab md-mini" ng-click="vm.asignarCanalesTV($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-library-plus"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.ADDCANALES") + '</md-tooltip>' +
                                        '</md-button>' +
                                        '<md-button class="md-fab md-mini" ng-click="vm.ordenarCanalesTV($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-format-line-spacing"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.ORDENCANALES") + '</md-tooltip>' +
                                        '</md-button>';

                            if (srvc.elements)
                                html += '<md-button class="md-fab md-mini" ng-click="vm.ventanaServicioAGrupo($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-group"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.SERVICIOSCONTENIDOS") + '</md-tooltip>' +
                                        '</md-button>';

                            if (srvc.samples)
                                html += '<md-button class="md-fab md-mini" ng-click="vm.ventanaSamples($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-file-multiple"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.LISTAARCHIVOS") + '</md-tooltip>' +
                                        '</md-button>';

                            if (srvc.dates)
                                html += '<md-button class="md-fab md-mini" ng-click="vm.calendar($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-calendar"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.LISTACALENDAR") + '</md-tooltip>' +
                                        '</md-button>';

                            if (srvc.type === 'modal')
                                html += '<md-button class="md-fab md-mini" ng-click="vm.modalService($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-tooltip-text"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODALACTIONS") + '</md-tooltip>' +
                                        '</md-button>';

                            if (srvc.type === 'widget')
                                html += '<md-button class="md-fab md-mini" ng-click="vm.widgetService($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-tooltip-text"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.WIDGETACTIONS") + '</md-tooltip>' +
                                        '</md-button>';

                            if (srvc.dependencies)
                                html += '<md-button class="md-fab md-mini" ng-click="vm.dependenciasWidget($event, ' + srvc.idService + ')">' +
                                        '    <md-icon md-font-icon="icon-arrange-bring-forward"></md-icon>' +
                                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.DEPENDENCIAS") + '</md-tooltip>' +
                                        '</md-button>';

                            html += '<md-button class="md-fab md-mini" ng-click="vm.imagenesServicio($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-image-filter"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODALIMAGENES.TITLE") + '</md-tooltip>' +
                                    '</md-button>' +
                                    '<md-button class="md-fab md-mini" ng-click="vm.ventanaEditar($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-pencil"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODIFICARSERVICIO") + '</md-tooltip>' +
                                    '</md-button>' +
                                    '<md-button class="md-fab md-mini" ng-click="vm.eliminarServicio($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-delete"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.ELIMINARSERVICIO") + '</md-tooltip>' +
                                    '</md-button>';


                            html += '</div><span style="position:absolute;bottom: 0;left: 0">ID' + srvc.idService + '</span></md-list-item>';
                        });
                    });

                    $('#service-container').empty().append(html);
                    $compile($('#service-container'))($scope);
                    pantallaCarga.lsDisable();
                }, 200);
            } else {
                $timeout(function () {
                    $scope.selectedType = type;

                    var html = '';

                    $.each(vm.listaServicios[type], function (index, srvc) {
                        html += '<md-list-item class="md-3-line layout-wrap">' +
                                '    <img src="' + $filter('replacePath')(srvc.logo) + '" style="width: 50px; margin-right: 20px" on-error-image="/assets/quantionImagenes/img-error.png" ng-click="vm.imagenesServicio($event, ' + srvc.idService + ')"/>' +
                                (srvc.active ? '<md-icon md-font-icon="icon-checkbox-marked-circle"></md-icon>' : '') +
                                (srvc.lang ? '<img class="flag" src="' + $filter('replacePath')(vm.mapIdiomas[srvc.lang].rutaIcono) + '"/>' : '') +
                                '    <div class="md-list-item-text layout-column flex">' +
                                '        <h3><span>' + $filter('translate')("PAQUETES.NOMBRE") + '</span> ' + $filter('formatNameDesc')(srvc.name) + ' (' + srvc.acl + ')</h3>' +
                                '        <h4><span>' + $filter('translate')("PAQUETES.DESCRIPCION") + '</span> ' + $filter('formatNameDesc')(srvc.description) + '</h4>';

                        if (srvc.elements)
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMELEMENTOS") + '</span> ' + srvc.elements.length + '</h4>';

                        if (srvc.samples)
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMARCHIVOS") + '</span> ' + srvc.samples.length + '</h4>';

                        if (srvc.countries)
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.PAISES") + '</span> ' + $filter('stringifyArray')(srvc.countries) + '</h4>';

                        if (srvc.cities)
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.CIUDADES") + '</span> ' + $filter('stringifyArray')(srvc.cities) + '</h4>';

                        if (srvc.channelList)
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMCANALES") + '</span> ' + srvc.channelList.length + '</h4>';

                        if (srvc.type === 'web' || srvc.type === 'game')
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.URL") + '</span> ' + $filter('parseJSON')(srvc.toAction.data, 'url') + '</h4>';

                        if (srvc.maxConnections)
                            html += '<h4><span>' + $filter('translate')("SERVICIOS.MAXCONEXIONES") + '</span> ' + srvc.maxConnections +
                                    (srvc.portal ? ('<span> - ' + $filter('translate')("SERVICIOS.PORTAL") + '</span> ' + srvc.portal) : '') +
                                    '</h4>';

                        html += '</div><div layout="row" layout-wrap flex-xs="100" flex-sm="100">';

                        if (srvc.channelList)
                            html += '<md-button class="md-fab md-mini" ng-click="vm.asignarCanalesTV($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-library-plus"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.ADDCANALES") + '</md-tooltip>' +
                                    '</md-button>' +
                                    '<md-button class="md-fab md-mini" ng-click="vm.ordenarCanalesTV($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-format-line-spacing"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.ORDENCANALES") + '</md-tooltip>' +
                                    '</md-button>';

                        if (srvc.elements)
                            html += '<md-button class="md-fab md-mini" ng-click="vm.ventanaServicioAGrupo($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-group"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.SERVICIOSCONTENIDOS") + '</md-tooltip>' +
                                    '</md-button>';

                        if (srvc.samples)
                            html += '<md-button class="md-fab md-mini" ng-click="vm.ventanaSamples($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-file-multiple"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.LISTAARCHIVOS") + '</md-tooltip>' +
                                    '</md-button>';

                        if (srvc.dates)
                            html += '<md-button class="md-fab md-mini" ng-click="vm.calendar($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-calendar"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.LISTACALENDAR") + '</md-tooltip>' +
                                    '</md-button>';

                        if (srvc.type === 'modal')
                            html += '<md-button class="md-fab md-mini" ng-click="vm.modalService($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-tooltip-text"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODALACTIONS") + '</md-tooltip>' +
                                    '</md-button>';

                        if (srvc.type === 'widget')
                            html += '<md-button class="md-fab md-mini" ng-click="vm.widgetService($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-tooltip-text"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.WIDGETACTIONS") + '</md-tooltip>' +
                                    '</md-button>';

                        if (srvc.dependencies)
                            html += '<md-button class="md-fab md-mini" ng-click="vm.dependenciasWidget($event, ' + srvc.idService + ')">' +
                                    '    <md-icon md-font-icon="icon-arrange-bring-forward"></md-icon>' +
                                    '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.DEPENDENCIAS") + '</md-tooltip>' +
                                    '</md-button>';

                        html += '<md-button class="md-fab md-mini" ng-click="vm.imagenesServicio($event, ' + srvc.idService + ')">' +
                                '    <md-icon md-font-icon="icon-image-filter"></md-icon>' +
                                '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODALIMAGENES.TITLE") + '</md-tooltip>' +
                                '</md-button>' +
                                '<md-button class="md-fab md-mini" ng-click="vm.ventanaEditar($event, ' + srvc.idService + ')">' +
                                '    <md-icon md-font-icon="icon-pencil"></md-icon>' +
                                '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODIFICARSERVICIO") + '</md-tooltip>' +
                                '</md-button>' +
                                '<md-button class="md-fab md-mini" ng-click="vm.eliminarServicio($event, ' + srvc.idService + ')">' +
                                '    <md-icon md-font-icon="icon-delete"></md-icon>' +
                                '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.ELIMINARSERVICIO") + '</md-tooltip>' +
                                '</md-button>';


                        html += '</div><span style="position:absolute;bottom: 0;left: 0">ID' + srvc.idService + '</span></md-list-item>';
                    });

                    $('#service-container').empty().append(html);
                    $compile($('#service-container'))($scope);
                    pantallaCarga.lsDisable();
                }, 200);
            }
        };


        //Creacion de servicios
        vm.ventanaNuevo = function (ev, tipo) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/crearservicio.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {tipo: tipo}
            });
        };

        function NuevoCtrl($scope, $mdDialog, tipo) {
            $scope.title = "SERVICIOS.MODALEDITAR.TITLECREAR";
            $scope.serviceType = tipo;
            $scope.listaIdiomas = vm.listaIdiomas;
            $scope.tipo = tipo;
            $scope.accion = 'crear';
            $scope.listaLogos = vm.listaLogos;
            $scope.listaTemas = vm.listaTemas;
            $scope.allCategories = vm.allCategories;

            $scope.selectedThemes = [];

            $scope.service = {
                type: tipo,
                name: {},
                description: {},
                toAction: {}
            };

            $scope.toActionInputType = false;
            $scope.toActionBasic = {
                method: 'POST',
                url: "",
                data: ""
            };
            $scope.toActionAdv = {
                method: 'POST',
                url: "",
                data: '{"url": ""}'
            };

            $scope.watchAcl = function () {
                if ($scope.service.type !== 'group' && $scope.service.type !== 'files')
                    return;

                $scope.toActionBasic.data = $scope.service.type === 'group' ? 'group/' + $scope.service.acl : '/files/' + $scope.service.acl;
                $scope.toActionAdv.data = $scope.toActionAdv.data.replace(/"url": "([^"']*)"/ig, '"url": "' + ($scope.service.type === 'group' ? 'group/' + $scope.service.acl : '/files/' + $scope.service.acl) + '"');
            };

            if (tipo === 'tv') {
                $scope.service.blockedVideo = {};
                $scope.service.visibleVideo = {};
            }

            if (tipo === 'onlineradio') {
                $scope.service.countries = [];
            }

            if (tipo === 'weather') {
                $scope.service.cities = [];
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var service = angular.copy($scope.service);
//                service.tag = $scope.tagSelected.length > 0 ? '-' + $scope.tagSelected.join('-') + '-' : '';

                if ($scope.toActionInputType) {
                    service.toAction = angular.copy($scope.toActionAdv);
                } else {
                    service.toAction = {
                        method: 'POST',
                        url: $scope.toActionBasic.url,
                        data: "{\"url\": \"" + $scope.toActionBasic.data + "\"}"
                    };
                }

                service.logo = JSONconfig.logosPath.from + '/' + FilePaths.servicios_paquetes + '/' + service.acl + '.png';

                if (service.portal === '') {
                    service.portal = null;
                }

                var jsonObj = angular.toJson(service, 0);
                console.log(angular.toJson(service, true));

                quantionApi.addServicio(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('SERVICIOS.CREARTOAST')).position('top right').hideDelay(3000));
                    CargarServicios($scope.service.type);
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "SERVICIOS.MODALEDITAR.ERRORCREAR";
                    $scope.dataLoading = false;
                });
            };

            $scope.tagSelected = [];
            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };
        }

        //Modificacion de servicio
        vm.ventanaEditar = function (ev, srvc) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/crearservicio.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, servicio) {
            $scope.title = "SERVICIOS.MODALEDITAR.TITLEEDITAR";
            $scope.serviceType = servicio.type;
            $scope.listaIdiomas = vm.listaIdiomas;
            $scope.accion = 'editar';
            $scope.listaLogos = vm.listaLogos;
            $scope.listaTemas = vm.listaTemas;
            $scope.allCategories = vm.allCategories;

            $scope.selectedThemes = [];

            $scope.service = angular.copy(servicio);//Clonar objeto servicio

            delete $scope.service.name;
            delete $scope.service.description;

            switch (servicio.type) {
                case 'tv':
                    delete $scope.service.blockedVideo;
                    delete $scope.service.visibleVideo;
                    delete $scope.service.channelList;
                    delete $scope.service.orders;
                    break;
                case 'web':
                    delete $scope.service.body;
                    break;
                case 'files':
                    delete $scope.service.samples;
                    break;
                case 'group':
                    delete $scope.service.elements;
                    delete $scope.service.defaultService;
                    break;
            }

            $scope.toActionInputType = isJSON(servicio.toAction.data) ? Object.keys(angular.fromJson(servicio.toAction.data)).length > 1 : true;
            $scope.toActionBasic = {
                method: 'POST',
                url: servicio.toAction ? servicio.toAction.url : "",
                data: (servicio.toAction && isJSON(servicio.toAction.data) ? angular.fromJson(servicio.toAction.data).url : "")
            };
            $scope.toActionAdv = angular.copy(servicio.toAction);

            $scope.watchAcl = function () {
                if ($scope.service.type !== 'group' && $scope.service.type !== 'files')
                    return;

                $scope.toActionBasic.data = $scope.service.type === 'group' ? 'group/' + $scope.service.acl : '/files/' + $scope.service.acl;
                $scope.toActionAdv.data = $scope.toActionAdv.data.replace(/"url": "([^"']*)"/ig, '"url": "' + ($scope.service.type === 'group' ? 'group/' + $scope.service.acl : '/files/' + $scope.service.acl) + '"');
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var service = angular.copy($scope.service);

                if ($scope.toActionInputType) {
                    service.toAction = angular.copy($scope.toActionAdv);
                } else {
                    service.toAction = {
                        method: 'POST',
                        url: $scope.toActionBasic.url,
                        data: "{\"url\": \"" + $scope.toActionBasic.data + "\"}"
                    };
                }

                service.logo = JSONconfig.logosPath.from + '/' + FilePaths.servicios_paquetes + '/' + service.acl + '.png';

                if (service.portal === '') {
                    service.portal = null;
                }
                
                var jsonObj = angular.toJson(service, 0);
                console.log(angular.toJson(service, true));

                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('SERVICIOS.EDITARTOAST')).position('top right').hideDelay(3000));
                    CargarServicios($scope.service.type);
                    $scope.hide();
                }, function () {
                    $scope.mensajeError = "SERVICIOS.MODALEDITAR.ERROREDITAR";
                    $scope.dataLoading = false;
                });
            };

//            $scope.tagSelected = $scope.service.tag ? $scope.service.tag.split('-').filter(function (e) {
//                return e.length > 0;
//            }) : [];
//            $scope.toggle = function (item, list) {
//                var idx = list.indexOf(item);
//                if (idx > -1)
//                    list.splice(idx, 1);
//                else
//                    list.push(item);
//            };
//            $scope.exists = function (item, list) {
//                return list.indexOf(item) > -1;
//            };
        }

        //Borrado de servicio
        vm.eliminarServicio = function (ev, srvc) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('SERVICIOS.CONFIRMELIMINAR.TITLE'))
                    .textContent($filter('translate')('SERVICIOS.CONFIRMELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('SERVICIOS.CONFIRMELIMINAR.OK'))
                    .cancel($filter('translate')('SERVICIOS.CONFIRMELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteServicio(srvc).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('SERVICIOS.CONFIRMELIMINAR.TOAST')).position('top right').hideDelay(3000));

                    quantionApi.deleteGenericFile(vm.serviceMap[srvc].acl + '.png', FilePaths.servicios_paquetes).then(function (dataResponse) {
                    }, function () {
                    });

                    CargarServicios(vm.serviceMap[srvc].type);
                });
            }, function (dataResponse) {
                console.log(dataResponse);
            });
        };

        //Asignacion de canales a servicio TV
        vm.asignarCanalesTV = function (ev, srvc) {
            if (vm.serviceMap[srvc].type === 'tv')
                $mdDialog.show({
                    controller: AsignarCanalCtrl,
                    templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/asignarcanal.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {servicio: vm.serviceMap[srvc]}
                });
        };

        function AsignarCanalCtrl($scope, $mdDialog, $mdToast, servicio) {
            var canalesInicialesEnServicio = servicio.channelList.map(function (item, index) {
                return item.idCanal;
            });
            $scope.listaIdiomas = [];
            $scope.listaCanales = vm.listaCanales.map(function (elm) {
                $scope.listaIdiomas = $scope.listaIdiomas.concat(elm.idiomas);
                elm.seleccionado = ($.inArray(elm.idCanal, canalesInicialesEnServicio) !== -1);
                return elm;
            });
            $scope.listaIdiomas = $.unique($scope.listaIdiomas);

            $scope.busquedaIdioma = [];
            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.filterByLang = function (elm) {
                for (var i = 0; i < $scope.busquedaIdioma.length; i++) {
                    if (elm.idiomas.indexOf($scope.busquedaIdioma[i]) === -1)
                        return false;
                }
                return true;
            };

            $scope.toggleSelect = function (canal) {
                canal.seleccionado = !canal.seleccionado;
            };

            $scope.setAll = function (boolean) {
                $.each($scope.listaCanales, function (i, el) {
                    el.seleccionado = boolean;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    channelList: $scope.listaCanales
                            .filter(function (elm) {
                                return elm.seleccionado;
                            })
                            .map(function (item) {
                                return {idCanal: item.idCanal};
                            }),
                    orders: {}
                };

                var channelListIds = obj.channelList.map(function (item) {
                    return item.idCanal;
                });

                $.each(servicio.orders, function (key, value) {
                    var arr = [];
                    $.each(value, function (index, value2) {
                        if (channelListIds.indexOf(value2) > -1)
                            arr.push(value2);
                    });
                    $.each(channelListIds, function (index, value2) {
                        if (value.indexOf(value2) === -1)
                            arr.push(value2);
                    });
                    obj.orders[key] = arr;
                });

                var jsonObj = angular.toJson(obj, 0);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };
        }

        //Ordenación de canales
        vm.ordenarCanalesTV = function (ev, srvc) {
            $mdDialog.show({
                controller: OrdenarCanalCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/ordenarcanales.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function OrdenarCanalCtrl($scope, $mdDialog, $mdToast, servicio) {
            $scope.service = servicio;

            $scope.listaCodes = [];
            var listaCanales = servicio.channelList.map(function (e) {
                $scope.listaCodes = $scope.listaCodes.concat(e.idiomas);
                return e;
            });
            $scope.listaCodes = $.unique($scope.listaCodes);

            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.ordenacion = {
                es: respetarOrden(listaCanales, servicio.orders.es),
                en: respetarOrden(listaCanales, servicio.orders.en),
                fr: respetarOrden(listaCanales, servicio.orders.fr),
                de: respetarOrden(listaCanales, servicio.orders.de)
            };

            $scope.hide = function () {
                CargarServiciosTV();

                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var obj = {
                    orders: {}
                };

                $.each($scope.ordenacion, function (key, value) {
                    obj.orders[key] = ConvertirCanalesAIDs(value);
                });

                var jsonObj = angular.toJson(obj, 0);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            function ConvertirCanalesAIDs(arrayCanales) {
                var arr = arrayCanales.map(function (elm) {
                    return elm.idCanal;
                });
                return arr;
            }

            //Pasa el array de ID de canales a array de objetos completos.
            function respetarOrden(arrayAOrdenar, arrayIndicesOrden) {
                var arr = angular.copy(arrayAOrdenar);
                if (!arrayIndicesOrden)
                    arrayIndicesOrden = [];
                arr.sort(
                        function (a, b) {
                            return arrayIndicesOrden.indexOf(a.idCanal) - arrayIndicesOrden.indexOf(b.idCanal);
                        }
                );
                return arr;
            }

            $scope.sortableOptionsOrden = {
                revert: true,
                distance: 10,
                tolerance: "pointer",
                placeholder: "lsta-highlight"
            };

            $scope.copiarOrden = function (idioma) {
                console.log(idioma);
                $scope.tempOrden = angular.copy($scope.ordenacion[idioma]);
            };

            $scope.pegarOrden = function (idioma) {
                console.log($scope.tempOrden);
                $scope.ordenacion[idioma] = angular.copy($scope.tempOrden);
                $scope.tempOrden = null;
            };

            $scope.priorizarIdioma = function (idioma, code) {
                $scope.ordenacion[idioma].sort(
                        function (a, b) {
                            var hasA = a.idiomas.indexOf(code);
                            var hasB = b.idiomas.indexOf(code);

                            if (hasB > hasA)
                                return 1;
                            else
                                return -1;
                        }
                );
            };

            $scope.swap = function (list, x, y) {
                var b = list[y];
                list[y] = list[x];
                list[x] = b;
            };
        }

        vm.ventanaServicioAGrupo = function (ev, grupo) {
            if (vm.serviceMap[grupo].type === 'group')
                $mdDialog.show({
                    controller: AsignarServicioAGrupo,
                    templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/asignaragrupo.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {grupo: vm.serviceMap[grupo]}
                });
        };

        function AsignarServicioAGrupo($scope, $mdDialog, $mdToast, grupo) {
            $scope.listaServicios = {};
            $scope.group = angular.copy(grupo);
            if (grupo.defaultService)
                $scope.group.defaultService = grupo.defaultService.idService;

            $scope.selected = grupo.elements.map(function (elm) {
                return elm.idService;
            });
            $.each(angular.copy(vm.listaServicios), function (key, value) {
                $scope.listaServicios[key] = value.map(function (elm) {
                    return elm;
                });
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var obj = {elements: $scope.selected, defaultService: $scope.group.defaultService};
                var jsonObj = angular.toJson(obj, 0);

                quantionApi.updateServicio(grupo.idService, jsonObj).then(function (dataResponse) {
                    $mdDialog.hide();
                    console.log(dataResponse.data);

                    $mdDialog.show({
                        controller: OrdenGrupo,
                        templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/orden-grupo.tmpl.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        locals: {grupo: dataResponse.data}
                    });
                });
            };

            $scope.checkDefault = function (srv) {
                if (srv.idService !== $scope.group.defaultService)
                    $scope.group.defaultService = srv.idService;
                else
                    $scope.group.defaultService = null;
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            function OrdenGrupo($scope, $mdDialog, $mdToast, grupo) {
                $scope.group = angular.copy(grupo);

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.guardar = function () {
                    var jsonObj = angular.toJson({
                        elements: $scope.group.elements.map(function (e) {
                            return e.idService;
                        })
                    });
                    quantionApi.updateServicio(grupo.idService, jsonObj).then(function (dataResponse) {
                        CargarServicios(grupo.type);
                        $mdDialog.hide();
                    });
                };

                $scope.sortableOptionsOrden = {
                    revert: true,
                    distance: 10,
                    tolerance: "pointer",
                    placeholder: "orden-grupo-highlight"
                };
            }

            $scope.fold = function (tipo) {
                $('#grupo_' + tipo).toggleClass('hide');

                if ($('#grupo_' + tipo).hasClass('hide')) {
                    $('#icon_' + tipo).addClass('icon-plus');
                    $('#icon_' + tipo).removeClass('icon-minus');
                } else {
                    $('#icon_' + tipo).addClass('icon-minus');
                    $('#icon_' + tipo).removeClass('icon-plus');
                }
            };
        }

        vm.ventanaSamples = function (ev, srvc) {
            $mdDialog.show({
                controller: SamplesCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/listaSamples.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function SamplesCtrl($scope, $mdDialog, $mdSidenav, servicio) {
            $scope.service = angular.copy(servicio);
            $scope.listaIdiomas = vm.listaIdiomas;

            CargarArchivos();
            function CargarArchivos() {
                quantionApi.getGenericFiles('FileServices/' + servicio.acl).then(function (dataResponse) {
                    $scope.listaArchivos = dataResponse.data.files;
                });
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson({samples: $scope.service.samples}, 0);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            $scope.updateList = function () {
                var obj = {
                    name: [],
                    description: [],
                    url: [],
                    thumbnail: $scope.sample.thumbnail,
                    mime: $scope.sample.mime
                };

                $.each($scope.sample.name, function (key, value) {
                    obj.name.push({'language': key, 'value': value});
                });
                $.each($scope.sample.description, function (key, value) {
                    obj.description.push({'language': key, 'value': value});
                });
                $.each($scope.sample.url, function (key, value) {
                    obj.url.push({'language': key, 'value': value});
                });

                if ($scope.smplIndex !== null) {
                    $scope.service.samples.splice($scope.smplIndex, 1, obj);
                } else {
                    $scope.service.samples.push(obj);
                }
                $mdSidenav('right').close();
            };

            $scope.close = function () {
                $mdSidenav('right').close();
            };

            $scope.add = function () {
                $scope.sample = {
                    name: {},
                    description: {},
                    url: {},
                    thumbnail: '',
                    mime: ''
                };

                $scope.smplIndex = null;
                $scope.selectedMime = undefined;
                $scope.customMime = undefined;
                $mdSidenav('right').open();
            };

            $scope.editar = function (index, elem) {
                $scope.sample = {
                    name: {},
                    description: {},
                    url: {},
                    thumbnail: elem.thumbnail,
                    mime: elem.mime
                };
                $.each(elem.name, function (index, value) {
                    $scope.sample.name[value.language] = value.value;
                });
                $.each(elem.description, function (index, value) {
                    $scope.sample.description[value.language] = value.value;
                });
                $.each(elem.url, function (index, value) {
                    $scope.sample.url[value.language] = value.value;
                });

                $scope.smplIndex = index;
                $scope.selectedMime = ['video', 'imagen', 'audio', 'doc'].includes(elem.mime) ? elem.mime : '_';
                $scope.customMime = ['video', 'imagen', 'audio', 'doc'].includes(elem.mime) ? undefined : elem.mime;
                $mdSidenav('right').open();
            };

            $scope.eliminar = function (index) {
                $scope.service.samples.splice(index, 1);
            };

            function cargarArchivo(evt) {
                var files = evt.target.files;
                var file = files[0];
                if (!file)
                    return;

                var formData = new FormData();
                formData.append('file', file);

                $scope.dataLoading = true;
                quantionApi.uploadGenericFile(formData, file.name, 'FileServices/' + servicio.acl).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTSUBIDA')).position('top right').hideDelay(3000));
                    $scope.dataLoading = false;
                    CargarArchivos();
                });
            }

            var a = false;
            $scope.upload = function () {
                if (!a)
                    document.getElementById('uploadFile').addEventListener('change', cargarArchivo, false);
                $('#uploadFile').click();
            };

            $scope.replicar = function (el) {
                $.each($scope.listaIdiomas, function (index, value) {
                    $scope.sample.url[value.idioma] = el;
                });
            };

            $scope.mimeChanged = function (newMime) {
                $scope.sample.mime = newMime;
            };
        }

        //**************************** CALENDARIO ******************************
        vm.calendar = function (ev, srvc) {
            $mdDialog.show({
                controller: CalendarCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/calendario.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function CalendarCtrl($scope, $mdDialog, $mdToast, servicio) {
            $scope.service = angular.copy(servicio);
            console.log($scope.service);
            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var jsonObj = angular.toJson({dates: $scope.service.dates}, 0);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            $scope.updateList = function () {
                var obj = {
                    title: [],
                    description: [],
                    image: $scope.sample.image,
                    category: $scope.sample.category,
                    startTime: $filter('date')($scope.sample.startTime, 'HH:mm:ss') /*$scope.sample.startTime.getHours() + ':' + $scope.sample.startTime.getMinutes() + ':' + $scope.sample.startTime.getSeconds()*/,
                    duration: $scope.sample.duration
                };

                $.each($scope.sample.title, function (key, value) {
                    obj.title.push({'language': key, 'value': value});
                });
                $.each($scope.sample.description, function (key, value) {
                    obj.description.push({'language': key, 'value': value});
                });

                var dateToKey = $filter('date')($scope.sample.date, 'yyyy-MM-dd');

                if ($scope.smplIndex !== null) {
                    if ($scope.service.dates[dateToKey])
                        $scope.service.dates[dateToKey].splice($scope.smplIndex, 1);

                    if (!$scope.service.dates[dateToKey])
                        $scope.service.dates[dateToKey] = [];
                    $scope.service.dates[dateToKey].push(obj);
                } else {
                    if (!$scope.service.dates[dateToKey])
                        $scope.service.dates[dateToKey] = [];
                    $scope.service.dates[dateToKey].push(obj);
                }

                $.each($scope.service.dates, function (key, value) {
                    if (value.length < 1)
                        delete $scope.service.dates[key];
                });

                $scope.close();
            };

            $scope.add = function () {
                $scope.sample = {
                    title: {},
                    description: {},
                    image: "",
                    category: '',
                    startTime: null,
                    duration: null
                };

                $scope.smplIndex = null;
                $scope.key = null;

                $mdSidenav('right').open();
            };

            $scope.editar = function (key, index, elem) {
                $scope.sample = {
                    title: {},
                    description: {},
                    image: elem.image,
                    category: elem.category,
                    duration: elem.duration,
                    date: new Date(key)
                };
                $.each(elem.title, function (index, value) {
                    $scope.sample.title[value.language] = value.value;
                });
                $.each(elem.description, function (index, value) {
                    $scope.sample.description[value.language] = value.value;
                });

                var time = elem.startTime.split(':');

                var d = new Date(0);

                d.setHours(+time[0]);
                d.setMinutes(time[1]);
                d.setSeconds(time[2]);

                $scope.sample.startTime = d;

                $scope.smplIndex = index;
                $scope.key = key;

                $mdSidenav('right').open();
            };

            $scope.eliminar = function (key, index) {
                $scope.service.dates[key].splice(index, 1);

                $.each($scope.service.dates, function (key, value) {
                    if (value.length < 1)
                        delete $scope.service.dates[key];
                });
            };

            $scope.close = function () {
                $mdSidenav('right').close();
            };
        }

        //*************** PAISES RADIO ONLINE ******************

        vm.radioCountries = function () {
            $mdDialog.show({
                controller: RadioCountriesCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/radioCountries.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function RadioCountriesCtrl($scope, $mdDialog) {
            quantionApi.getRadioCountries().then(function (dataResponse) {
                $scope.countryList = dataResponse.data;
            });

            $scope.updateActive = function (country) {
                $scope.dataLoading = true;
                country.active = !country.active;
                var json = angular.toJson(country);

                quantionApi.updateRadioCountry(json).then(function (dataResponse) {
                    $scope.dataLoading = false;
                }, function () {
                    country.active = !country.active;
                    $scope.dataLoading = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        vm.modalService = function (ev, srvc) {
            $mdDialog.show({
                controller: ModalCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/modalService.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function ModalCtrl($scope, $mdDialog, $mdSidenav, servicio, $timeout) {
            console.log(servicio)

            $scope.service = angular.copy(servicio);
            delete $scope.service.body;
            delete $scope.service.header;
            delete $scope.service.subheader;

            $.each($scope.service.actions, function (index, value) {
                delete value.title;
                delete value.description;
            });

            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson($scope.service);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            $scope.updateList = function () {
                if ($scope.smplIndex !== null) {
                    $scope.service.actions.splice($scope.smplIndex, 1, $scope.action);
                } else {
                    $scope.service.actions.push($scope.action);
                }
                $mdSidenav('right').close();
            };

            $scope.close = function () {
                $mdSidenav('right').close();
            };

            $scope.add = function () {
                $scope.action = {
                    name: "",
                    titleInt: {},
                    descriptionInt: {},
                    url: "",
                    method: '',
                    data: ''
                };

                $scope.smplIndex = null;
                $mdSidenav('right').open();
            };

            $scope.editar = function (index, elem) {
                $scope.action = angular.copy(elem);

                $scope.smplIndex = index;
                $mdSidenav('right').open();
            };

            $scope.eliminar = function (index) {
                $scope.service.actions.splice(index, 1);
            };
        }

        vm.widgetService = function (ev, srvc) {
            $mdDialog.show({
                controller: WidgetCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/widgetService.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function WidgetCtrl($scope, $mdDialog, $mdSidenav, servicio, $timeout) {
            $scope.service = angular.copy(servicio);

            $.each($scope.service.actions, function (index, value) {
                delete value.title;
                delete value.description;
            });

            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson({actions: $scope.service.actions});
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            $scope.updateList = function () {
                if ($scope.smplIndex !== null) {
                    $scope.service.actions.splice($scope.smplIndex, 1, $scope.action);
                } else {
                    $scope.service.actions.push($scope.action);
                }
                $mdSidenav('right').close();
            };

            $scope.close = function () {
                $mdSidenav('right').close();
            };

            $scope.add = function () {
                $scope.action = {
                    name: "",
                    titleInt: {},
                    descriptionInt: {},
                    url: "",
                    method: '',
                    data: ''
                };

                $scope.smplIndex = null;
                $mdSidenav('right').open();
            };

            $scope.editar = function (index, elem) {
                $scope.action = angular.copy(elem);

                $scope.smplIndex = index;
                $mdSidenav('right').open();
            };

            $scope.eliminar = function (index) {
                $scope.service.actions.splice(index, 1);
            };
        }

        vm.dependenciasWidget = function (ev, widget) {
            if (vm.serviceMap[widget].type === 'widget')
                $mdDialog.show({
                    controller: dependenciasWidgetCtrl,
                    templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/dependenciasWidget.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {widget: vm.serviceMap[widget]}
                });
        };

        function dependenciasWidgetCtrl($scope, $mdDialog, $mdToast, widget) {
            $scope.listaServicios = {};
            $scope.widget = angular.copy(widget);

            $scope.selected = widget.dependencies.map(function (elm) {
                return elm.idService;
            });

            $.each(angular.copy(vm.listaServicios), function (key, value) {
                $scope.listaServicios[key] = value.map(function (elm) {
                    return elm;
                });
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var obj = {dependencies: $scope.selected};
                var jsonObj = angular.toJson(obj, 0);

                quantionApi.updateServicio(widget.idService, jsonObj).then(function (dataResponse) {
                    CargarServicios(widget.type);
                    $mdDialog.hide();
                });
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.fold = function (tipo) {
                $('#grupo_' + tipo).toggleClass('hide');

                if ($('#grupo_' + tipo).hasClass('hide')) {
                    $('#icon_' + tipo).addClass('icon-plus');
                    $('#icon_' + tipo).removeClass('icon-minus');
                } else {
                    $('#icon_' + tipo).addClass('icon-minus');
                    $('#icon_' + tipo).removeClass('icon-plus');
                }
            };
        }

        //Cambiar imagenes del servicio
        vm.imagenesServicio = function (ev, srvc) {
            $mdDialog.show({
                controller: ImgCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/imagenesServicio.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]},
                onComplete: function (scope, element) {
                    scope.initInput();
                },
                skipHide: true
            });
        };

        function ImgCtrl($scope, $mdDialog, $mdToast, servicio) {
            $scope.listaTemas = vm.listaTemas;

            $scope.imageNames = ['icon', 'icon-horizontal', 'icon-vertical', 'icon-dashboard', 'icon-dashboard-focus'];

            $scope.selectedThemes = [];

            $scope.service = angular.copy(servicio);//Clonar objeto servicio

            organizeImages();
            function organizeImages() {
                $scope.imageObj = {admin: servicio.logo + "?" + (+new Date())};

                $.each($scope.listaTemas, function (index, value) {
                    $.each($scope.imageNames, function (index2, value2) {
                        $scope.imageObj[value + '#' + value2] = getImageUrl(value, value2);
                    });
                });
            }

            function getImageUrl(theme, name) {
                return JSONconfig.logosPath.from + '/' + FilePaths.temas + '/' + theme + '/services/' + servicio.acl + '/' + name + '.png?' + (+new Date());
            }

            $scope.uploadAdminLogo = function () {
                var files = document.getElementById('logoInput').files;
                var file = files[0];

                if (file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    $scope.uploadingAdminLogo = true;

                    quantionApi.uploadGenericFile(formData, servicio.acl + '.png', FilePaths.servicios_paquetes).then(function (dataResponse) {
                        $scope.uploadingAdminLogo = false;
                        $('#logoInput').val('');
                        $('#previewAdmin').attr('src', "");
                        organizeImages();
                        $scope.recargarServicios = true;
                    }, function () {
                        $scope.uploadingAdminLogo = false;
                    });
                }
            };

            $scope.uploadThemesLogo = function () {
                var files = document.getElementById('logoInput2').files;
                var file = files[0];

                if (file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    $scope.uploadingThemeLogo = true;

                    quantionApi.uploadServiceLogo(formData, servicio.acl, $scope.selectedThemes, $scope.themeFileName).then(function (dataResponse) {
                        $scope.uploadingThemeLogo = false;
                        $('#logoInput2').val('');
                        $('#previewTheme').attr('src', "");
                        $scope.selectedThemes = [];
                        $scope.fileName = "";
                        organizeImages();
                    }, function () {
                        $scope.uploadingThemeLogo = false;
                    });
                }
            };

            $scope.initInput = function () {
                document.getElementById('logoInput').addEventListener('change', cargarArchivo, false);
                document.getElementById('logoInput2').addEventListener('change', cargarArchivo2, false);

                function cargarArchivo(evt) {
                    var files = evt.target.files;
                    var file = files[0];
                    $scope.adminImageFile = file;

                    if (file) {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            $('#previewAdmin').attr('src', reader.result);
                        };
                        reader.readAsDataURL(file);
                    } else {
                        $('#previewAdmin').attr('src', "");
                    }
                }

                function cargarArchivo2(evt) {
                    var files = evt.target.files;
                    var file = files[0];
                    $scope.themeImageFile = file;

                    if (file) {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            $('#previewTheme').attr('src', reader.result);
                        };
                        reader.readAsDataURL(file);
                    } else {
                        $('#previewTheme').attr('src', "");
                    }
                }
            };

            $scope.deleteImage = function (themeName, imageName) {
                console.log($scope.imageObj[themeName + '#' + imageName])

//                var confirm = $mdDialog.confirm()
//                        .title($filter('translate')('SERVICIOS.CONFIRMELIMINAR.TITLE'))
//                        .textContent($filter('translate')('SERVICIOS.CONFIRMELIMINAR.CONTENT'))
//                        .ok($filter('translate')('SERVICIOS.CONFIRMELIMINAR.OK'))
//                        .cancel($filter('translate')('SERVICIOS.CONFIRMELIMINAR.CANCEL'));
//
//                $mdDialog.show(confirm).then(function () {
//                    quantionApi.deleteGenericFile(imageName + 'png', FilePaths.temas + '/' + themeName + '/services/' + servicio.acl).then(function (dataResponse) {
//                        organizeImages();
//                    });
//                }, function (dataResponse) {
//                    console.log(dataResponse);
//                });

                $mdDialog.show({
                    skipHide: true,
                    controllerAs: 'dialogCtrl',
                    controller: function ($mdDialog, $scope) {
                        $scope.confirm = function () {
                            quantionApi.deleteGenericFile(imageName + '.png', FilePaths.temas + '/' + themeName + '/services/' + servicio.acl).then(function (dataResponse) {
                                organizeImages();
                            });
                            $mdDialog.hide();
                        };

                        $scope.hide = function () {
                            $mdDialog.hide();
                        };
                    },
                    template: '<md-dialog class="confirm"><md-dialog-content><h2 class="text-center">¿Eliminar imagen?</h2></md-dialog-content><md-dialog-actions class="padding-8" layout="row" layout-align="space-between center"><md-button class="md-raised" ng-click="confirm()">Eliminar</md-button><md-button class="md-raised" ng-click="hide()">Volver</md-button></md-dialog-actions></md-dialog>'
                });
            };

            $scope.hide = function () {
                if ($scope.recargarServicios)
                    location.reload(true);
                else
                    $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };
        }

        //******************** IMPORTACIÓN *********************

        vm.importFile = function () {
            $('#files').click();
        };

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var contenidoArchivo = e.target.result;

                if (isJSON(contenidoArchivo)) {
                    var listaServicios = JSON.parse(contenidoArchivo);

                    $mdDialog.show({
                        controller: SelectServicesToImport,
                        templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/importServices.tmpl.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        locals: {listaServicios: listaServicios},
                        onRemoving: function () {
                            document.getElementById('files').value = null;
                        }
                    });
                }
                $scope.isLoading = false;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
            return text ? true : false;
        }

        function SelectServicesToImport($scope, $mdDialog, $mdToast, $filter, listaServicios) {
            $scope.listaServicios = listaServicios;

            $scope.selected = [];
            $scope.selectedThemes = [];

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.selectAll = function (type) {
                $.each($scope.listaServicios[type], function (index, value) {
                    if ($scope.selected.indexOf(value.idService) === -1) {
                        $scope.selected.push(value.idService);
                    }
                });
            };

            $scope.unselectAll = function (type) {
                $.each($scope.listaServicios[type], function (index, value) {
                    var idx = $scope.selected.indexOf(value.idService);
                    if (idx > -1)
                        $scope.selected.splice(idx, 1);
                });
            };

            var idMap = {};//key: antiguo id, value: nuevo id
            var groupElementsMap = {};//key: id grupo, value: elements

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var arr = [];

                $.each($scope.listaServicios, function (key, value) {
                    $.each(value, function (index, value2) {
                        if ($scope.exists(value2.idService, $scope.selected)) {
                            var o = angular.copy(value2);

                            if (o.type === 'group') {
                                groupElementsMap[o.idService] = o.elements.map(function (e) {
                                    return e.acl;
                                });
                                delete o.elements;
                            }

                            arr.push(o);
                        }
                    });
                });

                PostService(arr);
            };

            function PostService(array) {
                if (array[0]) {
                    var aux = array[0].idService;
                    idMap[aux] = -1;
                    delete array[0].idService;

                    if (array[0].type === 'files') {
                        $.each(array[0].samples, function (index, value) {
                            delete value.idSample;
                        });
                    }

                    quantionApi.addServicio(angular.toJson(array[0])).then(function (dataResponse) {//Se intenta crear el servicio
                        idMap[aux] = dataResponse.data.idService;
                        array.shift();
                        PostService(array);
                    }, function () {//Si da error, es posible que sea porque hay otro servicio con el mismo ACL. Se intenta actualizar dicho servicio.
                        quantionApi.updateServicio(aux, angular.toJson(array[0])).then(function (dataResponse) {
                            idMap[aux] = dataResponse.data.idService;
                            array.shift();
                            PostService(array);
                        }, function () {
                            $mdToast.show($mdToast.simple()
                                    .textContent($filter('translate')('SERVICIOS.ERRORPOSTTOAST', {serviceName: $filter('formatNameDesc')(array[0].name)}))
                                    .position('top right').hideDelay(3000));
                            array.shift();
                            PostService(array);
                        });
                    });
                } else {
                    $mdDialog.hide();

                    var allServices = [];
                    $.each($scope.listaServicios, function (key, value) {
                        allServices = allServices.concat(value);
                    });

                    var cont = Object.keys(groupElementsMap).length;
                    if (cont > 0) {
                        $.each(groupElementsMap, function (key, value) {
                            quantionApi.updateServicio(idMap[key], angular.toJson({
                                elements: getServicesByAcl(allServices, value, true)
                            })).finally(function () {
                                if (--cont === 0)
                                    CargarServicios();
                            });
                        });
                    } else {
                        CargarServicios();
                    }
                }
            }

            function getServicesByAcl(lista, acls, onlyIds) {
                var arr = lista.filter(function (e) {
                    return acls.indexOf(e.acl) !== -1;
                });

                return onlyIds ? arr.map(function (e) {
                    return e.idService;
                }) : arr;
            }
        }

        vm.importRecursos = function () {
            $('#files_rsc').click();
        };

        document.getElementById('files_rsc').addEventListener('change', LeerArchivoRsc, false);

        function LeerArchivoRsc(evt) {
            var files = evt.target.files;
            var file = files[0];
            if (!file)
                return;

            var formData = new FormData();
            formData.append('file', file);

            pantallaCarga.lsEnable('');
            quantionApi.importServices(formData).then(function (dataResponse) {
                pantallaCarga.lsDisable();
                $mdToast.show($mdToast.simple()
                        .textContent($filter('translate')('SERVICIOS.UPLOAD_ZIP_OK_TOAST'))
                        .position('top right').hideDelay(3000));
            }, function () {
                pantallaCarga.lsDisable();
                $mdToast.show($mdToast.simple()
                        .textContent($filter('translate')('SERVICIOS.UPLOAD_ZIP_ERROR_TOAST'))
                        .position('top right').hideDelay(3000));
            });
        }

        vm.exportServices = function () {
            $mdDialog.show({
                controller: SelectServicesToExport,
                templateUrl: 'app/main/Quantion/root/gservicios/servicios/templates/exportServices.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {listaServicios: vm.listaServicios, listaTemas: vm.listaTemas}
            });
        };

        function SelectServicesToExport($scope, $mdDialog, $mdToast, $filter, listaServicios, listaTemas) {
            $scope.listaServicios = listaServicios;
            $scope.listaTemas = listaTemas;

            $scope.selected = [];
            $scope.selectedThemes = [];

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.selectAll = function (type) {
                $.each($scope.listaServicios[type], function (index, value) {
                    if ($scope.selected.indexOf(value.idService) === -1) {
                        $scope.selected.push(value.idService);
                    }
                });
            };

            $scope.unselectAll = function (type) {
                $.each($scope.listaServicios[type], function (index, value) {
                    var idx = $scope.selected.indexOf(value.idService);
                    if (idx > -1)
                        $scope.selected.splice(idx, 1);
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.exportJson = function () {
                var ob = {};

                $.each($scope.listaServicios, function (key, value) {
                    $.each(value, function (index, value2) {
                        if ($scope.exists(value2.idService, $scope.selected)) {
                            if (!ob[value2.type])
                                ob[value2.type] = [];
                            ob[value2.type].push(value2);
                        }
                    });
                });

                var a = $('#json-download-link');

                var file;
                var properties = {type: 'text/plain'};
                file = new Blob([angular.toJson(ob, true)], properties);
                var url = URL.createObjectURL(file);
                a[0].download = 'Backup-Servicios (' + (new Date()).toLocaleDateString('es-ES') + ').json';
                a[0].href = url;
                a[0].click();
            };

            $scope.exportRecursos = function () {
                var ob = [];

                $.each($scope.listaServicios, function (key, value) {
                    $.each(value, function (index, value2) {
                        if ($scope.exists(value2.idService, $scope.selected)) {
                            ob.push(value2.acl);
                        }
                    });
                });

                var a = $('#resources-download-link');
                a[0].href = quantionApi.exportServices(ob.join(','), $scope.selectedThemes.join(','));
                a[0].click();
            };
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gservicios.paquetes', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_paquetes', {
            url: '/root/paquetes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/gservicios/paquetes/paquetes.html',
                    controller: 'paquetesController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/gservicios/paquetes');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gservicios.paquetes')
            .controller('paquetesController', paquetesController);

    /** @ngInject */
    function paquetesController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_G_PAQUETES';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        CargarPaquetes();
        function CargarPaquetes() {
            pantallaCarga.lsEnable('LS.PAQUETES');

            quantionApi.getPaquetes().then(function (dataResponse) {
                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();

                vm.listaPaquetes = dataResponse.data;
                vm.groupPaquetes = $filter('groupBy')(dataResponse.data, 'historical');
            });
        }

        vm.listaServicios = {};

        quantionApi.getServicios(false).then(function (dataResponse) {
            $.each(dataResponse.data, function (index, value) {
                if (!vm.listaServicios[value.type])
                    vm.listaServicios[value.type] = [];
                vm.listaServicios[value.type].push(value);
            });
        });

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.idiomas = dataResponse.data;
        });

        CargarLogosPaquetes();
        function CargarLogosPaquetes() {
            quantionApi.getLogosPaquetesServicios().then(function (dataResponse) {
                vm.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');
            });
        }

        CargarVideosPaquetes();
        function CargarVideosPaquetes() {
            quantionApi.getGenericFiles(FilePaths.paquetes_video).then(function (dataResponse) {
                vm.listaVideos = dataResponse.data.files;
            });
        }

        CargarGateways();
        function CargarGateways() {
            quantionApi.getGateways().then(function (dataResponse) {
                vm.listaGateways = dataResponse.data;
            });
        }

        CargarLogosGateways();
        function CargarLogosGateways() {
            quantionApi.getGenericFiles(FilePaths.gateways).then(function (dataResponse) {
                vm.listaLogosGateways = $filter('orderBy')(dataResponse.data.files, 'name');
            });
        }

        //Creacion de paquetes
        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/creareditarpaquete.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.tituloVentana = "Crear paquete";
            $scope.idiomas = vm.idiomas;
            $scope.listaLogos = vm.listaLogos;
            $scope.listaVideos = vm.listaVideos;

            $scope.package = {
                nameInt: {},
                descriptionInt: {},
                videoInt: {},
                logo: '',
                logoFocus: '',
                active: false
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                $scope.package.historical = ($scope.package.historical || null);
                var jsonObj = angular.toJson($scope.package, 0);

                quantionApi.addPaquete(jsonObj).then(function (dataResponse) {
                    vm.showSimpleToast('Paquete creado correctamente');
                    CargarPaquetes();
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al crear el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });
            };

            $scope.elegirLogo = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        listaLogos: $scope.listaLogos,
                        paquete: $scope.package
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, listaLogos, paquete) {
                $scope.listaLogos = listaLogos;

                $scope.escogerImagen = function (img) {
                    paquete.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.uploadFile = function () {
                    var file = $('#packageLogo')[0].files[0];
                    if (!file)
                        return;

                    var formData = new FormData();
                    formData.append('file', file);

                    pantallaCarga.lsEnable('LS.UPLOADING');
                    quantionApi.uploadGenericFile(formData, file.name, FilePaths.servicios_paquetes).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarLogosPaquetes();

                        quantionApi.getLogosPaquetesServicios().then(function (dataResponse) {
                            $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                            var arr = $scope.listaLogos.filter(function (e) {
                                return e.name === file.name;
                            });

                            if (arr[0])
                                $scope.escogerImagen(arr[0]);
                        });

                        pantallaCarga.lsDisable();
                    }, function () {
                        pantallaCarga.lsDisable();
                    });
                };
            }

            $scope.uploadVideo = function () {
                var file = $('#videoStore')[0].files[0];
                if (!file)
                    return;

                var formData = new FormData();
                formData.append('file', file);

                $scope.uploading = true;
                quantionApi.uploadGenericFile(formData, file.name, FilePaths.paquetes_video).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                    CargarVideosPaquetes();

                    quantionApi.getGenericFiles(FilePaths.paquetes_video).then(function (dataResponse) {
                        $scope.listaVideos = dataResponse.data.files;
                    });

                    $scope.uploading = false;
                    $("#videoStore").val('');
                }, function () {
                    $scope.uploading = false;
                    $("#videoStore").val('');
                });
            };
        }

        //Modificacion de paquetes
        vm.ventanaEditar = function (ev, pckg) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/creareditarpaquete.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {paquete: pckg}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, paquete) {
            $scope.tituloVentana = "Modificar paquete";
            $scope.idiomas = vm.idiomas;
            $scope.listaLogos = vm.listaLogos;
            $scope.listaVideos = vm.listaVideos;

            $scope.package = angular.copy(paquete);//Clonar objeto paquete
            delete $scope.package.name;
            delete $scope.package.description;
            delete $scope.package.video;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    nameInt: $scope.package.nameInt,
                    descriptionInt: $scope.package.descriptionInt,
                    active: $scope.package.active,
                    logo: $scope.package.logo,
                    logoFocus: $scope.package.logoFocus,
                    videoInt: $scope.package.videoInt,
                    acl: $scope.package.acl,
                    historical: ($scope.package.historical || null)
                };

                var jsonObj = angular.toJson(obj, 0);

                quantionApi.updatePaquete(paquete.idPackage, jsonObj).then(function (dataResponse) {
                    vm.showSimpleToast('Paquete modificado correctamente');
                    CargarPaquetes();
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al editar el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });
            };

            $scope.elegirLogo = function (ev, tipo) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        listaLogos: $scope.listaLogos,
                        paquete: $scope.package,
                        tipo: tipo
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, listaLogos, paquete, tipo) {
                $scope.listaLogos = listaLogos;

                $scope.escogerImagen = function (img) {
                    if (tipo === 'normal')
                        paquete.logo = img.path;
                    else if (tipo === 'focus')
                        paquete.logoFocus = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.uploadFile = function () {
                    var file = $('#packageLogo')[0].files[0];
                    if (!file)
                        return;

                    var formData = new FormData();
                    formData.append('file', file);

                    pantallaCarga.lsEnable('LS.UPLOADING');
                    quantionApi.uploadGenericFile(formData, file.name, FilePaths.servicios_paquetes).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarLogosPaquetes();

                        quantionApi.getLogosPaquetesServicios().then(function (dataResponse) {
                            $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                            var arr = $scope.listaLogos.filter(function (e) {
                                return e.name === file.name;
                            });

                            if (arr[0])
                                $scope.escogerImagen(arr[0]);
                        });

                        pantallaCarga.lsDisable();
                    }, function () {
                        pantallaCarga.lsDisable();
                    });
                };
            }

            $scope.uploadVideo = function () {
                var file = $('#videoStore')[0].files[0];
                if (!file)
                    return;

                var formData = new FormData();
                formData.append('file', file);

                $scope.uploading = true;
                quantionApi.uploadGenericFile(formData, file.name, FilePaths.paquetes_video).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                    CargarVideosPaquetes();

                    quantionApi.getGenericFiles(FilePaths.paquetes_video).then(function (dataResponse) {
                        $scope.listaVideos = dataResponse.data.files;
                    });

                    $scope.uploading = false;
                    $("#videoStore").val('');
                }, function () {
                    $scope.uploading = false;
                    $("#videoStore").val('');
                });
            };
        }

        //Borrado de paquetes
        vm.eliminarPaquete = function (ev, pckg) {
            var confirm = $mdDialog.confirm()
                    .title('¿Deseas eliminar este paquete?')
                    .textContent('No podrás deshacer esta acción')
                    .targetEvent(ev)
                    .ok('Eliminar')
                    .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                quantionApi.deletePaquete(pckg.idPackage).then(function (dataResponse) {
                    vm.showSimpleToast('Paquete eliminado correctamente');
                    CargarPaquetes();
                }, function (dataResponse) {
                    console.log(dataResponse.data);
                });
            });
        };

        //Asignacion de servicios a paquete
        vm.ventanaAsignarServicioOrdinario = function (ev, pkg) {
            $mdDialog.show({
                controller: AsignarServicioOrdinarioCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/asignarservicio.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {paquete: pkg},
                onComplete: function (scope) {
                    scope.aaa();
                }
            });
        };

        function AsignarServicioOrdinarioCtrl($scope, $mdDialog, $timeout, paquete) {
            $scope.pkg = angular.copy(paquete);
            $scope.listaServicios = vm.listaServicios;

            var serviciosSeleccionados = paquete.ordinaryServices.map(function (item, index) {
                return item.idService;
            });//[0,1,3]

            $scope.aaa = function () {
                $.each($scope.listaServicios, function (key, value) {
                    $.each(value, function (index, value2) {
                        if (serviciosSeleccionados.includes(value2.idService)) {
                            $('#grupo_' + value2.type).removeClass('hide');
                        }
                    });
                });
            };

            $scope.toggle = function (item) {
                var idx = serviciosSeleccionados.indexOf(item);
                if (idx > -1)
                    serviciosSeleccionados.splice(idx, 1);
                else
                    serviciosSeleccionados.push(item);
            };

            $scope.exists = function (item) {
                return serviciosSeleccionados.indexOf(item) > -1;
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson({
                    ordinaryServices: serviciosSeleccionados
                });

                quantionApi.updatePaquete(paquete.idPackage, jsonObj).then(function (dataResponse) {
                    vm.showSimpleToast('Servicios actualizados');
                    CargarPaquetes();
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al editar el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.fold = function (tipo) {
                $('#grupo_' + tipo).toggleClass('hide');

                if ($('#grupo_' + tipo).hasClass('hide')) {
                    $('#icon_' + tipo).addClass('icon-plus');
                    $('#icon_' + tipo).removeClass('icon-minus');
                } else {
                    $('#icon_' + tipo).addClass('icon-minus');
                    $('#icon_' + tipo).removeClass('icon-plus');
                }
            };
        }

        //Asignacion de servicios PROMOCIONALES a paquete
        vm.ventanaAsignarServicioPromo = function (ev, pkg) {
            $mdDialog.show({
                controller: AsignarServicioPromoCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/asignarserviciopromo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {paquete: pkg}
            });
        };

        function AsignarServicioPromoCtrl($scope, $mdDialog, $mdToast, paquete) {

            $scope.pkg = angular.copy(paquete);
            var ids = $scope.pkg.promotionalServices.map(function (e) {
                return e.service.idService;
            });

            $scope.listaServicios = angular.copy(vm.listaServicios);

            $scope.addService = function (servicio) {
                if (ids.indexOf(servicio.idService) === -1) {
                    $scope.pkg.promotionalServices.push({
                        service: servicio,
                        conditionalDuration: {}
                    });
                    ids.push(servicio.idService);
                }
            };

            $scope.removeService = function (idService) {
                for (var i = 0; i < $scope.pkg.promotionalServices.length; i++) {
                    if ($scope.pkg.promotionalServices[i].service.idService === idService) {
                        $scope.pkg.promotionalServices.splice(i, 1);
                        ids.splice(ids.indexOf(idService), 1);
                        break;
                    }
                }
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                console.log($scope.pkg.promotionalServices);

                var jsonObj = angular.toJson({
                    promotionalServices: $scope.pkg.promotionalServices.map(function (e) {
                        return {
                            service: e.service.idService,
                            conditionalDuration: clearNullKeys(e.conditionalDuration)
                        };
                    })
                });

                quantionApi.updatePaquete(paquete.idPackage, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    vm.showSimpleToast('Servicios actualizados');
                    CargarPaquetes();
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al editar el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });

                function clearNullKeys(obj) {
                    var o = angular.copy(obj);

                    $.each(obj, function (key, value) {
                        if (!value) {
                            delete o[key];
                        }
                    });

                    return o;
                }
            };

            function diff(a, b) {//Elementos de 'a' que no están en 'b'
                return a.filter(function (i) {
                    return b.indexOf(i) < 0;
                });
            }
        }

        //Precios de paquete
        vm.ventanaPrecios = function (ev, pkg) {
            $mdDialog.show({
                controller: PreciosCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/precios.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {paquete: pkg},
                onRemoving: function () {
                    CargarPaquetes();
                }
            });
        };

        function PreciosCtrl($scope, $mdDialog, $mdToast, paquete, $mdSidenav) {

            $scope.pkg = paquete;
            $scope.listaGateways = vm.listaGateways;
            $scope.selectedGateways = $scope.pkg.gateways.map(function (e) {
                return e.idGateway;
            });

            function cargarPrecios(objetoDurationPrice) {
                $scope.precios = [];

                $.each(objetoDurationPrice, function (i, el) {
                    $scope.precios.push({
                        "indice": i,
                        "duracion": el.duration,
                        "precio": el.price
                    });
                });
            }
            cargarPrecios(paquete.durationPrice);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardarNuevoPrecio = function (paquete, duracion, precio) {
                quantionApi.addPrecioDuracionDePaquete(paquete, duracion, precio).then(function (dataResponse) {
                    vm.showSimpleToast("Precio añadido");
                    cargarPrecios(dataResponse.data.durationPrice);
                    $mdSidenav('right').close();
                });
            };

            $scope.eliminarPrecio = function (paquete, duracion) {
                quantionApi.deleteDuracionDePaquete(paquete, duracion).then(function (dataResponse) {
                    vm.showSimpleToast("Precio eliminado");
                    cargarPrecios(dataResponse.data.durationPrice);
                }, function (dataResponse) {
                    vm.showSimpleToast("Precio eliminado");
                    cargarPrecios(dataResponse.data.durationPrice);
                });
            };

            $scope.openSidenav = function () {
                $scope.duracion = undefined;
                $scope.precio = undefined;
                $mdSidenav('right').open();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);

                var jsonObj = angular.toJson({gateways: $scope.selectedGateways}, 0);

                quantionApi.updatePaquete(paquete.idPackage, jsonObj).then(function (dataResponse) {
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al editar el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };
        }
        //////////
        vm.showSimpleToast = function (msg) {
            $mdToast.show(
                    $mdToast.simple()
                    .textContent(msg)
                    .position('top right')
                    .hideDelay(3000)
                    );
        };

        //*************** IMPORTACIÓN **************************

        vm.importFile = function () {
            $('#files').click();
        };

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var contenidoArchivo = e.target.result;

                if (isJSON(contenidoArchivo)) {
                    var listaPaquetes = JSON.parse(contenidoArchivo);

                    $mdDialog.show({
                        controller: SelectPackagesToImport,
                        templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/importPaquetes.tmpl.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        locals: {listaPaquetes: listaPaquetes},
                        onRemoving: function () {
                            document.getElementById('files').value = null;
                        }
                    });
                }
                $scope.isLoading = false;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
            return true;
        }

        function SelectPackagesToImport($scope, $mdDialog, $mdToast, $filter, listaPaquetes) {
            $scope.listaPaquetes = listaPaquetes;

            var allServices = [];
            $.each(vm.listaServicios, function (key, value) {
                allServices = allServices.concat(value);
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var arr = [];

                $.each($scope.listaPaquetes, function (index, value) {
                    if (value.seleccionado) {
                        var o = angular.copy(value);
                        delete o.idPackage;
                        delete o.seleccionado;

                        o.ordinaryServices = getServicesByAcl(allServices, value.ordinaryServices.map(function (e) {
                            return e.acl;
                        }), true);

                        o.promotionalServices = value.promotionalServices.map(function (e) {
                            e.service = getServicesByAcl(allServices, [e.service.acl], true)[0];
                            return e;
                        });
                        arr.push(o);
                    }
                });

                console.log(arr);

                PostService(arr);
            };

            function PostService(array) {
                if (array[0]) {
                    quantionApi.addPaquete(angular.toJson(array[0])).then(function (dataResponse) {
                        array.shift();
                        PostService(array);
                    }, function () {
                        $mdToast.show($mdToast.simple()
                                .textContent('Error al guardar el paquete "' + $filter('formatNameDesc')(array[0].name) + '"')
                                .position('top right').hideDelay(3000));
                        array.shift();
                        PostService(array);
                    });
                } else {
                    $mdDialog.hide();
                    CargarPaquetes();
                }
            }

            function getServicesByAcl(lista, acls, onlyIds) {
                var arr = lista.filter(function (e) {
                    return acls.indexOf(e.acl) !== -1;
                });

                return onlyIds ? arr.map(function (e) {
                    return e.idService;
                }) : arr;
            }
        }

        //Creacion de gateways
        vm.crearGateway = function (ev) {
            $mdDialog.show({
                controller: NuevoGatewayCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/creareditargateway.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoGatewayCtrl($scope, $mdDialog, $mdToast) {
            $scope.tituloVentana = "Crear pasarela de pago";
            $scope.idiomas = vm.idiomas;
            $scope.listaLogos = vm.listaLogosGateways;

            $scope.gateway = {
                nameInt: {},
                descriptionInt: {},
                logo: '',
                active: false,
                price: 0,
                toAction: {}
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson($scope.gateway, 0);

                quantionApi.addGateway(jsonObj).then(function (dataResponse) {
                    vm.showSimpleToast('Paquete creado correctamente');
                    CargarGateways();
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al crear el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });
            };

            $scope.elegirLogo = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        listaLogos: $scope.listaLogos,
                        gateway: $scope.gateway
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, listaLogos, gateway) {
                $scope.listaLogos = listaLogos;

                $scope.escogerImagen = function (img) {
                    gateway.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.uploadFile = function () {
                    var file = $('#packageLogo')[0].files[0];
                    if (!file)
                        return;

                    var formData = new FormData();
                    formData.append('file', file);

                    pantallaCarga.lsEnable('LS.UPLOADING');
                    quantionApi.uploadGenericFile(formData, file.name, FilePaths.gateways).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarLogosGateways();

                        quantionApi.getGenericFiles(FilePaths.gateways).then(function (dataResponse) {
                            $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                            var arr = $scope.listaLogos.filter(function (e) {
                                return e.name === file.name;
                            });

                            if (arr[0])
                                $scope.escogerImagen(arr[0]);
                        });

                        pantallaCarga.lsDisable();
                    }, function () {
                        pantallaCarga.lsDisable();
                    });
                };
            }
        }

        //Modificacion de gateway
        vm.editarGateway = function (ev, gat) {
            $mdDialog.show({
                controller: EditarGatewayCtrl,
                templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/creareditargateway.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {gateway: gat}
            });
        };

        function EditarGatewayCtrl($scope, $mdDialog, $mdToast, gateway) {
            $scope.tituloVentana = "Modificar pasarela de pago";
            $scope.idiomas = vm.idiomas;
            $scope.listaLogos = vm.listaLogosGateways;

            $scope.gateway = angular.copy(gateway);//Clonar objeto paquete
            delete $scope.gateway.name;
            delete $scope.gateway.description;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.gateway, 0);

                quantionApi.updateGateway(jsonObj).then(function (dataResponse) {
                    vm.showSimpleToast('Pasarela modificada correctamente');
                    CargarGateways();
                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = "Ha ocurrido un error al editar el paquete. Compruebe los datos.";
                    $scope.dataLoading = false;
                });
            };

            $scope.elegirLogo = function (ev, tipo) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/root/gservicios/paquetes/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        listaLogos: $scope.listaLogos,
                        gateway: $scope.gateway
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, listaLogos, gateway) {
                $scope.listaLogos = listaLogos;

                $scope.escogerImagen = function (img) {
                    gateway.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.uploadFile = function () {
                    var file = $('#packageLogo')[0].files[0];
                    if (!file)
                        return;

                    var formData = new FormData();
                    formData.append('file', file);

                    pantallaCarga.lsEnable('LS.UPLOADING');
                    quantionApi.uploadGenericFile(formData, file.name, FilePaths.gateways).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarLogosPaquetes();

                        quantionApi.getGenericFiles(FilePaths.gateways).then(function (dataResponse) {
                            $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                            var arr = $scope.listaLogos.filter(function (e) {
                                return e.name === file.name;
                            });

                            if (arr[0])
                                $scope.escogerImagen(arr[0]);
                        });

                        pantallaCarga.lsDisable();
                    }, function () {
                        pantallaCarga.lsDisable();
                    });
                };
            }
        }

        //Borrado de gateway
        vm.eliminarGateway = function (ev, gat) {
            var confirm = $mdDialog.confirm()
                    .title('¿Deseas eliminar esta pasarela?')
                    .textContent('No podrás deshacer esta acción')
                    .targetEvent(ev)
                    .ok('Eliminar')
                    .cancel('Cancelar');
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteGateway(gat.idGateway).then(function (dataResponse) {
                    vm.showSimpleToast('Pasarela eliminada correctamente');
                    CargarGateways();
                }, function (dataResponse) {
                    console.log(dataResponse.data);
                });
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.error-500', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.Quantion_error-500', {
            url: '/error500',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Quantion_error-500': {
                    templateUrl: 'app/main/Quantion/auth/errores/500/error-500.html',
                    controller: 'MyError500Controller as vm'
                }
            },
            bodyClass: 'error500'
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/auth/errores/500');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.error-500')
            .controller('MyError500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller($scope, $location, quantionApi, $interval)
    {
        $scope.tryingReturn = false;
        $scope.error = false;

        quantionApi.serverOn().then(function () {
            $scope.tryingReturn = false;
            $scope.error = false;
            $location.path('/');
        }, function () {
            $scope.tryingReturn = false;
            $scope.error = true;
        });

        $scope.goHome = function () {
            $scope.tryingReturn = true;
            $scope.error = false;

            setTimeout(function () {
                quantionApi.serverOn().then(function () {
                    $scope.tryingReturn = false;
                    $scope.error = false;
                    $location.path('/');
                }, function () {
                    $scope.tryingReturn = false;
                    $scope.error = true;
                });
            }, 1000);
        };

        var int = $interval($scope.goHome, 5000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(int);
        });
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.error-404', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.Quantion_error-404', {
            url: '/error404',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Quantion_error-404': {
                    templateUrl: 'app/main/Quantion/auth/errores/404/error-404.html',
                    controller: 'MyError404Controller as vm'
                }
            },
            bodyClass: 'error404'
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/auth/errores/404');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.error-404')
            .controller('MyError404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($scope, $location)
    {
        $scope.goHome = function () {
            $location.path('/');
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.error-401', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.Quantion_error-401', {
            url: '/error401',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Quantion_error-401': {
                    templateUrl: 'app/main/Quantion/auth/errores/401/error-401.html',
                    controller: 'MyError401Controller as vm'
                }
            },
            bodyClass: 'error401'
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/auth/errores/401');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.error-401')
            .controller('MyError401Controller', Error401Controller);

    /** @ngInject */
    function Error401Controller($scope, $location)
    {
        $scope.goHome = function () {
            $location.path('/');
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.traduccion', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_traduccion', {
            url: '/root/traduccion',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/traduccion/traduccion.html',
                    controller: 'traduccionController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/traduccion');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.traduccion')
            .controller('traduccionController', traduccionController);

    /** @ngInject */
    function traduccionController(quantionApi, $mdToast, $scope, $rootScope, $filter, $mdDialog, translateApi)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_TRADUCCION';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        pantallaCarga.lsEnable('LS.GENERIC');
        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        CargarPaquetes();
        function CargarPaquetes() {
            quantionApi.getPaquetes(true).then(function (dataResponse) {
                $scope.listaPaquetes = dataResponse.data;
            });
        }

        CargarServicios();
        function CargarServicios() {
            quantionApi.getServicios(true).then(function (dataResponse) {
                $scope.listaServicios = $filter('orderBy')(dataResponse.data, 'name|formatNameDesc');
            });
        }

        CargarIdiomas();
        function CargarIdiomas() {
            quantionApi.getIdiomas(true).then(function (dataResponse) {
                $scope.listaIdiomas = dataResponse.data;
            });
        }

        //******************** Traducciones *************************
        var idiomaPrincipal = 'es';
        $scope.idiomaPrincipal = idiomaPrincipal;

        $scope.tryTranslate = function (obj, idioma) {
            translateApi.translate(idiomaPrincipal, idioma, obj[idiomaPrincipal]).then(function (dataResponse) {
                obj[idioma] = dataResponse.data[0][0][0];
            });
        };

        $scope.copyAllFrom = function (pkg) {
            $.each($scope.listaIdiomas, function (index, value) {
                if (value.idioma !== idiomaPrincipal && pkg.nameInt[idiomaPrincipal])
                    pkg.nameInt[value.idioma] = pkg.nameInt[idiomaPrincipal];

                if (value.idioma !== idiomaPrincipal && pkg.descriptionInt[idiomaPrincipal])
                    pkg.descriptionInt[value.idioma] = pkg.descriptionInt[idiomaPrincipal];
            });
        };

        $scope.updatePackage = function (pkg) {
            console.log(pkg.idPackage, {
                nameInt: pkg.nameInt,
                descriptionInt: pkg.descriptionInt
            });

            quantionApi.updatePaquete(pkg.idPackage, angular.toJson({
                nameInt: pkg.nameInt,
                descriptionInt: pkg.descriptionInt
            })).then(function (dataResponse) {
                $mdToast.show($mdToast.simple().textContent('Paquete editado correctamente').position('top right').hideDelay(3000));
            });
        };

        $scope.updateService = function (srvc) {
            console.log(srvc.idService, {
                nameInt: srvc.nameInt,
                descriptionInt: srvc.descriptionInt
            });

            quantionApi.updateServicio(srvc.idService, angular.toJson({
                nameInt: srvc.nameInt,
                descriptionInt: srvc.descriptionInt
            })).then(function (dataResponse) {
                $mdToast.show($mdToast.simple().textContent('Servicio editado correctamente').position('top right').hideDelay(3000));
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.temas', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_temas', {
            url: '/root/temas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/temas/temas.html',
                    controller: 'temasController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/temas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.temas')
            .controller('temasController', temasController);

    /** @ngInject */
    function temasController(quantionApi, $mdToast, $scope, $rootScope, $filter, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_TEMAS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        function CargarTemas() {
            pantallaCarga.lsEnable('LS.TEMAS');

            quantionApi.getTemas().then(function (dataResponse) {
                if (dataResponse.data.files.length === 0)
                    pantallaCarga.lsDisable();

                vm.listaTemas = {};
                $.each(dataResponse.data.files, function (key, value) {
                    if (value[0] !== '.') {
                        vm.listaTemas[value] = {name: value, download: quantionApi.downloadTema(value)};
                        quantionApi.getThemeProperties(value, 'properties.json?' + (+new Date())).then(function (dataResponse) {
                            vm.listaTemas[value].properties = dataResponse.data.properties;
                        }, function (dataResponse) {
                            console.warn('No existe un properties.json para el tema ' + value + ', o el parámetro "id" del fichero no concuerda con el nombre del tema');
                        });
                    }
                });
            });
        }
        CargarTemas();

        document.getElementById('files').addEventListener('change', cargarArchivo, false);

        function cargarArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            if (!file)
                return;

            vm.file = file;
        }

        vm.enviarArchivo = function () {
            var formData = new FormData();
            formData.append('file', vm.file);

            quantionApi.uploadTema(formData).then(function (dataResponse) {
                $mdToast.show($mdToast.simple().textContent($filter('translate')('TEMAS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                CargarTemas();
            });
        };

        $scope.showInfo = function (tema) {
            $mdDialog.show({
                template:
                        '<md-dialog aria-label="Tema info">' +
                        '  <md-dialog-content>' +
                        '    <md-list>' +
                        '      <md-list-item ng-repeat="(key,value) in tema.properties">' +
                        '       <h2><b>{{key}}:</b> {{value}}</h2>' +
                        '    </md-list-item></md-list>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="closeDialog()" class="md-primary">' +
                        '      Cerrar' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                controller: function ($scope, $mdDialog) {
                    $scope.tema = tema;
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
                clickOutsideToClose: true
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.tarjetas', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_tarjetas', {
            url: '/root/tarjetas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/tarjetas/tarjetas.html',
                    controller: 'tarjetasController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/tarjetas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.tarjetas')
            .controller('tarjetasController', tarjetasController);

    /** @ngInject */
    function tarjetasController(quantionApi, $mdDialog, $mdToast, $scope, JSONconfig, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_TARJETAS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.numberOfPages = function () {
            if (!vm.cardListFiltered)
                return 0;

            var a = Math.floor(vm.cardListFiltered.length / $scope.pageSize);
            if ($scope.currentPage > a)
                $scope.currentPage = a;
            return a;
        };

        $scope.filterTarjetas = function () {
            vm.cardListFiltered = $filter('filter')(vm.cardList, $scope.search);
        };

        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        CargarTarjetas();
        function CargarTarjetas() {
            pantallaCarga.lsEnable('LS.MONEDEROS');

            vm.cardList = [];
            vm.cardListFiltered = [];

            quantionApi.getCardsIntegration().then(function (dataResponse) {
                vm.cardList = $filter('orderBy')(dataResponse.data, 'uuidAuthCard');
                vm.cardListFiltered = vm.cardList;

                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();

                initTable();
            }, function () {
                pantallaCarga.lsDisable();
            });
        }
        $scope.CargarTarjetas = CargarTarjetas;

        function initTable() {
            $scope.search = '';
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.orderProp = 'uuidAuthCard';
            $scope.orderReverse = false;
        }

//        CargarTipos();
//        function CargarTipos() {
//            quantionApi.getCardTypes().then(function (dataResponse) {
//                vm.typeList = dataResponse.data;
//            });
//        }

        $scope.nuevaTarjeta = function () {
            $mdDialog.show({
                controller: NuevaTarjetaCtrl,
                templateUrl: 'app/main/Quantion/root/tarjetas/templates/nuevaTarjeta.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NuevaTarjetaCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = $filter('translate')('TARJETAS.NUEVATARJETA');
            $scope.typeList = vm.typeList;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.card, 0);

                quantionApi.addCardIntegration(jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    $mdDialog.hide();
                    CargarTarjetas();
                });
            };
        }

        $scope.cambiarTipo = function (card) {
            $mdDialog.show({
                controller: CambiarTipoCtrl,
                templateUrl: 'app/main/Quantion/root/tarjetas/templates/cambiarTipo.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    card: card
                }
            });
        };

        function CambiarTipoCtrl($scope, $mdDialog, $mdToast, card) {
            $scope.DialogTitle = $filter('translate')('TARJETAS.CAMBIARTIPO');
            $scope.selectedType = card.type ? card.type.name : null;

            $scope.typeList = vm.typeList;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson({"type": $scope.selectedType}, 0);

                quantionApi.updateCardIntegration(card.uuidAuthCard, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    $mdDialog.hide();
                    CargarTarjetas();
                });
            };
        }

        $scope.acciones = function (card) {
            $mdDialog.show({
                controller: AccionesCtrl,
                templateUrl: 'app/main/Quantion/root/tarjetas/templates/acciones.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    card: card
                },
                onRemoving: function () {
                    CargarTarjetas();
                }
            });
        };

        function AccionesCtrl($scope, $mdDialog, $mdToast, card, $mdSidenav) {
            $scope.DialogTitle = $filter('translate')('TARJETAS.ASIGNARACCIONES');
            $scope.card = angular.copy(card);

            quantionApi.getCardsVars().then(function (dataResponse) {
                $scope.varList = dataResponse.data;
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            var flag;//Indica si el sidenav crea o edita
            var editedIdx;

            $scope.addAction = function () {
                flag = 'nuevo';
                $scope._action = {};
                $mdSidenav('right').open();
            };

            $scope.editAction = function (action, index) {
                flag = 'editar';
                editedIdx = index;
                $scope._action = angular.copy(action);
                $mdSidenav('right').open();
            };

            $scope.deleteAction = function (index) {
                var arr = angular.copy($scope.card.actions);
                arr.splice(index, 1);

                var jsonObj = angular.toJson({"actions": arr}, 0);

                quantionApi.updateCardIntegration(card.uuidAuthCard, jsonObj).then(function (dataResponse) {
                    $scope.card.actions = arr;
                });
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var arr = angular.copy($scope.card.actions);

                if (flag === 'nuevo') {
                    arr.push($scope._action);
                }

                if (flag === 'editar') {
                    arr[editedIdx] = $scope._action;
                }

                var jsonObj = angular.toJson({"actions": arr}, 0);

                quantionApi.updateCardIntegration(card.uuidAuthCard, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    $scope.card.actions = arr;
                    $mdSidenav('right').close();
                });
            };
        }

        $scope.eliminar = function (card) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('TARJETAS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('TARJETAS.MODALELIMINAR.CONTENT'))
                    .ok($filter('translate')('TARJETAS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('TARJETAS.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCardIntegration(card.uuidAuthCard).then(function () {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('TARJETAS.TOASTELIMINAR'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    CargarTarjetas();
                });
            });
        };

        $scope.nuevoTipo = function () {
            $mdDialog.show({
                controller: NuevoTipoCtrl,
                templateUrl: 'app/main/Quantion/root/tarjetas/templates/nuevoTipo.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

//        function NuevoTipoCtrl($scope, $mdDialog, $mdToast) {
//            $scope.DialogTitle = $filter('translate')('TARJETAS.NUEVOTIPO');
//
//            $scope.hide = function () {
//                $mdDialog.hide();
//            };
//            $scope.cancel = function () {
//                $mdDialog.cancel();
//            };
//
//            $scope.Guardar = function () {
//                $scope.dataLoading = true;
//
//                var jsonObj = angular.toJson({name: $scope.typeName}, 0);
//
//                quantionApi.addCardType(jsonObj).then(function (dataResponse) {
//                    $scope.dataLoading = false;
//                    $mdDialog.hide();
//                    CargarTipos();
//                });
//            };
//        }

//        $scope.accionesTipo = function (type) {
//            $mdDialog.show({
//                controller: AccionesTipoCtrl,
//                templateUrl: 'app/main/Quantion/root/tarjetas/templates/acciones.tmpl.html',
//                parent: angular.element(document.body),
//                clickOutsideToClose: true,
//                locals: {
//                    type: type
//                },
//                onRemoving: function () {
//                    CargarTipos();
//                    CargarTarjetas();
//                }
//            });
//        };

//        function AccionesTipoCtrl($scope, $mdDialog, $mdToast, type, $mdSidenav) {
//            $scope.DialogTitle = $filter('translate')('TARJETAS.ASIGNARACCIONES');
//            $scope.card = angular.copy(type);
//
//            quantionApi.getCardsVars().then(function (dataResponse) {
//                $scope.varList = dataResponse.data;
//            });
//
//            $scope.hide = function () {
//                $mdDialog.hide();
//            };
//            $scope.cancel = function () {
//                $mdDialog.cancel();
//            };
//
//            var flag;//Indica si el sidenav crea o edita
//            var editedIdx;
//
//            $scope.addAction = function () {
//                flag = 'nuevo';
//                $scope._action = {};
//                $mdSidenav('right').open();
//            };
//
//            $scope.editAction = function (action, index) {
//                flag = 'editar';
//                editedIdx = index;
//                $scope._action = angular.copy(action);
//                $mdSidenav('right').open();
//            };
//
//            $scope.deleteAction = function (index) {
//                var arr = angular.copy($scope.card.actions);
//                arr.splice(index, 1);
//
//                var jsonObj = angular.toJson({"actions": arr}, 0);
//
//                quantionApi.updateCardType(type.name, jsonObj).then(function (dataResponse) {
//                    $scope.card.actions = arr;
//                });
//            };
//
//            $scope.Guardar = function () {
//                $scope.dataLoading = true;
//
//                var arr = angular.copy($scope.card.actions);
//
//                if (flag === 'nuevo') {
//                    arr.push($scope._action);
//                }
//
//                if (flag === 'editar') {
//                    arr[editedIdx] = $scope._action;
//                }
//
//                var jsonObj = angular.toJson({"actions": arr}, 0);
//
//                quantionApi.updateCardType(type.name, jsonObj).then(function (dataResponse) {
//                    $scope.dataLoading = false;
//                    $scope.card.actions = arr;
//                    $mdSidenav('right').close();
//                });
//            };
//        }

//        $scope.eliminarTipo = function (type) {
//            var confirm = $mdDialog.confirm()
//                    .title($filter('translate')('TARJETAS.MODALELIMINAR2.TITLE'))
//                    .textContent($filter('translate')('TARJETAS.MODALELIMINAR2.CONTENT'))
//                    .ok($filter('translate')('TARJETAS.MODALELIMINAR2.OK'))
//                    .cancel($filter('translate')('TARJETAS.MODALELIMINAR2.CANCEL'));
//            $mdDialog.show(confirm).then(function () {
//                quantionApi.deleteCardType(type.name).then(function () {
//                    $mdToast.show(
//                            $mdToast.simple()
//                            .textContent($filter('translate')('TARJETAS.TOASTELIMINAR2'))
//                            .position('top right')
//                            .hideDelay(3000)
//                            );
//
//                    CargarTipos();
//                });
//            });
//        };

        $scope.importar = function () {
            $mdDialog.show({
                controller: ImportarCtrl,
                templateUrl: 'app/main/Quantion/root/tarjetas/templates/importar.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function ImportarCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = $filter('translate')('TARJETAS.NUEVATARJETA');
            $scope.typeList = vm.typeList;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.readFile = function (evt) {
                var files = document.getElementById("fileInput").files;
                var file = files[0];
                var reader = new FileReader();

                reader.onload = function (e) {
                    var contenidoArchivo = e.target.result;

                    $scope.textcontent = contenidoArchivo;
                    $scope.splitContent($scope.textcontent);
                };

                if (file) {
                    $scope.isLoading = true;
                    reader.readAsText(file);
                }
            };

            $scope.splitContent = function (textcontent) {
                $scope.cardList = textcontent.split('\n');
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                guardadoRecursivo($scope.cardList);
            };

            function guardadoRecursivo(array) {
                if (array[0]) {
                    var obj = {
                        "uuidAuthCard": array.shift(),
                        "type": $scope.type
                    };

                    quantionApi.addCardIntegration(angular.toJson(obj)).then(function (dataResponse) {
                        guardadoRecursivo(array);
                    }, function () {
                        console.error('Error al guardar la tarjeta ' + array[0]);
                        guardadoRecursivo(array);
                    });
                } else {
                    $scope.dataLoading = false;
                    $mdDialog.hide();
                    CargarTarjetas();
                }
            }
        }

        $scope.actionDetails = function (action) {
            $mdDialog.show({
                controller: VerActionCtrl,
                templateUrl: 'app/main/Quantion/root/tarjetas/templates/verAccion.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    action: action
                }
            });
        };

        function VerActionCtrl($scope, $mdDialog, action) {
            $scope.action = angular.copy(action);

            try {
                $scope.action.data = JSON.parse($scope.action.data);
            } catch (e) {

            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.properties', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_properties', {
            url: '/root/properties',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/properties/properties.html',
                    controller: 'propertiesController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/properties');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.properties')
            .controller('propertiesController', propertiesController);

    /** @ngInject */
    function propertiesController(quantionApi, $mdToast, $scope, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_PROPERTIES';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        CargarProperties();
        function CargarProperties() {
            pantallaCarga.lsEnable('LS.GENERIC');

            quantionApi.getProperties(false).then(function (dataResponse) {
                vm.listaProperties = dataResponse.data;
                vm.listaPropertiesOrig = angular.copy(vm.listaProperties);

                if (dataResponse.data.length < 1)
                    pantallaCarga.lsDisable();
            });

            quantionApi.getProperties(true).then(function (dataResponse) {
                vm.listaPropertiesInstallation = dataResponse.data;
                vm.listaPropertiesInstallationOrig = angular.copy(vm.listaPropertiesInstallation);

                if (dataResponse.data.length < 1)
                    pantallaCarga.lsDisable();
            });
        }

        $scope.save = function (installation, key, value) {
            quantionApi.updateProperties(installation, key, value).then(function () {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('PROPERTIES.TOAST_GUARDAR'))
                        .position('top right')
                        .hideDelay(3000)
                        );

                if (installation) {
                    vm.listaPropertiesInstallationOrig[key] = vm.listaPropertiesInstallation[key];
                } else {
                    vm.listaPropertiesOrig[key] = vm.listaProperties[key];
                }
            });
        };

        $scope.restart = function (installation, key) {
            if (installation) {
                vm.listaPropertiesInstallation[key] = vm.listaPropertiesInstallationOrig[key];
            } else {
                vm.listaProperties[key] = vm.listaPropertiesOrig[key];
            }
        };

    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.instalaciones', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_instalaciones', {
            url: '/root/instalaciones',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/instalaciones/instalaciones.html',
                    controller: 'instalacionesController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/instalaciones');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.instalaciones')
            .controller('instalacionesController', instalacionesController);

    /** @ngInject */
    function instalacionesController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter, $mdSidenav, JSONconfig, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_INSTALACIONES';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.JSONconfig = JSONconfig;

        function CargarInstalaciones() {
            pantallaCarga.lsEnable('LS.INSTALACIONES');

            quantionApi.getInstalaciones().then(function (dataResponse) {
                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();

                vm.listaSinAgrupar = $filter('orderBy')(dataResponse.data, 'name');
                vm.listaInstalaciones = $filter('groupBy')(dataResponse.data, 'category');
            });
        }
        CargarInstalaciones();

        function CargarServicios() {
            quantionApi.getServicios(false).then(function (dataResponse) {
                vm.allServicios = dataResponse.data;

                vm.listaServicios = [];
                vm.listaGrupos = [];
                $.each(dataResponse.data, function (index, value) {
                    if (value.type === 'group') {
                        vm.listaGrupos.push(value);
                    } else {
                        vm.listaServicios.push(value);
                    }
                });
            });
        }
        CargarServicios();

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.listaIdiomas = dataResponse.data;
        });

        quantionApi.getInstalacionThemes().then(function (dataResponse) {
            vm.listaThemes = dataResponse.data;
        });

        quantionApi.getAcls().then(function (dataResponse) {
            vm.listaAcls = $filter('orderBy')($.unique(dataResponse.data));
        });

        quantionApi.getControls().then(function (dataResponse) {
            vm.listaControls = $filter('orderBy')(dataResponse.data, 'model');
        });

        vm.eliminarInstalacion = function (ev, instalacion) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('INSTALACIONES.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('INSTALACIONES.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('INSTALACIONES.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('INSTALACIONES.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteInstalacion(instalacion.idInstallation).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('INSTALACIONES.TOASTELIMINAR')).position('top right').hideDelay(3000));
                    CargarInstalaciones();
                }, function () {
                    console.error('No se puede eliminar la instalación');
                });
            });
        };

        vm.nuevaInstalacion = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/instalaciones/templates/creareditarInstalacion.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = $filter('translate')('INSTALACIONES.MODALEDITAR.TITLECREAR');
            $scope.tipo = 'Nuevo';
            $scope.listaIdiomas = vm.listaIdiomas;
            $scope.listaThemes = vm.listaThemes;
            $scope.listaAcls = vm.listaAcls;
            $scope.listaControls = vm.listaControls;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.installation);

                quantionApi.addInstalacion(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('INSTALACIONES.TOASTCREAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                    CargarInstalaciones();
                });
            };
        }

        vm.editarInstalacion = function (ev, inst) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/root/instalaciones/templates/creareditarInstalacion.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"inst": inst}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, inst) {
            $scope.DialogTitle = $filter('translate')('INSTALACIONES.MODALEDITAR.TITLEEDITAR', {installationName: inst.name});
            $scope.tipo = 'Editar';
            $scope.listaIdiomas = vm.listaIdiomas;
            $scope.listaThemes = vm.listaThemes;
            $scope.listaAcls = vm.listaAcls;
            $scope.listaControls = vm.listaControls;

            $scope.installation = {
                name: inst.name,
                description: inst.description,
                language: inst.language,
                theme: inst.theme,
                welcomeType: inst.welcomeType,
                welcomeMessage: inst.welcomeMessage,
                lockedType: inst.lockedType,
                checkoutType: inst.checkoutType,
                checkoutMessage: inst.checkoutMessage,
                autorun: inst.autorun,
                control: inst.control ? inst.control.idControl : null,
                category: inst.category,
                brand: inst.brand
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.installation);

                quantionApi.updateInstalacion(inst.idInstallation, jsonObj).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('INSTALACIONES.TOASTEDITAR'))
                            .position('top right')
                            .hideDelay(3000)
                            );
                    $mdDialog.hide();
                    CargarInstalaciones();
                });
            };
        }

        vm.verServicios = function (ev, inst) {
            $mdDialog.show({
                controller: VerServiciosCtrl,
                templateUrl: 'app/main/Quantion/root/instalaciones/templates/verServicios.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"inst": inst}
            });
        };

        function VerServiciosCtrl($scope, $mdDialog, inst) {
            $scope.installation = angular.copy(inst);
            $scope.listaServicios = filtrarListaServicios(vm.listaServicios);
            $scope.listaGrupos = filtrarListaGrupos(vm.listaGrupos);

            function filtrarListaServicios(array) {
                var base = $scope.installation.registerBase.map(function (elm) {
                    return elm.idService;
                });
                var purch = $scope.installation.registerPurchasable.map(function (elm) {
                    return elm.idService;
                });
                var extra = $scope.installation.registerExtra.map(function (elm) {
                    return elm.idService;
                });
                return array.filter(function (elm) {
                    return base.indexOf(elm.idService) === -1 &&
                            purch.indexOf(elm.idService) === -1 &&
                            extra.indexOf(elm.idService) === -1;
                });
            }

            function filtrarListaGrupos(array) {
                var group = $scope.installation.registerGroup.map(function (elm) {
                    return elm.idService;
                });

                return array.filter(function (elm) {
                    return group.indexOf(elm.idService) === -1;
                });
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.addServicio = function (srvc, arraySrc, isExtra) {
                if (arraySrc.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) === -1) {
                    arraySrc.push(srvc);
                }

                $scope.listaServicios = filtrarListaServicios($scope.listaServicios);
            };

            $scope.addGrupo = function (srvc, arraySrc, isExtra) {
                if (arraySrc.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) === -1) {
                    arraySrc.push(srvc);
                }

                $scope.listaGrupos = filtrarListaGrupos($scope.listaGrupos);
            };

            $scope.deleteServicio = function (index, srvc, arraySrc) {
                arraySrc.splice(index, 1);
                if ($scope.installation.homeServices.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) !== -1) {
                    $scope.installation.homeServices.splice($scope.installation.homeServices.map(function (elm) {
                        return elm.idService;
                    }).indexOf(srvc.idService), 1);
                }
                if ($scope.installation.extraServices.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) !== -1) {
                    $scope.installation.extraServices.splice($scope.installation.extraServices.map(function (elm) {
                        return elm.idService;
                    }).indexOf(srvc.idService), 1);
                }
                if ($scope.installation.sidebar.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) !== -1) {
                    $scope.installation.sidebar.splice($scope.installation.sidebar.map(function (elm) {
                        return elm.idService;
                    }).indexOf(srvc.idService), 1);
                }
                $scope.listaServicios = filtrarListaServicios(vm.listaServicios);
            };

            $scope.deleteGrupo = function (index, srvc, arraySrc) {
                arraySrc.splice(index, 1);
                if ($scope.installation.homeServices.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) !== -1) {
                    $scope.installation.homeServices.splice($scope.installation.homeServices.map(function (elm) {
                        return elm.idService;
                    }).indexOf(srvc.idService), 1);
                }
                if ($scope.installation.extraServices.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) !== -1) {
                    $scope.installation.extraServices.splice($scope.installation.extraServices.map(function (elm) {
                        return elm.idService;
                    }).indexOf(srvc.idService), 1);
                }
                if ($scope.installation.sidebar.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) !== -1) {
                    $scope.installation.sidebar.splice($scope.installation.sidebar.map(function (elm) {
                        return elm.idService;
                    }).indexOf(srvc.idService), 1);
                }
                $scope.listaGrupos = filtrarListaGrupos(vm.listaGrupos);
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson({
                    registerBase: $scope.installation.registerBase.map(function (elm) {
                        return elm.idService;
                    }),
                    registerPurchasable: $scope.installation.registerPurchasable.map(function (elm) {
                        return elm.idService;
                    }),
                    registerExtra: $scope.installation.registerExtra.map(function (elm) {
                        return elm.idService;
                    }),
                    registerGroup: $scope.installation.registerGroup.map(function (elm) {
                        return elm.idService;
                    }),
                    homeServices: $scope.installation.homeServices.map(function (elm) {
                        return elm.idService;
                    }),
                    extraServices: $scope.installation.extraServices.map(function (elm) {
                        return elm.idService;
                    }),
                    sidebar: $scope.installation.sidebar.map(function (elm) {
                        return elm.idService;
                    })
                }, true);

                quantionApi.updateInstalacion(inst.idInstallation, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('INSTALACIONES.TOASTEDITAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                    CargarInstalaciones();
                });
            };
        }

        vm.ordenarHome = function (ev, inst) {
            $mdDialog.show({
                controller: OrdenHomeCtrl,
                templateUrl: 'app/main/Quantion/root/instalaciones/templates/ordenHome.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"inst": inst}
            });
        };

        function OrdenHomeCtrl($scope, $mdDialog, inst, $mdSidenav) {
            $scope.installation = angular.copy(inst);
            $scope.stateTree = {};

            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            filtrarListaHome();
            function filtrarListaHome() {
                $scope.listaHomeRestantes = vm.allServicios.filter(function (elm) {
                    return (
                            $scope.installation.homeServices.map(function (elm) {
                                return elm.idService;
                            }).indexOf(elm.idService) === -1 &&
                            $scope.installation.extraServices.map(function (elm) {
                                return elm.idService;
                            }).indexOf(elm.idService) === -1
                            );
                });

                $.each($scope.installation.registerBase, function (index, value) {
                    $scope.stateTree[value.idService] = 'base';
                });

                $.each($scope.installation.registerPurchasable, function (index, value) {
                    $scope.stateTree[value.idService] = 'purchasable';
                });
            }

            filtrarListaExtra();
            function filtrarListaExtra() {
                $scope.listaExtraRestantes = vm.allServicios.filter(function (elm) {
                    return (
                            $scope.installation.extraServices.map(function (elm) {
                                return elm.idService;
                            }).indexOf(elm.idService) === -1 &&
                            $scope.installation.homeServices.map(function (elm) {
                                return elm.idService;
                            }).indexOf(elm.idService) === -1
                            );
                });

                $.each($scope.installation.registerBase, function (index, value) {
                    $scope.stateTree[value.idService] = 'base';
                });

                $.each($scope.installation.registerPurchasable, function (index, value) {
                    $scope.stateTree[value.idService] = 'purchasable';
                });
            }

            filtrarListaSidebar();
            function filtrarListaSidebar() {
                $scope.listaSidebarRestantes = vm.allServicios.filter(function (elm) {
                    return (
                            $scope.installation.sidebar.map(function (elm) {
                                return elm.idService;
                            }).indexOf(elm.idService) === -1
                            );
                });

                $.each($scope.installation.registerBase, function (index, value) {
                    $scope.stateTree[value.idService] = 'base';
                });

                $.each($scope.installation.registerPurchasable, function (index, value) {
                    $scope.stateTree[value.idService] = 'purchasable';
                });
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.addServicio = function (srvc, arraySrc) {
                if (arraySrc.map(function (elm) {
                    return elm.idService;
                }).indexOf(srvc.idService) === -1) {
                    arraySrc.push(srvc);
                }

                filtrarListaHome();
                filtrarListaExtra();
                filtrarListaSidebar();
            };

            $scope.deleteServicio = function (index, arraySrc) {
                arraySrc.splice(index, 1);

                filtrarListaHome();
                filtrarListaExtra();
                filtrarListaSidebar();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var h = [];
                $.each($scope.installation.homeServices, function (index, value) {
                    getIdServices(value);
                });
                $.each($scope.installation.extraServices, function (index, value) {
                    getIdServices(value);
                });
                $.each($scope.installation.sidebar, function (index, value) {
                    getIdServices(value);
                });
                function getIdServices(service) {
                    h.push(service.idService);
                    $.each(service.elements, function (index, value) {
                        getIdServices(value);
                    });
                }

                var bases = [], purchs = [];
                $.each($scope.stateTree, function (index, value) {
                    var idx = parseInt(index);
                    switch (value) {
                        case 'base':
                            if (h.indexOf(idx) !== -1)
                                bases.push(idx);
                            break;
                        case 'purchasable':
                            if (h.indexOf(idx) !== -1)
                                purchs.push(idx);
                            break;
                    }
                });

                var jsonObj = angular.toJson({
                    homeServices: $scope.installation.homeServices.map(function (elm) {
                        return elm.idService;
                    }),
                    extraServices: $scope.installation.extraServices.map(function (elm) {
                        return elm.idService;
                    }),
                    sidebar: $scope.installation.sidebar.map(function (elm) {
                        return elm.idService;
                    }),
                    registerBase: bases,
                    registerPurchasable: purchs
                });

                quantionApi.updateInstalacion(inst.idInstallation, jsonObj).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('INSTALACIONES.TOASTORDEN'))
                            .position('top right')
                            .hideDelay(3000)
                            );
                    $mdDialog.hide();
                    CargarInstalaciones();
                });
            };

            $scope.sortableOptionsY = {
                revert: true,
                axis: 'y',
                distance: 10,
                tolerance: "intersect",
                opacity: 0.9,
                placeholder: "lsta-highlight"
            };

            $scope.sortableOptionsX = {
                revert: true,
                axis: 'x',
                distance: 10,
                tolerance: "intersect",
                opacity: 0.9,
                placeholder: "lsta-highlight"
            };

            $scope.swap = function (list, x, y) {
                var b = list[y];
                list[y] = list[x];
                list[x] = b;
            };

            $scope.openSidenav = function (serviceObj) {
                $scope.elem = serviceObj;
                $mdSidenav('right').open();
            };

            $scope.changeState = function (idService, newState) {
                if (newState)
                    $scope.stateTree[idService] = newState;
                else
                    delete $scope.stateTree[idService];
            };
        }

        vm.paquetes = function (ev, inst) {
            $mdDialog.show({
                controller: PaquetesCtrl,
                templateUrl: 'app/main/Quantion/root/instalaciones/templates/paquetes.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"inst": inst}
            });
        };

        function PaquetesCtrl($scope, $mdDialog, inst, $mdSidenav) {
            $scope.installation = angular.copy(inst);

            quantionApi.getPaquetes().then(function (dataResponse) {
                $scope.listaPaquetes = $filter('orderBy')(dataResponse.data.filter(function (e) {
                    return e.active;
                }), 'name|formatNameDesc');
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.addPaquete = function (pkg, arraySrc) {
                if (arraySrc.map(function (elm) {
                    return elm.idPackage;
                }).indexOf(pkg.idPackage) === -1) {
                    arraySrc.push(pkg);
                }
            };

            $scope.deletePaquete = function (index, arraySrc) {
                arraySrc.splice(index, 1);
            };

            $scope.exists = function (item, list) {
                return list.map(function (e) {
                    return e.idPackage;
                }).indexOf(item.idPackage) > -1;
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson({
                    availablePackages: $scope.installation.availablePackages.map(function (elm) {
                        return elm.idPackage;
                    })
                });

                quantionApi.updateInstalacion(inst.idInstallation, jsonObj).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('INSTALACIONES.TOASTPAQUETES'))
                            .position('top right')
                            .hideDelay(3000)
                            );
                    $mdDialog.hide();
                    CargarInstalaciones();
                });
            };

            $scope.sortableOptionsY = {
                revert: true,
                axis: 'y',
                distance: 10,
                tolerance: "intersect",
                opacity: 0.9,
                placeholder: "lsta-highlight"
            };

            $scope.swap = function (list, x, y) {
                var b = list[y];
                list[y] = list[x];
                list[x] = b;
            };
        }

        $scope.CopiarInstalacion = function (inst) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('INSTALACIONES.MODALCOPIAR.TITLE'))
                    .ok($filter('translate')('INSTALACIONES.MODALCOPIAR.OK'))
                    .cancel($filter('translate')('INSTALACIONES.MODALCOPIAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                var i = angular.copy(inst);
                i.name += " (copia)";
                delete i.idInstallation;

                $.each(['extraServices', 'homeServices', 'registerBase', 'registerPurchasable', 'sidebar'], function (ind, atr) {
                    i[atr] = inst[atr].map(function (el) {
                        return el.idService;
                    });
                });

                quantionApi.addInstalacion(angular.toJson(i)).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('INSTALACIONES.TOASTCOPIAR')).position('top right').hideDelay(3000));
                    CargarInstalaciones();
                });
            });
        };


        //*************** IMPORTACIÓN **************************
        vm.importFile = function () {
            $('#files').click();
        };

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var contenidoArchivo = e.target.result;

                if (isJSON(contenidoArchivo)) {
                    var listaInstalaciones = JSON.parse(contenidoArchivo);

                    $mdDialog.show({
                        controller: SelectInstallationToImport,
                        templateUrl: 'app/main/Quantion/root/instalaciones/templates/importInstalaciones.tmpl.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        locals: {listaInstalaciones: listaInstalaciones},
                        onRemoving: function () {
                            document.getElementById('files').value = null;
                        }
                    });
                }
                $scope.isLoading = false;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
            return true;
        }

        function SelectInstallationToImport($scope, $mdDialog, $mdToast, $filter, listaInstalaciones) {
            $scope.listaInstalaciones = listaInstalaciones;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var arr = [];

                $.each($scope.listaInstalaciones, function (index, value) {
                    if (value.seleccionado) {
                        var o = angular.copy(value);
                        delete o.idInstallation;
                        delete o.seleccionado;

                        o.registerBase = getServicesByAcl(vm.allServicios, value.registerBase.map(function (e) {
                            return e.acl;
                        }), true);

                        o.registerPurchasable = getServicesByAcl(vm.allServicios, value.registerPurchasable.map(function (e) {
                            return e.acl;
                        }), true);

                        o.homeServices = getServicesByAcl(vm.allServicios, value.homeServices.map(function (e) {
                            return e.acl;
                        }), true);

                        o.extraServices = getServicesByAcl(vm.allServicios, value.extraServices.map(function (e) {
                            return e.acl;
                        }), true);

                        o.sidebar = getServicesByAcl(vm.allServicios, value.sidebar.map(function (e) {
                            return e.acl;
                        }), true);

                        arr.push(o);
                    }
                });

                PostService(arr);
            };

            function PostService(array) {
                if (array[0]) {
                    quantionApi.addInstalacion(angular.toJson(array[0])).then(function (dataResponse) {
                        array.shift();
                        PostService(array);
                    }, function () {
                        $mdToast.show($mdToast.simple()
                                .textContent($filter('translate')('INSTALACIONES.TOASTERRORGUARDAR', {name: array[0].name}))
                                .position('top right').hideDelay(3000));
                        array.shift();
                        PostService(array);
                    });
                } else {
                    $mdDialog.hide();
                    CargarInstalaciones();
                }
            }

            function getServicesByAcl(lista, acls, onlyIds) {
                var arr = lista.filter(function (e) {
                    return acls.indexOf(e.acl) !== -1;
                });

                return onlyIds ? arr.map(function (e) {
                    return e.idService;
                }) : arr;
            }
        }

        //****************** Upload logo ***********************
        $scope.uploadLogo = function (inst) {
            $scope.selectedInstallation = inst;

            $('#logoUpload').click();
        };

        document.getElementById('logoUpload').addEventListener('change', UploadLogo, false);

        function UploadLogo(evt) {
            if (!$scope.selectedInstallation)
                return;

            var files = evt.target.files;
            var file = files[0];

            var formData = new FormData();
            formData.append('file', file);

            quantionApi.uploadGenericFile(formData, angular.lowercase($scope.selectedInstallation.name) + '.png', FilePaths.instalaciones).then(function (dataResponse) {
                var jsonObj = angular.toJson({logo: JSONconfig.logosPath.from + '/' + FilePaths.instalaciones + '/' + angular.lowercase($scope.selectedInstallation.name) + '.png?' + (+new Date())});

                quantionApi.updateInstalacion($scope.selectedInstallation.idInstallation, jsonObj).then(function (dataResponse) {
                    CargarInstalaciones();
                });
            }, function () {
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.idiomas', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_idiomas', {
            url: '/root/idiomas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/idiomas/idiomas.html',
                    controller: 'idiomasController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/idiomas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.idiomas')
            .controller('idiomasController', idiomasController);

    /** @ngInject */
    function idiomasController(quantionApi, $mdDialog, $mdToast, $scope, JSONconfig, $rootScope, $filter, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_IDIOMAS';

        function CargarIdiomas() {
            quantionApi.getIdiomas().then(function (dataResponse) {
                vm.listaIdiomas = dataResponse.data;
            });
        }

        CargarIdiomas();

        vm.eliminarIdioma = function (ev, idioma) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('IDIOMAS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('IDIOMAS.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('IDIOMAS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('IDIOMAS.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteIdioma(idioma.idIdioma).then(function () {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('IDIOMAS.TOASTELIMINAR'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    CargarIdiomas();
                });
            });
        };

        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/idiomas/creareditaridioma.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = $filter('translate')('IDIOMAS.CREARTITLE');

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.langIcon = function (nombre) {
                $scope.rutaIcono = JSONconfig.logosPath.from + '/Language/' + nombre + '.png';
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson({"idioma": $scope.idioma, "rutaIcono": $scope.rutaIcono}, 0);

                if ($scope.idioma.length > 0 && $scope.rutaIcono.length > 0) {
                    quantionApi.addIdioma(jsonObj).then(function (dataResponse) {
                        CargarIdiomas();

                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('IDIOMAS.TOASTCREAR'))
                                .position('top right')
                                .hideDelay(3000)
                                );

                        $mdDialog.hide();
                    });
                } else {
                    $scope.dataLoading = false;
                    $scope.mensajeError = $filter('translate')('IDIOMAS.ERRORVACIO');
                }
            };
        }

        vm.ventanaEditar = function (ev, idioma) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/root/idiomas/creareditaridioma.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"_original": idioma}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, _original) {
            $scope.DialogTitle = $filter('translate')('IDIOMAS.EDITARTITLE', {idioma: _original.idioma});

            $scope.idioma = _original.idioma;
            $scope.rutaIcono = _original.rutaIcono;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.langIcon = function (nombre) {
                $scope.rutaIcono = JSONconfig.logosPath.from + '/Language/' + nombre + '.png';
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    idIdioma: _original.idIdioma,
                    idioma: $scope.idioma,
                    rutaIcono: $scope.rutaIcono
                };

                if ($scope.idioma.length > 0 && $scope.rutaIcono.length > 0) {
                    quantionApi.updateIdioma(obj).then(function (dataResponse) {
                        CargarIdiomas();

                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('IDIOMAS.TOASTEDITAR'))
                                .position('top right')
                                .hideDelay(3000)
                                );

                        $mdDialog.hide();
                    });
                } else {
                    $scope.dataLoading = false;
                    $scope.mensajeError = $filter('translate')('IDIOMAS.ERRORVACIO');
                }
            };
        }

        //****************** Upload logo ***********************
        $scope.uploadLogo = function (idioma) {
            $scope.selectedIdioma = idioma;
            $('#logoUpload').click();
        };

        document.getElementById('logoUpload').addEventListener('change', UploadLogo, false);

        function UploadLogo(evt) {
            if (!$scope.selectedIdioma)
                return;

            var files = evt.target.files;
            var file = files[0];

            var formData = new FormData();
            formData.append('file', file);

            quantionApi.uploadGenericFile(formData, angular.lowercase($scope.selectedIdioma.idioma) + '.png', FilePaths.idiomas).then(function (dataResponse) {
                var obj = angular.copy($scope.selectedIdioma);
                obj.rutaIcono = JSONconfig.logosPath.from + '/Language/' + angular.lowercase($scope.selectedIdioma.idioma) + '.png';

                quantionApi.updateIdioma(obj).then(function (dataResponse) {
                    CargarIdiomas();
                }, function () {
                    CargarIdiomas();
                });
            }, function () {
            });
        }

        //*************** IMPORTACIÓN **************************

        vm.importFile = function () {
            $('#files').click();
        };

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var listaIdiomas = isJSON(e.target.result);

                if (listaIdiomas) {
                    console.log(listaIdiomas);
                    document.getElementById('files').value = null;

                    $.each(listaIdiomas, function (index, value) {
                        delete value.idIdioma;
                        var jsonObj = angular.toJson(value);
                        quantionApi.addIdioma(jsonObj).then(function (dataResponse) {
                            CargarIdiomas();
                        });
                    });
                }
                $scope.isLoading = false;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function isJSON(text) {
            try {
                return JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gruposStb', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_gruposStb', {
            url: '/root/gruposStb',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/gruposStb/gruposStb.html',
                    controller: 'gruposStbController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/gruposStb');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gruposStb')
            .controller('gruposStbController', gruposStbController);

    /** @ngInject */
    function gruposStbController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_GRUPOS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        function CargarGrupos() {
            pantallaCarga.lsEnable('LS.GRUPOSSTB');

            quantionApi.getGrupos().then(function (dataResponse) {
                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();

                vm.listaGrupos = dataResponse.data;

                vm.listaPlaces = unique(dataResponse.data.map(function (e) {
                    return e.place;
                }));

                console.log(vm.listaPlaces)
            }, function () {
                pantallaCarga.lsDisable();
            });

            function unique(array) {
                return array.filter(function (el, index, arr) {
                    return el && index === arr.indexOf(el);
                });
            }
        }
        CargarGrupos();

        function ObtenerStbs() {
            quantionApi.getStbs(true).then(function (dataResponse) {
                vm.listaStbs = $filter('orderBy')(dataResponse.data, 'room|tryParseInt');
            });
        }
        ObtenerStbs();

        vm.eliminarGrupo = function (ev, grupo) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('GRUPOSSTB.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('GRUPOSSTB.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('GRUPOSSTB.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('GRUPOSSTB.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteGrupo(grupo.idStbGroup).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTELIMINAR')).position('top right').hideDelay(3000));
                    CargarGrupos();
                });
            });
        };

        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/gruposStb/templates/creareditargruposStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = $filter('translate')('GRUPOSSTB.CREAR.TITLE');

            $scope.grupo = {};

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var obj = angular.copy($scope.grupo);

                if (!obj.place)
                    if ($scope.searchText)
                        obj.place = $scope.searchText;
                    else
                        obj.place = '';

                var jsonObj = angular.toJson(obj);

                quantionApi.addGrupo(jsonObj).then(function (dataResponse) {
                    CargarGrupos();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTCREAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                });
            };

            $scope.querySearch = function (query) {
                var results = query ? vm.listaPlaces.filter(createFilterFor(query)) : vm.listaPlaces;
                return results;
            };

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function (elm) {
                    return (elm.indexOf(lowercaseQuery) === 0);
                };
            }
        }

        vm.ventanaEditar = function (ev, grupo) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/root/gruposStb/templates/creareditargruposStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"grupo": grupo}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, grupo) {
            $scope.DialogTitle = $filter('translate')('GRUPOSSTB.EDITAR.TITLE', {groupName: grupo.nombre});

            $scope.grupo = angular.copy(grupo);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var obj = angular.copy($scope.grupo);

                if (!obj.place)
                    if ($scope.searchText)
                        obj.place = $scope.searchText;
                    else
                        obj.place = '';

                var jsonObj = angular.toJson(obj);

                quantionApi.updateGrupo(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTEDITADO')).position('top right').hideDelay(3000));
                    CargarGrupos();
                    $mdDialog.hide();
                });
            };

            $scope.querySearch = function (query) {
                var results = query ? vm.listaPlaces.filter(createFilterFor(query)) : vm.listaPlaces;
                return results;
            };

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function (elm) {
                    return (elm.indexOf(lowercaseQuery) === 0);
                };
            }
        }

        vm.asignarStbAGrupo = function (ev, grupo) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/root/gruposStb/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"grupo": grupo}
            });
        };

        function AsignarStbCtrl($scope, $mdDialog, $mdToast, grupo) {
            $scope.DialogTitle = (grupo.idStbGroup === 1) ? ($filter('translate')('GRUPOSSTB.ASIGNARSTB.SINGRUPO')) : ($filter('translate')('GRUPOSSTB.ASIGNARSTB.TITLE', {groupName: grupo.nombre}));
            $scope.idStbGroup = grupo.idStbGroup;

            $scope.group = angular.copy(grupo);
            $scope.allStbs = vm.listaStbs;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var obj = angular.copy($scope.group);
                var jsonObj = angular.toJson(obj);

                quantionApi.updateGrupo(jsonObj).then(function (dataResponse) {
                    CargarGrupos();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTEDITADO')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                });
            };

            $scope.toggle = function (item, list) {
                if (grupo.idStbGroup === 1)
                    return;

                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.initRange = function () {
                $scope.range = true;
                $scope.rangeIni = null;
                $scope.rangeFin = null;
            };

            $scope.selectRange = function (index) {
                if ($scope.rangeIni === null) {
                    $scope.rangeIni = index;

                    console.log('Inicio: ' + $scope.rangeIni);
                } else if (!$scope.rangeFin) {
                    $scope.rangeFin = index;

                    console.log('Fin: ' + $scope.rangeFin);

                    var min = Math.min($scope.rangeIni, $scope.rangeFin);
                    var max = Math.max($scope.rangeIni, $scope.rangeFin);

                    for (var i = min; i <= max; i++) {
                        if ($scope.group.stbs.indexOf($scope.allStbs[i].idStb) === -1) {
                            $scope.group.stbs.push($scope.allStbs[i].idStb);
                        }
                    }

                    $scope.range = false;
                    $scope.rangeIni = null;
                    $scope.rangeFin = null;
                }
            };

            $scope.selectAll = function (value) {
                if (value) {
                    $scope.group.stbs = $scope.allStbs.map(function (e) {
                        return e.idStb;
                    });
                } else {
                    $scope.group.stbs = [];
                }
            };
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gCajeros', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_gCajeros', {
            url: '/root/gCajeros',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/gCajeros/gCajeros.html',
                    controller: 'gCajerosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/gCajeros');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.gCajeros')
            .controller('gCajerosController', gCajerosController);

    /** @ngInject */
    function gCajerosController(quantionApi, $mdDialog, $mdToast, $rootScope, $scope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_CAJEROS';

        CargarCajeros();
        function CargarCajeros() {
            quantionApi.getAtm().then(function (dataResponse) {
                vm.listaCajeros = $filter('orderBy')(dataResponse.data, ['-version', 'model']);
            });
        }

        $scope.featureIcons = {
            "InzRfid": {icon: "icon-account-location", text: "GCAJEROS.FEATURES.RFID"},
            "InzCard": {icon: "icon-credit-card", text: "GCAJEROS.FEATURES.TARJETA"},
            "InzCash": {icon: "icon-coin", text: "GCAJEROS.FEATURES.EFECTIVO"},
            "InzRc": {icon: "icon-remote", text: "GCAJEROS.FEATURES.MANDOS"},
            "SpecialCard": {icon: 'icon-star-outline', text: "GCAJEROS.FEATURES.SPECIALCARD"}
        };

        vm.eliminarCajero = function (ev, cajero) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('GCAJEROS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('GCAJEROS.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('GCAJEROS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('GCAJEROS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteAtm(cajero.idAtm).then(function (dataResponse) {
                    CargarCajeros();

                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GCAJEROS.TOASTELIMINAR')).position('top right').hideDelay(5000));
                }, function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title($filter('translate')('GCAJEROS.ERRORELIMINAR.TITLE'))
                            .textContent($filter('translate')('GCAJEROS.ERRORELIMINAR.CONTENT'))
                            .ariaLabel('Error eliminar cajero')
                            .ok($filter('translate')('GCAJEROS.ERRORELIMINAR.OK'))
                            );
                });
            });
        };

        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/gCajeros/templates/crearcajero.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    tipo: 'Nuevo',
                    cajero: null
                }
            });
        };

        vm.ventanaEditar = function (ev, cajero) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/gCajeros/templates/crearcajero.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    tipo: 'Editar',
                    cajero: cajero
                }
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast, tipo, cajero) {
            if (tipo === 'Editar') {
                $scope.windowTitle = $filter('translate')('GCAJEROS.MODALEDITAR.TITLEEDITAR');
                $scope.cajero = angular.copy(cajero);
            } else {
                $scope.windowTitle = $filter('translate')('GCAJEROS.MODALEDITAR.TITLENUEVO');
                $scope.cajero = {
                    features: [],
                    chats: []
                };
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var copy = angular.copy($scope.cajero);
                delete copy.config;
                var jsonObj = angular.toJson(copy, 0);

                if (tipo === 'Nuevo') {
                    quantionApi.addAtm(jsonObj).then(function (dataResponse) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('GCAJEROS.TOASTCREAR'))
                                .position('top right')
                                .hideDelay(5000)
                                );

                        CargarCajeros();
                        $scope.hide();
                    }, function (dataResponse) {
                        console.error(dataResponse);
                    });
                } else {
                    quantionApi.updateAtm(jsonObj).then(function (dataResponse) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('GCAJEROS.TOASTEDITAR'))
                                .position('top right')
                                .hideDelay(5000)
                                );

                        CargarCajeros();
                        $scope.hide();
                    }, function (dataResponse) {
                        console.error(dataResponse);
                    });
                }
            };
        }

        vm.registryAtm = function () {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('GCAJEROS.MODALSINCRO.TITLE'))
                    .textContent($filter('translate')('GCAJEROS.MODALSINCRO.CONTENT'))
                    .ok($filter('translate')('GCAJEROS.MODALSINCRO.OK'))
                    .cancel($filter('translate')('GCAJEROS.MODALSINCRO.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.registryAtm().then(function (dataResponse) {});
            });
        };

        vm.verArqueos = function (ev, cajero) {
            $mdDialog.show({
                controller: ArqueosCtrl,
                templateUrl: 'app/main/Quantion/root/gCajeros/templates/arqueos.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function ArqueosCtrl($scope, $mdDialog, cajero) {
            $scope.data = cajero.arqueoInzacard;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }

        vm.verMandos = function (ev, cajero) {
            $mdDialog.show({
                controller: MandosCtrl,
                templateUrl: 'app/main/Quantion/root/gCajeros/templates/mandos.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function MandosCtrl($scope, $mdDialog, cajero) {
            $scope.data = cajero.mandosRegistrados;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }

        vm.verCupones = function (ev, cajero) {
            $mdDialog.show({
                controller: CuponesCtrl,
                templateUrl: 'app/main/Quantion/root/gCajeros/templates/cupones.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    cajero: cajero
                }
            });
        };

        function CuponesCtrl($scope, $mdDialog, cajero) {
            $scope.data = cajero.cuponNoUsado;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.encuestas', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_encuestas', {
            url: '/root/encuestas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/encuestas/encuestas.html',
                    controller: 'encuestasController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/encuestas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.encuestas')
            .controller('encuestasController', encuestasController);

    /** @ngInject */
    function encuestasController(quantionApi, $mdDialog, $mdToast, $scope, $filter, JSONconfig, $rootScope, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_ENCUESTAS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();


        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        function CargarEncuestas() {
            pantallaCarga.lsEnable('LS.ENCUESTAS');
            $scope.langFilter = "";

            quantionApi.getSurveys().then(function (dataResponse) {
                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();

                vm.listaEncuestas = dataResponse.data;
//                console.log(vm.listaEncuestas);
            });
        }
        CargarEncuestas();

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.listaIdiomas = dataResponse.data;
        });

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;
            vm.mapStbs = {};

            $.each(dataResponse.data, function (index, value) {
                vm.mapStbs[value.idStb] = value;
            });
//            console.log(vm.mapStbs);
        });

        quantionApi.getQuestions().then(function (dataResponse) {
            vm.listaQuestions = dataResponse.data;
            vm.mapQuestions = {};

            $.each(dataResponse.data, function (index, value) {
                vm.mapQuestions[value.idQuestion] = value;
            });
//            console.log(vm.mapQuestions);
        });

        vm.eliminarEncuesta = function (ev, encuesta) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('encuestas.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('encuestas.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('encuestas.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('encuestas.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteSurvey(encuesta.idSurvey).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('encuestas.MODALELIMINAR.TOASTELIMINAR')).position('top right').hideDelay(3000));
                    CargarEncuestas();
                }, function () {
                    console.error('No se puede eliminar la encuesta');
                });
            });
        };

        vm.nuevaEncuesta = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/root/encuestas/templates/creareditarencuesta.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = "Crear nueva encuesta";
            $scope.tipo = 'Nuevo';
            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.survey = {
                name: '',
                img: '',
                lang: '',
                questions: []
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.survey);
//                console.log(jsonObj);

                quantionApi.addSurvey(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('encuestas.TOASTCREAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                    CargarEncuestas();
                });
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/root/encuestas/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        survey: $scope.survey
                    }
                });
            };
        }

        vm.editarEncuesta = function (ev, encuesta) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/root/encuestas/templates/creareditarencuesta.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"enc": encuesta}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, enc) {
            $scope.DialogTitle = "Editar encuesta";
            $scope.tipo = 'Editar';
            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.survey = angular.copy(enc);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.survey, true);
                console.log(jsonObj);

                quantionApi.updateSurvey(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('encuestas.TOASTEDITAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                    CargarEncuestas();
                });
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/root/encuestas/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        survey: $scope.survey
                    }
                });
            };
        }

        function ElegirImgCtrl($scope, $mdDialog, survey) {

            $scope.escogerImagen = function (img) {
                survey.img = img;
                $scope.hide();
            };
            $scope.hide = function () {
                $mdDialog.hide();
            };

            CargarImagenesEncuestas();
            function CargarImagenesEncuestas() {
                quantionApi.getGenericFiles(FilePaths.encuestas).then(function (dataResponse) {
                    $scope.listaImagenes = dataResponse.data.files;
                }, function () {
                    $scope.listaImagenes = [];
                });
            }

            function cargarArchivo(evt) {
                var files = evt.target.files;
                var file = files[0];
                if (!file)
                    return;

                var formData = new FormData();
                formData.append('file', file);

                quantionApi.uploadGenericFile(formData, file.name, FilePaths.encuestas).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTSUBIDA')).position('top right').hideDelay(3000));
                    CargarImagenesEncuestas();
                });
            }

            var flag = false;
            $scope.upload = function () {
                if (!flag) {
                    document.getElementById('uploadFile').addEventListener('change', cargarArchivo, false);
                    flag = true;
                }
                $('#uploadFile').click();
            };
        }

        vm.verPreguntas = function (ev, encuesta) {
            $mdDialog.show({
                controller: ListaPreguntasCtrl,
                templateUrl: 'app/main/Quantion/root/encuestas/templates/preguntas.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"encuesta": encuesta}
            });
        };

        function ListaPreguntasCtrl($scope, $mdDialog, encuesta) {
            $scope.survey = angular.copy(encuesta);

            $scope.tiposPregunta = [
                {key: 'Normal', text: 'Una respuesta'},
                {key: 'Multi', text: 'Multi-respuesta'},
                {key: 'Icons', text: 'Emoticonos'},
                {key: 'Input', text: 'Campo de texto'}
            ];

            if (!vm.listaServicios) {
                quantionApi.getServicios().then(function (dataResponse) {
                    vm.listaServicios = dataResponse.data;
                    $scope.listaServicios = vm.listaServicios;
                });
            } else {
                $scope.listaServicios = vm.listaServicios;
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.survey, true);
//                console.log(jsonObj);

                quantionApi.updateSurvey(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('encuestas.TOASTEDITAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                    CargarEncuestas();
                });
            };

            $scope.selectQuestion = function (question, $index) {
                $scope.questionSelected = question;
                $scope.indexSelected = $index;
            };

            if ($scope.survey.questions[0])
                $scope.selectQuestion($scope.survey.questions[0], 0);

            $scope.addQuestion = function () {
                $scope.survey.questions.push({
                    "question": "",
                    "responses": [],
                    "type": $scope.tiposPregunta[0].key,
                    "description": "",
                    "img": "",
                    "modal": null,
                    "idService": 0
                });

                $scope.selectQuestion($scope.survey.questions[$scope.survey.questions.length - 1], $scope.survey.questions.length - 1);
            };

            $scope.deleteQuestion = function (index) {
                $scope.survey.questions.splice(index, 1);

                if ($scope.indexSelected === index)
                    $scope.selectQuestion($scope.survey.questions[0], 0);
            };

            $scope.addResponse = function (question) {
                question.responses.push('');
            };

            $scope.deleteResponse = function (question, index) {
                question.responses.splice(index, 1);
            };

            $scope.elegirImagen = function (ev, question) {
                $mdDialog.show({
                    controller: ElegirImgCtrl2,
                    templateUrl: 'app/main/Quantion/root/encuestas/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        question: question
                    }
                });
            };

            function ElegirImgCtrl2($scope, $mdDialog, question) {

                $scope.escogerImagen = function (img) {
                    question.img = img;
                    $scope.hide();
                };
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                CargarImagenesEncuestas();
                function CargarImagenesEncuestas() {
                    quantionApi.getGenericFiles(FilePaths.encuestas).then(function (dataResponse) {
                        $scope.listaImagenes = dataResponse.data.files;
                    }, function () {
                        $scope.listaImagenes = [];
                    });
                }

                function cargarArchivo(evt) {
                    var files = evt.target.files;
                    var file = files[0];
                    if (!file)
                        return;

                    var formData = new FormData();
                    formData.append('file', file);

                    quantionApi.uploadGenericFile(formData, file.name, FilePaths.encuestas).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarImagenesEncuestas();
                    });
                }

                var flag = false;
                $scope.upload = function () {
                    if (!flag) {
                        document.getElementById('uploadFile').addEventListener('change', cargarArchivo, false);
                        flag = true;
                    }
                    $('#uploadFile').click();
                };
            }
        }

        vm.verRespuestas = function (ev, encuesta) {
            $mdDialog.show({
                controller: ListaRespuestasCtrl,
                templateUrl: 'app/main/Quantion/root/encuestas/templates/respuestas.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"encuesta": encuesta}
            });
        };

        function ListaRespuestasCtrl($scope, $mdDialog, encuesta) {
            $scope.survey = angular.copy(encuesta);
            $scope.listaStbs = vm.mapStbs;
            $scope.listaQuestions = vm.mapQuestions;

            if (!vm.listaRespuestas)
                vm.listaRespuestas = {};

            if (vm.listaRespuestas[encuesta.idSurvey]) {
                $scope.listaRespuestas = vm.listaRespuestas[encuesta.idSurvey];
            } else {
                quantionApi.getResponses(encuesta.idSurvey).then(function (dataResponse) {
                    vm.listaRespuestas[encuesta.idSurvey] = dataResponse.data;
                    vm.listaRespuestas[encuesta.idSurvey].reverse();
                    $scope.listaRespuestas = vm.listaRespuestas[encuesta.idSurvey];
                });
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        vm.verEstadisticasRespuestas = function (ev, encuesta) {
            $mdDialog.show({
                controller: EstadisticasRespuestasCtrl,
                templateUrl: 'app/main/Quantion/root/encuestas/templates/estadisticas.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"encuesta": encuesta}
            });
        };

        function EstadisticasRespuestasCtrl($scope, $mdDialog, encuesta) {
            $scope.survey = angular.copy(encuesta);
            $scope.listaQuestions = vm.mapQuestions;

            if (!vm.listaRespuestas)
                vm.listaRespuestas = {};

            if (vm.listaRespuestas[encuesta.idSurvey]) {
                $scope.listaRespuestas = vm.listaRespuestas[encuesta.idSurvey];
                processData();
            } else {
                quantionApi.getResponses(encuesta.idSurvey).then(function (dataResponse) {
                    vm.listaRespuestas[encuesta.idSurvey] = dataResponse.data;
                    vm.listaRespuestas[encuesta.idSurvey].reverse();
                    $scope.listaRespuestas = vm.listaRespuestas[encuesta.idSurvey];
                    processData();
                });
            }

            function processData() {
                var o = {};

                $.each($scope.listaRespuestas, function (index, envio) {
                    $.each(envio.responses, function (index2, pregunta) {
                        if (!o[pregunta.idQuestion])
                            o[pregunta.idQuestion] = {keys: {}, data: [], total: 0};

                        $.each(pregunta.response, function (index3, respuesta) {
                            if (!o[pregunta.idQuestion].keys[respuesta])
                                o[pregunta.idQuestion].keys[respuesta] = 0;
                            o[pregunta.idQuestion].keys[respuesta]++;
                            o[pregunta.idQuestion].total++;
                        });
                    });
                });

                $.each(o, function (key, value) {
                    $.each(value.keys, function (key2, value2) {
                        value.data.push({
                            key: key2,
                            y: value2,
                            percent: (100 * value2 / value.total)
                        });
                    });

                });

                $scope.o = o;
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.colorList = [
                "#ffe1ff",
                "#ee0000",
                "#ffb90f",
                "#3a5fcd",
                "#ee9572",
                "#8b8b83",
                "#54ff9f",
                "#00868b",
                "#ffffe0",
                "#ffe7ba"
            ];
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.Quantion.root.dhcpEquipos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.Quantion_root_dhcpEquipos', {
            url  : '/root/dhcpEquipos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/dhcpEquipos/dhcpEquipos.html',
                    controller : 'dhcpEquiposController as vm'
                }
            },
            data: {
                authorization: true
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.dhcpEquipos')
            .controller('dhcpEquiposController', dhcpEquiposController);

    /** @ngInject */
    function dhcpEquiposController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_DHCP';

        quantionApi.getDhcpEquipos().then(function (dataResponse) {
            vm.fileContent = dataResponse.data;
        });

        vm.guardar = function () {
            quantionApi.updateDhcpEquipos().then(function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('CVERSIONES.TOASTDHCP'))
                        .position('top right')
                        .hideDelay(5000)
                        );
            });
        };
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.cversiones', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_cversiones', {
            url: '/root/cversiones',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/cversiones/cversiones.html',
                    controller: 'cversionesController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/cversiones');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.cversiones')
            .controller('cversionesController', cversionesController);

    /** @ngInject */
    function cversionesController(quantionApi, $mdDialog, $mdToast, $scope, JSONconfig, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_VERSIONES';

        var baseUrl = JSONconfig.Protocol + JSONconfig.BaseUrl + JSONconfig.APIPort;

        vm.fileOptions = {
            file: null,
            fileName: '',
            fileType: 'dynamic',
            fileMD5: '',
            isUploading: false,
            overwrite: false,
            uploadProgress: {
                total: '',
                current: '',
                percent: ''
            }
        };

        vm.fileLists = {};

        vm.fileIcons = {
            dynamic: "/assets/quantionImagenes/DYNAMIC.svg",
            system: "/assets/quantionImagenes/SYSTEM.svg",
            bios: "/assets/quantionImagenes/BIOS.svg"
        };

        function getFiles(type) {
            quantionApi.getFiles(type).then(function (dataResponse) {
                vm.fileLists[type] = dataResponse.data;
            });
        }

        getFiles('dynamic');
//        getFiles('system');
        getFiles('bios');

        document.getElementById('files').addEventListener('change', readFile, false);

        function readFile(evt) {
            var files = evt.target.files;
            vm.fileOptions.file = files[0];
            vm.fileOptions.fileName = vm.fileOptions.file.name;
        }

        vm.uploadFile = function () {
            var formData = new FormData();
            formData.append('file', vm.fileOptions.file);

            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                //************** readyState ********************              
                //0: request not initialized
                //1: server connection established
                //2: request received
                //3: processing request
                //4: request finished and response is ready
                //**********************************************
                if (request.readyState === 4) {

                    if (request.status >= 200 && request.status < 400) {//Correcto
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CVERSIONES.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        getFiles(vm.fileOptions.fileType);
                        console.log('Enviado ' + vm.fileOptions.fileName);
                    } else

                    if (request.status === 400) {//Error por fallo en MD5 u otro dato
                        $scope.md5Wrong = true;
                    }

//                    if (request.status > 400) {//Otro error
                    else {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CVERSIONES.ERRORMIRARCONSOLA')).position('top right').hideDelay(3000));
                        console.log(request);
                    }

                    vm.fileOptions.isUploading = false;
                }
            };

            console.log('Enviando...');
            vm.fileOptions.isUploading = true;
            var requestUrl = baseUrl
                    + '/Solertia/files/image?type=' + vm.fileOptions.fileType
                    + '&fileName=' + vm.fileOptions.fileName
                    + '&md5=' + vm.fileOptions.fileMD5;

            if (vm.fileOptions.fileSHA1)
                requestUrl += ('&sha1=' + vm.fileOptions.fileSHA1);
            if (vm.fileOptions.fileSHA256)
                requestUrl += ('&sha256=' + vm.fileOptions.fileSHA256);
            if (vm.fileOptions.changelog)
                requestUrl += ('&changelog=' + vm.fileOptions.changelog);
            if (vm.fileOptions.overwrite)
                requestUrl += ('&overwrite=true');

            request.open('POST', requestUrl, true);//True: Asíncrono (ejecuta onreadystatechange), False: Síncrono (no ejecuta onreadystatechange)
            request.upload.onprogress = function (pe) {
                if (pe.lengthComputable) {
                    vm.fileOptions.uploadProgress.total = formatBytes(pe.total);
                    vm.fileOptions.uploadProgress.current = formatBytes(pe.loaded);
                    vm.fileOptions.uploadProgress.percent = (pe.loaded / pe.total) * 100;
                }
            };
            request.send(formData);
        };

        function formatBytes(bytes, decimals) {//Pasa bytes a otros formatos
            if (bytes === 0)
                return '0 Byte';
            var k = 1000;
            var dm = decimals + 1 || 3;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        $scope.checkExistent = function () {
            $scope.fileNameExistent = (vm.fileLists[vm.fileOptions.fileType].indexOf(vm.fileOptions.fileName) !== -1);
        };

        $scope.hideMD5message = function () {
            $scope.md5Wrong = false;
        };

        $scope.deleteFile = function (id) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('CVERSIONES.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('CVERSIONES.MODALELIMINAR.CONTENT'))
                    .ariaLabel('Eliminar archivo')
                    .ok($filter('translate')('CVERSIONES.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('CVERSIONES.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteFiles(id).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('CVERSIONES.MODALELIMINAR.TOAST')).position('top right').hideDelay(3000));

                    getFiles('dynamic');
                    getFiles('system');
                    getFiles('bios');
                }, function (dataResponse) {
                    if (dataResponse.status == 424) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CVERSIONES.MODALELIMINAR.TOASTERROR424')).position('top right').hideDelay(3000));

                        var confirm = $mdDialog.confirm()
                                .title($filter('translate')('CVERSIONES.MODALELIMINARFORCE.TOASTERROR424'))
                                .textContent($filter('translate')('CVERSIONES.MODALELIMINARFORCE.CONTENT'))
                                .ariaLabel('Eliminar archivo')
                                .ok($filter('translate')('CVERSIONES.MODALELIMINARFORCE.OK'))
                                .cancel($filter('translate')('CVERSIONES.MODALELIMINARFORCE.CANCEL'));

                        $mdDialog.show(confirm).then(function () {
                            quantionApi.deleteFiles(id, true).then(function (dataResponse) {
                                $mdToast.show($mdToast.simple().textContent($filter('translate')('CVERSIONES.MODALELIMINARFORCE.TOAST')).position('top right').hideDelay(3000));

                                getFiles('dynamic');
                                getFiles('system');
                                getFiles('bios');
                            }, function (dataResponse) {
                                if (dataResponse.status == 424)
                                    $mdToast.show($mdToast.simple().textContent($filter('translate')('CVERSIONES.MODALELIMINARFORCE.TOASTERROR424')).position('top right').hideDelay(3000));
                            });
                        });
                    }
                });
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.controls', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_root_controls', {
            url: '/root/controls',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/root/controls/controls.html',
                    controller: 'controlsController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/root/controls');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.root.controls')
            .controller('controlsController', controlsController);

    /** @ngInject */
    function controlsController(quantionApi, $mdToast, $scope, $rootScope, $filter, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_CONTROLS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        function CargarControls() {
            pantallaCarga.lsEnable('LS.GENERIC');

            quantionApi.getControls().then(function (dataResponse) {
                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();
                vm.listaControls = dataResponse.data;
            });
        }
        CargarControls();

        $scope.addControl = function () {
            $mdDialog.show({
                controller: AddCtrl,
                templateUrl: 'app/main/Quantion/root/controls/templates/edit.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function AddCtrl($scope, $mdDialog, $mdToast) {
            $scope.control = {
                model: "",
                keyboardkeys: []
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.addRow = function () {
                $scope.control.keyboardkeys.push({key1: "", key2: ""});
            };

            $scope.deleteRow = function (index) {
                $scope.control.keyboardkeys.splice(index, 1);
            };

            $scope.keyUp = function (e, index) {
                if (index >= $scope.control.keyboardkeys.length - 1 && e.keyCode === 13)
                    $scope.addRow();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = angular.copy($scope.control);
                var r = {};
                $.each($scope.control.keyboardkeys, function (index, value) {
                    if (value.key1)
                        r[value.key1] = value.key2;
                });
                copy.keyboardkeys = r;

                var jsonObj = angular.toJson(copy);

                quantionApi.addControl(jsonObj).then(function () {
                    $scope.dataLoading = false;
                    $mdDialog.hide();
                    CargarControls();
                });
            };
        }

        $scope.editControl = function (control) {
            $mdDialog.show({
                controller: EditCtrl,
                templateUrl: 'app/main/Quantion/root/controls/templates/edit.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {control: control}
            });
        };

        function EditCtrl($scope, $mdDialog, $mdToast, control) {
            $scope.control = angular.copy(control);

            var o = [];
            $.each($scope.control.keyboardkeys, function (key, value) {
                o.push({key1: key, key2: value});
            });
            $scope.control.keyboardkeys = o;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.addRow = function () {
                $scope.control.keyboardkeys.push({key1: "", key2: ""});
            };

            $scope.deleteRow = function (index) {
                $scope.control.keyboardkeys.splice(index, 1);
            };

            $scope.keyUp = function (e, index) {
                if (index >= $scope.control.keyboardkeys.length - 1 && e.keyCode === 13)
                    $scope.addRow();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var copy = angular.copy($scope.control);
                var r = {};
                $.each($scope.control.keyboardkeys, function (index, value) {
                    if (value.key1)
                        r[value.key1] = value.key2;
                });
                copy.keyboardkeys = r;

                var jsonObj = angular.toJson(copy);

                quantionApi.updateControl(jsonObj).then(function () {
                    $scope.dataLoading = false;
                    $mdDialog.hide();
                    CargarControls();
                });
            };
        }

        $scope.deleteControl = function (control) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('CONTROLS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('ELIMINAR.CONTENT'))
                    .ok($filter('translate')('ELIMINAR.OK'))
                    .cancel($filter('translate')('ELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('');

                quantionApi.deleteControl(control.idControl).then(function (dataResponse) {
                    pantallaCarga.lsDisable();
                    CargarControls();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al eliminar').action('OK').highlightAction(false).position('top right'));
                    pantallaCarga.lsDisable();
                });
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.tasks.servidor', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {        
        $stateProvider.state('app.Quantion_tasks_servidor', {
            url: '/tasks/servidor',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/tasks/servidor/tasks.html',
                    controller: 'tasksServidorController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/tasks/servidor');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.tasks.servidor')
            .controller('tasksServidorController', tasksServidorController);

    /** @ngInject */
    function tasksServidorController(quantionApi, $mdDialog, $state, $scope, $filter, $translate, $rootScope)
    {
        'use strict';
        var vm = this;
        $rootScope.seccion = 'TASKS_SERVIDOR';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.typeSelected = 'programmed';
        vm.taskProgrammedNum = 1;
        vm.taskNum = 1;
        vm.templateTaskNum = 1;
        $scope.selectType = function (type) {
            $scope.typeSelected = type;
            vm.taskProgrammedNum = 1;
            vm.taskNum = 1;
            vm.templateTaskNum = 1;
            CargarTasks($scope.typeSelected);
        };

        CargarTasks($scope.typeSelected);
        function CargarTasks(_type, _page) {
            var type = _type || $scope.typeSelected;

            if (type === 'programmed') {
                pantallaCarga.lsEnable('LS.TASKS');
                var page = _page || vm.taskProgrammedNum || 1;

                quantionApi.getTasksPaginated({type: 'taskProgrammed', page: page}).then(function (dataResponse) {
                    vm.tasksProgrammed = {
                        'finalizados': [],
                        'encurso': [],
                        'pendientes': []
                    };

                    var now = new Date();
                    $.each(dataResponse.data, function (index, value) {
                        try {
                            value.header = JSON.parse(value.header);
                        } catch (e) {
                            console.error(e);
                        }

                        if (value.fFin > now && value.fIni < now) {
                            vm.tasksProgrammed.encurso.push(value);
                        } else if (value.fFin < now) {
                            vm.tasksProgrammed.finalizados.push(value);
                        } else if (value.fIni > now) {
                            vm.tasksProgrammed.pendientes.push(value);
                        }
                    });

                    pantallaCarga.lsDisable();
                });

                quantionApi.countTasksPaginated({type: 'taskProgrammed'}).then(function (dataResponse) {
                    vm.taskProgrammedPages = [1];
                    for (var i = 2; i <= dataResponse.data; i++) {
                        vm.taskProgrammedPages.push(i);
                    }
                });
            }

            if (type === 'inmediate') {
                pantallaCarga.lsEnable('LS.TASKS');
                var page = _page || vm.taskNum || 1;

                quantionApi.getTasksPaginated({type: 'task', page: page}).then(function (dataResponse) {
                    vm.tasks = dataResponse.data;

                    $.each(vm.tasks, function (index, value) {
                        try {
                            value.header = JSON.parse(value.header);
                        } catch (e) {
                            console.error(e);
                        }
                    });

                    pantallaCarga.lsDisable();
                });

                quantionApi.countTasksPaginated({type: 'task'}).then(function (dataResponse) {
                    vm.taskPages = [1];
                    for (var i = 2; i <= dataResponse.data; i++) {
                        vm.taskPages.push(i);
                    }
                });
            }

            if (type === 'template') {
                pantallaCarga.lsEnable('LS.TASKS');
                var page = _page || vm.templateTaskNum || 1;

                quantionApi.getTasksPaginated({type: 'templateTask', page: page}).then(function (dataResponse) {
                    vm.templates = dataResponse.data;

                    $.each(vm.templates, function (index, value) {
                        try {
                            value.header = JSON.parse(value.header);
                        } catch (e) {
                            console.error(e);
                        }
                    });

                    pantallaCarga.lsDisable();
                });

                quantionApi.countTasksPaginated({type: 'templateTask'}).then(function (dataResponse) {
                    vm.templateTaskPages = [1];
                    for (var i = 2; i <= dataResponse.data; i++) {
                        vm.templateTaskPages.push(i);
                    }
                });
            }
        }
        $scope.CargarTasks = CargarTasks;

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;

            vm.mapStbs = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbs[value.idStb] = value;
            });

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = elm.stbs.map(function (elm2) {
                        return vm.mapStbs[elm2];
                    });
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        //****************************** Detalles *******************************
        $scope.details = function (task) {
            $mdDialog.show({
                controller: DetailsCtrl,
                templateUrl: 'app/main/Quantion/tasks/servidor/templates/details.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {task: task}
            });
        };

        function DetailsCtrl($scope, $mdDialog, task, $filter) {
            $scope.task = angular.copy(task);

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Nueva tarea *******************
        $scope.addTask = function () {
            $mdDialog.show({
                controller: NewTaskCtrl,
                templateUrl: 'app/main/Quantion/tasks/servidor/templates/task.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewTaskCtrl($scope, $mdDialog, $filter) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.task = {
                command: "",
                type: 'task',
                header: {},
                arguments: {
                    taskroot: false,
                    cmdline: "",
                    args: []
                },
                displaytime: 10,
//                stbs: [],
                fIni: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                fFin: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm'))
            };

            $scope.argTypeList = [
                'text'
            ];

            $scope.addArgument = function () {
                $scope.task.arguments.args.push({
                    name: '',
                    type: 'text',
                    editable: true,
                    value: ''
                });
            };

            $scope.deleteArgument = function (index) {
                $scope.task.arguments.args.splice(index, 1);
            };

            $scope.enviarEvento = function () {
                var copy = angular.copy($scope.task);

                copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');

                copy.command = copy.arguments.cmdline;
                $.each(copy.arguments.args, function (i, v) {
                    copy.command += (' "' + v.value + '"');
                });

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTasks();
                    $mdDialog.hide();
                }, function () {

                });
            };

//            $scope.toggle = function (item, list) {
//                var idx = list.indexOf(item);
//                if (idx > -1) {
//                    list.splice(idx, 1);
//                } else {
//                    list.push(item);
//                }
//            };
//
//            $scope.exists = function (item, list) {
//                return list.indexOf(item) > -1;
//            };
//
//            $scope.marcarGrupo = function (grupo, bool) {
//                $.each(grupo.cStbs, function (index, value) {
//                    if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
//                        $scope.event.stbs.push(value.idStb);
//
//                    if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
//                        var idx = $scope.event.stbs.indexOf(value.idStb);
//                        $scope.event.stbs.splice(idx, 1);
//                    }
//                });
//            };
//
//            $scope.marcarTodo = function (bool) {
//                $.each($scope.listaGrupos, function (i, gr) {
//                    $.each(gr.cStbs, function (index, value) {
//                        value.seleccionado = bool;
//                    });
//                });
//            };
//
//            $scope.marcarStorage = function () {
//                if (!localStorage.marcados)
//                    return;
//
//                var obj = angular.fromJson(localStorage.marcados);
//
//                $.each($scope.listaGrupos, function (i, gr) {
//                    $.each(gr.cStbs, function (index, value) {
//                        value.seleccionado = obj[value.idStb];
//                    });
//                });
//            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Nueva plantilla *******************
        $scope.addTemplate = function () {
            $mdDialog.show({
                controller: NewTemplateCtrl,
                templateUrl: 'app/main/Quantion/tasks/servidor/templates/task-template.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewTemplateCtrl($scope, $mdDialog, $filter) {

            $scope.task = {
                command: "",
                type: 'templateTask',
                header: {},
                arguments: {
                    taskroot: false,
                    cmdline: "",
                    args: []
                },
                displaytime: 10
            };

            $scope.argTypeList = [
                'text'
            ];

            $scope.addArgument = function () {
                $scope.task.arguments.args.push({
                    name: '',
                    type: 'text',
                    editable: true,
                    value: ''
                });
            };

            $scope.deleteArgument = function (index) {
                $scope.task.arguments.args.splice(index, 1);
            };

            $scope.guardar = function () {
                var copy = angular.copy($scope.task);

                copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');

                copy.command = copy.arguments.cmdline;
                $.each(copy.arguments.args, function (i, v) {
                    copy.command += (' "' + v.value + '"');
                });

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTasks();
                    $mdDialog.hide();
                }, function () {

                });
            };

            $scope.previewCommand = function () {
                var result = $scope.task.arguments.cmdline;
                $.each($scope.task.arguments.args, function (i, v) {
                    result += (' "' + v.value + '"');
                });
                return result;
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Copiar tarea *******************
        vm.copyTask = function (task) {
            $mdDialog.show({
                controller: CopyTaskCtrl,
                templateUrl: 'app/main/Quantion/tasks/servidor/templates/task.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {task: task}
            });
        };

        function CopyTaskCtrl($scope, $mdDialog, $filter, task) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.task = angular.copy(task);

            if ($scope.task.fIni)
                $scope.task.fIni = new Date($scope.task.fIni);

            if ($scope.task.fFin)
                $scope.task.fFin = new Date($scope.task.fFin);

            if ($scope.task.rangeInit)
                $scope.task.rangeInit = new Date('01/01/1970 ' + $scope.task.rangeInit);

            if ($scope.task.rangeEnd)
                $scope.task.rangeEnd = new Date('01/01/1970 ' + $scope.task.rangeEnd);

            if ($scope.task.type === 'templateTask')
                $scope.task.type = null;

            $scope.argTypeList = [
                'text'
            ];

            $scope.addArgument = function () {
                $scope.task.arguments.args.push({
                    name: '',
                    type: 'text',
                    editable: true,
                    value: ''
                });
            };

            $scope.deleteArgument = function (index) {
                $scope.task.arguments.args.splice(index, 1);
            };

            $scope.enviarEvento = function () {
                var copy = angular.copy($scope.task);

                copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');

                copy.command = copy.arguments.cmdline;
                $.each(copy.arguments.args, function (i, v) {
                    copy.command += (' "' + v.value + '"');
                });

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                delete copy.idTask;

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTasks();
                    $mdDialog.hide();
                }, function () {

                });
            };

//            $scope.toggle = function (item, list) {
//                var idx = list.indexOf(item);
//                if (idx > -1) {
//                    list.splice(idx, 1);
//                } else {
//                    list.push(item);
//                }
//            };
//
//            $scope.exists = function (item, list) {
//                return list.indexOf(item) > -1;
//            };
//
//            $scope.marcarGrupo = function (grupo, bool) {
//                $.each(grupo.cStbs, function (index, value) {
//                    if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
//                        $scope.event.stbs.push(value.idStb);
//
//                    if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
//                        var idx = $scope.event.stbs.indexOf(value.idStb);
//                        $scope.event.stbs.splice(idx, 1);
//                    }
//                });
//            };
//
//            $scope.marcarTodo = function (bool) {
//                $.each($scope.listaGrupos, function (i, gr) {
//                    $.each(gr.cStbs, function (index, value) {
//                        value.seleccionado = bool;
//                    });
//                });
//            };
//
//            $scope.marcarStorage = function () {
//                if (!localStorage.marcados)
//                    return;
//
//                var obj = angular.fromJson(localStorage.marcados);
//
//                $.each($scope.listaGrupos, function (i, gr) {
//                    $.each(gr.cStbs, function (index, value) {
//                        value.seleccionado = obj[value.idStb];
//                    });
//                });
//            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        vm.eliminarTask = function (ev, id) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('TASKS.MODALELIMINAR.TITLE'))
                    .targetEvent(ev)
                    .ok($filter('translate')('TASKS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('TASKS.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteTask(id).then(function (dataResponse) {
                    CargarTasks();
                    pantallaCarga.lsDisable();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    pantallaCarga.lsDisable();
                });
            });
        };

        $scope.deleteAllTasks = function (type) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('TASKS.MODALELIMINAR.TITLE_ALT'))
                    .ok($filter('translate')('TASKS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('TASKS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteAllTasks(type).then(function (dataResponse) {
                    $scope.selectType($scope.typeSelected);
                    pantallaCarga.lsDisable();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    pantallaCarga.lsDisable();
                });
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.tasks.procesos', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {        
        $stateProvider.state('app.Quantion_tasks_procesos', {
            url: '/tasks/procesos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/tasks/procesos/procesos.html',
                    controller: 'procesosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/tasks/procesos');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.tasks.procesos')
            .controller('procesosController', procesosController);

    /** @ngInject */
    function procesosController(quantionApi, $mdDialog, $state, $scope, $filter, $translate, $rootScope)
    {
        'use strict';
        var vm = this;
        $rootScope.seccion = 'PROCESOS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        CargarTasks();
        function CargarTasks() {
            pantallaCarga.lsEnable('LS.GENERIC');

            quantionApi.getProcesos().then(function (dataResponse) {
                vm.procesos = dataResponse.data.map(function (e) {
                    e.fecha = new Date(e.fecha);
                    return e;
                });

                $scope.limit = 20;

                if (dataResponse.data.length < 1)
                    pantallaCarga.lsDisable();
            });
        }

        vm.eliminar = function (id) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('TASKS.MODALELIMINAR.TITLE'))
                    .ok($filter('translate')('TASKS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('TASKS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteProceso(id).then(function (dataResponse) {
                    CargarTasks();
                    pantallaCarga.lsDisable();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    pantallaCarga.lsDisable();
                });
            });
        };

        $scope.loadMore = function () {
            pantallaCarga.lsEnable('LS.GENERIC');
            $scope.limit += 20;
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.tasks.equipos', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {        
        $stateProvider.state('app.Quantion_tasks_equipos', {
            url: '/tasks/equipos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/tasks/equipos/tasks.html',
                    controller: 'tasksEquiposController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/tasks/equipos');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.tasks.equipos')
            .controller('tasksEquiposController', tasksEquiposController);

    /** @ngInject */
    function tasksEquiposController(quantionApi, $mdDialog, $state, $scope, $filter, $translate, $rootScope)
    {
        'use strict';
        var vm = this;
        $rootScope.seccion = 'TASKS_EQUIPOS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.typeSelected = 'programmed';
        vm.taskProgrammedNum = 1;
        vm.taskNum = 1;
        vm.templateTaskNum = 1;
        $scope.selectType = function (type) {
            $scope.typeSelected = type;
            vm.taskProgrammedNum = 1;
            vm.taskNum = 1;
            vm.templateTaskNum = 1;
            CargarTasks($scope.typeSelected);
        };

        CargarTasks($scope.typeSelected);
        function CargarTasks(_type, _page) {
            var type = _type || $scope.typeSelected;

            if (type === 'programmed') {
                pantallaCarga.lsEnable('LS.TASKS');
                var page = _page || vm.taskProgrammedNum || 1;

                quantionApi.getTasksPaginated({type: 'eventProgrammed', excludeCommands: ['notification'], page: page}).then(function (dataResponse) {
                    vm.tasksProgrammed = {
                        'finalizados': [],
                        'encurso': [],
                        'pendientes': []
                    };

                    var now = new Date();
                    $.each(dataResponse.data, function (index, value) {
//                    try {
//                        value.header = JSON.parse(value.header);
//                    } catch (e) {
//                        console.error(e);
//                    }

                        if (value.fFin > now && value.fIni < now) {
                            vm.tasksProgrammed.encurso.push(value);
                        } else if (value.fFin < now) {
                            vm.tasksProgrammed.finalizados.push(value);
                        } else if (value.fIni > now) {
                            vm.tasksProgrammed.pendientes.push(value);
                        }
                    });

                    pantallaCarga.lsDisable();
                });

                quantionApi.countTasksPaginated({type: 'eventProgrammed'}).then(function (dataResponse) {
                    vm.taskProgrammedPages = [1];
                    for (var i = 2; i <= dataResponse.data; i++) {
                        vm.taskProgrammedPages.push(i);
                    }
                });
            }

            if (type === 'inmediate') {
                pantallaCarga.lsEnable('LS.TASKS');
                var page = _page || vm.taskNum || 1;

                quantionApi.getTasksPaginated({type: 'event', excludeCommands: ['notification'], page: page}).then(function (dataResponse) {
                    vm.tasks = dataResponse.data;

//                $.each(vm.tasks, function (index, value) {
//                    try {
//                        value.header = JSON.parse(value.header);
//                    } catch (e) {
//                        console.error(e);
//                    }
//                });

                    pantallaCarga.lsDisable();
                });

                quantionApi.countTasksPaginated({type: 'event'}).then(function (dataResponse) {
                    vm.taskPages = [1];
                    for (var i = 2; i <= dataResponse.data; i++) {
                        vm.taskPages.push(i);
                    }
                });
            }

            if (type === 'template') {
                pantallaCarga.lsEnable('LS.TASKS');
                var page = _page || vm.templateTaskNum || 1;

                quantionApi.getTasksPaginated({type: 'templateEvent', excludeCommands: ['notification'], page: page}).then(function (dataResponse) {
                    vm.templates = dataResponse.data;

//                $.each(vm.templates, function (index, value) {
//                    try {
//                        value.header = JSON.parse(value.header);
//                    } catch (e) {
//                        console.error(e);
//                    }
//                });

                    pantallaCarga.lsDisable();
                });

                quantionApi.countTasksPaginated({type: 'templateEvent'}).then(function (dataResponse) {
                    vm.templateTaskPages = [1];
                    for (var i = 2; i <= dataResponse.data; i++) {
                        vm.templateTaskPages.push(i);
                    }
                });
            }
        }
        $scope.CargarTasks = CargarTasks;

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;

            vm.mapStbs = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbs[value.idStb] = value;
            });

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = elm.stbs.map(function (elm2) {
                        return vm.mapStbs[elm2];
                    });
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        //****************************** Detalles *******************************
        $scope.details = function (task) {
            $mdDialog.show({
                controller: DetailsCtrl,
                templateUrl: 'app/main/Quantion/tasks/equipos/templates/details.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {task: task}
            });
        };

        function DetailsCtrl($scope, $mdDialog, task, $filter) {
            $scope.task = angular.copy(task);

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Nueva tarea *******************
        $scope.addTask = function () {
            $mdDialog.show({
                controller: NewTaskCtrl,
                templateUrl: 'app/main/Quantion/tasks/equipos/templates/task.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewTaskCtrl($scope, $mdDialog, $filter) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.task = {
                command: "",
                type: 'event',
                header: "",
                arguments: {
                    taskroot: false,
                    cmdline: "",
                    args: []
                },
                displaytime: 10,
                stbs: [],
                fIni: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                fFin: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm'))
            };

            $scope.argTypeList = [
                'text'
            ];

            $scope.addArgument = function () {
                $scope.task.arguments.args.push({
                    name: '',
                    type: 'text',
                    editable: true,
                    value: ''
                });
            };

            $scope.deleteArgument = function (index) {
                $scope.task.arguments.args.splice(index, 1);
            };

            $scope.enviarEvento = function () {
                var copy = angular.copy($scope.task);

                copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');

                copy.command = copy.arguments.cmdline;
                $.each(copy.arguments.args, function (i, v) {
                    copy.command += (' "' + v.value + '"');
                });

//                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTasks();
                    $mdDialog.hide();
                }, function () {

                });
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.idStb, $scope.task.stbs))
                        $scope.task.stbs.push(value.idStb);

                    if (bool === false && $scope.exists(value.idStb, $scope.task.stbs)) {
                        var idx = $scope.task.stbs.indexOf(value.idStb);
                        $scope.task.stbs.splice(idx, 1);
                    }
                });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (bool === true && !$scope.exists(value.idStb, $scope.task.stbs))
                            $scope.task.stbs.push(value.idStb);

                        if (bool === false && $scope.exists(value.idStb, $scope.task.stbs)) {
                            var idx = $scope.task.stbs.indexOf(value.idStb);
                            $scope.task.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarStorage = function () {
                if (!localStorage.marcados)
                    return;

                var obj = angular.fromJson(localStorage.marcados);

                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
//                        value.seleccionado = obj[value.idStb];

                        if (obj[value.idStb] === true && !$scope.exists(value.idStb, $scope.task.stbs))
                            $scope.task.stbs.push(value.idStb);

                        if (obj[value.idStb] === false && $scope.exists(value.idStb, $scope.task.stbs)) {
                            var idx = $scope.task.stbs.indexOf(value.idStb);
                            $scope.task.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Nueva plantilla *******************
        $scope.addTemplate = function () {
            $mdDialog.show({
                controller: NewTemplateCtrl,
                templateUrl: 'app/main/Quantion/tasks/equipos/templates/task-template.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewTemplateCtrl($scope, $mdDialog, $filter) {

            $scope.task = {
                command: "",
                type: 'templateEvent',
                header: "",
                arguments: {
                    taskroot: false,
                    cmdline: "",
                    args: []
                },
                displaytime: 10
            };

            $scope.argTypeList = [
                'text'
            ];

            $scope.addArgument = function () {
                $scope.task.arguments.args.push({
                    name: '',
                    type: 'text',
                    editable: true,
                    value: ''
                });
            };

            $scope.deleteArgument = function (index) {
                $scope.task.arguments.args.splice(index, 1);
            };

            $scope.guardar = function () {
                var copy = angular.copy($scope.task);

                copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');

                copy.command = copy.arguments.cmdline;
                $.each(copy.arguments.args, function (i, v) {
                    copy.command += (' "' + v.value + '"');
                });

//                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTasks();
                    $mdDialog.hide();
                }, function () {

                });
            };

            $scope.previewCommand = function () {
                var result = $scope.task.arguments.cmdline;
                $.each($scope.task.arguments.args, function (i, v) {
                    result += (' "' + v.value + '"');
                });
                return result;
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Copiar tarea *******************
        vm.copyTask = function (task) {
            $mdDialog.show({
                controller: CopyTaskCtrl,
                templateUrl: 'app/main/Quantion/tasks/equipos/templates/task.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {task: task}
            });
        };

        function CopyTaskCtrl($scope, $mdDialog, $filter, task) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.task = angular.copy(task);

            if ($scope.task.fIni)
                $scope.task.fIni = new Date($scope.task.fIni);

            if ($scope.task.fFin)
                $scope.task.fFin = new Date($scope.task.fFin);

            if ($scope.task.rangeInit)
                $scope.task.rangeInit = new Date('01/01/1970 ' + $scope.task.rangeInit);

            if ($scope.task.rangeEnd)
                $scope.task.rangeEnd = new Date('01/01/1970 ' + $scope.task.rangeEnd);

            if ($scope.task.type === 'templateEvent')
                $scope.task.type = null;

            $scope.argTypeList = [
                'text'
            ];

            $scope.addArgument = function () {
                $scope.task.arguments.args.push({
                    name: '',
                    type: 'text',
                    editable: true,
                    value: ''
                });
            };

            $scope.deleteArgument = function (index) {
                $scope.task.arguments.args.splice(index, 1);
            };

            $scope.enviarEvento = function () {
                $scope.loading = true;
                var copy = angular.copy($scope.task);

                copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');

                copy.command = copy.arguments.cmdline;
                $.each(copy.arguments.args, function (i, v) {
                    copy.command += (' "' + v.value + '"');
                });

//                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                delete copy.idTask;

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTasks();
                    $mdDialog.hide();
                }, function () {
                    $scope.loading = false;
                });
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.idStb, $scope.task.stbs))
                        $scope.task.stbs.push(value.idStb);

                    if (bool === false && $scope.exists(value.idStb, $scope.task.stbs)) {
                        var idx = $scope.task.stbs.indexOf(value.idStb);
                        $scope.task.stbs.splice(idx, 1);
                    }
                });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (bool === true && !$scope.exists(value.idStb, $scope.task.stbs))
                            $scope.task.stbs.push(value.idStb);

                        if (bool === false && $scope.exists(value.idStb, $scope.task.stbs)) {
                            var idx = $scope.task.stbs.indexOf(value.idStb);
                            $scope.task.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarStorage = function () {
                if (!localStorage.marcados)
                    return;

                var obj = angular.fromJson(localStorage.marcados);

                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
//                        value.seleccionado = obj[value.idStb];

                        if (obj[value.idStb] === true && !$scope.exists(value.idStb, $scope.task.stbs))
                            $scope.task.stbs.push(value.idStb);

                        if (obj[value.idStb] === false && $scope.exists(value.idStb, $scope.task.stbs)) {
                            var idx = $scope.task.stbs.indexOf(value.idStb);
                            $scope.task.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        vm.eliminarTask = function (ev, id) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('TASKS.MODALELIMINAR.TITLE'))
                    .targetEvent(ev)
                    .ok($filter('translate')('TASKS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('TASKS.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteTask(id).then(function (dataResponse) {
                    CargarTasks();
                    pantallaCarga.lsDisable();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    pantallaCarga.lsDisable();
                });
            });
        };

        $scope.deleteAllTasks = function (type) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('TASKS.MODALELIMINAR.TITLE_ALT'))
                    .ok($filter('translate')('TASKS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('TASKS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteAllTasks(type).then(function (dataResponse) {
                    $scope.selectType($scope.typeSelected);
                    pantallaCarga.lsDisable();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    pantallaCarga.lsDisable();
                });
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.lotes', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_lotes', {
            url: '/lotes',
            views: {
                'content@app': {
//                    templateUrl: 'app/main/Quantion/lotes/lotes.html',
                    templateUrl: 'app/main/Quantion/lotes/new/lotes.html',
//                    controller: 'lotesController as vm',
                    controller: 'lotesController2 as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/lotes');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.lotes')
            .controller('lotesController2', lotesController);

    /** @ngInject */
    function lotesController(quantionApi, $mdToast, $scope, $mdDialog, $rootScope, $filter, $compile, $timeout)
    {
        var vm = this;
        $rootScope.seccion = 'LOTES';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        pantallaCarga.lsEnable('LS.DATOSVOIP');
        $scope.$on('onRepeatLast', function () {
            pantallaCarga.lsDisable();
        });

        initWizard();
        function initWizard() {
            vm.action = '';
            vm.secondaryAction = '';
            CargarStbs();

            vm.launchOpt = {};
        }

        function CargarStbs() {
            $scope.listaGrupos = [];
            quantionApi.getStbs().then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;
                var map = {};
                $.each(vm.listaStbs, function (index, stb) {
                    map[stb.idStb] = stb;
                });
                vm.mapStbs = map;

                quantionApi.getGrupos().then(function (dataResponse) {
                    $scope.listaGrupos = dataResponse.data.map(function (elm) {
                        elm.cStbs = elm.stbs.map(function (elm2) {
                            return map[elm2];
                        });
                        return elm;
                    });
                    $scope.listaGrupos.sort(function (a, b) {
                        return a.orden - b.orden;
                    });
                });
            });
        }

        $scope.stbFilter = {};

        quantionApi.getModelos().then(function (dataResponse) {
            vm.listaModelos = $filter('orderBy')(dataResponse.data, 'name');
        });

        quantionApi.getInstalaciones(true).then(function (dataResponse) {
            vm.listaInstalaciones = dataResponse.data;
        });

        quantionApi.getInstalacionThemes().then(function (dataResponse) {
            vm.listaThemes = dataResponse.data;
        });

        quantionApi.getAcls().then(function (dataResponse) {
            vm.listaAcls = $filter('orderBy')(dataResponse.data);
            vm.selectedAcl = null;
            vm.aclIsNull = false;

            $scope.querySearch = function (query) {
                return query ? vm.listaAcls.filter(createFilterFor(query)) : vm.listaAcls;
            };

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);

                return function (acl) {
                    return (angular.lowercase(acl.indexOf(lowercaseQuery) !== -1));
                };
            }
        });

        $scope.selected = [];
        $scope.patchAttr = [];
        $scope.patchObj = {};

        $scope.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1)
                list.splice(idx, 1);
            else
                list.push(item);
            refresh();
        };

        $scope.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        $scope.marcarGrupo = function (grupo, bool) {
            $.each(grupo.stbs, function (index, value) {
                var idx = $scope.selected.indexOf(value);
                if (idx > -1 && !bool)
                    $scope.selected.splice(idx, 1);

                if (idx === -1 && bool)
                    $scope.selected.push(value);
            });
            refresh();
        };

        $scope.marcarTodo = function (bool) {
            if (bool)
                $scope.selected = vm.listaStbs.map(function (e) {
                    return e.idStb;
                });
            else
                $scope.selected = [];
            refresh();
        };

        $scope.marcarStorage = function () {
            if (!localStorage.marcados)
                return;

            var obj = angular.fromJson(localStorage.marcados);
            $scope.selected = (Object.keys(obj)).filter(function (e) {
                return obj[e];
            }).map(function (e) {
                return parseInt(e);
            });
            refresh();
        };

        function refresh() {
            var stbs = vm.listaStbs.filter(function (stb) {
                return $scope.selected.includes(stb.idStb);
            });

            var models = stbs.map(function (s) {
                return s.model.identifier;
            }).filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });

            var modelsFiltered = vm.listaModelos.filter(function (model) {
                return models.includes(model.idStbModel);
            }).map(function (model) {
                return model.dynamicList.completeList;
            });

            modelsFiltered.sort(function (a, b) {
                return a.length - b.length;
            });

            $scope.dynamicIntersectionList = modelsFiltered.length > 0
                    ? modelsFiltered.shift().reduce(function (res, v) {
                if (res.map(function (_) {
                    return _.idItemVersion;
                }).indexOf(v.idItemVersion) === -1 && modelsFiltered.every(function (a) {
                    return a.map(function (_) {
                        return _.idItemVersion;
                    }).indexOf(v.idItemVersion) !== -1;
                }))
                    res.push(v);
                return res;
            }, [])
                    : [];
        }

        $scope.enviar = function (msWizard) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('LOTES.CONFIRMACION.TITLE'))
                    .clickOutsideToClose(true)
                    .ok($filter('translate')('LOTES.CONFIRMACION.OK'))
                    .cancel($filter('translate')('LOTES.CONFIRMACION.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                enviar(msWizard);
            }, function () {

            });
        };

        function enviar(msWizard) {
            $scope.msWizard = msWizard;

            var list = angular.copy($scope.selected);

            var obj = vm.secondaryAction;

            if (list.length > 0) {
                vm.yaEnviado = true;
                $scope.cargando = true;

                switch (vm.action) {
                    case 'rebootLote':
                        quantionApi.rebootLote(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.REINICIOENVIADO'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'serviceRebootLote':
                        quantionApi.serviceRebootLote(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.RECARGAENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'dynamic':
                        quantionApi.setDynamicGrupo(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'delete':
                        quantionApi.deleteStbLotes(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ELIMINARENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'checkout':
                        quantionApi.updateCheckLotes(list, 'Out').then(function (dataResponse) {
                            toast($filter('translate')('LOTES.CHECKOUTENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'checkin':
                        quantionApi.updateCheckLotes(list, 'In').then(function (dataResponse) {
                            toast($filter('translate')('LOTES.CHECKINENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'igualarextension':
                        quantionApi.igualarExtensionLotes(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'lastSystem':
                        quantionApi.patchStbLotes(list, angular.toJson({updated: {forceSystem: false}, systemVersion: null})).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'updateDynamic':
                        quantionApi.patchStbLotes(list, angular.toJson({updated: {forceDynamic: true}, dynamicVersion: null})).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'autorun':
                        quantionApi.patchStbLotes(list, angular.toJson({autorun: (vm.aclIsNull ? null : vm.selectedAcl)})).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'edidCache':
                        edidCacheProgresivo(list, vm.launchOpt.interval * 1000);
                        break;
                    case 'patch':
                        (function filter(obj) {
                            $.each(obj, function (key, value) {
                                if (angular.isObject(value) && Object.keys(value).length > 0) {
                                    filter(value);
                                }
                                if (value === "" || value === null || (angular.isObject(value) ? Object.keys(value).length < 1 : $scope.patchAttr.indexOf(key) === -1)) {
                                    delete obj[key];
                                }
                            });
                        })($scope.patchObj);

                        $("#progressLog").empty();

                        if (vm.launchOpt.mode === 'simultaneo') {
                            $("#progressLog").append("<p>Lanzada acción</p>");
                            quantionApi.patchStbLotes(list, angular.toJson($scope.patchObj)).then(function (dataResponse) {
                                $("#progressLog").append("<p>Acción realizada correctamente</p>");

                                switch (vm.launchOpt.postAction) {
                                    case 'recarga':
                                        $("#progressLog").append("<div>Recargando interfaz de todos los equipos seleccionados</div>");
                                        quantionApi.serviceRebootLote(list);
                                        break;
                                    case 'reinicio':
                                        $("#progressLog").append("<div>Reiniciando los equipos seleccionados</div>");
                                        quantionApi.rebootLote(list);
                                        break;
                                }

                                toast($filter('translate')('LOTES.ACTUENVIADA'));
                                $scope.cargando = false;
                            }, function (dataResponse) {
                                $scope.cargando = false;
                                vm.yaEnviado = false;
                                toast(dataResponse.status + ' - ' + dataResponse.statusText);
                            });
                        } else {
                            patchProgresivo(list, $scope.patchObj, vm.launchOpt.interval * 1000);
                        }
                        break;
                    default:
                        quantionApi.patchStbLotes(list, angular.toJson(obj)).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                }
            } else {
                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('LOTES.ALERT.TITLE'))
                        .textContent($filter('translate')('LOTES.ALERT.CONTENT'))
                        .ariaLabel('No STB')
                        .ok($filter('translate')('LOTES.ALERT.OK'))
                        );
            }
        }

        function patchProgresivo(stbs, obj, time) {
            if ($scope.paused || $scope.stopped) {
                a();
                return;
            }

            var index0 = stbs.shift();

            if (Object.keys(obj).length > 0) {
                $("#progressLog").append("<div style='color: blue'>" + getNow() + "Actualizando campos de hab. " + vm.mapStbs[index0].room + "</div>");

                quantionApi.patchStb(index0, angular.toJson(obj)).then(function () {
                    $("#progressLog").append("<div style='color: green'>" + getNow() + "Actualizada hab. " + vm.mapStbs[index0].room + "</div>");
                    switch (vm.launchOpt.postAction) {
                        case 'recarga':
                            $("#progressLog").append("<div>" + getNow() + "Recargando interfaz de hab. " + vm.mapStbs[index0].room + "</div>");
                            quantionApi.rebootInterface(index0);
                            break;
                        case 'dynamic':
                            $("#progressLog").append("<div>" + getNow() + "Actualizando dynamic de hab. " + vm.mapStbs[index0].room + "</div>");
                            quantionApi.setDynamic(index0);
                            break;
                        case 'reinicio':
                            $("#progressLog").append("<div>" + getNow() + "Reiniciando hab. " + vm.mapStbs[index0].room + "</div>");
                            quantionApi.rebootStb(index0);
                            break;
                    }
                    $("#progressLog").append("<div>" + getNow() + stbs.length + " restantes</div>");
                    a();
                }, function () {
                    $("#progressLog").append("<div style='color: red'>" + getNow() + "Error al actualizar hab. " + vm.mapStbs[index0].room + "</div>");
                    $("#progressLog").append("<div>" + getNow() + stbs.length + " restantes</div>");
                    a();
                });
            } else {
                switch (vm.launchOpt.postAction) {
                    case 'recarga':
                        $("#progressLog").append("<div>" + getNow() + "Recargando interfaz de hab. " + vm.mapStbs[index0].room + "</div>");
                        quantionApi.rebootInterface(index0);
                        break;
                    case 'dynamic':
                        $("#progressLog").append("<div>" + getNow() + "Actualizando dynamic de hab. " + vm.mapStbs[index0].room + "</div>");
                        quantionApi.setDynamic(index0);
                        break;
                    case 'reinicio':
                        $("#progressLog").append("<div>" + getNow() + "Reiniciando hab. " + vm.mapStbs[index0].room + "</div>");
                        quantionApi.rebootStb(index0);
                        break;
                }
                $("#progressLog").append("<div>" + getNow() + stbs.length + " restantes</div>");
                a();
            }

            function a() {
                if (stbs.length > 0 && !$scope.stopped) {
                    $timeout(function () {
                        patchProgresivo(stbs, obj, time);
                    }, time);
                } else {
                    $("#progressLog").append("<div style='color: blue'>" + getNow() + "FINALIZADA ACCIÓN POR LOTES</div>");
                    vm.yaEnviado = false;
                    $scope.cargando = false;
                    toast($filter('translate')('LOTES.ACTUENVIADA'));
                }
            }
        }

        function edidCacheProgresivo(stbs, time) {
            if ($scope.paused || $scope.stopped) {
                a();
                return;
            }

            var index0 = stbs.shift();

            $("#progressLog").append("<div style='color: blue'>" + getNow() + "Borrando caché EDID de hab. " + vm.mapStbs[index0].room + "</div>");

            quantionApi.deleteCacheEdid(index0).then(function () {
                $("#progressLog").append("<div style='color: green'>" + getNow() + "Borrado caché EDID hab. " + vm.mapStbs[index0].room + "</div>");
                switch (vm.launchOpt.postAction) {
                    case 'recarga':
                        $("#progressLog").append("<div>" + getNow() + "Recargando interfaz de hab. " + vm.mapStbs[index0].room + "</div>");
                        quantionApi.rebootInterface(index0);
                        break;
                    case 'dynamic':
                        $("#progressLog").append("<div>" + getNow() + "Actualizando dynamic de hab. " + vm.mapStbs[index0].room + "</div>");
                        quantionApi.setDynamic(index0);
                        break;
                    case 'reinicio':
                        $("#progressLog").append("<div>" + getNow() + "Reiniciando hab. " + vm.mapStbs[index0].room + "</div>");
                        quantionApi.rebootStb(index0);
                        break;
                }
                $("#progressLog").append("<div>" + getNow() + stbs.length + " restantes</div>");
                a();
            }, function () {
                $("#progressLog").append("<div style='color: red'>" + getNow() + "Error al borrar caché EDID de hab. " + vm.mapStbs[index0].room + "</div>");
                $("#progressLog").append("<div>" + getNow() + stbs.length + " restantes</div>");
                a();
            });

            function a() {
                if (stbs.length > 0 && !$scope.stopped) {
                    $timeout(function () {
                        edidCacheProgresivo(stbs, time);
                    }, time);
                } else {
                    $("#progressLog").append("<div style='color: blue'>" + getNow() + "FINALIZADA ACCIÓN POR LOTES</div>");
                    vm.yaEnviado = false;
                    $scope.cargando = false;
                }
            }
        }

        function toast(text) {
            $mdToast.show(
                    $mdToast.simple()
                    .textContent(text)
                    .position('top right')
                    .hideDelay(3000)
                    );
            $scope.msWizard.firstStep();
            initWizard();
            vm.yaEnviado = false;
        }

        $scope.aplicarFiltro = function () {
            limpiarObjeto($scope.stbFilter);

            if (vm.listaStbs)
                $scope.selected = ($filter('filter')(vm.listaStbs, $scope.stbFilter)).map(function (e) {
                    return e.idStb;
                });
        };

        function limpiarObjeto(obj) {//Elimina atributos vacíos
            $.each(obj, function (key, value) {
                if (angular.isObject(value) && Object.keys(value).length > 0) {
                    limpiarObjeto(value);
                }

                if (value === "" || value === null || (angular.isObject(value) && Object.keys(value).length < 1)) {
                    delete obj[key];
                }
            });
        }

        $scope.limpiarFiltro = function () {
            $scope.stbFilter = {};
        };

        $scope.pauseProcess = function () {
            $scope.paused = true;
            $("#progressLog").append("<div style='color: darkorange'>" + getNow() + "Pausado el proceso</div>");
        };

        $scope.resumeProcess = function () {
            $scope.paused = false;
            $("#progressLog").append("<div style='color: darkorange'>" + getNow() + "Reanudado el proceso</div>");
        };

        $scope.stopProcess = function () {
            $scope.paused = false;
            $scope.stopped = true;
            $("#progressLog").append("<div style='color: red'>" + getNow() + "Cancelado el proceso</div>");
        };

        function getNow() {
            return '[' + $filter('date')(new Date(), 'HH:mm:ss') + '] ';
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.iptv.listaIptv', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_iptv_listaIptv', {
            url: '/iptv',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/iptv/listaIptv/listaIptv.html',
                    controller: 'listaIptvController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/iptv/listaIptv');
    }

})();
(function ()
{
    'use strict';
    angular
            .module('app.Quantion.iptv.listaIptv')
            .controller('listaIptvController', listaIptvController);
    /** @ngInject */
    function listaIptvController(quantionApi, $mdDialog, $mdToast, $scope, $interval, $rootScope, $filter, $compile, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'IPTV_LISTADO';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        CargarCanales();
        function CargarCanales() {
            pantallaCarga.lsEnable('LS.CANALESIPTV');

            quantionApi.getCanalesTV().then(function (dataResponse) {
                vm.canalesTV = $filter('orderBy')(dataResponse.data, 'nombre');

                quantionApi.getCanalesRadio().then(function (dataResponse) {
                    vm.canalesRadio = $filter('orderBy')(dataResponse.data, 'nombre');
                    appendHTMLchannelList();
                });
            });
        }

        CargarLogos();
        function CargarLogos() {
            vm.logos = {
                tv: [],
                radio: []
            };

            quantionApi.getLogosTv().then(function (dataResponse) {
                vm.logos.tv = $filter('orderBy')(dataResponse.data.files, 'name');
            });

            quantionApi.getLogosRadio().then(function (dataResponse) {
                vm.logos.radio = $filter('orderBy')(dataResponse.data.files, 'name');
            });
        }

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.idiomas = dataResponse.data;
        });

        ActualizarParametrosFlow();
        function ActualizarParametrosFlow() {
            quantionApi.getProperties(true, 'name').then(function (dataResponse) {
                quantionApi.getFlow(dataResponse.data.name).then(function (dataResponse) {
                    vm.flowTemp = {
                        temperature: dataResponse.data.temperature ? (dataResponse.data.temperature + '\xB0 C') : ' - '
                    };
                    if (vm.flowTemp.temperature < 50) {
                        vm.flowTemp.status = 'normal';
                    } else if (vm.flowTemp.temperature < 60) {
                        vm.flowTemp.status = 'high';
                    } else {
                        vm.flowTemp.status = 'critical';
                    }

                    if (dataResponse.data.alarms) {
                        $scope.listaAlarmas = dataResponse.data.alarms;
                    }
                }, function (dataResponse) {
                    $scope.listaAlarmas = [];
                    $interval.cancel(timer);
                    vm.flowTemp = {
                        temperature: 'No info'
                    };
                });
            });
        }

        function appendHTMLchannelList() {
            var tvHTML = "";

            angular.forEach(vm.canalesTV, function (canalTV, index) {
                tvHTML = tvHTML +
                        '<tr class="' + (canalTV.visible ? 'canalVisible' : 'canalNoVisible') + '">' +
                        '   <td flex-gt-sm>' + canalTV.nombre + '</td>' +
                        '   <td flex-gt-sm><img src="' + $filter('replacePath')(canalTV.tvgLogo) + '" alt="' + canalTV.nombre + '" height="42" width="42" on-error-image="/assets/quantionImagenes/img-error.png"/></td>' +
                        '   <td flex-gt-sm>' + canalTV.urlStreaming + '</td>' +
                        '   <td flex-gt-sm>' + $filter('stringifyArray')(canalTV.idiomas, true) + '</td>' +
                        '   <td flex-gt-sm>' +
                        '       <div layout="row">' +
                        '           <md-button class="md-fab md-mini" ng-click="vm.ventanaEditar($event, vm.canalesTV[' + index + '])">' +
                        '               <md-icon md-font-icon="icon-pencil"></md-icon>' +
                        '               <md-tooltip md-direction="bottom">' + $filter('translate')("LISTADO.EDITAR") + '</md-tooltip>' +
                        '           </md-button>' +
                        '           <md-button class="md-fab md-mini" ng-click="vm.eliminarCanal($event, vm.canalesTV[' + index + '])">' +
                        '               <md-icon md-font-icon="icon-delete"></md-icon>' +
                        '               <md-tooltip md-direction="bottom">' + $filter('translate')("LISTADO.ELIMINAR") + '</md-tooltip>' +
                        '           </md-button>' +
                        '       </div>' +
                        '   </td>' +
                        '</tr>';
            });

            $('#channelTvContainer').empty().append(tvHTML);
            $compile($('#channelTvContainer'))($scope);

            var radioHTML = "";

            angular.forEach(vm.canalesRadio, function (canalRadio, index) {
                radioHTML = radioHTML +
                        '<tr class="' + (canalRadio.visible ? 'canalVisible' : 'canalNoVisible') + '">' +
                        '   <td flex-gt-sm>' + canalRadio.nombre + '</td>' +
                        '   <td flex-gt-sm><img src="' + $filter('replacePath')(canalRadio.tvgLogo) + '" alt="' + canalRadio.nombre + '" height="42" width="42" on-error-image="/assets/quantionImagenes/img-error.png"/></td>' +
                        '   <td flex-gt-sm>' + canalRadio.urlStreaming + '</td>' +
                        '   <td flex-gt-sm>' + $filter('stringifyArray')(canalRadio.idiomas, true) + '</td>' +
                        '   <td flex-gt-sm>' +
                        '       <div layout="row">' +
                        '           <md-button class="md-fab md-mini" ng-click="vm.ventanaEditar($event, vm.canalesRadio[' + index + '])">' +
                        '               <md-icon md-font-icon="icon-pencil"></md-icon>' +
                        '               <md-tooltip md-direction="bottom">' + $filter('translate')("LISTADO.EDITAR") + '</md-tooltip>' +
                        '           </md-button>' +
                        '           <md-button class="md-fab md-mini" ng-click="vm.eliminarCanal($event, vm.canalesRadio[' + index + '])">' +
                        '               <md-icon md-font-icon="icon-delete"></md-icon>' +
                        '               <md-tooltip md-direction="bottom">' + $filter('translate')("LISTADO.ELIMINAR") + '</md-tooltip>' +
                        '           </md-button>' +
                        '       </div>' +
                        '   </td>' +
                        '</tr>';
            });

            $('#channelRadioContainer').empty().append(radioHTML);
            $compile($('#channelRadioContainer'))($scope);
            pantallaCarga.lsDisable();
        }

        //*********** TEMPORIZADOR **********
        var timer = $interval(function () {
            ActualizarParametrosFlow();
        }, 15000);
        $scope.$on("$destroy", function (event) {
            $interval.cancel(timer);
        });

//************ Eliminar ***************
        vm.eliminarCanal = function (ev, canal) {
            var confirm = $mdDialog.confirm().title($filter('translate')('LISTADO.ELIMINAR_.TITLE'))
                    .textContent($filter('translate')('LISTADO.ELIMINAR_.CONTENT')).clickOutsideToClose(true)
                    .targetEvent(ev).ok($filter('translate')('LISTADO.ELIMINAR_.OK')).cancel($filter('translate')('LISTADO.ELIMINAR_.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCanal(canal.idCanal).then(function (dataResponse) {
                    CargarCanales();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('LISTADO.ELIMINAR_.TOAST')).position('top right').hideDelay(5000));
                }, function () {

                });
            });
        };

        vm.eliminarTodosTV = function (ev) {
            var confirm = $mdDialog.confirm().title($filter('translate')('LISTADO.ELIMINARTODOS.TITLETV'))
                    .textContent($filter('translate')('LISTADO.ELIMINARTODOS.CONTENT')).targetEvent(ev).clickOutsideToClose(true)
                    .ok($filter('translate')('LISTADO.ELIMINARTODOS.OK')).cancel($filter('translate')('LISTADO.ELIMINARTODOS.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCanalesTV().then(function (dataResponse) {
                    CargarCanales();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('LISTADO.ELIMINARTODOS.TOAST')).position('top right').hideDelay(5000));
                }, function (dataResponse) {
                    $mdDialog.show($mdDialog.alert().title($filter('translate')('LISTADO.ELIMINARTODOS.ALERT.TITLE'))
                            .textContent($filter('translate')('LISTADO.ELIMINARTODOS.ALERT.CONTENT'))
                            .ariaLabel('Error borrar').ok($filter('translate')('LISTADO.ELIMINARTODOS.ALERT.OK')).targetEvent(ev));
                });
            });
        };

        vm.eliminarTodosRadio = function (ev) {
            var confirm = $mdDialog.confirm().title($filter('translate')('LISTADO.ELIMINARTODOS.TITLERADIO'))
                    .textContent($filter('translate')('LISTADO.ELIMINARTODOS.CONTENT')).targetEvent(ev).clickOutsideToClose(true)
                    .ok($filter('translate')('LISTADO.ELIMINARTODOS.OK')).cancel($filter('translate')('LISTADO.ELIMINARTODOS.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCanalesRadio().then(function (dataResponse) {
                    CargarCanales();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('LISTADO.ELIMINARTODOS.TOAST')).position('top right').hideDelay(5000));
                }, function (dataResponse) {
                    $mdDialog.show($mdDialog.alert().title($filter('translate')('LISTADO.ELIMINARTODOS.ALERT.TITLE'))
                            .textContent($filter('translate')('LISTADO.ELIMINARTODOS.ALERT.CONTENT'))
                            .ariaLabel('Error borrar').ok($filter('translate')('LISTADO.ELIMINARTODOS.ALERT.OK')).targetEvent(ev));
                });
            });
        };

//************ Nuevo ***************
        vm.ventanaNuevo = function (ev, tipo) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/iptv/listaIptv/editar.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {_tipo: tipo}
            });
        };
        function NuevoCtrl($scope, $mdDialog, $mdToast, _tipo) {
            $scope.canal = {
                tipo: _tipo === 'tv' ? 'hd' : 'radio',
                idiomas: []
            };
            $scope.arrayLogos = vm.logos;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.Guardar = function () {
                $scope.loading = true;

                var canal = angular.copy($scope.canal);
                var jsonObj = angular.toJson(canal);

                quantionApi.addCanal(jsonObj).then(function (dataResponse) {
                    CargarCanales();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('CREAR.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                }, function () {
                    $scope.loading = false;
                });
            };

            $scope.querySearch = function (query) {
                var results;
                if ($scope.canal.tipo !== 'radio') {
                    results = query ? $scope.arrayLogos.tv.filter(filtrarLogos(query)) : $scope.arrayLogos.tv;
                } else {
                    results = query ? $scope.arrayLogos.radio.filter(filtrarLogos(query)) : $scope.arrayLogos.radio;
                }
                return results;
            };

            function filtrarLogos(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function (logo) {
                    return (angular.lowercase(logo.name).indexOf(lowercaseQuery) !== -1);
                };
            }

            $scope.elegirLogo = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/iptv/listaIptv/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        listaLogos: $scope.canal.tipo !== 'radio' ? $scope.arrayLogos.tv : $scope.arrayLogos.radio,
                        canal: $scope.canal
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, listaLogos, canal) {
                $scope.listaLogos = listaLogos;
                $scope.canal = canal;

                var Path = FilePaths.logos[canal.tipo === 'radio' ? 'radio' : 'tv'];

                $scope.escogerImagen = function (img) {
                    canal.tvgLogo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.uploadFile = function () {
                    var file = $('#channelLogo')[0].files[0];
                    if (!file)
                        return;

                    var arr = file.name.split(".");
                    var fileInfo = {
                        name: arr[0],
                        extension: arr[arr.length - 1]
                    };

                    var formData = new FormData();
                    var aux = fileInfo.name.replace(/ /g, "_") + "." + fileInfo.extension;

                    formData.append('file', file);

                    pantallaCarga.lsEnable('LS.UPLOADING');
                    quantionApi.uploadGenericFile(formData, aux, Path).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarLogos();

                        if (canal.tipo === 'radio') {
                            quantionApi.getLogosRadio().then(function (dataResponse) {
                                $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                                var arr = $scope.listaLogos.filter(function (e) {
                                    return e.name === aux;
                                });

                                if (arr[0])
                                    $scope.escogerImagen(arr[0]);
                            });
                        } else {
                            quantionApi.getLogosTv().then(function (dataResponse) {
                                $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                                var arr = $scope.listaLogos.filter(function (e) {
                                    return e.name === aux;
                                });

                                if (arr[0])
                                    $scope.escogerImagen(arr[0]);
                            });
                        }

                        pantallaCarga.lsDisable();
                    }, function () {
                        pantallaCarga.lsDisable();
                    });
                };
            }
        }

//************ Editar ***************
        vm.ventanaEditar = function (ev, canal) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/iptv/listaIptv/editar.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {canal: canal}
            });
        };
        function EditarCtrl($scope, $mdDialog, canal, $mdToast) {
            $scope.canal = angular.copy(canal);
            $scope.arrayLogos = vm.logos;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.Guardar = function () {
                var canal_ = angular.copy($scope.canal);
                canal_.checkIntegrity = !canal_.checkIntegrity;

                var jsonObj = angular.toJson(canal_, true);

                quantionApi.updateCanal(jsonObj).then(function (dataResponse) {
                    CargarCanales();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('EDITAR.TOAST')).position('top right').hideDelay(5000));
                    $scope.hide();
                });
            };

            $scope.querySearch = function (query) {
                var results;
                if ($scope.canal.tipo !== 'radio') {
                    results = query ? $scope.arrayLogos.tv.filter(filtrarLogos(query)) : $scope.arrayLogos.tv;
                } else {
                    results = query ? $scope.arrayLogos.radio.filter(filtrarLogos(query)) : $scope.arrayLogos.radio;
                }
                return results;
            };

            function filtrarLogos(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function (logo) {
                    return (angular.lowercase(logo.name).indexOf(lowercaseQuery) !== -1);
                };
            }

            $scope.elegirLogo = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/iptv/listaIptv/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        listaLogos: $scope.canal.tipo !== 'radio' ? $scope.arrayLogos.tv : $scope.arrayLogos.radio,
                        canal: $scope.canal
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, listaLogos, canal) {
                $scope.listaLogos = listaLogos;
                $scope.canal = canal;

                var Path = FilePaths.logos[canal.tipo === 'radio' ? 'radio' : 'tv'];

                $scope.escogerImagen = function (img) {
                    canal.tvgLogo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.uploadFile = function () {
                    var file = $('#channelLogo')[0].files[0];
                    if (!file)
                        return;

                    var arr = file.name.split(".");
                    var fileInfo = {
                        name: arr[0],
                        extension: arr[arr.length - 1]
                    };

                    var formData = new FormData();
                    var aux = fileInfo.name.replace(/ /g, "_") + "." + fileInfo.extension;

                    formData.append('file', file);

                    pantallaCarga.lsEnable('LS.UPLOADING');
                    quantionApi.uploadGenericFile(formData, aux, Path).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                        CargarLogos();

                        if (canal.tipo === 'radio') {
                            quantionApi.getLogosRadio().then(function (dataResponse) {
                                $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                                var arr = $scope.listaLogos.filter(function (e) {
                                    return e.name === aux;
                                });

                                if (arr[0])
                                    $scope.escogerImagen(arr[0]);
                            });
                        } else {
                            quantionApi.getLogosTv().then(function (dataResponse) {
                                $scope.listaLogos = $filter('orderBy')(dataResponse.data.files, 'name');

                                var arr = $scope.listaLogos.filter(function (e) {
                                    return e.name === aux;
                                });

                                if (arr[0])
                                    $scope.escogerImagen(arr[0]);
                            });
                        }

                        pantallaCarga.lsDisable();
                    }, function () {
                        pantallaCarga.lsDisable();
                    });
                };
            }
        }

        //*************** EXPORTACIÓN **************************

        vm.exportData = function () {
            //Get the file contents
            var str = {
                'Fecha de guardado': (new Date()).toLocaleDateString('es-ES'),
                'Numero canales TV': vm.canalesTV.length,
                'Numero canales Radio': vm.canalesRadio.length,
                'TV': vm.canalesTV.map(function (elm) {
                    return {
                        nombre: elm.nombre,
                        idiomas: elm.idiomas,
                        tipo: elm.tipo,
                        tvgLogo: elm.tvgLogo,
                        urlStreaming: elm.urlStreaming
                    };
                }),
                'RADIO': vm.canalesRadio.map(function (elm) {
                    return {
                        nombre: elm.nombre,
                        idiomas: elm.idiomas,
                        tipo: elm.tipo,
                        tvgLogo: elm.tvgLogo,
                        urlStreaming: elm.urlStreaming
                    };
                })
            };

            //Save the file contents as a DataURI
            var dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(angular.toJson(str, true));

            //Write it as the href for the link
            var link = document.getElementById('link');
            link.href = dataUri;
            link.click();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.Quantion.iptv.importexport', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_iptv_importexport', {
            url  : '/iptv/importexport',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/iptv/importexport/importexport.html',
                    controller : 'importExportController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/iptv/importexport');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.iptv.importexport')
            .controller('importExportController', importExportController);

    /** @ngInject */
    function importExportController(quantionApi, $mdToast, $scope, $interval, JSONconfig, $mdDialog, $state, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'IMPORT_EXPORT';

        vm.listaCanalesImportados = {"TV": [], "RADIO": []};//Canales obtenidos de la Flow o del archivo
        vm.canalesYaExistentes = {canalesObj: [], canalesUrlStr: []};//Canales de la BBDD
        vm.listaCanalesSeleccionados = [];//Canales marcados para guardar

        var imagenNoLogo = JSONconfig.logosPath.to + '/Logos/TV/nodisponible.png';

        vm.listaLogos = [];
        quantionApi.getLogosTv().then(function (dataResponse) {
            vm.listaLogos = vm.listaLogos.concat(dataResponse.data.files.map(function (elm) {
                return elm.path;
            }));
        });
        quantionApi.getLogosRadio().then(function (dataResponse) {
            vm.listaLogos = vm.listaLogos.concat(dataResponse.data.files.map(function (elm) {
                return elm.path;
            }));
        });

        function CargarCanalesExistentes() {
            quantionApi.getCanales().then(function (dataResponse) {
                vm.canalesYaExistentes.canalesObj = dataResponse.data;

                vm.incluidos = {};
                $.each(dataResponse.data, function (index, value) {
                    vm.incluidos[value.urlStreaming] = true;
                });

                vm.canalesYaExistentes.canalesUrlStr = dataResponse.data.map(function (item, index) {
                    return item.urlStreaming;
                });
            });
        }

        CargarCanalesExistentes();

        function existeCanal(url) {
            return vm.canalesYaExistentes.canalesUrlStr.indexOf(url) !== -1;
        }

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var contenidoArchivo = e.target.result;
                vm.listaCanalesImportados.TV = [];
                vm.listaCanalesImportados.RADIO = [];
                vm.seleccionados = {};
                vm.canalesExistentesNoImportadosPorFlow = null;

                if (isJSON(contenidoArchivo)) {//Archivo en formato JSON
                    var contenidoArchivoObj = JSON.parse(contenidoArchivo);
                    vm.listaCanalesImportados.TV = contenidoArchivoObj.TV;
                    vm.listaCanalesImportados.RADIO = contenidoArchivoObj.RADIO;
                }
                $scope.isLoading = false;

                document.getElementById('files').value = null;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
            return true;
        }

        vm.seleccionarTodo = function () {
            $.each(vm.listaCanalesImportados.TV, function (index, value) {
                if (!vm.incluidos[value.urlStreaming])
                    vm.seleccionados[value.urlStreaming] = true;
            });
            $.each(vm.listaCanalesImportados.RADIO, function (index, value) {
                if (!vm.incluidos[value.urlStreaming])
                    vm.seleccionados[value.urlStreaming] = true;
            });
        };

        vm.deseleccionarTodo = function () {
            vm.seleccionados = {};
        };

        vm.guardarSeleccion = function () {
            var arr = vm.listaCanalesImportados.TV.filter(function (el) {
                return vm.seleccionados[el.urlStreaming] && !vm.incluidos[el.urlStreaming];
            }).concat(vm.listaCanalesImportados.RADIO.filter(function (el) {
                return vm.seleccionados[el.urlStreaming] && !vm.incluidos[el.urlStreaming];
            }));
            var contador = 0;

            if (arr.length > 0) {

                $.each(arr, function (i, el) {
                    var canal = {
                        "nombre": el.nombre,
                        "tvgLogo": el.tvgLogo || encodeURI(JSONconfig.logosPath.from + '/Logos/' + (el.tipo === 'radio' ? 'radio/' : 'tv/') + (el.tvglogo || el.nombre) + '.png'),
                        "urlStreaming": el.urlStreaming,
                        "tvgId": el.tvgId,
                        "idiomas": el.idiomas,
                        "tipo": el.tipo
                    };

                    var jsonObj = angular.toJson(canal, 0);
                    console.log(jsonObj);

                    $scope.isLoading = true;
                    quantionApi.addCanal(jsonObj).then(function (dataResponse) {
                        contador++;

                        if (contador === arr.length) {
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('IMPEXP.TOASTGUARDAR')).position('top right').hideDelay(5000));
                            vm.listaCanalesImportados = {"TV": [], "RADIO": []};
//                            CargarCanalesExistentes();
                            $scope.isLoading = false;
                            setTimeout(function () {
                                $state.go('app.Quantion_iptv_listaIptv');
                            }, 2000);
                        }
                    });
                });
            } else {
                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('IMPEXP.ALERTNOCANALES.TITLE'))
                        .ok($filter('translate')('IMPEXP.ALERTNOCANALES.OK'))
                        );
            }
        };

        function filtroLogosAFlow(nombreCanal) {
            var filtered = vm.listaLogos.filter(function (logo) {
                return logo.replace(/ /g, '').toLowerCase() === nombreCanal.replace(/ /g, '').toLowerCase();
            });

            if (filtered.length < 1) {
                filtered = vm.listaLogos.filter(function (logo) {
                    return logo.replace(/ /g, '').toLowerCase().indexOf(nombreCanal.replace(/ /g, '').toLowerCase()) !== -1;
                });
            }

            if (filtered.length < 1) {
                filtered = vm.listaLogos.filter(function (logo) {
                    return nombreCanal.replace(/ /g, '').toLowerCase().indexOf(logo.replace(/ /g, '').toLowerCase()) !== -1;
                });
            }

            if (filtered.length > 0) {
                return filtered[0];
            } else {
                return imagenNoLogo;
            }
        }

        vm.getFlowChannels = function () {
            $scope.isLoading = true;
            vm.listaCanalesImportados.TV = [];
            vm.listaCanalesImportados.RADIO = [];
            vm.seleccionados = {};

            quantionApi.getProperties(true, 'name').then(function (dataResponse) {

                quantionApi.getCanalesFlow(dataResponse.data.name).then(function (dataResponse) {
                    $.each(dataResponse.data, function (index, value) {
                        value.tvgLogo = filtroLogosAFlow(value.nombre);
//                        value.yaIncluido = existeCanal(value.urlStreaming);
                        if (!value.tipo)
                            value.tipo = 'sd';

                        if (value.tipo === 'radio') {
                            vm.listaCanalesImportados.RADIO.push(value);
                        } else {
                            vm.listaCanalesImportados.TV.push(value);
                        }
                    });

                    var arr = vm.listaCanalesImportados.TV.map(function (e) {
                        return e.urlStreaming;
                    });
                    var arr2 = vm.listaCanalesImportados.RADIO.map(function (e) {
                        return e.urlStreaming;
                    });
                    vm.canalesExistentesNoImportadosPorFlow = vm.canalesYaExistentes.canalesObj.filter(function (elm) {
                        return arr.indexOf(elm.urlStreaming) === -1 && arr2.indexOf(elm.urlStreaming) === -1;
                    });

                    getFlowParams();

                    $scope.isLoading = false;
                }, function () {
                    $scope.isLoading = false;
                });
            });
        };

        vm.seleccionarArchivo = function () {
            $('#files').click();
        };

        getFlowParams();

        function getFlowParams() {
            quantionApi.getProperties(true, 'name').then(function (dataResponse) {
                quantionApi.getFlow(dataResponse.data.name).then(function (dataResponse) {
                    vm.flowTemp = {
                        temperature: dataResponse.data.temperature ? (dataResponse.data.temperature + '\xB0 C') : ' - '
                    };
                    if (vm.flowTemp.temperature < 50) {
                        vm.flowTemp.status = 'normal';
                    } else if (vm.flowTemp.temperature < 60) {
                        vm.flowTemp.status = 'high';
                    } else {
                        vm.flowTemp.status = 'critical';
                    }

                    if (dataResponse.data.alarms) {
                        $scope.listaAlarmas = dataResponse.data.alarms;
                    }
                }, function (dataResponse) {
                    $scope.listaAlarmas = [];
                });
            });
        }

        $scope.eliminarCanalDeBD = function (canal) {
            console.log(canal);

            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('IMPEXP.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('IMPEXP.MODALELIMINAR.CONTENT'))
                    .ok($filter('translate')('IMPEXP.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('IMPEXP.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCanal(canal.idCanal).then(function (dataResponse) {
                    vm.canalesExistentesNoImportadosPorFlow.splice(vm.canalesExistentesNoImportadosPorFlow.indexOf(canal), 1);

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('IMPEXP.MODALELIMINAR.TOAST'))
                            .position('top right')
                            .hideDelay(5000)
                            );
                }, function () {
                    var confirm2 = $mdDialog.confirm()
                            .title($filter('translate')('IMPEXP.MODALELIMINAR.PERTENECE.TITLE'))
                            .textContent($filter('translate')('IMPEXP.MODALELIMINAR.PERTENECE.CONTENT'))
                            .ok($filter('translate')('IMPEXP.MODALELIMINAR.PERTENECE.OK'))
                            .cancel($filter('translate')('IMPEXP.MODALELIMINAR.PERTENECE.CANCEL'));
                    $mdDialog.show(confirm2).then(function () {
                        quantionApi.getServiciosTVAll().then(function (dataResponse) {
                            $.each(dataResponse.data, function (index, value) {
                                if (value.channelList.map(function (elm) {
                                    return elm.idCanal;
                                }).indexOf(canal.idCanal) !== -1) {
                                    quantionApi.deleteCanalDeServicioTV(value.idService, canal.idCanal).then(function () {
                                        quantionApi.deleteCanal(canal.idCanal).then(function (dataResponse) {
                                            $mdToast.show(
                                                    $mdToast.simple()
                                                    .textContent($filter('translate')('IMPEXP.MODALELIMINAR.TOAST'))
                                                    .position('top right')
                                                    .hideDelay(5000)
                                                    );

                                            vm.canalesExistentesNoImportadosPorFlow.splice(vm.canalesExistentesNoImportadosPorFlow.indexOf(canal), 1);
                                        });
                                    });
                                }
                            });
                        });
                    });
                });
            });
        };

        //*********** TEMPORIZADOR **********
        var timer = $interval(function () {
//            console.log("Actualiza flow");
            getFlowParams();
        }, 15000);

        $scope.$on("$destroy", function (event) {
            $interval.cancel(timer);
//            console.log("cancel timer");
        });

        $scope.toogleChannel = function (canal) {
            if (vm.incluidos[canal.urlStreaming])
                return;

            if (vm.seleccionados[canal.urlStreaming])
                delete vm.seleccionados[canal.urlStreaming];
            else
                vm.seleccionados[canal.urlStreaming] = true;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.Quantion.habitaciones.wallets', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_wallets', {
            url  : '/habitaciones/wallets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/wallets/wallets.html',
                    controller : 'walletsController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/wallets');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.wallets')
            .controller('walletsController', walletsController);

    /** @ngInject */
    function walletsController(quantionApi, $mdDialog, $mdToast, $filter, $scope, $translate, $rootScope)
    {
        var vm = this;
        $rootScope.seccion = 'HABITACIONES_WALLETS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.$translate = $translate;

        $scope.numberOfPages = function () {
            if (!$scope.listaWalletsFiltered)
                return 1;

            var a = Math.ceil($scope.listaWalletsFiltered.length / $scope.pageSize) || 1;
            if ($scope.currentPage > a)
                $scope.currentPage = (a - 1);
            return a;
        };

        $scope.filterWallets = function () {
            $scope.listaWalletsFiltered = $filter('filter')(vm.listaWallets, $scope.search);
        };

        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        CargarWallets();
        function CargarWallets() {
            pantallaCarga.lsEnable('LS.MONEDEROS');

            vm.listaWallets = [];
            $scope.listaWalletsFiltered = [];

            quantionApi.getStbs(true).then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;

                vm.stbsIndexed = {};
                $.each(vm.listaStbs, function (index, value) {
                    vm.stbsIndexed[value.idStb] = value;
                });

                quantionApi.getWallets(true).then(function (dataResponse) {
                    vm.listaWallets = dataResponse.data;

                    $.each(vm.listaWallets, function (index, value) {
                        value.stbAsociated = vm.stbsIndexed[value.idStb];
                    });

                    $scope.listaWalletsFiltered = vm.listaWallets;

                    if (dataResponse.data.length === 0)
                        pantallaCarga.lsDisable();

                    initTable();
                }, function () {
                    pantallaCarga.lsDisable();
                });
            });
        }

        vm.CargarWallets = CargarWallets;

        function initTable() {
            $scope.search = '';
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.orderProp = 'room';
            $scope.orderReverse = false;
        }

        $scope.openMenu = function ($mdOpenMenu, ev, wallet) {
            if (wallet.services) {
                $mdOpenMenu(ev);
            } else {
                quantionApi.getWallet(wallet.uuidVirtualWallet).then(function (dataResponse) {
                    wallet.services = dataResponse.data.services;
                    $mdOpenMenu(ev);
                });
            }
        };

        vm.eliminarWallet = function (ev, wallet) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('WALLETS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('WALLETS.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('WALLETS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('WALLETS.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteWallet(wallet.uuidVirtualWallet).then(function (dataResponse) {
                    CargarWallets();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("WALLETS.ELIMINARTOAST")).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert().clickOutsideToClose(true)
                            .title($filter('translate')('WALLETS.ERRORELIMINAR.TITLE'))
                            .ariaLabel('Error eliminar wallet')
                            .ok($filter('translate')('WALLETS.ERRORELIMINAR.CERRAR')));
                });
            });
        };

        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/wallets/templates/crearwallet.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                $scope.mensajeError = '';
                var jsonObj = angular.toJson($scope.wallet);
                console.log(jsonObj);

                quantionApi.addWallet(jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.CREARTOAST')).position('top right').hideDelay(5000));
                    CargarWallets();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.dataLoading = false;
                    $scope.mensajeError = $filter('translate')('WALLETS.ERROREXISTE');
                });
            };
        }

        vm.checkWallet = function (ev, wallet, value) {
            if (value === 'In') {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('WALLETS.MODALCHECKIN.TITLE'))
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .ok($filter('translate')('WALLETS.MODALCHECKIN.OK'))
                        .cancel($filter('translate')('WALLETS.MODALCHECKIN.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                    quantionApi.updateWalletCheck(wallet.uuidVirtualWallet, value).then(function (dataResponse) {
                        CargarWallets();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.MODALCHECKIN.CORRECTO')).position('top right').hideDelay(3000));
                    }, function (dataResponse) {
                        $mdDialog.show(
                                $mdDialog.alert().clickOutsideToClose(true)
                                .title($filter('translate')('WALLETS.MODALCHECKIN.ERROR.TITLE'))
                                .textContent($filter('translate')('WALLETS.MODALCHECKIN.ERROR.CONTENT'))
                                .ariaLabel('Error check-in wallet')
                                .ok($filter('translate')('WALLETS.MODALCHECKIN.ERROR.OK')));
                    });
                });
            } else {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('WALLETS.MODALCHECKOUT.TITLE'))
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .ok($filter('translate')('WALLETS.MODALCHECKOUT.OK'))
                        .cancel($filter('translate')('WALLETS.MODALCHECKOUT.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                    quantionApi.updateWalletCheck(wallet.uuidVirtualWallet, value).then(function (dataResponse) {
                        CargarWallets();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.MODALCHECKOUT.CORRECTO')).position('top right').hideDelay(3000));
                    }, function (dataResponse) {
                        $mdDialog.show(
                                $mdDialog.alert().clickOutsideToClose(true)
                                .title($filter('translate')('WALLETS.MODALCHECKOUT.ERROR.TITLE'))
                                .textContent($filter('translate')('WALLETS.MODALCHECKOUT.ERROR.CONTENT'))
                                .ariaLabel('Error check-out wallet')
                                .ok($filter('translate')('WALLETS.MODALCHECKOUT.ERROR.OK')));
                    });
                });
            }
        };

        vm.vincularStb = function (ev, wallet) {
            $mdDialog.show({
                controller: VinculaCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/wallets/templates/vinculaStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {wallet: wallet}
            });
        };

        function VinculaCtrl($scope, $mdDialog, $mdToast, wallet) {
            $scope.listaStbs = vm.listaStbs;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                quantionApi.VincularStbWallet($scope.stbSelected.idStb, wallet.uuidVirtualWallet).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.VINCULAR.TOAST')).position('top right').hideDelay(5000));
                    CargarWallets();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            };
        }

        vm.desvincularStb = function (ev, wallet) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('WALLETS.DESVINCULA.TITLE'))
                    .textContent($filter('translate')('WALLETS.DESVINCULA.CONTENT'))
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .ok($filter('translate')('WALLETS.DESVINCULA.OK'))
                    .cancel($filter('translate')('WALLETS.DESVINCULA.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.DesvincularStbWallet(wallet.stbAsociated.idStb, wallet.uuidVirtualWallet).then(function (dataResponse) {
                    CargarWallets();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.DESVINCULA.CORRECTO')).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert().clickOutsideToClose(true)
                            .title($filter('translate')('WALLETS.DESVINCULA.ERROR.TITLE'))
                            .ariaLabel('Error desvincular wallet')
                            .ok($filter('translate')('WALLETS.DESVINCULA.ERROR.OK')));
                });
            });
        };

        vm.listaChecks = function (ev, wallet) {
            $mdDialog.show({
                controller: ListaChecksCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/wallets/templates/listaChecks.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {wallet: wallet}
            });
        };

        function ListaChecksCtrl($scope, $mdDialog, $mdToast, wallet) {
            $scope.listaStbs = vm.listaStbs;
            $scope.checkType = null;
            $scope.pageSize = 10;

            $scope.refresh = function () {
                $scope.dataLoading = true;

                quantionApi.getWalletChecks(wallet.uuidVirtualWallet, $scope.checkType, $scope.pageSize).then(function (dataResponse) {
                    $scope.listaChecks = dataResponse.data;
                    $scope.dataLoading = false;
                }, function () {
                    $scope.dataLoading = false;
                });
            };
            $scope.refresh();

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        $scope.changeLogoutOnDisconnect = function (wallet) {
            if ($('#icon-status-' + wallet.uuidVirtualWallet).hasClass('animate'))
                return;

            $('#icon-status-' + wallet.uuidVirtualWallet).addClass('animate');
            quantionApi.updateWalletLogoutOnDisconnect(wallet.uuidVirtualWallet, !wallet.logoutOnDisconnect).then(function (dataResponse) {
                wallet.logoutOnDisconnect = dataResponse.data.logoutOnDisconnect;
                $('#icon-status-' + wallet.uuidVirtualWallet).removeClass('animate');
            }, function () {
                $('#icon-status-' + wallet.uuidVirtualWallet).removeClass('animate');
            });
        };

        $scope.obtainPin = function (wallet) {
            quantionApi.getAccountant({"wallet": wallet.uuidVirtualWallet, "concept": "Wallet", "limit": 10, "check": "Out"}).then(function (dataResponse) {
                var oper = dataResponse.data.find(function (o) {
                    return o.policyType === 'Acquire';
                });

                if (oper) {
                    wallet.pin = $filter('generateCode')(oper.idAccountant);
                } else {
                    quantionApi.getAccountant({"wallet": wallet.uuidVirtualWallet, "concept": "Wallet", "limit": 10, "check": "Out", "remote": true}).then(function (dataResponse) {
                        var oper = dataResponse.data.find(function (o) {
                            return o.policyType === 'Acquire';
                        });

                        if (oper) {
                            wallet.pin = $filter('generateCode')(oper.idAccountant);
                        }
                    });
                }
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.ver_mas', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_ver_mas', {
            url: '/habitaciones/:ip',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/ver_mas/ver_mas.html',
                    controller: 'ver_masHabitacionController as vm'
                }
            },
            data: {
                authorization: true
            }
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/ver_mas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.ver_mas')
            .controller('ver_masHabitacionController', ver_masHabitacionController);

    /** @ngInject */
    function ver_masHabitacionController(quantionApi, JSONconfig, $stateParams, $translate, $scope, $mdDialog, $mdToast, $state, $rootScope, $filter, incidencesStateService, IncidencesConfig)
    {
        'use strict';
        var vm = this;
        $rootScope.seccion = 'HABITACIONES_VERMAS';

        $scope.incidencesCardCtrl = incidencesStateService.createCardCtrl($state, IncidencesConfig.urlGestor);

        function syncRoomIncidences() {
            if (!vm.habitacion || !vm.habitacion.room) {
                $scope.listaIncidencias = [];
                $scope.listaPreventivas = [];
                return;
            }

            var roomData = incidencesStateService.getByRoom(vm.habitacion.room);
            $scope.listaIncidencias = roomData.incidences;
            $scope.listaPreventivas = roomData.prevents;
        }

        if (!$stateParams.ip) {
            $state.go('app.Quantion_habitaciones_listado');
            return;
        }

        vm.tipoFront = JSONconfig;

        vm.role = $rootScope.user.userRole;

        vm.ipPattern = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$';
        vm.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';

        $scope.$translate = $translate;

        CargarStb();

        function CargarStb() {
            quantionApi.getStb($stateParams.ip).then(function (dataResponse) {
                vm.habitacion = dataResponse.data;

                if (vm.habitacion.properties.wifiAp && vm.habitacion.properties.wifiAp.bssid && vm.habitacion.properties.wifiAp.bssid.match(/([0-9A-Fa-f]{2}[-:]){5}[0-9A-Fa-f]{2}/)) {
                    quantionApi.getRuckusApByMac(vm.habitacion.properties.wifiAp.bssid).then(function (dataResponse) {
                        $scope.assignedAp = dataResponse.data;
                    });
                }

                quantionApi.getUptime(vm.habitacion.idStb).then(function (dataResponse) {
                    if (!dataResponse.data)
                        return;

                    vm.habitacion.uptime = dataResponse.data;

                    if (dataResponse.data.uptime) {
                        var horas = dataResponse.data.uptime.split('h');
                        var h = parseInt(horas[0]);

                        if (h >= 24) {
                            var h1 = parseInt(h / 24);
                            var h2 = h % 24;
                            vm.habitacion.uptime.uptime = h1 + "d " + h2 + "h" + horas[1];
                        }
                    }

                    var knownTags = {
                        "Hongever USB Audio and HID": "Mando",
                        "Castles Technology Co., Ltd EZUSB PC/SC Smart Card Reader": "Lector SmartCard",
                        "Ralink Technology, Corp. RT5370 Wireless Adapter": "Dongle WiFi",
                        "Sycreader RFID Technology Co., Ltd SYC ID&IC USB Reader": "Lector RFID",

                        "eth": "Interfaz cableada",
                        "wlan": "Interfaz WiFi"
                    };

                    vm.habitacion.uptime.usbList2 = $filter('orderBy')(dataResponse.data.usbList).map(function (elm) {
                        var a = knownTags[elm.trim()];
                        var b = elm.trim().indexOf('eth') === 0;
                        var c = elm.trim().indexOf('wlan') === 0;
                        var d = elm.trim().toLowerCase().includes('omnikey') ? 'Lector Omnikey ' + elm.split(' ').pop() : false;
                        var e = elm.trim().toLowerCase().includes('c3po') ? 'Lector C3PO ' + elm.split(' ').pop() : false;

                        if (a)
                            return {
                                known: true,
                                name: '(' + a + ') ' + elm,
                                color: 'red'
                            };
                        else if (b)
                            return {
                                known: true,
                                name: '(' + knownTags['eth'] + ') ' + elm,
                                color: 'blue'
                            };
                        else if (c)
                            return {
                                known: true,
                                name: '(' + knownTags['wlan'] + ') ' + elm,
                                color: 'darkorange'
                            };
                        else if (d)
                            return {
                                known: true,
                                name: '(' + d + ') ' + elm,
                                color: 'green'
                            };
                        else if (e)
                            return {
                                known: true,
                                name: '(' + e + ') ' + elm,
                                color: 'mediumpurple'
                            };
                        else
                            return {
                                known: false,
                                name: elm
                            };
                    });

                    if (vm.habitacion.uptime && vm.habitacion.uptime.ap && vm.habitacion.uptime.ap.match(/([0-9A-Fa-f]{2}[-:]){5}[0-9A-Fa-f]{2}/)) {
                        quantionApi.getRuckusApByMac(vm.habitacion.uptime.ap).then(function (dataResponse) {
                            $scope.connectedAp = dataResponse.data;
                        });
                    }

                    $scope.signalStatusPercent = $filter('signalToPercent')(vm.habitacion.uptime.signal, -90, -30);

                    if ($scope.signalStatusPercent < 25) {
                        $scope.signalStatus = 'bad';
                    } else if ($scope.signalStatusPercent < 60) {
                        $scope.signalStatus = 'ok';
                    } else {
                        $scope.signalStatus = 'good';
                    }
                });

                quantionApi.getStatus(vm.habitacion.mac).then(function (dataResponse) {
                    var now2minutesAgo = new Date();
                    now2minutesAgo.setMinutes(now2minutesAgo.getMinutes() - 2);

                    if (dataResponse.data.ultConexion < now2minutesAgo) {
                        vm.habitacion.status = {
                            ultConexion: dataResponse.data.ultConexion,
                            currentScreen: $filter('translate')('ESTADISTICAS.SCREENS.OFF'),
                            currentInfo: "OFF",
                            currentShadow: "OFF",
                            currentStatus: "OFF"
                        };
                    } else {
                        vm.habitacion.status = {
                            ultConexion: dataResponse.data.ultConexion,
                            currentScreen: $filter('translateStat')(dataResponse.data.currentScreen),
                            currentInfo: dataResponse.data.currentInfo || "null",
                            currentShadow: dataResponse.data.currentShadow || "null",
                            currentStatus: dataResponse.data.currentStatus
                        };
                    }
                });

                quantionApi.getDispositivosConectados(vm.habitacion.ip, vm.habitacion.properties.wifiPassword).then(function (dataResponse) {
                    vm.habitacion.wifiList = angular.isArray(dataResponse.data) ? dataResponse.data : [];
                });

                syncRoomIncidences();

                if (!incidencesStateService.getState().lastRefresh) {
                    incidencesStateService.refresh().then(syncRoomIncidences);
                }

                $scope.$on('incidencesReceived', syncRoomIncidences);
                $scope.$on('preventsReceived', syncRoomIncidences);

                if (vm.habitacion.typeWallet === 'virtual' && $rootScope.user.mapRole.actions.WALLET_PINCODE) {
                    quantionApi.getAccountant({"wallet": vm.habitacion.wallet.identifier, "concept": "Wallet", "limit": 10, "check": "Out"}).then(function (dataResponse) {
                        $scope.lastCheckinOperation = dataResponse.data.find(function (o) {
                            return o.policyType === 'Acquire';
                        });

                        if (!$scope.lastCheckinOperation) {
                            quantionApi.getAccountant({"wallet": vm.habitacion.wallet.identifier, "concept": "Wallet", "limit": 10, "check": "Out", "remote": true}).then(function (dataResponse) {
                                $scope.lastCheckinOperation = dataResponse.data.find(function (o) {
                                    return o.policyType === 'Acquire';
                                });
                            });
                        }
                    });
                }
            }, function () {
                $state.go('app.Quantion_habitaciones_listado');
            });
        }

        $scope.back = function () {
            history.back();
        };

        quantionApi.getPuntosAcceso().then(function (dataResponse) {
            vm.puntosAcceso = dataResponse.data;

            vm.mapAps = {};
            $.each(vm.puntosAcceso, function (index, value) {
                vm.mapAps[value.bssid && value.bssid.toLowerCase()] = value;
            });
        });

//************************************* Conexion VNC *************************************
        vm.connectVNC = function (ev) {
            quantionApi.connectVNC(vm.habitacion.idStb).then(function (dataResponse) {
//                window.open('https://admin.solertia.sol/plugin-vnc/vnc.html?host=' + vm.habitacion.ip + '&port=5900&autoconnect=true&resize=scale&password=', '_blank');
                var win = window.open(JSONconfig.urlVNC(vm.habitacion.ip, vm.habitacion.model), '_blank');
                if (win === null || typeof (win) === 'undefined') {
                    alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                }

//                $mdDialog.show({
//                    controller: VNCController,
//                    templateUrl: 'app/main/Quantion/habitaciones/ver_mas/vnc.tmpl.html',
//                    parent: angular.element(document.body),
//                    targetEvent: ev,
//                    clickOutsideToClose: true,
//                    locals: {stb: vm.habitacion}
//                });
            }, function () {
                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(false)
                        .title($filter('translate')('PRINCIPAL.ERRORVNC.TITLE'))
                        .textContent($filter('translate')('PRINCIPAL.ERRORVNC.CONTENT'))
                        .ok($filter('translate')('PRINCIPAL.ERRORVNC.OK'))
                        .targetEvent(ev)
                        );
            });
        };

        function VNCController($scope, $mdDialog, stb) {
            $scope.ip = stb.ip;

            $scope.selectIP = function () {
                document.getElementById("formIP").focus();
                document.execCommand('copy');
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        $scope.getAps = function () {
            $scope.loadingAps = true;
            quantionApi.getApsDisponibles(vm.habitacion.idStb).then(function (dataResponse) {
                $scope.loadingAps = false;
                console.log(dataResponse.data);
                vm.listaAps = dataResponse.data;
            }, function () {
                $scope.loadingAps = false;
                vm.listaAps = [];
            });
        };

//************************************* Reinicio *************************************
        vm.mostrarConfirmacionReinicio = function (ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PRINCIPAL.MODALREINICIO.TITLE', {stbroom: vm.habitacion.room}))
                    .ariaLabel('Reinicio')
                    .targetEvent(ev)
                    .ok($filter('translate')('PRINCIPAL.MODALREINICIO.OK'))
                    .cancel($filter('translate')('PRINCIPAL.MODALREINICIO.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootStb(vm.habitacion.idStb).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('PRINCIPAL.MODALREINICIO.TOAST'))
                            .position('top right')
                            .hideDelay(5000)
                            );
                });
            });
        };

//************************************* Recarga interfaz *************************************
        vm.mostrarConfirmacionRecargaInterfaz = function (ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PRINCIPAL.MODALRECARGA.TITLE', {stbroom: vm.habitacion.room}))
                    .ariaLabel('Recargar interfaz')
                    .targetEvent(ev)
                    .ok($filter('translate')('PRINCIPAL.MODALRECARGA.OK'))
                    .cancel($filter('translate')('PRINCIPAL.MODALRECARGA.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootInterface(vm.habitacion.idStb).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('PRINCIPAL.MODALRECARGA.TOAST'))
                            .position('top right')
                            .hideDelay(5000)
                            );
                });
            });
        };

//************************************* EVENTO RÁPIDO *************************************
        vm.mostrarVentanaEventoRapido = function (ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/Quantion/habitaciones/ver_mas/avisoRapido.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {stb: vm.habitacion}
            });
        };

        //Controlador para la ventana de aviso rápido
        function DialogController($scope, $mdDialog, stb) {

            $scope.event = {
                metodo: "POST",
                header: {
                    wakeup: true,
                    properties: {
                        "frame": {
                            "color1": "#2b3e4a",
                            "color2": "#2b3e4a",
                            "theme": "custom",
                            "position": "down-mini",
                            "time": 30,
                            "opacity": 90
                        },
                        "desc": {
                            "pointSize": 22,
                            "color": "#ffffff",
                            "text": "",
                            "family": "URW Gothic L"
                        },
                        "title": {}
                    }
                },
                arguments: {
                    "qt": true,
                    "type": "simple"
                },
                command: "notification",
                type: 'event',
                stbs: [stb.idStb]
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.enviar = function () {

                var copy = angular.copy($scope.event);

                copy.displaytime = copy.header.properties.frame.time;
                copy.description = copy.header.properties.desc.text;

                copy.header.properties.frame.time = copy.header.properties.frame.time * 1000;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title($filter('translate')('AVISO.ALERT.TITLE'))
                            .ariaLabel('Enviado')
                            .ok($filter('translate')('AVISO.ALERT.OK'))
                            );
                }, function (dataResponse) {
                    console.log(dataResponse);
                });
            };
        }

        //****** Compras *************
        vm.mostrarCompras = function (ev) {
            $mdDialog.show({
                controller: comprasCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/ver_mas/compras.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {stb: vm.habitacion}
            });
        };

        function comprasCtrl($scope, $mdDialog, stb) {
            $scope.activeServices = stb.wallet.services;
            $scope.$translate = $translate;

            quantionApi.getAccountant({stb: stb.idStb, check: 'In'}).then(function (dataResponse) {
                $scope.listaOperaciones = dataResponse.data;
            });

            $scope.transPayment = {
                'Balance': 'OPERACIONES.PAYMENT.BALANCE',
                'Cash': 'OPERACIONES.PAYMENT.CASH',
                'Card': 'OPERACIONES.PAYMENT.CARD',
                'PendingGive': 'OPERACIONES.PAYMENT.PENDINGGIVE',
                'PendingReceive': 'OPERACIONES.PAYMENT.PENDINGRECEIVE',
                'Cortesy': 'OPERACIONES.PAYMENT.CORTESY',
                'None': 'OPERACIONES.PAYMENT.NONE',
                'Paypal': 'OPERACIONES.PAYMENT.PAYPAL'
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }

        vm.verOperaciones = function () {
            var params = {};
            if (vm.habitacion.wallet.type === 'virtual')
                params.idStb = '_' + vm.habitacion.wallet.identifier;
            else
                params.idStb = vm.habitacion.idStb;

            $state.go('app.Quantion_gestionCompras_operaciones', params);
        };

        $scope.getCardLog = function () {
            window.open(quantionApi.getCardLog(vm.habitacion.ip), '_blank');
        };

        $scope.moveWallet = function (ev) {
            $mdDialog.show({
                controller: VinculaCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/wallets/templates/vinculaStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {wallet: vm.habitacion.wallet}
            });
        };

        function VinculaCtrl($scope, $mdDialog, $mdToast, wallet) {

            quantionApi.getStbs(true).then(function (dataResponse) {
                $scope.listaStbs = $filter('orderBy')(dataResponse.data, 'room|tryParseInt');
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                quantionApi.VincularStbWallet($scope.stbSelected.idStb, wallet.identifier).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.VINCULAR.TOAST')).position('top right').hideDelay(5000));
                    quantionApi.getStbWallet(vm.habitacion.idStb).then(function (dataResponse) {
                        vm.habitacion.wallet = dataResponse.data;
                    });
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            };
        }

        $scope.changeRoom = function (ev) {
            $mdDialog.show({
                controller: ChangeRoomCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/cambiohabitacion.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {stb: vm.habitacion}
            });
        };

        function ChangeRoomCtrl($scope, $mdDialog, $mdToast, stb) {
            $scope.title = 'VERMAS.MOVEPERSONAL';

            $scope.options = {
                merge: true,
                checkout: true
            };

            $scope.checkoutDest = false;

            quantionApi.getStbs(true, true).then(function (dataResponse) {
                $scope.listaStbs = $filter('orderBy')(dataResponse.data, 'room|tryParseInt');
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                if ($scope.checkoutDest) {
                    quantionApi.updateCheck($scope.stbSelected.idStb, 'Out').then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.TOAST')).position('top right').hideDelay(3000));

                        quantionApi.changeRoom(stb.idStb, $scope.stbSelected.idStb, $scope.options).then(function (dataResponse) {
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('VERMAS.MOVEPERSONAL_TOAST')).position('top right').hideDelay(5000));
                            CargarStb();
                            $scope.hide();
                            $scope.dataLoading = false;
                        }, function (dataResponse) {
                            console.error(dataResponse);
                            $scope.dataLoading = false;
                        });
                    }, function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.ERROR')).position('top right').hideDelay(3000));
                        $scope.dataLoading = false;
                    });
                } else {
                    quantionApi.changeRoom(stb.idStb, $scope.stbSelected.idStb, $scope.options).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('VERMAS.MOVEPERSONAL_TOAST')).position('top right').hideDelay(5000));
                        CargarStb();
                        $scope.hide();
                        $scope.dataLoading = false;
                    }, function (dataResponse) {
                        console.error(dataResponse);
                        $scope.dataLoading = false;
                    });
                }
            };
        }

        $scope.rebootAP = function (ev, ap) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('APS.MODAL_REBOOT.TITLE'))
                    .content($filter('translate')('APS.MODAL_REBOOT.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('APS.MODAL_REBOOT.OK'))
                    .cancel($filter('translate')('APS.MODAL_REBOOT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootRuckusApByMac(ap.apMac).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('APS.MODAL_REBOOT.TOAST')).position('top right').hideDelay(3000));
                });
            });
        };

        $scope.showApRuckusInfo = function (ap) {
            $mdDialog.show({
                controller: ApRuckusInfoController,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusDetails.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {puntoAcceso: ap}
            });
        };

        function ApRuckusInfoController($scope, $mdDialog, puntoAcceso) {
            $scope.puntoAcceso = puntoAcceso;

            $scope.puntoAcceso = {
                name: puntoAcceso.deviceName,
                ruckus: {
                    more: {
                        status: puntoAcceso.status,
                        isOverallHealthStatusFlagged: puntoAcceso["isOverallHealthStatusFlagged"],
                        isLatency24GFlagged: puntoAcceso["isLatency24GFlagged"],
                        isCapacity24GFlagged: puntoAcceso["isCapacity24GFlagged"],
                        isConnectionFailure24GFlagged: puntoAcceso["isConnectionFailure24GFlagged"],
                        isLatency50GFlagged: puntoAcceso["isLatency50GFlagged"],
                        isCapacity50GFlagged: puntoAcceso["isCapacity50GFlagged"],
                        isConnectionFailure50GFlagged: puntoAcceso["isConnectionFailure50GFlagged"],
                        isConnectionTotalCountFlagged: puntoAcceso["isConnectionTotalCountFlagged"],
                        isConnectionFailureFlagged: puntoAcceso["isConnectionFailureFlagged"],
                        isAirtimeUtilization24GFlagged: puntoAcceso["isAirtimeUtilization24GFlagged"],
                        isAirtimeUtilization50GFlagged: puntoAcceso["isAirtimeUtilization50GFlagged"],

                        numClients: puntoAcceso["numClients"],
                        numClients24G: puntoAcceso["numClients24G"],
                        numClients5G: puntoAcceso["numClients5G"],
                        capacity: puntoAcceso["capacity"] + '%',
                        capacity24G: puntoAcceso["capacity24G"] + '%',
                        capacity50G: puntoAcceso["capacity50G"] + '%',
                        airtime24G: puntoAcceso["airtime24G"] + '%',
                        airtime5G: puntoAcceso["airtime5G"] + '%',
                        latency24G: (puntoAcceso["latency24G"] / 1000) + 'ms',
                        latency50G: (puntoAcceso["latency50G"] / 1000) + 'ms',
                        channel24G: puntoAcceso["channel24G"],
                        channel5G: puntoAcceso["channel5G"],
                        connectionFailure: (puntoAcceso["connectionFailure"] * 100) + '%',
                    }
                }
            };

            $scope.booleanProps = ['isOverallHealthStatusFlagged', 'isLatency24GFlagged', 'isCapacity24GFlagged', 'isConnectionFailure24GFlagged', 'isLatency50GFlagged', 'isCapacity50GFlagged', 'isConnectionFailure50GFlagged', 'isConnectionTotalCountFlagged', 'isConnectionFailureFlagged', 'isAirtimeUtilization24GFlagged', 'isAirtimeUtilization50GFlagged'];
            $scope.numericProps = ['numClients', 'numClients24G', 'numClients5G', 'capacity', 'capacity24G', 'capacity50G', 'airtime24G', 'airtime5G', 'latency24G', 'latency50G', 'channel24G', 'channel5G', 'connectionFailure'];

            $scope.hide = $mdDialog.hide;

            $scope.loadingClients = false;
            quantionApi.getRuckusApsClientsByMac(puntoAcceso.apMac).then(function (dataResponse) {
                $scope.clients = dataResponse.data.clients;
                $scope.loadingClients = false;
            }, function () {
                $scope.loadingClients = false;
            });
        }

        $scope.showApRuckusEvents = function (ap) {
            $mdDialog.show({
                controller: ApRuckusEventsController,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusEvents.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {puntoAcceso: ap}
            });
        };

        function ApRuckusEventsController($scope, $mdDialog, puntoAcceso) {
            $scope.hide = $mdDialog.hide;

            $scope.loadingEvents = true;

            if (puntoAcceso) {
                quantionApi.getRuckusEventsByMac(puntoAcceso.apMac).then(function (dataResponse) {
                    $scope.events = dataResponse.data.list;
                    $scope.loadingEvents = false;
                }, function () {
                    $scope.loadingEvents = false;
                });
            } else {
                quantionApi.getRuckusEvents().then(function (dataResponse) {
                    $scope.events = dataResponse.data.list;
                    $scope.loadingEvents = false;
                }, function () {
                    $scope.loadingEvents = false;
                });
            }
        }

        $scope.showApRuckusAlarms = function (ap) {
            $mdDialog.show({
                controller: ApRuckusAlarmsController,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusAlarms.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {puntoAcceso: ap}
            });
        };

        function ApRuckusAlarmsController($scope, $mdDialog, puntoAcceso) {
            $scope.hide = $mdDialog.hide;

            $scope.loadingAlarms = true;

            if (puntoAcceso) {
                quantionApi.getRuckusAlarmsByMac(puntoAcceso.apMac).then(function (dataResponse) {
                    $scope.alarms = dataResponse.data.list;
                    $scope.loadingAlarms = false;
                }, function () {
                    $scope.loadingAlarms = false;
                });
            } else {
                quantionApi.getRuckusAlarms().then(function (dataResponse) {
                    $scope.alarms = dataResponse.data.list;
                    $scope.loadingAlarms = false;
                }, function () {
                    $scope.loadingAlarms = false;
                });
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.voip', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_voip', {
            url: '/voip',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/voip/voip.html',
                    controller: 'voipController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/voip');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.voip')
            .controller('voipController', voipController);

    /** @ngInject */
    function voipController(quantionApi, $mdDialog, $mdToast, $filter, $scope, $translate, $rootScope, $timeout)
    {
        var vm = this;
        $rootScope.seccion = 'HABITACIONES_VOIP';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.$translate = $translate;

        $scope.numberOfPages = function () {
            if (!$scope.listaStbsFiltered)
                return 0;

            var a = Math.floor($scope.listaStbsFiltered.length / $scope.pageSize);
            if ($scope.currentPage > a)
                $scope.currentPage = a;
            return a;
        };

        $scope.filterStbs = function () {
            $scope.listaStbsFiltered = $filter('filter')(vm.listaStbs, $scope.search);
        };

        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        CargarExtensiones(true);
        function CargarExtensiones(init) {
            pantallaCarga.lsEnable('LS.DATOSVOIP');

            vm.listaStbs = [];
            $scope.listaStbsFiltered = [];

            quantionApi.getExtensionesStb().then(function (dataResponse) {
                vm.listaStbs = $filter('orderBy')(dataResponse.data, 'room');

                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();

                if (init)
                    initTable();

                $scope.filterStbs(dataResponse.data);

                quantionApi.getExtensiones().then(function (dataResponse) {
                    $scope.listaExtensiones = dataResponse.data.filter(function (e) {
                        return e.special;
                    });
                });
            }, function () {
                pantallaCarga.lsDisable();
            });
        }

        function initTable() {
            $scope.search = '';
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.orderProp = 'room';
            $scope.orderReverse = false;
        }

        vm.editarExtensionStb = function (ev, stb) {
            $mdDialog.show({
                controller: ExtensionStbCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/editarExtensionStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    stb: stb
                }
            });
        };

        function ExtensionStbCtrl($scope, $mdDialog, $mdToast, stb) {
            $scope.stb = angular.copy(stb);
            if (!$scope.stb.extension)
                $scope.stb.extension = {
                    usuario: '',
                    number: '',
                    password: ''
                };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson({
                    extension: $scope.stb.extension
                });
                console.log(jsonObj);

                quantionApi.patchStb($scope.stb.idStb, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.MODTOAST")).position('top right').hideDelay(5000));
                    CargarExtensiones();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = dataResponse.data.reason;
                    $scope.dataLoading = false;
                });
            };
        }

        vm.editarExtension = function (ev, extension) {
            $mdDialog.show({
                controller: ExtensionCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/editarExtension.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    extension: extension
                }
            });
        };

        function ExtensionCtrl($scope, $mdDialog, $mdToast, extension) {
            $scope.extension = angular.copy(extension);

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                $scope.extension.special = true;

                var jsonObj = angular.toJson($scope.extension);
                console.log(jsonObj);

                quantionApi.updateExtension(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.MODTOAST")).position('top right').hideDelay(5000));
                    CargarExtensiones();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = dataResponse.data.reason;
                    $scope.dataLoading = false;
                });
            };
        }

        vm.addExtension = function (ev) {
            $mdDialog.show({
                controller: AddExtensionCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/editarExtension.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AddExtensionCtrl($scope, $mdDialog, $mdToast) {
            $scope.extension = {
                special: true
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson($scope.extension);
                console.log(jsonObj);

                quantionApi.addExtension(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.CREARTOAST")).position('top right').hideDelay(5000));
                    CargarExtensiones();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            };
        }

        vm.eliminarExtension = function (ev, extension) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('VOIP.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('VOIP.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('VOIP.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('VOIP.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteExtension(extension.idExtension).then(function (dataResponse) {
                    CargarExtensiones();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.ELIMINARTOAST")).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert().clickOutsideToClose(true)
                            .title($filter('translate')('VOIP.ERRORELIMINAR.TITLE'))
                            .ariaLabel('Error eliminar extension')
                            .ok($filter('translate')('VOIP.ERRORELIMINAR.CERRAR')));
                });
            });
        };

        vm.eliminarExtensionStb = function (ev, stb) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('VOIP.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('VOIP.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('VOIP.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('VOIP.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson({
                    extension: null
                });
                console.log(jsonObj);

                quantionApi.patchStb(stb.idStb, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.MODTOAST")).position('top right').hideDelay(5000));
                    CargarExtensiones();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = dataResponse.data.reason;
                    $scope.dataLoading = false;
                });
            });
        };

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.listaIdiomas = dataResponse.data;
        });

        vm.verTarifas = function (ev) {
            $mdDialog.show({
                controller: TarifasCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/tarifas.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function TarifasCtrl($scope, $mdDialog, $mdToast, $mdSidenav) {
            $scope.listaIdiomas = vm.listaIdiomas;

            CargarTarifas();
            function CargarTarifas() {
                quantionApi.getTarifas().then(function (dataResponse) {
                    $scope.listaTarifas = dataResponse.data;
                });
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.editarTarifa = function (tarifa) {
                $scope.tarifa = angular.copy(tarifa);
                var obj = {};
                $.each($scope.tarifa.description, function (index, value) {
                    obj[value.language] = value.value;
                });
                $scope.tarifa.description = obj;

                $mdSidenav('right').open();
                console.log($scope.tarifa, tarifa);
            };

            $scope.addTarifa = function () {
                $scope.tarifa = {};
                $mdSidenav('right').open();
            };

            $scope.eliminarTarifa = function (tarifa) {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('VOIP.TARIFAS.MODAL.TITLE'))
                        .textContent($filter('translate')('VOIP.TARIFAS.MODAL.CONTENT'))
                        .ok($filter('translate')('VOIP.TARIFAS.MODAL.OK'))
                        .cancel($filter('translate')('VOIP.TARIFAS.MODAL.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                    quantionApi.deleteTarifa(tarifa.idTarification).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.TARIFAS.TOAST")).position('top right').hideDelay(3000));
                        vm.verTarifas();
                    }, function (dataResponse) {
                        console.error(dataResponse);
                    });
                }, function () {
                    vm.verTarifas();
                });
            };

            $scope.guardar = function () {
                var obj = angular.copy($scope.tarifa);

                var arr = [];
                $.each(obj.description, function (key, value) {
                    arr.push({'language': key, 'value': value});
                });
                obj.description = arr;

                var jsonObj = angular.toJson(obj);

                if (obj.idTarification) {
                    quantionApi.updateTarifa(jsonObj).then(function (dataResponse) {
                        CargarTarifas();
                        $mdSidenav('right').close();
                    });
                } else {
                    quantionApi.addTarifa(jsonObj).then(function (dataResponse) {
                        CargarTarifas();
                        $mdSidenav('right').close();
                    });
                }
            };
        }

        vm.verListaLlamadas = function (ev) {
            $mdDialog.show({
                controller: KnocksCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/knocks.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function KnocksCtrl($scope, $mdDialog, $filter) {
            $scope.busqueda = {
                extension: '',
                ini: new Date((new Date()).toDateString()),
                fin: new Date((new Date()).toDateString())
            };

            $scope.buscar = function () {
                var fin = $scope.busqueda.fin;
                fin.setDate(fin.getDate() + 1);

                var obj = {
                    extension: $scope.busqueda.extension,
                    ini: $filter('date')($scope.busqueda.ini, 'yyyy-MM-dd'),
                    fin: $filter('date')(fin, 'yyyy-MM-dd')
                };

                quantionApi.getLlamadasTotal(obj).then(function (dataResponse) {
                    $scope.listaLlamadas = dataResponse.data;
                    $scope.listaLlamadas.reverse();
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        // Agenda
        CargarAgenda();
        function CargarAgenda() {
            quantionApi.getDiarys().then(function (dataResponse) {
                vm.listaDiarys = $filter('orderBy')(dataResponse.data, ['orden', 'name|formatNameDesc']);
            }, function () {
            });
        }

        vm.addDiary = function (ev) {
            $mdDialog.show({
                controller: AddDiaryCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/editarDiary.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AddDiaryCtrl($scope, $mdDialog, $mdToast, FilePaths) {
            if (vm.listaIdiomas) {
                $scope.idiomas = vm.listaIdiomas;
            } else {
                quantionApi.getIdiomas().then(function (dataResponse) {
                    vm.listaIdiomas = dataResponse.data;
                    $scope.idiomas = dataResponse.data;
                });
            }

            if (vm.listaDiaryLogos) {
                $scope.listaLogos = vm.listaDiaryLogos;
            } else {
                quantionApi.getGenericFiles(FilePaths.diarys).then(function (dataResponse) {
                    vm.listaDiaryLogos = dataResponse.data.files;
                    $scope.listaLogos = dataResponse.data.files;
                });
            }

            quantionApi.getGruposMin().then(function (dataResponse) {
                $scope.listaGrupos = dataResponse.data.map(function (gr) {
                    return gr.nombre;
                });
            });

            $scope.diary = {
                nameInt: {},
                descriptionInt: {}
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson($scope.diary);
                console.log(jsonObj);

                quantionApi.addDiary(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.CREARDIARYTOAST")).position('top right').hideDelay(5000));
                    CargarAgenda();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            };
        }

        vm.editarDiary = function (ev, diary) {
            $mdDialog.show({
                controller: UpdateDiaryCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/voip/templates/editarDiary.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    diary: diary
                }
            });
        };

        function UpdateDiaryCtrl($scope, $mdDialog, $mdToast, diary, FilePaths) {
            $scope.diary = angular.copy(diary);
            delete $scope.diary.name;
            delete $scope.diary.description;

            if (vm.listaIdiomas) {
                $scope.idiomas = vm.listaIdiomas;
            } else {
                quantionApi.getIdiomas().then(function (dataResponse) {
                    vm.listaIdiomas = dataResponse.data;
                    $scope.idiomas = dataResponse.data;
                });
            }

            if (vm.listaDiaryLogos) {
                $scope.listaLogos = vm.listaDiaryLogos;
            } else {
                quantionApi.getGenericFiles(FilePaths.diarys).then(function (dataResponse) {
                    vm.listaDiaryLogos = dataResponse.data.files;
                    $scope.listaLogos = dataResponse.data.files;
                });
            }

            quantionApi.getGruposMin().then(function (dataResponse) {
                $scope.listaGrupos = dataResponse.data.map(function (gr) {
                    return gr.nombre;
                });
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.diary);

                quantionApi.updateDiary(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.MODDIARYTOAST")).position('top right').hideDelay(5000));
                    CargarAgenda();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = dataResponse.data.reason;
                    $scope.dataLoading = false;
                });
            };
        }

        vm.eliminarDiary = function (ev, diary) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('VOIP.MODALELIMINARDIARY.TITLE'))
                    .textContent($filter('translate')('VOIP.MODALELIMINARDIARY.CONTENT'))
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .ok($filter('translate')('VOIP.MODALELIMINARDIARY.OK'))
                    .cancel($filter('translate')('VOIP.MODALELIMINARDIARY.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteDiary(diary.idDiary).then(function (dataResponse) {
                    CargarAgenda();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.ELIMINARTOASTDIARY")).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')("VOIP.ERRORELIMINARTOASTDIARY")).position('top right').hideDelay(3000));
                });
            });
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.unprovisioned', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_unprovisioned', {
            url  : '/unprovisioned',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/unprovisioned/unprovisioned.html',
                    controller : 'unprovisionedController as vm'
                }
            },
            data: {
                authorization: true
            }
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/unprovisioned');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.unprovisioned')
            .controller('unprovisionedController', unprovisionedController);

    /** @ngInject */
    function unprovisionedController($scope, quantionApi, $mdDialog, $rootScope, $mdToast, JSONconfig, $translate, $location, $filter, $state, dirayaApi)
    {
        'use strict';

        var vm = this;
        $rootScope.seccion = 'HABITACIONES_LISTADO';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.JSONconfig = JSONconfig;

        pantallaCarga.lsEnable('LS.GENERIC');
        $scope.$on('onRepeatLast', function () {
            pantallaCarga.lsDisable();
        });

        $scope.$translate = $translate;

        //Carga de los datos
        vm.CargarStbs = function (inicializarParametrosTabla) {
            pantallaCarga.lsEnable();
//            console.time('Carga');
            vm.habitacionesRecibidas = [];
            $scope.filtered = [];

            if (inicializarParametrosTabla)
                initTable();

            quantionApi.getUnprovisioned().then(function (dataResponse) {
                vm.habitacionesRecibidas = dataResponse.data;

                if (vm.habitacionesRecibidas.length === 0) {
                    pantallaCarga.lsDisable();
                }

                if ($scope.search || $scope.filtroEstado)
                    $scope.filterStbs();
                else
                    $scope.filtered = vm.habitacionesRecibidas;

            }, function () {
                pantallaCarga.lsDisable();
            });
        };
        vm.CargarStbs(true);//Carga inicial

        //*********** TABLA **************
        function initTable() {
            $scope.search = localStorage['search2'] || '';
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.filtroEstado = '';
            $scope.orderProp = 'room';
            $scope.orderReverse = false;

            vm.allProperties = ['ip', "mac", "lastMacs", "firstSeen", "lastSeen", 'retryCount', 'viewed.lastBios', 'viewed.lastDynamic', 'viewed.lastSystem', 'viewed.lastSystemInstallation', 'viewed.lastSystemUpdate'];
            vm.tableOptions = localStorage['vm.tableOptions2'] ? angular.fromJson(localStorage['vm.tableOptions2']) : {
                ip: true,
                mac: true,
                "firstSeen": true,
                "lastSeen": true,
                "retryCount": true
            };

            vm.searchProperties = ['ip', "mac", "lastMacs", 'viewed.lastBios', 'viewed.lastDynamic', 'viewed.lastSystem', 'viewed.lastSystemInstallation', 'viewed.lastSystemUpdate'];
            vm.searchOptions = localStorage['vm.searchOptions2'] ? angular.fromJson(localStorage['vm.searchOptions2']) : {
                ip: true,
                mac: true
            };
        }

        $scope.numberOfPages = function () {
            var a = Math.ceil($scope.filtered.length / $scope.pageSize) || 1;
            if ($scope.currentPage > a)
                $scope.currentPage = (a - 1);
            return a;
        };

        $scope.filterStbs = function () {
            $scope.filtered = vm.habitacionesRecibidas.filter(function (value) {
                var b = false;

                $.each(vm.searchOptions, function (key, value2) {
                    if (value2) {
                        var k = pathIndex(value, key);

                        if (k) {
                            var p = angular.isObject(k) ? angular.toJson(k) : k.toString();
                            if (angular.lowercase(p).indexOf(angular.lowercase($scope.search)) >= 0)
                                b = true;
                        }
                    }
                });
                return b;
            });

            if ($scope.filtered.length === 0)
                pantallaCarga.lsDisable();

            function multiIndex(obj, is) {  // obj,['1','2','3'] -> ((obj['1'])['2'])['3']
                if (obj)
                    return is.length ? multiIndex(obj[is[0]], is.slice(1)) : obj;
            }
            function pathIndex(obj, is) {   // obj,'1.2.3' -> multiIndex(obj,['1','2','3'])
                return multiIndex(obj, is.split('.'));
            }

            localStorage['search2'] = $scope.search;
        };

        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        //************ /TABLA ***************

        //************ Eliminar ***************
        vm.eliminarStb = function (ev, stb) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('ELIMINAR.TITLE'))
                    .textContent($filter('translate')('ELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('ELIMINAR.OK'))
                    .cancel($filter('translate')('ELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('');

                quantionApi.deleteUnprovisionedByMac(stb.mac).then(function (dataResponse) {
                    pantallaCarga.lsDisable();
                    vm.CargarStbs();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('ELIMINAR.TOAST')).position('top right').hideDelay(3000));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al eliminar').action('OK').highlightAction(false).position('top right'));
                    pantallaCarga.lsDisable();
                });
            });
        };

        //********************** PROPIEDADES TABLA *****************************
        vm.tableProperties = function (ev) {
            $mdDialog.show({
                controller: PropCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/unprovisioned/templates/tableProperties.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function () {
                    localStorage['vm.tableOptions2'] = angular.toJson(vm.tableOptions, 0);
                    localStorage['vm.searchOptions2'] = angular.toJson(vm.searchOptions, 0);
                }
            });
        };

        function PropCtrl($scope, $mdDialog) {
            $scope.allProperties = vm.allProperties;
            $scope.tableOptions = vm.tableOptions;

            $scope.searchProperties = vm.searchProperties;
            $scope.searchOptions = vm.searchOptions;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.setDefault = function () {
                vm.tableOptions = {
                    ip: true,
                    mac: true,
                    "firstSeen": true,
                    "lastSeen": true,
                    "retryCount": true
                };

                $scope.tableOptions = vm.tableOptions;

                vm.searchOptions = {
                    ip: true,
                    mac: true
                };

                $scope.searchOptions = vm.searchOptions;
            };
        }

        //******************* Nuevo *********************
        vm.provisionar = function (ev, hab) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/editar.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {hab: hab}
            });
        };

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.idiomas = dataResponse.data;
        });

        quantionApi.getInstalacionThemes().then(function (dataResponse) {
            vm.listaThemes = dataResponse.data;
        });

        quantionApi.getModelos().then(function (dataResponse) {
            vm.listaModelos = $filter('orderBy')(dataResponse.data, 'name');
        });

        quantionApi.getInstalaciones(true).then(function (dataResponse) {
            vm.listaInstalaciones = dataResponse.data;
        });

        quantionApi.getPuntosAcceso().then(function (dataResponse) {
            vm.listaAp = dataResponse.data;
        });

        quantionApi.getAcls().then(function (dataResponse) {
            vm.listaAcls = $filter('orderBy')($.unique(dataResponse.data));
        });

        quantionApi.getFiles('system').then(function (dataResponse) {
            vm.systemList = dataResponse.data;
        });

        function Existe(stb, propiedad) {//Mira si una propiedad de stb coincide con la de los demás
            return vm.habitacionesRecibidas.map(function (e) {
                return e[propiedad];
            }).indexOf(stb[propiedad]) !== -1;
        }

        function NuevoCtrl($scope, $mdDialog, hab) {
            $scope.stb = {
                mac: hab.mac.toUpperCase()
            };
            $scope.listaModelos = vm.listaModelos;
            $scope.listaInstalaciones = vm.listaInstalaciones;
            $scope.listaThemes = vm.listaThemes;
            $scope.listaAp = vm.listaAp;
            $scope.listaAcls = vm.listaAcls;

            $scope.resTags = ['720p (1280x720)', '1080p (1920x1080)', '1080i (1920x1080i)', 'Auto', 'Custom'];
            $scope.listaResoluciones = ['1280x720', '1920x1080', '1920x1080i', '1x1', 'Custom'];

            $scope.listaIdiomas = vm.idiomas;
            $scope.ipPattern = "^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$";
            $scope.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';

            getVersionLists();
            $scope.getVersionLists = getVersionLists;

            $scope.JSONconfig = JSONconfig;
            if (JSONconfig.datosDiraya) {
                $scope.diraya = {
                    room: null,
                    installation: dirayaApi.DOMAIN,
                    cama: null,
                    centro: null,
                    modulo: null,
                    unidadfuncional: null,
                    codigounidad: null,
                };
            }

            $scope.Guardar = function () {
                var stb = angular.copy($scope.stb);
                stb.code = 'yo instalo';

                if ($scope.stb.extension)
                    stb.extension = {
                        number: $scope.stb.extension.number || stb.room,
                        password: "password" + $scope.stb.extension.number,
                        usuario: stb.room,
                        type: "PRE"
                    };

                var jsonObj = angular.toJson(stb, 0);
                $scope.mensajeError = '';
                $scope.cargando = true;

                if (!Existe($scope.stb, 'room') && !Existe($scope.stb, 'mac')) {
                    quantionApi.addStb(jsonObj).then(function (dataResponse) {
                        vm.CargarStbs();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CREAR_STB.TOAST')).position('top right').hideDelay(3000));
                        $scope.cargando = false;
                        $mdDialog.hide();

                        if (JSONconfig.datosDiraya) {
                            $scope.diraya.room = $scope.stb.room;

                            if ($scope.diraya.idDiraya) {
                                dirayaApi.putDirayaRoom($scope.diraya).then(function () {
                                    console.log('PUT Diraya ok')
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                                })
                            } else {
                                dirayaApi.postDirayaRoom($scope.diraya).then(function () {
                                    console.log('POST Diraya ok')
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                                })
                            }
                        }
                    }, function (dataResponse) {
                        $scope.cargando = false;

                        if (dataResponse.status === 401)
                            $scope.mensajeError = 'CREAR.ERROR2';
                    });
                } else {
                    $scope.mensajeError = "CREAR.ERROR1";
                }
            };

            function getVersionLists() {
                if (!$scope.stb || !$scope.stb.model)
                    return;

                var m = vm.listaModelos.filter(function (e) {
                    return e.idStbModel === $scope.stb.model;
                });
                if (m[0]) {
                    $scope.dynamicList = m[0].dynamicList;
                    $scope.systemList = vm.systemList;
                    $scope.biosList = m[0].biosList;

                    $scope.stb.dynamicVersion = null;
//                    $scope.stb.systemVersion = null;
                    $scope.stb.biosVersion = null;
                } else {
                    console.error(m);
                }
            }

            $scope.getInstallationById = getInstallationById;

            function getInstallationById(id) {
                $scope.installationChosed = vm.listaInstalaciones.filter(function (e) {
                    return e.idInstallation === id;
                })[0];
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.modelos', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_modelos', {
            url: '/habitaciones/modelos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/modelos/modelos.html',
                    controller: 'modelosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/modelos');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.modelos')
            .controller('modelosController', modelosController);

    /** @ngInject */
    function modelosController(quantionApi, $mdDialog, $mdToast, $rootScope, $scope, $filter, JSONconfig, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'HABITACIONES_MODELOS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        $scope.JSONconfig = JSONconfig;

        CargarModelos();
        function CargarModelos() {
            pantallaCarga.lsEnable('LS.MODELOSSTB');

            quantionApi.getModelos().then(function (dataResponse) {
                vm.listaModelos = $filter('orderBy')(dataResponse.data, 'name');;

                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();
            });

            quantionApi.getFeaturesModelos().then(function (dataResponse) {
                vm.listaFeatures = dataResponse.data;
            });
        }

        CargarVersiones();
        function CargarVersiones() {
            vm.listaVersiones = {};
            getFiles('dynamic');
            getFiles('system');
            getFiles('bios');
        }
        function getFiles(type) {
            quantionApi.getFiles(type).then(function (dataResponse) {
                vm.listaVersiones[type.toLowerCase() + 'List'] = dataResponse.data;
            });
        }

        vm.eliminarModelo = function (ev, modelo) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('MODELOS.CONFIRMACION.TITLE'))
                    .textContent($filter('translate')('MODELOS.CONFIRMACION.SUBTITLE'))
                    .targetEvent(ev)
                    .ok($filter('translate')('MODELOS.CONFIRMACION.OK'))
                    .cancel($filter('translate')('MODELOS.CONFIRMACION.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteModelo(modelo.idStbModel).then(function (dataResponse) {
                    CargarModelos();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTELIMINAR')).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert().clickOutsideToClose(true)
                            .title($filter('translate')('MODELOS.ERRORELIMINAR.TITLE'))
                            .textContent($filter('translate')('MODELOS.ERRORELIMINAR.CONTENT'))
                            .ariaLabel('Error eliminar modelo')
                            .ok($filter('translate')('MODELOS.ERRORELIMINAR.OK')));
                });
            });
        };

        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/modelos/crearmodelo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    tipo: 'Nuevo',
                    modelo: null
                }
            });
        };

        vm.ventanaEditar = function (ev, modelo) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/modelos/crearmodelo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    tipo: 'Editar',
                    modelo: modelo
                }
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast, tipo, modelo) {
            if (tipo === 'Editar') {
                $scope.windowTitle = $filter('translate')('MODELOS.TITLEEDITAR');

                $scope.modelo = angular.copy(modelo);
            } else {
                $scope.windowTitle = $filter('translate')('MODELOS.TITLECREAR');

                $scope.modelo = {
                    features: []
                };
            }

            $scope.listaFeatures = vm.listaFeatures;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.addFeature = function (feature) {
                if ($scope.modelo.features.indexOf(feature) === -1)
                    $scope.modelo.features.push(feature);
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson({name: $scope.modelo.name, features: $scope.modelo.features}, 0);
                console.log(jsonObj);

                if (tipo === 'Nuevo') {
                    quantionApi.addModelo(jsonObj).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTCREAR')).position('top right').hideDelay(5000));
                        CargarModelos();
                        $scope.hide();

                        vm.gestionarVersiones(null, dataResponse.data);
                    }, function (dataResponse) {
                        console.error(dataResponse);
                    });
                } else {
                    quantionApi.updateModelo(modelo.idStbModel, jsonObj).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTEDITAR')).position('top right').hideDelay(5000));
                        CargarModelos();
                        $scope.hide();
                    }, function (dataResponse) {
                        console.error(dataResponse);
                    });
                }
            };
        }

        vm.gestionarVersiones = function (ev, modelo) {
            $mdDialog.show({
                controller: VersionesCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/modelos/versiones.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    modelo: modelo
                },
                onRemoving: function () {
                    CargarModelos();
                }
            });
        };

        function VersionesCtrl($scope, modelo) {
            $scope.modelo = angular.copy(modelo);
            $scope.listaVersiones = vm.listaVersiones;

            function getModelo() {
                quantionApi.getModelo(modelo.idStbModel).then(function (dataResponse) {
                    $scope.modelo = dataResponse.data;
                    $scope.dataLoading = false;
                });
            }

            $scope.defaultVersion = function (attr, item) {
                if (item.idItemVersion !== $scope.modelo[attr].defaultItem.idItemVersion) {
                    $scope.dataLoading = true;

                    var obj = {};
                    obj[attr] = {
                        idItemList: $scope.modelo[attr].idItemList,
                        defaultItem: item.idItemVersion,
                        completeList: $scope.modelo[attr].completeList
                    };

                    quantionApi.updateModelo(modelo.idStbModel, angular.toJson(obj, 0)).then(function () {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTEDITAR')).position('top right').hideDelay(5000));
                        getModelo();
                    });
                }
            };

            $scope.addVersion = function (attr, nuevaVersion) {
                if (!nuevaVersion)
                    return;

                var aux = angular.copy($scope.modelo);
                aux[attr].completeList.push(nuevaVersion);

                var obj = {};
                obj[attr] = {
                    idItemList: aux[attr].idItemList,
                    defaultItem: aux[attr].defaultItem ? aux[attr].defaultItem.idItemVersion : null,
                    completeList: aux[attr].completeList
                };

                $scope.dataLoading = true;
                quantionApi.updateModelo(modelo.idStbModel, angular.toJson(obj, 0)).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTEDITAR')).position('top right').hideDelay(5000));
                    getModelo();
                }, function () {
                    $scope.dataLoading = false;
                });
            };

            $scope.eliminarVersion = function (attr, index) {
                $scope.dataLoading = true;

                var element = $scope.modelo[attr].completeList[index];
                var aux = angular.copy($scope.modelo);
                aux[attr].completeList.splice(index, 1);

                var obj = {};
                obj[attr] = {
                    idItemList: aux[attr].idItemList,
                    defaultItem: aux[attr].defaultItem.idItemVersion !== element.idItemVersion ? aux[attr].defaultItem.idItemVersion : null,
                    completeList: aux[attr].completeList
                };

                quantionApi.updateModelo(modelo.idStbModel, angular.toJson(obj, 0)).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTEDITAR')).position('top right').hideDelay(5000));
                    getModelo();
                });
            };

            $scope.changeSysVersion = function () {
                var obj = {systemImage: $scope.modelo.systemImage};

                quantionApi.updateModelo(modelo.idStbModel, angular.toJson(obj, 0)).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('MODELOS.TOASTEDITAR')).position('top right').hideDelay(5000));
                    getModelo();
                });
            };
        }

        //*************** IMPORTACIÓN **************************
        vm.importFile = function () {
            $('#files').click();
        };

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var contenidoArchivo = e.target.result;

                if (isJSON(contenidoArchivo)) {
                    var listaModelos = JSON.parse(contenidoArchivo);

                    $mdDialog.show({
                        controller: SelectModelsToImport,
                        templateUrl: 'app/main/Quantion/habitaciones/modelos/importModelos.tmpl.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        locals: {listaModelos: listaModelos},
                        onRemoving: function () {
                            document.getElementById('files').value = null;
                        }
                    });
                }
                $scope.isLoading = false;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
            return true;
        }

        function SelectModelsToImport($scope, $mdDialog, $mdToast, listaModelos) {
            $scope.listaModelos = listaModelos;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var arr = [];

                $.each($scope.listaModelos, function (index, value) {
                    if (value.seleccionado) {
                        var o = angular.copy(value);
                        delete o.idStbModel;
                        delete o.seleccionado;

                        arr.push(o);
                    }
                });

                console.log(arr);

                PostService(arr);
            };

            function PostService(array) {
                if (array[0]) {
                    quantionApi.addModelo(angular.toJson({name: array[0].name, features: array[0].features})).then(function (dataResponse) {
                        array.shift();
                        PostService(array);
                    }, function () {
                        $mdToast.show($mdToast.simple()
                                .textContent($filter('translate')('MODELOS.ERRORTOASTIMPORT', {name: array[0].name}))
                                .position('top right').hideDelay(3000));
                        array.shift();
                        PostService(array);
                    });
                } else {
                    $mdDialog.hide();
                    CargarModelos();
                }
            }
        }

        //****************** Upload logo ***********************
        $scope.uploadLogo = function (modelo) {
            $scope.selectedModel = modelo;

            $('#logoUpload').click();
        };

        document.getElementById('logoUpload').addEventListener('change', UploadLogo, false);

        function UploadLogo(evt) {            
            if (!$scope.selectedModel)
                return;

            var files = evt.target.files;
            var file = files[0];

            var formData = new FormData();
            formData.append('file', file);

            quantionApi.uploadGenericFile(formData, angular.lowercase($scope.selectedModel.name) + '.png', FilePaths.modelos).then(function (dataResponse) {
                CargarModelos();
            }, function () {
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.mantenimiento', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_mantenimiento', {
            url: '/mantenimiento',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/mantenimiento/mantenimiento.html',
                    controller: 'mantenimientoController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/mantenimiento');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.mantenimiento')
            .controller('mantenimientoController', mantenimientoController);

    /** @ngInject */
    function mantenimientoController(quantionApi, $mdDialog, $mdToast, $filter, $scope, $translate, $rootScope)
    {
        var vm = this;
        $rootScope.seccion = 'HABITACIONES_MANTENIMIENTO';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        CargarStbs();
        function CargarStbs() {
            quantionApi.getStbs().then(function (dataResponse) {
                vm.listaStbs = $filter('orderBy')(dataResponse.data, 'room|tryParseInt');

                quantionApi.getStatusAll(true).then(function (dataResponse) {
                    $.each(vm.listaStbs, function (index, val) {
                        var aux = findByMAC(val.mac);
                        if (aux) {
                            var e = $filter('translateStat')(aux.currentScreen);
//                            var e = $filter('translate')('ESTADISTICAS.SCREENS.' + aux.currentScreen);

                            val.status = {
                                ultConexion: new Date(aux.ultConexion),
                                currentScreen: e.indexOf('ESTADISTICAS.') === 0 ? aux.currentScreen : e,
                                currentInfo: aux.currentInfo || "null",
                                currentShadow: aux.currentShadow || "null",
                                currentStatus: aux.currentStatus,
                                active: aux.active ? 'Activo' : 'Inactivo'
                            };

                            if (val.status.currentShadow === '-WEBCENTRAL-off-SOL- ') {
                                val.status.currentScreen = $filter('translate')('ESTADISTICAS.SCREENS.OFF_SUSPEND');
                            }

                            if (val.status.currentShadow === '-WELCOME-SOL- ')
                                val.status.currentScreen = $filter('translate')('ESTADISTICAS.SCREENS.WELCOME');

                            val.status.parsed = '<b>' + val.status.currentScreen + '</b><br> (' + val.status.currentInfo + ' / ' + val.status.currentShadow.substring(0, 30) + ')';
                        } else {
                            val.status = {
                                currentScreen: $filter('translate')('PRINCIPAL.SCREENNAMES.SINESTADISTICAS'),
                                currentInfo: "null",
                                currentShadow: "null",
                                active: 'Desconocido'
                            };
                            val.status.parsed = val.status.currentScreen;
                        }
                    });

                    $scope.statsLoaded = true;

                    function findByMAC(mac) {
                        var arr = dataResponse.data.filter(function (elm) {
                            return elm.macStb.toLowerCase() === mac.toLowerCase();
                        });

                        return arr[0] ? arr[0] : null;
                    }
                });
            });
        }

        quantionApi.getModelos().then(function (dataResponse) {
            vm.modelos = {};
            $.each(dataResponse.data, function (index, value) {
                vm.modelos[value.idStbModel] = value;
            });
        });

        /* Intercambio de MACs */
        vm.swapMac = function (ev) {
            $mdDialog.show({
                controller: SwapMacCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/mantenimiento/templates/intercambiarMac.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function SwapMacCtrl($scope, $mdDialog, $mdToast) {
            $scope.listaStbs = vm.listaStbs;

            $scope.querySearch = function (query) {
                var results = query ? $scope.listaStbs.filter(filtrarHabs(query)) : $scope.listaStbs;
                return results;
            };

            function filtrarHabs(query) {
                var lowercaseQuery = angular.lowercase(query);

                return function (usuario) {
                    return (angular.lowercase(usuario.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(usuario.username).indexOf(lowercaseQuery) !== -1);
                };
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                if (!$scope.stb1 || !$scope.stb2)
                    return;

                $scope.dataLoading = true;

                var json1 = angular.toJson({
                    mac: $scope.stb1.mac
                });

                var json2 = angular.toJson({
                    mac: $scope.stb2.mac
                });

                console.log(json1, json2);

                quantionApi.patchStb($scope.stb1.idStb, json2).then(function (dataResponse) {
                    quantionApi.patchStb($scope.stb2.idStb, json1).then(function (dataResponse2) {
                        $mdDialog.hide();
                        CargarStbs();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')("MANTENIMIENTO.SWAPMAC.TOAST")).position('top right').hideDelay(5000));
                    }, function (dataResponse) {
                        console.error(dataResponse);
                        $scope.mensajeError = dataResponse.data.reason;
                        $scope.dataLoading = false;
                    });
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = dataResponse.data.reason;
                    $scope.dataLoading = false;
                });
            };
        }

        /* Dispositivos USB conectados */
        vm.usbDevices = function (ev) {
            $mdDialog.show({
                controller: DevicesCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/mantenimiento/templates/devices.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function DevicesCtrl($scope, $mdDialog, $mdToast) {
            $scope.listaStbs = vm.listaStbs;

            var mapIDs = {};
            $.each(vm.listaStbs, function (index, value) {
                mapIDs[value.idStb] = index;
            });

            var knownTags = function (n) {
                var a = {
                    "Hongever USB Audio and HID": "Mando",
                    "Castles Technology Co., Ltd EZUSB PC/SC Smart Card Reader": "Lector SmartCard",
                    "Ralink Technology, Corp. RT5370 Wireless Adapter": "Dongle WiFi",
                    "Sycreader RFID Technology Co., Ltd SYC ID&IC USB Reader": "Lector RFID"
                };

                if (a[n])
                    return a[n];
                else if (n.toLowerCase().includes('omnikey'))
                    return 'Lector Omnikey ' + n.split(' ').pop();
                else if (n.toLowerCase().includes('c3po'))
                    return 'Lector C3PO ' + n.split(' ').pop();
            };

            var cont = $scope.listaStbs.length;
            $scope.loading = (cont > 0);
            $.each($scope.listaStbs, function (index, value) {
                if (value.status.active === 'Activo') {
                    quantionApi.getUptime(value.idStb).then(function (dataResponse) {
                        $scope.listaStbs[mapIDs[value.idStb]].allList = $filter('orderBy')(dataResponse.data.usbList);
                        if (!dataResponse.data)
                            $scope.listaStbs[mapIDs[value.idStb]].usbList = "No se han obtenido datos";
                        else {
                            $scope.listaStbs[mapIDs[value.idStb]].usbList = [];
                            $.each($filter('orderBy')(dataResponse.data.usbList), function (ind, elm) {
                                var e = knownTags(elm);
                                if (e)
                                    $scope.listaStbs[mapIDs[value.idStb]].usbList.push(e);
                            });
                        }
                        $scope.listaStbs[mapIDs[value.idStb]].ethernet = dataResponse.data.ethernet;
                        $scope.loading = --cont > 0;
                    }, function () {
                        $scope.listaStbs[mapIDs[value.idStb]].usbList = "Apagado o fallo al obtener";
                        $scope.loading = --cont > 0;
                    });
                } else {
                    $scope.listaStbs[mapIDs[value.idStb]].usbList = "Apagado";
                    $scope.loading = --cont > 0;
                }
            });

            $rootScope.$broadcast('stbsMainLoaded');

            $scope.$on('incidencesReceived', function (event, args) {
                $scope.habIncidencias = args.incidences;
            });

            $scope.$on('preventsReceived', function (event, args) {
                $scope.habPrevents = args.incidences;
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.resetHubUsb = function (idStb) {
                if (window.confirm('¿Reiniciar Hub USB?')) {
                    quantionApi.resetUsbHubStb(idStb).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent('Petición enviada').position('top right').hideDelay(5000));
                    });
                }
            };
        }

        /* Admin. actualizaciones */
        vm.updates = function (ev) {
            $mdDialog.show({
                controller: UpdatesCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/mantenimiento/templates/updates.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function UpdatesCtrl($scope, $mdDialog, $mdToast, $compile, $interval) {
            $scope.listaStbs = angular.copy(vm.listaStbs);

            $scope.actualizarVersionDinamica = {};
            $scope.actualizarAhora = {};
            $scope.forzarActualizacionSistema = {};
            $scope.instCero = {};
            $scope.asignarUltimaVersionSistema = {};
            $scope.reinicio = {};

            $scope.intervaloDynamicReinicios = 10;
            $scope.randomizarStbs = false;

            var marcadosStorage = localStorage.marcados ? angular.fromJson(localStorage.marcados) : {};

            var a = $interval(function () {
                if ($('#table-content')) {
                    $interval.cancel(a);

                    $.each($scope.listaStbs, function (index, value) {
                        var html =
                                '<tr>' +
                                '    <td class="' + value.status.active + '"></td>' +
                                '    <td>' + value.room + '</td>' +
                                '    <td>' + value.status.parsed + '</td>' +
                                '    <td style="background-color: ' + ((value.viewed.lastDynamic === vm.modelos[value.model.identifier].dynamicList.defaultItem.name) ? "lightgreen" : "lightcoral") + '">' + value.viewed.lastDynamic + ' >>> ' + vm.modelos[value.model.identifier].dynamicList.defaultItem.name + '</td>' +
                                '    <td><md-checkbox ng-model="actualizarVersionDinamica[' + value.idStb + ']" aria-label="check"></md-checkbox></td>' +
                                '    <td><md-checkbox ng-model="actualizarAhora[' + value.idStb + ']" aria-label="check"></md-checkbox></td>' +
                                '    <td style="background-color: ' + (value.updated.matchSystem ? "lightgreen" : "lightcoral") + '">' + value.viewed.lastSystem + ' >>> ' + value.systemVersion.name + '</td>' +
                                '    <td><md-checkbox ng-model="forzarActualizacionSistema[' + value.idStb + ']" aria-label="check"></md-checkbox></td>' +
                                '    <td><md-checkbox ng-model="instCero[' + value.idStb + ']" aria-label="check"></md-checkbox></td>' +
                                '    <td style="background-color: ' + ((value.systemVersion.name === vm.modelos[value.model.identifier].systemImage) ? "lightgreen" : "lightcoral") + '">' + vm.modelos[value.model.identifier].systemImage + '</td>' +
                                '    <td><md-checkbox ng-model="asignarUltimaVersionSistema[' + value.idStb + ']" aria-label="check"></md-checkbox></td>' +
                                '    <td><md-checkbox ng-model="reinicio[' + value.idStb + ']" aria-label="check"></md-checkbox></td>' +
                                '</tr>';
                        $('#table-content').append(html);
                    });
                    $compile($('#table-content'))($scope);
                } else {
                    console.warn('No se encuentra el elemento');
                }
            }, 50);

            var allScreens = [
                $filter('translate')('ESTADISTICAS.SCREENS.HOME'),
                $filter('translate')('ESTADISTICAS.SCREENS.OFF_SUSPEND'),
                $filter('translate')('ESTADISTICAS.SCREENS.OFF'),
                $filter('translate')('ESTADISTICAS.SCREENS.WELCOME')
            ];
            $scope.screens = [];
            $scope.querySearch = function (query) {
                var results = query ? allScreens.filter(createFilterFor(query)) : allScreens;
                return results;
            };

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function (screen) {
                    return (angular.lowercase(screen).indexOf(lowercaseQuery) !== -1);
                };
            }
/////////////////
            $scope.marcarActualizarVersionDinamica = function (compareScreen) {
                if (compareScreen)
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.screens.indexOf(value.status.currentScreen) > -1 && !(value.viewed.lastDynamic === vm.modelos[value.model.identifier].dynamicList.defaultItem.name))
                            $scope.actualizarVersionDinamica[value.idStb] = true;
                    });
                else
                    $.each($scope.listaStbs, function (index, value) {
                        if (!(value.viewed.lastDynamic === vm.modelos[value.model.identifier].dynamicList.defaultItem.name))
                            $scope.actualizarVersionDinamica[value.idStb] = true;
                    });
            };

            $scope.desmarcarActualizarVersionDinamica = function () {
                $scope.actualizarVersionDinamica = {};
            };

            $scope.marcarActualizarVersionDinamicaStorage = function () {
                $scope.actualizarVersionDinamica = angular.copy(marcadosStorage);
            };
/////////////////
            $scope.marcarActualizarAhora = function (compareScreen) {
                if (compareScreen)
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.screens.indexOf(value.status.currentScreen) > -1 && $scope.actualizarVersionDinamica[value.idStb])
                            $scope.actualizarAhora[value.idStb] = true;
                    });
                else
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.actualizarVersionDinamica[value.idStb])
                            $scope.actualizarAhora[value.idStb] = true;
                    });
            };

            $scope.desmarcarActualizarAhora = function () {
                $scope.actualizarAhora = {};
            };

            $scope.marcarActualizarAhoraStorage = function () {
                $scope.actualizarAhora = angular.copy(marcadosStorage);
            };
////////////////////
            $scope.marcarForzarActualizacionSistema = function (compareScreen) {
                if (compareScreen)
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.screens.indexOf(value.status.currentScreen) > -1 && !value.updated.matchSystem)
                            $scope.forzarActualizacionSistema[value.idStb] = true;
                    });
                else
                    $.each($scope.listaStbs, function (index, value) {
                        if (!value.updated.matchSystem)
                            $scope.forzarActualizacionSistema[value.idStb] = true;
                    });
            };

            $scope.desmarcarForzarActualizacionSistema = function () {
                $scope.forzarActualizacionSistema = {};
            };

            $scope.marcarForzarActualizacionSistemaStorage = function () {
                $scope.forzarActualizacionSistema = angular.copy(marcadosStorage);
            };
//////////////////////////
            $scope.marcarInstCero = function (compareScreen) {
                if (compareScreen)
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.screens.indexOf(value.status.currentScreen) > -1 && !value.updated.matchSystem)
                            $scope.instCero[value.idStb] = true;
                    });
                else
                    $.each($scope.listaStbs, function (index, value) {
                        if (!value.updated.matchSystem)
                            $scope.instCero[value.idStb] = true;
                    });
            };

            $scope.desmarcarInstCero = function () {
                $scope.instCero = {};
            };

            $scope.marcarInstCeroStorage = function () {
                $scope.instCero = angular.copy(marcadosStorage);
            };
//////////////////////////
            $scope.marcarAsignarUltimaVersionSistema = function (compareScreen) {
                if (compareScreen)
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.screens.indexOf(value.status.currentScreen) > -1 && !(value.systemVersion.name === vm.modelos[value.model.identifier].systemImage))
                            $scope.asignarUltimaVersionSistema[value.idStb] = true;
                    });
                else
                    $.each($scope.listaStbs, function (index, value) {
                        if (!(value.systemVersion.name === vm.modelos[value.model.identifier].systemImage))
                            $scope.asignarUltimaVersionSistema[value.idStb] = true;
                    });
            };

            $scope.desmarcarAsignarUltimaVersionSistema = function () {
                $scope.asignarUltimaVersionSistema = {};
            };

            $scope.marcarAsignarUltimaVersionSistemaStorage = function () {
                $scope.asignarUltimaVersionSistema = angular.copy(marcadosStorage);
            };
///////////////////////////
            $scope.marcarReinicio = function (compareScreen) {
                if (compareScreen)
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.screens.indexOf(value.status.currentScreen) > -1 && $scope.forzarActualizacionSistema[value.idStb])
                            $scope.reinicio[value.idStb] = true;
                    });
                else
                    $.each($scope.listaStbs, function (index, value) {
                        if ($scope.forzarActualizacionSistema[value.idStb])
                            $scope.reinicio[value.idStb] = true;
                    });
            };

            $scope.desmarcarReinicio = function () {
                $scope.reinicio = {};
            };

            $scope.marcarReinicioStorage = function () {
                $scope.reinicio = angular.copy(marcadosStorage);
            };
//////////////////////////////////
            $scope.hide = $mdDialog.hide;

            $scope.enviar = function () {
                var total = {};
                var dynamic_Reinicios = [];//Ids que tienen que hacer /dynamic o reiniciar

                $scope.inProgress = true;

                console.log('Primero se actualizarán los objetos STB, luego se harán los reinicios o /dynamic necesarios.');

                $.each($scope.listaStbs, function (index, value) {
                    var obj = {};
                    //////////
                    if ($scope.actualizarVersionDinamica[value.idStb]) {
                        obj.dynamicVersion = null;
                        if (!obj.updated)
                            obj.updated = {};
                        obj.updated.forceDynamic = true;
                    }
                    if ($scope.actualizarAhora[value.idStb])
                        dynamic_Reinicios.push(value.idStb);
                    //////////
                    if ($scope.asignarUltimaVersionSistema[value.idStb]) {
                        obj.systemVersion = null;
                    }
                    if ($scope.forzarActualizacionSistema[value.idStb]) {
                        if (!obj.updated)
                            obj.updated = {};
                        obj.updated.forceSystem = true;
                    }
                    if ($scope.instCero[value.idStb]) {
                        if (!obj.updated)
                            obj.updated = {};
                        obj.updated.cleanSystem = true;
                    }
                    if ($scope.reinicio[value.idStb])
                        dynamic_Reinicios.push(value.idStb);
                    ///////////
                    if (Object.keys(obj).length > 0)
                        total[value.idStb] = obj;
                });

                dynamic_Reinicios = $scope.randomizarStbs ? shuffle($.unique(dynamic_Reinicios)) : $.unique(dynamic_Reinicios);

                var contador = 0;
                var contTotal = Object.keys(total).length;

                if (Object.keys(total).length > 0) {
                    $.each(total, function (idStb, obj) {
                        console.log('PATCH al stb con id ' + idStb, angular.toJson(obj));

                        quantionApi.patchStb(idStb, angular.toJson(obj)).then(function () {
                            contador++;
                            $('#contador').empty().append(contador + ' / ' + contTotal);

                            console.log('Actualizados ' + contador + ' de ' + contTotal);
                            if (contador === contTotal) {
                                empezarDynamic_Reinicio();
                            }
                        }, function () {
                            contador++;
                            $('#contador').empty().append(contador + ' / ' + contTotal);

                            console.log('Actualizados ' + contador + ' de ' + contTotal);
                            if (contador === contTotal) {
                                empezarDynamic_Reinicio();
                            }
                        });
                    });
                } else {
                    empezarDynamic_Reinicio();
                }

                function empezarDynamic_Reinicio() {
                    console.log('Empezamos a reiniciar o /dynamic');
                    var contadorDR = 0;
                    $interval(function () {
                        var id = dynamic_Reinicios[contadorDR];

                        if ($scope.reinicio[id]) {
                            quantionApi.rebootStb(id);
                            console.log('reinicio - ' + contadorDR + 'º - ID ' + id);
                            $('#contador').empty().append('Reiniciando id' + id + ' (' + (contadorDR + 1) + ' de ' + dynamic_Reinicios.length + ')');

                        } else if ($scope.actualizarAhora[id]) {
                            quantionApi.setDynamic(id);
                            console.log('dynamic - ' + contadorDR + 'º - ID ' + id);
                            $('#contador').empty().append('/dynamic id' + id + ' (' + (contadorDR + 1) + ' de ' + dynamic_Reinicios.length + ')');

                        } else {
                            console.log('nada - ' + contadorDR + 'º - ID ' + id);
                        }
                        contadorDR++;

                        if (contadorDR === dynamic_Reinicios.length) {
                            $mdDialog.hide();
                            CargarStbs();
                        }
                    }, (($scope.intervaloDynamicReinicios * 1000) || 10000), dynamic_Reinicios.length);
                }

                function shuffle(arr) {
                    var array = angular.copy(arr);
                    var currentIndex = array.length, temporaryValue, randomIndex;

                    // While there remain elements to shuffle...
                    while (0 !== currentIndex) {

                        // Pick a remaining element...
                        randomIndex = Math.floor(Math.random() * currentIndex);
                        currentIndex -= 1;

                        // And swap it with the current element.
                        temporaryValue = array[currentIndex];
                        array[currentIndex] = array[randomIndex];
                        array[randomIndex] = temporaryValue;
                    }

                    return array;
                }
            };
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.listado', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_listado', {
            url  : '/habitaciones',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/listado/listado.html',
                    controller : 'listadoHabitacionesController as vm'
                }
            },
            data: {
                authorization: true
            }
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/listado');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.habitaciones.listado')
            .controller('listadoHabitacionesController', listadoHabitacionesController)
            .filter('startFrom', function () {
                return function (input, start) {
                    start = +start;
                    return input.slice(start);
                };
            });

    /** @ngInject */
    function listadoHabitacionesController($scope, quantionApi, $mdDialog, $rootScope, $mdToast, JSONconfig, $translate, $location, $filter, $state, messagesApi, dirayaApi)
    {
        'use strict';

        var vm = this;
        $rootScope.seccion = 'HABITACIONES_LISTADO';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.JSONconfig = JSONconfig;

        pantallaCarga.lsEnable('LS.HABITACIONES');
        $scope.$on('onRepeatLast', function () {
            pantallaCarga.lsDisable();
        });

        $scope.$translate = $translate;

        //Carga de los datos
        vm.CargarStbs = function (inicializarParametrosTabla) {
            pantallaCarga.lsEnable();
//            console.time('Carga');
            vm.habitacionesRecibidas = [];
            $scope.filtered = [];

            if (inicializarParametrosTabla)
                initTable();

            quantionApi.getStbs(true, true).then(function (dataResponse) {
                vm.habitacionesRecibidas = dataResponse.data;

                if (vm.habitacionesRecibidas.length === 0) {
                    pantallaCarga.lsDisable();
                }

                quantionApi.getInstalaciones(true).then(function (dataResponse) {
                    vm.listaInstalaciones = dataResponse.data;
                });

                quantionApi.getStatusAll(true).then(function (dataResponse) {
                    vm.mapStatusByMac = {};
                    $.each(dataResponse.data, function (index, value) {
                        vm.mapStatusByMac[value.macStb.toLowerCase()] = value;
                    });

                    $.each(vm.habitacionesRecibidas, function (index, val) {
                        var aux = findByMAC(val.mac, dataResponse.data);
                        if (aux) {
                            var e = $filter('translateStat')(aux.currentScreen);
//                            $filter('translate')('ESTADISTICAS.SCREENS.' + aux.currentScreen);

                            val.status = {
                                ultConexion: new Date(aux.ultConexion),
                                currentScreen: e.indexOf('ESTADISTICAS.') === 0 ? aux.currentScreen : e,
                                currentInfo: aux.currentInfo || "null",
                                currentShadow: aux.currentShadow || "null",
                                currentStatus: aux.currentStatus,
//                                active: aux.active ? 'Activo' : 'Inactivo'
                            };
                            if (aux.active)
                                val.status.active = 'Activo';
                            else if (JSONconfig.mostrarEstadoNaranja && !aux.active && aux.currentScreen === 'OFF')
                                val.status.active = 'Boton';
                            else
                                val.status.active = 'Inactivo';

                            if (val.status.currentShadow === '-WEBCENTRAL-off-SOL- ') {
                                val.status.currentScreen = $filter('translate')('ESTADISTICAS.SCREENS.OFF_SUSPEND');
                            }

                            val.status.parsed = val.status.currentScreen + ' (' + val.status.currentInfo + ' / ' + val.status.currentShadow + ')';
                        } else {
                            val.status = {
                                currentScreen: $filter('translate')('PRINCIPAL.SCREENNAMES.SINESTADISTICAS'),
                                currentInfo: "null",
                                currentShadow: "null",
                                active: 'Desconocido'
                            };
                            val.status.parsed = val.status.currentScreen;
                        }

                        val.balance = val.virtualBalance || val.personalBalance;
                    });

                    quantionApi.getGrupos().then(function (dataResponse) {
                        var listaGrupos = dataResponse.data;
                        var obj = {};

                        $.each(listaGrupos, function (index, value) {
                            $.each(value.stbs, function (index2, value2) {
                                obj[value2] = value.place ? (value.place + " - " + value.nombre) : (value.nombre);
                            });
                        });

                        $.each(vm.habitacionesRecibidas, function (index, value) {
                            value.group = obj[value.idStb];
                        });

                        if ($scope.search || $scope.filtroEstado)
                            $scope.filterStbs();
                        else
                            $scope.filtered = vm.habitacionesRecibidas;
                    });

                    function findByMAC(mac, statusArray) {
                        if (vm.mapStatusByMac) {
                            return vm.mapStatusByMac[mac.toLowerCase()] || null;
                        } else {
                            return null;
                        }
                    }
                });

                if (JSONconfig.datosDiraya) {
                    dirayaApi.getDirayaAll(true).then(function (dataResponse) {
                        var mapByRoom = {};
                        $.each(dataResponse.data, function (index, value) {
                            if (JSONconfig.installation === value.installation)
                                mapByRoom[value.room.toLowerCase()] = value;
                        });

                        $.each(vm.habitacionesRecibidas, function (index, val) {
                            val.diraya = mapByRoom[val.room.toLowerCase()]
                        });
                    });
                }

            }, function () {
                pantallaCarga.lsDisable();
            });
        };
        vm.CargarStbs(true);//Carga inicial

        //*********** TABLA **************
        function initTable() {
            $scope.search = localStorage['search'] || '';
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            $scope.filtroEstado = '';
            $scope.orderProp = 'room';
            $scope.orderReverse = false;

            vm.allProperties = ["room", 'username', 'ip', "mac", 'extension', 'lang', "wallet", "balance", "services",
                "installation", "theme", "model", "wifiAp", "lastDynamic", "lastSystem", "forceSystem", "cleanSystem",
                "status.ultConexion", "status.parsed", "screenshot", "group", "lastMacs",
                "diraya.centro", "diraya.modulo", "diraya.cama", "diraya.codigounidad", "diraya.unidadfuncional"]
                .filter(function (e) {
                    return ($scope.JSONconfig.sistemaDePago || !(['balance', 'wallet', 'services'].includes(e))) &&
                        ($scope.JSONconfig.datosDiraya || !(["diraya.centro", "diraya.modulo", "diraya.cama", "diraya.codigounidad", "diraya.unidadfuncional"].includes(e)));
                });
            vm.tableOptions = localStorage['vm.tableOptions'] ? angular.fromJson(localStorage['vm.tableOptions']) : {
                room: true,
                ip: true,
                wallet: true,
                "balance": true,
                "services": true,
                "status.parsed": true
            };

            vm.searchProperties = ["room", 'username', 'ip', "mac", 'extension', 'lang', "uuidVirtualWallet", "balance", "services",
                "installation", "theme", "model", "wifiAp", "lastDynamic", "lastSystem", "forceSystem", "cleanSystem", "status.parsed", "group", "lastMacs",
                "diraya.centro", "diraya.modulo", "diraya.cama", "diraya.codigounidad", "diraya.unidadfuncional"]
                .filter(function (e) {
                    return ($scope.JSONconfig.sistemaDePago || !(["uuidVirtualWallet", "balance", "services"].includes(e))) &&
                        ($scope.JSONconfig.datosDiraya || !(["diraya.centro", "diraya.modulo", "diraya.cama", "diraya.codigounidad", "diraya.unidadfuncional"].includes(e)));;
                });
            vm.searchOptions = localStorage['vm.searchOptions'] ? angular.fromJson(localStorage['vm.searchOptions']) : {
                room: true,
                username: true,
                ip: true,
                'uuidVirtualWallet': true
            };
        }

        $scope.numberOfPages = function () {
            var a = Math.ceil($scope.filtered.length / $scope.pageSize) || 1;
            if ($scope.currentPage > a)
                $scope.currentPage = (a - 1);
            return a;
        };

        $scope.filterStbs = function () {
            $scope.filtered = vm.habitacionesRecibidas.filter(function (value) {
                var b = false;

                $.each(vm.searchOptions, function (key, value2) {
                    if (value2) {
                        var k = pathIndex(value, key);

                        if (k) {
                            var p = angular.isObject(k) ? angular.toJson(k) : k.toString();
                            if (angular.lowercase(p).indexOf(angular.lowercase($scope.search)) >= 0)
                                b = true;
                        }
                    }
                });
                return b;
            }).filter(function (value) {
                return $scope.filtroEstado ? (value.status.active === $scope.filtroEstado) : true;
            });

            if ($scope.filtered.length === 0)
                pantallaCarga.lsDisable();

            function multiIndex(obj, is) {  // obj,['1','2','3'] -> ((obj['1'])['2'])['3']
                if (obj)
                    return is.length ? multiIndex(obj[is[0]], is.slice(1)) : obj;
            }
            function pathIndex(obj, is) {   // obj,'1.2.3' -> multiIndex(obj,['1','2','3'])
                return multiIndex(obj, is.split('.'));
            }

            localStorage['search'] = $scope.search;
        };

        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        $scope.marcados = localStorage.marcados ? angular.fromJson(localStorage.marcados) : {};

        $scope.marcar = function (elem, status) {
            if (elem === null) {
                $scope.marcados = {};
                localStorage.removeItem('marcados');
                return;
            }

            if (Array.isArray(elem)) {
                $.each(elem.map(function (e) {
                    return e.idStb;
                }), function (index, value) {
                    if (angular.isDefined(status))
                        $scope.marcados[value] = status;
                    else
                        $scope.marcados[value] = !$scope.marcados[value];
                });
            } else {
                if (angular.isDefined(status))
                    $scope.marcados[elem] = status;
                else
                    $scope.marcados[elem] = !$scope.marcados[elem];
            }

            localStorage.marcados = angular.toJson($scope.marcados);
        };

        $scope.getServices = function (stb, $mdOpenMenu, $event) {
            if (!stb.services && stb.activeContracts)
                quantionApi.getStb(stb.idStb).then(function (dataResponse) {
                    stb.services = dataResponse.data.wallet.services;
                    if (stb.services.length > 0)
                        $mdOpenMenu($event);
                });
            else
                $mdOpenMenu($event);
        };

        //************ /TABLA ***************

        vm.irAVerMas = function (stb) {
//            $location.path('/habitaciones/' + stb.ip);
            $state.go('app.Quantion_habitaciones_ver_mas', {ip: stb.idStb});
        };

        function Existe(stb, propiedad) {//Mira si una propiedad de stb coincide con la de los demás
            return vm.habitacionesRecibidas.map(function (e) {
                return e[propiedad];
            }).indexOf(stb[propiedad]) !== -1;
        }

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.idiomas = dataResponse.data;
        });

        quantionApi.getInstalacionThemes().then(function (dataResponse) {
            vm.listaThemes = dataResponse.data;
        });

        quantionApi.getPuntosAcceso().then(function (dataResponse) {
            vm.listaAp = dataResponse.data;
        });

        quantionApi.getAcls().then(function (dataResponse) {
            vm.listaAcls = $filter('orderBy')($.unique(dataResponse.data));
        });

        quantionApi.getServicios().then(function (dataResponse) {
            vm.listaServicios = dataResponse.data;

            $scope.mapServicios = {};
            $.each(vm.listaServicios, function (index, value) {
                $scope.mapServicios[value.acl.toUpperCase()] = value;
            });
        });

        quantionApi.getCanalesTV().then(function (dataResponse) {
            vm.listaCanales = dataResponse.data;

            $scope.mapCanales = {};
            $.each(vm.listaCanales, function (index, value) {
                $scope.mapCanales[value.nombre] = value;
            });
        });

        quantionApi.getControls().then(function (dataResponse) {
            vm.listaControls = $filter('orderBy')(dataResponse.data, 'model');
        });

        //*********************** BLOQUEAR STB **********************
        vm.changeLock = function (stb, newValue) {
            var jsonObj = angular.toJson({properties: {"locked": newValue}}, 0);

            quantionApi.patchStb(stb.idStb, jsonObj).then(function (dataResponse) {
                vm.CargarStbs();
            }, function (dataResponse) {
                console.log("Fallo al guardar");
            });
        };

        //********************** CHECK-IN *******************************
        vm.checkIn = function (stb, event) {
            $mdDialog.show({
                controller: CheckInCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/checkin.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {stb: stb}
            });
        };

        function CheckInCtrl($scope, $mdDialog, stb) {
            quantionApi.getStb(stb.idStb).then(function (dataResponse) {
                $scope.stb = dataResponse.data;
            });

            $scope.listaIdiomas = vm.idiomas;

            $scope.CheckIn = function () {
                var jsonObj = angular.toJson({
                    properties: {
                        "displayWelcome": $scope.stb.properties.displayWelcome
                    },
                    "lang": $scope.stb.lang,
                    "username": $scope.stb.username
                }, 0);

                $scope.cargando = true;

                quantionApi.patchStb(stb.idStb, jsonObj).then(function (dataResponse) {
                    quantionApi.updateCheck(stb.idStb, 'In').then(function (dataResponse) {
                        $scope.cargando = false;
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKIN.TOAST')).position('top right').hideDelay(3000));
                        $mdDialog.hide();
                        vm.CargarStbs();
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al guardar').action('OK').highlightAction(false).position('top right'));
                });
            };
        }

        //**************************** CHECK-OUT *******************************
        vm.checkOut = function (hab, event) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('CHECKOUT.TITLE'))
                    .textContent($filter('translate')('CHECKOUT.CONTENT'))
                    .targetEvent(event)
                    .ok($filter('translate')('CHECKOUT.OK'))
                    .cancel($filter('translate')('CHECKOUT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.updateCheck(hab.idStb, 'Out').then(function (dataResponse) {
                    vm.CargarStbs();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.TOAST')).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.ERROR')).position('top right').hideDelay(3000));
                });
            });
        };

        //************ Eliminar ***************
        vm.eliminarStb = function (ev, stb) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('ELIMINAR.TITLE'))
                    .textContent($filter('translate')('ELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('ELIMINAR.OK'))
                    .cancel($filter('translate')('ELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('');

                quantionApi.deleteStb(stb.idStb).then(function (dataResponse) {
                    pantallaCarga.lsDisable();
                    vm.CargarStbs();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('ELIMINAR.TOAST')).position('top right').hideDelay(3000));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al eliminar').action('OK').highlightAction(false).position('top right'));
                    pantallaCarga.lsDisable();
                });
            });
        };

        //************ Editar ***************
        vm.ventanaEditar = function (ev, stb) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/editar.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {stbR: stb}
            });
        };

        quantionApi.getModelos().then(function (dataResponse) {
            vm.listaModelos = $filter('orderBy')(dataResponse.data, 'name');
        });

        quantionApi.getFiles('system').then(function (dataResponse) {
            vm.systemList = dataResponse.data;
        });

        function EditarCtrl($scope, $mdDialog, stbR, $rootScope) {
            var stbOriginal;

            quantionApi.getStb(stbR.idStb).then(function (dataResponse) {
                $scope.stb = angular.copy(dataResponse.data);

                stbOriginal = dataResponse.data;

                $scope.stb.model = stbOriginal.model ? stbOriginal.model.identifier : null;
                $scope.stb.installation = stbOriginal.installation ? stbOriginal.installation.identifier : null;
                getInstallationById($scope.stb.installation);
                $scope.res = stbOriginal.properties.resolution.split('x').map(function (e) {
                    return parseInt(e);
                });
                $scope.stb.properties.wifiAp = stbOriginal.properties.wifiAp ? stbOriginal.properties.wifiAp.idWiFiAp : null;

                getVersionLists();
                $scope.getVersionLists = getVersionLists;

                $scope.stb.control = stbOriginal.control ? stbOriginal.control.idControl : null;

                $scope.JSONconfig = JSONconfig;
                if (JSONconfig.datosDiraya) {
                    dirayaApi.getDirayaRoom($scope.stb.room).then(function (dataResponse) {
                        $scope.diraya = {
                            idDiraya: dataResponse.data.idDiraya,
                            room: dataResponse.data.room,
                            installation: dataResponse.data.installation,
                            cama: dataResponse.data.cama,
                            centro: dataResponse.data.centro,
                            modulo: dataResponse.data.modulo,
                            unidadfuncional: dataResponse.data.unidadfuncional,
                            codigounidad: dataResponse.data.codigounidad,
                        };
                    }, function (dataResponse) {
                        if(dataResponse.status === 404) {
                            $scope.diraya = {
                                room: $scope.stb.room,
                                installation: dirayaApi.DOMAIN,
                                cama: null,
                                centro: null,
                                modulo: null,
                                unidadfuncional: null,
                                codigounidad: null,
                            };
                        }
                    })
                }
            });

            $scope.listaIdiomas = vm.idiomas;
            $scope.ipPattern = "^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$";
            $scope.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';
            $scope.cargando = false;
            $scope.listaModelos = vm.listaModelos;
            $scope.listaInstalaciones = vm.listaInstalaciones;
            $scope.listaThemes = vm.listaThemes;
            $scope.listaAp = vm.listaAp;
            $scope.listaAcls = vm.listaAcls;
            $scope.listaControls = vm.listaControls;


            $scope.Guardar = function () {
                var obj = diffObj($scope.stb, stbOriginal);//Obtiene solo los campos que han cambiado

                if (stbOriginal.model && ($scope.stb.model === stbOriginal.model.identifier))
                    delete obj.model;

                if (stbOriginal.installation && ($scope.stb.installation === stbOriginal.installation.identifier))
                    delete obj.installation;

                if (stbOriginal.dynamicVersion && $scope.stb.dynamicVersion === stbOriginal.dynamicVersion.idItemVersion)
                    delete obj.dynamicVersion;

                if (stbOriginal.systemVersion && $scope.stb.systemVersion === stbOriginal.systemVersion.idItemVersion)
                    delete obj.systemVersion;

                if (stbOriginal.biosVersion && $scope.stb.biosVersion === stbOriginal.biosVersion.idItemVersion)
                    delete obj.biosVersion;

                if ((stbOriginal.properties.wifiAp && stbOriginal.properties.wifiAp.idWiFiAp) === $scope.stb.properties.wifiAp) {
                    if (obj.properties)
                        delete obj.properties.wifiAp;
                } else {
                    var found;
                    if ($scope.stb.properties.wifiAp) {
                        found = $scope.listaAp.find(function (ap) {
                            return ap.idWiFiAp === $scope.stb.properties.wifiAp;
                        });
                    }

                    messagesApi.sendMessage({
                        title: 'Cambio de AP - Hab. ' + $scope.stb.room + ' - ' + $rootScope.user.name,
                        message: [
                            stbOriginal.properties.wifiAp ? (stbOriginal.properties.wifiAp.name + ' (' + stbOriginal.properties.wifiAp.band + ' - ' + stbOriginal.properties.wifiAp.bssid + ')') : 'Sin AP',
                            found ? (found.name + ' (' + found.band + ' - ' + found.bssid + ')') : 'Sin AP'
                        ].join('\n🔻🔻🔻\n')
                    });
                }

                if (obj.extension) {
                    var extNum = obj.extension.number;
                    obj.extension = stbOriginal.extension || {};
                    obj.extension.number = extNum;
                }

                var jsonObj = angular.toJson(obj);
                $scope.cargando = true;

                if (($scope.stb.room === stbOriginal.room || !Existe($scope.stb, 'room')) && ($scope.stb.mac === stbOriginal.mac || !Existe($scope.stb, 'mac'))) {
                    quantionApi.patchStb(stbOriginal.idStb, jsonObj).then(function (dataResponse) {
                        vm.CargarStbs();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.TOASTEDITAR')).position('top right').hideDelay(3000));
                        $scope.cargando = false;
                        $mdDialog.hide();

                        $mdDialog.show({
                            controller: ActionPostEditController,
                            templateUrl: 'app/main/Quantion/habitaciones/listado/templates/actionPostEdit.tmpl.html',
                            locals: {stb: $scope.stb}
                        });
                    }, function (dataResponse) {
                        $scope.cargando = true;
                        $mdToast.show($mdToast.simple().textContent('Error al guardar').action('OK').highlightAction(false).position('top right'));
                        console.log("Fallo al guardar");
                    });
                } else {
                    $scope.mensajeError = "CREAR.ERROR1";
                    $scope.cargando = false;
                }

                if (JSONconfig.datosDiraya) {
                    $scope.diraya.room = $scope.stb.room;

                    if ($scope.diraya.idDiraya) {
                        dirayaApi.putDirayaRoom($scope.diraya).then(function () {
                            console.log('PUT Diraya ok')
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                        })
                    } else {
                        dirayaApi.postDirayaRoom($scope.diraya).then(function () {
                            console.log('POST Diraya ok')
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                        })
                    }
                }
            };

            function diffObj(edit, original) {
                var dest = {};
                $.each(edit, function (key, value) {
                    if (angular.isObject(value)) {
                        var a = diffObj(value, original[key]);
                        if (Object.keys(a).length > 0)
                            dest[key] = a;
                    } else {
                        if (!original || angular.toJson(value) !== angular.toJson(original[key])) {
                            dest[key] = value;
                        }
                    }
                });
                return dest;
            }

            function getVersionLists() {
                var m = vm.listaModelos.filter(function (e) {
                    return e.idStbModel === $scope.stb.model;
                });
                if (m[0]) {
                    $scope.dynamicList = m[0].dynamicList;
                    $scope.systemList = vm.systemList;
                    $scope.biosList = m[0].biosList;

                    if ($scope.stb.model !== stbOriginal.model.identifier) {
                        $scope.stb.dynamicVersion = null;
//                        $scope.stb.systemVersion = null;
                        $scope.stb.biosVersion = null;
                    } else {
                        $scope.stb.dynamicVersion = $scope.stb.dynamicVersion ? $scope.stb.dynamicVersion.idItemVersion : null;
                        $scope.stb.systemVersion = $scope.stb.systemVersion ? $scope.stb.systemVersion.idItemVersion : null;
                        $scope.stb.biosVersion = $scope.stb.biosVersion ? $scope.stb.biosVersion.idItemVersion : null;
                    }
                } else {
                    console.error(m);
                }
            }

            $scope.getInstallationById = getInstallationById;

            function getInstallationById(id) {
                $scope.installationChosed = vm.listaInstalaciones.filter(function (e) {
                    return e.idInstallation === id;
                })[0];
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        function ActionPostEditController($scope, $mdDialog, stb) {
            $scope.stb = stb;

            $scope.dynamic = function () {
                quantionApi.setDynamic(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('DYNAMIC.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                });
            };

            $scope.interfaceReboot = function () {
                quantionApi.rebootInterface(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALRECARGA.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                });
            };

            $scope.reboot = function () {
                quantionApi.rebootStb(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALREINICIO.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //******************* Nuevo *********************
        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/editar.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog) {
            $scope.stb = {};
            $scope.listaModelos = vm.listaModelos;
            $scope.listaInstalaciones = vm.listaInstalaciones;
            $scope.listaThemes = vm.listaThemes;
            $scope.listaAp = vm.listaAp;
            $scope.listaAcls = vm.listaAcls;
            $scope.listaControls = vm.listaControls;

            $scope.resTags = ['720p (1280x720)', '1080p (1920x1080)', '1080i (1920x1080i)', 'Auto', 'Custom'];
            $scope.listaResoluciones = ['1280x720', '1920x1080', '1920x1080i', '1x1', 'Custom'];

            $scope.listaIdiomas = vm.idiomas;
            $scope.ipPattern = "^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$";
            $scope.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';

            getVersionLists();
            $scope.getVersionLists = getVersionLists;

            $scope.JSONconfig = JSONconfig;
            if (JSONconfig.datosDiraya) {
                $scope.diraya = {
                    room: null,
                    installation: dirayaApi.DOMAIN,
                    cama: null,
                    centro: null,
                    modulo: null,
                    unidadfuncional: null,
                    codigounidad: null,
                };
            }

            $scope.Guardar = function () {
                var stb = angular.copy($scope.stb);
                stb.code = 'yo instalo';

                if ($scope.stb.extension)
                    stb.extension = {
                        number: $scope.stb.extension.number || stb.room,
                        password: "password" + $scope.stb.extension.number,
                        usuario: stb.room,
                        type: "PRE"
                    };

                var jsonObj = angular.toJson(stb, 0);
                console.log(jsonObj);
                $scope.mensajeError = '';
                $scope.cargando = true;

                if (!Existe($scope.stb, 'room') && !Existe($scope.stb, 'mac')) {
                    quantionApi.addStb(jsonObj).then(function (dataResponse) {
                        vm.CargarStbs();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CREAR_STB.TOAST')).position('top right').hideDelay(3000));
                        $scope.cargando = false;
                        $mdDialog.hide();

                        if (JSONconfig.datosDiraya) {
                            $scope.diraya.room = $scope.stb.room;

                            if ($scope.diraya.idDiraya) {
                                dirayaApi.putDirayaRoom($scope.diraya).then(function () {
                                    console.log('PUT Diraya ok')
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                                })
                            } else {
                                dirayaApi.postDirayaRoom($scope.diraya).then(function () {
                                    console.log('POST Diraya ok')
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                                })
                            }
                        }
                    }, function (dataResponse) {
                        $scope.cargando = false;

                        if (dataResponse.status === 401)
                            $scope.mensajeError = 'CREAR.ERROR2';
                    });
                } else {
                    $scope.mensajeError = "CREAR.ERROR1";
                }
            };

            function getVersionLists() {
                if (!$scope.stb || !$scope.stb.model)
                    return;

                var m = vm.listaModelos.filter(function (e) {
                    return e.idStbModel === $scope.stb.model;
                });
                if (m[0]) {
                    $scope.dynamicList = m[0].dynamicList;
                    $scope.systemList = vm.systemList;
                    $scope.biosList = m[0].biosList;

                    $scope.stb.dynamicVersion = null;
//                    $scope.stb.systemVersion = null;
                    $scope.stb.biosVersion = null;
                } else {
                    console.error(m);
                }
            }

            $scope.getInstallationById = getInstallationById;

            function getInstallationById(id) {
                $scope.installationChosed = vm.listaInstalaciones.filter(function (e) {
                    return e.idInstallation === id;
                })[0];
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //************ Cambio de habitación ***************
        vm.ventanaCambio = function (ev, hab) {
            $mdDialog.show({
                controller: CambioCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/cambiohabitacion.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {stbFrom: hab}
            });
        };

        function CambioCtrl($scope, $mdDialog, stbFrom) {
            $scope.stbFrom = stbFrom;
            $scope.$translate = $translate;
            $scope.listaStbs = vm.habitacionesRecibidas
                    .filter(function (elm) {
                        return elm.check.type === 'Out';
                    });
            $scope.sistemaDePago = JSONconfig.sistemaDePago;

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.GuardarCambio = function () {
                $scope.cargando = true;

                quantionApi.changeRoom($scope.stbFrom.idStb, $scope.stbTo.idStb).then(function (dataResponse) {
                    $scope.cargando = false;
                    $scope.hide();
                    vm.CargarStbs();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Error al hacer el cambio').action('OK').highlightAction(false).position('top right'));
                });
            };
        }

        //****************** VNC **************************
        vm.connectVNC = function (stb, ev) {
            quantionApi.connectVNC(stb.idStb).then(function (dataResponse) {
                var model = vm.listaModelos.find(function (item) { return item.name === stb.model });
                var win = window.open(JSONconfig.urlVNC(stb.ip, model), '_blank');
                if (win === null || typeof (win) === 'undefined') {
                    alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                }

            }, function () {
                $mdDialog.show(
                        $mdDialog.alert().clickOutsideToClose(false)
                        .title($filter('translate')('PRINCIPAL.ERRORVNC.TITLE')).textContent($filter('translate')('PRINCIPAL.ERRORVNC.CONTENT'))
                        .ok($filter('translate')('PRINCIPAL.ERRORVNC.OK')).targetEvent(ev)
                        );
            });
        };

        //**************** Reinicio *************************
        vm.reiniciarStb = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PRINCIPAL.MODALREINICIO.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Reinicio')
                    .targetEvent(ev)
                    .ok($filter('translate')('PRINCIPAL.MODALREINICIO.OK'))
                    .cancel($filter('translate')('PRINCIPAL.MODALREINICIO.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootStb(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALREINICIO.TOAST')).position('top right').hideDelay(5000));
                });
            });
        };

        //************************************* Recarga interfaz *************************************
        vm.recargarInterfaz = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PRINCIPAL.MODALRECARGA.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Recargar interfaz')
                    .targetEvent(ev)
                    .ok($filter('translate')('PRINCIPAL.MODALRECARGA.OK'))
                    .cancel($filter('translate')('PRINCIPAL.MODALRECARGA.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootInterface(stb.idStb).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('PRINCIPAL.MODALRECARGA.TOAST'))
                            .position('top right')
                            .hideDelay(5000)
                            );
                });
            });
        };

        //************************************* Dynamic *************************************
        vm.setDynamic = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('DYNAMIC.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Dynamic')
                    .targetEvent(ev)
                    .ok($filter('translate')('DYNAMIC.OK'))
                    .cancel($filter('translate')('DYNAMIC.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.setDynamic(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('DYNAMIC.TOAST')).position('top right').hideDelay(5000));
                });
            });
        };

        //*********************************** Caché EDID **************************************
        vm.deleteCacheEdid = function (ev, stb) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('EDID.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Edid')
                    .targetEvent(ev)
                    .ok($filter('translate')('EDID.OK'))
                    .cancel($filter('translate')('EDID.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCacheEdid(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('EDID.TOAST')).position('top right').hideDelay(5000));
                });
            });
        };

        //***************************** Reiniciar hub USB **************************************
        vm.resetHubUsb = function (ev, stb) {
            if (window.confirm('¿Reiniciar Hub USB?')) {
                quantionApi.resetUsbHubStb(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent('Petición enviada').position('top right').hideDelay(5000));
                });
            }
        };

        //********************** PROPIEDADES TABLA *****************************
        vm.tableProperties = function (ev) {
            $mdDialog.show({
                controller: PropCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/listado/templates/tableProperties.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function () {
                    localStorage['vm.tableOptions'] = angular.toJson(vm.tableOptions, 0);
                    localStorage['vm.searchOptions'] = angular.toJson(vm.searchOptions, 0);
                }
            });
        };

        function PropCtrl($scope, $mdDialog) {
            $scope.allProperties = vm.allProperties;
            $scope.tableOptions = vm.tableOptions;

            $scope.searchProperties = vm.searchProperties;
            $scope.searchOptions = vm.searchOptions;
            $scope.JSONconfig = JSONconfig;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.setDefault = function () {
                vm.tableOptions = {
                    room: true,
                    ip: true,
                    wallet: true,
                    "balance": true,
                    "services": true,
                    "status.parsed": true
                };

                $scope.tableOptions = vm.tableOptions;

                vm.searchOptions = {
                    room: true,
                    username: true,
                    ip: true,
                    'uuidVirtualWallet': true
                };

                $scope.searchOptions = vm.searchOptions;
            };

            $scope.setDefaultVer = function () {
                vm.tableOptions = {
                    "room": true,
                    "ip": true,
                    "status.parsed": true,
                    "lastDynamic": true,
                    "lastSystem": true,
                    "forceSystem": true,
                    "installation": true,
                    "theme": true,
                    "model": true,
                    "cleanSystem": true
                };

                $scope.tableOptions = vm.tableOptions;

                vm.searchOptions = {
                    "room": true,
                    "username": true,
                    "ip": true,
                    "lastDynamic": true,
                    "lastSystem": true,
                    "theme": true,
                    "installation": true
                };

                $scope.searchOptions = vm.searchOptions;
            };

            $scope.setDefaultDiraya = function () {
                vm.tableOptions = {
                    "room": true,
                    "diraya.centro": true,
                    "diraya.modulo": true,
                    "diraya.cama": true,
                    "diraya.codigounidad": true,
                    "diraya.unidadfuncional": true,
                };

                $scope.tableOptions = vm.tableOptions;

                vm.searchOptions = {
                    "room": true,
                    "diraya.centro": true,
                    "diraya.modulo": true,
                    "diraya.cama": true,
                    "diraya.codigounidad": true,
                    "diraya.unidadfuncional": true,
                };

                $scope.searchOptions = vm.searchOptions;
            };
        }

        //************************************* Monitorizar webcam *************************************
        vm.webcam = function (stb, ev) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                template:
                        '<md-dialog aria-label="Videollamada">' +
                        '  <md-dialog-content>' +
                        '    <h2 class="md-title">' + $filter('translate')('PRINCIPAL.MODALWEBCAM.TITLE', {stbroom: stb.room}) + '</h2>' +
                        '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALWEBCAM.CONTENT2') + '</h3>' +
                        '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALWEBCAM.CONTENT') + '</h3>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="closeDialog()" class="md-primary" ng-disabled="closeButtonDisabled">' +
                        $filter('translate')('PRINCIPAL.MODALWEBCAM.OK') +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                controller: DialogController,
                locals: {
                    stb: stb
                },
                escapeToClose: false
            });

            function DialogController($scope, $mdDialog, stb) {
                if (!JSONconfig.webcam)
                    return;

                if (JSONconfig.monitoringApi) {
                    $scope.closeButtonDisabled = true;

                    quantionApi.openMonitoring(stb.idStb).then(function (data) {
                        setTimeout(function () {
                            // window.open(JSONconfig.webcamUrl(stb));
                            var win = window.open(JSONconfig.webcamUrl(stb.ip, stb.model), '_blank');
                            if (win === null || typeof (win) === 'undefined') {
                                alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                            }
                            $scope.closeButtonDisabled = false;
                        }, 2000);
                    });

                    $scope.closeDialog = function () {
                        quantionApi.closeMonitoring(stb.idStb);
                        $mdDialog.hide();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALWEBCAM.TOAST')).position('top right').hideDelay(5000));
                    };
                } else {
                    var task = {
                        "title": "Webcam hab. " + stb.room,
                        "description": "IP: " + stb.ip,
                        "metodo": "GET",
                        "header": "{}",
                        "command": JSONconfig.videocallCommand(stb),
                        "arguments": angular.toJson({
                            "taskroot": false,
                            "cmdline": JSONconfig.videocallCommand(stb),
                            "args": []
                        }),
                        "type": "task"
                    };

                    var killTask = {
                        "title": "Kill Webcam hab. " + stb.room,
                        "description": "IP: " + stb.ip,
                        "metodo": "GET",
                        "header": "{}",
                        "command": JSONconfig.videocallCommand(stb, {kill: true}),
                        "arguments": angular.toJson({
                            "taskroot": false,
                            "cmdline": JSONconfig.videocallCommand(stb, {kill: true}),
                            "args": []
                        }),
                        "type": "task"
                    };

                    $scope.closeButtonDisabled = true;

                    quantionApi.addTask(angular.toJson(task)).then(function (data) {
                        setTimeout(function () {
                            // window.open(JSONconfig.webcamUrl(stb));
                            var win = window.open(JSONconfig.webcamUrl(stb.ip, stb.model), '_blank');
                            if (win === null || typeof (win) === 'undefined') {
                                alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                            }
                            $scope.closeButtonDisabled = false;
                        }, 2000);
                    });

                    $scope.closeDialog = function () {
                        quantionApi.addTask(angular.toJson(killTask));
                        $mdDialog.hide();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALWEBCAM.TOAST')).position('top right').hideDelay(5000));
                    };
                }
            }
        };

        //************************************* Videollamada OpenVidu *************************************
        vm.videocall = function (stb, ev) {
            if (JSONconfig.monitoringApi) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    template:
                            '<md-dialog aria-label="Videollamada">' +
                            '  <md-dialog-content>' +
                            '    <h2 class="md-title">' + $filter('translate')('PRINCIPAL.MODALVIDEOCALL.TITLE', {stbroom: stb.room}) + '</h2>' +
                            '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALVIDEOCALL.CONTENT2') + '</h3>' +
                            '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALVIDEOCALL.CONTENT') + '</h3>' +
                            '  </md-dialog-content>' +
                            '  <md-dialog-actions>' +
                            '    <md-button ng-click="closeDialog()" class="md-primary" ng-disabled="closeButtonDisabled">' +
                            $filter('translate')('PRINCIPAL.MODALVIDEOCALL.OK') +
                            '    </md-button>' +
                            '  </md-dialog-actions>' +
                            '</md-dialog>',
                    controller: DialogController,
                    locals: {
                        stb: stb
                    },
                    escapeToClose: false
                });

                function DialogController($scope, stb) {
                    if (!JSONconfig.videocall)
                        return;

                    $scope.closeButtonDisabled = true;

                    quantionApi.openVideocall(stb.idStb, JSONconfig.videocallRoom(stb)).then(function (data) {
                        setTimeout(function () {
                            window.open(JSONconfig.videocallUrl(stb));
                            $scope.closeButtonDisabled = false;
                        }, 2000);
                    });

                    $scope.closeDialog = function () {
                        quantionApi.closeVideocall(stb.idStb);
                        vm.abrirDetalle(stb.idStb);
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALVIDEOCALL.TOAST')).position('top right').hideDelay(5000));
                    };
                }
            } else {
                if (!JSONconfig.videocall)
                    return;

                var task = {
                    "title": "Videocall hab. " + stb.room,
                    "description": "IP: " + stb.ip,
                    "metodo": "GET",
                    "header": "{}",
                    "command": JSONconfig.videocallCommand(stb, {openvidu: true}),
                    "arguments": angular.toJson({
                        "taskroot": false,
                        "cmdline": JSONconfig.videocallCommand(stb, {openvidu: true}),
                        "args": []
                    }),
                    "type": "task"
                };

                quantionApi.addTask(angular.toJson(task)).then(function (data) {
                    window.open(JSONconfig.videocallUrl(stb));
                });

            }
        };

        vm.unlinkWallet = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('WALLETS.DESVINCULA.TITLE'))
                    .textContent($filter('translate')('WALLETS.DESVINCULA.CONTENT'))
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .ok($filter('translate')('WALLETS.DESVINCULA.OK'))
                    .cancel($filter('translate')('WALLETS.DESVINCULA.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.DesvincularStbWallet(stb.idStb, stb.uuidVirtualWallet).then(function (dataResponse) {
                    vm.CargarStbs();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.DESVINCULA.CORRECTO')).position('top right').hideDelay(3000));
                }, function (dataResponse) {
                    $mdDialog.show(
                            $mdDialog.alert().clickOutsideToClose(true)
                            .title($filter('translate')('WALLETS.DESVINCULA.ERROR.TITLE'))
                            .ariaLabel('Error desvincular wallet')
                            .ok($filter('translate')('WALLETS.DESVINCULA.ERROR.OK')));
                });
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.Quantion.habitaciones.aps', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_habitaciones_aps', {
            url  : '/habitaciones/puntos-de-acceso',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/habitaciones/aps/aps.html',
                    controller : 'apsController as vm'
                }
            },
            data: {
                authorization: true
            }
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/habitaciones/aps');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.Quantion.habitaciones.aps')
        .controller('apsController', apsController);

    /** @ngInject */
    function apsController($scope, quantionApi, $rootScope, $mdDialog, $mdToast, $filter) {
        var vm = this;
        $rootScope.seccion = 'HABITACIONES_APS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function () {
            pantallaCarga.lsDisable();
        });

        $scope.currentPage = 0;
        $scope.pageSize = 10;

        $scope.numberOfPages = function () {
            var a = Math.ceil($scope.filtered.length / $scope.pageSize) || 1;
            if ($scope.currentPage > a)
                $scope.currentPage = (a - 1);
            return a;
        };

        CargarStbs();
        function CargarStbs() {
            quantionApi.getStbs().then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;

                var mapIDs = {};
                $.each(vm.listaStbs, function (index, value) {
                    mapIDs[value.idStb] = value;
                });
                vm.mapIDs = mapIDs;

                quantionApi.getGrupos().then(function (dataResponse) {
                    $scope.listaGrupos = dataResponse.data;
                });

                quantionApi.getStatusAll(true).then(function (dataResponse2) {
                    var h = (new Date()).getTime();

                    $.each(vm.listaStbs, function (index, val) {
                        var aux = findByMAC(val.mac);
                        if (aux) {
                            val.status = aux.active ? 'activo' : 'inactivo';
                        } else {
                            val.status = 'desconocido';
                        }
                    });

                    function findByMAC(mac) {
                        var arr = dataResponse2.data.filter(function (elm) {
                            return elm.macStb.toLowerCase() === mac.toLowerCase();
                        });

                        return arr[0] ? arr[0] : null;
                    }
                });
            }, function () {
                pantallaCarga.lsDisable();
            });
        }

        $scope.getUptime = function (stb) {
            if (stb.status === 'activo')
                quantionApi.getUptime(stb.idStb).then(function (dataResponse) {
                    stb.uptime = dataResponse.data;
                }, function () {
                    stb.uptime = null;
                });
        };

        $scope.getAllUptimes = function (grupo) {
            if (grupo.stbs.length > 0)
                pantallaCarga.lsEnable('LS.HABITACIONES');

            $scope.stbs = [];
            $scope.loading = (grupo.stbs.length > 0);
            $.each(grupo.stbs, function (index, value) {
                var o = vm.mapIDs[value];
                if (o.status === 'activo') {
                    quantionApi.getUptime(value).then(function (dataResponse) {
                        o.uptime = dataResponse.data;
                        $scope.stbs.push(o);
                        $scope.loading = $scope.stbs.length < grupo.stbs.length;
                    }, function () {
                        $scope.stbs.push(o);
                        $scope.loading = $scope.stbs.length < grupo.stbs.length;
                    });
                } else {
                    $scope.stbs.push(o);
                    $scope.loading = $scope.stbs.length < grupo.stbs.length;
                }
            });
        };

        $scope.reiniciarStb = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('PRINCIPAL.MODALREINICIO.TITLE', { stbroom: stb.room }))
                .ariaLabel('Reinicio')
                .targetEvent(ev)
                .ok($filter('translate')('PRINCIPAL.MODALREINICIO.OK'))
                .cancel($filter('translate')('PRINCIPAL.MODALREINICIO.CANCEL'))
                .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootStb(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALREINICIO.TOAST')).position('top right').hideDelay(5000));
                });
            });
        };

        $scope.cambiarAp = function (stb) {
            $mdDialog.show({
                controller: CambiarApCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/cambiarAp.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    stb: stb,
                    listaStbs: $scope.stbs
                }
            });
        };

        function CambiarApCtrl($scope, $mdDialog, stb, listaStbs) {
            $scope.stb = angular.copy(stb);
            $scope.stb.properties.wifiAp = stb.properties.wifiAp ? stb.properties.wifiAp.idWiFiAp : null;

            $scope.apList = vm.puntosAcceso.map(function (ap) {
                ap.displayText = ap.name + ' (' + ap.band + ' - ' + ap.bssid + ')';
                return ap;
            });

            $scope.selectedItem = stb.properties.wifiAp && $scope.apList.find(function (ap) {
                return ap.idWiFiAp === stb.properties.wifiAp.idWiFiAp
            });
            $scope.searchText = null;
            $scope.isEthernet = !$scope.stb.properties.wifiAp;

            $scope.querySearch = function (query) {
                var results = query ? $scope.apList.filter(createFilterFor(query)) : $scope.apList;
                return $filter('orderBy')(results, 'name');
            }

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function filterFn(ap) {
                    return (ap.displayText.toLowerCase().indexOf(lowercaseQuery) !== -1);
                };
            }

            $scope.Guardar = function () {
                if (!$scope.selectedItem && !$scope.isEthernet) {
                    return;
                }

                var o = {
                    properties: {
                        // wifiAp: parseInt($scope.stb.properties.wifiAp)
                        wifiAp: $scope.isEthernet ? null : $scope.selectedItem.idWiFiAp
                    }
                };

                $scope.cargando = true;

                quantionApi.patchStb($scope.stb.idStb, angular.toJson(o)).then(function (dataResponse) {
                    var s = dataResponse.data;
                    vm.mapIDs[s.idStb] = s;

                    quantionApi.getUptime(s.idStb).then(function (dataResponse) {
                        vm.mapIDs[s.idStb].uptime = dataResponse.data;

                        for (var i = 0; i < listaStbs.length; i++) {
                            if (listaStbs[i].idStb === s.idStb) {
                                listaStbs[i] = vm.mapIDs[s.idStb];
                                break;
                            }
                        }
                    }, function () {
                        vm.mapIDs[s.idStb].uptime = null;
                    });

                    $mdDialog.hide();
                });
            };
        }

        //*********************** PUNTOS DE ACCESO *****************************
        CargarAPs();
        function CargarAPs() {
            vm.puntosAcceso = [];
            $scope.filtered = [];
            pantallaCarga.lsEnable('LS.DATOSVOIP');

            $scope.registeredAPs = {
                B_2_GHZ: {},
                B_5_GHZ: {}
            };

            quantionApi.getPuntosAcceso().then(function (dataResponse) {
                vm.puntosAcceso = dataResponse.data;
                $scope.filtered = vm.puntosAcceso;

                if ($scope.filtered.length === 0)
                    pantallaCarga.lsDisable();

                //                $scope.numberOfPages = Math.ceil(vm.puntosAcceso.length / $scope.pageSize);

                vm.mapAps = {};
                $.each(vm.puntosAcceso, function (index, value) {
                    vm.mapAps[value.bssid && value.bssid.toLowerCase()] = value;
                    $scope.registeredAPs[value.band][value.name] = true;
                });

                obtainRuckusAps();
            });
        }

        $scope.filterAps = function () {
            $scope.filtered = $filter('filter')(vm.puntosAcceso, $scope.search);
        };

        quantionApi.getTiposPuntoAcceso().then(function (dataResponse) {
            vm.tiposPuntoAcceso = dataResponse.data;
        });

        $scope.nuevoAP = function (ap) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/editar.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog) {
            $scope.puntoAcceso = {
                hidden: false
            };

            $scope.bandList = vm.tiposPuntoAcceso;
            $scope.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';

            $scope.Guardar = function () {
                var o = angular.copy($scope.puntoAcceso);

                $scope.cargando = true;

                quantionApi.addPuntoAcceso(angular.toJson(o)).then(function (dataResponse) {
                    CargarAPs();
                    $mdDialog.hide();
                });
            };
        }

        $scope.editarAP = function (ap) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/editar.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: { puntoAcceso: ap }
            });
        };

        function EditarCtrl($scope, $mdDialog, puntoAcceso) {
            $scope.puntoAcceso = angular.copy(puntoAcceso);

            $scope.bandList = vm.tiposPuntoAcceso;
            $scope.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';

            $scope.Guardar = function () {
                var o = angular.copy($scope.puntoAcceso);
                if (puntoAcceso.password === $scope.puntoAcceso.password)
                    delete o.password;

                $scope.cargando = true;

                quantionApi.updatePuntoAcceso(puntoAcceso.idWiFiAp, angular.toJson(o)).then(function (dataResponse) {
                    $scope.cargando = false;
                    CargarAPs();
                    $mdDialog.hide();
                }, function () {
                    $scope.cargando = false;
                });
            };
        }

        //************ Eliminar ***************
        $scope.eliminarAP = function (ev, ap) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('APS.MODAL_ELIMINAR.TITLE'))
                .textContent($filter('translate')('APS.MODAL_ELIMINAR.CONTENT'))
                .targetEvent(ev)
                .ok($filter('translate')('APS.MODAL_ELIMINAR.OK'))
                .cancel($filter('translate')('APS.MODAL_ELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deletePuntoAcceso(ap.idWiFiAp).then(function (dataResponse) {
                    CargarAPs();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('APS.MODAL_ELIMINAR.TOAST')).position('top right').hideDelay(3000));
                });
            });
        };

        //********************** Importar desde archivo ************************
        $scope.importarArchivo = function () {
            $('#files').click();
        };

        document.getElementById('files').addEventListener('change', LeerArchivo, false);

        function LeerArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var contenidoArchivo = angular.fromJson(e.target.result)

                $mdDialog.show({
                    controller: SelectApToImport,
                    templateUrl: 'app/main/Quantion/habitaciones/aps/templates/importarAps.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: { listaAps: contenidoArchivo },
                    onRemoving: function () {
                        document.getElementById('files').value = null;
                    }
                });
                //                }
                $scope.isLoading = false;
            };

            if (file) {
                $scope.isLoading = true;
                reader.readAsText(file);
            }
        }

        function SelectApToImport($scope, $mdDialog, $mdToast, listaAps) {
            var listaIds = [];
            var listaMacAps = vm.puntosAcceso.map(function (el) {
                listaIds.push(el.idWiFiAp);
                return angular.lowercase(el.bssid);
            });

            $scope.listaAps = listaAps;
            $.each($scope.listaAps, function (index, value) {
                var idx = listaMacAps.indexOf(angular.lowercase(value.bssid));
                if (idx > -1) {
                    value.exists = true;
                    value.idWiFiAp = listaIds[idx];
                } else {
                    value.exists = false;
                }
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var arr = [];

                $.each($scope.listaAps, function (index, value) {
                    if (value.seleccionado) {
                        var o = angular.copy(value);
                        delete o.seleccionado;
                        delete o.exists;
                        arr.push(o);
                    }
                });

                var contador = arr.length;
                $.each(arr, function (index, value) {
                    if (value.idWiFiAp) {
                        quantionApi.updatePuntoAcceso(value.idWiFiAp, value).then(function (dataResponse) {
                            contador--;

                            if (contador <= 0) {
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        }, function () {
                            contador--;
                            console.error("Error al guardar (" + value.bssid + ")");

                            if (contador <= 0) {
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        });
                    } else {
                        quantionApi.addPuntoAcceso(value).then(function (dataResponse) {
                            contador--;

                            if (contador <= 0) {
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        }, function () {
                            contador--;
                            console.error("Error al guardar (" + value.bssid + ")");

                            if (contador <= 0) {
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        });
                    }

                });
            };

            $scope.toggleAll = function (v) {
                $.each($scope.listaAps, function (index, value) {
                    value.seleccionado = v;
                });
            };
        }

        $scope.completarParejaAP = function (ap, band) {
            var ap2 = angular.copy(ap);

            ap2.band = band;
            ap2.bssid = ap.bssid.substring(0, ap.bssid.length - 1);

            if (ap2.band === 'B_2_GHZ')
                ap2.bssid += "8";
            else
                ap2.bssid += "C";

            delete ap2.idWiFiAp;
            ap2.password = 'lo pillo al vuelo';

            quantionApi.addPuntoAcceso(angular.toJson(ap2)).then(function (dataResponse) {
                CargarAPs();
            });
        };

        function obtainRuckusAps() {
            $scope.loadingRuckus = true;
            quantionApi.getRuckusApsBssids(true).then(function (dataResponse) {
                var aps = [];

                dataResponse.data.list.forEach(function (dev) {
                    dev.wlanBssids.forEach(function (bssid) {
                        aps.push({
                            name: dev.deviceName,
                            essid: bssid.ssid,
                            bssid: bssid.bssid,
                            password: bssid.wlan.encryption.passphrase,
                            hidden: bssid.wlan.advancedOptions.hideSsidEnabled,
                            band: bssid.radioType === '11g/n' ? 'B_2_GHZ' : (bssid.radioType === '11a/n/ac' ? 'B_5_GHZ' : null),
                            more: {
                                status: dev.status,
                                isOverallHealthStatusFlagged: dev["isOverallHealthStatusFlagged"],
                                isLatency24GFlagged: dev["isLatency24GFlagged"],
                                isCapacity24GFlagged: dev["isCapacity24GFlagged"],
                                isConnectionFailure24GFlagged: dev["isConnectionFailure24GFlagged"],
                                isLatency50GFlagged: dev["isLatency50GFlagged"],
                                isCapacity50GFlagged: dev["isCapacity50GFlagged"],
                                isConnectionFailure50GFlagged: dev["isConnectionFailure50GFlagged"],
                                isConnectionTotalCountFlagged: dev["isConnectionTotalCountFlagged"],
                                isConnectionFailureFlagged: dev["isConnectionFailureFlagged"],
                                isAirtimeUtilization24GFlagged: dev["isAirtimeUtilization24GFlagged"],
                                isAirtimeUtilization50GFlagged: dev["isAirtimeUtilization50GFlagged"],

                                numClients: dev["numClients"],
                                numClients24G: dev["numClients24G"],
                                numClients5G: dev["numClients5G"],
                                capacity: dev["capacity"] + '%',
                                capacity24G: dev["capacity24G"] + '%',
                                capacity50G: dev["capacity50G"] + '%',
                                airtime24G: dev["airtime24G"] + '%',
                                airtime5G: dev["airtime5G"] + '%',
                                latency24G: (dev["latency24G"] / 1000) + 'ms',
                                latency50G: (dev["latency50G"] / 1000) + 'ms',
                                channel24G: dev["channel24G"],
                                channel5G: dev["channel5G"],
                                connectionFailure: (dev["connectionFailure"] * 100) + '%',
                            }
                        });
                    });
                });

                vm.puntosAcceso.forEach(function (ap) {
                    ap.ruckus = aps.find(function (e) {
                        return e.bssid.toLowerCase() === ap.bssid.toLowerCase();
                    });
                });

                $scope.loadingRuckus = false;
            }, function () {
                $scope.loadingRuckus = false;
            });
        }

        $scope.showApRuckusInfo = function (ap) {
            $mdDialog.show({
                controller: ApRuckusInfoController,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusDetails.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: { puntoAcceso: ap }
            });
        };

        function ApRuckusInfoController($scope, $mdDialog, puntoAcceso) {
            $scope.puntoAcceso = puntoAcceso;
            $scope.booleanProps = ['isOverallHealthStatusFlagged', 'isLatency24GFlagged', 'isCapacity24GFlagged', 'isConnectionFailure24GFlagged', 'isLatency50GFlagged', 'isCapacity50GFlagged', 'isConnectionFailure50GFlagged', 'isConnectionTotalCountFlagged', 'isConnectionFailureFlagged', 'isAirtimeUtilization24GFlagged', 'isAirtimeUtilization50GFlagged'];
            $scope.numericProps = ['numClients', 'numClients24G', 'numClients5G', 'capacity', 'capacity24G', 'capacity50G', 'airtime24G', 'airtime5G', 'latency24G', 'latency50G', 'channel24G', 'channel5G', 'connectionFailure'];

            $scope.hide = $mdDialog.hide;

            $scope.loadingClients = false;
            quantionApi.getRuckusApsClientsByMac(puntoAcceso.bssid).then(function (dataResponse) {
                $scope.clients = dataResponse.data.clients;
                $scope.loadingClients = false;
            }, function () {
                $scope.loadingClients = false;
            });
        }

        $scope.rebootAP = function (ev, ap) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('APS.MODAL_REBOOT.TITLE'))
                .content($filter('translate')('APS.MODAL_REBOOT.CONTENT'))
                .targetEvent(ev)
                .ok($filter('translate')('APS.MODAL_REBOOT.OK'))
                .cancel($filter('translate')('APS.MODAL_REBOOT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootRuckusApByMac(ap.bssid).then(function (dataResponse) {
                    obtainRuckusAps();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('APS.MODAL_REBOOT.TOAST')).position('top right').hideDelay(3000));
                });
            });
        };

        $scope.showApRuckusEvents = function (ap) {
            $mdDialog.show({
                controller: ApRuckusEventsController,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusEvents.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: { puntoAcceso: ap }
            });
        };

        function ApRuckusEventsController($scope, $mdDialog, puntoAcceso) {
            $scope.hide = $mdDialog.hide;

            $scope.loadingEvents = true;

            if (puntoAcceso) {
                quantionApi.getRuckusEventsByMac(puntoAcceso.bssid).then(function (dataResponse) {
                    $scope.events = dataResponse.data.list;
                    $scope.loadingEvents = false;
                }, function () {
                    $scope.loadingEvents = false;
                });
            } else {
                quantionApi.getRuckusEvents().then(function (dataResponse) {
                    $scope.events = dataResponse.data.list;
                    $scope.loadingEvents = false;
                }, function () {
                    $scope.loadingEvents = false;
                });
            }
        }

        $scope.showApRuckusAlarms = function (ap) {
            $mdDialog.show({
                controller: ApRuckusAlarmsController,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusAlarms.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: { puntoAcceso: ap }
            });
        };

        function ApRuckusAlarmsController($scope, $mdDialog, puntoAcceso) {
            $scope.hide = $mdDialog.hide;

            $scope.loadingAlarms = true;

            if (puntoAcceso) {
                quantionApi.getRuckusAlarmsByMac(puntoAcceso.bssid).then(function (dataResponse) {
                    $scope.alarms = dataResponse.data.list;
                    $scope.loadingAlarms = false;
                }, function () {
                    $scope.loadingAlarms = false;
                });
            } else {
                quantionApi.getRuckusAlarms().then(function (dataResponse) {
                    $scope.alarms = dataResponse.data.list;
                    $scope.loadingAlarms = false;
                }, function () {
                    $scope.loadingAlarms = false;
                });
            }
        }

        $scope.importApsFromRuckus = function () {
            $mdDialog.show({
                controller: ImportApsFromRuckusCtrl,
                templateUrl: 'app/main/Quantion/habitaciones/aps/templates/importarApsRuckus.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function ImportApsFromRuckusCtrl($scope, $mdDialog, $mdToast) {
            $scope.loadingRuckus = true;

            quantionApi.getRuckusApsBssids(true).then(function (dataResponse) {
                $scope.listaAps = [];

                dataResponse.data.list.forEach(function (dev) {
                    dev.wlanBssids.forEach(function (bssid) {
                        $scope.listaAps.push({
                            name: dev.deviceName,
                            essid: bssid.ssid,
                            bssid: bssid.bssid,
                            password: bssid.wlan.encryption.passphrase,
                            hidden: bssid.wlan.advancedOptions.hideSsidEnabled,
                            band: bssid.radioType === '11g/n' ? 'B_2_GHZ' : (bssid.radioType === '11a/n/ac' ? 'B_5_GHZ' : null)
                        });
                    });
                });

                $.each($scope.listaAps, function (index, value) {
                    var found = vm.puntosAcceso.find(function (e) {
                        return e.name === value.name && e.essid === value.essid && e.band === value.band;
                    });
                    if (!!found) {
                        value.exists = true;
                        value.idWiFiAp = found.idWiFiAp;
                    } else {
                        value.exists = false;
                    }
                });

                $scope.loadingRuckus = false;
            }, function () {
                $scope.loadingRuckus = false;
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var arr = [];

                $.each($scope.listaAps, function (index, value) {
                    if (value.seleccionado) {
                        var o = angular.copy(value);
                        delete o.seleccionado;
                        delete o.exists;
                        arr.push(o);
                    }
                });

                var contador = arr.length;

                if (contador <= 0) {
                    return;
                }

                $scope.dataLoading = true;

                $.each(arr, function (index, value) {
                    if (value.idWiFiAp) {
                        quantionApi.updatePuntoAcceso(value.idWiFiAp, value).then(function (dataResponse) {
                            contador--;

                            if (contador <= 0) {
                                $scope.dataLoading = false;
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        }, function () {
                            contador--;
                            console.error("Error al guardar (" + value.bssid + ")");
                            $mdToast.show($mdToast.simple().textContent("Error al guardar (" + value.name + ")").position('top right').hideDelay(3000));

                            if (contador <= 0) {
                                $scope.dataLoading = false;
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        });
                    } else {
                        quantionApi.addPuntoAcceso(value).then(function (dataResponse) {
                            contador--;

                            if (contador <= 0) {
                                $scope.dataLoading = false;
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        }, function () {
                            contador--;
                            console.error("Error al guardar (" + value.bssid + ")");
                            $mdToast.show($mdToast.simple().textContent("Error al guardar (" + value.name + ")").position('top right').hideDelay(3000));

                            if (contador <= 0) {
                                $scope.dataLoading = false;
                                $mdDialog.hide();
                                CargarAPs();
                            }
                        });
                    }

                });
            };

            $scope.toggleAll = function (v) {
                $.each($scope.listaAps, function (index, value) {
                    value.seleccionado = v;
                });
            };

            $scope.filterAps = function (property, value) {
                $.each($scope.listaAps, function (index, ap) {
                    if (ap[property] && ap[property].toLowerCase().includes(value.toLowerCase()))
                        ap.seleccionado = true;
                });
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_recaudacion', {
            url: '/recaudacion',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/cajeros.html',
                    controller: 'recaudacionController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/recaudacion');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion')
            .controller('recaudacionSimpleController', recaudacionSimpleController);

    /** @ngInject */
    function recaudacionSimpleController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter, JSONconfig)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_RECAUDACION_SIMPLE';
        $scope.JSONconfig = JSONconfig;

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            $scope.loading = false;
        });

        $scope.obtenerReporte = function () {

            var obj = {
                fromDate: $scope.busqueda.fromDate ? parseDate($scope.busqueda.fromDate) : null,
                toDate: $scope.busqueda.toDate ? parseDate($scope.busqueda.toDate) : null
            };

            $scope.loading = true;

            quantionApi.getReporteAtmAdmin(obj).then(function (dataResponse) {
                vm.reporte = dataResponse.data;
                $scope.loading = false;
            }, function () {
                $scope.loading = false;
            });
        };

        $scope.resetForm = function () {
            var d = new Date();
            d.setDate(d.getDate() - 30);
            $scope.busqueda = {
                fromDate: d,
                toDate: new Date()
            };
        };
        $scope.resetForm();
        $scope.obtenerReporte();

        function parseDate(date) {
//            return date.toLocaleDateString('es-ES').split('/').reverse().join('-');
            return $filter('date')(date, 'yyyy-MM-dd');
        }

        $scope.operationAdminDetails = function (operation, type) {
            var title, list;

            switch (type) {
                case 'Descarga':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESDESCARGA');
                    list = operation.download;
                    break;
                }
                case 'Recarga':
                {
                    title = $filter('translate')("RECAUDACION.OPERACIONESRECARGA");
                    list = operation.upload;
                    break;
                }
            }

            $mdDialog.show({
                controller: function ($scope, data) {
                    $scope.title = title;
                    $scope.data = $filter('orderBy')(data, '-date');
                    $scope.medidas = {
                        "c1": "1c",
                        "c2": "2c",
                        "c5": "5c",
                        "c10": "10c",
                        "c20": "20c",
                        "c50": "50c",
                        "c100": "1€",
                        "c200": "2€",
                        "b5": "5€",
                        "b10": "10€",
                        "b20": "20€",
                        "b50": "50€",
                        "b100": "100€",
                        "b200": "200€",
                        "b500": "500€"};

                    $scope.groupedData = {};
                    $.each($scope.data, function (index, value) {
                        var d = $filter('date')(value.date, 'dd/MM/yyyy');
                        if ($scope.groupedData[d] === undefined)
                            $scope.groupedData[d] = 0;
                        $scope.groupedData[d] += value.total;
                    });
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/admin.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    data: list
                }
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion_v', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_recaudacion_v', {
            url: '/recaudacion_v',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/recaudacion_v/recaudacion_v.html',
                    controller: 'recaudacionVController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/recaudacion_v');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion_v')
            .controller('recaudacionVController', recaudacionVController);

    /** @ngInject */
    function recaudacionVController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_RECAUDACION_V';

        function obtenerReporte() {
            var obj = {
                fromDate: $scope.busqueda.fromDate ? parseDate($scope.busqueda.fromDate) : null,
                toDate: $scope.busqueda.toDate ? parseDate($scope.busqueda.toDate) : null
            };

            $scope.loading = true;

            quantionApi.getVReport(obj.fromDate, obj.toDate).then(function (dataResponse) {
                vm.reporte = dataResponse.data;
                $scope.loading = false;
            }, function () {
                $scope.loading = false;
            });
        }

        $scope.obtenerReporte = obtenerReporte;

        $scope.resetForm = function () {
            var dateIni = new Date();
            dateIni.setMonth(dateIni.getMonth() - 1);
            dateIni.setDate(1);

            var dateFin = new Date();
            dateFin.setDate(0);

            $scope.busqueda = {
                fromDate: dateIni,
                toDate: dateFin
            };
        };
        $scope.resetForm();

        function parseDate(date) {
            return $filter('date')(date, 'yyyy-MM-dd');
        }

        $scope.operationDetails = function (prop1, prop2) {
            $mdDialog.show({
                controller: function ($scope) {
                    $scope.title = $filter('translate')('RECAUDACION_V.PORFECHA');
                    $scope.data = vm.reporte[prop1][prop2];
                    $scope.days = Object.keys($scope.data);
                    $scope.days.sort();

                    $scope.edit = function (day) {
                        if (!$rootScope.user.mapRole.actions.EDIT_VREPORT) {
                            return;
                        }

                        var newValue = window.prompt('Editar valor', $scope.data[day].balance);

                        if (newValue !== null) {
                            var obj = {};
                            obj[prop1] = {};
                            obj[prop1][prop2] = {};
                            obj[prop1][prop2][day] = {balance: newValue};

                            quantionApi.putVReport(obj).then(function (dataResponse) {
                                $scope.data[day].balance = newValue;
                                obtenerReporte();
                            });
                        }
                    };
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion_v/templates/operations.tmpl.html',
                clickOutsideToClose: true
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion_completa', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_recaudacion_completa', {
            url: '/recaudacion-completa',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/recaudacion_completa/recaudacion_completa.html',
                    controller: 'recaudacionCompletaController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/recaudacion_completa');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion_completa')
            .controller('recaudacionCompletaController', recaudacionCompletaController);

    /** @ngInject */
    function recaudacionCompletaController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter, JSONconfig, $timeout)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_RECAUDACION_COMPLETA';
        $scope.JSONconfig = JSONconfig;

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            $scope.loading = false;
        });

        quantionApi.getAtm().then(function (dataResponse) {
            vm.listaAtm = dataResponse.data;

            if (vm.listaAtm.length === 0) {
                $scope.searchMode = 'fecha';
            }
        });

        $scope.obtenerReporte = function () {
            $scope.numRequests = 0;
            $scope.numRequestsFinished = 0;

            vm.informe = [];
            var atmIndex = 0;
            loadAtm(atmIndex);

            function loadAtm(idx) {
                var atm = vm.listaAtm[idx];

                if (!atm)
                    return;

                vm.informe.push({
                    model: atm.model,
                    arqueoInzacard: []
                });

                var arqueos = $filter('orderBy')(atm.arqueoInzacard, 'apertura').filter(function (arq, index, arr) {
                    if (arq.apertura >= $scope.busqueda.fromDate.getTime() && arq.cierre && arq.cierre <= $scope.busqueda.toDate.getTime()) {
                        arq.next = arr[index + 1];
                        return true;
                    }
                    return false;
                });

                var arqIndex = 0;
                loadArqueo(arqIndex);

                function loadArqueo(idx) {
                    var arq = arqueos[idx];

                    if (!arq) {
                        loadAtm(++atmIndex);
                        return;
                    }

                    var obj = {
                        atm: atm.idAtm,
                        idArqueo: arq.idArqueo
                    };

                    $scope.numRequests += 3;

                    quantionApi.getReporteAtmAdmin(obj).then(function (dataResponse) {
                        arq.atmAdmin = dataResponse.data;
                        arq.atmAdmin.firstUpload = dataResponse.data.atm[0].upload.find(function (op) {
                            return op.total > 0;
                        });
                        $scope.numRequestsFinished++;

                        return quantionApi.getReporteAtmClientCash(obj);
                    }, function () {
                        $scope.numRequestsFinished++;

                        return quantionApi.getReporteAtmClientCash(obj);
                    }).then(function (dataResponse) {
                        arq.atmCash = dataResponse.data;
                        $scope.numRequestsFinished++;

                        return quantionApi.getAccountant({
                            date: new Date(arq.apertura).toDateString(),
                            until: new Date(arq.cierre).toDateString(),
                            concept: 'Wallet',
                            remote: true,
                            place: 'Cajero',
                            extendedPlace: atm.ip
                        });
                    }, function () {
                        $scope.numRequestsFinished++;

                        return quantionApi.getAccountant({
                            date: new Date(arq.apertura).toDateString(),
                            until: new Date(arq.cierre).toDateString(),
                            concept: 'Wallet',
                            remote: true,
                            place: 'Cajero',
                            extendedPlace: atm.ip
                        });
                    }).then(function (dataResponse) {
                        var deposits = {
                            revoke: {
                                times: 0,
                                amount: 0
                            },
                            acquire: {
                                times: 0,
                                amount: 0
                            }
                        };

                        dataResponse.data.forEach(function (oper) {
                            if (oper.policyType === 'Acquire') {
                                deposits.acquire.times++;
                                deposits.acquire.amount += oper.extendedConcept.deposit.current;
                            } else if (oper.policyType === 'Revoke') {
                                deposits.revoke.times++;
                                deposits.revoke.amount += oper.extendedConcept.deposit.before;
                            }
                        });

                        arq.deposits = deposits;
                        $scope.numRequestsFinished++;

                        loadNextArqueo();
                    }, function () {
                        $scope.numRequestsFinished++;

                        loadNextArqueo();
                    });

                    function loadNextArqueo() {
                        if (idx + 1 === arqueos.length && arq.next) {
                            var obj = {
                                atm: atm.idAtm,
                                idArqueo: arq.next.idArqueo
                            };

                            $scope.numRequests++;

                            quantionApi.getReporteAtmAdmin(obj).then(function (dataResponse) {
                                arq.next.atmAdmin = dataResponse.data;
                                arq.next.atmAdmin.firstUpload = dataResponse.data.atm[0].upload.find(function (op) {
                                    return op.total > 0;
                                });
                                $scope.numRequestsFinished++;
                                loadArqueo(++arqIndex);
                            }, function () {
                                $scope.numRequestsFinished++;
                                loadArqueo(++arqIndex);
                            });
                        } else {
                            loadArqueo(++arqIndex);
                        }
                    }

                    arq.entradaClientesSaldo = function () {
                        var result = 0;
                        try {
                            result += arq.atmCash.totalIn;
                        } catch (e) {
                        }
                        try {
                            result -= arq.deposits.acquire.amount;
                        } catch (e) {
                        }
                        return result;
                    };

                    arq.entradaAdminRecargas = function () {
                        var result = 0;
                        try {
                            result += arq.atmAdmin.totalUpload;
                        } catch (e) {
                        }
                        try {
                            result -= arq.atmAdmin.firstUpload.total;
                        } catch (e) {
                        }
                        return result;
                    };

                    arq.salidaClientesAbonos = function () {
                        var result = 0;
                        try {
                            result += Math.abs(arq.atmCash.totalOut);
                        } catch (e) {
                        }
                        try {
                            result -= arq.deposits.revoke.amount;
                        } catch (e) {
                        }
                        return +result.toFixed(2);
                    };

                    arq.desfase = function () {
                        var result = 0;
                        try {
                            result += arq.atmAdmin.totalDownload;
                        } catch (e) {
                        }
                        try {
                            result += Math.abs(arq.atmCash.totalOut);
                        } catch (e) {
                        }
                        try {
                            result -= arq.atmAdmin.totalUpload;
                        } catch (e) {
                        }
                        try {
                            result -= arq.atmCash.totalIn;
                        } catch (e) {
                        }
                        return +result.toFixed(2);
                    };

                    arq.ingresoBanco = function () {
                        var result = 0;
                        try {
                            result += arq.atmAdmin.totalDownload;
                        } catch (e) {
                        }
                        try {
                            result -= arq.atmAdmin.totalUpload;
                        } catch (e) {
                        }
                        try {
                            result += arq.atmAdmin.firstUpload.total;
                        } catch (e) {
                        }
                        try {
                            result -= (arqueos[idx + 1] || arq.next).atmAdmin.firstUpload.total;
                        } catch (e) {
                        }
                        return result;
                    };

                    arq.recargaApertura = function () {
                        try {
                            return (arqueos[idx + 1] || arq.next).atmAdmin.firstUpload.total;
                        } catch (e) {
                        }
                        return 0;
                    };

                    vm.informe[atmIndex].arqueoInzacard.push(arq);
                }
            }

            vm.informeTotal = function () {
                var obj = {
                    entradaClientesSaldo: 0,
                    entradaAdminRecargas: 0,
                    salidaClientesAbonos: 0,
                    desfase: 0,
                    ingresoBanco: 0,
                    recargaApertura: 0,
                    deposits: {
                        revoke: {
                            times: 0,
                            amount: 0
                        },
                        acquire: {
                            times: 0,
                            amount: 0
                        }
                    },
                    atmAdmin: {
                        totalUpload: 0,
                        totalDownload: 0,
                        firstUpload: {
                            total: 0
                        }
                    },
                    atmCash: {
                        totalIn: 0,
                        totalOut: 0
                    }
                };

                vm.informe.forEach(function (atm) {
                    atm.arqueoInzacard.forEach(function (arq) {
                        try {
                            obj.entradaClientesSaldo = (+obj.entradaClientesSaldo + +arq.entradaClientesSaldo()).toFixed(2);
                        } catch (e) {
                        }

                        try {
                            obj.entradaAdminRecargas += arq.entradaAdminRecargas();
                        } catch (e) {
                        }

                        try {
                            obj.salidaClientesAbonos = (+obj.salidaClientesAbonos + +arq.salidaClientesAbonos()).toFixed(2);
                        } catch (e) {
                        }

                        try {
                            obj.desfase = (+obj.desfase + +arq.desfase()).toFixed(2);
                        } catch (e) {
                        }

                        try {
                            obj.ingresoBanco = (+obj.ingresoBanco + +arq.ingresoBanco()).toFixed(2);
                        } catch (e) {
                        }

                        try {
                            obj.recargaApertura += arq.recargaApertura();
                        } catch (e) {
                        }

                        try {
                            obj.deposits.revoke.times += arq.deposits.revoke.times;
                        } catch (e) {
                        }

                        try {
                            obj.deposits.revoke.amount += arq.deposits.revoke.amount;
                        } catch (e) {
                        }

                        try {
                            obj.deposits.acquire.times += arq.deposits.acquire.times;
                        } catch (e) {
                        }

                        try {
                            obj.deposits.acquire.amount += arq.deposits.acquire.amount;
                        } catch (e) {
                        }

                        try {
                            obj.atmAdmin.totalUpload += arq.atmAdmin.totalUpload;
                        } catch (e) {
                        }

                        try {
                            obj.atmAdmin.totalDownload = (+obj.atmAdmin.totalDownload + +arq.atmAdmin.totalDownload).toFixed(2);
                        } catch (e) {
                        }

                        try {
                            obj.atmAdmin.firstUpload.total += arq.atmAdmin.firstUpload.total;
                        } catch (e) {
                        }

                        try {
                            obj.atmCash.totalIn += arq.atmCash.totalIn;
                        } catch (e) {
                        }

                        try {
                            obj.atmCash.totalOut += arq.atmCash.totalOut;
                        } catch (e) {
                        }

                    });
                });

                return obj;
            };
        };

        $scope.resetForm = function () {
            var d = new Date();

            $scope.busqueda = {
                fromDate: new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7),
                toDate: new Date(d.getFullYear(), d.getMonth(), d.getDate())
            };
        };
        $scope.resetForm();

        $scope.exportarCSV = function () {
            var header1 = ';;;Entradas;Entradas;Entradas;Salidas;Salidas;Salidas\n';
            var header2 = ';;Remanente anterior;Clientes;Clientes;Admin;Clientes;Clientes;Admin;Desfase E/S;INGRESO BANCO;Recarga en apertura\n';
            var header3 = ';;;Saldo;Fianzas;Recargas;Abonos;Fianzas;Descargas\n';

            var content = [];

            vm.informe.forEach(function (atm) {
                atm.arqueoInzacard.forEach(function (arq) {
                    var atmRow = atm.model + ';'
                            + '"' + $filter('date')(arq.apertura, 'dd-MM-yyyy') + ' / ' + $filter('date')(arq.cierre, 'dd-MM-yyyy') + '";'
                            + '"' + arq.atmAdmin.firstUpload.total + '";'
                            + '"' + arq.entradaClientesSaldo() + '";'
                            + '"' + arq.deposits.acquire.amount + '";'
                            + '"' + arq.entradaAdminRecargas() + '";'
                            + '"' + arq.salidaClientesAbonos() + '";'
                            + '"' + arq.deposits.revoke.amount + '";'
                            + '"' + arq.atmAdmin.totalDownload + '";'
                            + '"' + arq.desfase() + '";'
                            + '"' + arq.ingresoBanco() + '";'
                            + '"' + arq.recargaApertura() + '"';

                    content.push(atmRow.replace(/\./g, ','));
                });

                content.push('');
            });

            var total = vm.informeTotal();
            var totalRow = 'Resumen;'
                    + ';'
                    + '"' + total.atmAdmin.firstUpload.total + '";'
                    + '"' + total.entradaClientesSaldo + '";'
                    + '"' + total.deposits.acquire.amount + '";'
                    + '"' + total.entradaAdminRecargas + '";'
                    + '"' + total.salidaClientesAbonos + '";'
                    + '"' + total.deposits.revoke.amount + '";'
                    + '"' + total.atmAdmin.totalDownload + '";'
                    + '"' + total.desfase + '";'
                    + '"' + total.ingresoBanco + '";'
                    + '"' + total.recargaApertura + '"';

            content.push(totalRow.replace(/\./g, ','));

            var text = header1 + header2 + header3 + content.join('\n');

            var a = document.createElement('a');
            var csvData = new Blob([text], {type: 'text/csv'});
            var csvUrl = URL.createObjectURL(csvData);
            a.href = csvUrl;
            a.download = 'report.csv';
            a.click();
        };

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.contabilidad', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_contabilidad', {
            url: '/contabilidad',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/consumo/contabilidad.html',
                    controller: 'contabilidadController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/consumo');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.contabilidad')
            .controller('contabilidadController', contabilidadController);

    /** @ngInject */
    function contabilidadController(quantionApi, $mdDialog, $scope, $rootScope, JSONconfig, $filter, $mdToast)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_CONTABILIDAD';
        $scope.JSONconfig = JSONconfig;

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            $scope.loadingStbs = false;
            $scope.loadingPaquetes = false;
            $scope.loadingCajeros = false;
        });

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = $filter('orderBy')(dataResponse.data, 'room');
        });

        var numStbs;
        quantionApi.getGrupos().then(function (dataResponse) {
            vm.listaGrupos = dataResponse.data.filter(function (elm) {
                return elm.stbs.length > 0;
            });

            vm.listaGrupos.sort(function (a, b) {
                return a.orden - b.orden;
            });

            numStbs = 0;

            $.each(vm.listaGrupos, function (index, value) {
                if (value.countable) {
                    numStbs += value.stbs.length;
                }
            });
        });

        //************** PAQUETES *****************
        vm.resetFormPaquetes = function () {
            var d = new Date();
            d.setDate(d.getDate() - 7);
            $scope.busquedaPaquetes = {
                fromDate: d,
                toDate: new Date(),
                resume: false,
                stbs: []
            };
            $scope.option = 'todos';
        };
        vm.resetFormPaquetes();

        vm.buscarOperacionesPaquetes = function () {
//            vm.listaOperacionesPaquetes = {};
            $scope.loadingPaquetes = true;
            $scope.error = false;

            var obj = {
                fromDate: $scope.busquedaPaquetes.fromDate ? parseDate($scope.busquedaPaquetes.fromDate) : null,
                toDate: $scope.busquedaPaquetes.toDate ? parseDate($scope.busquedaPaquetes.toDate) : null,
                resume: $scope.busquedaPaquetes.resume,
                remote: true
            };

            var stbs;
            $scope.selectedStbs = stbs;
            switch ($scope.option) {
                case 'todos':
                    stbs = null;
                    $scope.numStbs = numStbs;
                    break;
                case 'individual':
                    stbs = stbsSelected();
                    $scope.numStbs = stbs.length;
                    break;
                case 'grupo':
                    stbs = stbsSelected(true);
                    $scope.numStbs = stbs.length;
                    break;
            }

            quantionApi.getReportePaquetes(obj, stbs, false).then(function (dataResponse) {

                vm.listaOperacionesPaquetes = dataResponse.data.total ? dataResponse.data : {total: dataResponse.data};

                if (dataResponse.status === 202)
                    $mdToast.show($mdToast.simple().textContent('No se han podido obtener las operaciones anteriores a 3 meses').position('top right').hideDelay(5000));
//                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                if (vm.listaOperacionesPaquetes.eachDay) {
                    vm.listaOperacionesPaquetes.total.packages = $filter('orderBy')(vm.listaOperacionesPaquetes.total.packages, 'idPackage');

                    $.each(vm.listaOperacionesPaquetes.eachDay, function (index, value) {
                        value.reportMod = angular.copy(value.report);
                        $.each(vm.listaOperacionesPaquetes.total.packages, function (i, v) {
                            if (value.report.packages.map(function (el) {
                                return el.idPackage;
                            }).indexOf(v.idPackage) === -1) {
                                var v2 = angular.copy(v);
                                v2.totalAmount = 0;
                                v2.totalTimes = 0;
                                value.reportMod.packages.push(v2);
                            }
                        });
                        value.reportMod.packages = $filter('orderBy')(value.reportMod.packages, 'idPackage');
                    });
                }

                if (JSONconfig.hayMandos) {
                    var obj2 = angular.copy(obj);
                    obj2.package = 'extended';
                    quantionApi.getReporteAtmClientRc(obj2).then(function (dataResponse) {
                        vm.listaOperacionesMandos = dataResponse.data;
                    });
                }

                quantionApi.getReporteConcepto({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    concept: 'Voip',
                    resume: false,
                    remote: true
                }, stbs).then(function (dataResponse) {
                    vm.listaOperacionesVoip = dataResponse.data;

                    vm.listaOperacionesVoip.eachDay.sort(function (a, b) {
                        if (a.day > b.day) {
                            return 1;
                        }
                        if (b.day > a.day) {
                            return -1;
                        }
                        return 0;
                    });
                });

                quantionApi.getAccountant({
                    date: new Date(obj.fromDate).toDateString(),
                    until: new Date(obj.toDate).toDateString(),
                    concept: 'Refund',
                    limit: 1000,
                    remote: true
                }).then(function (dataResponse) {
                    var lista = stbs ? dataResponse.data.filter(function (op) {
                        return stbs.indexOf(op.idStb) !== -1;
                    }) : dataResponse.data;

                    var groupBy = function (data) {
                        var result = {
                            total: {times: 0, amount: 0, virtualAmount: 0, totalAmount: 0},
                            eachDay: []
                        };

                        var reduced = data.reduce(function (storage, item) {
                            var group = $filter('date')(item.date, 'yyyy-MM-dd');
                            storage[group] = storage[group] || [];
                            storage[group].push(item);
                            result.total.times += 1;
                            result.total.amount += Math.abs(item.amount);
                            result.total.virtualAmount += Math.abs(item.virtualAmount);
                            result.total.totalAmount = result.total.amount + result.total.virtualAmount;
                            return storage;
                        }, vm.listaOperacionesPaquetes.eachDay.reduce(function (obj, item) {
                            obj[$filter('date')(new Date(item.day), 'yyyy-MM-dd')] = [];
                            return obj;
                        }, {}));

                        result.eachDay = Object.keys(reduced).map(function (key) {
                            return {
                                day: key,
                                all: reduced[key],
                                report: {
                                    times: reduced[key].length,
                                    amount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.amount);
                                    }, 0),
                                    virtualAmount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.virtualAmount);
                                    }, 0),
                                    totalAmount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.amount) + Math.abs(item.virtualAmount);
                                    }, 0)
                                }
                            };
                        });

                        return result;
                    };

                    vm.listaDevoluciones = groupBy(lista);
                });

                quantionApi.getAccountant({
                    date: new Date(obj.fromDate).toDateString(),
                    until: new Date(obj.toDate).toDateString(),
                    payment: 'Cortesy',
                    limit: 1000,
                    remote: true
                }).then(function (dataResponse) {
                    var lista = stbs ? dataResponse.data.filter(function (op) {
                        return stbs.indexOf(op.idStb) !== -1;
                    }) : dataResponse.data;

                    var groupBy = function (data) {
                        var result = {
                            total: {times: 0, amount: 0, virtualAmount: 0, totalAmount: 0},
                            eachDay: []
                        };

                        var reduced = data.reduce(function (storage, item) {
                            var group = $filter('date')(item.date, 'yyyy-MM-dd');
                            storage[group] = storage[group] || [];
                            storage[group].push(item);
                            result.total.times += 1;
                            result.total.amount += Math.abs(item.amount);
                            result.total.virtualAmount += Math.abs(item.virtualAmount);
                            result.total.totalAmount = result.total.amount + result.total.virtualAmount;
                            return storage;
                        }, vm.listaOperacionesPaquetes.eachDay.reduce(function (obj, item) {
                            obj[$filter('date')(new Date(item.day), 'yyyy-MM-dd')] = [];
                            return obj;
                        }, {}));

                        result.eachDay = Object.keys(reduced).map(function (key) {
                            return {
                                day: key,
                                all: reduced[key],
                                report: {
                                    times: reduced[key].length,
                                    amount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.amount);
                                    }, 0),
                                    virtualAmount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.virtualAmount);
                                    }, 0),
                                    totalAmount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.amount) + Math.abs(item.virtualAmount);
                                    }, 0)
                                }
                            };
                        });

                        return result;
                    };

                    vm.listaCortesias = groupBy(lista);
                });

                quantionApi.getAccountant({
                    date: new Date(obj.fromDate).toDateString(),
                    until: new Date(obj.toDate).toDateString(),
                    concept: 'Balance',
                    place: 'Front',
                    limit: 1000,
                    remote: true
                }).then(function (dataResponse) {
                    var lista = stbs ? dataResponse.data.filter(function (op) {
                        return stbs.indexOf(op.idStb) !== -1;
                    }) : dataResponse.data;

                    var groupBy = function (data) {
                        var result = {
                            total: {times: 0, amount: 0, virtualAmount: 0, totalAmount: 0},
                            eachDay: []
                        };

                        var reduced = data.reduce(function (storage, item) {
                            var group = $filter('date')(item.date, 'yyyy-MM-dd');
                            storage[group] = storage[group] || [];
                            storage[group].push(item);
                            result.total.times += 1;
                            result.total.amount += Math.abs(item.amount);
                            result.total.virtualAmount += Math.abs(item.virtualAmount);
                            result.total.totalAmount = result.total.virtualAmount;// !!!!
                            return storage;
                        }, vm.listaOperacionesPaquetes.eachDay.reduce(function (obj, item) {
                            obj[$filter('date')(new Date(item.day), 'yyyy-MM-dd')] = [];
                            return obj;
                        }, {}));

                        result.eachDay = Object.keys(reduced).map(function (key) {
                            return {
                                day: key,
                                all: reduced[key],
                                report: {
                                    times: reduced[key].length,
                                    amount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.amount);
                                    }, 0),
                                    virtualAmount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.virtualAmount);
                                    }, 0),
                                    totalAmount: reduced[key].reduce(function (sum, item) {
                                        return sum + Math.abs(item.virtualAmount);// !!!!
                                    }, 0)
                                }
                            };
                        });

                        return result;
                    };

                    vm.listaRecargasFront = groupBy(lista);
                });

                if (vm.listaOperacionesPaquetes.total.packages.length === 0)
                    $scope.loadingPaquetes = false;
            }, function () {
                $scope.loadingPaquetes = false;
                vm.listaOperacionesPaquetes = null;
                $scope.error = true;
            });
        };

        function parseDate(date) {
//            return date.toLocaleDateString('es-ES').split('/').reverse().join('-');
            return $filter('date')(date, 'yyyy-MM-dd');
        }

        $scope.selectDay = function (day) {
            $mdDialog.show({
                controller: function ($scope) {
                    $scope.loading = true;

                    quantionApi.getReportePaquetes({
                        fromDate: $filter('date')(day, 'yyyy-MM-dd'),
                        toDate: $filter('date')(day, 'yyyy-MM-dd'),
                        resume: true,
                        remote: true
                    }, $scope.selectedStbs, true).then(function (dataResponse) {
                        $scope.reportPaquetes = dataResponse.data;
                        $scope.loading = false;

                        if (dataResponse.status === 202)
                            $mdToast.show($mdToast.simple().textContent('No se han podido obtener las operaciones anteriores a 3 meses').position('top right').hideDelay(5000));
                    }, function () {
                        $scope.loading = false;
                    });

                    $scope.JSONconfig = JSONconfig;
                },
                templateUrl: 'app/main/Quantion/gestionCompras/consumo/day.tmpl.html',
                clickOutsideToClose: true,
            });
        };

        $scope.verDevoluciones = function (report, $event) {
            listarOperaciones(report, $event, 'CONSUMO.DAY.TOTALDEVOLUCIONES');
        };

        $scope.verCortesias = function (report, $event) {
            listarOperaciones(report, $event, 'CONSUMO.DAY.TOTALCORTESIAS');
        };

        $scope.verRecargas = function (report, $event) {
            listarOperaciones(report, $event, 'CONSUMO.DAY.TOTALRECARGAS');
        };

        function listarOperaciones(report, $event, title) {
            $event.stopPropagation();

            $mdDialog.show({
                controller: function ($scope) {
                    $scope.report = report;
                    $scope.title = title;

                    $scope.transPayment = {
                        'Balance': 'OPERACIONES.PAYMENT.BALANCE',
                        'Cash': 'OPERACIONES.PAYMENT.CASH',
                        'Card': 'OPERACIONES.PAYMENT.CARD',
                        'PendingGive': 'OPERACIONES.PAYMENT.PENDINGGIVE',
                        'PendingReceive': 'OPERACIONES.PAYMENT.PENDINGRECEIVE',
                        'Cortesy': 'OPERACIONES.PAYMENT.CORTESY',
                        'None': 'OPERACIONES.PAYMENT.NONE',
                        'Paypal': 'OPERACIONES.PAYMENT.PAYPAL'
                    };

                    $scope.icons = {
                        Balance: 'icon-coin',
                        Package: 'icon-package-variant',
                        Service: 'icon-wallet-giftcard',
                        Cancellation: 'icon-cancel',
                        ChangeRoom: 'icon-swap-horizontal',
                        Refund: 'icon-quick-reply',
                        Wallet: 'icon-credit-card',
                        Voip: 'icon-phone'
                    };
                },
                templateUrl: 'app/main/Quantion/gestionCompras/consumo/list-operations.tmpl.html',
                clickOutsideToClose: true,
            });
        }

        $scope.toggle = function (gr) {
            gr.selected = !gr.selected;
        };

        function stbsSelected(isGroup) {
            if (isGroup) {
                var arr = [];
                $.each(vm.listaGrupos, function (ind, val) {
                    if (val.selected)
                        arr = arr.concat(val.stbs);
                });
                return arr;
            } else {
                return vm.listaStbs.filter(function (el) {
                    return el.selected;
                }).map(function (e) {
                    return e.idStb;
                });
            }
        }

        $scope.saveIndex = function (index) {
            $scope.index = index;
        };

        $scope.selectRange = function (index) {
            var min = Math.min(index, $scope.index);
            var max = Math.max(index, $scope.index);

            if (min !== max) {
                for (var i = min; i <= max; i++) {
                    $scope.toggle(vm.listaStbs[i]);
                }
            }
        };

        $scope.suma = function (val1, val2, val3, val4, div) {
            val3 = Math.abs(val3);
            var s = ($scope.option === 'todos' && JSONconfig.hayMandos) ? (val1 + val2 + val3 + val4) : (val1 + val3 + val4);
            return s / (div || 1);
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion')
            .controller('recaudacionController', recaudacionController);

    /** @ngInject */
    function recaudacionController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, $filter, JSONconfig)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_RECAUDACION';
        $scope.JSONconfig = JSONconfig;

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            $scope.loading = false;
        });

        quantionApi.getAtm().then(function (dataResponse) {
            vm.listaAtm = dataResponse.data;

            if (vm.listaAtm.length === 0) {
                $scope.searchMode = 'fecha';
            }
        });

        $scope.obtenerReporte = function () {

            var obj = $scope.searchMode === 'fecha' ?
                    {
                        fromDate: $scope.busqueda.fromDate ? parseDate($scope.busqueda.fromDate) : null,
                        toDate: $scope.busqueda.toDate ? parseDate($scope.busqueda.toDate) : null
                    } :
                    {
                        atm: $scope.busqueda.atm.idAtm,
                        idArqueo: $scope.busqueda.idArqueo
                    };

            $scope.numRequests = 4;
            $scope.numRequestsFinished = 0;

            quantionApi.getReporteAtmAdmin(obj).then(function (dataResponse) {
                vm.reporte = dataResponse.data;
                $scope.numRequestsFinished++;
            }, function () {
                $scope.numRequestsFinished++;
            });

            vm.reporteClient = {};
            quantionApi.getReporteAtmClientCash(obj).then(function (dataResponse) {
                vm.reporteClient.cash = dataResponse.data;
                $scope.numRequestsFinished++;
            }, function () {
                $scope.numRequestsFinished++;
            });

            quantionApi.getReporteAtmClientCard(obj).then(function (dataResponse) {
                vm.reporteClient.card = dataResponse.data;
                $scope.numRequestsFinished++;
            }, function () {
                $scope.numRequestsFinished++;
            });

            if (JSONconfig.hayMandos) {
                $scope.numRequests++;
                quantionApi.getReporteAtmClientRc(obj).then(function (dataResponse) {
                    vm.reporteClient.rc = dataResponse.data;
                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });
            }

            quantionApi.getReporteAtmClientFree(obj).then(function (dataResponse) {
                vm.reporteClient.free = dataResponse.data;
                vm.reporteClient.free.atm.map(function (el) {
                    el.dispensar = el.details.filter(function (el) {
                        return el.type === 'Dispensar';
                    });
                    el.pagar = el.details.filter(function (el) {
                        return el.type === 'Pagar';
                    });
                });
                $scope.numRequestsFinished++;
            }, function () {
                $scope.numRequestsFinished++;
            });

            if (obj.fromDate && obj.toDate) {
                $scope.numRequests += 6;

                vm.reporteClient.paypal = {};

                quantionApi.getReportePago({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    payment: 'Paypal',
                    resume: false,
                    remote: true,
                    place: 'Stb'
                }).then(function (dataResponse) {
                    vm.reporteClient.paypal.Stb = dataResponse.data;

                    if (dataResponse.status === 202)
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });

                quantionApi.getReportePago({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    payment: 'Paypal',
                    resume: false,
                    remote: true,
                    place: 'TiendaJoyclinic'
                }).then(function (dataResponse) {
                    vm.reporteClient.paypal.TiendaJoyclinic = dataResponse.data;

                    if (dataResponse.status === 202)
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });

                quantionApi.getReportePago({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    payment: 'Paypal',
                    resume: false,
                    remote: true,
                    place: 'Front'
                }).then(function (dataResponse) {
                    vm.reporteClient.paypal.Front = dataResponse.data;

                    if (dataResponse.status === 202)
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });

                vm.reporteClient.papam = {};

                quantionApi.getReportePago({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    payment: 'Card',
                    resume: false,
                    remote: true,
                    place: 'Stb'
                }).then(function (dataResponse) {
                    vm.reporteClient.papam.Stb = dataResponse.data;

                    if (dataResponse.status === 202)
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });

                quantionApi.getReportePago({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    payment: 'Card',
                    resume: false,
                    remote: true,
                    place: 'TiendaJoyclinic'
                }).then(function (dataResponse) {
                    vm.reporteClient.papam.TiendaJoyclinic = dataResponse.data;

                    if (dataResponse.status === 202)
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });

                quantionApi.getReportePago({
                    fromDate: obj.fromDate,
                    toDate: obj.toDate,
                    payment: 'Card',
                    resume: false,
                    remote: true,
                    place: 'Front'
                }).then(function (dataResponse) {
                    vm.reporteClient.papam.Front = dataResponse.data;

                    if (dataResponse.status === 202)
                        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));

                    $scope.numRequestsFinished++;
                }, function () {
                    $scope.numRequestsFinished++;
                });
            }
        };

        $scope.resetForm = function () {
            var d = new Date();
            d.setDate(d.getDate() - 7);
            $scope.busqueda = {
                fromDate: d,
                toDate: new Date()
            };
        };
        $scope.resetForm();

        function parseDate(date) {
//            return date.toLocaleDateString('es-ES').split('/').reverse().join('-');
            return $filter('date')(date, 'yyyy-MM-dd');
        }

        $scope.operationAdminDetails = function (operation, type) {
            var title, list;

            switch (type) {
                case 'Descarga':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESDESCARGA');
                    list = operation.download;
                    break;
                }
                case 'Recarga':
                {
                    title = $filter('translate')("RECAUDACION.OPERACIONESRECARGA");
                    list = operation.upload;
                    break;
                }
            }

            $mdDialog.show({
                controller: function ($scope, data) {
                    $scope.title = title;
                    $scope.data = $filter('orderBy')(data, '-date');
                    $scope.medidas = {
                        "c1": "1c",
                        "c2": "2c",
                        "c5": "5c",
                        "c10": "10c",
                        "c20": "20c",
                        "c50": "50c",
                        "c100": "1€",
                        "c200": "2€",
                        "b5": "5€",
                        "b10": "10€",
                        "b20": "20€",
                        "b50": "50€",
                        "b100": "100€",
                        "b200": "200€",
                        "b500": "500€"};

                    $scope.groupedData = {};
                    $.each($scope.data, function (index, value) {
                        var d = $filter('date')(value.date, 'dd/MM/yyyy');
                        if ($scope.groupedData[d] === undefined)
                            $scope.groupedData[d] = 0;
                        $scope.groupedData[d] += value.total;
                    });
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/admin.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    data: list
                }
            });
        };

        $scope.operationClientesDetailsCash = function (operation, type) {
            var title, list, tipoOp;

            switch (type) {
                case 'In':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESINGRESO');
                    tipoOp = $filter('translate')('RECAUDACION.COBRO');
                    list = operation.in;
                    break;
                }
                case 'Out':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESABONO');
                    tipoOp = $filter('translate')('RECAUDACION.PAGO');
                    list = operation.out;
                    break;
                }
            }

            $mdDialog.show({
                controller: function ($scope, data) {
                    $scope.title = title;
                    $scope.data = $filter('orderBy')(data, '-date');
                    $scope.tipoOp = tipoOp;
                    $scope.medidas = {
                        "c1": "1c",
                        "c2": "2c",
                        "c5": "5c",
                        "c10": "10c",
                        "c20": "20c",
                        "c50": "50c",
                        "c100": "1€",
                        "c200": "2€",
                        "b5": "5€",
                        "b10": "10€",
                        "b20": "20€",
                        "b50": "50€",
                        "b100": "100€",
                        "b200": "200€",
                        "b500": "500€"};

                    $scope.groupedData = {};
                    $.each($scope.data, function (index, value) {
                        var d = $filter('date')(value.date, 'dd/MM/yyyy');
                        if ($scope.groupedData[d] === undefined)
                            $scope.groupedData[d] = 0;
                        $scope.groupedData[d] += value.totalBalance;
                    });
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/cash.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    data: list
                }
            });
        };

        $scope.operationClientesDetailsCard = function (operation, type) {
            var title, list;

            switch (type) {
                case 'Yes':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESFINALIZADAS');
                    list = operation.details.filter(function (e) {
                        return e.completed;
                    });
                    break;
                }
                case 'No':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESABORTADAS');
                    list = operation.details.filter(function (e) {
                        return !e.completed;
                    });
                    break;
                }
            }

            $mdDialog.show({
                controller: function ($scope, data) {
                    $scope.title = title;
                    $scope.data = $filter('orderBy')(data, '-date');

                    $scope.groupedData = {};
                    $.each($scope.data, function (index, value) {
                        var d = $filter('date')(value.date, 'dd/MM/yyyy');
                        if ($scope.groupedData[d] === undefined)
                            $scope.groupedData[d] = 0;
                        $scope.groupedData[d] += value.amount;
                    });
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/card.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    data: list
                }
            });
        };

        $scope.operationClientesDetailsRc = function (operation, type) {
            var title, list, tmpl;

            switch (type) {
                case 'dispensar':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESDISPENSARMANDO');
                    list = operation.dispensar;
                    tmpl = 'app/main/Quantion/gestionCompras/recaudacion/templates/mandos.tmpl.html';
                    break;
                }
                case 'recoger':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESRECOGERMANDO');
                    list = operation.recoger;
                    tmpl = 'app/main/Quantion/gestionCompras/recaudacion/templates/mandos.tmpl.html';
                    break;
                }
                case 'cupones':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESCUPONESMANDO');
                    list = operation.cupon;
                    tmpl = 'app/main/Quantion/gestionCompras/recaudacion/templates/cupones.tmpl.html';
                    break;
                }
            }

            $mdDialog.show({
                controller: function ($scope, data) {
                    $scope.title = title;
                    $scope.data = data;
                },
                templateUrl: tmpl,
                clickOutsideToClose: true,
                locals: {
                    data: list
                }
            });
        };

        $scope.operationClientesDetailsFree = function (operation, type) {
            var title, list;

            switch (type) {
                case 'dispensar':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESDISPENSAR');
                    list = operation.dispensar;
                    break;
                }
                case 'pagar':
                {
                    title = $filter('translate')('RECAUDACION.OPERACIONESPAGAR');
                    list = operation.pagar;
                    break;
                }
            }

            $mdDialog.show({
                controller: function ($scope, data) {
                    $scope.title = title;
                    $scope.data = data;
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/gratis.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    data: list
                }
            });
        };

        $scope.operationPaypalDetails = function (place) {
            $mdDialog.show({
                controller: function ($scope) {
                    $scope.title = $filter('translate')('RECAUDACION.OPERACIONESPAYPAL');
                    $scope.data = vm.reporteClient.paypal[place];
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/paypal.tmpl.html',
                clickOutsideToClose: true
            });
        };

        $scope.operationPapamDetails = function (place) {
            $mdDialog.show({
                controller: function ($scope) {
                    $scope.title = $filter('translate')('RECAUDACION.OPERACIONESPAPAM');
                    $scope.data = vm.reporteClient.papam[place];
                },
                templateUrl: 'app/main/Quantion/gestionCompras/recaudacion/templates/paypal.tmpl.html',
                clickOutsideToClose: true
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.contabilidad_sin_precios', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_contabilidad_sin_precios', {
            url: '/activaciones',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/consumo_sin_precios/contabilidad.html',
                    controller: 'contabilidadSinPreciosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/consumo_sin_precios');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.contabilidad_sin_precios')
            .controller('contabilidadSinPreciosController', contabilidadSinPreciosController);

    /** @ngInject */
    function contabilidadSinPreciosController(quantionApi, $mdDialog, $scope, $rootScope, JSONconfig, $filter, $mdToast)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_CONTABILIDAD';
        $scope.JSONconfig = JSONconfig;

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            $scope.loadingStbs = false;
            $scope.loadingPaquetes = false;
            $scope.loadingCajeros = false;
        });

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = $filter('orderBy')(dataResponse.data, 'room');
        });

        var numStbs;
        quantionApi.getGrupos().then(function (dataResponse) {
            vm.listaGrupos = dataResponse.data.filter(function (elm) {
                return elm.stbs.length > 0;
            });

            vm.listaGrupos.sort(function (a, b) {
                return a.orden - b.orden;
            });

            numStbs = 0;

            $.each(vm.listaGrupos, function (index, value) {
                if (value.countable) {
                    numStbs += value.stbs.length;
                }
            });
        });

        //************** PAQUETES *****************
        vm.resetFormPaquetes = function () {
            var d = new Date();
            d.setDate(d.getDate() - 7);
            $scope.busquedaPaquetes = {
                fromDate: d,
                toDate: new Date(),
                resume: true,
                stbs: []
            };
            $scope.option = 'todos';
        };
        vm.resetFormPaquetes();

        vm.buscarOperacionesPaquetes = function () {
//            vm.listaOperacionesPaquetes = {};
            $scope.loadingPaquetes = true;
            $scope.error = false;

            var obj = {
                fromDate: $scope.busquedaPaquetes.fromDate ? parseDate($scope.busquedaPaquetes.fromDate) : null,
                toDate: $scope.busquedaPaquetes.toDate ? parseDate($scope.busquedaPaquetes.toDate) : null,
                resume: $scope.busquedaPaquetes.resume,
                remote: true
            };

            var stbs;
            $scope.selectedStbs = stbs;
            switch ($scope.option) {
                case 'todos':
                    stbs = null;
                    $scope.numStbs = numStbs;
                    break;
                case 'individual':
                    stbs = stbsSelected();
                    $scope.numStbs = stbs.length;
                    break;
                case 'grupo':
                    stbs = stbsSelected(true);
                    $scope.numStbs = stbs.length;
                    break;
            }

            quantionApi.getReportePaquetes(obj, stbs, true).then(function (dataResponse) {
                if (dataResponse.status === 202)
                    $mdToast.show($mdToast.simple().textContent('No se han podido obtener las operaciones anteriores a 3 meses').position('top right').hideDelay(5000));

                $scope.reportPaquetes = dataResponse.data;
                $scope.loadingPaquetes = false;
            }, function () {
                $scope.loadingPaquetes = false;
                $scope.error = true;
            });
        };

        function parseDate(date) {
//            return date.toLocaleDateString('es-ES').split('/').reverse().join('-');
            return $filter('date')(date, 'yyyy-MM-dd');
        }

        $scope.toggle = function (gr) {
            gr.selected = !gr.selected;
        };

        function stbsSelected(isGroup) {
            if (isGroup) {
                var arr = [];
                $.each(vm.listaGrupos, function (ind, val) {
                    if (val.selected)
                        arr = arr.concat(val.stbs);
                });
                return arr;
            } else {
                return vm.listaStbs.filter(function (el) {
                    return el.selected;
                }).map(function (e) {
                    return e.idStb;
                });
            }
        }

        $scope.saveIndex = function (index) {
            $scope.index = index;
        };

        $scope.selectRange = function (index) {
            var min = Math.min(index, $scope.index);
            var max = Math.max(index, $scope.index);

            if (min !== max) {
                for (var i = min; i <= max; i++) {
                    $scope.toggle(vm.listaStbs[i]);
                }
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.operaciones', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_operaciones', {
            url: '/gestionCompras/:idStb',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/operaciones/gestionCompras.html',
                    controller: 'gestionComprasController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/operaciones');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.operaciones')
            .controller('gestionComprasController', gestionComprasController);

    /** @ngInject */
    function gestionComprasController(quantionApi, $mdDialog, $mdToast, $scope, $stateParams, $filter, $rootScope, IncidencesConfig, cajeroService)
    {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_OPERACIONES';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            $scope.loading = false;
        });

        function CargarStbs() {
            pantallaCarga.lsEnable('LS.DATOSVOIP');
            quantionApi.getStbs(true).then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;
                pantallaCarga.lsDisable();
            });
        }
        CargarStbs();

        function CargarWallets() {
            quantionApi.getWallets(true).then(function (dataResponse) {
                vm.listaWallets = dataResponse.data;
            });
        }
        CargarWallets();

        function CargarPaquetes() {
            quantionApi.getPaquetesActivos().then(function (dataResponse) {
                vm.listaPaquetes = dataResponse.data;
            });
        }
        CargarPaquetes();

        function CargarServicios() {
            quantionApi.getServicios().then(function (dataResponse) {
                vm.listaServicios = dataResponse.data;
            });
        }
        CargarServicios();

        function CargarCajeros() {
            quantionApi.getAtm().then(function (dataResponse) {
                vm.listaCajeros = dataResponse.data;

                vm.mapCajeros = {};
                $.each(vm.listaCajeros, function (index, value) {
                    vm.mapCajeros[value.ip] = value;
                });
            });
        }
        CargarCajeros();

        quantionApi.getBalanceLimit().then(function (dataResponse) {
            vm.balanceLimit = dataResponse.data;
        });

        quantionApi.getUsuarios().then(function (dataResponse) {
            vm.listaUsuarios = $filter('orderBy')(dataResponse.data, 'name');
        });

        //******************** BUSQUEDA PRINCIPAL ***********
        $scope.opcionesBusqueda = {
            limites: {
                'OPERACIONES.BUSQUEDA.LIMIT.TODAS': null,
                'OPERACIONES.BUSQUEDA.LIMIT.ULTIMA': 1,
                'OPERACIONES.BUSQUEDA.LIMIT.ULTIMA5': 5,
                'OPERACIONES.BUSQUEDA.LIMIT.ULTIMA10': 10,
                'OPERACIONES.BUSQUEDA.LIMIT.ULTIMA50': 50,
                'OPERACIONES.BUSQUEDA.LIMIT.ULTIMA100': 100
            },
            check: {
                'OPERACIONES.BUSQUEDA.CHECK.NULL': null,
                'OPERACIONES.BUSQUEDA.CHECK.7DAYS': '7days',
                'OPERACIONES.BUSQUEDA.CHECK.IN': 'In',
                'OPERACIONES.BUSQUEDA.CHECK.OUT': 'Out',
                'OPERACIONES.BUSQUEDA.CHECK.DATE': 'Date'
            },
            payment: {
                'OPERACIONES.BUSQUEDA.PAYMENT.TODAS': null,
                'OPERACIONES.BUSQUEDA.PAYMENT.BALANCE': 'Balance',
                'OPERACIONES.BUSQUEDA.PAYMENT.CASH': 'Cash',
                'OPERACIONES.BUSQUEDA.PAYMENT.CARD': 'Card',
                'OPERACIONES.BUSQUEDA.PAYMENT.PENDINGGIVE': 'PendingGive',
                'OPERACIONES.BUSQUEDA.PAYMENT.PENDINGRECEIVE': 'PendingReceive',
                'OPERACIONES.BUSQUEDA.PAYMENT.CORTESY': 'Cortesy',
                'OPERACIONES.BUSQUEDA.PAYMENT.NONE': 'None',
                'OPERACIONES.BUSQUEDA.PAYMENT.PAYPAL': 'Paypal'
            },
            revokable: {
                'OPERACIONES.BUSQUEDA.REVOKABLE.NULL': null,
                'OPERACIONES.BUSQUEDA.REVOKABLE.TRUE': true,
                'OPERACIONES.BUSQUEDA.REVOKABLE.FALSE': false
            },
            concept: {
                'OPERACIONES.BUSQUEDA.CONCEPT.NULL': null,
                'OPERACIONES.BUSQUEDA.CONCEPT.BALANCE': 'Balance',
                'OPERACIONES.BUSQUEDA.CONCEPT.PACKAGE': 'Package',
                'OPERACIONES.BUSQUEDA.CONCEPT.SERVICE': 'Service',
                'OPERACIONES.BUSQUEDA.CONCEPT.CANCELLATION': 'Cancellation',
                'OPERACIONES.BUSQUEDA.CONCEPT.CHANGEROOM': 'ChangeRoom',
                'OPERACIONES.BUSQUEDA.CONCEPT.REFUND': 'Refund',
                'OPERACIONES.BUSQUEDA.CONCEPT.WALLET': 'Wallet',
                'OPERACIONES.BUSQUEDA.CONCEPT.VOIP': 'Voip'
            },
            places: {
                'OPERACIONES.BUSQUEDA.PLACE.NULL': null,
                'OPERACIONES.BUSQUEDA.PLACE.STB': 'Stb',
                'OPERACIONES.BUSQUEDA.PLACE.FRONT': 'Front',
                'OPERACIONES.BUSQUEDA.PLACE.CAJERO': 'Cajero',
                'OPERACIONES.BUSQUEDA.PLACE.TIENDAJOYCLINIC': 'TiendaJoyclinic'
            },
            defaultValues: {
                'limit': null,
                'check': 'Date',
                'payment': null,
                'revokable': null,
                'concept': null
            },
            maxDate: new Date()
        };

        $scope.icons = {
            Balance: 'icon-coin',
            Package: 'icon-package-variant',
            Service: 'icon-wallet-giftcard',
            Cancellation: 'icon-cancel',
            ChangeRoom: 'icon-swap-horizontal',
            Refund: 'icon-quick-reply',
            Wallet: 'icon-credit-card',
            Voip: 'icon-phone'
        };

        vm.resetForm = function () {
            $scope.busqueda = {
                selectedStb: null,
                limit: $scope.opcionesBusqueda.defaultValues.limit,
                check: $scope.opcionesBusqueda.defaultValues.check,
                date: new Date($filter('date')($scope.opcionesBusqueda.maxDate, 'yyyy-MM-ddT00:00Z')),
                until: new Date($filter('date')($scope.opcionesBusqueda.maxDate, 'yyyy-MM-ddT00:00Z')),
                payment: $scope.opcionesBusqueda.defaultValues.payment,
                revokable: $scope.opcionesBusqueda.defaultValues.revokable,
                concept: $scope.opcionesBusqueda.defaultValues.concept,
                place: null,
                extendedPlace: null
            };

            $scope.stbOrWallet = 'stb';
            $scope.searchText = null;
        };
        vm.resetForm();

        vm.querySearch = function (query) {
            var lowercaseQuery = angular.lowercase(query);

            var results = query ? vm.listaStbs.filter(function (e) {
                return (angular.lowercase(e.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(e.username).indexOf(lowercaseQuery) !== -1);
            }) : vm.listaStbs;
            return results;
        };

        $scope.TODAY = new Date();

        vm.buscarOperaciones = function (idStbOnInit) {
            vm.listaOperaciones = [];
            $scope.loading = true;
            $scope.error = null;

            var obj;

            if (idStbOnInit) {
                obj = {
                    check: 'Out',
                    limit: 100
                };

                if (idStbOnInit[0] === '_')
                    obj.wallet = idStbOnInit.substr(1);
                else
                    obj.stb = idStbOnInit;
            } else {
                obj = {
                    limit: $scope.busqueda.limit ? $scope.busqueda.limit : 1000,
                    payment: $scope.busqueda.payment,
                    revokable: $scope.busqueda.revokable,
                    concept: $scope.busqueda.concept,
                    place: $scope.busqueda.place,
                    extendedPlace: $scope.busqueda.place === 'Cajero' ? $scope.busqueda.extendedPlace : null,
                    username: $scope.busqueda.username || null,
                    remote: true
                };

                if ($scope.stbOrWallet === 'stb') {
                    obj.stb = $scope.busqueda.selectedStb ? $scope.busqueda.selectedStb.idStb : null;
                    obj.room = $scope.busqueda.selectedStb ? $scope.busqueda.selectedStb.room : ($scope.searchText || null);
                } else {
                    obj.wallet = ($scope.searchText || null);
                }

                switch ($scope.busqueda.check) {
                    case 'Date':
                        obj.date = $scope.busqueda.date.toDateString();
                        obj.until = $scope.busqueda.until.toDateString();
                        obj.remote = ($scope.TODAY - $scope.busqueda.date) > 7889400000; //3 meses en milisegundos
                        break;
                    case '7days':
                        var d = new Date();
                        obj.date = (new Date(d.setDate(d.getDate() - 7))).toDateString();
                        break;
                    default:
                        obj.check = $scope.busqueda.check;
                }
            }

            quantionApi.getAccountant(obj).then(function (dataResponse) {
                if (dataResponse.data.length < 1)
                    $scope.loading = false;

                vm.listaOperaciones = dataResponse.data;

                if (dataResponse.status === 202)
                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No se han podido obtener las operaciones anteriores a 3 meses').ok('Cerrar'));
            }, function (dataResponse) {
                $scope.loading = false;

                if (dataResponse.status === 400)
                    $scope.error = $filter('translate')('OPERACIONES.ERRORSINPARAMETROS');
            });
        };

        $scope.transPayment = {
            'Balance': 'OPERACIONES.PAYMENT.BALANCE',
            'Cash': 'OPERACIONES.PAYMENT.CASH',
            'Card': 'OPERACIONES.PAYMENT.CARD',
            'PendingGive': 'OPERACIONES.PAYMENT.PENDINGGIVE',
            'PendingReceive': 'OPERACIONES.PAYMENT.PENDINGRECEIVE',
            'Cortesy': 'OPERACIONES.PAYMENT.CORTESY',
            'None': 'OPERACIONES.PAYMENT.NONE',
            'Paypal': 'OPERACIONES.PAYMENT.PAYPAL'
        };

        if ($stateParams.idStb) {
            vm.buscarOperaciones($stateParams.idStb);
        }

        vm.buscarPorID = function (busquedaID) {
            vm.listaOperaciones = [];
            $scope.loading = true;

            quantionApi.getAccountantByID(busquedaID).then(function (dataResponse) {
                $scope.loading = false;

                vm.listaOperaciones = [dataResponse.data];
            }, function () {
                $scope.loading = false;
            });
        };

        //******************** NUEVA COMPRA ***************
        vm.nuevaCompra = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/gestionCompras/operaciones/templates/nuevacompra.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.listaStbs = vm.listaStbs.filter(function (stb) {
                return stb.checkInOut === 'In';
            });
            $scope.listaWallets = vm.listaWallets;
            $scope.listaPaquetes = vm.listaPaquetes;

            $scope.balanceLimit = vm.balanceLimit;

            //Métodos de búsqueda
            $scope.stbSearch = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                var results = query ? $scope.listaStbs.filter(function (e) {
                    return (angular.lowercase(e.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(e.username).indexOf(lowercaseQuery) !== -1);
                }) : $scope.listaStbs;
                return results;
            };

            $scope.walletSearch = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                var results = query ? $scope.listaWallets.filter(function (e) {
                    return (angular.lowercase(e.uuidVirtualWallet).indexOf(lowercaseQuery) === 0);
                }) : $scope.listaWallets;
                return results;
            };

            $scope.checkCustomPayment = function () {
                if ($scope.compra.payment !== 'Cortesy' && $scope.compra.duration === 'custom')
                    $scope.compra.duration = null;
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    stb: $scope.stbOrWallet === 'stb' ? $scope.compra.selectedStb.idStb : null,
                    wallet: $scope.stbOrWallet === 'wallet' ? $scope.compra.selectedWallet.uuidVirtualWallet : null,
                    package: $scope.compra.selectedPackage.idPackage,
                    duration: $scope.compra.duration === 'custom' ? $scope.compra.customDuration : $scope.compra.duration,
//                    duration: $scope.compra.duration,
                    payment: $scope.compra.payment !== 'TwoPending' ? $scope.compra.payment : null,
                    language: 'es',
                    policy: $scope.compra.payment !== 'TwoPending' ? 'OneShot' : 'TwoPending',
                    place: 'Front',
                    username: $rootScope.user.name
                };

//                console.log(obj)

                quantionApi.acquirePackage(obj, $scope.compra.comment ? ($scope.compra.comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('OPERACIONES.NUEVACOMPRA.TOAST'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    vm.resetForm();
                    vm.listaOperaciones = [];
                    CargarStbs();

                    $scope.dataLoading = false;

                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = 'OPERACIONES.NUEVACOMPRA.MENSAJEERROR';
                    $scope.dataLoading = false;
                });
            };
        }

        //******************** NUEVA RECARGA DE SALDO ***************
        vm.recargaSaldo = function (ev) {
            $mdDialog.show({
                controller: SaldoCtrl,
                templateUrl: 'app/main/Quantion/gestionCompras/operaciones/templates/recargasaldo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function SaldoCtrl($scope, $mdDialog, $mdToast) {
            $scope.listaStbs = vm.listaStbs.filter(function (stb) {
                return stb.checkInOut === 'In';
            });

            $scope.listaWallets = vm.listaWallets;

            $scope.balanceLimit = vm.balanceLimit;

            //Métodos de búsqueda
            $scope.stbSearch = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                var results = query ? $scope.listaStbs.filter(function (e) {
                    return (angular.lowercase(e.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(e.username).indexOf(lowercaseQuery) !== -1);
                }) : $scope.listaStbs;
                return results;
            };

            $scope.walletSearch = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                var results = query ? $scope.listaWallets.filter(function (e) {
                    return (angular.lowercase(e.uuidVirtualWallet).indexOf(lowercaseQuery) === 0);
                }) : $scope.listaWallets;
                return results;
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    stb: $scope.stbOrWallet === 'stb' ? $scope.recarga.selectedStb.idStb : null,
                    wallet: $scope.stbOrWallet === 'wallet' ? $scope.recarga.selectedWallet.uuidVirtualWallet : null,
                    amount: $scope.recarga.amount,
                    payment: $scope.recarga.payment,
                    language: 'es',
                    policy: 'OneShot',
                    place: 'Front',
                    username: $rootScope.user.name
                };

                quantionApi.acquireBalance(obj, $scope.recarga.comment ? ($scope.recarga.comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('OPERACIONES.RECARGASALDO.TOAST'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    vm.resetForm();
                    vm.listaOperaciones = [];
                    CargarStbs();

                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    $scope.mensajeError = 'OPERACIONES.RECARGASALDO.MENSAJEERROR';
                    $scope.dataLoading = false;
                });
            };
        }

        //******************** Pagar operacion pendiente ***************
        vm.finishPendingOperation = function (ev, operation) {
            $mdDialog.show({
                controller: finishPendingOperationCtrl,
                templateUrl: 'app/main/Quantion/gestionCompras/operaciones/templates/finishpending.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {operation: operation}
            });
        };

        function finishPendingOperationCtrl($scope, $mdDialog, $mdToast, operation) {
            $scope.listaStbs = vm.listaStbs;
            $scope.operation = operation;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    accountant: operation.idAccountant,
                    payment: $scope.finish.payment,
                    policy: 'TwoFinished',
                    language: 'es',
                    place: 'Front',
                    username: $rootScope.user.name
                };

                quantionApi.acquirePackage(obj, $scope.finish.comment ? ($scope.finish.comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                    CargarStbs();

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('OPERACIONES.TOASTPENDING'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    vm.buscarOperaciones();
                    $scope.hide();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    if (dataResponse.status === 403) {
                        $scope.mensajeError = 'OPERACIONES.FINISHPENDING.ERROR';
                    }
                    $scope.dataLoading = false;
                });
            };
        }

        //******************* Abortar operacion pendiente **************

        vm.abortPendingOperation = function (ev, oper) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('OPERACIONES.ABORTPENDING.TITLE'))
                    .textContent($filter('translate')('OPERACIONES.ABORTPENDING.CONTENT'))
                    .ariaLabel('Abortar operación')
                    .targetEvent(ev)
                    .ok($filter('translate')('OPERACIONES.ABORTPENDING.OK'))
                    .cancel($filter('translate')('OPERACIONES.ABORTPENDING.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                Abort(oper);
            });
        };

        function Abort(oper) {
            var obj = {
                accountant: oper.idAccountant,
                policy: 'TwoAborted',
                place: 'Front',
                language: 'es',
                username: $rootScope.user.name
            };

            var comment = 'Abortada la operación ' + oper.idAccountant + ' desde el administrador';

            quantionApi.acquirePackage(obj, comment ? (comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('OPERACIONES.ABORTPENDING.TOAST'))
                        .position('top right')
                        .hideDelay(3000)
                        );

                vm.buscarOperaciones();
            }, function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('OPERACIONES.ABORTPENDING.TOASTERROR'))
                        .position('top right')
                        .hideDelay(3000)
                        );
            });
        }

        //********************** Revocar operacion *****************

        vm.revokeOperation = function (ev, oper) {
            $mdDialog.show({
                controller: RevokeCtrl,
                templateUrl: 'app/main/Quantion/gestionCompras/operaciones/templates/revokeoperation.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {operation: oper}
            });
        };

        function RevokeCtrl($scope, $mdDialog, $mdToast, operation) {
            $scope.operation = operation;
            $scope.operation.maxImport = Math.max(operation.amount, Math.abs(operation.virtualAmount));

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    identifier: operation.idAccountant,
                    policy: $scope.revokation.policy,
                    place: 'Front',
                    refund: $scope.revokation.refund,
                    username: $rootScope.user.name
                };

                quantionApi.revokeOperation(obj, $scope.revokation.comment ? ($scope.revokation.comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('OPERACIONES.DEVOLUCION.TOAST'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    vm.buscarOperaciones();
                    CargarStbs();

                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = 'OPERACIONES.DEVOLUCION.ERROR';
                    $scope.dataLoading = false;
                });
            };
        }

        //******************* Registrar devolucion pendiente **************

        vm.finishPendingRevokation = function (ev, oper) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('OPERACIONES.FINISHPENDINGREVOCATION.TITLE'))
                    .textContent($filter('translate')('OPERACIONES.FINISHPENDINGREVOCATION.CONTENT'))
                    .ariaLabel('Finalizar revocacion')
                    .targetEvent(ev)
                    .ok($filter('translate')('OPERACIONES.FINISHPENDINGREVOCATION.OK'))
                    .cancel($filter('translate')('OPERACIONES.FINISHPENDINGREVOCATION.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                FinishRevokation(oper);
            });
        };

        function FinishRevokation(oper) {
            var obj = {
                identifier: oper.idAccountant,
                policy: 'TwoFinished',
                place: 'Front',
                username: $rootScope.user.name
            };

            var comment = 'Finalizada la devolución de ' + Math.abs(oper.virtualAmount) + '€ a la habitación ' + oper.room + ' desde el administrador';

            quantionApi.revokeOperation(obj, comment ? (comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('OPERACIONES.FINISHPENDINGREVOCATION.TOAST'))
                        .position('top right')
                        .hideDelay(3000)
                        );

                vm.buscarOperaciones();
            }, function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('OPERACIONES.DEVOLUCION.ERROR'))
                        .position('top right')
                        .hideDelay(3000)
                        );
            });
        }

        //******************* Registrar devolucion pendiente **************

        vm.abortPendingRevokation = function (ev, oper) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('OPERACIONES.ABORTPENDINGREVOCATION.TITLE'))
                    .ariaLabel('Abortar revocacion')
                    .targetEvent(ev)
                    .ok($filter('translate')('OPERACIONES.ABORTPENDINGREVOCATION.OK'))
                    .cancel($filter('translate')('OPERACIONES.ABORTPENDINGREVOCATION.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                AbortRevokation(oper);
            });
        };

        function AbortRevokation(oper) {
            var obj = {
                identifier: oper.idAccountant,
                policy: 'TwoAborted',
                place: 'Front',
                username: $rootScope.user.name
            };

            var comment = 'Abortada la devolución de ' + Math.abs(oper.virtualAmount) + '€ a la habitación ' + oper.room + ' desde el administrador';

            quantionApi.revokeOperation(obj, comment ? (comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('OPERACIONES.ABORTPENDINGREVOCATION.TOAST'))
                        .position('top right')
                        .hideDelay(3000)
                        );

                vm.buscarOperaciones();
            }, function (dataResponse) {
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('OPERACIONES.ABORTPENDINGREVOCATION.ERROR'))
                        .position('top right')
                        .hideDelay(3000)
                        );
            });
        }

        //************* ASIGNAR SERVICIO DE CORTESIA ***************
        vm.nuevaAsignacionServicio = function (ev) {
            $mdDialog.show({
                controller: AsigServCtrl,
                templateUrl: 'app/main/Quantion/gestionCompras/operaciones/templates/asignaServicios.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AsigServCtrl($scope, $mdDialog, $mdToast) {
            $scope.listaStbs = vm.listaStbs.filter(function (stb) {
                return stb.checkInOut === 'In';
            });
            $scope.listaWallets = vm.listaWallets;
            $scope.listaServicios = vm.listaServicios;

            //Métodos de búsqueda
            $scope.stbSearch = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                var results = query ? $scope.listaStbs.filter(function (e) {
                    return (angular.lowercase(e.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(e.username).indexOf(lowercaseQuery) !== -1);
                }) : $scope.listaStbs;
                return results;
            };

            $scope.walletSearch = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                var results = query ? $scope.listaWallets.filter(function (e) {
                    return (angular.lowercase(e.uuidVirtualWallet).indexOf(lowercaseQuery) === 0);
                }) : $scope.listaWallets;
                return results;
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;

                var obj = {
                    stb: $scope.stbOrWallet === 'stb' ? $scope.compra.selectedStb.idStb : null,
                    wallet: $scope.stbOrWallet === 'wallet' ? $scope.compra.selectedWallet.uuidVirtualWallet : null,
                    duration: $scope.compra.duration,
                    language: 'es',
                    place: 'Front',
                    username: $rootScope.user.name
                };

                var jsonObj = angular.toJson({"comment": $scope.compra.comment ? ($scope.compra.comment + ' - ' + $rootScope.user.name) : null, "idServices": [$scope.compra.selectedService.idService]}, 0);

                quantionApi.acquireService(obj, jsonObj).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('OPERACIONES.SERVICIOCORTESIA.TOAST'))
                            .position('top right')
                            .hideDelay(3000)
                            );

                    vm.resetForm();
                    vm.listaOperaciones = [];
                    CargarStbs();

                    $scope.hide();
                }, function (dataResponse) {
                    $scope.mensajeError = 'OPERACIONES.SERVICIOCORTESIA.ERROR';
                    $scope.dataLoading = false;
                });
            };
        }

        vm.exportar = function () {
            var link = $('#link')[0];
            console.log(link);

            var data = 'Fecha;Importe;Instalación;Monedero virtual;Modo de pago\n';
            $.each(vm.listaOperaciones, function (index, value) {
                data += (new Date(value.date)).toLocaleString() + ';' +
                        value.amount + ';' +
                        IncidencesConfig.instalacion + ';' +
                        (value.uuidVirtualWallet || '-') + ';' +
                        $filter('translate')($scope.transPayment[value.payment]) +
                        '\n';
            });

            var dataUri = 'data:application/json;charset=utf-8,' + encodeURI(data);
            link.download = 'reporte (' + (new Date()).toLocaleDateString('es-ES') + ').csv';
            link.href = dataUri;
            link.click();
        };

        vm.reimprimirTicket = function (ev, operacion) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('OPERACIONES.REPRINT.TITLE'))
                    .ariaLabel('Reimprimir ticket')
                    .targetEvent(ev)
                    .ok($filter('translate')('OPERACIONES.REPRINT.OK'))
                    .cancel($filter('translate')('OPERACIONES.REPRINT.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                console.log(operacion);

                var cajero = vm.mapCajeros[operacion.extendedPlace];

                if (!cajero)
                    return;

                if (operacion.concept === 'Wallet') {
                    cajeroService.reprintTicket(cajero.config.ip, cajero.config.port, angular.toJson({
                        "type": "walletin",
                        "language": operacion.language,
                        "signDate": (new Date(operacion.date)).toISOString(),
                        "identification": operacion.idAccountant,
                        "payment": operacion.payment,
                        "deposit": operacion.extendedConcept.deposit.current,
                        "balance": operacion.extendedConcept.balance.current
                    })).then(function () {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('OPERACIONES.REPRINT.TOAST'))
                                .position('top right')
                                .hideDelay(3000)
                                );
                    }, function () {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('OPERACIONES.REPRINT.ERROR'))
                                .position('top right')
                                .hideDelay(3000)
                                );
                    });
                } else if (operacion.concept === 'Balance') {
                    cajeroService.reprintTicket(cajero.config.ip, cajero.config.port, angular.toJson({
                        "type": "balance",
                        "identification": operacion.idAccountant,
                        "before": operacion.extendedConcept.before,
                        "increment": operacion.amount,
                        "current": operacion.extendedConcept.current,
                        "payment": operacion.payment,
                        "signDate": (new Date(operacion.date)).toISOString(),
                        "language": operacion.language
                    })).then(function () {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('OPERACIONES.REPRINT.TOAST'))
                                .position('top right')
                                .hideDelay(3000)
                                );
                    }, function () {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('OPERACIONES.REPRINT.ERROR'))
                                .position('top right')
                                .hideDelay(3000)
                                );
                    });
                }
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.estadoComercial', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_estadoComercial', {
            url: '/estado-comercial',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/estado-comercial/estado-comercial.html',
                    controller: 'estadoComercialController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/estado-comercial');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.Quantion.gestionCompras.estadoComercial')
        .controller('estadoComercialController', estadoComercialController);

    /** @ngInject */
    function estadoComercialController(quantionApi, $mdToast, $scope, $rootScope, $filter) {
        var vm = this;
        $rootScope.seccion = 'COMPRAS_ESTADO_COMERCIAL';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.servicios = {};

        var mainTable = document.querySelector('table#main-table');

        pantallaCarga.lsEnable('LS.GENERIC');
        Promise.all([
            quantionApi.getStbs(),
            quantionApi.getGrupos(),
        ]).then(function (values) {
            var stbs = values[0].data;
            var stbGroups = values[1].data;

            var mapById = {};
            stbs.forEach(function (item) {
                var obj = {
                    stb: item,
                    group: stbGroups.find(function (group) { return group.stbs.includes(item.idStb) }),
                    services: {
                        tv: (item.wallet && item.wallet.services && item.wallet.services.length > 0)
                            ? item.wallet.services.reduce(function (result, serv) {
                                if (['tv', 'basic'].includes(serv.acl) && serv.remainingTimeInMinutes > (result.remainingTimeInMinutes || 0)) {
                                    return {
                                        remainingTimeInMinutes: serv.remainingTimeInMinutes,
                                        endDate: serv.endDate,
                                    }
                                }
                                return result;
                            }, {})
                            : {},
                        internet: (item.wallet && item.wallet.services && item.wallet.services.length > 0)
                            ? item.wallet.services.reduce(function (result, serv) {
                                if (['internet'].includes(serv.acl) && serv.remainingTimeInMinutes > (result.remainingTimeInMinutes || 0)) {
                                    return {
                                        remainingTimeInMinutes: serv.remainingTimeInMinutes,
                                        endDate: serv.endDate,
                                    }
                                }
                                return result;
                            }, {})
                            : {},
                        wifi: (item.wallet && item.wallet.services && item.wallet.services.length > 0)
                            ? item.wallet.services.reduce(function (result, serv) {
                                if (['wifi', 'wificaptive'].includes(serv.acl) && serv.remainingTimeInMinutes > (result.remainingTimeInMinutes || 0)) {
                                    return {
                                        remainingTimeInMinutes: serv.remainingTimeInMinutes,
                                        endDate: serv.endDate,
                                    }
                                }
                                return result;
                            }, {})
                            : {},
                    }
                }
                if (obj.services.tv.remainingTimeInMinutes > 0 || obj.services.internet.remainingTimeInMinutes > 0 || obj.services.wifi.remainingTimeInMinutes > 0) mapById[item.idStb] = obj;
            });
            $scope.servicios = Object.values(mapById).sort(function (a, b) { return a.stb.room.localeCompare(b.stb.room) });
            renderTable();

            pantallaCarga.lsDisable();
        }).catch(function () {
            pantallaCarga.lsDisable();
        })

        function renderTable() {
            if (!mainTable) return;
            pantallaCarga.lsEnable('LS.GENERIC');

            var mainTableBody = mainTable.querySelector('tbody');
            mainTableBody.innerHTML = '';

            $scope.servicios.forEach(function (item) {
                var row = '<tr>'
                    + '<td>' + item.stb.room + '</td>'
                    + '<td>' + (item.services.tv.remainingTimeInMinutes > 0 ? ($filter('convertMinutesInHHMMSS')(item.services.tv.remainingTimeInMinutes, true) + '\n(' + $filter('date')(item.services.tv.endDate, 'dd-MM HH:mm') + ')') : '-') + '</td>'
                    + '<td>' + (item.services.internet.remainingTimeInMinutes > 0 ? ($filter('convertMinutesInHHMMSS')(item.services.internet.remainingTimeInMinutes, true) + '\n(' + $filter('date')(item.services.internet.endDate, 'dd-MM HH:mm') + ')') : '-') + '</td>'
                    + '<td>' + (item.services.wifi.remainingTimeInMinutes > 0 ? ($filter('convertMinutesInHHMMSS')(item.services.wifi.remainingTimeInMinutes, true) + '\n(' + $filter('date')(item.services.wifi.endDate, 'dd-MM HH:mm') + ')') : '-') + '</td>'
                    + '<td>' + item.group.place + ' | ' + item.group.nombre + '</td>'
                    + '</tr>';
                mainTableBody.innerHTML += row;
            })
            pantallaCarga.lsDisable();
        }

        $scope.orderProp = 'stb.room';
        $scope.orderReverse = false;
        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                $scope.orderReverse = false;
                console.log('Cambio de campo a ' + order);
            }

            sortBy($scope.servicios, $scope.orderProp, $scope.orderReverse ? 'desc' : 'asc');
            renderTable();
        };

        function sortBy(array, property, direction) {
            // Creamos una copia para no mutar el array original
            return array.sort(function (a, b) {

                // Función auxiliar para obtener el valor anidado (ej: 'user.name')
                function getValue(obj, path) {
                    return path.split('.').reduce(function (acc, curr) {
                        return acc && acc[curr] !== undefined ? acc[curr] : undefined;
                    }, obj);
                }

                var val1 = getValue(a, property);
                var val2 = getValue(b, property);

                // Manejo de valores nulos o indefinidos (los manda al final)
                if (val1 === undefined || val1 === null) return 1;
                if (val2 === undefined || val2 === null) return -1;

                // Si son strings, usamos localeCompare para un ordenamiento alfabético correcto
                if (typeof val1 === 'string' && typeof val2 === 'string') {
                    return direction.toLowerCase() === 'asc'
                        ? val1.localeCompare(val2)
                        : val2.localeCompare(val1);
                }

                // Para números, fechas o booleanos
                if (val1 < val2) {
                    return direction.toLowerCase() === 'asc' ? -1 : 1;
                }
                if (val1 > val2) {
                    return direction.toLowerCase() === 'asc' ? 1 : -1;
                }

                return 0;
            });
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.Quantion.estadisticas.instantanea', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_estadisticas_instantanea', {
            url  : '/estadisticas/instantanea',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/estadisticas/instantanea/instantanea.html',
                    controller : 'EstadisticasInstantaneaController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/estadisticas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.estadisticas.instantanea')
            .controller('EstadisticasInstantaneaController', EstadisticasInstantaneaController);

    /** @ngInject */
    function EstadisticasInstantaneaController($scope, quantionApi, $filter, $rootScope, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ESTADISTICAS_INSTANTANEA';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.fechaBusqueda = new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm'));

        var lastReport;

        $scope.CargarEstadisticas = function (fecha) {
            pantallaCarga.lsEnable('LS.ESTADISTICAS');
            $scope.dataError = null;

            vm.listaEstadisticas = [];//Array donde se van concatenando todas las estadísticas, tanto de todos o de un STB
            vm.estadisticasAgrupadas = [];
            if ($scope.selectedOption === 'Todos') {
                CargarReporteTodos(fecha);
            } else {
                CargarReporteTodos(fecha, vm.selectedStbs);
            }
        };

        function CargarReporteTodos(fecha, selectedStbs) {
            var arrGrupada = {};

            const formattedFecha = $filter('date')(fecha, 'yyyy-MM-dd');

            if (lastReport && lastReport.date === formattedFecha) {
                p(lastReport.content);
            } else {
                quantionApi.getReporte(formattedFecha).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    lastReport = {
                        date: formattedFecha,
                        content: dataResponse
                    };

                    p(dataResponse);
                }, function (dataResponse) {
                    vm.listaEstadisticas = null;
                    $scope.dataError = 'No se ha encontrado el reporte de ese día';
                    pantallaCarga.lsDisable();
                });
            }

            function p(dataResponse) {
                $.each(dataResponse.data, function (index, value) {//Por cada STB
                    $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                        var fechaIni = new Date(value2.fechaIni);
                        var fechaFin = new Date(value2.fechaFin);
                        var inRange = selectedStbs ? selectedStbs.indexOf(value2.macStb) !== -1 : true;

                        if (fecha >= fechaIni && fecha <= fechaFin && inRange) {
                            value2.fullStb = vm.mapStbByMac[angular.lowercase(value2.macStb)];
                            vm.listaEstadisticas.push(value2);//Añadir a la recopilación de estadísticas

                            var a = value2.status + " / " + value2.info + " / " + value2.screen + " / " + value2.shadow;
                            if (!arrGrupada[a])
                                arrGrupada[a] = {
                                    info: value2.info,
                                    screen: value2.screen,
                                    shadow: value2.shadow,
                                    status: value2.status,
                                    stbs: []
                                };
                            arrGrupada[a].stbs.push(value2.fullStb ? value2.fullStb.room : '?');
                        }
                    });

                });

                vm.estadisticasAgrupadas = [];
                $.each(arrGrupada, function (key, value) {
                    vm.estadisticasAgrupadas.push(value);
                });

                setTimeout(function () {
                    pantallaCarga.lsDisable();
                }, 250);
            }
        }

        $scope.orderProp = 'fullStb.room';
        $scope.orderReverse = false;
        $scope.sortBy = function (order) {
            if (order === $scope.orderProp) {
                $scope.orderReverse = !$scope.orderReverse;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        $scope.orderProp2 = 'stbs.length';
        $scope.orderReverse2 = true;
        $scope.sortBy2 = function (order) {
            if (order === $scope.orderProp2) {
                $scope.orderReverse2 = !$scope.orderReverse2;
                console.log('Cambio de orden');
            } else {
                $scope.orderProp2 = order;
                console.log('Cambio de campo a ' + order);
            }
        };

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = $filter('orderBy')(dataResponse.data, 'room');

            vm.mapStbByMac = {};
            vm.mapStbsById = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbByMac[angular.lowercase(value.mac)] = value;
                vm.mapStbsById[value.idStb] = value;
            });

            vm.selectedStbs = [];

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = $filter('orderBy')(elm.stbs.map(function (elm2) {
                        return vm.mapStbsById[elm2];
                    }), 'room');
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        $scope.querySearch = function (query) {
            var results = query ? vm.listaStbs.filter(function (hab) {
                var lowercaseQuery = angular.lowercase(query);
                return (angular.lowercase(hab.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(hab.username).indexOf(lowercaseQuery) !== -1);
            }) : vm.listaStbs;
            return results;
        };

        $scope.openShadow = function (elm) {
            if (!elm.view)
                elm.view = true;
        };

        $scope.closeShadow = function (elm) {
            if (elm.view)
                elm.view = false;
        };

        vm.asignarStbs = function (ev) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/estadisticas/instantanea/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AsignarStbCtrl($scope, $mdDialog, $mdToast) {
            $scope.selectedStbs = vm.selectedStbs;
            $scope.allStbs = vm.listaStbs;
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.initRange = function () {
                $scope.range = true;
                $scope.rangeIni = null;
                $scope.rangeFin = null;
                $scope.groupRange = null;
            };

            $scope.selectRange = function (index, group) {
                if ($scope.rangeIni === null) {
                    $scope.rangeIni = index;
                    $scope.groupRange = group;
                } else if (!$scope.rangeFin) {
                    if ($scope.groupRange === group) {
                        $scope.rangeFin = index;

                        var min = Math.min($scope.rangeIni, $scope.rangeFin);
                        var max = Math.max($scope.rangeIni, $scope.rangeFin);

                        for (var i = min; i <= max; i++) {
                            if ($scope.selectedStbs.indexOf($scope.allStbs[i].mac) === -1) {
                                $scope.selectedStbs.push($scope.allStbs[i].mac);
                            }
                        }
                    }

                    $scope.range = false;
                    $scope.rangeIni = null;
                    $scope.rangeFin = null;
                }
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.mac, $scope.selectedStbs))
                        $scope.selectedStbs.push(value.mac);

                    if (bool === false && $scope.exists(value.mac, $scope.selectedStbs)) {
                        var idx = $scope.selectedStbs.indexOf(value.mac);
                        $scope.selectedStbs.splice(idx, 1);
                    }
                });
            };

            $scope.selectAll = function (value) {
                if (value) {
                    $scope.selectedStbs = $scope.allStbs.map(function (e) {
                        return e.mac;
                    });
                } else {
                    $scope.selectedStbs = [];
                }
                vm.selectedStbs = $scope.selectedStbs;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.Quantion.estadisticas.urls', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_estadisticas_urls', {
            url  : '/estadisticas/urls',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/estadisticas/urls/urls.html',
                    controller : 'EstadisticasUrlsController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/estadisticas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.estadisticas.urls')
            .controller('EstadisticasUrlsController', EstadisticasUrlsController);

    /** @ngInject */
    function EstadisticasUrlsController($scope, quantionApi, $filter, $rootScope, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ESTADISTICAS_URLS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        quantionApi.getListaReportes().then(function (dataResponse) {
            vm.listaReportes = $filter('orderBy')(dataResponse.data.Reports.map(function (e) {
                return e.replace('.json', '');
            }));

            if (vm.listaReportes.length > 0) {
                $scope.reportIni = vm.listaReportes[0];

                $scope.inicioBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                $scope.finBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
            }
        });

        $scope.inicioBusqueda = new Date();
        $scope.finBusqueda = new Date();

        $scope.CargarEstadisticas = function (inicio, fin) {
            pantallaCarga.lsEnable('LS.ESTADISTICAS');

            $scope.dataError = null;
            if (inicio > fin) {
                vm.completeStatsObj = null;
                $scope.dataError = 'La fecha de inicio debe ser anterior a la fecha de fin';
                pantallaCarga.lsDisable();
                return;
            }

            var getDates = function (startDate, endDate) {
                var dates = [],
                        currentDate = startDate,
                        addDays = function (days) {
                            var date = new Date(this.valueOf());
                            date.setDate(date.getDate() + days);
                            return date;
                        };
                while (currentDate <= endDate) {
                    var formatted = $filter('date')(currentDate, 'yyyy-MM-dd');
                    if (vm.listaReportes.indexOf(formatted) !== -1)
                        dates.push(formatted);
                    currentDate = addDays.call(currentDate, 1);
                }
                return dates;
            };

            var listaReportesSeleccionados = getDates(inicio, fin);

            vm.arrayProcesamiento = [];//Array donde se van concatenando todas las estadísticas, tanto de todos o de un STB
            if ($scope.selectedOption === 'Todos') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento);
            } else if ($scope.selectedOption === 'Varios') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, vm.selectedStbs);
            } else {
                CargarReporteUnStb(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, fin);
            }
        };

        // Obtención de dominio
        function UrlDomainFromShadow(shadow) {
            var myRegexp = /^(?:.*https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im;
            var domRegexp = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;
            if (shadow) {
                var formShadow = myRegexp.exec(shadow)[1];
                if (formShadow) {
                    var f = domRegexp.exec(formShadow);
                    return f ? f[0] : null;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }

        /**
         * @param {type} listaReportes Array con los nombres de los ficheros .json
         * @param {type} funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param {type} arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         */
        function CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs) {
            if (listaReportes[0])
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        var inRange = selectedStbs ? selectedStbs.indexOf(value.macStb) !== -1 : true;
                        if (inRange) {
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                        }
                    });

                    listaReportes.shift();//Borra el primer elemento del array
                    if (listaReportes[0]) {//Si quedan reportes por leer...
                        CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs);
                    } else {//Si ya se han leido todos los reportes
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    }
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            else
                pantallaCarga.lsDisable();
        }

        /**
         * @param listaReportes Array con los nombres de los ficheros .json
         * @param funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         * @param fin Fecha del último reporte, y comienzo de la búsqueda individual
         */
        function CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin) {
            if (listaReportes[0]) {//Si quedan reportes por leer...
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        if (angular.lowercase($scope.selectedStb.mac) === angular.lowercase(value.macStb))
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                    });

                    listaReportes.shift();//Borra el primer elemento del array
                    CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin);
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            } else {//Si ya se han leido todos los reportes

                var aux = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                if (fin > aux) {
                    aux.setDate(aux.getDate() + 1);
                    var aux = ($scope.inicioBusqueda > aux ? $scope.inicioBusqueda : aux);

                    aux.setHours(0);
                    aux.setMinutes(0);
                    aux.setSeconds(0);
                    fin.setHours(23);
                    fin.setMinutes(59);
                    fin.setSeconds(59);

                    quantionApi.getEstadisticasDeStb($scope.selectedStb ? $scope.selectedStb.mac.toLowerCase() : $scope.searchText, aux, fin).then(function (dataResponse) {
                        $.each(dataResponse.data.Windows, function (index2, value2) {//Por cada estadística de este STB
                            arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                        });
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    });
                } else {
                    vm.completeStatsObj = funcionProcesado(arrayCompleto);
                    pantallaCarga.lsDisable();
                }
            }
        }

        function ProcesarEstadisticas(arrayEstadisticas) {
            var obj = {shadows: {}, time: 0};

            $.each(arrayEstadisticas, function (idx, elm) {
                var formShadow = UrlDomainFromShadow(elm.shadow);
                if (!formShadow)
                    return;
                if (!obj.shadows[formShadow])
                    obj.shadows[formShadow] = 0;

                elm.fechaFin = new Date(elm.fechaFin);
                elm.fechaIni = new Date(elm.fechaIni);
                var diferencia = (elm.fechaFin - elm.fechaIni) / 1000;
                obj.shadows[formShadow] += diferencia;
                obj.time += diferencia;
            });

            var mappedShadows = $.map(obj.shadows, function (value, key) {
                return{
                    shadow: key,
                    time: value
                };
            });

            obj.shadows = mappedShadows;

            return obj;
        }

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;
            vm.selectedStbs = [];

            vm.mapStbByMac = {};
            vm.mapStbsById = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbByMac[angular.lowercase(value.mac)] = value;
                vm.mapStbsById[value.idStb] = value;
            });

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = $filter('orderBy')(elm.stbs.map(function (elm2) {
                        return vm.mapStbsById[elm2];
                    }), 'room');
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        $scope.querySearch = function (query) {
            var results = query ? vm.listaStbs.filter(function (hab) {
                var lowercaseQuery = angular.lowercase(query);
                return (angular.lowercase(hab.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(hab.username).indexOf(lowercaseQuery) !== -1);
            }) : vm.listaStbs;
            return results;
        };
        
        vm.asignarStbs = function (ev) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/estadisticas/instantanea/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AsignarStbCtrl($scope, $mdDialog, $mdToast) {
            $scope.selectedStbs = vm.selectedStbs;
            $scope.allStbs = vm.listaStbs;
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.initRange = function () {
                $scope.range = true;
                $scope.rangeIni = null;
                $scope.rangeFin = null;
                $scope.groupRange = null;
            };

            $scope.selectRange = function (index, group) {
                if ($scope.rangeIni === null) {
                    $scope.rangeIni = index;
                    $scope.groupRange = group;
                } else if (!$scope.rangeFin) {
                    if ($scope.groupRange === group) {
                        $scope.rangeFin = index;

                        var min = Math.min($scope.rangeIni, $scope.rangeFin);
                        var max = Math.max($scope.rangeIni, $scope.rangeFin);

                        for (var i = min; i <= max; i++) {
                            if ($scope.selectedStbs.indexOf($scope.allStbs[i].mac) === -1) {
                                $scope.selectedStbs.push($scope.allStbs[i].mac);
                            }
                        }
                    }

                    $scope.range = false;
                    $scope.rangeIni = null;
                    $scope.rangeFin = null;
                }
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.mac, $scope.selectedStbs))
                        $scope.selectedStbs.push(value.mac);

                    if (bool === false && $scope.exists(value.mac, $scope.selectedStbs)) {
                        var idx = $scope.selectedStbs.indexOf(value.mac);
                        $scope.selectedStbs.splice(idx, 1);
                    }
                });
            };

            $scope.selectAll = function (value) {
                if (value) {
                    $scope.selectedStbs = $scope.allStbs.map(function (e) {
                        return e.mac;
                    });
                } else {
                    $scope.selectedStbs = [];
                }
                vm.selectedStbs = $scope.selectedStbs;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.Quantion.estadisticas.tv', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_estadisticas_tv', {
            url  : '/estadisticas/tv',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/estadisticas/tv/tv.html',
                    controller : 'EstadisticasTvController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/estadisticas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.estadisticas.tv')
            .controller('EstadisticasTvController', EstadisticasTvController);

    /** @ngInject */
    function EstadisticasTvController($scope, quantionApi, $filter, $rootScope, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ESTADISTICAS_TV';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        quantionApi.getListaReportes().then(function (dataResponse) {
            vm.listaReportes = $filter('orderBy')(dataResponse.data.Reports.map(function (e) {
                return e.replace('.json', '');
            }));

            if (vm.listaReportes.length > 0) {
                $scope.reportIni = vm.listaReportes[0];

                $scope.inicioBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                $scope.finBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
            }
        });

        $scope.inicioBusqueda = new Date();
        $scope.finBusqueda = new Date();

        $scope.CargarEstadisticas = function (inicio, fin) {
            pantallaCarga.lsEnable('LS.ESTADISTICAS');

            $scope.dataError = null;
            if (inicio > fin) {
                vm.completeStatsObj = null;
                $scope.dataError = 'La fecha de inicio debe ser anterior a la fecha de fin';
                pantallaCarga.lsDisable();
                return;
            }

            var getDates = function (startDate, endDate) {
                var dates = [],
                        currentDate = startDate,
                        addDays = function (days) {
                            var date = new Date(this.valueOf());
                            date.setDate(date.getDate() + days);
                            return date;
                        };
                while (currentDate <= endDate) {
                    var formatted = $filter('date')(currentDate, 'yyyy-MM-dd');
                    if (vm.listaReportes.indexOf(formatted) !== -1)
                        dates.push(formatted);
                    currentDate = addDays.call(currentDate, 1);
                }
                return dates;
            };

            var listaReportesSeleccionados = getDates(inicio, fin);

            vm.arrayProcesamiento = [];//Array donde se van concatenando todas las estadísticas, tanto de todos o de un STB
            $scope.arrr = [];
            if ($scope.selectedOption === 'Todos') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento);
            } else if ($scope.selectedOption === 'Varios') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, vm.selectedStbs);
            } else {
                CargarReporteUnStb(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, fin);
            }
        };

        /**
         * @param {type} listaReportes Array con los nombres de los ficheros .json
         * @param {type} funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param {type} arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         */
        function CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs) {
            if (listaReportes[0])
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    var rewer = {
                        key: listaReportes[0],
                        value: []
                    };
                    
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        var inRange = selectedStbs ? selectedStbs.indexOf(value.macStb) !== -1 : true;
                        if (inRange) {
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                            rewer.value.push({
                                key: value.macStb,
                                value: value.AllWindows.Windows
                            });
                        }
                    });

                    $scope.arrr.push(rewer);

                    listaReportes.shift();//Borra el primer elemento del array
                    if (listaReportes[0]) {//Si quedan reportes por leer...
                        CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs);
                    } else {//Si ya se han leido todos los reportes
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    }
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            else
                pantallaCarga.lsDisable();
        }

        /**
         * @param listaReportes Array con los nombres de los ficheros .json
         * @param funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         * @param fin Fecha del último reporte, y comienzo de la búsqueda individual
         */
        function CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin) {
            if (listaReportes[0]) {//Si quedan reportes por leer...
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        if (angular.lowercase($scope.selectedStb.mac) === angular.lowercase(value.macStb))
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                    });

                    listaReportes.shift();//Borra el primer elemento del array
                    CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin);
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            } else {//Si ya se han leido todos los reportes

                var aux = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                if (fin > aux) {
                    aux.setDate(aux.getDate() + 1);
                    var aux = ($scope.inicioBusqueda > aux ? $scope.inicioBusqueda : aux);

                    aux.setHours(0);
                    aux.setMinutes(0);
                    aux.setSeconds(0);
                    fin.setHours(23);
                    fin.setMinutes(59);
                    fin.setSeconds(59);

                    quantionApi.getEstadisticasDeStb($scope.selectedStb ? $scope.selectedStb.mac.toLowerCase() : $scope.searchText, aux, fin).then(function (dataResponse) {
                        $.each(dataResponse.data.Windows, function (index2, value2) {//Por cada estadística de este STB
                            arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                        });
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    });
                } else {
                    vm.completeStatsObj = funcionProcesado(arrayCompleto);
                    pantallaCarga.lsDisable();
                }
            }
        }

        function ProcesarEstadisticas(arrayEstadisticas) {
            var obj = {};

            $.each(arrayEstadisticas, function (idx, elm) {
                var nombre = elm.screen;

                if (!obj[nombre])
                    obj[nombre] = {'info': {}, 'time': 0};
                if (!obj[nombre].info[elm.info])
                    obj[nombre].info[elm.info] = {'shadow': {}, 'time': 0};
                if (!obj[nombre].info[elm.info].shadow[elm.shadow])
                    obj[nombre].info[elm.info].shadow[elm.shadow] = 0;

                elm.fechaFin = new Date(elm.fechaFin);
                elm.fechaIni = new Date(elm.fechaIni);
                var diferencia = (elm.fechaFin - elm.fechaIni) / 1000;
                obj[nombre].info[elm.info].shadow[elm.shadow] += diferencia;
                obj[nombre].info[elm.info].time += diferencia;
                obj[nombre].time += diferencia;
            });

            $.each(obj, function (key, value) {
                value.inArray = $.map(value.info, function (value, key) {
                    return{
                        channel: key,
                        shadow: $.map(value.shadow, function (value, key) {
                            return{
                                key: key,
                                value: value
                            };
                        }),
                        time: value.time
                    };
                });
            });

            $.each($scope.arrr, function (idx, r) {

                $.each(r.value, function (idx, rr) {
                    var asdf = {};

                    $.each(rr.value, function (idx, elm) {
                        var nombre = elm.screen;

                        if (!asdf[nombre])
                            asdf[nombre] = {'info': {}, 'time': 0};
                        if (!asdf[nombre].info[elm.info])
                            asdf[nombre].info[elm.info] = {'shadow': {}, 'time': 0};
                        if (!asdf[nombre].info[elm.info].shadow[elm.shadow])
                            asdf[nombre].info[elm.info].shadow[elm.shadow] = 0;

                        elm.fechaFin = new Date(elm.fechaFin);
                        elm.fechaIni = new Date(elm.fechaIni);
                        var diferencia = (elm.fechaFin - elm.fechaIni) / 1000;
                        asdf[nombre].info[elm.info].shadow[elm.shadow] += diferencia;
                        asdf[nombre].info[elm.info].time += diferencia;
                        asdf[nombre].time += diferencia;
                    });
                    rr.a = asdf;
                })
            });

            if ($scope.selectedOption === 'Individual') {
                $scope.singleStbTimeline = arrayEstadisticas;
            }

            return obj;
        }

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;
            vm.selectedStbs = [];

            vm.mapStbByMac = {};
            vm.mapStbsById = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbByMac[angular.lowercase(value.mac)] = value;
                vm.mapStbsById[value.idStb] = value;
            });

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = $filter('orderBy')(elm.stbs.map(function (elm2) {
                        return vm.mapStbsById[elm2];
                    }), 'room');
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        $scope.querySearch = function (query) {
            var results = query ? vm.listaStbs.filter(function (hab) {
                var lowercaseQuery = angular.lowercase(query);
                return (angular.lowercase(hab.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(hab.username).indexOf(lowercaseQuery) !== -1);
            }) : vm.listaStbs;
            return results;
        };

        $scope.openShadow = function (elm) {
            if (!elm.view)
                elm.view = true;
        };

        $scope.closeShadow = function (elm) {
            if (elm.view)
                elm.view = false;
        };

        vm.asignarStbs = function (ev) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/estadisticas/instantanea/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AsignarStbCtrl($scope, $mdDialog, $mdToast) {
            $scope.selectedStbs = vm.selectedStbs;
            $scope.allStbs = vm.listaStbs;
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.initRange = function () {
                $scope.range = true;
                $scope.rangeIni = null;
                $scope.rangeFin = null;
                $scope.groupRange = null;
            };

            $scope.selectRange = function (index, group) {
                if ($scope.rangeIni === null) {
                    $scope.rangeIni = index;
                    $scope.groupRange = group;
                } else if (!$scope.rangeFin) {
                    if ($scope.groupRange === group) {
                        $scope.rangeFin = index;

                        var min = Math.min($scope.rangeIni, $scope.rangeFin);
                        var max = Math.max($scope.rangeIni, $scope.rangeFin);

                        for (var i = min; i <= max; i++) {
                            if ($scope.selectedStbs.indexOf($scope.allStbs[i].mac) === -1) {
                                $scope.selectedStbs.push($scope.allStbs[i].mac);
                            }
                        }
                    }

                    $scope.range = false;
                    $scope.rangeIni = null;
                    $scope.rangeFin = null;
                }
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.mac, $scope.selectedStbs))
                        $scope.selectedStbs.push(value.mac);

                    if (bool === false && $scope.exists(value.mac, $scope.selectedStbs)) {
                        var idx = $scope.selectedStbs.indexOf(value.mac);
                        $scope.selectedStbs.splice(idx, 1);
                    }
                });
            };

            $scope.selectAll = function (value) {
                if (value) {
                    $scope.selectedStbs = $scope.allStbs.map(function (e) {
                        return e.mac;
                    });
                } else {
                    $scope.selectedStbs = [];
                }
                vm.selectedStbs = $scope.selectedStbs;
            };
        }

        $scope.downloadCsv = function (property) {
            var rooms = [];
            var text = '';

            $scope.arrr.forEach(function (date) {
                rooms = rooms.concat(date.value.map(function (e) {
                    var stb = vm.mapStbByMac[e.key.toLowerCase()];

                    return stb ? stb.room : null;
                }));
            });

            var roomsUnique = rooms.filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });
            roomsUnique.sort();

            text = "," + roomsUnique.join(',') + '\n';

            $scope.arrr.forEach(function (date) {
                text += date.key + ',';
                roomsUnique.forEach(function (r) {
                    var b = date.value.find(function (o) {
                        var a1 = vm.mapStbByMac[o.key.toLowerCase()];
                        return a1 && a1.room === r;
                    });

                    if (b && b.a && b.a[property] && b.a[property].time) {
                        text += (Math.ceil(b.a[property].time/3600) + ',');
                    } else {
                        text += '0,';
                    }
                });
                text += '\n';
            });

            var a = document.createElement('a');
            var csvData = new Blob([text], {type: 'text/csv'});
            var csvUrl = URL.createObjectURL(csvData);
            a.href = csvUrl;
            a.download = 'report.csv';
            a.click();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.Quantion.estadisticas.banners', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_estadisticas_banners', {
            url  : '/estadisticas/banners',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/estadisticas/banners/banners.html',
                    controller : 'EstadisticasBannersController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/estadisticas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.estadisticas.banners')
            .controller('EstadisticasBannersController', EstadisticasBannersController);

    /** @ngInject */
    function EstadisticasBannersController($scope, quantionApi, $filter, $rootScope, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ESTADISTICAS_BANNERS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        vm.stats = {};

        quantionApi.getBanners().then(function (dataResponse) {
            $.each(dataResponse.data, function (ind, elm) {
                var formattedDataUrl = tryParse(elm.data).url;

                if (formattedDataUrl)
                    vm.stats[formattedDataUrl] = {
                        banner: elm,
                        visits: 0,
                        time: 0
                    };
            });
        });

        quantionApi.getListaReportes().then(function (dataResponse) {
            vm.listaReportes = $filter('orderBy')(dataResponse.data.Reports.map(function (e) {
                return e.replace('.json', '');
            }));

            if (vm.listaReportes.length > 0) {
                $scope.reportIni = vm.listaReportes[0];

                $scope.inicioBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                $scope.finBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
            }
        });

        $scope.inicioBusqueda = new Date();
        $scope.finBusqueda = new Date();

        $scope.CargarEstadisticas = function (inicio, fin) {
            pantallaCarga.lsEnable('LS.ESTADISTICAS');

            $scope.dataError = null;
            if (inicio > fin) {
                vm.completeStatsObj = null;
                $scope.dataError = 'La fecha de inicio debe ser anterior a la fecha de fin';
                pantallaCarga.lsDisable();
                return;
            }

            var getDates = function (startDate, endDate) {
                var dates = [],
                        currentDate = startDate,
                        addDays = function (days) {
                            var date = new Date(this.valueOf());
                            date.setDate(date.getDate() + days);
                            return date;
                        };
                while (currentDate <= endDate) {
                    var formatted = $filter('date')(currentDate, 'yyyy-MM-dd');
                    if (vm.listaReportes.indexOf(formatted) !== -1)
                        dates.push(formatted);
                    currentDate = addDays.call(currentDate, 1);
                }
                return dates;
            };

            var listaReportesSeleccionados = getDates(inicio, fin);

            vm.arrayProcesamiento = [];//Array donde se van concatenando todas las estadísticas, tanto de todos o de un STB
            if ($scope.selectedOption === 'Todos') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento);
            } else if ($scope.selectedOption === 'Varios') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, vm.selectedStbs);
            } else {
                CargarReporteUnStb(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, fin);
            }
        };

        // Obtención de dominio
        function UrlDomainFromShadow(shadow) {
            var myRegexp = /^(?:.*https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im;
            var domRegexp = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;
            if (shadow) {
                var formShadow = myRegexp.exec(shadow);
                if (formShadow && formShadow[1]) {
                    var f = domRegexp.exec(formShadow[1]);
                    return f ? f[0] : null;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }

        /**
         * @param {type} listaReportes Array con los nombres de los ficheros .json
         * @param {type} funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param {type} arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         */
        function CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs) {
            if (listaReportes[0])
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        var inRange = selectedStbs ? selectedStbs.indexOf(value.macStb) !== -1 : true;
                        if (inRange) {
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                        }
                    });

                    listaReportes.shift();//Borra el primer elemento del array
                    if (listaReportes[0]) {//Si quedan reportes por leer...
                        CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs);
                    } else {//Si ya se han leido todos los reportes
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    }
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            else
                pantallaCarga.lsDisable();
        }

        /**
         * @param listaReportes Array con los nombres de los ficheros .json
         * @param funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         * @param fin Fecha del último reporte, y comienzo de la búsqueda individual
         */
        function CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin) {
            if (listaReportes[0]) {//Si quedan reportes por leer...
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        if (angular.lowercase($scope.selectedStb.mac) === angular.lowercase(value.macStb))
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                    });

                    listaReportes.shift();//Borra el primer elemento del array
                    CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin);
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            } else {//Si ya se han leido todos los reportes

                var aux = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                if (fin > aux) {
                    aux.setDate(aux.getDate() + 1);
                    var aux = ($scope.inicioBusqueda > aux ? $scope.inicioBusqueda : aux);

                    aux.setHours(0);
                    aux.setMinutes(0);
                    aux.setSeconds(0);
                    fin.setHours(23);
                    fin.setMinutes(59);
                    fin.setSeconds(59);

                    quantionApi.getEstadisticasDeStb($scope.selectedStb ? $scope.selectedStb.mac.toLowerCase() : $scope.searchText, aux, fin).then(function (dataResponse) {
                        $.each(dataResponse.data.Windows, function (index2, value2) {//Por cada estadística de este STB
                            arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                        });
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    });
                } else {
                    vm.completeStatsObj = funcionProcesado(arrayCompleto);
                    pantallaCarga.lsDisable();
                }
            }
        }

        function ProcesarEstadisticas(arrayEstadisticas) {
            var obj = {
                banners: angular.copy(vm.stats),
                time: 0,
                visits: 0
            };

            $.each(arrayEstadisticas, function (idx, elm) {
                $.each(obj.banners, function (key, value) {
                    if (elm.shadow.indexOf(key) !== -1) {
                        value.visits++;

                        elm.fechaFin = new Date(elm.fechaFin);
                        elm.fechaIni = new Date(elm.fechaIni);
                        var diferencia = (elm.fechaFin - elm.fechaIni) / 1000;
                        value.time += diferencia;
                        obj.time += diferencia;
                        obj.visits++;
                    }
                });
            });

            obj.banners = $.map(obj.banners, function (value, key) {
                return{
                    key: key,
                    value: value
                };
            });

            return obj;
        }

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;
            vm.selectedStbs = [];

            vm.mapStbByMac = {};
            vm.mapStbsById = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbByMac[angular.lowercase(value.mac)] = value;
                vm.mapStbsById[value.idStb] = value;
            });

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = $filter('orderBy')(elm.stbs.map(function (elm2) {
                        return vm.mapStbsById[elm2];
                    }), 'room');
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        $scope.querySearch = function (query) {
            var results = query ? vm.listaStbs.filter(function (hab) {
                var lowercaseQuery = angular.lowercase(query);
                return (angular.lowercase(hab.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(hab.username).indexOf(lowercaseQuery) !== -1);
            }) : vm.listaStbs;
            return results;
        };

        function tryParse(str) {
            var t;

            try {
                t = JSON.parse(str);
            } catch (e) {
                return {};
            }
            return t;
        }
        
        vm.asignarStbs = function (ev) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/estadisticas/instantanea/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AsignarStbCtrl($scope, $mdDialog, $mdToast) {
            $scope.selectedStbs = vm.selectedStbs;
            $scope.allStbs = vm.listaStbs;
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.initRange = function () {
                $scope.range = true;
                $scope.rangeIni = null;
                $scope.rangeFin = null;
                $scope.groupRange = null;
            };

            $scope.selectRange = function (index, group) {
                if ($scope.rangeIni === null) {
                    $scope.rangeIni = index;
                    $scope.groupRange = group;
                } else if (!$scope.rangeFin) {
                    if ($scope.groupRange === group) {
                        $scope.rangeFin = index;

                        var min = Math.min($scope.rangeIni, $scope.rangeFin);
                        var max = Math.max($scope.rangeIni, $scope.rangeFin);

                        for (var i = min; i <= max; i++) {
                            if ($scope.selectedStbs.indexOf($scope.allStbs[i].mac) === -1) {
                                $scope.selectedStbs.push($scope.allStbs[i].mac);
                            }
                        }
                    }

                    $scope.range = false;
                    $scope.rangeIni = null;
                    $scope.rangeFin = null;
                }
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.mac, $scope.selectedStbs))
                        $scope.selectedStbs.push(value.mac);

                    if (bool === false && $scope.exists(value.mac, $scope.selectedStbs)) {
                        var idx = $scope.selectedStbs.indexOf(value.mac);
                        $scope.selectedStbs.splice(idx, 1);
                    }
                });
            };

            $scope.selectAll = function (value) {
                if (value) {
                    $scope.selectedStbs = $scope.allStbs.map(function (e) {
                        return e.mac;
                    });
                } else {
                    $scope.selectedStbs = [];
                }
                vm.selectedStbs = $scope.selectedStbs;
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.avisos.listado', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {        
        $stateProvider.state('app.Quantion_avisos_listado', {
            url: '/avisos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/avisos/listado/listado.html',
                    controller: 'listadoAvisosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/avisos/listado');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.avisos.listado')
            .controller('listadoAvisosController', listadoAvisosController);

    /** @ngInject */
    function listadoAvisosController(quantionApi, $mdDialog, $state, $scope, $filter, $translate, $rootScope, JSONconfig, FilePaths, $mdToast)
    {
        'use strict';
        var vm = this;
        $rootScope.seccion = 'AVISOS_LISTADO';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();
        $scope.JSONconfig = JSONconfig;
        $scope.FilePaths = FilePaths;

        $scope.badgeValues = {};

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        CargarTodo();
        function CargarTodo() {
            CargarEventsProgrammed();
            CargarEvents();
            CargarTemplates();
        }

        function CargarEventsProgrammed() {
//            pantallaCarga.lsEnable('LS.LISTAAVISOS');
            $scope.badgeValues.numProgEnviados = 0;
            $scope.badgeValues.numProgPendientes = 0;

            $scope.badgeValues.numPubliEnviados = 0;
            $scope.badgeValues.numPubliPendientes = 0;

            quantionApi.getTasks('eventProgrammed', 'notification').then(function (dataResponse) {
                vm.eventosProgramados = {
                    'finalizados': [],
                    'encurso': [],
                    'pendientes': []
                };

                vm.eventosPubli = {
                    'finalizados': [],
                    'encurso': [],
                    'pendientes': []
                };

                var now = new Date();
                $.each(dataResponse.data, function (index, value) {
                    try {
                        value.header = JSON.parse(value.header);
                    } catch (e) {
                        console.error(e);
                    }

                    if ((value.arguments && !value.arguments.publi) || value.services.length < 1) {
                        if (value.fFin > now && value.fIni < now) {
                            vm.eventosProgramados.encurso.push(value);
                            $scope.badgeValues.numProgEnviados++;
                        } else if (value.fFin < now) {
                            vm.eventosProgramados.finalizados.push(value);
                            $scope.badgeValues.numProgEnviados++;
                        } else if (value.fIni > now) {
                            vm.eventosProgramados.pendientes.push(value);
                            $scope.badgeValues.numProgPendientes++;
                        }
                    } else {
                        if (value.fFin > now && value.fIni < now) {
                            vm.eventosPubli.encurso.push(value);
                            $scope.badgeValues.numPubliEnviados++;
                        } else if (value.fFin < now) {
                            vm.eventosPubli.finalizados.push(value);
                            $scope.badgeValues.numPubliEnviados++;
                        } else if (value.fIni > now) {
                            vm.eventosPubli.pendientes.push(value);
                            $scope.badgeValues.numPubliPendientes++;
                        }
                    }
                });

                if (vm.eventosProgramados.length === 0)
                    pantallaCarga.lsDisable();
            });
        }

        function CargarEvents() {
            quantionApi.getTasks('event', 'notification').then(function (dataResponse) {
                vm.eventosInmediatos = [];
                vm.eventosPubliInmediatos = [];

                $.each(dataResponse.data, function (index, value) {
                    try {
                        value.header = JSON.parse(value.header);
                    } catch (e) {
                        console.error(e);
                    }

                    if ((value.arguments && !value.arguments.publi) || value.services.length < 1) {
                        vm.eventosInmediatos.push(value);
                    } else {
                        vm.eventosPubliInmediatos.push(value);
                    }
                });

                if (dataResponse.data.length === 0)
                    pantallaCarga.lsDisable();
            });
        }

        function CargarTemplates() {
            quantionApi.getTasks('templateEvent', 'notification').then(function (dataResponse) {
                vm.plantillas = dataResponse.data;

                $.each(vm.plantillas, function (index, value) {
                    try {
                        value.header = JSON.parse(value.header);
                    } catch (e) {
                        console.error(e);
                    }
                });

                if (vm.plantillas.length === 0)
                    pantallaCarga.lsDisable();
            });
        }

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.listaStbs = dataResponse.data;

            vm.mapStbs = {};
            $.each(vm.listaStbs, function (index, value) {
                vm.mapStbs[value.idStb] = value;
            });

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = dataResponse.data.map(function (elm) {
                    elm.cStbs = elm.stbs.map(function (elm2) {
                        return vm.mapStbs[elm2];
                    });
                    return elm;
                });
                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });
            });
        });

        quantionApi.getServicios(true).then(function (dataResponse) {
            vm.listaServicios = dataResponse.data;

            vm.mapServicios = {};
            $.each(vm.listaServicios, function (index, value) {
                vm.mapServicios[value.idService] = value;
            });
        });

        quantionApi.getNotificacionLogos().then(function (dataResponse) {
            vm.listaLogos = dataResponse.data.files;
        });

        quantionApi.getPaquetesActivos().then(function (dataResponse) {
            vm.listaPaquetes = dataResponse.data;
        });

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.listaIdiomas = dataResponse.data;
        });

        $scope.typeSelected = 'programmed';
        $scope.selectType = function (type) {
            $scope.typeSelected = type;
            $scope.selectedTasks = [];
        };

        vm.deleteEvent = function (ev, id, isProgrammed, isTemplate) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('LISTADOAVISOS.MODALELIMINAR.ELIMINAR'))
                    .targetEvent(ev)
                    .ok($filter('translate')('LISTADOAVISOS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('LISTADOAVISOS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteTask(id).then(function (dataResponse) {
                    if (isProgrammed)
                        CargarEventsProgrammed();
                    else if (isTemplate)
                        CargarTemplates();
                    else
                        CargarEvents();

                    pantallaCarga.lsDisable();
                }, function (dataResponse) {
                    console.error(dataResponse);
                    pantallaCarga.lsDisable();
                });
            });
        };

        //*********** Borrar seleccionados *********************
        $scope.selectedTasks = [];

        $scope.toggleSelect = function (idTask, $event) {
            $event.stopPropagation();

            var idx = $scope.selectedTasks.indexOf(idTask);
            if (idx > -1)
                $scope.selectedTasks.splice(idx, 1);
            else
                $scope.selectedTasks.push(idTask);
        };

        $scope.existsSelect = function (idTask) {
            return $scope.selectedTasks.indexOf(idTask) > -1;
        };

        $scope.selectAll = function (list) {
            $.each(list, function (index, value) {
                if ($scope.selectedTasks.indexOf(value.idTask) === -1) {
                    $scope.selectedTasks.push(value.idTask);
                }
            });
        };

        $scope.unselectAll = function (list) {
            $.each(list, function (index, value) {
                var idx = $scope.selectedTasks.indexOf(value.idTask);
                if (idx > -1)
                    $scope.selectedTasks.splice(idx, 1);
            });
        };

        $scope.deleteSelected = function () {
            if ($scope.selectedTasks.length < 1)
                return;

            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('LISTADOAVISOS.MODALELIMINAR.ELIMINARSELECCIONADOS'))
                    .ok($filter('translate')('LISTADOAVISOS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('LISTADOAVISOS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                deleteTaskRecursive($scope.selectedTasks);
            });
        };

        function deleteTaskRecursive(list) {
            var id = list.shift();

            quantionApi.deleteTask(id).then(function (dataResponse) {
                console.log("Eliminado aviso " + id);

                if (list[0])
                    deleteTaskRecursive(list);
                else {
                    pantallaCarga.lsDisable();
                    CargarTodo();
                }
            }, function (dataResponse) {
                console.error("Error al eliminar aviso " + id);

                if (list[0])
                    deleteTaskRecursive(list);
                else {
                    pantallaCarga.lsDisable();
                    CargarTodo();
                }
            });
        }

        //******************* Detalles **********************
        $scope.details = function (obj) {
            $mdDialog.show({
                controller: DetailsCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/details.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {event: obj}
            });
        };

        function DetailsCtrl($scope, $mdDialog, event, $filter) {
            $scope.event = angular.copy(event);
            $scope.allStbsLength = vm.listaStbs.length;

            $scope.event.cstbs = $filter('orderBy')($scope.event.stbs.map(function (e) {
                return vm.mapStbs[e];
            }), 'room');

            if ($scope.event.services)
                $scope.event.cservices = $filter('orderBy')($scope.event.services.map(function (e) {
                    return vm.mapServicios[e];
                }), 'name|formatNameDesc');

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //***************** Nuevo aviso inmediato *******************
        $scope.addEvent = function () {
            $mdDialog.show({
                controller: NewEventCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/event.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewEventCtrl($scope, $mdDialog, $filter) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;
            $scope.listaIdiomas = angular.copy(vm.listaIdiomas);

            $scope.event = {
                metodo: "POST",
                header: {
                    "title": "",
                    "body": "",
                    "time": 10,
                    "icon": ""
                },
                arguments: {},
                command: "notification",
                type: 'event',
                stbs: [],
                roomsSmartphone: [],
                fIni: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                fFin: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                rangeInit: new Date($filter('date')(new Date(), 'yyyy-MM-dd 10:00')),
                rangeEnd: new Date($filter('date')(new Date(), 'yyyy-MM-dd 22:00'))
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                        $scope.event.stbs.push(value.idStb);

                    if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                        var idx = $scope.event.stbs.indexOf(value.idStb);
                        $scope.event.stbs.splice(idx, 1);
                    }
                });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarStorage = function () {
                if (!localStorage.marcados)
                    return;

                var obj = angular.fromJson(localStorage.marcados);

                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (obj[value.idStb] === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (obj[value.idStb] === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarPorIdioma = function (lang) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (value.lang === lang && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);
                    });
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;

                var copy = angular.copy($scope.event);

                if (copy.arguments.type === 'simple') {
                    copy.header.body = "";
                    copy.header.icon = "";
                }

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.time;
                copy.title = copy.header.title;
                copy.description = copy.header.body;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    event.header.icon = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }
        }

        //***************** Reenviar aviso inmediato *******************
        vm.reenviar = function (event) {
            if (event.arguments.qt) {
                $mdDialog.show({
                    controller: ReenvioQTCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {
                        event: event
                    }
                });

            } else {
                $mdDialog.show({
                    controller: ReenvioCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/event.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {
                        event: event
                    }
                });
            }
        };

        function ReenvioCtrl($scope, $mdDialog, $filter, event) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;
            $scope.listaIdiomas = angular.copy(vm.listaIdiomas);

            $scope.event = angular.copy(event);
            $scope.event.fIni = new Date($scope.event.fIni);
            $scope.event.fFin = new Date($scope.event.fFin);

            if ($scope.event.type === 'templateEvent')
                $scope.event.type = null;

            if ($scope.event.rangeInit)
                $scope.event.rangeInit = new Date('01/01/1970 ' + $scope.event.rangeInit);

            if ($scope.event.rangeEnd)
                $scope.event.rangeEnd = new Date('01/01/1970 ' + $scope.event.rangeEnd);

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                        $scope.event.stbs.push(value.idStb);

                    if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                        var idx = $scope.event.stbs.indexOf(value.idStb);
                        $scope.event.stbs.splice(idx, 1);
                    }
                });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarStorage = function () {
                if (!localStorage.marcados)
                    return;

                var obj = angular.fromJson(localStorage.marcados);

                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (obj[value.idStb] === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (obj[value.idStb] === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarPorIdioma = function (lang) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (value.lang === lang && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);
                    });
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.arguments.type === 'simple') {
                    copy.header.body = "";
                    copy.header.icon = "";
                }

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.time;
                copy.title = copy.header.title;
                copy.description = copy.header.body;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                delete copy.idTask;

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    event.header.icon = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }
        }

        //***************** Enviar aviso inmediato (desde portapapeles) *******************
        $scope.addEventFromClipboard = function () {

            navigator.clipboard.readText().then(function (event) {
                try {
                    event = JSON.parse(event);
                    event.stbs = vm.listaStbs.map(function (s) {
                        return s.idStb;
                    });

                    if (event.arguments.qt) {
                        $mdDialog.show({
                            controller: ReenvioQTCtrl,
                            templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event.tmpl.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                event: event
                            }
                        });
                    } else {
                        $mdDialog.show({
                            controller: ReenvioCtrl,
                            templateUrl: 'app/main/Quantion/avisos/listado/templates/event.tmpl.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                event: event
                            }
                        });
                    }
                } catch (ex) {
                    console.error(ex);
                    $mdToast.show($mdToast.simple().textContent('Error al obtener el contenido del portapapeles').position('top right').hideDelay(4000));
                }
            });
        };

        //***************** Nuevo aviso publi *******************
        $scope.addEventPubli = function () {
            $mdDialog.show({
                controller: NewEventPubliCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/event-publi.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewEventPubliCtrl($scope, $mdDialog, $filter) {
            $scope.listaPaquetes = vm.listaPaquetes;
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            $scope.event = {
                metodo: "POST",
                header: {
                    "title": "",
                    "body": "",
                    "time": 10,
                    "icon": ""
                },
                arguments: {
                    "publi": true
                },
                command: "notification",
                type: 'eventProgrammed',
                services: [],
                stbs: vm.listaStbs.map(function (e) {
                    return e.idStb;
                }),
                fIni: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                fFin: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                rangeInit: new Date($filter('date')(new Date(), 'yyyy-MM-dd 10:00')),
                rangeEnd: new Date($filter('date')(new Date(), 'yyyy-MM-dd 22:00'))
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (pkg, bool) {
                $.each(pkg.ordinaryServices, function (index, value) {
                    if (bool === true && !$scope.exists(value.idService, $scope.event.services))
                        $scope.event.services.push(value.idService);

                    if (bool === false && $scope.exists(value.idService, $scope.event.services)) {
                        var idx = $scope.event.services.indexOf(value.idService);
                        $scope.event.services.splice(idx, 1);
                    }
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.arguments.type === 'simple') {
                    copy.header.body = "";
                    copy.header.icon = "";
                }

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.time;
                copy.title = copy.header.title;
                copy.description = copy.header.body;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    event.header.icon = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }
        }

        //***************** Reenviar aviso publi *******************
        vm.reenvioPubli = function (event) {
            if (event.arguments.qt) {
                $mdDialog.show({
                    controller: ReenvioPubliQTCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event-publi.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {
                        event: event
                    }
                });
            } else {
                $mdDialog.show({
                    controller: ReenvioPubliCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/event-publi.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {
                        event: event
                    }
                });
            }
        };

        function ReenvioPubliCtrl($scope, $mdDialog, $filter, event) {
            $scope.listaPaquetes = vm.listaPaquetes;
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            $scope.event = angular.copy(event);
            $scope.event.fIni = new Date($scope.event.fIni);
            $scope.event.fFin = new Date($scope.event.fFin);

            if ($scope.event.type === 'templateEvent')
                $scope.event.type = null;

            if ($scope.event.rangeInit)
                $scope.event.rangeInit = new Date('01/01/1970 ' + $scope.event.rangeInit);

            if ($scope.event.rangeEnd)
                $scope.event.rangeEnd = new Date('01/01/1970 ' + $scope.event.rangeEnd);

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (pkg, bool) {
                $.each(pkg.ordinaryServices, function (index, value) {
                    if (bool === true && !$scope.exists(value.idService, $scope.event.services))
                        $scope.event.services.push(value.idService);

                    if (bool === false && $scope.exists(value.idService, $scope.event.services)) {
                        var idx = $scope.event.services.indexOf(value.idService);
                        $scope.event.services.splice(idx, 1);
                    }
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.arguments.type === 'simple') {
                    copy.header.body = "";
                    copy.header.icon = "";
                }

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.time;
                copy.title = copy.header.title;
                copy.description = copy.header.body;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                delete copy.idTask;

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    event.header.icon = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }
        }

        //***************** Enviar aviso publi (desde portapapeles) *******************
        $scope.addEventPubliFromClipboard = function () {

            navigator.clipboard.readText().then(function (event) {
                try {
                    event = JSON.parse(event);
                    event.services = [];
                    event.cservices = [];

                    if (event.arguments.qt) {
                        $mdDialog.show({
                            controller: ReenvioPubliQTCtrl,
                            templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event-publi.tmpl.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                event: event
                            }
                        });
                    } else {
                        $mdDialog.show({
                            controller: ReenvioPubliCtrl,
                            templateUrl: 'app/main/Quantion/avisos/listado/templates/event-publi.tmpl.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                event: event
                            }
                        });
                    }
                } catch (ex) {
                    console.error(ex);
                    $mdToast.show($mdToast.simple().textContent('Error al obtener el contenido del portapapeles').position('top right').hideDelay(4000));
                }
            });
        };

        //***************** Nueva plantilla *******************
        $scope.addTemplate = function () {
            $mdDialog.show({
                controller: NewTemplateCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/event-template.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewTemplateCtrl($scope, $mdDialog, $filter) {
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            $scope.event = {
                metodo: "POST",
                header: {
                    "title": "",
                    "body": "",
                    "time": 10,
                    "icon": ""
                },
                arguments: {},
                command: "notification",
                type: 'templateEvent'
            };

            $scope.guardar = function () {
                $scope.loading = true;
                var copy = angular.copy($scope.event);

                if (copy.arguments.type === 'simple') {
                    copy.header.body = "";
                    copy.header.icon = "";
                }

                copy.title = copy.header.title;
                copy.description = copy.header.body;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTemplates();
                    $scope.loading = false;
                    $mdDialog.hide();
                }, function () {
                    $scope.loading = false;

                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    event.header.icon = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }
        }

        //***************** Nuevo aviso inmediato (QT) *******************
        var fontFamilyList = ['Arial', 'Times New Roman', 'URW Chancery L', 'NanumMyeongjo', 'URW Bookman L', 'URW Gothic L'];

        $scope.addEventQT = function () {
            $mdDialog.show({
                controller: NewEventQTCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewEventQTCtrl($scope, $mdDialog, $filter) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;
            $scope.listaIdiomas = angular.copy(vm.listaIdiomas);

            $scope.fontFamilyList = fontFamilyList;

            $scope.event = {
                metodo: "POST",
                header: {
                    wakeup: true,
                    properties: {
                        "frame": {
                            "sound": "",
                            "border-color": "white",
                            "color1": "black",
                            "color2": "black",
                            "w": 1200,
                            "h": 500,
                            "x": 200,
                            "y": 200,
                            "theme": "blue",
                            "border-width": 2,
                            "position": "down",
                            "time": 10,
                            "opacity": 90
                        },
                        "title": {
                            "pointSize": 18,
                            "color": "#000000",
                            "someData": "",
                            "text": "",
                            "family": "URW Gothic L",
                            "url": ""
                        },
                        "desc": {
                            "pointSize": 12,
                            "color": "black",
                            "w": 800,
                            "h": 100,
                            "x": 370,
                            "y": 75,
                            "text": "",
                            "family": "URW Gothic L"
                        },
                        "image": {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        },
                        "buttons": []
                    }
                },
                arguments: {
                    "qt": true
                },
                command: "notification",
                type: 'event',
                stbs: [],
                fIni: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                fFin: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                rangeInit: new Date($filter('date')(new Date(), 'yyyy-MM-dd 10:00')),
                rangeEnd: new Date($filter('date')(new Date(), 'yyyy-MM-dd 22:00'))
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                        $scope.event.stbs.push(value.idStb);

                    if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                        var idx = $scope.event.stbs.indexOf(value.idStb);
                        $scope.event.stbs.splice(idx, 1);
                    }
                });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarStorage = function () {
                if (!localStorage.marcados)
                    return;

                var obj = angular.fromJson(localStorage.marcados);

                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (obj[value.idStb] === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (obj[value.idStb] === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarPorIdioma = function (lang) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (value.lang === lang && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);
                    });
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.properties.frame.time;
                copy.title = copy.header.properties.title.text;
                copy.description = copy.header.properties.desc.text;

                if (copy.arguments.type === 'simple') {
                    copy.header.properties.frame.position = 'down-mini';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                } else if (copy.arguments.type === 'completo') {
                    copy.header.properties.frame.position = 'down';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.title.pointSize = 26;
                    copy.header.properties.title.color = '#ffffff';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                }

                copy.header.properties.frame.time = copy.header.properties.frame.time * 1000;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    if (!event.header.properties.image)
                        event.header.properties.image = {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        };

                    event.header.properties.image.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }

            $scope.addButton = function () {
                $scope.event.header.properties.buttons.push({
                    "background-color": "#FFFFFF",
                    "text-color": "#000000",
                    "border-color": "#000000",
                    "border-width": 1.2,
                    "url": "",
                    "someData": "",
                    "text": "",
                    "h": 35,
                    "w": 200,
                    "y": 320,
                    "x": 75
                });
            };

            $scope.deleteButton = function (index) {
                $scope.event.header.properties.buttons.splice(index, 1);
            };
        }

        //***************** Reenviar aviso inmediato *******************
        function ReenvioQTCtrl($scope, $mdDialog, $filter, event) {
            $scope.listaStbs = angular.copy(vm.listaStbs);
            $scope.mapStbs = angular.copy(vm.mapStbs);
            $scope.listaGrupos = angular.copy(vm.listaGrupos);
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;
            $scope.listaIdiomas = angular.copy(vm.listaIdiomas);

            $scope.fontFamilyList = fontFamilyList;

            $scope.event = angular.copy(event);
            $scope.event.fIni = new Date($scope.event.fIni);
            $scope.event.fFin = new Date($scope.event.fFin);

            $scope.event.header.properties.frame.time = event.displaytime;

            if ($scope.event.type === 'templateEvent')
                $scope.event.type = null;

            if ($scope.event.rangeInit)
                $scope.event.rangeInit = new Date('01/01/1970 ' + $scope.event.rangeInit);

            if ($scope.event.rangeEnd)
                $scope.event.rangeEnd = new Date('01/01/1970 ' + $scope.event.rangeEnd);

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                        $scope.event.stbs.push(value.idStb);

                    if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                        var idx = $scope.event.stbs.indexOf(value.idStb);
                        $scope.event.stbs.splice(idx, 1);
                    }
                });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (bool === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (bool === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarStorage = function () {
                if (!localStorage.marcados)
                    return;

                var obj = angular.fromJson(localStorage.marcados);

                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (obj[value.idStb] === true && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);

                        if (obj[value.idStb] === false && $scope.exists(value.idStb, $scope.event.stbs)) {
                            var idx = $scope.event.stbs.indexOf(value.idStb);
                            $scope.event.stbs.splice(idx, 1);
                        }
                    });
                });
            };

            $scope.marcarPorIdioma = function (lang) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        if (value.lang === lang && !$scope.exists(value.idStb, $scope.event.stbs))
                            $scope.event.stbs.push(value.idStb);
                    });
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.properties.frame.time;
                copy.title = copy.header.properties.title.text;
                copy.description = copy.header.properties.desc.text;

                if (copy.arguments.type === 'simple') {
                    copy.header.properties.frame.position = 'down-mini';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                } else if (copy.arguments.type === 'completo') {
                    copy.header.properties.frame.position = 'down';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.title.pointSize = 26;
                    copy.header.properties.title.color = '#ffffff';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                }

                copy.header.properties.frame.time = copy.header.properties.frame.time * 1000;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                delete copy.idTask;

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    if (!event.header.properties.image)
                        event.header.properties.image = {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        };

                    event.header.properties.image.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }

            $scope.addButton = function () {
                $scope.event.header.properties.buttons.push({
                    "background-color": "#FFFFFF",
                    "text-color": "#000000",
                    "border-color": "#000000",
                    "border-width": 1.2,
                    "url": "",
                    "someData": "",
                    "text": "",
                    "h": 35,
                    "w": 200,
                    "y": 320,
                    "x": 75
                });
            };

            $scope.deleteButton = function (index) {
                $scope.event.header.properties.buttons.splice(index, 1);
            };
        }

        //***************** Nuevo aviso publi (QT) *******************
        $scope.addEventPubliQT = function () {
            $mdDialog.show({
                controller: NewEventPubliQTCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event-publi.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewEventPubliQTCtrl($scope, $mdDialog, $filter) {
            $scope.listaPaquetes = vm.listaPaquetes;
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            $scope.fontFamilyList = fontFamilyList;

            $scope.event = {
                metodo: "POST",
                header: {
                    wakeup: true,
                    properties: {
                        "frame": {
                            "sound": "",
                            "border-color": "white",
                            "color1": "black",
                            "color2": "black",
                            "w": 1200,
                            "h": 500,
                            "x": 200,
                            "y": 200,
                            "theme": "blue",
                            "border-width": 2,
                            "position": "down",
                            "time": 10,
                            "opacity": 90
                        },
                        "title": {
                            "pointSize": 18,
                            "color": "#000000",
                            "someData": "",
                            "text": "",
                            "family": "URW Gothic L",
                            "url": ""
                        },
                        "desc": {
                            "pointSize": 12,
                            "color": "black",
                            "w": 800,
                            "h": 100,
                            "x": 370,
                            "y": 75,
                            "text": "",
                            "family": "URW Gothic L"
                        },
                        "image": {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        },
                        "buttons": []
                    }
                },
                arguments: {
                    "publi": true,
                    "qt": true
                },
                command: "notification",
                type: 'event',
                services: [],
                stbs: vm.listaStbs.map(function (e) {
                    return e.idStb;
                }),
                fIni: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                fFin: new Date($filter('date')(new Date(), 'yyyy-MM-dd HH:mm')),
                rangeInit: new Date($filter('date')(new Date(), 'yyyy-MM-dd 10:00')),
                rangeEnd: new Date($filter('date')(new Date(), 'yyyy-MM-dd 22:00'))
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (pkg, bool) {
                $.each(pkg.ordinaryServices, function (index, value) {
                    if (bool === true && !$scope.exists(value.idService, $scope.event.services))
                        $scope.event.services.push(value.idService);

                    if (bool === false && $scope.exists(value.idService, $scope.event.services)) {
                        var idx = $scope.event.services.indexOf(value.idService);
                        $scope.event.services.splice(idx, 1);
                    }
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.properties.frame.time;
                copy.title = copy.header.properties.title.text;
                copy.description = copy.header.properties.desc.text;

                if (copy.arguments.type === 'simple') {
                    copy.header.properties.frame.position = 'down-mini';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                } else if (copy.arguments.type === 'completo') {
                    copy.header.properties.frame.position = 'down';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.title.pointSize = 26;
                    copy.header.properties.title.color = '#ffffff';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                }

                copy.header.properties.frame.time = copy.header.properties.frame.time * 1000;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    if (!event.header.properties.image)
                        event.header.properties.image = {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        };

                    event.header.properties.image.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }

            $scope.addButton = function () {
                $scope.event.header.properties.buttons.push({
                    "background-color": "#FFFFFF",
                    "text-color": "#000000",
                    "border-color": "#000000",
                    "border-width": 1.2,
                    "url": "",
                    "someData": "",
                    "text": "",
                    "h": 35,
                    "w": 200,
                    "y": 320,
                    "x": 75
                });
            };

            $scope.deleteButton = function (index) {
                $scope.event.header.properties.buttons.splice(index, 1);
            };
        }

        //***************** Reenviar aviso publi *******************
        function ReenvioPubliQTCtrl($scope, $mdDialog, $filter, event) {
            $scope.listaPaquetes = vm.listaPaquetes;
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            $scope.fontFamilyList = fontFamilyList;

            $scope.event = angular.copy(event);
            $scope.event.fIni = new Date($scope.event.fIni);
            $scope.event.fFin = new Date($scope.event.fFin);

            $scope.event.header.properties.frame.time = event.displaytime;

            if ($scope.event.type === 'templateEvent')
                $scope.event.type = null;

            if ($scope.event.rangeInit)
                $scope.event.rangeInit = new Date('01/01/1970 ' + $scope.event.rangeInit);

            if ($scope.event.rangeEnd)
                $scope.event.rangeEnd = new Date('01/01/1970 ' + $scope.event.rangeEnd);

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.marcarGrupo = function (pkg, bool) {
                $.each(pkg.ordinaryServices, function (index, value) {
                    if (bool === true && !$scope.exists(value.idService, $scope.event.services))
                        $scope.event.services.push(value.idService);

                    if (bool === false && $scope.exists(value.idService, $scope.event.services)) {
                        var idx = $scope.event.services.indexOf(value.idService);
                        $scope.event.services.splice(idx, 1);
                    }
                });
            };

            $scope.enviarEvento = function () {
                $scope.yaEnviado = true;
                var copy = angular.copy($scope.event);

                if (copy.type !== 'eventProgrammed') {
                    copy.fIni = null;
                    copy.fFin = null;
                    copy.intervalo = 0;
                    copy.rangeInit = null;
                    copy.rangeEnd = null;
                } else {
                    copy.rangeInit = $filter('date')(copy.rangeInit, 'HH:mm:ss');
                    copy.rangeEnd = $filter('date')(copy.rangeEnd, 'HH:mm:ss');
                }

                copy.displaytime = copy.header.properties.frame.time;
                copy.title = copy.header.properties.title.text;
                copy.description = copy.header.properties.desc.text;

                if (copy.arguments.type === 'simple') {
                    copy.header.properties.frame.position = 'down-mini';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                } else if (copy.arguments.type === 'completo') {
                    copy.header.properties.frame.position = 'down';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.title.pointSize = 26;
                    copy.header.properties.title.color = '#ffffff';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                }

                copy.header.properties.frame.time = copy.header.properties.frame.time * 1000;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.toSmartPhones)
                    copy.roomsSmartphone = copy.stbs.map(function (e) {
                        var a = vm.mapStbs[e];
                        return a ? a.room : null;
                    });

                delete copy.idTask;

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    $scope.yaEnviado = false;
                    CargarTodo();
                    $mdDialog.hide();
                }, function () {
                    $scope.yaEnviado = false;
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    if (!event.header.properties.image)
                        event.header.properties.image = {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        };

                    event.header.properties.image.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }

            $scope.addButton = function () {
                $scope.event.header.properties.buttons.push({
                    "background-color": "#FFFFFF",
                    "text-color": "#000000",
                    "border-color": "#000000",
                    "border-width": 1.2,
                    "url": "",
                    "someData": "",
                    "text": "",
                    "h": 35,
                    "w": 200,
                    "y": 320,
                    "x": 75
                });
            };

            $scope.deleteButton = function (index) {
                $scope.event.header.properties.buttons.splice(index, 1);
            };
        }

        //***************** Nueva plantilla *******************
        $scope.addTemplateQT = function () {
            $mdDialog.show({
                controller: NewTemplateQTCtrl,
                templateUrl: 'app/main/Quantion/avisos/listado/templates/qt-event-template.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        function NewTemplateQTCtrl($scope, $mdDialog, $filter) {
            $scope.fontFamilyList = fontFamilyList;
            $scope.JSONconfig = JSONconfig;
            $scope.FilePaths = FilePaths;

            $scope.event = {
                metodo: "POST",
                header: {
                    wakeup: true,
                    properties: {
                        "frame": {
                            "sound": "",
                            "border-color": "white",
                            "color1": "black",
                            "color2": "black",
                            "w": 1200,
                            "h": 500,
                            "x": 200,
                            "y": 200,
                            "theme": "blue",
                            "border-width": 2,
                            "position": "down",
                            "time": 10,
                            "opacity": 90
                        },
                        "title": {
                            "pointSize": 18,
                            "color": "#000000",
                            "someData": "",
                            "text": "",
                            "family": "URW Gothic L",
                            "url": ""
                        },
                        "desc": {
                            "pointSize": 12,
                            "color": "black",
                            "w": 800,
                            "h": 100,
                            "x": 370,
                            "y": 75,
                            "text": "",
                            "family": "URW Gothic L"
                        },
                        "image": {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        },
                        "buttons": []
                    }
                },
                arguments: {
                    "qt": true
                },
                command: "notification",
                type: 'templateEvent'
            };

            $scope.guardar = function () {
                $scope.loading = true;
                var copy = angular.copy($scope.event);

                copy.title = copy.header.properties.title.text;
                copy.description = copy.header.properties.desc.text;

                copy.header = angular.toJson(copy.header);
                copy.arguments = angular.toJson(copy.arguments);

                if (copy.arguments.type === 'simple') {
                    copy.header.properties.frame.position = 'down-mini';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                } else if (copy.arguments.type === 'completo') {
                    copy.header.properties.frame.position = 'down';
                    copy.header.properties.frame.theme = 'custom';
                    copy.header.properties.frame.color1 = '#2b3e4a';
                    copy.header.properties.frame.color2 = '#2b3e4a';
                    copy.header.properties.title.pointSize = 26;
                    copy.header.properties.title.color = '#ffffff';
                    copy.header.properties.desc.pointSize = 22;
                    copy.header.properties.desc.color = '#ffffff';
                }

                var jsonObj = angular.toJson(copy);

                quantionApi.addTask(jsonObj).then(function () {
                    CargarTemplates();
                    $scope.loading = false;
                    $mdDialog.hide();
                }, function () {
                    $scope.loading = false;

                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.elegirImagen = function (ev) {
                $mdDialog.show({
                    controller: ElegirImgCtrl,
                    templateUrl: 'app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        event: $scope.event
                    }
                });
            };
            function ElegirImgCtrl($scope, $mdDialog, event) {
                $scope.listaLogos = vm.listaLogos;

                $scope.escogerImagen = function (img) {
                    if (!event.header.properties.image)
                        event.header.properties.image = {
                            "someData": "",
                            "w": 350,
                            "h": 250,
                            "x": 2,
                            "y": 2,
                            "logo": "",
                            "border-color": "#FFFFFF",
                            "url": ""
                        };

                    event.header.properties.image.logo = img.path;
                    $scope.hide();
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };
            }

            $scope.addButton = function () {
                $scope.event.header.properties.buttons.push({
                    "background-color": "#FFFFFF",
                    "text-color": "#000000",
                    "border-color": "#000000",
                    "border-width": 1.2,
                    "url": "",
                    "someData": "",
                    "text": "",
                    "h": 35,
                    "w": 200,
                    "y": 320,
                    "x": 75
                });
            };

            $scope.deleteButton = function (index) {
                $scope.event.header.properties.buttons.splice(index, 1);
            };
        }

        vm.copyToClipboard = function (event) {
            try {
                navigator.clipboard.writeText(JSON.stringify(event)).then(function () {
                    $mdToast.show($mdToast.simple().textContent('Aviso copiado al portapapeles').position('top right').hideDelay(4000));
                });
            } catch (ex) {
                console.error(ex);
                $mdToast.show($mdToast.simple().textContent('Error al copiar al portapapeles').position('top right').hideDelay(4000));
            }
        };

    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.avisos.publi', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_avisos_publi', {
            url: '/avisos/publi',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/avisos/enviarpubli/enviarpubli.html',
                    controller: 'publiAvisoController as vm'
                }
            },
            params: {
                param: null
            },
            data: {
                authorization: true
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/Quantion/avisos/enviarpubli');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.avisos.publi')
            .controller('publiAvisoController', publiAvisoController);

    /** @ngInject */
    function publiAvisoController($scope, quantionApi, $rootScope, $mdDialog, $mdToast, $state, $stateParams, $filter, JSONconfig, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'AVISOS_PUBLI';

        var EVENTORECIBIDO = $stateParams.param;//Este evento se recibe desde la lista. Será un objeto o null.

        if (EVENTORECIBIDO) {//Si se envia un evento desde la lista, para reenviar
            vm.event = {
                type: EVENTORECIBIDO.evento ? (EVENTORECIBIDO.evento.message ? 'completo' : 'simple') : (EVENTORECIBIDO.message ? 'completo' : 'simple'),
                title: EVENTORECIBIDO.evento ? EVENTORECIBIDO.evento.title : EVENTORECIBIDO.title,
                message: EVENTORECIBIDO.evento ? EVENTORECIBIDO.evento.message : EVENTORECIBIDO.message,
                logo: EVENTORECIBIDO.evento ? EVENTORECIBIDO.evento.icon : EVENTORECIBIDO.icon,
                receiverMode: 'individual',
                displaytime: EVENTORECIBIDO.evento ? EVENTORECIBIDO.evento.displaytime : EVENTORECIBIDO.displaytime
            };
            console.log(vm.event);
            $rootScope.avisoReenviar = null;
        } else {
            vm.event = {
                type: '', //'simple' o 'completo'
                title: '',
                message: '',
                logo: '',
                receiverMode: 'individual',
                displaytime: 10
            };
        }

        $scope.togglePackage = function (pkg) {
            pkg.selected = !pkg.selected;

            $.each(pkg.ordinaryServices, function (i, v) {
                $scope.toggleService(v, null, pkg.selected);
            });
        };

        $scope.toggleService = function (srv, pkg, value) {
            srv.selected = angular.isDefined(value) ? value : !srv.selected;

            if (pkg) {
                var nSel = pkg.ordinaryServices.filter(function (el) {
                    return el.selected;
                }).length;

                pkg.selected = (nSel === pkg.ordinaryServices.length);
            }

            $.each(vm.listaPaquetes, function (i, v) {
                $.each(v.ordinaryServices, function (i2, v2) {
                    if (v2.idService === srv.idService)
                        v2.selected = srv.selected;
                });
            });
        };

        $scope.obtainServiceIds = function () {
            var a = [];
            $.each(vm.listaPaquetes, function (i, v) {
                $.each(v.ordinaryServices, function (i2, v2) {
                    if (v2.selected)
                        a.push(v2.idService);
                });
            });
            return $.unique(a);
        };

        vm.temp_modo = (!EVENTORECIBIDO || !EVENTORECIBIDO.evento) ? "inmediato" : "programado";
        vm.temp_fini = (!EVENTORECIBIDO || !EVENTORECIBIDO.evento) ? new Date() : new Date(EVENTORECIBIDO.fIni);
        vm.temp_ffin = (!EVENTORECIBIDO || !EVENTORECIBIDO.evento) ? new Date() : new Date(EVENTORECIBIDO.fFin);
        vm.temp_repet = "minutos";
        vm.temp_repet2 = (!EVENTORECIBIDO || !EVENTORECIBIDO.evento) ? 1 : Math.min(EVENTORECIBIDO.intervalo, 999);

        vm.ini_hours = vm.temp_fini.getHours();
        vm.fin_hours = vm.temp_ffin.getHours();
        vm.ini_minutes = vm.temp_fini.getMinutes();
        vm.fin_minutes = vm.temp_ffin.getMinutes();

        vm.fechaMinima = new Date();//Fecha de hoy

        vm.enviando = false;
        vm.yaEnviado = false;

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.stbs = dataResponse.data;
        });

        quantionApi.getNotificacionLogos().then(function (dataResponse) {
            vm.listaLogos = dataResponse.data.files;
        });

        quantionApi.getPaquetesActivos().then(function (dataResponse) {
            vm.listaPaquetes = dataResponse.data;
        });

        $scope.JSONconfig = JSONconfig;
        $scope.FilePaths = FilePaths;

        vm.enviarEvento = function () {
            if ($scope.obtainServiceIds().length < 1) {
                $mdDialog.show(
                        $mdDialog.alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title($filter('translate')('PUBLI.ERRORSERV.TITLE'))
                        .ariaLabel('Error destino')
                        .ok($filter('translate')('PUBLI.ERRORSERV.OK'))
                        );
                return;
            }

            var minutos = vm.temp_repet2;
            switch (vm.temp_repet) {
                case "horas":
                    minutos = vm.temp_repet2 * 60;
                    break;
                case "dias":
                    minutos = vm.temp_repet2 * 60 * 24;
                    break;
                default :
                    minutos = vm.temp_repet2;
            }

            vm.temp_fini.setHours(vm.ini_hours);
            vm.temp_fini.setMinutes(vm.ini_minutes);
            vm.temp_fini.setSeconds(0);
            vm.temp_fini.setMilliseconds(0);
            vm.temp_ffin.setHours(vm.fin_hours);
            vm.temp_ffin.setMinutes(vm.fin_minutes);
            vm.temp_ffin.setSeconds(0);
            vm.temp_ffin.setMilliseconds(0);

            var eventoProg = {
                "title": vm.event.title,
                "message": (vm.event.type === 'completo') ? vm.event.message : '',
                "displaytime": vm.event.displaytime,
                "ips": vm.stbs.map(function (elm) {
                    return elm.ip;
                }),
                "icon": (vm.event.type === 'completo') ? vm.event.logo : '',
                "stbs": vm.stbs.map(function (elm) {
                    return elm.idStb;
                }),
                "fIni": vm.temp_fini,
                "fFin": vm.temp_ffin,
                "intervalo": minutos,
                "services": $scope.obtainServiceIds()
            };
            console.log(eventoProg);
            var jsonObjProgramado = angular.toJson(eventoProg, 0);
            console.log(jsonObjProgramado);

            if (vm.temp_ffin > vm.temp_fini) {
                vm.enviando = true;
                vm.yaEnviado = true;
                quantionApi.addEventoProgramado(jsonObjProgramado).then(function (dataResponse) {
                    vm.enviando = false;

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('ENVIAR.TOASTENVIADO'))
                            .position('top right')
                            .hideDelay(4000)
                            );

                    setTimeout(function () {
                        $state.go('app.Quantion_avisos_listado');
                    }, 2000);
                }, function (dataResponse) {
                    vm.enviando = false;
                    vm.yaEnviado = false;

                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('ENVIAR.TOASTERRORENVIO'))
                            .position('top right')
                            .hideDelay(4000)
                            );
                });
            } else {
                $mdDialog.show(
                        $mdDialog.alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title($filter('translate')('ENVIAR.ERRORTEMP.TITLE'))
                        .textContent($filter('translate')('ENVIAR.ERRORTEMP.CONTENT'))
                        .ariaLabel('Error fecha')
                        .ok($filter('translate')('ENVIAR.ERRORTEMP.OK'))
                        );
            }
        };

        //************************ Modal de selección de imagen ****************************
        vm.elegirImagen = function (ev) {
            $mdDialog.show({
                controller: ElegirImagenCtrl,
                templateUrl: 'app/main/Quantion/avisos/enviar/elegirimagen.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {listaLogos: vm.listaLogos}
            });
        };

        function ElegirImagenCtrl($scope, $mdDialog, listaLogos) {
            $scope.listaLogos = listaLogos;

            $scope.escogerImagen = function (img) {
                vm.event.logo = img;
                $scope.hide();
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.avisos.enviar', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_avisos_enviar', {
            url: '/avisos/enviar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/avisos/enviar/enviar.html',
                    controller: 'enviarAvisoController as vm'
                }
            },
            params: {
                param: null,
                isPlantilla: null
            },
            data: {
                authorization: true
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/Quantion/avisos/enviar');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.avisos.enviar')
            .controller('enviarAvisoController', enviarAvisoController);

    /** @ngInject */
    function enviarAvisoController($scope, quantionApi, $rootScope, $mdDialog, $mdToast, $state, $stateParams, $location, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'AVISOS_ENVIAR';

        var EVENTORECIBIDO = $stateParams.param;//Este evento se recibe desde la lista. Será un objeto o null.
        $scope.isPlantilla = $location.search().plantilla;

        if (EVENTORECIBIDO) {//Si se envia un evento desde la lista, para reenviar
            vm.event = {
                type: (EVENTORECIBIDO.message ? 'completo' : 'simple'),
                title: EVENTORECIBIDO.title,
                message: EVENTORECIBIDO.message,
                logo: EVENTORECIBIDO.icon,
                receiverMode: 'individual',
                displaytime: EVENTORECIBIDO.displaytime
            };
            console.log(vm.event);
        } else {
            vm.event = {
                type: '', //'simple' o 'completo'
                title: '',
                message: '',
                logo: '',
                receiverMode: 'individual',
                displaytime: 10
            };
        }

        vm.stbSearch = {
            mode: 'individual',
            allStbs: [],
            modes: {
                individual: {
                    value: 'individual',
                    text: 'Individual',
                    selectedStbObjs: [],
                    noSelectedStbObjs: [],
                    func: function () {
                        return vm.stbSearch.modes.individual.selectedStbObjs.map(function (elm) {
                            return elm.idStb;
                        });
                    }
                },
                group: {
                    value: 'group',
                    text: 'Grupo',
                    groupList: [],
                    groupsSelected: [],
                    selectedStbObjs: [],
                    toogle: function (item) {
                        item.selected = !item.selected;
                    },
                    func: function () {
                        vm.stbSearch.modes.group.selectedStbObjs = [];

                        $.each(vm.stbSearch.modes.group.groupList, function (index, value) {
                            if (value.selected)
                                vm.stbSearch.modes.group.selectedStbObjs = vm.stbSearch.modes.group.selectedStbObjs.concat(value.stbObjs);
                        });

                        return vm.stbSearch.modes.group.selectedStbObjs.map(function (elm) {
                            return elm.idStb;
                        });
                    }
                },
                all: {
                    value: 'all',
                    text: 'Todos',
                    func: function () {
                        return vm.stbSearch.allStbs.map(function (elm) {
                            return elm.idStb;
                        });
                    }
                }
            }
        };

        vm.temp_modo = (!EVENTORECIBIDO || !EVENTORECIBIDO.fIni) ? "inmediato" : "programado";
        vm.temp_fini = (!EVENTORECIBIDO || !EVENTORECIBIDO.fIni) ? new Date() : new Date(EVENTORECIBIDO.fIni);
        vm.temp_ffin = (!EVENTORECIBIDO || !EVENTORECIBIDO.fIni) ? new Date() : new Date(EVENTORECIBIDO.fFin);
        vm.temp_repet = "minutos";
        vm.temp_repet2 = (!EVENTORECIBIDO || !EVENTORECIBIDO.fIni) ? 1 : Math.min(EVENTORECIBIDO.intervalo, 999);

        vm.ini_hours = vm.temp_fini.getHours();
        vm.fin_hours = vm.temp_ffin.getHours();
        vm.ini_minutes = vm.temp_fini.getMinutes();
        vm.fin_minutes = vm.temp_ffin.getMinutes();

        vm.fechaMinima = new Date();//Fecha de hoy

        vm.enviando = false;
        vm.yaEnviado = false;

        quantionApi.getStbs(true).then(function (dataResponse) {
            vm.stbSearch.allStbs = dataResponse.data;
            vm.stbSearch.modes.individual.selectedStbObjs = EVENTORECIBIDO ? EVENTORECIBIDO.stbs : [];
            vm.stbSearch.modes.individual.noSelectedStbObjs = EVENTORECIBIDO ? vm.stbSearch.allStbs.diff(EVENTORECIBIDO.stbs) : vm.stbSearch.allStbs.slice();

            quantionApi.getGrupos().then(function (dataResponse) {
                vm.stbSearch.modes.group.groupList = dataResponse.data;
                vm.stbSearch.modes.group.groupList.sort(function (a, b) {
                    return a.orden - b.orden;
                });

                //Por cada grupo recibido de la petición
                $.each(vm.stbSearch.modes.group.groupList, function (index, value) {
                    value.stbObjs = [];
                    value.selected = false;

                    //Por cada índice de STB dentro de {grupo}.stbs
                    $.each(value.stbs, function (index2, value2) {

                        //Por cada STB de la lista completa, comprueba si coincide su ID, 
                        //y lo inserta en la lista de objetos del grupo
                        $.each(vm.stbSearch.allStbs, function (index3, value3) {
                            if (value3.idStb === value2) {
                                value.stbObjs.push(value3);
                                return;
                            }
                        });
                    });
                });
            });
        });

        quantionApi.getNotificacionLogos().then(function (dataResponse) {
            vm.listaLogos = dataResponse.data.files;
        });

        vm.enviarEvento = function () {
            if (vm.stbSearch.modes[vm.stbSearch.mode].func().length < 1) {
                $mdDialog.show(
                        $mdDialog.alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title($filter('translate')('ENVIAR.ALERTNOSTB.TITLE'))
                        .textContent($filter('translate')('ENVIAR.ALERTNOSTB.CONTENT'))
                        .ariaLabel('Error destino')
                        .ok($filter('translate')('ENVIAR.ALERTNOSTB.OK'))
                        );
                return;
            }

            var minutos = vm.temp_repet2;
            switch (vm.temp_repet) {
                case "horas":
                    minutos = vm.temp_repet2 * 60;
                    break;
                case "dias":
                    minutos = vm.temp_repet2 * 60 * 24;
                    break;
                default :
                    minutos = vm.temp_repet2;
            }

            vm.temp_fini.setHours(vm.ini_hours);
            vm.temp_fini.setMinutes(vm.ini_minutes);
            vm.temp_fini.setSeconds(0);
            vm.temp_fini.setMilliseconds(0);
            vm.temp_ffin.setHours(vm.fin_hours);
            vm.temp_ffin.setMinutes(vm.fin_minutes);
            vm.temp_ffin.setSeconds(0);
            vm.temp_ffin.setMilliseconds(0);

//            console.log(vm.event);

            switch (vm.temp_modo) {
                case "inmediato":
                {
                    var eventoUnico = {
                        "title": vm.event.title,
                        "message": (vm.event.type === 'completo') ? vm.event.message : '',
                        "displaytime": vm.event.displaytime,
                        "stbs": vm.stbSearch.modes[vm.stbSearch.mode].func(), //IDs de STB
                        "icon": (vm.event.type === 'completo') ? vm.event.logo : '',
                        info: ['normal', vm.event.type].join(';')
                    };
//                    console.log(eventoUnico);
                    var jsonObjInmediato = angular.toJson(eventoUnico);
                    console.log(eventoUnico);
                    vm.enviando = true;
                    vm.yaEnviado = true;
                    quantionApi.addEvento(jsonObjInmediato).then(function (dataResponse) {
                        vm.enviando = false;

                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('ENVIAR.TOASTENVIADO'))
                                .position('top right')
                                .hideDelay(4000)
                                );

                        setTimeout(function () {
                            $state.go('app.Quantion_avisos_listado');
                        }, 2000);

                    }, function (dataResponse) {
//                        console.log(dataResponse);

                        vm.enviando = false;
                        vm.yaEnviado = false;

                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('ENVIAR.TOASTERRORENVIO'))
                                .position('top right')
                                .hideDelay(4000)
                                );
                    });
                    break;
                }
                case "programado":
                {
                    var eventoProg = {
                        "title": vm.event.title,
                        "message": (vm.event.type === 'completo') ? vm.event.message : '',
                        "displaytime": vm.event.displaytime,
                        "icon": (vm.event.type === 'completo') ? vm.event.logo : '',
                        "stbs": vm.stbSearch.modes[vm.stbSearch.mode].func(),
                        "fIni": vm.temp_fini,
                        "fFin": vm.temp_ffin,
                        "intervalo": minutos,
                        info: ['normal', 'prog', vm.event.type].join(';')
                    };
                    console.log(eventoProg);
                    var jsonObjProgramado = angular.toJson(eventoProg, 0);
//                    console.log(jsonObjProgramado);

                    if (vm.temp_ffin > vm.temp_fini) {
                        vm.enviando = true;
                        vm.yaEnviado = true;
                        quantionApi.addEventoProgramado(jsonObjProgramado).then(function (dataResponse) {
                            vm.enviando = false;

                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent($filter('translate')('ENVIAR.TOASTENVIADO'))
                                    .position('top right')
                                    .hideDelay(4000)
                                    );

                            setTimeout(function () {
                                $state.go('app.Quantion_avisos_listado');
                            }, 2000);
                        }, function (dataResponse) {
//                            console.log(dataResponse);

                            vm.enviando = false;
                            vm.yaEnviado = false;

                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent($filter('translate')('ENVIAR.TOASTERRORENVIO'))
                                    .position('top right')
                                    .hideDelay(4000)
                                    );
                        });
                    } else {
                        $mdDialog.show(
                                $mdDialog.alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title($filter('translate')('ENVIAR.ERRORTEMP.TITLE'))
                                .textContent($filter('translate')('ENVIAR.ERRORTEMP.CONTENT'))
                                .ariaLabel('Error fecha')
                                .ok($filter('translate')('ENVIAR.ERRORTEMP.OK'))
                                );
                    }
                    break;
                }
                default:
                    alert("Opcion no disponible");
            }
        };

        vm.guardarPlantilla = function () {
            var eventoUnico = {
                "title": vm.event.title,
                "message": (vm.event.type === 'completo') ? vm.event.message : '',
                "icon": (vm.event.type === 'completo') ? vm.event.logo : '',
                info: ['template', vm.event.type].join(';')
            };
//                    console.log(eventoUnico);
            var jsonObjInmediato = angular.toJson(eventoUnico, 0);
            console.log(eventoUnico);
            vm.enviando = true;
            vm.yaEnviado = true;
            quantionApi.addEvento(jsonObjInmediato).then(function (dataResponse) {
                vm.enviando = false;

                setTimeout(function () {
                    $state.go('app.Quantion_avisos_listado');
                }, 2000);
            }, function (dataResponse) {
                vm.enviando = false;
                vm.yaEnviado = false;

                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Error')
                        .position('top right')
                        .hideDelay(4000)
                        );
            });
        };

        //Funciones para el autocomplete de habitaciones

        vm.selectedItem = null;
        vm.searchText = null;

        vm.querySearch = function (query) {
            var results = query ? vm.stbSearch.modes.individual.noSelectedStbObjs.filter(createFilterFor(query)) : vm.stbSearch.modes.individual.noSelectedStbObjs;
            return results;
        };

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            var filterFn = function (hab) {
                return (angular.lowercase(hab.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(hab.username).indexOf(lowercaseQuery) !== -1);
            };

            return filterFn;
        }

        //Diferencia entre arrays
        Array.prototype.diff = function (a) {
            return this.filter(function (i) {
                return a.indexOf(i) < 0;
            });
        };

        vm.actualizarRestantes = function () {
            vm.stbSearch.modes.individual.noSelectedStbObjs = vm.stbSearch.allStbs.diff(vm.stbSearch.modes.individual.selectedStbObjs);
        };

        //************************ Modal de selección de imagen ****************************
        vm.elegirImagen = function (ev) {
            $mdDialog.show({
                controller: ElegirImagenCtrl,
                templateUrl: 'app/main/Quantion/avisos/enviar/elegirimagen.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {listaLogos: vm.listaLogos}
            });
        };

        function ElegirImagenCtrl($scope, $mdDialog, listaLogos) {
            $scope.listaLogos = listaLogos;

            $scope.escogerImagen = function (img) {
                vm.event.logo = img;
                $scope.hide();
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.login', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.Quantion_login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Quantion_login': {
                    templateUrl: 'app/main/Quantion/auth/login/login.html',
                    controller: 'QuantionLoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/auth/login');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.auth.login')
            .controller('QuantionLoginController', QuantionLoginController);

    /** @ngInject */
    function QuantionLoginController($location, quantionApi, $rootScope, $cookies, LogoConfig, $translate, RoleService, $filter, $scope, incidencesApi, incidencesStateService, JSONconfig)
    {
        var vm = this;

        vm.logoEstablecimiento = LogoConfig;

        quantionApi.installationName().then(function (dataResponse) {
            $scope.installationName = dataResponse.data;
        });

        vm.loggedSuccesfully = false;
        $translate.use($translate.preferredLanguage());

        function finishLogin() {
            var redirectUrl = $cookies.get('redirectUrl');
            if (redirectUrl) {
                $cookies.remove('redirectUrl');
                $location.path(redirectUrl);
            } else {
                $location.path('/');
            }
            vm.dataLoading = false;
        }

        function loginIncidences() {
            if (!JSONconfig.soporteIncidencias) {
                finishLogin();
                return;
            }

            incidencesApi.login(vm.user.name, vm.user.password).then(function (res) {
                incidencesApi.setToken(res.data.jwt, res.data.expiresAt);
                incidencesStateService.startPolling();
                finishLogin();
            }, function () {
                incidencesApi.clearToken();
                incidencesStateService.stopPolling();
                finishLogin();
            });
        }

        vm.login = function () {
            vm.dataLoading = true;

            var jsonObj = angular.toJson(vm.user, 0);

            quantionApi.loginUsuario(jsonObj).then(function (dataResponse) {
                vm.loggedSuccesfully = true;
                $rootScope.user = dataResponse.data;
                $translate.use($rootScope.user.language || $translate.preferredLanguage());

                var cookieExpireTime = new Date();
                cookieExpireTime.setDate(cookieExpireTime.getDate() + 1);
                $cookies.put('expires', cookieExpireTime.toString(), {expires: cookieExpireTime});
                RoleService.setUserStored(dataResponse.data);
                RoleService.updateUserStoredNavigationList();

                loginIncidences();
            }, function (dataResponse) {
                switch (dataResponse.status) {
                    case 401:
                        vm.mensajeError = $filter('translate')('LOGIN.ERROR401');
                        break;
                    case 404:
                        vm.mensajeError = $filter('translate')('LOGIN.ERROR404');
                        break;
                    default:
                        vm.mensajeError = $filter('translate')('LOGIN.ERRORDEFAULT');
                }
                vm.dataLoading = false;
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.servicios', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_archivos_servicios', {
            url: '/archivos/servicios',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/archivos/servicios/servicios.html',
                    controller: 'serviciosArchivosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/archivos/servicios');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.servicios')
            .controller('serviciosArchivosController', serviciosArchivosController);

    /** @ngInject */
    function serviciosArchivosController(quantionApi, $mdDialog, $mdToast, $scope, $location, $rootScope, $filter, $mdSidenav, JSONconfig, FilePaths, $compile)
    {
        var vm = this;
        $rootScope.seccion = 'ROOT_G_SERVICIOS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        $scope.$on('onRepeatLast', function (scope, element, attrs) {
            pantallaCarga.lsDisable();
        });

        CargarServicios($location.search().select);
        function CargarServicios(srvType) {
            vm.listaServicios = {};
            vm.serviceMap = {};

            quantionApi.getTiposServicio().then(function (dataResponse) {
                dataResponse.data.sort();
                $.each(dataResponse.data, function (index, value) {
                    vm.listaServicios[value] = [];
                });

                quantionApi.getServicios(false).then(function (dataResponse) {
                    $.each($filter('orderBy')(dataResponse.data, 'name|formatNameDesc'), function (index, value) {
                        if (!$rootScope.user.mapRole.acls || $rootScope.user.mapRole.acls.length < 1) {
                            vm.listaServicios[value.type].push(value);
                            vm.serviceMap[value.idService] = value;
                        } else if ($rootScope.user.mapRole.acls && $rootScope.user.mapRole.acls.indexOf(value.acl) > -1) {
                            getServicesInGroup(value)
                        }
                    });

                    $scope.tiposServicio = [];
                    $.each(vm.listaServicios, function (key, value) {
                        if (value.length > 0)
                            $scope.tiposServicio.push(key);
                    });
                    $scope.tiposServicio.sort(function (a, b) {
                        return $filter('translate')('SERVICIOS.TIPOS.' + a).localeCompare($filter('translate')('SERVICIOS.TIPOS.' + b));
                    });

                    if (srvType)
                        $scope.selectType(srvType);
                    else
                        $scope.selectType($scope.tiposServicio[0]);
                });

            });
        }

        function getServicesInGroup(srvc) {
            if (!vm.serviceMap[srvc.idService]) {
                vm.listaServicios[srvc.type].push(srvc);
                vm.serviceMap[srvc.idService] = srvc;
            }

            if (srvc.elements) {
                $.each(srvc.elements, function (index, value) {
                    getServicesInGroup(value);
                });
            }
        }

        quantionApi.getIdiomas().then(function (dataResponse) {
            vm.listaIdiomas = dataResponse.data;
        });

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
//                console.log('Error en formato de JSON');
                return false;
            }
            return text ? true : false;
        }

        $scope.selectType = function (type) {
            $scope.selectedType = type;

            var html = '';

            $.each(vm.listaServicios[type], function (index, srvc) {
                html += '<md-list-item class="md-3-line layout-wrap">' +
                        '    <img src="' + $filter('replacePath')(srvc.logo) + '" on-error-image="/assets/quantionImagenes/img-error.png"/>' +
                        (srvc.active ? '<md-icon md-font-icon="icon-checkbox-marked-circle"></md-icon>' : '') +
                        '    <div class="md-list-item-text layout-column flex">' +
                        '        <h3><span>' + $filter('translate')("PAQUETES.NOMBRE") + '</span> ' + $filter('formatNameDesc')(srvc.name) + ' (' + srvc.acl + ')</h3>' +
                        '        <h4><span>' + $filter('translate')("PAQUETES.DESCRIPCION") + '</span> ' + $filter('formatNameDesc')(srvc.description) + '</h4>';

                if (srvc.elements)
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMELEMENTOS") + '</span> ' + srvc.elements.length + '</h4>';

                if (srvc.samples)
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMARCHIVOS") + '</span> ' + srvc.samples.length + '</h4>';

                if (srvc.countries)
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.PAISES") + '</span> ' + $filter('stringifyArray')(srvc.countries) + '</h4>';

                if (srvc.cities)
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.CIUDADES") + '</span> ' + $filter('stringifyArray')(srvc.cities) + '</h4>';

                if (srvc.channelList)
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.NUMCANALES") + '</span> ' + srvc.channelList.length + '</h4>';

                if (srvc.type === 'web' || srvc.type === 'game')
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.URL") + '</span> ' + $filter('parseJSON')(srvc.toAction.data, 'url') + '</h4>';

                if (srvc.maxConnections)
                    html += '<h4><span>' + $filter('translate')("SERVICIOS.MAXCONEXIONES") + '</span> ' + srvc.maxConnections + '</h4>';

                html += '</div><div layout="row" layout-wrap flex-xs="100" flex-sm="100">';

                if (srvc.samples)
                    html += '<md-button class="md-fab md-mini" ng-click="vm.ventanaSamples($event, ' + srvc.idService + ')">' +
                            '    <md-icon md-font-icon="icon-file-multiple"></md-icon>' +
                            '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.LISTAARCHIVOS") + '</md-tooltip>' +
                            '</md-button>';

                if (srvc.dates)
                    html += '<md-button class="md-fab md-mini" ng-click="vm.calendar($event, ' + srvc.idService + ')">' +
                            '    <md-icon md-font-icon="icon-calendar"></md-icon>' +
                            '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.LISTACALENDAR") + '</md-tooltip>' +
                            '</md-button>';

                html += '<md-button class="md-fab md-mini" ng-click="vm.ventanaEditar($event, ' + srvc.idService + ')">' +
                        '    <md-icon md-font-icon="icon-pencil"></md-icon>' +
                        '    <md-tooltip md-direction="bottom">' + $filter('translate')("SERVICIOS.MODIFICARSERVICIO") + '</md-tooltip>' +
                        '</md-button>';


                html += '</div><span style="position:absolute;bottom: 0;left: 0">ID' + srvc.idService + '</span></md-list-item>';
            });

            $('#service-container').empty().append(html);
            $compile($('#service-container'))($scope);
        };

//Modificacion de servicio
        vm.ventanaEditar = function (ev, srvc) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/archivos/servicios/templates/crearservicio.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, servicio) {
            $scope.title = "SERVICIOS.MODALEDITAR.TITLEEDITAR";
            $scope.serviceType = servicio.type;
            $scope.listaIdiomas = vm.listaIdiomas;
            $scope.accion = 'editar';

            $scope.service = angular.copy(servicio);//Clonar objeto servicio

            $scope.service.name = {};
            $.each(servicio.name, function (i, el) {
                $scope.service.name[el.language] = el.value;
            });

            $scope.service.description = {};
            $.each(servicio.description, function (i, el) {
                $scope.service.description[el.language] = el.value;
            });

            switch (servicio.type) {
                case 'tv':
                    $scope.service.blockedVideo = {};
                    $.each(servicio.blockedVideo, function (i, el) {
                        $scope.service.blockedVideo[el.language] = el.value;
                    });
                    $scope.service.visibleVideo = {};
                    $.each(servicio.visibleVideo, function (i, el) {
                        $scope.service.visibleVideo[el.language] = el.value;
                    });
                    delete $scope.service.channelList;
                    delete $scope.service.orders;
                    break;
                case 'web':
                    delete $scope.service.body;
                    break;
                case 'files':
                    delete $scope.service.samples;
                    break;
                case 'group':
                    delete $scope.service.elements;
                    delete $scope.service.defaultService;
                    break;
            }

//            $scope.toActionInputType = servicio.toAction ? !(servicio.toAction.method === 'POST' && (servicio.toAction.url === 'https://wc.solertia.sol:8091/browser' || servicio.toAction.url === 'href')) : false;
            $scope.toActionBasic = {
                method: 'POST',
                url: servicio.toAction ? servicio.toAction.url : "",
                data: (servicio.toAction && isJSON(servicio.toAction.data) ? angular.fromJson(servicio.toAction.data).url : "")
            };
//            $scope.toActionAdv = angular.copy(servicio.toAction);

//            console.log(servicio, $scope.service);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var service = angular.copy($scope.service);

                service.name = $.map($scope.service.name, function (value, key) {
                    return {language: key, value: value};
                });
                service.description = $.map($scope.service.description, function (value, key) {
                    return {language: key, value: value};
                });

                switch ($scope.service.type) {
                    case 'tv':
                        service.blockedVideo = $.map($scope.service.blockedVideo, function (value, key) {
                            return {language: key, value: value};
                        });
                        service.visibleVideo = $.map($scope.service.visibleVideo, function (value, key) {
                            return {language: key, value: value};
                        });
                        break;
                }

                service.toAction = {
                    method: 'POST',
                    url: $scope.toActionBasic.url,
                    data: "{\"url\": \"" + $scope.toActionBasic.data + "\"}"
                };


                var jsonObj = angular.toJson(service, 0);
//                console.log(angular.toJson(service, true));

                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('SERVICIOS.EDITARTOAST')).position('top right').hideDelay(3000));
                    CargarServicios($scope.service.type);
                    $scope.hide();
                }, function () {
                    $scope.mensajeError = "SERVICIOS.MODALEDITAR.ERROREDITAR";
                    $scope.dataLoading = false;
                });
            };
        }

        vm.ventanaSamples = function (ev, srvc) {
            $mdDialog.show({
                controller: SamplesCtrl,
                templateUrl: 'app/main/Quantion/archivos/servicios/templates/listaSamples.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function SamplesCtrl($scope, $mdDialog, $mdSidenav, servicio) {
            $scope.service = angular.copy(servicio);
            $scope.listaIdiomas = vm.listaIdiomas;

            CargarArchivos();
            function CargarArchivos() {
                quantionApi.getGenericFiles('FileServices/' + servicio.acl).then(function (dataResponse) {
                    $scope.listaArchivos = dataResponse.data.files;
                });
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                $scope.dataLoading = true;
                var jsonObj = angular.toJson({samples: $scope.service.samples}, 0);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    $scope.dataLoading = false;
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            $scope.updateList = function () {
                var obj = {
                    name: [],
                    description: [],
                    url: [],
                    thumbnail: $scope.sample.thumbnail,
                    mime: $scope.sample.mime
                };

                $.each($scope.sample.name, function (key, value) {
                    obj.name.push({'language': key, 'value': value});
                });
                $.each($scope.sample.description, function (key, value) {
                    obj.description.push({'language': key, 'value': value});
                });
                $.each($scope.sample.url, function (key, value) {
                    obj.url.push({'language': key, 'value': value});
                });

                if ($scope.smplIndex !== null) {
                    $scope.service.samples.splice($scope.smplIndex, 1, obj);
                } else {
                    $scope.service.samples.push(obj);
                }
                $mdSidenav('right').close();
            };

            $scope.close = function () {
                $mdSidenav('right').close();
            };

            $scope.add = function () {
                $scope.sample = {
                    name: {},
                    description: {},
                    url: {},
                    thumbnail: '',
                    mime: ''
                };

                $scope.smplIndex = null;
                $scope.selectedMime = undefined;
                $scope.customMime = undefined;
                $mdSidenav('right').open();
            };

            $scope.editar = function (index, elem) {
                $scope.sample = {
                    name: {},
                    description: {},
                    url: {},
                    thumbnail: elem.thumbnail,
                    mime: elem.mime
                };
                $.each(elem.name, function (index, value) {
                    $scope.sample.name[value.language] = value.value;
                });
                $.each(elem.description, function (index, value) {
                    $scope.sample.description[value.language] = value.value;
                });
                $.each(elem.url, function (index, value) {
                    $scope.sample.url[value.language] = value.value;
                });

                $scope.smplIndex = index;
                $scope.selectedMime = ['video', 'imagen', 'audio', 'doc'].includes(elem.mime) ? elem.mime : '_';
                $scope.customMime = ['video', 'imagen', 'audio', 'doc'].includes(elem.mime) ? undefined : elem.mime;
                $mdSidenav('right').open();
            };

            $scope.eliminar = function (index) {
                $scope.service.samples.splice(index, 1);
            };

            function cargarArchivo(evt) {
                var files = evt.target.files;
                var file = files[0];
                if (!file)
                    return;

                var formData = new FormData();
                formData.append('file', file);

                $scope.dataLoading = true;
                quantionApi.uploadGenericFile(formData, file.name, 'FileServices/' + servicio.acl).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTSUBIDA')).position('top right').hideDelay(3000));
                    $scope.dataLoading = false;
                    CargarArchivos();
                });
            }

            var a = false;
            $scope.upload = function () {
                if (!a)
                    document.getElementById('uploadFile').addEventListener('change', cargarArchivo, false);
                $('#uploadFile').click();
            };

            $scope.replicar = function (el) {
                $.each(Object.keys($scope.sample.url), function (index, value) {
                    $scope.sample.url[value] = el;
                });
            };

            $scope.mimeChanged = function (newMime) {
                $scope.sample.mime = newMime;
            };
        }

        //**************************** CALENDARIO ******************************
        vm.calendar = function (ev, srvc) {
            $mdDialog.show({
                controller: CalendarCtrl,
                templateUrl: 'app/main/Quantion/archivos/servicios/templates/calendario.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {servicio: vm.serviceMap[srvc]}
            });
        };

        function CalendarCtrl($scope, $mdDialog, $mdToast, servicio) {
            $scope.service = angular.copy(servicio);
//            console.log($scope.service);
            $scope.listaIdiomas = vm.listaIdiomas;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.guardar = function () {
                var jsonObj = angular.toJson({dates: $scope.service.dates}, 0);
                quantionApi.updateServicio(servicio.idService, jsonObj).then(function (dataResponse) {
                    CargarServicios(servicio.type);
                    $mdDialog.hide();
                });
            };

            $scope.updateList = function () {
                var obj = {
                    title: [],
                    description: [],
                    image: $scope.sample.image,
                    category: $scope.sample.category,
                    startTime: $filter('date')($scope.sample.startTime, 'HH:mm:ss') /*$scope.sample.startTime.getHours() + ':' + $scope.sample.startTime.getMinutes() + ':' + $scope.sample.startTime.getSeconds()*/,
                    duration: $scope.sample.duration
                };

                $.each($scope.sample.title, function (key, value) {
                    obj.title.push({'language': key, 'value': value});
                });
                $.each($scope.sample.description, function (key, value) {
                    obj.description.push({'language': key, 'value': value});
                });

                var dateToKey = $filter('date')($scope.sample.date, 'yyyy-MM-dd');

                if ($scope.smplIndex !== null) {
                    if ($scope.service.dates[dateToKey])
                        $scope.service.dates[dateToKey].splice($scope.smplIndex, 1);

                    if (!$scope.service.dates[dateToKey])
                        $scope.service.dates[dateToKey] = [];
                    $scope.service.dates[dateToKey].push(obj);
                } else {
                    if (!$scope.service.dates[dateToKey])
                        $scope.service.dates[dateToKey] = [];
                    $scope.service.dates[dateToKey].push(obj);
                }

                $.each($scope.service.dates, function (key, value) {
                    if (value.length < 1)
                        delete $scope.service.dates[key];
                });

                $scope.close();
            };

            $scope.add = function () {
                $scope.sample = {
                    title: {},
                    description: {},
                    image: "",
                    category: '',
                    startTime: null,
                    duration: null
                };

                $scope.smplIndex = null;
                $scope.key = null;

                $mdSidenav('right').open();
            };

            $scope.editar = function (key, index, elem) {
                $scope.sample = {
                    title: {},
                    description: {},
                    image: elem.image,
                    category: elem.category,
                    duration: elem.duration,
                    date: new Date(key)
                };
                $.each(elem.title, function (index, value) {
                    $scope.sample.title[value.language] = value.value;
                });
                $.each(elem.description, function (index, value) {
                    $scope.sample.description[value.language] = value.value;
                });

                var time = elem.startTime.split(':');

                var d = new Date(0);

                d.setHours(+time[0]);
                d.setMinutes(time[1]);
                d.setSeconds(time[2]);

                $scope.sample.startTime = d;

                $scope.smplIndex = index;
                $scope.key = key;

                $mdSidenav('right').open();
            };

            $scope.eliminar = function (key, index) {
                $scope.service.dates[key].splice(index, 1);

                $.each($scope.service.dates, function (key, value) {
                    if (value.length < 1)
                        delete $scope.service.dates[key];
                });
            };

            $scope.close = function () {
                $mdSidenav('right').close();
            };
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.banners', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_archivos_banners', {
            url: '/archivos/banners',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/archivos/nombreRandom/nombreRandom.html',
                    controller: 'bannersController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/archivos/nombreRandom');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.banners')
            .controller('bannersController', bannersController);

    /** @ngInject */
    function bannersController($scope, quantionApi, $mdDialog, $mdToast, $filter, $rootScope, FilePaths, JSONconfig)
    {
        var vm = this;
        $rootScope.seccion = 'ARCHIVOS_BANNERS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        //Aviso adblock
        $("#content-container")[0].appendChild($(".avisoAdblock")[0]);
        $scope.$on('$destroy', function () {
            $(".avisoAdblock").remove();
        });

        //Obtiene la lista de archivos de la carpeta rsc/Publicidad
        CargarListaArchivos();
        function CargarListaArchivos() {
            pantallaCarga.lsEnable('LS.GENERIC');

            quantionApi.getGenericFiles(FilePaths.publicidad).then(function (dataResponse) {
                var videoExtensions = ['mp4', 'webm'];

                $scope.listaArchivos = $filter('orderBy')(dataResponse.data.files.map(function (elm) {
                    var ext = elm.name.split('.');
                    ext = ext[ext.length - 1];
                    elm.type = videoExtensions.indexOf(ext) > -1 ? 'VIDEO' : 'IMG';
                    return elm;
                }), 'name');

                vm.listaArchivos = $scope.listaArchivos;

                pantallaCarga.lsDisable();
            });
        }

        $scope.toggleActive = function (banner, group) {
            if (!banner.active && banner.url.length < 1 && banner.type !== 'IFRAME') {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('BANNERS.ASIGNAURL.TITLE'))
                        .clickOutsideToClose(true)
                        .ok($filter('translate')('BANNERS.ASIGNAURL.OK'));

                $mdDialog.show(confirm).then(function () {
                    vm.setLink(banner, null, group);
                });
                return;
            }

            var i = {
                idBanner: banner.idBanner,
                active: !banner.active
            };

            pantallaCarga.lsEnable('LS.SAVING');
            quantionApi.updateBanner(angular.toJson(i)).then(function (dataResponse) {
                pantallaCarga.lsDisable();
                quantionApi.updateGrupoBanner(angular.toJson({idBannerGroup: group.idBannerGroup})).then(function (dataResponse) {
                    CargarGrupos();
//                    replaceBannerGroup(dataResponse.data);
                });
            }, function () {
                pantallaCarga.lsDisable();
            });
        };

        vm.zoomImagen = function (elm) {
            window.open($filter('replacePath')(elm.link));
        };

        vm.eliminarArchivo = function (elm, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('MISCONTENIDOS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('MISCONTENIDOS.MODALELIMINAR.CONTENT'))
                    .ariaLabel('Confirmación borrado')
                    .targetEvent(ev)
                    .ok($filter('translate')('MISCONTENIDOS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('MISCONTENIDOS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteArchivoMediaPubli(elm.name).then(function (dataResponse) {
                    pantallaCarga.lsDisable();
                    CargarListaArchivos();
                }, function () {
                    pantallaCarga.lsDisable();
                });
            });
        };

        vm.eliminarBanner = function (elm, ev, group) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('MISCONTENIDOS.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('MISCONTENIDOS.MODALELIMINAR.CONTENT'))
                    .ariaLabel('Confirmación borrado')
                    .targetEvent(ev)
                    .ok($filter('translate')('MISCONTENIDOS.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('MISCONTENIDOS.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                pantallaCarga.lsEnable('LS.ELIMINANDO');

                quantionApi.deleteBannerById(elm.idBanner).then(function (dataResponse) {
                    pantallaCarga.lsDisable();
                    quantionApi.updateGrupoBanner(angular.toJson({idBannerGroup: group.idBannerGroup})).then(function (dataResponse) {
                        CargarGrupos();
//                        replaceBannerGroup(dataResponse.data);
                    });
                }, function () {
                    pantallaCarga.lsDisable();
                });
            });
        };

        $scope.toggle = function (id, className) {
            $(id).toggleClass(className);
        };

        vm.setLink = function (elm, ev, group) {
            if (elm.type === 'IFRAME') {
                vm.asignarBannerIframe(ev, group, elm);
            } else if ($rootScope.user.userRole !== 'BASE')
                $mdDialog.show({
                    controller: LinkCtrl,
                    templateUrl: 'app/main/Quantion/archivos/nombreRandom/link.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        banner: elm,
                        group: group
                    }
                });
            else
                $mdDialog.show({
                    controller: LinkLiteCtrl,
                    templateUrl: 'app/main/Quantion/archivos/nombreRandom/link_lite.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        banner: elm,
                        group: group
                    }
                });
        };

        function LinkCtrl($scope, $mdDialog, $mdToast, banner, $mdSidenav, group) {
            $scope.banner = angular.copy(banner);

            $scope.banner.fechaini = $scope.banner.fechaini ? new Date($scope.banner.fechaini) : null;
            $scope.banner.fechafin = $scope.banner.fechafin ? new Date($scope.banner.fechafin) : null;
            $scope.banner.horaini = $scope.banner.horaini ? new Date($scope.banner.horaini) : null;
            $scope.banner.horafin = $scope.banner.horafin ? new Date($scope.banner.horafin) : null;

            $scope.toActionInputType = isJSON(banner.data) ? Object.keys(angular.fromJson(banner.data)).length > 1 : true;
            $scope.toActionBasic = {
                method: 'POST',
                url: banner.url,
                data: isJSON(banner.data) ? angular.fromJson(banner.data).url : ""
            };
            $scope.toActionAdv = {
                method: banner.method,
                url: banner.url,
                data: banner.data
            };

            if (banner.url !== 'href') {
                $scope.url = 'browser';
            } else {
                if (banner.data.indexOf('store') === -1) {
                    $scope.url = 'href';
                } else {
                    $scope.url = 'store';

                    var x = angular.fromJson(banner.data).url.split('/');
                    var pid = x[x.length - 1];
                    $scope.pack = isNaN(pid) ? null : pid;
                }
            }

            var methods = {
                "browser": "https://wc.solertia.sol:8091/browser",
                "href": "href",
                "store": "href"
            };

            if (vm.listaPaquetes) {
                $scope.listaPaquetes = vm.listaPaquetes;
            } else {
                quantionApi.getPaquetesActivos().then(function (dataResponse) {
                    $scope.listaPaquetes = dataResponse.data;
                    vm.listaPaquetes = $scope.listaPaquetes;
                });
            }

            if (vm.listaAcls) {
                $scope.listaAcls = vm.listaAcls;
                $scope.otherSites = $scope.banner.sites.filter(function (e) {
                    return $scope.listaAcls.indexOf(e) < 0 && ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) < 0;
                }).join(',');
                $scope.banner.sites = $scope.banner.sites.filter(function (e) {
                    return $scope.listaAcls.indexOf(e) >= 0 || ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) >= 0;
                });
            } else {
                quantionApi.getAcls('group').then(function (dataResponse) {
                    $scope.listaAcls = $filter('orderBy')(dataResponse.data);
                    vm.listaAcls = $scope.listaAcls;
                    $scope.otherSites = $scope.banner.sites.filter(function (e) {
                        return $scope.listaAcls.indexOf(e) < 0 && ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) < 0;
                    }).join(',');
                    $scope.banner.sites = $scope.banner.sites.filter(function (e) {
                        return $scope.listaAcls.indexOf(e) >= 0 || ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) >= 0;
                    });
                });
            }

            $scope.editSites = function () {
                $mdSidenav('right').open();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };
            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var banner_ = angular.copy($scope.banner);

                delete(banner_.name);

                if ($scope.toActionInputType) {
                    banner_.method = $scope.toActionAdv.method;
                    banner_.url = $scope.toActionAdv.url;
                    banner_.data = $scope.toActionAdv.data;
                } else {
                    banner_.method = 'POST';

                    switch ($scope.url) {
                        case 'browser':
                            banner_.url = methods['browser'];
                            banner_.data = angular.toJson({url: $scope.toActionBasic.data || ""});
                            break;
                        case 'href':
                            banner_.url = methods['href'];
                            banner_.data = angular.toJson({url: $scope.toActionBasic.data || ""});
                            break;
                        case 'store':
                            banner_.url = methods['store'];
                            banner_.data = angular.toJson({url: "/store" + ($scope.pack ? ('/package/' + $scope.pack) : '')});
                            break;
                    }
                }

                banner_.sites = $scope.banner.sites.concat($scope.otherSites.split(',').map(function (e) {
                    return e.trim();
                }).filter(function (e) {
                    return e.length > 0;
                }));

                var jsonObj = angular.toJson(banner_, true);

                quantionApi.updateBanner(jsonObj).then(function (dataResponse) {
                    $mdDialog.hide();
                    quantionApi.updateGrupoBanner(angular.toJson({idBannerGroup: group.idBannerGroup})).then(function (dataResponse) {
                        CargarGrupos();
//                        replaceBannerGroup(dataResponse.data);
                    });
                });
            };
        }

        function LinkLiteCtrl($scope, $mdDialog, $mdToast, banner, $mdSidenav, group) {
            $scope.banner = angular.copy(banner);

            $scope.banner.fechaini = $scope.banner.fechaini ? new Date($scope.banner.fechaini) : null;
            $scope.banner.fechafin = $scope.banner.fechafin ? new Date($scope.banner.fechafin) : null;
            $scope.banner.horaini = $scope.banner.horaini ? new Date($scope.banner.horaini) : null;
            $scope.banner.horafin = $scope.banner.horafin ? new Date($scope.banner.horafin) : null;

            $scope.toAction = {
                method: 'POST',
                url: 'https://wc.solertia.sol:8091/browser',
                data: isJSON(banner.data) ? angular.fromJson(banner.data).url : ""
            };

            if (vm.listaAcls) {
                $scope.listaAcls = vm.listaAcls;
                $scope.otherSites = $scope.banner.sites.filter(function (e) {
                    return $scope.listaAcls.indexOf(e) < 0 && ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) < 0;
                }).join(',');
                $scope.banner.sites = $scope.banner.sites.filter(function (e) {
                    return $scope.listaAcls.indexOf(e) >= 0 || ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) >= 0;
                });
            } else {
                quantionApi.getAcls('group').then(function (dataResponse) {
                    $scope.listaAcls = $filter('orderBy')(dataResponse.data);
                    vm.listaAcls = $scope.listaAcls;
                    $scope.otherSites = $scope.banner.sites.filter(function (e) {
                        return $scope.listaAcls.indexOf(e) < 0 && ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) < 0;
                    }).join(',');
                    $scope.banner.sites = $scope.banner.sites.filter(function (e) {
                        return $scope.listaAcls.indexOf(e) >= 0 || ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) >= 0;
                    });
                });
            }

            $scope.editSites = function () {
                $mdSidenav('right').open();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var banner_ = angular.copy($scope.banner);

                delete(banner_.name);

                banner_.method = $scope.toAction.method;
                banner_.url = $scope.toAction.url;
                banner_.data = angular.toJson({url: $scope.toAction.data || ""});

                banner_.sites = $scope.banner.sites.concat($scope.otherSites.split(',').map(function (e) {
                    return e.trim();
                }).filter(function (e) {
                    return e.length > 0;
                }));

                var jsonObj = angular.toJson(banner_, true);

                quantionApi.updateBanner(jsonObj).then(function (dataResponse) {
                    $mdDialog.hide();
                    quantionApi.updateGrupoBanner(angular.toJson({idBannerGroup: group.idBannerGroup})).then(function (dataResponse) {
                        CargarGrupos();
//                        replaceBannerGroup(dataResponse.data);
                    });
                });
            };
        }

        function isJSON(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                console.log('Error en formato de JSON');
                return false;
            }
            return true;
        }

        document.getElementById('files').addEventListener('change', cargarArchivo, false);

        function cargarArchivo(evt) {
            var files = evt.target.files;
            var file = files[0];
            if (!file)
                return;

            var aux = file.type.split('/');
            if ((aux[0] === "image" || aux[0] === "video") /*&& perteneceAExtension(aux[1], extensions)*/) {

                vm.file = file;

                var arr = vm.file.name.split(".");
                $scope.fileInfo = {
                    name: arr[0],
                    extension: arr[arr.length - 1]
                };

                if (aux[0] === "video") {
                    //****** Obtener información del archivo antes de subirlo ******
                    window.URL = window.URL || window.webkitURL;
                    var video = document.createElement('video');
                    video.preload = 'metadata';
                    video.onloadedmetadata = function () {
                        window.URL.revokeObjectURL(this.src);
                        $scope.fileInfo.duration = video.duration;
                    };
                    video.src = URL.createObjectURL(files[0]);
                    //**************************************************************
                }
            } else {
                vm.file = null;

                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('MISCONTENIDOS.FORMATONOVALIDO.TITLE'))
                        .textContent($filter('translate')('BANNERS.FORMATONOVALIDO.CONTENT'))
                        .ariaLabel('Formato incorrecto')
                        .ok($filter('translate')('MISCONTENIDOS.FORMATONOVALIDO.OK'))
                        );
            }
        }

        vm.enviarArchivo = function () {
            var formData = new FormData();
            var aux = $scope.fileInfo.name.replace(/ /g, "_") + "." + $scope.fileInfo.extension;

            formData.append('file', vm.file);

            pantallaCarga.lsEnable('LS.UPLOADING');
            quantionApi.uploadArchivoMediaPubli(formData, aux).then(function (dataResponse) {
                $mdToast.show($mdToast.simple().textContent($filter('translate')('MISCONTENIDOS.TOASTSUBIDA')).position('top right').hideDelay(3000));
                CargarListaArchivos();
            }, function () {
                pantallaCarga.lsDisable();
            });
        };

        $scope.checkName = function () {
            if (!$scope.fileInfo.name)
                return;

            var e = $scope.fileInfo.name.replace(/ /g, "_") + "." + $scope.fileInfo.extension;
            $scope.coincideNombre = vm.listaArchivos.map(function (e) {
                return e.name;
            }).indexOf(e) !== -1;
        };

        //************************** Grupos de banners ***********************************
        CargarGrupos();//Carga inicial
        function CargarGrupos() {
            pantallaCarga.lsEnable('LS.MULTIMEDIA');

            quantionApi.getGruposBanner().then(function (dataResponse) {
                vm.bannerGroupList = $filter('orderBy')(dataResponse.data, 'orden');

                pantallaCarga.lsDisable();
            }, function (dataResponse) {
                pantallaCarga.lsDisable();
            });
        }

        vm.eliminarGrupo = function (ev, grupo) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('GRUPOSSTB.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('GRUPOSSTB.MODALELIMINAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('GRUPOSSTB.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('GRUPOSSTB.MODALELIMINAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteGrupoBanner(grupo.idBannerGroup).then(function () {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTELIMINAR')).position('top right').hideDelay(3000));
                    CargarGrupos();
                });
            });
        };

        vm.ventanaNuevo = function (ev) {
            $mdDialog.show({
                controller: NuevoCtrl,
                templateUrl: 'app/main/Quantion/archivos/nombreRandom/templates/editarGrupo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function NuevoCtrl($scope, $mdDialog, $mdToast) {
            $scope.DialogTitle = $filter('translate')('GRUPOSSTB.CREAR.TITLE');

            $scope.grupo = {};

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var obj = angular.copy($scope.grupo);
                var jsonObj = angular.toJson(obj);

                quantionApi.addGrupoBanner(jsonObj).then(function (dataResponse) {
                    CargarGrupos();
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTCREAR')).position('top right').hideDelay(3000));
                    $mdDialog.hide();
                });
            };
        }

        vm.ventanaEditar = function (ev, grupo) {
            $mdDialog.show({
                controller: EditarCtrl,
                templateUrl: 'app/main/Quantion/archivos/nombreRandom/templates/editarGrupo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"grupo": grupo}
            });
        };

        function EditarCtrl($scope, $mdDialog, $mdToast, grupo) {
            $scope.DialogTitle = $filter('translate')('GRUPOSSTB.EDITAR.TITLE', {groupName: grupo.nombre});

            $scope.grupo = angular.copy(grupo);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;
                $scope.mensajeError = '';

                var obj = angular.copy($scope.grupo);
                var jsonObj = angular.toJson(obj);

                quantionApi.updateGrupoBanner(jsonObj).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTEDITADO')).position('top right').hideDelay(3000));
                    CargarGrupos();
//                    replaceBannerGroup(dataResponse.data);
                    $mdDialog.hide();
                }, function (dataResponse) {
                    $scope.dataLoading = false;
                    $scope.mensajeError = dataResponse.status;
                });
            };
        }

        vm.asignarStbAGrupo = function (ev, grupo) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/archivos/nombreRandom/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"grupo": grupo}
            });
        };

        function CargarStbs() {
            vm.listaGrupos = [];
            quantionApi.getStbs(true).then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;
                var map = {};
                $.each(vm.listaStbs, function (index, stb) {
                    map[stb.idStb] = stb;
                });

                quantionApi.getGrupos().then(function (dataResponse) {
                    vm.listaGrupos = dataResponse.data.map(function (elm) {
                        elm.cStbs = elm.stbs.map(function (elm2) {
                            return map[elm2];
                        });
                        return elm;
                    });
                    vm.listaGrupos.sort(function (a, b) {
                        return a.orden - b.orden;
                    });
                });
            });
        }
        CargarStbs();

        function AsignarStbCtrl($scope, $mdDialog, $mdToast, grupo) {
            $scope.DialogTitle = $filter('translate')('GRUPOSSTB.ASIGNARSTB.TITLE', {groupName: grupo.nombre});
            $scope.idBannerGroup = grupo.idBannerGroup;

            $scope.listaGrupos = angular.copy(vm.listaGrupos);
            $scope.grupo = angular.copy(grupo);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var jsonObj = angular.toJson($scope.grupo);

                quantionApi.updateGrupoBanner(jsonObj).then(function (dataResponse) {
                    CargarGrupos();
//                    replaceBannerGroup(dataResponse.data);
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('GRUPOSSTB.TOASTEDITADO')).position('top right').hideDelay(3000));
                    $mdDialog.hide();

                    CargarStbsSinGrupo();
                });
            };

            $scope.marcarGrupo = function (idGrupo, bool) {
                var gr = $scope.listaGrupos.filter(function (elm) {
                    return elm.idStbGroup === idGrupo;
                });

                if (gr.length > 0)
                    $.each(gr[0].cStbs, function (index, value) {
                        $scope.toggleWithValue(value.idStb, bool);
                    });
            };

            $scope.marcarTodo = function (bool) {
                $.each($scope.listaGrupos, function (i, gr) {
                    $.each(gr.cStbs, function (index, value) {
                        $scope.toggleWithValue(value.idStb, bool);
                    });
                });
            };

            $scope.toggle = function (item) {
                var idx = $scope.grupo.stbs.indexOf(item);
                if (idx > -1)
                    $scope.grupo.stbs.splice(idx, 1);
                else
                    $scope.grupo.stbs.push(item);
            };

            $scope.toggleWithValue = function (item, newValue) {
                var idx = $scope.grupo.stbs.indexOf(item);

                if (newValue === false && idx > -1)
                    $scope.grupo.stbs.splice(idx, 1);

                if (newValue === true && idx === -1)
                    $scope.grupo.stbs.push(item);
            };

            $scope.exists = function (item) {
                return $scope.grupo.stbs.indexOf(item) > -1;
            };
        }

        vm.asignarBanners = function (ev, grupo) {
            $mdDialog.show({
                controller: AsignarBannersCtrl,
                templateUrl: 'app/main/Quantion/archivos/nombreRandom/templates/asignarBanners.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"grupo": grupo}
            });
        };

        function AsignarBannersCtrl($scope, $mdDialog, $mdToast, grupo) {
            $scope.DialogTitle = $filter('translate')('GRUPOSSTB.ASIGNARBANNERS.TITLE', {groupName: grupo.nombre});

            $scope.listaArchivos = angular.copy(vm.listaArchivos);
            $scope.grupo = angular.copy(grupo);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                quantionApi.addBanner($scope.bannerObj).then(function (dataResponse) {
                    var o = {
                        idBannerGroup: $scope.grupo.idBannerGroup,
                        listbanner: $scope.grupo.listbanner.concat(dataResponse.data).map(function (elm) {
                            return elm.idBanner;
                        })
                    };

                    var jsonObj = angular.toJson(o);

                    quantionApi.updateGrupoBanner(jsonObj).then(function (dataResponse2) {
                        vm.setLink(dataResponse.data, null, grupo);
                        CargarGrupos();
//                        replaceBannerGroup(dataResponse.data);
                    }, function (dataResponse2) {
                        vm.setLink(dataResponse.data, null, grupo);
                        CargarGrupos();
                    });
                });
            };

            $scope.toggle = function (item, ev) {
                $scope.selectedFile = item;

                var d = $(ev.target).siblings('video')[0];

                var obj = {
                    "link": item.path,
                    "active": false,
                    "timeon": d ? d.duration : 10,
                    "type": d ? 'VIDEO' : 'IMG',
                    "data": "{}"
                };

                $scope.bannerObj = obj;
            };

            $scope.exists = function (item) {
                return $scope.selectedFile && item.path === $scope.selectedFile.path;
            };

            $scope.zoomImagen = function (elm) {
                window.open($filter('replacePath')(elm.path));
            };
        }

        vm.asignarBannerIframe = function (ev, grupo, banner) {
            $mdDialog.show({
                controller: AsignarBannerIframeCtrl,
                templateUrl: 'app/main/Quantion/archivos/nombreRandom/link_iframe.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {"grupo": grupo, "banner": banner}
            });
        };

        function AsignarBannerIframeCtrl($scope, $mdDialog, $mdToast, $mdSidenav, grupo, banner) {
            $scope.banner = angular.copy(banner) || {
                "link": "",
                "data": "{}",
                "active": false,
                "isMuted": true,
                "timeon": 10,
                "type": "IFRAME",
                "sites": [],
                "fechaini": null,
                "fechafin": null,
                "horaini": null,
                "horafin": null,
                "priority": 0
            };

            if (vm.listaAcls) {
                $scope.listaAcls = vm.listaAcls;
                $scope.otherSites = $scope.banner.sites.filter(function (e) {
                    return $scope.listaAcls.indexOf(e) < 0 && ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) < 0;
                }).join(',');
                $scope.banner.sites = $scope.banner.sites.filter(function (e) {
                    return $scope.listaAcls.indexOf(e) >= 0 || ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) >= 0;
                });
            } else {
                quantionApi.getAcls('group').then(function (dataResponse) {
                    $scope.listaAcls = $filter('orderBy')(dataResponse.data);
                    vm.listaAcls = $scope.listaAcls;
                    $scope.otherSites = $scope.banner.sites.filter(function (e) {
                        return $scope.listaAcls.indexOf(e) < 0 && ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) < 0;
                    }).join(',');
                    $scope.banner.sites = $scope.banner.sites.filter(function (e) {
                        return $scope.listaAcls.indexOf(e) >= 0 || ['home', 'digitalsignage', 'screensaver-left', 'screensaver-right'].indexOf(e) >= 0;
                    });
                });
            }

            $scope.editSites = function () {
                $mdSidenav('right').open();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.Guardar = function () {
                $scope.dataLoading = true;

                var banner_ = angular.copy($scope.banner);

                delete(banner_.name);

                banner_.sites = $scope.banner.sites.concat($scope.otherSites.split(',').map(function (e) {
                    return e.trim();
                }).filter(function (e) {
                    return e.length > 0;
                }));

                var jsonObj = angular.toJson(banner_, true);

                if (banner) {
                    quantionApi.updateBanner(jsonObj).then(function (dataResponse) {
                        CargarGrupos();
                        $mdDialog.hide();
                    });
                } else {
                    quantionApi.addBanner(jsonObj).then(function (dataResponse) {
                        var o = {
                            idBannerGroup: grupo.idBannerGroup,
                            listbanner: grupo.listbanner.concat(dataResponse.data).map(function (elm) {
                                return elm.idBanner;
                            })
                        };

                        var jsonObj = angular.toJson(o);

                        quantionApi.updateGrupoBanner(jsonObj).then(function (dataResponse2) {
                            CargarGrupos();
                            $mdDialog.hide();
                        }, function (dataResponse2) {
                            CargarGrupos();
                            $mdDialog.hide();
                        });
                    });
                }
            };
        }

        vm.notificarEquipos = function (ev, grupo) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('BANNERS.MODALNOTIFICAR.TITLE'))
                    .textContent($filter('translate')('BANNERS.MODALNOTIFICAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('BANNERS.MODALNOTIFICAR.OK'))
                    .cancel($filter('translate')('BANNERS.MODALNOTIFICAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                quantionApi.notifyGrupoBanner(grupo.idBannerGroup).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('BANNERS.TOASTNOTIFICAR')).position('top right').hideDelay(3000));
                    CargarGrupos();
//                    replaceBannerGroup(dataResponse.data);
                });
            });
        };

        CargarStbsSinGrupo();
        function CargarStbsSinGrupo() {
            quantionApi.getStbSinGrupo().then(function (dataResponse) {
                var lista = $filter('orderBy')(dataResponse.data.map(function (e) {
                    return $filter('tryParseInt')(e.room);
                }));

                $('#sin-grupo-container').empty();

                $.each(lista, function (index, value) {
                    $('#sin-grupo-container').append('<span class="md-warn-bg">' + value + '</span>');
                });
            });
        }

        vm.ventanaAyuda = function (ev) {
            $mdDialog.show({
                templateUrl: 'app/main/Quantion/archivos/nombreRandom/templates/help.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                controller: function ($scope, $mdDialog) {
                    $scope.hide = function () {
                        $mdDialog.hide();
                    };
                }
            });
        };

        function replaceBannerGroup(bannerGroup) {
            var idx = vm.bannerGroupList.findIndex(function (el) {
                return el.idBannerGroup === bannerGroup.idBannerGroup;
            });
            vm.bannerGroupList[idx] = bannerGroup;
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.documentExplorer', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_archivos_documentExplorer', {
            url: '/archivos/documentExplorer',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/archivos/documentExplorer/documentExplorer.html',
                    controller: 'documentExplorerController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/archivos/documentExplorer');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.documentExplorer')
            .controller('documentExplorerController', documentExplorerController);

    /** @ngInject */
    function documentExplorerController($scope, quantionApi, $mdDialog, $mdToast, JSONconfig, $filter, $rootScope)
    {
        var vm = this;
        $rootScope.seccion = 'ARCHIVOS_DOCUMENTEXPLORER';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        CargarMedia('Documents');//Carga inicial
        function CargarMedia(folder) {
            pantallaCarga.lsEnable('LS.MULTIMEDIA');

            quantionApi.getGenericFiles(folder).then(function (dataResponse) {
                $scope.actualPath = folder || "";

                $scope.listaArchivos = dataResponse.data.files.map(function (e) {
                    var re = new RegExp(JSONconfig.logosPath.from + '[/]+', "g");
                    e.path = e.path.replace(re, JSONconfig.logosPath.from + "/");

                    e.relPath = e.path.replace(JSONconfig.logosPath.from + '/', '');
                    if (e.file)
                        e.extension = e.name.split('.').pop();

                    return e;
                });

                $scope.listaArchivos.sort(function (a, b) {
                    var aa = +!b.file;
                    var bb = +!a.file;
                    if (aa === bb) {
                        return a.path.localeCompare(b.path);
                    } else {
                        return aa - bb;
                    }
                });

                pantallaCarga.lsDisable();
            }, function (dataResponse) {
                $scope.actualPath = folder ? folder.replace(/[/]+/, "/") : '';
                $scope.listaArchivos = [];
                pantallaCarga.lsDisable();
                console.log(dataResponse)

                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('DOCUMENTEXPLORER.NOFOLDER.TITLE'))
                        .textContent($filter('translate')('DOCUMENTEXPLORER.NOFOLDER.CONTENT'))
                        .ariaLabel('Formato incorrecto')
                        .ok($filter('translate')('DOCUMENTEXPLORER.NOFOLDER.OK'))
                        );
            });
        }

        $scope.openFolder = function (file) {
            if (!file.file) {
                CargarMedia(file.relPath);
            } else {
                window.open($filter('replacePath')(file.path));
            }
        };

        $scope.goBack = function () {
            if (!$scope.actualPath || $scope.actualPath === 'Documents')
                return;

            var back = $scope.actualPath.split('/');
            back.pop();
            var path = back.join('/');
            CargarMedia(path);
        };

        $scope.download = function (file) {
            var a = $('#hiddenLink');
            a[0].href = $filter('replacePath')(file.path);
            a[0].click();
        };

        $scope.eliminar = function (file) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('FILEEXPLORER.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('FILEEXPLORER.MODALELIMINAR.CONTENT'))
                    .ok($filter('translate')('FILEEXPLORER.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('FILEEXPLORER.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteGenericFile(file.name, $scope.actualPath).then(function (dataResponse) {
                    CargarMedia($scope.actualPath);
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            });
        };

        $scope.eliminarCarpeta = function (file) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('FILEEXPLORER.MODALELIMINAR.TITLE2'))
                    .textContent($filter('translate')('FILEEXPLORER.MODALELIMINAR.CONTENT2'))
                    .ok($filter('translate')('FILEEXPLORER.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('FILEEXPLORER.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteFolder(file.name, $scope.actualPath).then(function (dataResponse) {
                    CargarMedia($scope.actualPath);
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            });
        };

        document.getElementById('uploadFile').addEventListener('change', cargarArchivo, false);

        function cargarArchivo(evt) {
            var files = evt.target.files;
            if (files.length < 1)
                return;

            var cont = files.length;

            $.each(files, function (index, file) {
                var formData = new FormData();
                formData.append('file', file);

                quantionApi.uploadGenericFile(formData, file.name, $scope.actualPath).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTSUBIDA')).position('top right').hideDelay(3000));

                    if (--cont <= 0) {
                        CargarMedia($scope.actualPath);
                    }
                }, function () {
                    if (--cont <= 0) {
                        CargarMedia($scope.actualPath);
                    }
                });

            });
        }

        $scope.upload = function () {
            $('#uploadFile').click();
        };

        $scope.newFolder = function (actualPath, ev) {
            $mdDialog.show({
                controller: FolderCtrl,
                templateUrl: 'app/main/Quantion/archivos/documentExplorer/newFolder.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {actualPath: actualPath}
            });
        };

        function FolderCtrl($scope, $mdDialog, $mdToast, actualPath) {
            $scope.guardar = function (name) {
                quantionApi.createFolder(actualPath || '/', name).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTCARPETA')).position('top right').hideDelay(3000));
                    CargarMedia(actualPath);
                    $mdDialog.hide();
                });
            };
        }

        $scope.getIconFromExtension = function (file) {
            var extensions = {
                css: '/assets/quantionImagenes/FileExplorer/code.png',
                js: '/assets/quantionImagenes/FileExplorer/code.png',
                html: '/assets/quantionImagenes/FileExplorer/code.png',

                png: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                jpg: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                gif: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                jpeg: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                svg: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',

                mp4: '/assets/quantionImagenes/FileExplorer/video.png',
                mkv: '/assets/quantionImagenes/FileExplorer/video.png',
                avi: '/assets/quantionImagenes/FileExplorer/video.png',
                mov: '/assets/quantionImagenes/FileExplorer/video.png',

                txt: '/assets/quantionImagenes/FileExplorer/document.png',
                doc: '/assets/quantionImagenes/FileExplorer/document.png',
                md: '/assets/quantionImagenes/FileExplorer/document.png',

                zip: '/assets/quantionImagenes/FileExplorer/zip.png',
                rar: '/assets/quantionImagenes/FileExplorer/zip.png',
                tar: '/assets/quantionImagenes/FileExplorer/zip.png',
                gz: '/assets/quantionImagenes/FileExplorer/zip.png',

                mp3: '/assets/quantionImagenes/FileExplorer/audio.png',
                ogg: '/assets/quantionImagenes/FileExplorer/audio.png'
            };

            return extensions[file.extension.toLowerCase()] || "/assets/quantionImagenes/FileExplorer/file.png";
        };

        $scope.toggleGrid = function () {
            $scope.grid = !$scope.grid;
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.fileExplorer', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_archivos_fileExplorer', {
            url: '/archivos/fileExplorer',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/archivos/fileExplorer/fileExplorer.html',
                    controller: 'fileExplorerController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/archivos/fileExplorer');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.archivos.fileExplorer')
            .controller('fileExplorerController', fileExplorerController);

    /** @ngInject */
    function fileExplorerController($scope, quantionApi, $mdDialog, $mdToast, JSONconfig, $filter, $rootScope)
    {
        var vm = this;
        $rootScope.seccion = 'ARCHIVOS_FILEEXPLORER';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        CargarMedia();//Carga inicial
        function CargarMedia(folder) {
            pantallaCarga.lsEnable('LS.MULTIMEDIA');

            quantionApi.getGenericFiles(folder).then(function (dataResponse) {
                $scope.actualPath = folder || "";

                $scope.listaArchivos = dataResponse.data.files.map(function (e) {
                    var re = new RegExp(JSONconfig.logosPath.from + '[/]+', "g");
                    e.path = e.path.replace(re, JSONconfig.logosPath.from + "/");

                    e.relPath = e.path.replace(JSONconfig.logosPath.from + '/', '');
                    if (e.file)
                        e.extension = e.name.split('.').pop();

                    return e;
                });

                $scope.listaArchivos.sort(function (a, b) {
                    var aa = +!b.file;
                    var bb = +!a.file;
                    if (aa === bb) {
                        return a.path.localeCompare(b.path);
                    } else {
                        return aa - bb;
                    }
                });

                pantallaCarga.lsDisable();
            }, function (dataResponse) {
                $scope.actualPath = folder ? folder.replace(/[/]+/, "/") : '';
                $scope.listaArchivos = [];
                pantallaCarga.lsDisable();
            });
        }

        $scope.openFolder = function (file) {
            if (!file.file) {
                CargarMedia(file.relPath);
            } else {
                window.open($filter('replacePath')(file.path));
            }
        };

        $scope.goBack = function () {
            if (!$scope.actualPath)
                return;

            var back = $scope.actualPath.split('/');
            back.pop();
            var path = back.join('/');
            CargarMedia(path);
        };

        $scope.download = function (file) {
            var a = $('#hiddenLink');
            a[0].href = $filter('replacePath')(file.path);
            a[0].click();
        };

        $scope.eliminar = function (file) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('FILEEXPLORER.MODALELIMINAR.TITLE'))
                    .textContent($filter('translate')('FILEEXPLORER.MODALELIMINAR.CONTENT'))
                    .ok($filter('translate')('FILEEXPLORER.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('FILEEXPLORER.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteGenericFile(file.name, $scope.actualPath).then(function (dataResponse) {
                    CargarMedia($scope.actualPath);
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            });
        };

        $scope.eliminarCarpeta = function (file) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('FILEEXPLORER.MODALELIMINAR.TITLE2'))
                    .textContent($filter('translate')('FILEEXPLORER.MODALELIMINAR.CONTENT2'))
                    .ok($filter('translate')('FILEEXPLORER.MODALELIMINAR.OK'))
                    .cancel($filter('translate')('FILEEXPLORER.MODALELIMINAR.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteFolder(file.name, $scope.actualPath).then(function (dataResponse) {
                    CargarMedia($scope.actualPath);
                }, function (dataResponse) {
                    console.error(dataResponse);
                });
            });
        };

        document.getElementById('uploadFile').addEventListener('change', cargarArchivo, false);

        function cargarArchivo(evt) {
            var files = evt.target.files;
            if (files.length < 1)
                return;

            var cont = files.length;

            $.each(files, function (index, file) {
                var formData = new FormData();
                formData.append('file', file);

                quantionApi.uploadGenericFile(formData, file.name, $scope.actualPath).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTSUBIDA')).position('top right').hideDelay(3000));

                    if (--cont <= 0) {
                        CargarMedia($scope.actualPath);
                    }
                }, function () {
                    if (--cont <= 0) {
                        CargarMedia($scope.actualPath);
                    }
                });

            });
        }

        $scope.upload = function () {
            $('#uploadFile').click();
        };

        $scope.newFolder = function (actualPath, ev) {
            $mdDialog.show({
                controller: FolderCtrl,
                templateUrl: 'app/main/Quantion/archivos/fileExplorer/newFolder.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {actualPath: actualPath}
            });
        };

        function FolderCtrl($scope, $mdDialog, $mdToast, actualPath) {
            $scope.guardar = function (name) {
                quantionApi.createFolder(actualPath || '/', name).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('FILEEXPLORER.TOASTCARPETA')).position('top right').hideDelay(3000));
                    CargarMedia(actualPath);
                    $mdDialog.hide();
                });
            };
        }

        $scope.getIconFromExtension = function (file) {
            var extensions = {
                css: '/assets/quantionImagenes/FileExplorer/code.png',
                js: '/assets/quantionImagenes/FileExplorer/code.png',
                html: '/assets/quantionImagenes/FileExplorer/code.png',

                png: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                jpg: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                gif: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                jpeg: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',
                svg: $filter('replacePath')(file.path), //'/assets/quantionImagenes/FileExplorer/image.png',

                mp4: '/assets/quantionImagenes/FileExplorer/video.png',
                mkv: '/assets/quantionImagenes/FileExplorer/video.png',
                avi: '/assets/quantionImagenes/FileExplorer/video.png',
                mov: '/assets/quantionImagenes/FileExplorer/video.png',

                txt: '/assets/quantionImagenes/FileExplorer/document.png',
                doc: '/assets/quantionImagenes/FileExplorer/document.png',
                md: '/assets/quantionImagenes/FileExplorer/document.png',

                zip: '/assets/quantionImagenes/FileExplorer/zip.png',
                rar: '/assets/quantionImagenes/FileExplorer/zip.png',
                tar: '/assets/quantionImagenes/FileExplorer/zip.png',
                gz: '/assets/quantionImagenes/FileExplorer/zip.png',

                mp3: '/assets/quantionImagenes/FileExplorer/audio.png',
                ogg: '/assets/quantionImagenes/FileExplorer/audio.png'
            };

            return extensions[file.extension.toLowerCase()] || "/assets/quantionImagenes/FileExplorer/file.png";
        };

        $scope.toggleGrid = function () {
            $scope.grid = !$scope.grid;
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.wifiAdm', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_wifiAdm', {
            url: '/wifiAdm',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/wifiAdm/listado.html',
                    controller: 'listadoWifiController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/wifiAdm');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.wifiAdm')
            .controller('listadoWifiController', listadoWifiController);

    /** @ngInject */
    function listadoWifiController($scope, quantionApi, $mdDialog, $translate, $rootScope, $filter, JSONconfig)
    {
        'use strict';

        var vm = this;
        $rootScope.seccion = 'WIFI';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();
        $scope.JSONconfig = JSONconfig;

        $scope.$on('onRepeatLast', function () {
            pantallaCarga.lsDisable();
        });

        CargarStbs();
        function CargarStbs() {
            pantallaCarga.lsEnable('LS.DATOSVOIP');

            quantionApi.getStbs().then(function (dataResponse) {
                vm.listaStbs = JSONconfig.sistemaDePago ? dataResponse.data.map(function (e) {
                    e.hasWifiService = e.wallet.services.filter(function (e) {
                        return e.type === 'wifi';
                    }).length > 0;
                    return e;
                }) : dataResponse.data;

                var mapIDs = {};
                $.each(vm.listaStbs, function (index, value) {
                    mapIDs[value.idStb] = value;
                });
                vm.mapIDs = mapIDs;

                quantionApi.getGrupos().then(function (dataResponse) {
                    $scope.listaGrupos = dataResponse.data;
                    $scope.listaGrupos.sort(function (a, b) {
                        return a.orden - b.orden;
                    });
                    pantallaCarga.lsDisable();
                });
            }, function () {
                pantallaCarga.lsDisable();
            });
        }

        $scope.getAllDispositivos = function (grupo) {
            if (grupo.stbs.length > 0)
                pantallaCarga.lsEnable('LS.DATOSVOIP');

            $scope.stbs = [];
            $scope.totalDispositivos = 0;
            $scope.loading = (grupo.stbs.length > 0);
            $.each(grupo.stbs, function (index, value) {
                var o = vm.mapIDs[value];
                if (o)
                    quantionApi.getDispositivosConectados(o.ip, o.properties.wifiPassword).then(function (dataResponse) {
                        o.dispositivos = angular.isArray(dataResponse.data) ? dataResponse.data : [];
                        $scope.totalDispositivos += o.dispositivos.length;
                        $scope.stbs.push(o);
                        $scope.loading = $scope.stbs.length < grupo.stbs.length;
                    }, function () {
                        $scope.stbs.push(o);
                        $scope.loading = $scope.stbs.length < grupo.stbs.length;
                    });
            });
        };

        vm.confirmarCambioClave = function (ev, hab) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('WIFIADM.CAMBIAR.TITLE'))
                    .textContent($filter('translate')('WIFIADM.CAMBIAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('WIFIADM.CAMBIAR.OK'))
                    .cancel($filter('translate')('WIFIADM.CAMBIAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                console.log("Cambiada la clave del cliente " + hab.username);

                quantionApi.createOrUpdateWifiPassword(hab.idStb).then(function (dataResponse) {
                    console.log(dataResponse);
                    vm.CargarStbs();
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.CargarStbs();
                });
            }, function () {
            });
        };

        vm.confirmarGenerarClave = function (ev, hab) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('WIFIADM.GENERAR.TITLE'))
                    .textContent($filter('translate')('WIFIADM.GENERAR.CONTENT'))
                    .targetEvent(ev)
                    .ok($filter('translate')('WIFIADM.GENERAR.OK'))
                    .cancel($filter('translate')('WIFIADM.GENERAR.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                console.log("Generada la clave del cliente " + hab.username);

                quantionApi.createOrUpdateWifiPassword(hab.idStb).then(function (dataResponse) {
                    console.log(dataResponse);
                    vm.CargarStbs();
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.CargarStbs();
                });
            }, function () {
            });
        };

        vm.verDispositivosConectados = function (hab) {
            $mdDialog.show({
                controller: function ($scope) {
                    $scope.data = hab.dispositivos;
                    $scope.noHay = !$scope.data || $scope.data.length < 1;
                },
                templateUrl: 'app/main/Quantion/wifiAdm/dispositivos.tmpl.html',
                clickOutsideToClose: true
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.usuarios', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_usuarios', {
            url: '/usuarios',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/usuarios/usuarios.html',
                    controller: 'usuariosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/usuarios');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.usuarios')
            .controller('usuariosController', usuariosController);

    /** @ngInject */
    function usuariosController(quantionApi, $mdDialog, $mdToast, $rootScope, $scope, RoleService, $filter)
    {
        var vm = this;
        $rootScope.seccion = 'USUARIOS';

        var rolePriority = {
            'BASE': 0,
            'ADMINISTRATOR': 1,
            'INSTALLER': 2,
            'ROOT': 3
        };

        CargarUsuarios();
        function CargarUsuarios() {
            vm.usuarios = [];

            quantionApi.getUsuarios().then(function (dataResponse) {
                vm.usuarios = dataResponse.data;
                vm.usuarios.sort(function (a, b) {//Compara por rol, y si son iguales, por nombre
                    if (rolePriority[a.userRole] < rolePriority[b.userRole])
                        return 1;
                    if (rolePriority[a.userRole] > rolePriority[b.userRole])
                        return -1;
                    return a.name.localeCompare(b.name);
                });

                if ($rootScope.user.userRole !== 'ROOT')
                    //si es ROOT se muestran todos los usuarios, si no, salen los de rango menor al actual
                    vm.usuarios = vm.usuarios.filter(function (usuario) {
                        return rolePriority[usuario.userRole] < rolePriority[$rootScope.user.userRole];
                    });
            });
        }

//        quantionApi.getIdiomas().then(function (dataResponse) {
//            vm.listaIdiomas = dataResponse.data;
//        });

//        vm.eliminarUsuario = function (ev, user) {
//            var confirm = $mdDialog.confirm()
//                    .title($filter('translate')('USUARIOS.MODALELIMINAR.TITLE'))
//                    .textContent($filter('translate')('USUARIOS.MODALELIMINAR.CONTENT'))
//                    .targetEvent(ev)
//                    .ok($filter('translate')('USUARIOS.MODALELIMINAR.OK'))
//                    .cancel($filter('translate')('USUARIOS.MODALELIMINAR.CANCEL'));
//            $mdDialog.show(confirm).then(function () {
//                if (user.name !== $rootScope.user.name) {
//                    quantionApi.deleteUsuario(user.idUser).then(function (dataResponse) {
//                        CargarUsuarios();
//
//                        $mdToast.show(
//                                $mdToast.simple()
//                                .textContent($filter('translate')('USUARIOS.TOASTELIMINAR'))
//                                .position('top right')
//                                .hideDelay(3000)
//                                );
//                    }, function (dataResponse) {
//                        $mdDialog.show(
//                                $mdDialog.alert()
//                                .clickOutsideToClose(true)
//                                .title($filter('translate')('USUARIOS.ERRORELIMINAR.TITLE'))
//                                .textContent($filter('translate')('USUARIOS.ERRORELIMINAR.CONTENT'))
//                                .ariaLabel('Error eliminar usuario')
//                                .ok($filter('translate')('USUARIOS.ERRORELIMINAR.OK'))
//                                );
//                    });
//                } else {
//                    $mdDialog.show(
//                            $mdDialog.alert()
//                            .clickOutsideToClose(true)
//                            .title($filter('translate')('USUARIOS.ERRORPROPIO.TITLE'))
//                            .ok($filter('translate')('USUARIOS.ERRORPROPIO.OK'))
//                            );
//                }
//            });
//        };

//        vm.nuevoUsuario = function (ev) {
//            $mdDialog.show({
//                controller: NuevoCtrl,
//                templateUrl: 'app/main/Quantion/usuarios/crearusuario.tmpl.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose: true
//            });
//        };

//        function NuevoCtrl($scope, $mdDialog, $mdToast) {
//            $scope.DialogTitle = "USUARIOS.CREAR.TITLE";
//            $scope.listaIdiomas = vm.listaIdiomas;
//            $scope.listaRoles = ['ADMINISTRATOR', 'INSTALLER', 'BASE'];
//            $scope.creating = true;
//            $scope.changePass = true;
//
//            $scope.passObj = {};
//
//            $scope.user = {
//                language: 'es',
//                userRole: $scope.listaRoles[2]
//            };
//
//            $scope.hide = function () {
//                $mdDialog.hide();
//            };
//            $scope.cancel = function () {
//                $mdDialog.cancel();
//            };
//
//            $scope.guardar = function () {
//                if ($scope.passObj.newPass !== $scope.passObj.newPass2) {
//                    $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.PASSCOINCIDE');
//                    return;
//                }
//                $scope.dataLoading = true;
//                $scope.mensajeError = "";
//
//                $scope.user.mapRole = angular.toJson($scope.user.mapRole);
//                $scope.user.password = $scope.passObj.newPass;
//
//                var jsonObj = angular.toJson($scope.user, 0);
//                console.info(jsonObj);
//
//                quantionApi.addUsuario(jsonObj).then(function (dataResponse) {
//                    $mdToast.show($mdToast.simple().textContent($filter('translate')('USUARIOS.TOASTCREAR')).position('top right').hideDelay(3000));
////                    console.log(dataResponse.data);
//                    CargarUsuarios();
//                    $scope.hide();
//                }, function (dataResponse) {
//                    if (dataResponse.status === 409)
//                        $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.USUARIOEXISTE', {name: $scope.user.name});
//                    else
//                        $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.ERRORCREAR');
//                    $scope.dataLoading = false;
//                });
//            };
//
//            $scope.showRoleRadio = function (role) {
//                return rolePriority[role] < rolePriority[$rootScope.user.userRole];
//            };
//        }

//        vm.editarUsuario = function (ev, usuario) {
//            $mdDialog.show({
//                controller: EditarCtrl,
//                templateUrl: 'app/main/Quantion/usuarios/crearusuario.tmpl.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose: true,
//                locals: {
//                    usuario: usuario
//                }
//            });
//        };

//        function EditarCtrl($scope, $mdDialog, $mdToast, usuario) {
//            $scope.DialogTitle = "USUARIOS.EDITARUSUARIO.TITLE";
//            $scope.listaIdiomas = vm.listaIdiomas;
//            $scope.listaRoles = ['ADMINISTRATOR', 'INSTALLER', 'BASE'];
//            $scope.creating = false;
//            $scope.changePass = false;
//            $scope.passObj = {};
//
//            $scope.user = angular.copy(usuario);
//
//            $scope.hide = function () {
//                $mdDialog.hide();
//            };
//            $scope.cancel = function () {
//                $mdDialog.cancel();
//            };
//
//            $scope.guardar = function () {
//                if ($scope.passObj.newPass !== $scope.passObj.newPass2) {
//                    $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.PASSCOINCIDE');
//                    return;
//                }
//
//                $scope.dataLoading = true;
//                $scope.mensajeError = "";
//
//                var obj = {};//Obtiene solo los campos que han cambiado
//                $.each($scope.user, function (key, value) {
//                    if (angular.toJson(value) !== angular.toJson(usuario[key])) {
//                        obj[key] = (key === 'mapRole') ? angular.toJson(value) : value;
//                    }
//                });
//
//                var jsonObj = angular.toJson(obj, 0);
////                console.info(jsonObj);
//
//                quantionApi.updateUsuario(usuario.idUser, jsonObj).then(function (dataResponse) {
//
//                    if ($scope.changePass) {
//                        quantionApi.updatePasswordUsuario(usuario.idUser, $scope.passObj.oldPass, $scope.passObj.newPass).then(function (dataResponse) {
//                            $mdToast.show($mdToast.simple().textContent($filter('translate')('USUARIOS.TOASTEDITAR')).position('top right').hideDelay(3000));
//
//                            if (RoleService.getUserStored().idUser === dataResponse.data.idUser)
//                                RoleService.setUserStored(dataResponse.data);
//
//                            if ($rootScope.user.idUser === dataResponse.data.idUser)
//                                $rootScope.user = dataResponse.data;
//
//                            CargarUsuarios();
//                            $scope.hide();
//                        }, function () {
//                            $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.CAMBIOPASS');
//                            $scope.dataLoading = false;
//                        });
//                    } else {
//                        $mdToast.show($mdToast.simple().textContent($filter('translate')('USUARIOS.TOASTEDITAR')).position('top right').hideDelay(3000));
//
//                        if (RoleService.getUserStored().idUser === dataResponse.data.idUser)
//                            RoleService.setUserStored(dataResponse.data);
//
//                        if ($rootScope.user.idUser === dataResponse.data.idUser)
//                            $rootScope.user = dataResponse.data;
//
//                        CargarUsuarios();
//                        $scope.hide();
//                    }
//
//                }, function (dataResponse) {
//                    if (dataResponse.status === 409)
//                        $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.USUARIOEXISTE', {name: $scope.user.name});
//                    else
//                        $scope.mensajeError = $filter('translate')('USUARIOS.ERROR.ERROREDITAR');
//                    $scope.dataLoading = false;
//                });
//            };
//
//            $scope.showRoleRadio = function (role) {
//                return rolePriority[role] < rolePriority[$rootScope.user.userRole];
//            };
//
//            $scope.change = function () {
//                $scope.changePass = !$scope.changePass;
//            };
//        }

//        vm.permisosUsuario = function (ev, usuario) {
//            $mdDialog.show({
//                controller: PermisosCtrl,
//                templateUrl: 'app/main/Quantion/usuarios/permisos.tmpl.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose: true,
//                locals: {
//                    usuario: usuario
//                }
//            });
//        };

//        function PermisosCtrl($scope, $mdDialog, $mdToast, usuario, RoleService) {
//            $scope.DialogTitle = 'USUARIOS.PERMISOS.TITLE';
//
//            $scope.user = angular.copy(usuario);
//
//            $scope.allRoutes = RoleService.getRoutes();
//            $scope.allNodes = RoleService.getAllNodes();
//            console.log($scope.allNodes)
//
//            $scope.allActions = ['EDIT_STB', 'CREATE_STB', 'EDIT_IPTV_CHANNELS'];
//
//            if (!$scope.user.mapRole) {
//                $scope.user.mapRole = {routes: []};
//            }
//            if (!$scope.user.mapRole.routes || !angular.isArray($scope.user.mapRole.routes)) {
//                $scope.user.mapRole.routes = [];
//            }
//            if (!$scope.user.mapRole.nodes) {
//                $scope.user.mapRole.nodes = [];
//            }
//
//            if (!$scope.user.mapRole.actions || angular.isArray($scope.user.mapRole.actions)) {
//                $scope.user.mapRole.actions = {};
//            }
//
//            $scope.hide = function () {
//                $mdDialog.hide();
//            };
//
//            $scope.checkedRoute = function (route) {
//                return $scope.user.mapRole.routes.indexOf(route) !== -1;
//            };
//
//            $scope.toggleRoute = function (route) {
//                var index = $scope.user.mapRole.routes.indexOf(route);
//
//                if (index !== -1) {
//                    $scope.user.mapRole.routes.splice(index, 1);
//                } else {
//                    $scope.user.mapRole.routes.push(route);
//                }
//            };
//
//            $scope.checkedNode = function (node) {
//                return $scope.user.mapRole.nodes.indexOf(node) !== -1;
//            };
//
//            $scope.toggleNode = function (node) {
//                var index = $scope.user.mapRole.nodes.indexOf(node);
//
//                if (index !== -1) {
//                    $scope.user.mapRole.nodes.splice(index, 1);
//                } else {
//                    $scope.user.mapRole.nodes.push(node);
//                }
//            };
//
//            $scope.checkedAction = function (action) {
//                return $scope.user.mapRole.actions[action];
//            };
//
//            $scope.toggleAction = function (action) {
//                var index = $scope.user.mapRole.actions[action];
//
//                if (index) {
//                    delete $scope.user.mapRole.actions[action];
//                } else {
//                    $scope.user.mapRole.actions[action] = true;
//                }
//            };
//
//            $scope.guardar = function () {
//                var obj = angular.copy($scope.user);
//
//                console.log(usuario.idUser, obj);
//
//                quantionApi.updateUsuario(usuario.idUser, angular.toJson({
//                    mapRole: angular.toJson(obj.mapRole)
//                })).then(function (dataResponse) {
//                    if (RoleService.getUserStored().idUser === dataResponse.data.idUser)
//                        RoleService.setUserStored(dataResponse.data);
//
//                    if ($rootScope.user.idUser === dataResponse.data.idUser)
//                        $rootScope.user = dataResponse.data;
//
//                    $mdDialog.hide();
//                    CargarUsuarios();
//                });
//            };
//        }

        quantionApi.getHistorialLogin({max: 50}).then(function (dataResponse) {
            vm.listaLogin = dataResponse.data;
        });
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.principal', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_principal', {
            url: '/',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/principal/principal.html',
                    controller: 'PrincipalController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/principal');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.principal')
            .controller('PrincipalController', PrincipalController);

    /** @ngInject */
    function PrincipalController($scope, quantionApi, $mdSidenav, $mdDialog, $rootScope, $mdToast, JSONconfig, $filter, $translate, $compile, messagesApi, dirayaApi, incidencesStateService, IncidencesConfig, $state)
    {
        var vm = this;

        $scope.JSONconfig = JSONconfig;
        $scope.incidencesCardCtrl = incidencesStateService.createCardCtrl($state, IncidencesConfig.urlGestor);

        $scope.openIncidencesPanel = function (tab) {
            $mdSidenav('quick-panel').open();
            $rootScope.$broadcast('openIncidencesPanel', {tab: tab});
            incidencesStateService.refresh();
        };

        $rootScope.seccion = 'PRINCIPAL';

        //********************************************* Busqueda *************************************************
        vm.querySearch = querySearch;
        vm.stbsFiltradosPorGrupo = {}; // key:nombre del grupo, value: array con los stbs de ese grupo

        $scope.filtroWidgets = [];

        $scope.userRoleGroups = ($rootScope.user && $rootScope.user.mapRole && $rootScope.user.mapRole.stbgroups) || [];

        //Métodos de búsqueda
        function querySearch(query) {
            var results = query ? $scope.listaStbs.filter(filtrarHabs(query)) : $scope.listaStbs;
            return results;
        }

        function filtrarHabs(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function (usuario) {
                return (angular.lowercase(usuario.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(usuario.username).indexOf(lowercaseQuery) !== -1);
            };
        }

        vm.searchText = localStorage['search'] || '';
        $scope.saveSearchText = function () {
            localStorage['search'] = vm.searchText;

            appendHTMLstbList();
            appendHTMLgroup($scope.selectedGroup);
        };

        $scope.$on('onRepeatLast', function () {
            $scope.listLoading = false;
        });

        //******************************** Widget 2: Usuarios conectados*********************************************
        setTimeout(function () {
            CargarStbs();//Carga inicial
        }, 500);

        function CargarStbs() {
            $scope.listLoading = true;

            quantionApi.getStbs(true, true).then(function (dataResponse) {
                $scope.listaStbs = $filter('orderBy')(dataResponse.data, 'room|tryParseInt');
                vm.mapaPorId = {};

                $.each($scope.listaStbs, function (index, value) {
                    vm.mapaPorId[value.idStb] = value;
                });

                quantionApi.getStatusAll(true).then(function (dataResponse) {
                    var mapaStatPorMac = {};
                    $.each(dataResponse.data, function (index, val) {
                        mapaStatPorMac[val.macStb.toLowerCase()] = val;
                    });

                    $.each($scope.listaStbs, function (index, val) {
                        var aux = mapaStatPorMac[val.mac.toLowerCase()];
                        if (aux) {
                            val.status = {
                                ultConexion: aux.ultConexion,
                                currentScreen: $filter('translateStat')(aux.currentScreen),
                                currentInfo: aux.currentInfo || "null",
                                currentShadow: aux.currentShadow || "null",
                                currentStatus: aux.currentStatus,
//                                active: aux.active ? 'Activo' : 'Inactivo'
                                "buscandoAp": aux.currentShadow.indexOf('CONNECT-SOL') !== -1
                            };
                            if (aux.active)
                                val.status.active = 'Activo';
                            else if (JSONconfig.mostrarEstadoNaranja && !aux.active && aux.currentScreen === 'OFF')
                                val.status.active = 'Boton';
                            else
                                val.status.active = 'Inactivo';
                        } else {
                            val.status = {
                                currentScreen: $filter('translate')('PRINCIPAL.SCREENNAMES.SINESTADISTICAS'),
                                currentInfo: "null",
                                currentShadow: "null",
                                active: 'Desconocido'
                            };
                        }
                    });

                    appendHTMLstbList();
                    ListaDeHabsYMacsExistentes($scope.listaStbs);
                    OrganizarSTBsPorGrupo();
                });

                quantionApi.getIdiomas().then(function (dataResponse) {
                    vm.idiomas = dataResponse.data;
//                    vm.widgetIdiomaUsuarios.refresh();
                });

                quantionApi.getInstalaciones(true).then(function (dataResponse) {
                    vm.listaInstalaciones = dataResponse.data;
                });

                quantionApi.getInstalacionThemes().then(function (dataResponse) {
                    vm.listaThemes = dataResponse.data;
                });

                quantionApi.getPuntosAcceso().then(function (dataResponse) {
                    vm.listaAp = dataResponse.data;

                    vm.mapAps = {};
                    $.each(vm.listaAp, function (index, value) {
                        vm.mapAps[value.bssid && value.bssid.toLowerCase()] = value;
                    });
                });
            });
        }

        function appendHTMLstbList() {
            var tableRow = "";

            var listaStbs = vm.searchText ? $filter('filter')($scope.listaStbs, vm.searchText) : $scope.listaStbs;

            if ($scope.filtroWidgets.length > 0)
                listaStbs = listaStbs.filter(function (stb) {
                    return $scope.filtroWidgets.indexOf(stb.status.active) !== -1;
                });

            angular.forEach(listaStbs, function (item) {
                tableRow = tableRow +
                        '<div class="stb layout-row layout-align-start-center ' + (($scope.habIncidencias && ($scope.habIncidencias.indexOf(item.room) !== -1)) ? 'notification-incidences' : '') + ' ' + (($scope.habPrevents && ($scope.habPrevents.indexOf(item.room) !== -1)) ? 'notification-prevents' : '') + ' ' + (item.checkInOut !== 'In' ? 'checkout' : 'checkin') + ' ' + (item.status.buscandoAp ? 'buscandoAp' : '') + '" ' +
                        '       ng-click="abrirDetalle(' + item.idStb + ')">' +
                        '           <div class="stateLed ' + item.status.active + '"></div>' +
                        '           <span>' + item.room + '</span>' +
                        (JSONconfig.mostrarNombreHabitacion
                                ? ('<span> - ' + (item.checkInOut !== 'In' ? '(Check-out)' : item.username) + '</span>')
                                : '') +
                        (item.status.buscandoAp ? '<md-tooltip>Buscando AP</md-tooltip>' : '') +
                        '</div>';
            });

            $('#simpleListContainer').empty().append(tableRow);
            $compile($('#simpleListContainer'))($scope);
            $scope.listLoading = false;
        }

        function appendHTMLgroup(grupo) {
            if (!grupo) {
                $scope.listLoading = false;
                return;
            }

            var tableRow = '<div layout="row" layout-wrap>';

            var listaStbs = vm.searchText ? $filter('filter')(vm.stbsFiltradosPorGrupo[grupo.idStbGroup], vm.searchText) : vm.stbsFiltradosPorGrupo[grupo.idStbGroup];

            if ($scope.filtroWidgets.length > 0)
                listaStbs = listaStbs.filter(function (stb) {
                    return $scope.filtroWidgets.indexOf(stb.status.active) !== -1;
                });

            listaStbs = $filter('orderBy')(listaStbs, 'room|tryParseInt');

            $.each(listaStbs, function (key, stb) {
                var item = (
                        '<md-list-item class="completeList ' + stb.status.active + ' ' + (($scope.habIncidencias && ($scope.habIncidencias.indexOf(stb.room) !== -1)) ? 'notification-incidences' : '') + ' ' + (($scope.habPrevents && ($scope.habPrevents.indexOf(stb.room) !== -1)) ? 'notification-prevents' : '') + ' '
                        + (stb.checkInOut !== 'In'
                                ? 'checkout'
                                : 'checkin') + ' '
                        + (stb.status.buscandoAp ? 'buscandoAp' : '') + ' '
                        + (!JSONconfig.mostrarNombreHabitacion
                                ? 'completeList-mini'
                                : '') + '" '
                        + 'ng-click="abrirDetalle(' + stb.idStb + ')">'
                        + '<div class="md-list-item-text"><h3>' + stb.room
                        + (JSONconfig.mostrarNombreHabitacion
                                ? ('<span> - ' + ((stb.checkInOut !== 'In')
                                        ? '(Check - out)'
                                        : stb.username) + '</span>')
                                : '')
                        + '</h3></div>'
                        + (stb.status.buscandoAp ? '<md-tooltip>Buscando AP</md-tooltip>' : '')
                        + '<div layout="row" class="lockIcon">'
                        + (stb.typeWallet === 'virtual' ? '<md-icon md-font-icon="icon-credit-card"></md-icon>' : '')
                        + ((stb.activeContracts || stb.hasCrushedServices) ? '<md-icon md-font-icon="icon-cart-outline"></md-icon>' : '')
                        + '</div></md-list-item>');
                tableRow += item;
            });

            tableRow += '</div>';

            $('#groupListContainer').empty().append(tableRow);
            $compile($('#groupListContainer'))($scope);
            $scope.listLoading = false;
        }

        $scope.$on('incidencesReceived', function (event, args) {
            $scope.habIncidencias = args.incidences;
            $scope.listaIncidencias = args.list;
            vm.widgetIncidencias.numIncidencias = $scope.listaIncidencias.length;
            appendHTMLstbList();

            $.each(vm.groupsGrouped, function (key, value) {
                $.each(value, function (key, value) {
                    value.hasIncidences = value.stbs.filter(function (e) {
                        return args.incidences.indexOf(vm.mapaPorId[e] && vm.mapaPorId[e].room && vm.mapaPorId[e].room.toLowerCase()) !== -1;
                    }).length > 0;
                });
            });

            appendHTMLgroup($scope.selectedGroup);
        });

        $scope.$on('preventsReceived', function (event, args) {
            $scope.habPrevents = args.incidences;
            $scope.listaPrevents = args.list;
            vm.widgetIncidencias.numPrevents = $scope.listaPrevents.length;
            appendHTMLstbList();

            $.each(vm.groupsGrouped, function (key, value) {
                $.each(value, function (key, value) {
                    value.hasPrevents = value.stbs.filter(function (e) {
                        return args.incidences.indexOf(vm.mapaPorId[e] && vm.mapaPorId[e].room && vm.mapaPorId[e].room.toLowerCase()) !== -1;
                    }).length > 0;
                });
            });

            appendHTMLgroup($scope.selectedGroup);
        });

        $scope.cambiarGrupo = function (grupo) {
            $scope.selectedGroup = grupo;
            appendHTMLgroup(grupo);
        };

        var stbsNoReparacion = [];//Número de STBs que no están en grupo de reparación

        function OrganizarSTBsPorGrupo() {
            quantionApi.getGrupos().then(function (dataResponse) {
                vm.listaGrupos = ($scope.userRoleGroups.length > 0)
                        ? dataResponse.data.filter(function (gr) {
                            return $scope.userRoleGroups.includes(gr.nombre);
                        })
                        : dataResponse.data;
                vm.groupsGrouped = {};

                vm.listaGrupos.sort(function (a, b) {
                    return a.orden - b.orden;
                });

                $.each(vm.listaGrupos, function (index, value) {
                    if (!vm.groupsGrouped[value.place])
                        vm.groupsGrouped[value.place] = [];
                    vm.groupsGrouped[value.place].push(value);
                });

//                $scope.listaStbs = [];//Lista de STBs que se ven en la vista resumida. No están los STBs de los grupos descartados por !
                stbsNoReparacion = [];

                $.each(vm.listaGrupos, function (key, value) {
                    vm.stbsFiltradosPorGrupo[value.idStbGroup] = [];
                    vm.stbsFiltradosPorGrupo[value.idStbGroup].numActivos = 0;
                    vm.stbsFiltradosPorGrupo[value.idStbGroup].numInactivos = 0;
                    vm.stbsFiltradosPorGrupo[value.idStbGroup].numInactivosBoton = 0;
                    vm.stbsFiltradosPorGrupo[value.idStbGroup].numDesconocidos = 0;

                    var stbs = $filter('orderBy')(value.stbs, 'room|tryParseInt');

                    $.each(stbs, function (key2, value2) {
                        var stb = vm.mapaPorId[value2]; //getStbByID(value2, $scope.listaStbs);

                        if (!stb)
                            return;

                        vm.stbsFiltradosPorGrupo[value.idStbGroup].push(stb);

                        if (value.countable)
                            stbsNoReparacion.push(stb);

                        if (stb.status.active === 'Inactivo') {
                            vm.stbsFiltradosPorGrupo[value.idStbGroup].numInactivos++;
                        } else if (stb.status.active === 'Activo') {
                            vm.stbsFiltradosPorGrupo[value.idStbGroup].numActivos++;
                        } else if (stb.status.active === 'Boton') {
                            vm.stbsFiltradosPorGrupo[value.idStbGroup].numInactivosBoton++;
                        } else {
                            vm.stbsFiltradosPorGrupo[value.idStbGroup].numDesconocidos++;
                        }
                    });
                });

                vm.widgetHabitacionesOcupadas.refresh();
                vm.widgetUsuariosConectados.refresh();
                vm.widgetUsuariosDesconectados.refresh();
                vm.widgetUsuariosDesconectadosBoton.refresh();
                vm.widgetUsuariosNegro.refresh();
                vm.widgetTarjetas.refresh();
                vm.widgetServicios.refresh();
//                appendHTMLgroupList();
                $scope.cambiarGrupo(vm.listaGrupos[0]);

                $rootScope.$broadcast('stbsMainLoaded');
            });
        }

        function ListaDeHabsYMacsExistentes(lista) {
            vm.listaHabs = [];
            vm.listaMacs = [];

            $.each(lista, function (index, value) {
                vm.listaHabs.push(value.room);
                vm.listaMacs.push(value.mac);
            });
        }

        vm.widgetUsuariosConectados = {
            usuariosActivos: 0,
            totalUsuarios: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetUsuariosConectados.totalUsuarios = stbsNoReparacion.length;//$scope.listaStbs.length;

                vm.widgetUsuariosConectados.usuariosActivos = stbsNoReparacion.filter(function (stb) {
                    if (!stb.status)
                        return false;
                    return stb.status.active === 'Activo';
                }).length;

                vm.widgetUsuariosConectados.porcentaje = parseFloat((vm.widgetUsuariosConectados.usuariosActivos / vm.widgetUsuariosConectados.totalUsuarios) * 100).toFixed(2);
            }
        };

        vm.widgetUsuariosDesconectados = {
            usuariosActivos: 0,
            totalUsuarios: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetUsuariosDesconectados.totalUsuarios = stbsNoReparacion.length;//$scope.listaStbs.length;

                vm.widgetUsuariosDesconectados.usuariosActivos = stbsNoReparacion.filter(function (stb) {
                    if (!stb.status)
                        return false;
                    return stb.status.active === 'Inactivo';
                }).length;

                vm.widgetUsuariosDesconectados.porcentaje = parseFloat((vm.widgetUsuariosDesconectados.usuariosActivos / vm.widgetUsuariosDesconectados.totalUsuarios) * 100).toFixed(2);
            }
        };

        vm.widgetUsuariosDesconectadosBoton = {
            usuariosActivos: 0,
            totalUsuarios: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetUsuariosDesconectadosBoton.totalUsuarios = stbsNoReparacion.length;//$scope.listaStbs.length;

                vm.widgetUsuariosDesconectadosBoton.usuariosActivos = stbsNoReparacion.filter(function (stb) {
                    if (!stb.status)
                        return false;
                    return stb.status.active === 'Boton';
                }).length;

                vm.widgetUsuariosDesconectadosBoton.porcentaje = parseFloat((vm.widgetUsuariosDesconectadosBoton.usuariosActivos / vm.widgetUsuariosDesconectadosBoton.totalUsuarios) * 100).toFixed(2);
            }
        };

        vm.widgetUsuariosNegro = {
            usuariosActivos: 0,
            totalUsuarios: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetUsuariosNegro.totalUsuarios = stbsNoReparacion.length;//$scope.listaStbs.length;

                vm.widgetUsuariosNegro.usuariosActivos = stbsNoReparacion.filter(function (stb) {
                    if (!stb.status)
                        return false;
                    return stb.status.active === 'Desconocido';
                }).length;

                vm.widgetUsuariosNegro.porcentaje = parseFloat((vm.widgetUsuariosNegro.usuariosActivos / vm.widgetUsuariosNegro.totalUsuarios) * 100).toFixed(2);
            }
        };

        vm.widgetHabitacionesOcupadas = {
            habitacionesOcupadas: 0,
            totalHabitaciones: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetHabitacionesOcupadas.totalHabitaciones = stbsNoReparacion.length;

                vm.widgetHabitacionesOcupadas.habitacionesOcupadas = stbsNoReparacion.filter(function (stb) {
                    return stb.checkInOut === 'In';
                }).length;

                vm.widgetHabitacionesOcupadas.porcentaje = parseFloat((vm.widgetHabitacionesOcupadas.habitacionesOcupadas / vm.widgetHabitacionesOcupadas.totalHabitaciones) * 100).toFixed(2);
            }
        };

        vm.widgetIdiomaUsuarios = {
            data: [],
            refresh: function () {
                vm.widgetIdiomaUsuarios.data = {};

                $.each(vm.idiomas, function (index, value) {
                    vm.widgetIdiomaUsuarios.data[value.idioma] = 0;
                });

                $.each($scope.listaStbs, function (index, value) {
                    vm.widgetIdiomaUsuarios.data[value.lang]++;
                });
            }
        };

        vm.widgetTarjetas = {
            conTarjeta: 0,
            total: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetTarjetas.total = stbsNoReparacion.length;
                vm.widgetTarjetas.conTarjeta = stbsNoReparacion.filter(function (e) {
                    return e.typeWallet === 'virtual';
                }).length;
                vm.widgetTarjetas.porcentaje = parseFloat((vm.widgetTarjetas.conTarjeta / vm.widgetTarjetas.total) * 100).toFixed(2);
            }
        };

        vm.widgetIncidencias = {
            numIncidencias: 0,
            numPrevents: 0
        };

        $scope.toggleFiltroWidgets = function (status) {
            if ($scope.filtroWidgets.indexOf(status) === -1) {
                $scope.filtroWidgets.push(status);
            } else {
                $scope.filtroWidgets.splice($scope.filtroWidgets.indexOf(status), 1);
            }

            $('.wdgt-' + status).toggleClass('wdgt-marcado');

            appendHTMLstbList();
            appendHTMLgroup($scope.selectedGroup);
        };

        vm.widgetServicios = {
            conServicios: 0,
            total: 0,
            porcentaje: 0,
            refresh: function () {
                vm.widgetServicios.total = stbsNoReparacion.length;
                vm.widgetServicios.conServicios = stbsNoReparacion.filter(function (e) {
                    return e.activeContracts || e.hasCrushedServices;
                }).length;
                vm.widgetServicios.porcentaje = parseFloat((vm.widgetServicios.conServicios / vm.widgetServicios.total) * 100).toFixed(2);
            }
        };

        $scope.abrirDetalle = function (stbId) {
            if ($rootScope.user.mapRole.actions.DASHBOARD_NOT_INTERACTABLE) {
                return;
            }

            var stb = vm.mapaPorId[stbId];

//            if (stb.checkInOut === 'In') {
            vm.detailedStb = stb;

            $mdDialog.show({
                controller: DetailsCtrl,
                templateUrl: 'app/main/Quantion/principal/templates/details.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    stb: stb,
                    listaIncidencias: $scope.listaIncidencias ? $scope.listaIncidencias.filter(function (e) {
                        return e.room === stb.room;
                    }) : [],
                    listaPreventivas: $scope.listaPrevents ? $scope.listaPrevents.filter(function (e) {
                        return e.room === stb.room;
                    }) : [],
                    listaStbs: $scope.listaStbs
                }
            });
//            }
        };
        vm.abrirDetalle = $scope.abrirDetalle;

        function DetailsCtrl($scope, $mdDialog, stb, $state, $mdSidenav, listaIncidencias, listaPreventivas, $location, listaStbs, incidencesStateService, IncidencesConfig) {
            quantionApi.getStb(stb.idStb).then(function (dataResponse) {
                $scope.stb = dataResponse.data;

                if ($scope.stb.properties.wifiAp && $scope.stb.properties.wifiAp.bssid && $scope.stb.properties.wifiAp.bssid.match(/([0-9A-Fa-f]{2}[-:]){5}[0-9A-Fa-f]{2}/)) {
                    quantionApi.getRuckusApByMac($scope.stb.properties.wifiAp.bssid).then(function (dataResponse) {
                        $scope.assignedAp = dataResponse.data;
                    });
                }

                quantionApi.getUptime($scope.stb.idStb).then(function (dataResponse) {
                    if (!dataResponse.data)
                        return;

                    $scope.stb.uptime = dataResponse.data;

                    if (dataResponse.data.uptime) {
                        var horas = dataResponse.data.uptime.split('h');
                        var h = parseInt(horas[0]);

                        if (h >= 24) {
                            var h1 = parseInt(h / 24);
                            var h2 = h % 24;
                            $scope.stb.uptime.uptime = h1 + "d " + h2 + "h" + horas[1];
                        }
                    }

                    var knownTags = {
                        "Hongever USB Audio and HID": "Mando",
                        "Castles Technology Co., Ltd EZUSB PC/SC Smart Card Reader": "Lector SmartCard",
                        "Ralink Technology, Corp. RT5370 Wireless Adapter": "Dongle WiFi",
                        "Sycreader RFID Technology Co., Ltd SYC ID&IC USB Reader": "Lector RFID",

                        "eth": "Interfaz cableada",
                        "wlan": "Interfaz WiFi"
                    };

                    $scope.stb.uptime.usbList2 = $filter('orderBy')(dataResponse.data.usbList).map(function (elm) {
                        var a = knownTags[elm.trim()];
                        var b = elm.trim().indexOf('eth') === 0;
                        var c = elm.trim().indexOf('wlan') === 0;
                        var d = elm.trim().toLowerCase().includes('omnikey') ? 'Lector Omnikey ' + elm.split(' ').pop() : false;
                        var e = elm.trim().toLowerCase().includes('c3po') ? 'Lector C3PO ' + elm.split(' ').pop() : false;

                        if (a)
                            return {
                                known: true,
                                name: '(' + a + ') ' + elm,
                                color: 'red'
                            };
                        else if (b)
                            return {
                                known: true,
                                name: '(' + knownTags['eth'] + ') ' + elm,
                                color: 'blue'
                            };
                        else if (c)
                            return {
                                known: true,
                                name: '(' + knownTags['wlan'] + ') ' + elm,
                                color: 'darkorange'
                            };
                        else if (d)
                            return {
                                known: true,
                                name: '(' + d + ') ' + elm,
                                color: 'green'
                            };
                        else if (e)
                            return {
                                known: true,
                                name: '(' + e + ') ' + elm,
                                color: 'mediumpurple'
                            };
                        else
                            return {
                                known: false,
                                name: elm
                            };
                    });

                    if ($scope.stb.uptime && $scope.stb.uptime.ap && $scope.stb.uptime.ap.match(/([0-9A-Fa-f]{2}[-:]){5}[0-9A-Fa-f]{2}/)) {
                        quantionApi.getRuckusApByMac($scope.stb.uptime.ap).then(function (dataResponse) {
                            $scope.connectedAp = dataResponse.data;
                        });
                    }

                    $scope.signalStatusPercent = $filter('signalToPercent')($scope.stb.uptime.signal, -90, -30);

                    if ($scope.signalStatusPercent < 25) {
                        $scope.signalStatus = 'bad';
                    } else if ($scope.signalStatusPercent < 60) {
                        $scope.signalStatus = 'ok';
                    } else {
                        $scope.signalStatus = 'good';
                    }

                });

                quantionApi.getStatus($scope.stb.mac).then(function (dataResponse) {
//                    var now2minutesAgo = new Date();
//                    now2minutesAgo.setMinutes(now2minutesAgo.getMinutes() - 2);

//                    if (dataResponse.data.ultConexion < now2minutesAgo) {
//                        $scope.stb.status = {
//                            ultConexion: dataResponse.data.ultConexion,
//                            currentScreen: $filter('translate')('ESTADISTICAS.SCREENS.OFF'),
//                            currentInfo: "OFF",
//                            currentShadow: "OFF",
//                            currentStatus: "OFF"
//                        };
//                    } else {
                    $scope.stb.status = {
                        ultConexion: dataResponse.data.ultConexion,
                        currentScreen: $filter('translateStat')(dataResponse.data.currentScreen),
                        currentInfo: dataResponse.data.currentInfo || "null",
                        currentShadow: dataResponse.data.currentShadow || "null",
                        currentStatus: dataResponse.data.currentStatus
                    };
//                    }
                });

                quantionApi.getDispositivosConectados($scope.stb.ip, $scope.stb.properties.wifiPassword).then(function (dataResponse) {
                    $scope.stb.wifiList = angular.isArray(dataResponse.data) ? dataResponse.data : [];
                });

                if ($scope.stb.typeWallet === 'virtual' && $rootScope.user.mapRole.actions.WALLET_PINCODE) {
                    quantionApi.getAccountant({"wallet": $scope.stb.wallet.identifier, "concept": "Wallet", "limit": 10, "check": "Out"}).then(function (dataResponse) {
                        $scope.lastCheckinOperation = dataResponse.data.find(function (o) {
                            return o.policyType === 'Acquire';
                        });

                        if (!$scope.lastCheckinOperation) {
                            quantionApi.getAccountant({"wallet": $scope.stb.wallet.identifier, "concept": "Wallet", "limit": 10, "check": "Out", "remote": true}).then(function (dataResponse) {
                                $scope.lastCheckinOperation = dataResponse.data.find(function (o) {
                                    return o.policyType === 'Acquire';
                                });
                            });
                        }
                    });
                }

                if (JSONconfig.datosDiraya) {
                    dirayaApi.getDirayaRoom($scope.stb.room).then(function (dataResponse) {
                        $scope.diraya = dataResponse.data;
                    })
                }
            });

            $scope.JSONconfig = JSONconfig;
            $scope.sistemaDePago = JSONconfig.sistemaDePago;

            $scope.connectVNC = vm.connectVNC;
            $scope.reiniciarStb = vm.reiniciarStb;
            $scope.recargarInterfaz = vm.recargarInterfaz;
            $scope.ventanaEditar = vm.ventanaEditar;
            $scope.setDynamic = vm.setDynamic;
            $scope.deleteCacheEdid = vm.deleteCacheEdid;
            $scope.videocall = vm.videocall;
            $scope.webcam = vm.webcam;
            $scope.changeLock = vm.changeLock;

            $scope.$translate = $translate;

            $scope.listaIncidencias = listaIncidencias;
            $scope.listaPreventivas = listaPreventivas;
            $scope.incidencesCardCtrl = incidencesStateService.createCardCtrl($state, IncidencesConfig.urlGestor);

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.goDetails = function (stb) {
                $mdDialog.hide();
                $state.go('app.Quantion_habitaciones_ver_mas', {ip: stb.idStb});
            };

            $scope.verOperaciones = function (stb) {
                var params = {};
                if (stb.wallet.type === 'virtual')
                    params.idStb = '_' + stb.wallet.identifier;
                else
                    params.idStb = stb.idStb;

                $mdDialog.hide();
                $state.go('app.Quantion_gestionCompras_operaciones', params);
            };

            $scope.openSidenavLlamadas = function (stb) {
                $mdSidenav('llamadas').open();

                $scope.busqueda = {
                    extension: stb.extension.number,
                    ini: new Date((new Date()).toDateString()),
                    fin: new Date((new Date()).toDateString())
                };
            };

            $scope.buscar = function () {
                var fin = $scope.busqueda.fin;
                fin.setDate(fin.getDate() + 1);

                var obj = {
                    extension: $scope.busqueda.extension,
                    ini: $filter('date')($scope.busqueda.ini, 'yyyy-MM-dd'),
                    fin: $filter('date')(fin, 'yyyy-MM-dd')
                };

                quantionApi.getLlamadasTotal(obj).then(function (dataResponse) {
                    $scope.listaLlamadas = dataResponse.data;
                    $scope.listaLlamadas.reverse();
                });
            };

            $scope.closeSidenavLlamadas = function () {
                $mdSidenav('llamadas').close();
            };

            $scope.mapAps = vm.mapAps;

            $scope.getAps = function () {
                $scope.loadingAps = true;
                quantionApi.getApsDisponibles($scope.stb.idStb).then(function (dataResponse) {
                    $scope.loadingAps = false;
                    $scope.listaAps = dataResponse.data;
                }, function () {
                    $scope.loadingAps = false;
                    $scope.listaAps = [];
                });
            };

            $scope.getCardLog = function () {
                window.open(quantionApi.getCardLog($scope.stb.ip), '_blank');
            };

            //******************** NUEVA COMPRA ***************
            $scope.nuevaCompra = function (ev) {
                $mdDialog.show({
                    controller: NuevoCtrl,
                    templateUrl: 'app/main/Quantion/principal/templates/nuevacompra.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        stb: $scope.stb
                    }
                });
            };

            function NuevoCtrl($scope, $mdDialog, $mdToast, stb) {
                $scope.compra = {selectedStb: stb};

                quantionApi.getPaquetesActivos().then(function (dataResponse) {
                    $scope.listaPaquetes = dataResponse.data;
                });

                $scope.checkCustomPayment = function () {
                    if ($scope.compra.payment !== 'Cortesy' && $scope.compra.duration === 'custom')
                        $scope.compra.duration = null;
                };

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.guardar = function () {
                    $scope.dataLoading = true;

                    var obj = {
                        stb: $scope.compra.selectedStb.idStb,
                        wallet: $scope.stbOrWallet === 'wallet' ? $scope.compra.selectedWallet.uuidVirtualWallet : null,
                        package: $scope.compra.selectedPackage.idPackage,
                        duration: $scope.compra.duration === 'custom' ? $scope.compra.customDuration : $scope.compra.duration,
//                    duration: $scope.compra.duration,
                        payment: $scope.compra.payment !== 'TwoPending' ? $scope.compra.payment : null,
                        language: 'es',
                        policy: $scope.compra.payment !== 'TwoPending' ? 'OneShot' : 'TwoPending',
                        place: 'Front',
                        username: $rootScope.user.name
                    };

//                console.log(obj)

                    quantionApi.acquirePackage(obj, $scope.compra.comment ? ($scope.compra.comment + ' - ' + $rootScope.user.name) : null).then(function (dataResponse) {
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent($filter('translate')('OPERACIONES.NUEVACOMPRA.TOAST'))
                                .position('top right')
                                .hideDelay(3000)
                                );

                        $scope.hide();
                        vm.abrirDetalle(stb.idStb);
                    }, function (dataResponse) {
                        console.error(dataResponse);
                        $scope.mensajeError = 'OPERACIONES.NUEVACOMPRA.MENSAJEERROR';
                        $scope.dataLoading = false;
                    });
                };
            }

            $scope.verEstadisticas = function (stb) {
                $mdDialog.hide();
                $location.url('/estadisticas?idStb=' + stb.idStb);
            };

            $scope.resetHubUsb = function (stb) {
                if (window.confirm('¿Reiniciar Hub USB?')) {
                    quantionApi.resetUsbHubStb(stb.idStb).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent('Petición enviada').position('top right').hideDelay(5000));
                    });
                }
            };

            $scope.moveWallet = function (ev) {
                $mdDialog.show({
                    controller: VinculaCtrl,
                    templateUrl: 'app/main/Quantion/habitaciones/wallets/templates/vinculaStb.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {wallet: $scope.stb.wallet}
                });
            };

            function VinculaCtrl($scope, $mdDialog, $mdToast, wallet) {
                $scope.listaStbs = listaStbs;

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.guardar = function () {
                    $scope.dataLoading = true;

                    quantionApi.VincularStbWallet($scope.stbSelected.idStb, wallet.identifier).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.VINCULAR.TOAST')).position('top right').hideDelay(5000));
                        CargarStbs();
                        vm.abrirDetalle(stb.idStb);
                        $scope.hide();
                    }, function (dataResponse) {
                        console.error(dataResponse);
                    });
                };
            }

            $scope.unlinkWallet = function (ev) {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('WALLETS.DESVINCULA.TITLE'))
                        .textContent($filter('translate')('WALLETS.DESVINCULA.CONTENT'))
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .ok($filter('translate')('WALLETS.DESVINCULA.OK'))
                        .cancel($filter('translate')('WALLETS.DESVINCULA.CANCEL'));

                $mdDialog.show(confirm).then(function () {
                    quantionApi.DesvincularStbWallet($scope.stb.idStb, $scope.stb.wallet.identifier).then(function (dataResponse) {
                        CargarStbs();
                        vm.abrirDetalle(stb.idStb);
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('WALLETS.DESVINCULA.CORRECTO')).position('top right').hideDelay(3000));
                    }, function (dataResponse) {
                        $mdDialog.show(
                                $mdDialog.alert().clickOutsideToClose(true)
                                .title($filter('translate')('WALLETS.DESVINCULA.ERROR.TITLE'))
                                .ariaLabel('Error desvincular wallet')
                                .ok($filter('translate')('WALLETS.DESVINCULA.ERROR.OK')));
                    });
                });
            };

            $scope.changeRoom = function (ev) {
                $mdDialog.show({
                    controller: ChangeRoomCtrl,
                    templateUrl: 'app/main/Quantion/habitaciones/listado/templates/cambiohabitacion.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {stb: $scope.stb}
                });
            };

            function ChangeRoomCtrl($scope, $mdDialog, $mdToast, stb) {
                $scope.listaStbs = listaStbs;
                $scope.title = 'VERMAS.MOVEPERSONAL';

                $scope.options = {
                    merge: true,
                    checkout: true
                };

                $scope.checkoutDest = false;

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.guardar = function () {
                    $scope.dataLoading = true;

                    if ($scope.checkoutDest) {
                        quantionApi.updateCheck($scope.stbSelected.idStb, 'Out').then(function (dataResponse) {
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.TOAST')).position('top right').hideDelay(3000));

                            quantionApi.changeRoom(stb.idStb, $scope.stbSelected.idStb, $scope.options).then(function (dataResponse) {
                                $mdToast.show($mdToast.simple().textContent($filter('translate')('VERMAS.MOVEPERSONAL_TOAST')).position('top right').hideDelay(5000));
                                CargarStbs();
                                vm.abrirDetalle(stb.idStb);
                                $scope.hide();
                                $scope.dataLoading = false;
                            }, function (dataResponse) {
                                console.error(dataResponse);
                                $scope.dataLoading = false;
                                $mdToast.show($mdToast.simple().textContent('Error al hacer el cambio').position('top right').hideDelay(3000));
                            });
                        }, function (dataResponse) {
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.ERROR')).position('top right').hideDelay(3000));
                            $scope.dataLoading = false;
                        });
                    } else {
                        quantionApi.changeRoom(stb.idStb, $scope.stbSelected.idStb, $scope.options).then(function (dataResponse) {
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('VERMAS.MOVEPERSONAL_TOAST')).position('top right').hideDelay(5000));
                            CargarStbs();
                            vm.abrirDetalle(stb.idStb);
                            $scope.hide();
                            $scope.dataLoading = false;
                        }, function (dataResponse) {
                            console.error(dataResponse);
                            $scope.dataLoading = false;
                            $mdToast.show($mdToast.simple().textContent('Error al hacer el cambio').position('top right').hideDelay(3000));
                        });
                    }
                };
            }

            $scope.rebootAP = function (ev, ap) {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('APS.MODAL_REBOOT.TITLE'))
                        .content($filter('translate')('APS.MODAL_REBOOT.CONTENT'))
                        .targetEvent(ev)
                        .ok($filter('translate')('APS.MODAL_REBOOT.OK'))
                        .cancel($filter('translate')('APS.MODAL_REBOOT.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                    quantionApi.rebootRuckusApByMac(ap.apMac).then(function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('APS.MODAL_REBOOT.TOAST')).position('top right').hideDelay(3000));
                    });
                }).finally(function () {
                    vm.abrirDetalle(stb.idStb);
                });
            };

            $scope.showApRuckusInfo = function (ap) {
                $mdDialog.show({
                    controller: ApRuckusInfoController,
                    templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusDetails.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {puntoAcceso: ap}
                }).finally(function () {
                    vm.abrirDetalle(stb.idStb);
                });
            };

            function ApRuckusInfoController($scope, $mdDialog, puntoAcceso) {
                $scope.puntoAcceso = puntoAcceso;

                $scope.puntoAcceso = {
                    name: puntoAcceso.deviceName,
                    ruckus: {
                        more: {
                            status: puntoAcceso.status,
                            isOverallHealthStatusFlagged: puntoAcceso["isOverallHealthStatusFlagged"],
                            isLatency24GFlagged: puntoAcceso["isLatency24GFlagged"],
                            isCapacity24GFlagged: puntoAcceso["isCapacity24GFlagged"],
                            isConnectionFailure24GFlagged: puntoAcceso["isConnectionFailure24GFlagged"],
                            isLatency50GFlagged: puntoAcceso["isLatency50GFlagged"],
                            isCapacity50GFlagged: puntoAcceso["isCapacity50GFlagged"],
                            isConnectionFailure50GFlagged: puntoAcceso["isConnectionFailure50GFlagged"],
                            isConnectionTotalCountFlagged: puntoAcceso["isConnectionTotalCountFlagged"],
                            isConnectionFailureFlagged: puntoAcceso["isConnectionFailureFlagged"],
                            isAirtimeUtilization24GFlagged: puntoAcceso["isAirtimeUtilization24GFlagged"],
                            isAirtimeUtilization50GFlagged: puntoAcceso["isAirtimeUtilization50GFlagged"],

                            numClients: puntoAcceso["numClients"],
                            numClients24G: puntoAcceso["numClients24G"],
                            numClients5G: puntoAcceso["numClients5G"],
                            capacity: puntoAcceso["capacity"] + '%',
                            capacity24G: puntoAcceso["capacity24G"] + '%',
                            capacity50G: puntoAcceso["capacity50G"] + '%',
                            airtime24G: puntoAcceso["airtime24G"] + '%',
                            airtime5G: puntoAcceso["airtime5G"] + '%',
                            latency24G: (puntoAcceso["latency24G"] / 1000) + 'ms',
                            latency50G: (puntoAcceso["latency50G"] / 1000) + 'ms',
                            channel24G: puntoAcceso["channel24G"],
                            channel5G: puntoAcceso["channel5G"],
                            connectionFailure: (puntoAcceso["connectionFailure"] * 100) + '%',
                        }
                    }
                };

                $scope.booleanProps = ['isOverallHealthStatusFlagged', 'isLatency24GFlagged', 'isCapacity24GFlagged', 'isConnectionFailure24GFlagged', 'isLatency50GFlagged', 'isCapacity50GFlagged', 'isConnectionFailure50GFlagged', 'isConnectionTotalCountFlagged', 'isConnectionFailureFlagged', 'isAirtimeUtilization24GFlagged', 'isAirtimeUtilization50GFlagged'];
                $scope.numericProps = ['numClients', 'numClients24G', 'numClients5G', 'capacity', 'capacity24G', 'capacity50G', 'airtime24G', 'airtime5G', 'latency24G', 'latency50G', 'channel24G', 'channel5G', 'connectionFailure'];

                $scope.hide = $mdDialog.hide;

                $scope.loadingClients = false;
                quantionApi.getRuckusApsClientsByMac(puntoAcceso.apMac).then(function (dataResponse) {
                    $scope.clients = dataResponse.data.clients;
                    $scope.loadingClients = false;
                }, function () {
                    $scope.loadingClients = false;
                });
            }

            $scope.showApRuckusEvents = function (ap) {
                $mdDialog.show({
                    controller: ApRuckusEventsController,
                    templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusEvents.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {puntoAcceso: ap}
                }).finally(function () {
                    vm.abrirDetalle(stb.idStb);
                });
            };

            function ApRuckusEventsController($scope, $mdDialog, puntoAcceso) {
                $scope.hide = $mdDialog.hide;

                $scope.loadingEvents = true;

                if (puntoAcceso) {
                    quantionApi.getRuckusEventsByMac(puntoAcceso.apMac).then(function (dataResponse) {
                        $scope.events = dataResponse.data.list;
                        $scope.loadingEvents = false;
                    }, function () {
                        $scope.loadingEvents = false;
                    });
                } else {
                    quantionApi.getRuckusEvents().then(function (dataResponse) {
                        $scope.events = dataResponse.data.list;
                        $scope.loadingEvents = false;
                    }, function () {
                        $scope.loadingEvents = false;
                    });
                }
            }

            $scope.showApRuckusAlarms = function (ap) {
                $mdDialog.show({
                    controller: ApRuckusAlarmsController,
                    templateUrl: 'app/main/Quantion/habitaciones/aps/templates/apRuckusAlarms.tmpl.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {puntoAcceso: ap}
                }).finally(function () {
                    vm.abrirDetalle(stb.idStb);
                });
            };

            function ApRuckusAlarmsController($scope, $mdDialog, puntoAcceso) {
                $scope.hide = $mdDialog.hide;

                $scope.loadingAlarms = true;

                if (puntoAcceso) {
                    quantionApi.getRuckusAlarmsByMac(puntoAcceso.apMac).then(function (dataResponse) {
                        $scope.alarms = dataResponse.data.list;
                        $scope.loadingAlarms = false;
                    }, function () {
                        $scope.loadingAlarms = false;
                    });
                } else {
                    quantionApi.getRuckusAlarms().then(function (dataResponse) {
                        $scope.alarms = dataResponse.data.list;
                        $scope.loadingAlarms = false;
                    }, function () {
                        $scope.loadingAlarms = false;
                    });
                }
            }

            //********************** CHECK-IN *******************************
            $scope.checkIn = function (stb, event) {
                $mdDialog.show({
                    controller: CheckInCtrl,
                    templateUrl: 'app/main/Quantion/habitaciones/listado/templates/checkin.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {stb: stb}
                });
            };

            function CheckInCtrl($scope, $mdDialog, stb) {
                $scope.listaIdiomas = vm.idiomas;
                $scope.stb = stb;

                $scope.CheckIn = function () {
                    var jsonObj = angular.toJson({
                        properties: {
                            "displayWelcome": $scope.stb.properties.displayWelcome
                        },
                        "lang": $scope.stb.lang,
                        "username": $scope.stb.username
                    }, 0);

                    $scope.cargando = true;

                    quantionApi.patchStb(stb.idStb, jsonObj).then(function (dataResponse) {
                        quantionApi.updateCheck(stb.idStb, 'In').then(function (dataResponse) {
                            $scope.cargando = false;
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKIN.TOAST')).position('top right').hideDelay(3000));
                            $mdDialog.hide();
                            CargarStbs();
                            vm.abrirDetalle(stb.idStb);
                        });
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Error al guardar').action('OK').highlightAction(false).position('top right'));
                    });
                };
            }

            //**************************** CHECK-OUT *******************************
            $scope.checkOut = function (stb, event) {
                var confirm = $mdDialog.confirm()
                        .title($filter('translate')('CHECKOUT.TITLE'))
                        .textContent($filter('translate')('CHECKOUT.CONTENT'))
                        .targetEvent(event)
                        .ok($filter('translate')('CHECKOUT.OK'))
                        .cancel($filter('translate')('CHECKOUT.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                    quantionApi.updateCheck(stb.idStb, 'Out').then(function (dataResponse) {
                        CargarStbs();
                        vm.abrirDetalle(stb.idStb);
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.TOAST')).position('top right').hideDelay(3000));
                    }, function (dataResponse) {
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('CHECKOUT.ERROR')).position('top right').hideDelay(3000));
                    });
                });
            };
        }

        //************ Editar ***************
        vm.ventanaEditar = function (ev, stb) {
            if ($rootScope.user.mapRole.actions.CREATE_EDIT_STB) {
                $mdDialog.show({
                    controller: EditarCtrl,
                    templateUrl: 'app/main/Quantion/habitaciones/listado/templates/editar.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {stb: stb}
                });
            }
        };

        quantionApi.getModelos().then(function (dataResponse) {
            vm.listaModelos = $filter('orderBy')(dataResponse.data, 'name');
            ;
        });

        quantionApi.getFiles('system').then(function (dataResponse) {
            vm.systemList = dataResponse.data;
        });

        quantionApi.getAcls().then(function (dataResponse) {
            vm.listaAcls = $filter('orderBy')($.unique(dataResponse.data));
        });

        quantionApi.getControls().then(function (dataResponse) {
            vm.listaControls = $filter('orderBy')(dataResponse.data, 'model');
        });

        function EditarCtrl($scope, $mdDialog, stb, $rootScope) {
            quantionApi.getStb(stb.idStb).then(function (dataResponse) {
                $scope.stb = dataResponse.data;

                $scope.stb.model = stb.model ? stb.model.identifier : null;
                $scope.stb.installation = stb.installation ? stb.installation.identifier : null;
                getInstallationById($scope.stb.installation);
                $scope.res = stb.properties.resolution.split('x').map(function (e) {
                    return parseInt(e);
                });
                $scope.stb.properties.wifiAp = stb.properties.wifiAp ? stb.properties.wifiAp.idWiFiAp : null;

                $scope.stb.dynamicVersion = $scope.stb.dynamicVersion ? $scope.stb.dynamicVersion.idItemVersion : null;
                $scope.stb.systemVersion = $scope.stb.systemVersion ? $scope.stb.systemVersion.idItemVersion : null;
                $scope.stb.biosVersion = $scope.stb.biosVersion ? $scope.stb.biosVersion.idItemVersion : null;

                $scope.stb.control = stb.control ? stb.control.idControl : null;

                $scope.editing = true;

                $scope.listaIdiomas = vm.idiomas;
                $scope.ipPattern = "^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$";
                $scope.macPattern = '^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$';
                $scope.cargando = false;
                $scope.listaModelos = vm.listaModelos;
                $scope.listaInstalaciones = vm.listaInstalaciones;
                $scope.listaThemes = vm.listaThemes;
                $scope.listaAp = vm.listaAp;
                $scope.listaAcls = vm.listaAcls;
                $scope.listaControls = vm.listaControls;

                getVersionLists();
                $scope.getVersionLists = getVersionLists;

                $scope.$watch('stb.properties.themeOverride', function (newValue, oldValue) {
                    if (newValue === "")
                        $scope.stb.properties.themeOverride = null;
                });

                $scope.JSONconfig = JSONconfig;
                if (JSONconfig.datosDiraya) {
                    dirayaApi.getDirayaRoom(stb.room).then(function (dataResponse) {
                        $scope.diraya = {
                            idDiraya: dataResponse.data.idDiraya,
                            room: dataResponse.data.room,
                            installation: dataResponse.data.installation,
                            cama: dataResponse.data.cama,
                            centro: dataResponse.data.centro,
                            modulo: dataResponse.data.modulo,
                            unidadfuncional: dataResponse.data.unidadfuncional,
                            codigounidad: dataResponse.data.codigounidad,
                        };
                    }, function (dataResponse) {
                        if(dataResponse.status === 404) {
                            $scope.diraya = {
                                room: stb.room,
                                installation: dirayaApi.DOMAIN,
                                cama: null,
                                centro: null,
                                modulo: null,
                                unidadfuncional: null,
                                codigounidad: null,
                            };
                        }
                    })
                }
            });

            $scope.userRole = $rootScope.user.userRole;

            $scope.Guardar = function () {
                var obj = diffObj($scope.stb, stb);//Obtiene solo los campos que han cambiado

                if (stb.model && $scope.stb.model === stb.model.identifier)
                    delete obj.model;

                if (stb.installation && $scope.stb.installation === stb.installation.identifier)
                    delete obj.installation;

                if (stb.dynamicVersion && $scope.stb.dynamicVersion === stb.dynamicVersion.idItemVersion)
                    delete obj.dynamicVersion;

                if (stb.systemVersion && $scope.stb.systemVersion === stb.systemVersion.idItemVersion)
                    delete obj.systemVersion;

                if (stb.biosVersion && $scope.stb.biosVersion === stb.biosVersion.idItemVersion)
                    delete obj.biosVersion;

                if ((stb.properties.wifiAp && stb.properties.wifiAp.idWiFiAp) === $scope.stb.properties.wifiAp) {
                    if (obj.properties)
                        delete obj.properties.wifiAp;
                } else {
                    var found;
                    if ($scope.stb.properties.wifiAp) {
                        found = $scope.listaAp.find(function (ap) {
                            return ap.idWiFiAp === $scope.stb.properties.wifiAp;
                        });
                    }

                    messagesApi.sendMessage({
                        title: 'Cambio de AP - Hab. ' + $scope.stb.room + ' - ' + $rootScope.user.name,
                        message: [
                            stb.properties.wifiAp ? (stb.properties.wifiAp.name + ' (' + stb.properties.wifiAp.band + ' - ' + stb.properties.wifiAp.bssid + ')') : 'Sin AP',
                            found ? (found.name + ' (' + found.band + ' - ' + found.bssid + ')') : 'Sin AP'
                        ].join('\n🔻🔻🔻\n')
                    });
                }

                if (obj.extension) {
                    var extNum = obj.extension.number;
                    obj.extension = stb.extension || {};
                    obj.extension.number = extNum;
                }

                var jsonObj = angular.toJson(obj, 0);
                $scope.cargando = true;

//                console.log(jsonObj);

                if (($scope.stb.room === stb.room || vm.listaHabs.indexOf($scope.stb.room) === -1) && ($scope.stb.mac === stb.mac || vm.listaMacs.indexOf($scope.stb.mac) === -1)) {
                    quantionApi.patchStb(stb.idStb, jsonObj).then(function (dataResponse) {
                        CargarStbs();
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.TOASTEDITAR')).position('top right').hideDelay(3000));
                        $scope.cargando = false;
                        $mdDialog.hide();
                        $mdSidenav('right').close();

                        $mdDialog.show({
                            controller: ActionPostEditController,
                            templateUrl: 'app/main/Quantion/habitaciones/listado/templates/actionPostEdit.tmpl.html',
                            locals: {stb: stb}
                        });
                    }, function (dataResponse) {
                        $scope.cargando = false;
                        $mdToast.show($mdToast.simple().textContent('Error al guardar').action('OK').highlightAction(false).position('top right'));
                        console.log("Fallo al guardar");
                    });
                } else {
                    $scope.mensajeError = $filter('translate')('PRINCIPAL.ERRORMISMO');
                    $scope.cargando = false;
                }

                if (JSONconfig.datosDiraya) {
                    $scope.diraya.room = $scope.stb.room;

                    if ($scope.diraya.idDiraya) {
                        dirayaApi.putDirayaRoom($scope.diraya).then(function () {
                            console.log('PUT Diraya ok')
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                        })
                    } else {
                        dirayaApi.postDirayaRoom($scope.diraya).then(function () {
                            console.log('POST Diraya ok')
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Error al guardar datos Diraya').action('OK').highlightAction(false).position('top right'));
                        })
                    }
                }
            };

            function diffObj(edit, original) {
                var dest = {};
                $.each(edit, function (key, value) {
                    if (angular.isObject(value)) {
                        var a = diffObj(value, original[key]);
                        if (Object.keys(a).length > 0)
                            dest[key] = a;
                    } else {
                        if (!original || angular.toJson(value) !== angular.toJson(original[key])) {
                            dest[key] = value;
                        }
                    }
                });
                return dest;
            }

            function getVersionLists() {
                var m = vm.listaModelos.filter(function (e) {
                    return e.idStbModel === $scope.stb.model;
                });
                if (m[0]) {
                    $scope.dynamicList = m[0].dynamicList;
                    $scope.systemList = vm.systemList;
                    $scope.biosList = m[0].biosList;

                    if ($scope.stb.model !== stb.model.identifier) {
                        $scope.stb.dynamicVersion = null;
                        $scope.stb.systemVersion = null;
                        $scope.stb.biosVersion = null;
                    } else {
                        $scope.stb.dynamicVersion = stb.dynamicVersion ? stb.dynamicVersion.idItemVersion : null;
                        $scope.stb.systemVersion = stb.systemVersion ? stb.systemVersion.idItemVersion : null;
                        $scope.stb.biosVersion = stb.biosVersion ? stb.biosVersion.idItemVersion : null;
                    }
                } else {
                    console.error(m);
                }
            }

            $scope.getInstallationById = getInstallationById;

            function getInstallationById(id) {
                $scope.installationChosed = vm.listaInstalaciones.filter(function (e) {
                    return e.idInstallation === id;
                })[0];
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        function ActionPostEditController($scope, $mdDialog, stb) {
            $scope.stb = stb;

            $scope.dynamic = function () {
                quantionApi.setDynamic(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('DYNAMIC.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                });
            };

            $scope.interfaceReboot = function () {
                quantionApi.rebootInterface(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALRECARGA.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                });
            };

            $scope.reboot = function () {
                quantionApi.rebootStb(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALREINICIO.TOAST')).position('top right').hideDelay(5000));
                    $mdDialog.hide();
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

//************************************* Conexion VNC *************************************
        vm.connectVNC = function (stb, ev) {
            quantionApi.connectVNC(stb.idStb).then(function (dataResponse) {
//                window.open('https://admin.solertia.sol/plugin-vnc/vnc.html?host=' + stb.ip + '&port=5900&autoconnect=true&resize=scale&password=', '_blank');
                var win = window.open(JSONconfig.urlVNC(stb.ip, stb.model), '_blank');
                if (win === null || typeof (win) === 'undefined') {
                    alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                }

//                $mdDialog.show({
//                    controller: VNCController,
//                    templateUrl: 'app/main/Quantion/habitaciones/ver_mas/vnc.tmpl.html',
//                    parent: angular.element(document.body),
//                    targetEvent: ev,
//                    clickOutsideToClose: true,
//                    locals: {stb: stb},
//                    onRemoving: function () {
//                        $scope.abrirDetalle(vm.detailedStb);
//                    }
//                });
            }, function () {
                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(false)
                        .title($filter('translate')('PRINCIPAL.ERRORVNC.TITLE'))
                        .textContent($filter('translate')('PRINCIPAL.ERRORVNC.CONTENT'))
                        .ok($filter('translate')('PRINCIPAL.ERRORVNC.OK'))
                        .targetEvent(ev)
                        )
                        .then(function () {
                            $scope.abrirDetalle(stb.idStb);
                        }, function () {
                            $scope.abrirDetalle(stb.idStb);
                        });
            });
        };

        function VNCController($scope, $mdDialog, stb) {
            $scope.ip = stb.ip;

            $scope.selectIP = function () {
                document.getElementById("formIP").focus();
                document.execCommand('copy');
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        //**************** Reinicio *************************
        vm.reiniciarStb = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PRINCIPAL.MODALREINICIO.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Reinicio')
                    .targetEvent(ev)
                    .ok($filter('translate')('PRINCIPAL.MODALREINICIO.OK'))
                    .cancel($filter('translate')('PRINCIPAL.MODALREINICIO.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootStb(stb.idStb).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('PRINCIPAL.MODALREINICIO.TOAST'))
                            .position('top right')
                            .hideDelay(5000)
                            );

                    $scope.abrirDetalle(stb.idStb);
                });
            }, function () {
                $scope.abrirDetalle(stb.idStb);
            });
        };

        //************************************* Recarga interfaz *************************************
        vm.recargarInterfaz = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PRINCIPAL.MODALRECARGA.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Recargar interfaz')
                    .targetEvent(ev)
                    .ok($filter('translate')('PRINCIPAL.MODALRECARGA.OK'))
                    .cancel($filter('translate')('PRINCIPAL.MODALRECARGA.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                quantionApi.rebootInterface(stb.idStb).then(function (dataResponse) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($filter('translate')('PRINCIPAL.MODALRECARGA.TOAST'))
                            .position('top right')
                            .hideDelay(5000)
                            );

                    $scope.abrirDetalle(stb.idStb);
                });
            }, function () {
                $scope.abrirDetalle(stb.idStb);
            });
        };

        //************************************* Dynamic *************************************
        vm.setDynamic = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('DYNAMIC.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Dynamic')
                    .targetEvent(ev)
                    .ok($filter('translate')('DYNAMIC.OK'))
                    .cancel($filter('translate')('DYNAMIC.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.setDynamic(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('DYNAMIC.TOAST')).position('top right').hideDelay(5000));
                    $scope.abrirDetalle(stb.idStb);
                });
            }, function () {
                $scope.abrirDetalle(stb.idStb);
            });
        };


        //*********************************** Caché EDID **************************************
        vm.deleteCacheEdid = function (stb, ev) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('EDID.TITLE', {stbroom: stb.room}))
                    .ariaLabel('Edid')
                    .targetEvent(ev)
                    .ok($filter('translate')('EDID.OK'))
                    .cancel($filter('translate')('EDID.CANCEL'))
                    .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(function () {
                quantionApi.deleteCacheEdid(stb.idStb).then(function (dataResponse) {
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('EDID.TOAST')).position('top right').hideDelay(5000));
                    $scope.abrirDetalle(stb.idStb);
                });
            }, function () {
                $scope.abrirDetalle(stb.idStb);
            });
        };

        $scope.slOpened = $scope.userRoleGroups.length <= 0 ? localStorage['slOpened'] : 0;
        $scope.toggleSimpleList = function (value) {
            $scope.slOpened = value;
            localStorage['slOpened'] = value;
        };

        $scope.barraBuscador = $('#buscador');
        $scope.focusBuscador = function () {
            $scope.barraBuscador.focus();
        };

        //************************************* Monitorizar webcam *************************************
        vm.webcam = function (stb, ev) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                template:
                        '<md-dialog aria-label="Videollamada">' +
                        '  <md-dialog-content>' +
                        '    <h2 class="md-title">' + $filter('translate')('PRINCIPAL.MODALWEBCAM.TITLE', {stbroom: stb.room}) + '</h2>' +
                        '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALWEBCAM.CONTENT2') + '</h3>' +
                        '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALWEBCAM.CONTENT') + '</h3>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="closeDialog()" class="md-primary" ng-disabled="closeButtonDisabled">' +
                        $filter('translate')('PRINCIPAL.MODALWEBCAM.OK') +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                controller: DialogController,
                locals: {
                    stb: stb
                },
                escapeToClose: false
            });

            function DialogController($scope, stb) {
                if (!JSONconfig.webcam)
                    return;

                if (JSONconfig.monitoringApi) {
                    $scope.closeButtonDisabled = true;

                    quantionApi.openMonitoring(stb.idStb).then(function (data) {
                        setTimeout(function () {
                            // window.open(JSONconfig.webcamUrl(stb));
                            var win = window.open(JSONconfig.webcamUrl(stb.ip, stb.model && stb.model.name), '_blank');
                            if (win === null || typeof (win) === 'undefined') {
                                alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                            }
                            $scope.closeButtonDisabled = false;
                        }, 2000);
                    });

                    $scope.closeDialog = function () {
                        quantionApi.closeMonitoring(stb.idStb);
                        vm.abrirDetalle(stb.idStb);
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALWEBCAM.TOAST')).position('top right').hideDelay(5000));
                    };
                } else {
                    var task = {
                        "title": "Webcam hab. " + stb.room,
                        "description": "IP: " + stb.ip,
                        "metodo": "GET",
                        "header": "{}",
                        "command": JSONconfig.videocallCommand(stb),
                        "arguments": angular.toJson({
                            "taskroot": false,
                            "cmdline": JSONconfig.videocallCommand(stb),
                            "args": []
                        }),
                        "type": "task"
                    };

                    var killTask = {
                        "title": "Kill Webcam hab. " + stb.room,
                        "description": "IP: " + stb.ip,
                        "metodo": "GET",
                        "header": "{}",
                        "command": JSONconfig.videocallCommand(stb, {kill: true}),
                        "arguments": angular.toJson({
                            "taskroot": false,
                            "cmdline": JSONconfig.videocallCommand(stb, {kill: true}),
                            "args": []
                        }),
                        "type": "task"
                    };

                    $scope.closeButtonDisabled = true;

                    quantionApi.addTask(angular.toJson(task)).then(function (data) {
                        setTimeout(function () {
                            // window.open(JSONconfig.webcamUrl(stb));
                            var win = window.open(JSONconfig.webcamUrl(stb.ip, stb.model && stb.model.name), '_blank');
                            if (win === null || typeof (win) === 'undefined') {
                                alert('Por favor deshabilita el bloqueador de ventanas emergentes y vuelve a hacer clic en el botón.');
                            }
                            $scope.closeButtonDisabled = false;
                        }, 2000);
                    });

                    $scope.closeDialog = function () {
                        quantionApi.addTask(angular.toJson(killTask));
                        vm.abrirDetalle(stb.idStb);
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALWEBCAM.TOAST')).position('top right').hideDelay(5000));
                    };
                }
            }
        };

        //************************************* Videollamada OpenVidu *************************************
        vm.videocall = function (stb, ev) {
            if (JSONconfig.monitoringApi) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    template:
                            '<md-dialog aria-label="Videollamada">' +
                            '  <md-dialog-content>' +
                            '    <h2 class="md-title">' + $filter('translate')('PRINCIPAL.MODALVIDEOCALL.TITLE', {stbroom: stb.room}) + '</h2>' +
                            '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALVIDEOCALL.CONTENT2') + '</h3>' +
                            '    <h3 class="md-dialog-content-body">' + $filter('translate')('PRINCIPAL.MODALVIDEOCALL.CONTENT') + '</h3>' +
                            '  </md-dialog-content>' +
                            '  <md-dialog-actions>' +
                            '    <md-button ng-click="closeDialog()" class="md-primary" ng-disabled="closeButtonDisabled">' +
                            $filter('translate')('PRINCIPAL.MODALVIDEOCALL.OK') +
                            '    </md-button>' +
                            '  </md-dialog-actions>' +
                            '</md-dialog>',
                    controller: DialogController,
                    locals: {
                        stb: stb
                    },
                    escapeToClose: false
                });

                function DialogController($scope, stb) {
                    if (!JSONconfig.videocall)
                        return;

                    $scope.closeButtonDisabled = true;

                    quantionApi.openVideocall(stb.idStb, JSONconfig.videocallRoom(stb)).then(function (data) {
                        setTimeout(function () {
                            window.open(JSONconfig.videocallUrl(stb));
                            $scope.closeButtonDisabled = false;
                        }, 2000);
                    });

                    $scope.closeDialog = function () {
                        quantionApi.closeVideocall(stb.idStb);
                        vm.abrirDetalle(stb.idStb);
                        $mdToast.show($mdToast.simple().textContent($filter('translate')('PRINCIPAL.MODALVIDEOCALL.TOAST')).position('top right').hideDelay(5000));
                    };
                }
            } else {
                if (!JSONconfig.videocall)
                    return;

                var task = {
                    "title": "Videocall hab. " + stb.room,
                    "description": "IP: " + stb.ip,
                    "metodo": "GET",
                    "header": "{}",
                    "command": JSONconfig.videocallCommand(stb, {openvidu: true}),
                    "arguments": angular.toJson({
                        "taskroot": false,
                        "cmdline": JSONconfig.videocallCommand(stb, {openvidu: true}),
                        "args": []
                    }),
                    "type": "task"
                };

                quantionApi.addTask(angular.toJson(task)).then(function (data) {
                    window.open(JSONconfig.videocallUrl(stb));
                });
            }
        };

        //*********************** BLOQUEAR STB **********************
        vm.changeLock = function (stb, newValue) {
            var jsonObj = angular.toJson({properties: {"locked": newValue}}, 0);

            quantionApi.patchStb(stb.idStb, jsonObj).then(function (dataResponse) {
                $scope.abrirDetalle(stb.idStb);
            }, function (dataResponse) {
                console.log("Fallo al guardar");
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.precios', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_precios', {
            url: '/precios',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/precios/precios.html',
                    controller: 'preciosController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/precios');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.precios')
            .controller('preciosController', preciosController);

    /** @ngInject */
    function preciosController(quantionApi, $mdDialog, $mdToast, $scope, $rootScope, JSONconfig, FilePaths)
    {
        var vm = this;
        $rootScope.seccion = 'PRECIOS';

        quantionApi.getPaquetes().then(function (dataResponse) {
            vm.listaPaquetes = dataResponse.data;
        });

        quantionApi.getServicios().then(function (dataResponse) {
            $scope.servicios = {};
            $.each(dataResponse.data, function (index, value) {
                $scope.servicios[value.idService] = {
                    service: value,
                    count: 0
                };

                $scope.servicios[value.idService].service.logo = JSONconfig.logosPath.to + '/' + FilePaths.servicios_paquetes + '/' + value.acl + '.png';
            });

            quantionApi.getStbs().then(function (dataResponse2) {
                $.each(dataResponse2.data, function (index, value) {
                    $.each(value.wallet.services, function (index, value) {
                        $scope.servicios[value.idService].count++;
                    });
                });

                $scope.lServicios = [];
                $.each($scope.servicios, function (key, value) {
                    $scope.lServicios.push(value);
                });
            });
        });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.lotes')
            .controller('lotesController', lotesController);

    /** @ngInject */
    function lotesController(quantionApi, $mdToast, $scope, $mdDialog, $rootScope, $filter, $compile)
    {
        var vm = this;
        $rootScope.seccion = 'LOTES';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        pantallaCarga.lsEnable('LS.DATOSVOIP');
        $scope.$on('onRepeatLast', function () {
            pantallaCarga.lsDisable();
        });

        initWizard();
        function initWizard() {
            vm.action = '';
            vm.secondaryAction = '';
            CargarStbs();
        }

        function CargarStbs() {
            $scope.listaGrupos = [];
            quantionApi.getStbs().then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;
                var map = {};
                $.each(vm.listaStbs, function (index, stb) {
                    map[stb.idStb] = stb;
                });

                quantionApi.getGrupos().then(function (dataResponse) {
                    $scope.listaGrupos = dataResponse.data.map(function (elm) {
                        elm.cStbs = elm.stbs.map(function (elm2) {
                            return map[elm2];
                        });
                        return elm;
                    });
                    $scope.listaGrupos.sort(function (a, b) {
                        return a.orden - b.orden;
                    });
                });
            });
        }

        quantionApi.getModelos().then(function (dataResponse) {
            vm.listaModelos = $filter('orderBy')(dataResponse.data, 'name');;
        });

        quantionApi.getInstalaciones(true).then(function (dataResponse) {
            vm.listaInstalaciones = dataResponse.data;
        });

        quantionApi.getInstalacionThemes().then(function (dataResponse) {
            vm.listaThemes = dataResponse.data;
        });

        quantionApi.getAcls().then(function (dataResponse) {
            vm.listaAcls = dataResponse.data;
            vm.selectedAcl = null;
            vm.aclIsNull = false;

            $scope.querySearch = function (query) {
                return query ? vm.listaAcls.filter(createFilterFor(query)) : vm.listaAcls.lista;
            };

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);

                return function (acl) {
                    return (angular.lowercase(acl.indexOf(lowercaseQuery) !== -1));
                };
            }
        });

        $scope.marcarGrupo = function (idGrupo, bool) {
            var gr = $scope.listaGrupos.filter(function (elm) {
                return elm.idStbGroup === idGrupo;
            });

            if (gr.length > 0)
                $.each(gr[0].cStbs, function (index, value) {
                    value.seleccionado = bool;
                });
        };

        $scope.marcarTodo = function (bool) {
            $.each($scope.listaGrupos, function (i, gr) {
                $.each(gr.cStbs, function (index, value) {
                    value.seleccionado = bool;
                });
            });
        };

        $scope.marcarStorage = function () {
            if (!localStorage.marcados)
                return;

            var obj = angular.fromJson(localStorage.marcados);

            $.each($scope.listaGrupos, function (i, gr) {
                $.each(gr.cStbs, function (index, value) {
                    value.seleccionado = obj[value.idStb];
                });
            });
        };

        $scope.enviar = function (msWizard) {
            var confirm = $mdDialog.confirm()
                    .title($filter('translate')('LOTES.CONFIRMACION.TITLE'))
                    .clickOutsideToClose(true)
                    .ok($filter('translate')('LOTES.CONFIRMACION.OK'))
                    .cancel($filter('translate')('LOTES.CONFIRMACION.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                enviar(msWizard);
            }, function () {

            });
        };

        function enviar(msWizard) {
            $scope.msWizard = msWizard;

            var list = [];
            var completeList = [];
            $.each($scope.listaGrupos, function (index, gr) {
                completeList = completeList.concat(gr.cStbs
                        .filter(function (stb) {
                            return stb.seleccionado;
                        }));

                list = list.concat(gr.cStbs
                        .filter(function (stb) {
                            return stb.seleccionado;
                        })
                        .map(function (stb) {
                            return stb.idStb;
                        }));
            });

            var obj = vm.secondaryAction;

            if (list.length > 0) {
                vm.yaEnviado = true;
                $scope.cargando = true;

                switch (vm.action) {
                    case 'rebootLote':
                        quantionApi.rebootLote(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.REINICIOENVIADO'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'serviceRebootLote':
                        quantionApi.serviceRebootLote(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.RECARGAENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'dynamic':
                        quantionApi.setDynamicGrupo(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'delete':
                        quantionApi.deleteStbLotes(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ELIMINARENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'checkout':
                        quantionApi.updateCheckLotes(list, 'Out').then(function (dataResponse) {
                            toast($filter('translate')('LOTES.CHECKOUTENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'checkin':
                        quantionApi.updateCheckLotes(list, 'In').then(function (dataResponse) {
                            toast($filter('translate')('LOTES.CHECKINENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'igualarextension':
                        quantionApi.igualarExtensionLotes(list).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'lastSystem':
                        quantionApi.patchStbLotes(list, angular.toJson({updated: {forceSystem: false}, systemVersion: null})).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'updateDynamic':
                        quantionApi.patchStbLotes(list, angular.toJson({updated: {forceDynamic: true}, dynamicVersion: null})).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    case 'autorun':
                        quantionApi.patchStbLotes(list, angular.toJson({autorun: (vm.aclIsNull ? null : vm.selectedAcl)})).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                        break;
                    default:
                        quantionApi.patchStbLotes(list, angular.toJson(obj)).then(function (dataResponse) {
                            toast($filter('translate')('LOTES.ACTUENVIADA'));
                            $scope.cargando = false;
                        }, function (dataResponse) {
                            $scope.cargando = false;
                            vm.yaEnviado = false;
                            toast(dataResponse.status + ' - ' + dataResponse.statusText);
                        });
                }
            } else {
                $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($filter('translate')('LOTES.ALERT.TITLE'))
                        .textContent($filter('translate')('LOTES.ALERT.CONTENT'))
                        .ariaLabel('No STB')
                        .ok($filter('translate')('LOTES.ALERT.OK'))
                        );
            }
        }

        function toast(text) {
            $mdToast.show(
                    $mdToast.simple()
                    .textContent(text)
                    .position('top right')
                    .hideDelay(3000)
                    );
            $scope.msWizard.firstStep();
            initWizard();
            vm.yaEnviado = false;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.Quantion.estadisticas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_estadisticas', {
            url  : '/estadisticas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/estadisticas/estadisticas.html',
                    controller : 'EstadisticasController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/estadisticas');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.estadisticas')
            .controller('EstadisticasController', EstadisticasController);

    /** @ngInject */
    function EstadisticasController($scope, quantionApi, $filter, $rootScope, $location, $compile, FilePaths, JSONconfig, $mdDialog)
    {
        var vm = this;
        $rootScope.seccion = 'ESTADISTICAS';
        var pantallaCarga = angular.element(document.getElementById('pantallaCarga')).scope();

        quantionApi.getListaReportes().then(function (dataResponse) {
            vm.listaReportes = $filter('orderBy')(dataResponse.data.Reports.map(function (e) {
                return e.replace('.json', '');
            }));

            if (vm.listaReportes.length > 0) {
                $scope.reportIni = vm.listaReportes[0];

                $scope.inicioBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                $scope.finBusqueda = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
            }

            quantionApi.getStbs(true).then(function (dataResponse) {
                vm.listaStbs = dataResponse.data;
                vm.selectedStbs = [];

                vm.mapStbByMac = {};
                vm.mapStbsById = {};
                $.each(vm.listaStbs, function (index, value) {
                    vm.mapStbByMac[angular.lowercase(value.mac)] = value;
                    vm.mapStbsById[value.idStb] = value;
                });

                quantionApi.getGrupos().then(function (dataResponse) {
                    vm.listaGrupos = dataResponse.data.map(function (elm) {
                        elm.cStbs = $filter('orderBy')(elm.stbs.map(function (elm2) {
                            return vm.mapStbsById[elm2];
                        }), 'room');
                        return elm;
                    });
                    vm.listaGrupos.sort(function (a, b) {
                        return a.orden - b.orden;
                    });
                });

                if ($location.search().idStb) {
                    $scope.selectedOption = 'Individual';
                    $scope.selectedStb = vm.mapStbsById[$location.search().idStb];
                    $scope.finBusqueda = new Date();
                    $scope.CargarEstadisticas($scope.inicioBusqueda, $scope.finBusqueda);
                }
            });

        });

        $scope.inicioBusqueda = new Date();
        $scope.finBusqueda = new Date();

        $scope.CargarEstadisticas = function (inicio, fin) {
            pantallaCarga.lsEnable('LS.ESTADISTICAS');

            $scope.dataError = null;
            if (inicio > fin) {
                vm.completeStatsObj = null;
                $scope.dataError = 'La fecha de inicio debe ser anterior a la fecha de fin';
                pantallaCarga.lsDisable();
                return;
            }

            var getDates = function (startDate, endDate) {
                var dates = [],
                        currentDate = startDate,
                        addDays = function (days) {
                            var date = new Date(this.valueOf());
                            date.setDate(date.getDate() + days);
                            return date;
                        };
                while (currentDate <= endDate) {
                    var formatted = $filter('date')(currentDate, 'yyyy-MM-dd');
                    if (vm.listaReportes.indexOf(formatted) !== -1)
                        dates.push(formatted);
                    currentDate = addDays.call(currentDate, 1);
                }
                return dates;
            };

            var listaReportesSeleccionados = getDates(inicio, fin);

            vm.arrayProcesamiento = [];//Array donde se van concatenando todas las estadísticas, tanto de todos o de un STB
            $scope.arrr = [];
            if ($scope.selectedOption === 'Todos') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento);
            } else if ($scope.selectedOption === 'Varios') {
                CargarReporteTodos(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, vm.selectedStbs);
            } else {
                CargarReporteUnStb(listaReportesSeleccionados, ProcesarEstadisticas, vm.arrayProcesamiento, fin);
            }
        };

        $scope.screenIcons = {
            "HOME": "icon-web",
            "TV_OPENING": "icon-television",
            'TV': "icon-television",
            "CHECK_OUT": "icon-close",
            "SHUTDOWN_AUTH_YES_DOWNLOAD_IMAGE": "icon-cloud-download",
            "OFF": "icon-power",
            "MEDIA": "icon-youtube-play",
            "RADIO": "icon-radio",
            "CONFIG": "icon-cog",
            "SOCIAL": "icon-account-multiple",
            "UNKNOW": "icon-question-mark-circle",
            "FLIST": "icon-cast-connected",
            "READING": "icon-book-open",
            "TOOLS": "icon-grid",
            "SPORTNEWS": "icon-tennis",

            "GAMES": "icon-gamepad-variant",
            "ARCADE": "icon-gamepad-variant",
            "DEPORTES": "icon-gamepad-variant",
            "PUZZLES": "icon-gamepad-variant",
            "SHOOTER": "icon-gamepad-variant",
            "HABILIDAD": "icon-gamepad-variant",
            "AVENTURAS": "icon-gamepad-variant",
            "ESTRATEGIA": "icon-gamepad-variant",
            "CARRERAS": "icon-gamepad-variant"
        };

        /**
         * @param {type} listaReportes Array con los nombres de los ficheros .json
         * @param {type} funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param {type} arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         */
        function CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs) {
            if (listaReportes[0])
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    var rewer = {
                        key: listaReportes[0],
                        value: []
                    };

                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        var inRange = selectedStbs ? selectedStbs.indexOf(value.macStb) !== -1 : true;
                        if (inRange) {
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                            rewer.value.push({
                                key: value.macStb,
                                value: value.AllWindows.Windows
                            });
                        }
                    });

                    $scope.arrr.push(rewer);

                    listaReportes.shift();//Borra el primer elemento del array
                    if (listaReportes[0]) {//Si quedan reportes por leer...
                        CargarReporteTodos(listaReportes, funcionProcesado, arrayCompleto, selectedStbs);
                    } else {//Si ya se han leido todos los reportes
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    }
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            else
                pantallaCarga.lsDisable();
        }

        /**
         * @param listaReportes Array con los nombres de los ficheros .json
         * @param funcionProcesado Función que se va a ejecutar cuando se hayan leido todos los reportes
         * @param arrayCompleto Array donde se van almacenando las estadísticas de los reportes para hacer los recuentos
         * @param fin Fecha del último reporte, y comienzo de la búsqueda individual
         */
        function CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin) {
            if (listaReportes[0]) {//Si quedan reportes por leer...
                quantionApi.getReporte(listaReportes[0]).then(function (dataResponse) {//Para cada reporte, obtenemos el contenido
                    $.each(dataResponse.data, function (index, value) {//Por cada STB
                        if (angular.lowercase($scope.selectedStb.mac) === angular.lowercase(value.macStb)) {
                            $.each(value.AllWindows.Windows, function (index2, value2) {//Por cada estadística de este STB
                                arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                            });
                        }
                    });

                    listaReportes.shift();//Borra el primer elemento del array
                    CargarReporteUnStb(listaReportes, funcionProcesado, arrayCompleto, fin);
                }, function (dataResponse) {
                    console.log(dataResponse);
                    vm.completeStatsObj = null;
                    $scope.dataError = 'No se han encontrado estadísticas';
                    pantallaCarga.lsDisable();
                });
            } else {//Si ya se han leido todos los reportes

                var aux = new Date(vm.listaReportes[vm.listaReportes.length - 1]);
                if (fin > aux) {
                    aux.setDate(aux.getDate() + 1);
                    var aux = ($scope.inicioBusqueda > aux ? $scope.inicioBusqueda : aux);

                    aux.setHours(0);
                    aux.setMinutes(0);
                    aux.setSeconds(0);
                    fin.setHours(23);
                    fin.setMinutes(59);
                    fin.setSeconds(59);

                    quantionApi.getEstadisticasDeStb($scope.selectedStb ? $scope.selectedStb.mac.toLowerCase() : $scope.searchText, aux, fin).then(function (dataResponse) {
                        $.each(dataResponse.data.Windows, function (index2, value2) {//Por cada estadística de este STB
                            arrayCompleto.push(value2);//Añadir a la recopilación de estadísticas
                        });
                        vm.completeStatsObj = funcionProcesado(arrayCompleto);
                        pantallaCarga.lsDisable();
                    });
                } else {
                    vm.completeStatsObj = funcionProcesado(arrayCompleto);
                    pantallaCarga.lsDisable();
                }
            }
        }

        function ProcesarEstadisticas(arrayEstadisticas) {
            var obj = {};

            $.each(arrayEstadisticas, function (idx, elm) {
                var nombre = elm.screen;

                if (!obj[nombre])
                    obj[nombre] = {'info': {}, 'time': 0};
                if (!obj[nombre].info[elm.info])
                    obj[nombre].info[elm.info] = {'shadow': {}, 'time': 0};
                if (!obj[nombre].info[elm.info].shadow[elm.shadow])
                    obj[nombre].info[elm.info].shadow[elm.shadow] = 0;

                elm.fechaFin = new Date(elm.fechaFin);
                elm.fechaIni = new Date(elm.fechaIni);
                var diferencia = (elm.fechaFin - elm.fechaIni) / 1000;
                obj[nombre].info[elm.info].shadow[elm.shadow] += diferencia;
                obj[nombre].info[elm.info].time += diferencia;
                obj[nombre].time += diferencia;
            });

            $.each(obj, function (key, value) {
                value.inArray = $.map(value.info, function (value, key) {
                    return{
                        channel: key,
                        shadow: $.map(value.shadow, function (value, key) {
                            return{
                                key: key,
                                value: value
                            };
                        }),
                        time: value.time
                    };
                });
            });

            $.each($scope.arrr, function (idx, r) {

                $.each(r.value, function (idx, rr) {
                    var asdf = {};

                    $.each(rr.value, function (idx, elm) {
                        var nombre = elm.screen;

                        if (!asdf[nombre])
                            asdf[nombre] = {'info': {}, 'time': 0};
                        if (!asdf[nombre].info[elm.info])
                            asdf[nombre].info[elm.info] = {'shadow': {}, 'time': 0};
                        if (!asdf[nombre].info[elm.info].shadow[elm.shadow])
                            asdf[nombre].info[elm.info].shadow[elm.shadow] = 0;

                        elm.fechaFin = new Date(elm.fechaFin);
                        elm.fechaIni = new Date(elm.fechaIni);
                        var diferencia = (elm.fechaFin - elm.fechaIni) / 1000;
                        asdf[nombre].info[elm.info].shadow[elm.shadow] += diferencia;
                        asdf[nombre].info[elm.info].time += diferencia;
                        asdf[nombre].time += diferencia;
                    });
                    rr.a = asdf;
                })
            });

            if ($scope.selectedOption === 'Individual') {
                $scope.singleStbTimeline = arrayEstadisticas;

                pintarTimeline($scope.singleStbTimeline);
            } else {
                $scope.singleStbTimeline = null;
                $('#timeline-container').empty();
                $compile($('#timeline-container'))($scope);
            }

            return obj;
        }

        $scope.querySearch = function (query) {
            var results = query ? vm.listaStbs.filter(function (hab) {
                var lowercaseQuery = angular.lowercase(query);
                return (angular.lowercase(hab.room.toString()).indexOf(lowercaseQuery) !== -1 || angular.lowercase(hab.username).indexOf(lowercaseQuery) !== -1);
            }) : vm.listaStbs;
            return results;
        };

        $scope.openShadow = function (elm) {
            if (!elm.view)
                elm.view = true;
        };

        $scope.closeShadow = function (elm) {
            if (elm.view)
                elm.view = false;
        };

        function pintarTimeline(timeline) {
            var html = '';

            $.each(timeline, function (index, stat) {
                html += (
                        '<div layout="row">' +
                        (index > 0 ? '<md-icon md-font-icon="icon-chevron-right"></md-icon>' : '') +
                        '   <div class="stat-box ' + stat.screen + '" layout="row">' +
                        ($scope.screenIcons[stat.screen] ? '       <md-icon md-font-icon="' + $scope.screenIcons[stat.screen] + '"></md-icon>' : '<img src="' + JSONconfig.logosPath.to + '/' + FilePaths.servicios_paquetes + '/' + angular.lowercase(stat.screen) + '.png"/>') +
                        '       <div layout="column">' +
                        '           <span class="text-bold">' + ($filter('translateStat')(stat.screen).trim() || "?") + '</span>' +
                        '           <span>' + (stat.info.trim() || "?") + '</span>' +
                        '           <span class="advanced">' + (stat.shadow.trim() || "?") + '</span>' +
                        '           <span class="advanced">' + (stat.status.trim() || "?") + '</span>' +
                        '           <span>' + $filter('convertSeconds')((stat.fechaFin - stat.fechaIni) / 1000, true) + '</span>' +
                        '       </div>' +
                        '       <md-tooltip md-direction="left">' + $filter('date')(stat.fechaIni, 'dd/MM/yy HH:mm:ss') + '</md-tooltip>' +
                        '       <md-tooltip md-direction="right">' + $filter('date')(stat.fechaFin, 'dd/MM/yy HH:mm:ss') + '</md-tooltip>' +
                        '   </div>' +
                        '</div>'
                        );
            });

            $('#timeline-container').empty().append(html);
            $compile($('#timeline-container'))($scope);
        }

        vm.asignarStbs = function (ev) {
            $mdDialog.show({
                controller: AsignarStbCtrl,
                templateUrl: 'app/main/Quantion/estadisticas/instantanea/templates/asignarStb.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function AsignarStbCtrl($scope, $mdDialog, $mdToast) {
            $scope.selectedStbs = vm.selectedStbs;
            $scope.allStbs = vm.listaStbs;
            $scope.listaGrupos = angular.copy(vm.listaGrupos);

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1)
                    list.splice(idx, 1);
                else
                    list.push(item);
            };

            $scope.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };

            $scope.initRange = function () {
                $scope.range = true;
                $scope.rangeIni = null;
                $scope.rangeFin = null;
                $scope.groupRange = null;
            };

            $scope.selectRange = function (index, group) {
                if ($scope.rangeIni === null) {
                    $scope.rangeIni = index;
                    $scope.groupRange = group;
                } else if (!$scope.rangeFin) {
                    if ($scope.groupRange === group) {
                        $scope.rangeFin = index;

                        var min = Math.min($scope.rangeIni, $scope.rangeFin);
                        var max = Math.max($scope.rangeIni, $scope.rangeFin);

                        for (var i = min; i <= max; i++) {
                            if ($scope.selectedStbs.indexOf($scope.allStbs[i].mac) === -1) {
                                $scope.selectedStbs.push($scope.allStbs[i].mac);
                            }
                        }
                    }

                    $scope.range = false;
                    $scope.rangeIni = null;
                    $scope.rangeFin = null;
                }
            };

            $scope.marcarGrupo = function (grupo, bool) {
                $.each(grupo.cStbs, function (index, value) {
                    if (bool === true && !$scope.exists(value.mac, $scope.selectedStbs))
                        $scope.selectedStbs.push(value.mac);

                    if (bool === false && $scope.exists(value.mac, $scope.selectedStbs)) {
                        var idx = $scope.selectedStbs.indexOf(value.mac);
                        $scope.selectedStbs.splice(idx, 1);
                    }
                });
            };

            $scope.selectAll = function (value) {
                if (value) {
                    $scope.selectedStbs = $scope.allStbs.map(function (e) {
                        return e.mac;
                    });
                } else {
                    $scope.selectedStbs = [];
                }
                vm.selectedStbs = $scope.selectedStbs;
            };
        }

        $scope.downloadCsv = function (property) {
            var rooms = [];
            var text = '';

            $scope.arrr.forEach(function (date) {
                rooms = rooms.concat(date.value.map(function (e) {
                    var stb = vm.mapStbByMac[e.key.toLowerCase()];

                    return stb ? stb.room : null;
                }));
            });

            var roomsUnique = rooms.filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });
            roomsUnique.sort();

            text = "," + roomsUnique.join(',') + '\n';

            $scope.arrr.forEach(function (date) {
                text += date.key + ',';
                roomsUnique.forEach(function (r) {
                    var b = date.value.find(function (o) {
                        var a1 = vm.mapStbByMac[o.key.toLowerCase()];
                        return a1 && a1.room === r;
                    });

                    if (b && b.a && b.a[property] && b.a[property].time) {
                        text += (Math.ceil(b.a[property].time/3600) + ',');
                    } else {
                        text += '0,';
                    }
                });
                text += '\n';
            });

            var a = document.createElement('a');
            var csvData = new Blob([text], {type: 'text/csv'});
            var csvUrl = URL.createObjectURL(csvData);
            a.href = csvUrl;
            a.download = 'report.csv';
            a.click();
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion.administradorCajeros', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
                .state('app.Quantion_administradorCajeros', {
                    url: '/administradorCajeros',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/Quantion/administradorCajeros/administradorCajeros.html',
                            controller: 'administradorCajerosController as vm'
                        }
                    },
                    data: {
                        authorization: true
                    }
                })
                .state('app.Quantion_administradorCajeros_mandos', {
                    url: '/administradorCajeros/:installation/mandos',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/Quantion/administradorCajeros/views/mandos.html',
                            controller: 'MandosController'
                        }
                    },
                    data: {
                        authorization: true
                    }
                })
                .state('app.Quantion_administradorCajeros_paquetes', {
                    url: '/administradorCajeros/:installation/paquetes',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/Quantion/administradorCajeros/views/paquetes.html',
                            controller: 'PaqueteController'
                        }
                    },
                    data: {
                        authorization: true
                    }
                })
                .state('app.Quantion_administradorCajeros_tarjetas', {
                    url: '/administradorCajeros/:installation/tarjetas',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/Quantion/administradorCajeros/views/tarjetas.html',
                            controller: 'TarjetasController'
                        }
                    },
                    data: {
                        authorization: true
                    }
                })
                .state('app.Quantion_administradorCajeros_sumup', {
                    url: '/administradorCajeros/:installation/sumup',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/Quantion/administradorCajeros/views/sumup.html',
                            controller: 'CajeroSumupController'
                        }
                    },
                    data: {
                        authorization: true
                    }
                });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/administradorCajeros');
    }

})();
(function () {

    angular.module('app.Quantion.administradorCajeros')

            .factory('socketService', function () {

                function start(callback, urlWebSockets) {

                    var ws = new WebSocket(urlWebSockets);
//                    var ws = new WebSocket('prueba');

                    ws.onopen = function () {
                        console.log('Conexion establecida con ' + urlWebSockets);
                    };

                    ws.onmessage = function (evt) {
                        callback(evt);
                    };

                    ws.onclose = function (evt) {
                        callback(evt);
                        console.log('Conexion cerrada');
                    };
                }

                return {
                    start: start
                };
            });
})();
(function () {

    angular
            .module('app.Quantion.administradorCajeros')
            .factory('cajeroSumupService', ['$http', '$q', function ($http, $q) {

                    var baseUrl = "https://tickets.joyclinic.es/api/proxy?url=";

                    function restart(ip, port) {
                        var deferred = $q.defer();

                        var host = baseUrl + ip + ':' + port + '/restart';

                        $http.put(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function reboot(ip, port) {
                        var deferred = $q.defer();

                        var host = baseUrl + ip + ':' + port + '/reboot';

                        $http.put(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function status(ip, port) {
                        var deferred = $q.defer();

                        var host = baseUrl + ip + ':' + port + '/status';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function statusFservicio(ip, port) {
                        return $http({
                            method: 'GET',
                            url: baseUrl + ip + ':' + port + '/out-of-service/status',
                        });
                    }

                    function startFservicio(ip, port) {
                        return $http({
                            method: 'PUT',
                            url: baseUrl + ip + ':' + port + '/out-of-service/enable',
                        });
                    }

                    function stopFservicio(ip, port) {
                        return $http({
                            method: 'PUT',
                            url: baseUrl + ip + ':' + port + '/out-of-service/disable'
                        });
                    }
                    
                    function getInfo(ip, port) {
                        return $http({
                            method: 'GET',
                            url: baseUrl + ip + ':' + port + '/info'
                        });
                    }
                    
                    function screenshot(ip, port, size) {
                        return $http({
                            method: 'GET',
                            url: baseUrl + ip + ':' + port + '/screenshot/' + size
                        });
                    }
                    
                    function getSumupMode(ip, port) {
                        return $http({
                            method: 'GET',
                            url: baseUrl + ip + ':' + port + '/sumup/mode'
                        });
                    }
                    
                    function updateSumupMode(ip, port, mode) {
                        return $http({
                            method: 'PUT',
                            url: baseUrl + ip + ':' + port + '/sumup/mode/' + mode
                        });
                    }

                    return {
                        restart: restart,
                        reboot: reboot,
                        status: status,
                        statusFservicio: statusFservicio,
                        startFservicio: startFservicio,
                        stopFservicio: stopFservicio,
                        getInfo: getInfo,
                        screenshot: screenshot,
                        getSumupMode: getSumupMode,
                        updateSumupMode: updateSumupMode,
                    };
                }]);

})();

(function () {

    angular
            .module('app.Quantion.administradorCajeros')
            .factory('cajeroService', ['$http', '$q', function ($http, $q) {

                    function start(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/iniciar';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function reboot(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/reboot';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function rebootOCX(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/reiniciar';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function rebootRele(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/rele';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function toggle(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/trampilla/toggle';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function rebootPaquetes(ip) {
                        var deferred = $q.defer();

                        var host = ip + ':7410/reboot';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function end(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/finalizar';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function disponibilidad(ip, port, uID, value) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/mando/disponibilidad/' + uID + '/' + value;

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function getMando(ip, port, uID) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/mando/consulta/' + uID;

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function dispensar(ip, port, type, message) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/dispensa/gratis/' + type;

                        var req = {
                            method: 'POST',
                            url: host,
                            headers: {
                                'Content-Type': 'text/plain'
                            },
                            data: message
                        }
                        $http(req)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function pagar(ip, port, cantidad, message) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/pagar/gratis/' + cantidad;

                        var req = {
                            method: 'POST',
                            url: host,
                            headers: {
                                'Content-Type': 'text/plain'
                            },
                            data: message
                        }

                        $http(req)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function marcarPagado(ip, port, idOperacion) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/operacion/recoger/pagado/' + idOperacion + '/true';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function mandos(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/mando';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function cantidadMandos(ip, port, type) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/tipo/cantidad/' + type;

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function existeMandos(ip, port, type) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/tolva';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function data(file)
                    {
                        var deferred = $q.defer();

                        $http.get(file)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function allType(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/tipo';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function status(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/estado';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function saldo(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/saldo';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function logDispensar(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/operacion/dispensar/limite/0/20';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function logDispensarFecha(ip, port, fInicio, fFin) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/operacion/dispensar/fecha/' + fInicio + '/' + fFin;

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function logRecoger(ip, port) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/operacion/recoger/limite/0/20';

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function logRecogerFecha(ip, port, fInicio, fFin) {
                        var deferred = $q.defer();

                        var host = ip + ':' + port + '/operacion/recoger/fecha/' + fInicio + '/' + fFin;

                        $http.get(host)
                                .success(function (data) {
                                    deferred.resolve(data);
                                })
                                .error(function (data) {
                                    deferred.reject(data)
                                });

                        return deferred.promise;
                    }

                    function startFservicio(ip, port, mensaje) {
                        if (mensaje)
                            return $http({
                                method: 'POST',
                                url: ip + ':' + port + '/fservicio/start',
                                data: mensaje
                            });
                        else
                            return $http({
                                method: 'GET',
                                url: ip + ':' + port + '/fservicio/start'
                            });
                    }

                    function stopFservicio(ip, port) {
                        return $http({
                            method: 'GET',
                            url: ip + ':' + port + '/fservicio/stop'
                        });
                    }

                    function listLogs(ip) {
                        return $http({
                            method: 'GET',
                            url: ip + ':20001/list'
                        });
                    }

                    function openLog(ip, key, value) {
                        return $http({
                            method: 'GET',
                            url: ip + ':20001/open/' + key + '/' + value
                        });
                    }

                    function reprintTicket(ip, port, json) {
                        return $http({
                            method: 'POST',
                            url: ip + ':' + port + '/imprimir',
                            data: json
                        });
                    }

                    return {
                        start: start,
                        reboot: reboot,
                        rebootOCX: rebootOCX,
                        rebootRele: rebootRele,
                        toggle: toggle,
                        rebootPaquetes: rebootPaquetes,
                        end: end,
                        disponibilidad: disponibilidad,
                        getMando: getMando,
                        dispensar: dispensar,
                        pagar: pagar,
                        mandos: mandos,
                        cantidadMandos: cantidadMandos,
                        existeMandos: existeMandos,
                        allType: allType,
                        data: data,
                        status: status,
                        saldo: saldo,
                        logDispensar: logDispensar,
                        logDispensarFecha: logDispensarFecha,
                        logRecoger: logRecoger,
                        logRecogerFecha: logRecogerFecha,
                        startFservicio: startFservicio,
                        stopFservicio: stopFservicio,
                        listLogs: listLogs,
                        openLog: openLog,
                        reprintTicket: reprintTicket
                    };
                }]);

})();

(function () {
    'use strict';

    angular
        .module('app.Quantion.administradorCajeros')
        .controller('administradorCajerosController', administradorCajerosController);

    /** @ngInject */
    function administradorCajerosController(quantionApi, $mdDialog, $mdToast, $rootScope, $scope, $filter, cajeroService) {
        var vm = this;
        $rootScope.seccion = 'ADMINISTRADORCAJEROS';

        quantionApi.getAtm().then(function (dataResponse) {
            $scope.cajeros = $filter('orderBy')(dataResponse.data.filter(function (e) {
                return e.config !== null && (e.synchronizeDatabase || e.type === 'sumup');
            }), 'model');
        });

        $scope.copyIp = function (cajero) {
            var input = document.getElementById("caj-ip-" + cajero.idAtm);
            input.select();

            if (document.execCommand) {
                try {
                    // Copiando el texto seleccionado
                    var successful = document.execCommand('copy');

                    if (successful)
                        $mdToast.show($mdToast.simple().textContent('IP copiada al portapapeles').position('top right').hideDelay(3000));
                    else
                        $mdToast.show($mdToast.simple().textContent('No se pudo copiar la IP al portapapeles').position('top right').hideDelay(3000));
                } catch (err) {
                    $mdToast.show($mdToast.simple().textContent('Navegador no compatible').position('top right').hideDelay(3000));
                }
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(cajero.config.ipVnc)
                    .then(function () {
                        $mdToast.show($mdToast.simple().textContent('IP copiada al portapapeles').position('top right').hideDelay(3000));
                    })
                    .catch(function () {
                        $mdToast.show($mdToast.simple().textContent('No se pudo copiar la IP al portapapeles').position('top right').hideDelay(3000));
                    })
            } else {
                $mdToast.show($mdToast.simple().textContent('Navegador no compatible').position('top right').hideDelay(3000));
            }
        };

        $scope.copyPass = function (cajero) {
            var input = document.getElementById("caj-pass-" + cajero.idAtm);
            input.select();

            if (document.execCommand) {
                try {
                    // Copiando el texto seleccionado
                    var successful = document.execCommand('copy');

                    if (successful)
                        $mdToast.show($mdToast.simple().textContent('Contraseña copiada al portapapeles').position('top right').hideDelay(3000));
                    else
                        $mdToast.show($mdToast.simple().textContent('No se pudo copiar la contraseña al portapapeles').position('top right').hideDelay(3000));
                } catch (err) {
                    $mdToast.show($mdToast.simple().textContent('Navegador no compatible').position('top right').hideDelay(3000));
                }
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(cajero.config.passVnc)
                    .then(function () {
                        $mdToast.show($mdToast.simple().textContent('IP copiada al portapapeles').position('top right').hideDelay(3000));
                    })
                    .catch(function () {
                        $mdToast.show($mdToast.simple().textContent('No se pudo copiar la IP al portapapeles').position('top right').hideDelay(3000));
                    })
            } else {
                $mdToast.show($mdToast.simple().textContent('Navegador no compatible').position('top right').hideDelay(3000));
            }
        };

        $scope.logs = function (cajero) {
            $mdDialog.show({
                controller: LogsCtrl,
                templateUrl: 'app/main/Quantion/administradorCajeros/views/logs.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: { cajero: cajero }
            });

        };

        function LogsCtrl($scope, $mdDialog, $mdToast, cajero) {
            $scope.cajero = cajero;

            cajeroService.listLogs(cajero.config.ip).then(function (dataResponse) {
                console.log(cajero);
                $scope.logObject = dataResponse.data;
            }, function () {
                $scope.error = 'No se han podido obtener los datos';
            });

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }

})();

(function () {

    angular
        .module('app.Quantion.administradorCajeros')
        .controller('PaqueteController', PaqueteCtrl)
        .controller('TarjetasController', TarjetasCtrl)
        .controller('CajeroSumupController', CajeroSumupCtrl);

    function PaqueteCtrl($mdDialog, $stateParams, cajeroService, $scope, $rootScope, $state, quantionApi) {

        $rootScope.seccion = 'ADMINISTRADORCAJEROS';

        quantionApi.getAtm($stateParams.installation).then(function (dataResponse) {
            $scope.CAJERO = dataResponse.data.config;

            checkStatus($scope.CAJERO.ip, $scope.CAJERO.port);
            checkSaldo($scope.CAJERO.ip, $scope.CAJERO.port);
        }, function () {
            $state.go('app.Quantion_administradorCajeros');
        });

        $scope.on = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Encender cajero?')
                .ok('Encender')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.start($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log('Se está encendiendo');
                });
                console.log("Encendiendo");
            }, function () {

            });
        };

        $scope.reboot = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Reiniciar cajero?')
                .ok('Reiniciar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.reboot($scope.CAJERO.ip, $scope.CAJERO.portApi).then(function (res) {
                    console.log('Se está reiniciando');
                });
                console.log("Reiniciando");
            }, function () {

            });
        };

        $scope.off = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Apagar cajero?')
                .ok('Apagar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.end($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log("Se está apagando");
                });
                console.log("Apagando");
            }, function () {

            });
        };

        function checkStatus(ip, port) {
            cajeroService.status(ip, port).then(function (res) {
                $scope.status = res.data;

                var now = Date.now();

                $scope.status.tiempoOnline.enInicio = new Date(now - $scope.status.tiempoOnline.enInicio * 1000);
            });
        }

        function checkSaldo(ip, port) {
            cajeroService.saldo(ip, port).then(function (res) {
                $scope.pagadores = res.data.pagadores;
                $scope.nopagadores = res.data.nopagadores;
            });
        }
    }

    function TarjetasCtrl($mdDialog, $stateParams, cajeroService, $scope, $rootScope, $state, $timeout, quantionApi) {

        $rootScope.seccion = 'ADMINISTRADORCAJEROS';

        quantionApi.getAtm($stateParams.installation).then(function (dataResponse) {
            $scope.CAJERO = dataResponse.data.config;

            checkStatus($scope.CAJERO.ip, $scope.CAJERO.port);
            checkSaldo($scope.CAJERO.ip, $scope.CAJERO.port);
        }, function () {
            $state.go('app.Quantion_administradorCajeros');
        });

        $scope.on = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Encender cajero?')
                .ok('Encender')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.start($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log('Se está encendiendo');

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Mandado encendido')
                            .ok('Cerrar')
                    );
                });
                console.log("Encendiendo");
            }, function () {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No se ha podido completar la acción, inténtelo de nuevo')
                        .ok('Cerrar')
                );
            });
        };

        $scope.reboot = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Reiniciar cajero?')
                .ok('Reiniciar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.reboot($scope.CAJERO.ip, $scope.CAJERO.portApi).then(function (res) {
                    console.log('Se está reiniciando');

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Mandado reinicio')
                            .ok('Cerrar')
                    );
                });
                console.log("Reiniciando");
            }, function () {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No se ha podido completar la acción, inténtelo de nuevo')
                        .ok('Cerrar')
                );
            });
        };

        $scope.rebootOCX = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Reiniciar OCX del cajero?')
                .ok('Reiniciar OCX')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.rebootOCX($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log('Se está reiniciando el OCX');

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Mandado reinicio de OCX')
                            .ok('Cerrar')
                    );
                });
                console.log("Reiniciando");
            }, function () {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No se ha podido completar la acción, inténtelo de nuevo')
                        .ok('Cerrar')
                );
            });
        };

        $scope.rebootRele = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Reiniciar cajero de corriente (mediante el relé)?')
                .textContent('También se reiniciará el PC del cajero en 5 segundos')
                .ok('Reiniciar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.rebootRele($scope.CAJERO.ip, $scope.CAJERO.portApi).then(function (res) {
                    console.log('Se está reiniciando el relé');

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Mandado reinicio de relé')
                            .ok('Cerrar')
                    );

                    $timeout(function () {
                        cajeroService.reboot($scope.CAJERO.ip, $scope.CAJERO.portApi).then(function (res) {
                            console.log('Se está reiniciando');

                            $mdDialog.show(
                                $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title('Mandado reinicio de miniPc')
                                    .ok('Cerrar')
                            );
                        });
                    }, 5000);
                });
                console.log("Reiniciando");
            }, function () {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No se ha podido completar la acción, inténtelo de nuevo')
                        .ok('Cerrar')
                );
            });
        };

        $scope.off = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Apagar cajero?')
                .ok('Apagar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.end($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log("Se está apagando");

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Mandado apagado')
                            .ok('Cerrar')
                    );
                });
                console.log("Apagando");
            }, function () {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No se ha podido completar la acción, inténtelo de nuevo')
                        .ok('Cerrar')
                );
            });
        };

        function checkStatus(ip, port) {
            cajeroService.status(ip, port).then(function (res) {
                $scope.status = res.data;

                var now = Date.now();

                $scope.status.tiempoOnline.enInicio = new Date(now - $scope.status.tiempoOnline.enInicio * 1000);
            });
        }

        function checkSaldo(ip, port) {
            cajeroService.saldo(ip, port).then(function (res) {
                $scope.pagadores = res.data.pagadores;
                $scope.nopagadores = res.data.nopagadores;
            });
        }

        $scope.startFservicio = function () {
            $mdDialog.show({
                controller: MensajeCtrl,
                templateUrl: 'app/main/Quantion/administradorCajeros/views/mensajeFservicio.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: $scope.CAJERO
                }
            });
        };

        function MensajeCtrl($scope, $mdDialog, cajero) {
            $scope.enviar = function (mensaje) {
                $scope.isLoading = true;

                cajeroService.startFservicio(cajero.ip, cajero.port, mensaje).then(function (res) {
                    console.log("Puesta la pantalla de fuera de servicio");

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Activado fuera de servicio')
                            .ok('Cerrar')
                    );

                    $mdDialog.hide();
                    checkStatus($scope.CAJERO.ip, $scope.CAJERO.port);
                }, function () {
                    $scope.isLoading = false;

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
                console.log("Poniendo");
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        $scope.stopFservicio = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Quitar pantalla de "Fuera de Servicio"?')
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                cajeroService.stopFservicio($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log("Quitada pantalla de fuera de servicio");

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Desactivado fuera de servicio')
                            .ok('Cerrar')
                    );

                    checkStatus($scope.CAJERO.ip, $scope.CAJERO.port);
                }, function () {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
                console.log("Quitando");
            }, function () {

            });
        };
    }

    function CajeroSumupCtrl($mdDialog, $stateParams, cajeroSumupService, $scope, $rootScope, $state, $timeout, quantionApi) {

        $rootScope.seccion = 'ADMINISTRADORCAJEROS';

        quantionApi.getAtm($stateParams.installation).then(function (dataResponse) {
            $scope.CAJERO = dataResponse.data.config;

            checkStatus($scope.CAJERO.ip, $scope.CAJERO.port);
            checkInfo($scope.CAJERO.ip, $scope.CAJERO.port);
            statusFservicio($scope.CAJERO.ip, $scope.CAJERO.port);
            getScreenshot($scope.CAJERO.ip, $scope.CAJERO.port);
            getSumupMode($scope.CAJERO.ip, $scope.CAJERO.port);
        }, function () {
            $state.go('app.Quantion_administradorCajeros');
        });

        $scope.reboot = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Reiniciar cajero?')
                .ok('Reiniciar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroSumupService.reboot($scope.CAJERO.ip, $scope.CAJERO.portApi).then(function (res) {
                    console.log('Se está reiniciando');

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Reinicio enviado')
                            .ok('Cerrar')
                    );
                }, function () {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
                console.log("Reiniciando");
            });
        };

        $scope.restart = function () {
            var confirm = $mdDialog.confirm()
                .title('Recargar interfaz del cajero?')
                .ok('Recargar')
                .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroSumupService.restart($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log('Se está recargando');

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Recarga de interfaz enviada')
                            .ok('Cerrar')
                    );
                }, function () {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
                console.log("Reiniciando");
            });
        };

        function checkStatus(ip, port) {
            cajeroSumupService.status(ip, port).then(function (res) {
                $scope.status = true;
            }, function (error) {
                $scope.status = false;
            });
        }

        function checkInfo(ip, port) {
            cajeroSumupService.getInfo(ip, port).then(function (res) {
                $scope.info = res.data;
                var now = Date.now();
                $scope.info.tiempoOnline = new Date(now - $scope.info.uptime * 1000);
            }, function (error) {
                $scope.info = null;
            });
        }

        function statusFservicio(ip, port) {
            cajeroSumupService.statusFservicio(ip, port).then(function (res) {
                $scope.fueraServicio = res.data.status;
            }, function (error) {
                console.log(error)
            })
        }

        $scope.startFservicio = function () {
            $mdDialog.show({
                controller: MensajeCtrl,
                templateUrl: 'app/main/Quantion/administradorCajeros/views/mensajeFservicioSinMensaje.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    cajero: $scope.CAJERO
                }
            });
        };

        function MensajeCtrl($scope, $mdDialog, cajero) {
            $scope.enviar = function () {
                $scope.isLoading = true;

                cajeroSumupService.startFservicio(cajero.ip, cajero.port).then(function (res) {
                    console.log("Puesta la pantalla de fuera de servicio");

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Activado fuera de servicio')
                            .ok('Cerrar')
                    );

                    $mdDialog.hide();

                    statusFservicio(cajero.ip, cajero.port);
                }, function () {
                    $scope.isLoading = false;

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
            };

            $scope.hide = function () {
                $mdDialog.hide();
            };
        }

        $scope.stopFservicio = function () {
            var confirm = $mdDialog.confirm()
                .title('¿Quitar pantalla de "Fuera de Servicio"?')
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                cajeroSumupService.stopFservicio($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log("Quitada pantalla de fuera de servicio");

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Desactivado fuera de servicio')
                            .ok('Cerrar')
                    );

                    statusFservicio($scope.CAJERO.ip, $scope.CAJERO.port);
                }, function () {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
            });
        };

        function getScreenshot(ip, port) {
            $scope.screenshotLoading = true;
            cajeroSumupService.screenshot(ip, port, 20).then(function (res) {
                $scope.screenshot = res.data;
                $scope.screenshotLoading = false;
            }, function (error) {
                console.log(error)
                $scope.screenshot = null;
                $scope.screenshotLoading = false;
            })
        }

        $scope.getScreenshot = function () {
            getScreenshot($scope.CAJERO.ip, $scope.CAJERO.port)
        };

        function getSumupMode(ip, port) {
            cajeroSumupService.getSumupMode(ip, port, 20).then(function (res) {
                $scope.sumupMode = res.data.mode;
            }, function (error) {
                console.log(error)
                $scope.sumupMode = null;
            })
        }

        $scope.getSumupMode = function () {
            getSumupMode($scope.CAJERO.ip, $scope.CAJERO.port)
        };

        $scope.updateSumupMode = function (mode) {
            var confirm = $mdDialog.confirm()
                .title('¿Cambiar a modo "' + mode + '"?')
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                cajeroSumupService.updateSumupMode($scope.CAJERO.ip, $scope.CAJERO.port, mode).then(function (res) {

                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Cambiado a modo "' + mode + '" correctamente')
                            .ok('Cerrar')
                    );

                    getSumupMode($scope.CAJERO.ip, $scope.CAJERO.port);
                }, function () {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No se ha podido completar la acción, inténtelo de nuevo')
                            .ok('Cerrar')
                    );
                });
            });
        }
    }

})();
(function () {

    angular
            .module('app.Quantion.administradorCajeros')
            .controller('MandosController', MandosCtrl);

    function MandosCtrl($mdDialog, socketService, $stateParams, cajeroService, $scope, $rootScope, $state, $filter, quantionApi) {

        $rootScope.seccion = 'ADMINISTRADORCAJEROS';

        $scope.fInicio = new Date();
        $scope.fFin = new Date();
        $scope.fFin.setDate($scope.fInicio.getDate() + 1);
        $scope.isLoading1 = true;
        $scope.isLoading2 = true;
        $scope.isLoading3 = true;

        quantionApi.getAtm($stateParams.installation).then(function (dataResponse) {
            $scope.CAJERO = dataResponse.data.config;
            $scope.CAJERO.id = dataResponse.data.idAtm;

            checkStatus($scope.CAJERO.ip, $scope.CAJERO.port);
            checkSaldo($scope.CAJERO.ip, $scope.CAJERO.port);
            checkLog($scope.CAJERO.ip, $scope.CAJERO.port);
            checkType($scope.CAJERO.ip, $scope.CAJERO.port);

            $scope.CAJERO.cuponNoUsado = dataResponse.data.cuponNoUsado;

            quantionApi.getReporteAtmClientRc({fromDate: $scope.fInicio, toDate: $scope.fFin}).then(function (dataResponse) {
                var a = dataResponse.data.atm.filter(function (elm) {
                    return elm.idAtm === $scope.CAJERO.id;
                });

                $scope.CAJERO.cupon = a[0] ? a[0].cupon : [];
            });

            init();
        }, function () {
            $state.go('app.Quantion_administradorCajeros');
        });

        function init() {
            //Test con sockets (en proceso)
            socketService.start(function (evt) {
                var obj = JSON.parse(evt.data);
                var evento = obj.data;

                $scope.$apply(function () {
                    $scope.msg = obj.data;
                });

                if (!evento)
                {
                    //Cajero Apagado
                    console.log('Apagado')
                    $scope.status.cajeroIniciado = !$scope.status.cajeroIniciado;
                } else if (evento.name === 'FinIniciar')
                {
                    console.log($scope.status.cajeroIniciado)
                    $scope.status.cajeroIniciado = true;
                } else if (evento.name === 'FinFinalizar')
                {
                    console.log($scope.status.cajeroIniciado)
                    $scope.status.cajeroIniciado = false;

                } else if (evento.name === 'trampillaAbierta')
                {
                    console.log($scope.status.cajeroIniciado)
                    $scope.status.trampillaAbierta = !$scope.status.trampillaAbierta;
                } else if (evento.name === "ImporteCobrado")
                {
                    var cantidad = evento.importe;
                    if (evento.dispositivo.description === "BILLETERO")
                    {
                        $scope.pagadores.billetes[cantidad] = $scope.pagadores.billetes[cantidad] + 1;
                    } else if (evento.dispositivo.description === "HOPPER")
                    {
                        $scope.nopagadores.stacker[cantidad] = $scope.nopagadores.stacker[cantidad] + 1;
                    }
                    console.log('Se ha incrementado los billetes de' + cantidad)
                } else if (evento.name === "ImportePagado")
                {
                    var cantidad = evento.importe;
                    if (evento.dispositivo.description === "RECICLADOR BILLETES")
                    {
                        $scope.pagadores.billetes[cantidad] = $scope.pagadores.billetes[cantidad] - 1;
                    } else if (evento.dispositivo.description === "HOPPER")
                    {
                        $scope.pagadores.hopper[cantidad] = $scope.pagadores.hopper[cantidad] - 1;
                    }

                    console.log('Se ha decrementado los billetes de ' + cantidad)
                } else if (evento.name === "MandoDetectado")
                {
                    console.log("Se ha detectado un mando!!")
                    //Se ha dispensado un mando
                } else if (evento.name === "MandoRecogido")
                {
                    $scope.status.uidMando = evento.uID;
                    cajeroService.getMando($scope.CAJERO.ip, $scope.CAJERO.port, $scope.status.uidMando)
                            .then(function (res) {
                                $scope.mandoStatus = res.data[0]
                            });
                    console.log("Mando recogido correctamente")
                    //Se ha dispensado un mando
                } else if (evento.name === "MandoEntregado")
                {
                    console.log("Se ha entregado un mando!!")
                    if (evento.tipo === 1)
                    {
                        $scope.cantidad1.number = $scope.cantidad1.number - 1;
                    } else if (evento.tipo === 2)
                    {
                        $scope.cantidad2.number = $scope.cantidad1.number - 1;
                    }
                    //Se ha dispensado un mando
                } else if (evento.name === "Lectura")
                {
                    console.log('leido')
                    console.log(evento.uID)
                    $scope.status.uidMando = evento.uID;
                    cajeroService.getMando($scope.CAJERO.ip, $scope.CAJERO.port, $scope.status.uidMando)
                            .then(function (res) {
                                $scope.mandoStatus = res.data[0]
                            });
                }
            }, $scope.CAJERO.urlWebSockets);

            cajeroService.mandos($scope.CAJERO.ip, $scope.CAJERO.port, $scope.type)
                    .then(function (res) {
                        $scope.mandos = res.data;
                        $scope.isLoading3 = false;
                    }, function () {
                        $scope.mandos = [];
                        $scope.isLoading3 = false;
                    });
        }

        $scope.on = function () {
            var confirm = $mdDialog.confirm()
                    .title('¿Encender cajero?')
                    .ok('Encender')
                    .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.start($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log('Se está encendiendo');
                });
                console.log("Encendiendo");
            }, function () {

            });
        };

        $scope.reboot = function () {
            var confirm = $mdDialog.confirm()
                    .title('¿Reiniciar cajero?')
                    .ok('Reiniciar')
                    .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.reboot($scope.CAJERO.ip, $scope.CAJERO.portApi).then(function (res) {
                    console.log('Se está reiniciando');
                });
                console.log("Reiniciando");
            }, function () {

            });
        };

        $scope.changeDisp = function () {
            cajeroService.disponibilidad($scope.CAJERO.ip, $scope.CAJERO.port, $scope.status.uidMando, $scope.mandoStatus.isAvailable).then(function () {
                console.log('Cambiada disponibilidad del mando ' + $scope.status.uidMando);
            });
        };

        $scope.toggleTrampilla = function () {
            cajeroService.toggle($scope.CAJERO.ip, $scope.CAJERO.port).then(function () {
                console.log('Switch trampilla');
            });
        };

        $scope.off = function () {
            var confirm = $mdDialog.confirm()
                    .title('¿Apagar cajero?')
                    .ok('Apagar')
                    .cancel('Volver');
            $mdDialog.show(confirm).then(function () {
                cajeroService.end($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    console.log("Se está apagando");
                });
                console.log("Apagando");
            }, function () {

            });
        };

        $scope.dispensar = function (ev) {
            $mdDialog.show({
                controller: DispensarController,
                templateUrl: 'app/main/Quantion/administradorCajeros/views/dispensar.tmpl.html',
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                locals: {
                    cajero: $scope.CAJERO,
                    type: $scope.type
                }
            });
        };

        function DispensarController($scope, $mdDialog, cajero, type) {
            console.log('Mando gratis', type);

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.dispensar = function () {
                if ($scope.password === cajero.password) {
                    cajeroService.dispensar(cajero.ip, cajero.port, type, $scope.comentario).then(function () {
                        console.log('Mando dispensado');
                    });
                } else {
                    alert('Password incorrecta');
                }

                $mdDialog.hide();
            };
        }

        $scope.marcarPagado = function () {
            /*cajeroService.marcarPagado($scope.CAJERO.ip, $scope.CAJERO.port)
             .then(function () {
             
             });*/
        }

        $scope.date_changed = function () {
            $scope.isLoading1 = true;
            $scope.isLoading2 = true;

            console.info($scope.fInicio, $scope.fFin);

            cajeroService.logDispensarFecha($scope.CAJERO.ip, $scope.CAJERO.port,
                    $filter('date')($scope.fInicio, 'yyyy-MM-dd'), $filter('date')($scope.fFin, 'yyyy-MM-dd')
                    ).then(function (res) {
                $scope.logDispensar = res.data;
                $scope.isLoading1 = false;
            }, function () {
                $scope.logDispensar = [];
                $scope.isLoading1 = false;
            });

            cajeroService.logRecogerFecha($scope.CAJERO.ip, $scope.CAJERO.port,
                    $filter('date')($scope.fInicio, 'yyyy-MM-dd'), $filter('date')($scope.fFin, 'yyyy-MM-dd'))
                    .then(function (res) {
                        $scope.logRecoger = res.data;
                        $scope.isLoading2 = false;
                    }, function () {
                        $scope.logRecoger = [];
                        $scope.isLoading2 = false;
                    });


            quantionApi.getReporteAtmClientRc({fromDate: $scope.fInicio, toDate: $scope.fFin}).then(function (dataResponse) {
                var a = dataResponse.data.atm.filter(function (elm) {
                    return elm.idAtm === $scope.CAJERO.id;
                });

                $scope.CAJERO.cupon = a[0] ? a[0].cupon : [];
            });
        };

        $scope.pay = function (cantidad) {
            $mdDialog.show({
                controller: PayController,
                templateUrl: 'app/main/Quantion/administradorCajeros/views/pagar.tmpl.html',
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                locals: {
                    cantidad: cantidad,
                    cajero: $scope.CAJERO
                }
            });
        };

        function PayController($scope, $mdDialog, cantidad, cajero) {
            console.log('Pagar gratis');

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.pagar = function () {
                if (cajero.password === $scope.password) {
                    alert('Se ha pagado: ' + cantidad + '€');
                    cajeroService.pagar(cajero.ip, cajero.port, cantidad, $scope.comentario).then(function () {
                        console.log('Pagado correctamente');
                    });
                    $mdDialog.hide();
                } else {
                    alert('Password incorrecta');
                }
            };
        }

        function checkType(ip, port) {
            cajeroService.allType(ip, port)
                    .then(function (res) {
                        $scope.tipos = res.data;
                    });

            cajeroService.cantidadMandos(ip, port, 1)
                    .then(function (res) {
                        $scope.cantidad1 = res.data;
                    });

            cajeroService.cantidadMandos(ip, port, 2)
                    .then(function (res) {
                        $scope.cantidad2 = res.data;
                    });
        }

        function checkStatus(ip, port) {
            cajeroService.status(ip, port).then(function (res) {
                $scope.status = res.data;

                cajeroService.getMando($scope.CAJERO.ip, $scope.CAJERO.port, $scope.status.uidMando).then(function (res) {
                    if (res.data) {
                        $scope.mandoStatus = res.data[0];
                    }
                });

                cajeroService.existeMandos($scope.CAJERO.ip, $scope.CAJERO.port).then(function (res) {
                    $scope.tolvas = res.data;
                });

                var now = Date.now();

                $scope.status.tiempoOnline.enInicio = new Date(now - $scope.status.tiempoOnline.enInicio * 1000);
            });
        }

        function checkSaldo(ip, port) {
            cajeroService.saldo(ip, port).then(function (res) {
                $scope.pagadores = res.data.pagadores;
                $scope.nopagadores = res.data.nopagadores;
            });
        }

        function checkLog(ip, port) {
            cajeroService.logDispensar(ip, port).then(function (res) {
                $scope.logDispensar = res.data;
                $scope.isLoading1 = false;
            }, function () {
                $scope.logDispensar = [];
                $scope.isLoading1 = false;
            });

            cajeroService.logRecoger(ip, port).then(function (res) {
                $scope.logRecoger = res.data;
                $scope.isLoading2 = false;
            }, function () {
                $scope.logRecoger = [];
                $scope.isLoading2 = false;
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core',
                    [
                        'ngAnimate',
                        'ngAria',
                        'ngCookies',
                        'ngMessages',
                        'ngResource',
                        'ngSanitize',
                        'ngMaterial',
//                'angular-chartist',
//                'chart.js',
                        'datatables',
//                'gridshore.c3js.chart',
                        'nvd3',
                        'pascalprecht.translate',
//                'timer',
                        'ui.router',
//                'uiGmapgoogle-maps',
//                'textAngular',
                        'ui.sortable',
//                'ng-sortable',
//                'xeditable',
//                'moment-picker'
                    ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
                registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes: getRegisteredThemes,
                setActiveTheme: setActiveTheme,
                setThemesList: setThemesList,
                themes: {
                    list: {},
                    active: {
                        'name': '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if (angular.isUndefined(service.themes.list[themeName]))
                {
                    // If there is no theme called "default"...
                    if (angular.isUndefined(service.themes.list.default))
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.core')
            .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                    .primaryPalette(theme.primary.name, theme.primary.hues)
                    .accentPalette(theme.accent.name, theme.accent.hues)
                    .warnPalette(theme.warn.name, theme.warn.hues)
                    .backgroundPalette(theme.background.name, theme.background.hues);
        });
        
        if (window.CUSTOM_THEME)
            $mdThemingProvider.theme('custom')
                    .primaryPalette(CUSTOM_THEME.colors.primary.name, CUSTOM_THEME.colors.primary.hues)
                    .accentPalette(CUSTOM_THEME.colors.accent.name, CUSTOM_THEME.colors.accent.hues)
                    .warnPalette(CUSTOM_THEME.colors.warn.name, CUSTOM_THEME.colors.warn.hues)
                    .backgroundPalette(CUSTOM_THEME.colors.background.name, CUSTOM_THEME.colors.background.hues);

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default': {
            "primary": {
                "name": "fuse-pale-blue",
                "hues": {"default": "700", "hue-1": "500", "hue-2": "600", "hue-3": "400"}
            },
            "accent": {
                "name": "blue-grey",
                "hues": {"default": "400", "hue-1": "200", "hue-2": "500", "hue-3": "50"}
            },
            "warn": {
                "name": "amber",
                "hues": {"default": "500", "hue-1": "300", "hue-2": "800", "hue-3": "A100"}
            },
            "background": {
                "name": "grey",
                "hues": {"default": "A100", "hue-1": "A100", "hue-2": "100", "hue-3": "300"}
            }
        }
    };

    angular
            .module('app.core')
            .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'rocio-pink',
            options: {
                '50': '#4e0d2b',
                '100': '#ccbfc5',
                '200': '#4e0d2b',
                '300': '#4e0d2b',
                '400': '#4e0d2b',
                '500': '#4e0d2b',
                '600': '#4e0d2b',
                '700': '#4e0d2b',
                '800': '#4e0d2b',
                '900': '#4e0d2b',
                'A100': '#ccbfc5',
                'A200': '#4e0d2b',
                'A400': '#4e0d2b',
                'A700': '#4e0d2b',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'rocio-orange',
            options: {
                '50': '#ff853f',
                '100': '#dac4b7',
                '200': '#ff853f',
                '300': '#ff853f',
                '400': '#ff853f',
                '500': '#ff853f',
                '600': '#ff853f',
                '700': '#ff853f',
                '800': '#ff853f',
                '900': '#ff853f',
                'A100': '#dac4b7',
                'A200': '#ff853f',
                'A400': '#ff853f',
                'A700': '#ff853f',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'melia-bluegreen',
            options: {
                '50': '#144f5c',
                '100': '#1e687d',
                '200': '#144f5c',
                '300': '#144f5c',
                '400': '#144f5c',
                '500': '#144f5c',
                '600': '#144f5c',
                '700': '#144f5c',
                '800': '#144f5c',
                '900': '#144f5c',
                'A100': '#1e687d',
                'A200': '#144f5c',
                'A400': '#144f5c',
                'A700': '#144f5c',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'green-cyan',
            options: {
                '50': '#279787',
                '100': '#41ecd2',
                '200': '#279787',
                '300': '#279787',
                '400': '#279787',
                '500': '#279787',
                '600': '#279787',
                '700': '#279787',
                '800': '#279787',
                '900': '#279787',
                'A100': '#41ecd2',
                'A200': '#279787',
                'A400': '#279787',
                'A700': '#279787',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'dark-yellow',
            options: {
                '50': '#e2bc38',
                '100': '#e2bc38',
                '200': '#e2bc38',
                '300': '#e2bc38',
                '400': '#e2bc38',
                '500': '#e2bc38',
                '600': '#e2bc38',
                '700': '#e2bc38',
                '800': '#e2bc38',
                '900': '#e2bc38',
                'A100': '#e2bc38',
                'A200': '#e2bc38',
                'A400': '#e2bc38',
                'A700': '#e2bc38',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
            .module('app.core')
            .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba: rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name': colorType.name,
                        'levels': {
                            'default': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            fuseTheming.setActiveTheme('custom');
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255)
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if (contrastLevel)
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if (color.length === 3)
            {
                return 'rgb(' + color.join(',') + ')';
            } else if (color.length === 4)
            {
                return 'rgba(' + color.join(',') + ')';
            } else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if (color[0] === 255 && color[1] === 255 && color[2] === 255)
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if (color[0] === 0 && color[1] === 0, color[2] === 0)
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.quick-panel')
            .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($scope, $state, incidencesStateService, IncidencesConfig)
    {
        var vm = this;

        vm.urlGestor = IncidencesConfig.urlGestor;
        vm.state = incidencesStateService.getState();
        vm.selectedTab = 0;
        vm.cardCtrl = incidencesStateService.createCardCtrl($state, IncidencesConfig.urlGestor);

        vm.refresh = function () {
            incidencesStateService.refresh();
        };

        vm.goToRoom = function (room) {
            incidencesStateService.goToRoom(room, $state);
        };

        vm.getTypeStyle = function (type) {
            return incidencesStateService.getTypeStyle(type);
        };

        vm.getGestorUrl = function (item, isPrevent) {
            return vm.cardCtrl.getGestorUrl(item, isPrevent);
        };

        $scope.$on('stbsMainLoaded', function () {
            incidencesStateService.refresh();
        });

        $scope.$on('openIncidencesPanel', function (event, args) {
            vm.selectedTab = args && args.tab === 'prevents' ? 1 : 0;
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.toolbar')
            .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $location, $rootScope, $cookies, JSONconfig, quantionApi, $translate, $mdSidenav, incidencesApi, incidencesStateService, $state)
    {
        var vm = this;

        $scope.JSONconfig = JSONconfig;
        vm.incidencesState = incidencesStateService.getState();

        $scope.logout = function () {
            incidencesApi.clearToken();
            incidencesStateService.stopPolling();
            $cookies.remove('user');
            $location.path('/login');
        };

        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
            incidencesStateService.refresh();
        };

        vm.formatBadgeCount = function (count) {
            if (!count || count <= 0) {
                return null;
            }

            return count > 99 ? '99+' : String(count);
        };

        quantionApi.installationName().then(function (dataResponse) {
            $scope.installationName = dataResponse.data;
        });

        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es'
            }
        };

        vm.selectedLanguage = vm.languages[$translate.use()];

        vm.changeLanguage = function (lang)
        {
            vm.selectedLanguage = lang;
            $translate.use(lang.code);
            localStorage.idioma = lang.code;
        };

        $scope.goHome = function () {
            $state.go('app.Quantion_principal');
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.navigation', [])
            .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/navigation');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.navigation')
            .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $interval, $translate, quantionApi, LogoConfig, VersionConfig, $state)
    {
        var vm = this;

        $scope.logoEstablecimiento = LogoConfig;
        $scope.version = VersionConfig.version;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = localStorage.menuFolded === 'true' ? true : false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
            localStorage.menuFolded = vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        //////////////////////////
        // Now widget
        vm.nowWidget = {
            ticker: function ()
            {
                var now = new Date();
                vm.nowWidget.now = {
                    now: now,
                    hour: now.toLocaleTimeString($translate.use()),
                    date: now.toLocaleDateString($translate.use())
                };
            }
        };

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        //WEATHER WIDGET
        vm.weatherWidget = {
            "location": {
                "name": "",
                "temp": '',
                "next3Days": [],
                "icon": ''
            },
            days: {
                "Mon": "Monday",
                "Tue": "Tuesday",
                "Wed": "Wednesday",
                "Thu": "Thursday",
                "Fri": "Friday",
                "Sat": "Saturday",
                "Sun": "Sunday"
            },
            weatherIcons: {
                "0": {text: "tornado", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "1": {text: "tropical storm", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "2": {text: "hurricane", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "3": {text: "severe thunderstorms", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "4": {text: "thunderstorms", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "5": {text: "mixed rain and snow", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "6": {text: "mixed rain and sleet", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "7": {text: "mixed snow and sleet", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "8": {text: "freezing drizzle", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "9": {text: "drizzle", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "10": {text: "freezing rain", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "11": {text: "showers", icon: "/assets/quantionImagenes/Weather/weather-11.png"},
                "12": {text: "showers", icon: "/assets/quantionImagenes/Weather/weather-11.png"},
                "13": {text: "snow flurries", icon: "/assets/quantionImagenes/Weather/weather-11.png"},
                "14": {text: "light snow showers", icon: "/assets/quantionImagenes/Weather/weather-11.png"},
                "15": {text: "blowing snow", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "16": {text: "snow", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "17": {text: "hail", icon: "/assets/quantionImagenes/Weather/weather-17.png"},
                "18": {text: "sleet", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "19": {text: "dust", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "20": {text: "foggy", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "21": {text: "haze", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "22": {text: "smoky", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "23": {text: "blustery", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "24": {text: "windy", icon: "/assets/quantionImagenes/Weather/weather-24.png"},
                "25": {text: "cold", icon: "/assets/quantionImagenes/Weather/weather-32.png"},
                "26": {text: "cloudy", icon: "/assets/quantionImagenes/Weather/weather-26.png"},
                "27": {text: "mostly cloudy (night)", icon: "/assets/quantionImagenes/Weather/weather-26.png"},
                "28": {text: "mostly cloudy (day)", icon: "/assets/quantionImagenes/Weather/weather-44.png"},
                "29": {text: "partly cloudy (night)", icon: "/assets/quantionImagenes/Weather/weather-26.png"},
                "30": {text: "partly cloudy (day)", icon: "/assets/quantionImagenes/Weather/weather-44.png"},
                "31": {text: "clear (night)", icon: "/assets/quantionImagenes/Weather/weather-night.png"},
                "32": {text: "sunny", icon: "/assets/quantionImagenes/Weather/weather-31.png"},
                "33": {text: "fair (night)", icon: "/assets/quantionImagenes/Weather/weather-night.png"},
                "34": {text: "fair (day)", icon: "/assets/quantionImagenes/Weather/weather-31.png"},
                "35": {text: "mixed rain and hail", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "36": {text: "hot", icon: "/assets/quantionImagenes/Weather/weather-31.png"},
                "37": {text: "isolated thunderstorms", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "38": {text: "scattered thunderstorms", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "39": {text: "scattered thunderstorms", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "40": {text: "scattered showers", icon: "/assets/quantionImagenes/Weather/weather-9.png"},
                "41": {text: "heavy snow", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "42": {text: "scattered snow showers", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "43": {text: "heavy snow", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "44": {text: "partly cloudy", icon: "/assets/quantionImagenes/Weather/weather-44.png"},
                "45": {text: "thundershowers", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "46": {text: "snow showers", icon: "/assets/quantionImagenes/Weather/weather-16.png"},
                "47": {text: "isolated thundershowers", icon: "/assets/quantionImagenes/Weather/weather-37.png"},
                "3200": {text: "not available", icon: "/assets/quantionImagenes/Weather/unknown.png"}
            }
        };

        function getWeather() {
            quantionApi.getWeather().then(function (dataResponse) {
                var data = dataResponse.data.response;

                vm.weatherWidget.location.name = data.query.results.channel.location.city;
                vm.weatherWidget.location.temp = celsiusToFahrenheit(data.query.results.channel.item.condition.temp);
                vm.weatherWidget.location.icon = vm.weatherWidget.weatherIcons[data.query.results.channel.item.condition.code.toString()].icon;

//                for (var i = 0; i < 3; ++i) {
//                    vm.weatherWidget.location.next3Days.push({
//                        name: vm.weatherWidget.days[data.query.results.channel.item.forecast[i].day],
//                        tempMin: celsiusToFahrenheit(data.query.results.channel.item.forecast[i].low),
//                        tempMax: celsiusToFahrenheit(data.query.results.channel.item.forecast[i].high),
//                        icon: vm.weatherWidget.weatherIcons[data.query.results.channel.item.forecast[i].code.toString()].icon
//                    });
//                }
            });
        }
//        getWeather();


        function celsiusToFahrenheit(grados) {
            return Math.round((grados - 32) / 1.8);
        }

        $scope.updateDeletingCache = function () {
            location.reload(true);
        };

        $scope.goHome = function () {
            $state.go('app.Quantion_principal');
        };
    }

})();
(function ()
{
    'use strict';

    angular
            .module('project', [
                'app.core',
                'app.navigation',
                'app.toolbar',
                'app.quick-panel',
                'app.Quantion'
            ]);
})();
(function ()
{
    'use strict';

    angular
            .module('project')
            .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $mdSidenav, JSONconfig, $filter)
    {
        if (window.CUSTOM_THEME)
            $scope.backgroundUrl = CUSTOM_THEME.background;

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if (event.targetScope.$id === $scope.$id)
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        ///Pantalla de carga única
        $scope.lsText = '';
        var element = $('#pantallaCarga');

        $scope.lsEnable = function (newText) {
            if (newText)
                $scope.lsText = newText;
            element.removeClass("lsHidden");
        };
        $scope.lsDisable = function () {
            element.addClass("lsHidden");
        };

        $scope.toggleNavigation = function () {
            $mdSidenav('navigation').toggle();
        };

        $scope.toggleMainToolbar = function (ev) {
            $('#toolbar').toggleClass('hide')
        };

        $scope.expireLicense = JSONconfig.expireLicense && $filter('date')(JSONconfig.expireLicense, 'dd/MM/yyyy');
        $scope.hiddenLicenseMessage = false;

        $scope.hideLicenseMessage = function () {
            $scope.hiddenLicenseMessage = true;
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
//        $translateProvider.preferredLanguage(localStorage.idioma || 'es');
        $translateProvider.preferredLanguage('es');
//        $translateProvider.useSanitizeValueStrategy('sanitize');
        $translateProvider.useSanitizeValueStrategy();

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
            .module('project')
            .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $location, quantionApi, $cookies, RoleService, fuseTheming, $translate, incidencesApi, incidencesStateService, JSONconfig)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });

            quantionApi.serverOn().then(function (dataResponse) {
                console.log(dataResponse.status + ': ' + dataResponse.statusText);
            }, function (dataResponse) {
//                if (dataResponse.status === 500 || dataResponse.status === 404) {
                console.error(dataResponse.status + ': ' + dataResponse.statusText);
                $location.path('/error500');
//                }
            });
            RoleService.validPath();
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        if (RoleService.isLogged()) {
            $rootScope.user = RoleService.getUserStored();
            if ($rootScope.user) {
                RoleService.updateUserStoredNavigationList();
                $translate.use($rootScope.user.language || $translate.preferredLanguage());

                quantionApi.existUserById($rootScope.user.idUser).then(function (dataResponse) {
                    if (dataResponse.data !== 'true') {
                        $location.path('/login');
                        return;
                    }

                    if (JSONconfig.soporteIncidencias && incidencesApi.isAuthenticated()) {
                        incidencesStateService.startPolling();
                    }
                });
            }
        }

//        $rootScope.$on('$locationChangeStart', function () {
//
//        });

        $rootScope.theme = fuseTheming.themes.active.name;

//        $rootScope.$watch('user', function () {
////            if ($rootScope.user) {
//            console.info('Logueado el usuario "' + $rootScope.user.name + '" con rol "' + $rootScope.user.userRole + '"');
//            RoleService.updateUserStoredNavigationList();
//            console.info(RoleService.getNodes());
////            }
//        }, true);

//        console.log('Lista de temas', angular.toJson(Object.keys(fuseTheming.getRegisteredThemes())));
    }
})();
(function ()
{
    'use strict';

    angular
            .module('project')
            .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/error404');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/vertical-navigation.html',
                            controller: 'MainController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                        'navigation@app': {
                            templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: 'app/quick-panel/quick-panel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });
    }

})();
(function ()
{
    'use strict';

    angular
            .module('project')
            .service('RoleService', roleService);

    /** @ngInject */
    function roleService($rootScope, $state, msNavigationService, $filter, $location, $cookies)
    {
        var rs = this;
        window.rs = this;

        rs.info = function () {
            $.each($state.get(), function (i, v) {
                if (v.url)
                    console.log(v.url + '->' + rs.validPath(v.url));
            });
        };

        /*
         * Devuelve las rutas disponibles en la aplicación
         */
        rs.getRoutes = function () {
            return $state.get().filter(function (e) {
                return e.data && e.data.authorization;
            }).map(function (e) {
                return e.url;
            });
        };

        /*
         * Devuelve las rutas disponibles en la aplicación
         */
        rs.getRoutesJson = function () {
            return angular.toJson(rs.getRoutes(), true);
        };

        /*
         * Devuelve todos los elementos de navigation
         */
        rs.getAllNodes = function () {
            return allNodes;
        };

        /*
         * Devuelve todos los elementos de navigation (formato JSON)
         */
        rs.getAllNodesJson = function () {
            return angular.toJson(allNodes, true);
        };

        /*
         * Devuelve el usuario logueado en este momento
         */
        rs.getUserStored = function () {
            try {
                return angular.fromJson(localStorage.usuario);
            } catch (e) {
                console.error('Error al obtener el usuario');
                return;
            }
        };

        /*
         * Almacena el usuario logueado en el almacenamiento local
         */
        rs.setUserStored = function (obj) {
            localStorage.usuario = angular.toJson(obj);
        };

        /*
         * Devuelve los elementos de navegation del usuario actual
         */
        rs.getUserStoredNodes = function () {
            var us = rs.getUserStored();

            if (us && us.mapRole) {
                return us.mapRole.nodes.map(function (elm) {
                    return allNodes[elm];
                }).filter(function (elm) {
                    return elm && elm.state;
                });
            } else {
                return [];
            }
        };

        /*
         * Actualiza el navigation con los elementos del usuario actual
         */
        rs.updateUserStoredNavigationList = function () {
            var us = rs.getUserStored();
            var allNodesCopy = angular.copy(allNodes);

            if (us && us.mapRole) {
                msNavigationService.clearNavigation();

                $.each(us.mapRole.nodes, function (i, v) {
                    if (allNodesCopy[v])
                        msNavigationService.saveItem(v, allNodesCopy[v]);
                });
            } else {
                return [];
            }
        };

        /*
         * Comprueba si el usuario actual puede acceder a una ruta concreta
         */
        rs.validPath = function () {
            var restrictedPage = $state.current.data && $state.current.data.authorization;
            var loggedIn = $cookies.get('expires') && $rootScope.user && $rootScope.user.mapRole;

            if (restrictedPage) {//Si es una vista con login requerido
                if (!loggedIn) {//Si no estamos logueados, nos lleva a la vista de login
                    $cookies.put('redirectUrl', $location.path());
                    $location.path('/login');
                    return;
                }

                if ($rootScope.user.mapRole.routes.indexOf($state.current.url) === -1) {//Si estamos logueados, comprueba que tengamos permiso para esa vista
                    $location.path('/error401');
                    return;
                }
            }
        };

        rs.isLogged = function () {
            return $cookies.get('expires');
        };
    }

    var allNodes = {
        "principal": {
            "title": "Inicio",
            "icon": "icon-home",
            "state": "app.Quantion_principal",
            "weight": 0,
            "translate": "NAVIGATION.PRINCIPAL"
        },
        "habitaciones": {
            "title": "Habitaciones",
            "icon": "icon-hotel",
            "weight": 1,
            "translate": "NAVIGATION.HABITACIONES"
        },
        "habitaciones.listado": {
            "title": "Lista de habitaciones",
            "icon": "icon-table-large",
            "state": "app.Quantion_habitaciones_listado",
            "weight": 0,
            "translate": "NAVIGATION.HABITACIONES_LISTADO"
        },
        "habitaciones.aps": {
            "title": "Gestión Puntos de acceso",
            "icon": "icon-radio-tower",
            "state": "app.Quantion_habitaciones_aps",
            "weight": 1,
            "translate": "NAVIGATION.HABITACIONES_APS"
        },
        "habitaciones.modelos": {
            "title": "Modelos de STB",
            "icon": "icon-tag-text-outline",
            "state": "app.Quantion_habitaciones_modelos",
            "weight": 2,
            "translate": "NAVIGATION.HABITACIONES_MODELOS"
        },
        "habitaciones.wallets": {
            "title": "Monederos virtuales / Tarjetas",
            "icon": "icon-credit-card",
            "state": "app.Quantion_habitaciones_wallets",
            "weight": 3,
            "translate": "NAVIGATION.HABITACIONES_WALLETS"
        },
        "habitaciones.voip": {
            "title": "VOIP",
            "icon": "icon-phone-log",
            "state": "app.Quantion_habitaciones_voip",
            "weight": 4,
            "translate": "NAVIGATION.HABITACIONES_VOIP"
        },
        "habitaciones.mantenimiento": {
            "title": "Mantenimiento",
            "icon": "icon-cog",
            "state": "app.Quantion_habitaciones_mantenimiento",
            "weight": 5,
            "translate": "NAVIGATION.HABITACIONES_MANTENIMIENTO"
        },
        "habitaciones.unprovisioned": {
            "title": "No provisionadas",
            "icon": "icon-key-remove",
            "state": "app.Quantion_habitaciones_unprovisioned",
            "weight": 6,
            "translate": "NAVIGATION.HABITACIONES_UNPROVISIONED"
        },
        "iptv": {
            "title": "Canales IPTV",
            "icon": "icon-television",
            "weight": 2,
            "translate": "NAVIGATION.IPTV"
        },
        "iptv.listaIptv": {
            "title": "Lista de canales IPTV",
            "icon": "icon-table-large",
            "state": "app.Quantion_iptv_listaIptv",
            "weight": 0,
            "translate": "NAVIGATION.IPTV_LISTADO"
        },
        "iptv.importexport": {
            "title": "Importar canales",
            "icon": "icon-import",
            "state": "app.Quantion_iptv_importexport",
            "weight": 1,
            "translate": "NAVIGATION.IMPORT_EXPORT"
        },
        "avisos": {
            "title": "Avisos",
            "icon": "icon-comment-alert",
            "state": "app.Quantion_avisos_listado",
            "weight": 3,
            "translate": "NAVIGATION.AVISOS"
        },
        "lotes": {
            "title": "Acciones por lotes",
            "icon": "icon-domain",
            "state": "app.Quantion_lotes",
            "weight": 4,
            "translate": "NAVIGATION.LOTES"
        },
        "gestionCompras": {
            "title": "Gestión de compras",
            "icon": "icon-cart",
            "weight": 5,
            "translate": "NAVIGATION.COMPRAS"
        },
        "gestionCompras.operaciones": {
            "title": "Nueva oper. / Historial",
            "icon": "icon-playlist-plus",
            "state": "app.Quantion_gestionCompras_operaciones",
            "weight": 0,
            "translate": "NAVIGATION.COMPRAS_OPERACIONES"
        },
        "gestionCompras.contabilidad": {
            "title": "Consumo",
            "icon": "icon-speedometer",
            "state": "app.Quantion_gestionCompras_contabilidad",
            "weight": 1,
            "translate": "NAVIGATION.COMPRAS_CONTABILIDAD"
        },
        "gestionCompras.contabilidad_sin_precios": {
            "title": "Consumo",
            "icon": "icon-speedometer",
            "state": "app.Quantion_gestionCompras_contabilidad_sin_precios",
            "weight": 1,
            "translate": "NAVIGATION.COMPRAS_CONTABILIDAD"
        },
        "gestionCompras.recaudacion_simple": {
            "title": "Recaudaciones",
            "icon": "icon-window-open",
            "state": "app.Quantion_gestionCompras_recaudacion_simple",
            "weight": 2,
            "translate": "NAVIGATION.COMPRAS_RECAUDACION_SIMPLE"
        },
        "gestionCompras.recaudacion": {
            "title": "Informe recaudación",
            "icon": "icon-desktop-tower",
            "state": "app.Quantion_gestionCompras_recaudacion",
            "weight": 3,
            "translate": "NAVIGATION.COMPRAS_RECAUDACION"
        },
        "gestionCompras.recaudacion_completa": {
            "title": "Informe cajeros",
            "icon": "icon-table-large",
            "state": "app.Quantion_gestionCompras_recaudacion_completa",
            "weight": 4,
            "translate": "NAVIGATION.COMPRAS_RECAUDACION_COMPLETA"
        },
        "gestionCompras.recaudacion_v": {
            "title": "Informe recaudación_",
            "icon": "icon-desktop-tower",
            "state": "app.Quantion_gestionCompras_recaudacion_v",
            "weight": 4,
            "translate": "NAVIGATION.COMPRAS_RECAUDACION_V"
        },
        "gestionCompras.estadoComercial": {
            "title": "Estado comercial",
            "icon": "icon-information-outline",
            "state": "app.Quantion_gestionCompras_estadoComercial",
            "weight": 5,
            "translate": "NAVIGATION.COMPRAS_ESTADO_COMERCIAL"
        },
        "wifiAdm": {
            "title": "Administración WiFi",
            "icon": "icon-wifi",
            "state": "app.Quantion_wifiAdm",
            "weight": 6,
            "translate": "NAVIGATION.WIFI"
        },
        "precios": {
            "title": "Precios",
            "icon": "icon-currency-eur",
            "state": "app.Quantion_precios",
            "weight": 7,
            "translate": "NAVIGATION.PRECIOS"
        },
        "archivos": {
            "title": "Gestión de archivos",
            "icon": "icon-folder-upload",
            "weight": 8,
            "translate": "NAVIGATION.ARCHIVOS"
        },
        "archivos.servicios": {
            "title": "Servicios",
            "icon": "icon-readability",
            "state": "app.Quantion_archivos_servicios",
            "weight": 2,
            "translate": "NAVIGATION.ROOT_G_SERVICIOS"
        },
        "archivos.banners": {
            "title": "Banners",
            "icon": "icon-calendar-text",
            "state": "app.Quantion_archivos_banners",
            "weight": 1,
            "translate": "NAVIGATION.ARCHIVOS_BANNERS"
        },
        "archivos.fileExplorer": {
            "title": "Explorador de archivos",
            "icon": "icon-folder-multiple-outline",
            "state": "app.Quantion_archivos_fileExplorer",
            "weight": 3,
            "translate": "NAVIGATION.ARCHIVOS_FILEEXPLORER"
        },
        "documentExplorer": {
            "title": "Documentación",
            "icon": "icon-file-document",
            "state": "app.Quantion_archivos_documentExplorer",
            "weight": 8.5,
            "translate": "NAVIGATION.ARCHIVOS_DOCUMENTEXPLORER"
        },
        "estadisticas": {
            "title": "Estadísticas",
            "icon": "icon-chart-bar",
            "weight": 9,
            "translate": "NAVIGATION.ESTADISTICAS"
        },
        "estadisticas.completa": {
            "title": "Estadísticas completas",
            "icon": "icon-chart-bar",
            "state": "app.Quantion_estadisticas",
            "weight": 1,
            "translate": "NAVIGATION.ESTADISTICAS"
        },
        "estadisticas.tv": {
            "title": "Estadísticas de TV",
            "icon": "icon-television",
            "state": "app.Quantion_estadisticas_tv",
            "weight": 2,
            "translate": "NAVIGATION.ESTADISTICAS_TV"
        },
        "estadisticas.urls": {
            "title": "Estadísticas de URLs",
            "icon": "icon-web",
            "state": "app.Quantion_estadisticas_urls",
            "weight": 3,
            "translate": "NAVIGATION.ESTADISTICAS_URLS"
        },
        "estadisticas.banners": {
            "title": "Estadísticas de Banners",
            "icon": "icon-calendar-text",
            "state": "app.Quantion_estadisticas_banners",
            "weight": 4,
            "translate": "NAVIGATION.ESTADISTICAS_BANNERS"
        },
        "estadisticas.instantanea": {
            "title": "Estadísticas Instantánea",
            "icon": "icon-timelapse",
            "state": "app.Quantion_estadisticas_instantanea",
            "weight": 5,
            "translate": "NAVIGATION.ESTADISTICAS_INSTANTANEA"
        },
        "usuarios": {
            "title": "Control de usuarios",
            "icon": "icon-people",
            "state": "app.Quantion_usuarios",
            "weight": 10,
            "translate": "NAVIGATION.USUARIOS"
        },
        "tasks": {
            "title": "Tareas programadas",
            "icon": "icon-clock-fast",
            "weight": 11,
            "translate": "NAVIGATION.TASKS"
        },
        "tasks.servidor": {
            "title": "Tareas programadas (Servidor)",
            "icon": "icon-server",
            "state": "app.Quantion_tasks_servidor",
            "weight": 1,
            "translate": "NAVIGATION.TASKS_SERVIDOR"
        },
        "tasks.equipos": {
            "title": "Tareas programadas (Equipos)",
            "icon": "icon-tablet",
            "state": "app.Quantion_tasks_equipos",
            "weight": 2,
            "translate": "NAVIGATION.TASKS_EQUIPOS"
        },
        "tasks.procesos": {
            "title": "Procesos en ejecución",
            "icon": "icon-chart-areaspline",
            "state": "app.Quantion_tasks_procesos",
            "weight": 3,
            "translate": "NAVIGATION.PROCESOS"
        },
        "root": {
            "title": "[Root]",
            "icon": "icon-key-variant",
            "weight": 12,
            "translate": "NAVIGATION.ROOT"
        },
        "root.gservicios": {
            "title": "Gestión de servicios",
            "icon": "icon-package-variant",
            "weight": 1,
            "translate": "NAVIGATION.ROOT_G"
        },
        "root.gservicios.paquetes": {
            "title": "Paquetes",
            "icon": "icon-package-variant",
            "state": "app.Quantion_root_paquetes",
            "weight": 0,
            "translate": "NAVIGATION.ROOT_G_PAQUETES"
        },
        "root.gservicios.servicios": {
            "title": "Servicios",
            "icon": "icon-readability",
            "state": "app.Quantion_root_servicios",
            "weight": 1,
            "translate": "NAVIGATION.ROOT_G_SERVICIOS"
        },
        "root.gruposStb": {
            "title": "Grupos de STB",
            "icon": "icon-group",
            "state": "app.Quantion_root_gruposStb",
            "weight": 3,
            "translate": "NAVIGATION.ROOT_GRUPOS"
        },
        "root.cversiones": {
            "title": "Control de versiones",
            "icon": "icon-tag-text-outline",
            "state": "app.Quantion_root_cversiones",
            "weight": 4,
            "translate": "NAVIGATION.ROOT_VERSIONES"
        },
        "root.idiomas": {
            "title": "Idiomas",
            "icon": "icon-flag-variant",
            "state": "app.Quantion_root_idiomas",
            "weight": 5,
            "translate": "NAVIGATION.ROOT_IDIOMAS"
        },
        "root.dhcpEquipos": {
            "title": "Equipos DHCP",
            "icon": "icon-security-network",
            "state": "app.Quantion_root_dhcpEquipos",
            "weight": 6,
            "translate": "NAVIGATION.ROOT_DHCP"
        },
        "root.gCajeros": {
            "title": "Gestión de cajeros",
            "icon": "icon-deskphone",
            "state": "app.Quantion_root_gCajeros",
            "weight": 7,
            "translate": "NAVIGATION.ROOT_CAJEROS"
        },
        "root.instalaciones": {
            "title": "Instalaciones",
            "icon": "icon-sitemap",
            "state": "app.Quantion_root_instalaciones",
            "weight": 8,
            "translate": "NAVIGATION.ROOT_INSTALACIONES"
        },
        "root.encuestas": {
            "title": "Encuestas de satisfacción",
            "icon": "icon-library-books",
            "state": "app.Quantion_root_encuestas",
            "weight": 9,
            "translate": "NAVIGATION.ROOT_ENCUESTAS"
        },
        "root.temas": {
            "title": "Temas",
            "icon": "icon-brush",
            "state": "app.Quantion_root_temas",
            "weight": 10,
            "translate": "NAVIGATION.ROOT_TEMAS"
        },
        "root.tarjetas": {
            "title": "Tarjetas con acción",
            "icon": "icon-credit-card",
            "state": "app.Quantion_root_tarjetas",
            "weight": 11,
            "translate": "NAVIGATION.ROOT_TARJETAS"
        },
        "root.properties": {
            "title": "Properties",
            "icon": "icon-cog",
            "state": "app.Quantion_root_properties",
            "weight": 12,
            "translate": "NAVIGATION.ROOT_PROPERTIES"
        },
        "root.traduccion": {
            "title": "Traducción",
            "icon": "icon-format-text",
            "state": "app.Quantion_root_traduccion",
            "weight": 13,
            "translate": "NAVIGATION.ROOT_TRADUCCION"
        },
        "root.controls": {
            "title": "Controles",
            "icon": "icon-remote",
            "state": "app.Quantion_root_controls",
            "weight": 14,
            "translate": "NAVIGATION.ROOT_CONTROLS"
        },
        "administradorCajeros": {
            "title": "Administrador cajeros",
            "icon": "icon-deskphone",
            "state": "app.Quantion_administradorCajeros",
            "weight": 13,
            "translate": "NAVIGATION.ADMINISTRADORCAJEROS"
        }
    };
})();

(function ()
{
    'use strict';

    angular
            .module('project')
            .filter('formatNameDesc', ['$translate', formatNameDesc])
            .filter('checkStbStatus', checkStbStatus)
            .filter('convertMinutesInHHMMSS', ['$filter', convertMinutesInHHMMSS])
            .filter('convertSeconds', ['$filter', convertSeconds])
            .filter('convertSecondsWithoutDays', ['$filter', convertSecondsWithoutDays])
            .filter('separateWindowChannel', separateWindowChannel)
            .filter('roundDecimals', roundDecimals)
            .filter('abs', convertPositive)
            .filter('showLink', showLink)
            .filter('showText', showText)
            .filter('replacePath', replacePath)
            .filter('stringifyArray', stringifyArray)
            .filter('parseJSON', parseJSON)
            .filter('formatBytes', formatBytes)
            .filter('trustUrl', trustUrl)
            .filter('formatReportName', formatReportName)
            .filter('tryParseInt', tryParseInt)
            .filter('pxeSplit', pxeSplit)
            .filter('translateStat', ['$filter', translateStat])
            .filter('groupBy', groupBy)
            .filter('generateCode', [generateCode])
            .filter('signalToPercent', signalToPercent);

    function separateWindowChannel() {
        return function (input) {
            if (input) {
                var a = input.split('@');
                return (a[0] + ' (' + a[1] + ')');
            }
        };
    }

    function roundDecimals() {
        return function (input, decimals) {
            if (angular.isDefined(input))
                return +input.toFixed(decimals);
        };
    }

    function convertPositive() {
        return function (input) {
            return Math.abs(input);
        };
    }

    function formatNameDesc($translate) {
        return function (input, _lang) {
            var lang = _lang || 'es';

            if (!input)
                return '';

            if (angular.isArray(input)) {
                var a = input.filter(function (el) {
                    return el.language === $translate.use();
                })[0];
                return a ? a.value : '';
            } else {
                return input[$translate.use()];
            }
        };
    }

    function showLink() {//"<a href="www.google.es">Google</a>" --> www.google.es
        return function (input) {
            input = input.replace(/<a href=['"]|["']|<\/a>+/g, '').split('>');
            return input[0];
        };
    }

    function showText() {//"<a href="www.google.es">Google</a>" --> Google
        return function (input) {
            input = input.replace(/<a href=['"]|["']|<\/a>+/g, '').split('>');
            return input[1];
        };
    }

    function checkStbStatus() {
        return function (input, _now_) {
            if (!input || !input.status)
                return 'Inactivo';

            if (input.properties && input.properties.locked)
                return 'Bloqueado';

            var now = (_now_) ? new Date(_now_) : new Date();
            now.setMinutes(now.getMinutes() - 2);//Hora hace 2 minutos
            var ultCon = new Date(input.status.ultConexion);
            return ((now < ultCon) ? 'Activo' : 'Inactivo');
        };
    }

    function convertMinutesInHHMMSS($filter) {
        return function (input, minimized) {
            var numbers = [Math.floor(input / 24 / 60), Math.floor(input / 60 % 24), input % 60];
            var words = minimized ?
                    [$filter('translate')('FILTERS.CONVERTDATES.D'),
                        $filter('translate')('FILTERS.CONVERTDATES.H'),
                        $filter('translate')('FILTERS.CONVERTDATES.M'),
                        $filter('translate')('FILTERS.CONVERTDATES.S')] :
                    [$filter('translate')('FILTERS.CONVERTDATES.DIA'),
                        $filter('translate')('FILTERS.CONVERTDATES.HORA'),
                        $filter('translate')('FILTERS.CONVERTDATES.MINUTO'),
                        $filter('translate')('FILTERS.CONVERTDATES.SEGUNDO')];

            var b = [];
            for (var j = 0; j < numbers.length; j++) {
                if (numbers[j] > 0)
                    b.push(numbers[j] + words[j] + ((numbers[j] > 1 && !minimized) ? 's' : ''));
            }

            var a = '';
            for (var i = 0; i < b.length; i++) {
                a += (b[i]);
                if (i < b.length - 2)
                    a += ', ';
                if (i === b.length - 2)
                    a += $filter('translate')('FILTERS.CONVERTDATES.Y');
            }

            return a;
        };
    }

    function convertSeconds($filter) {
        return function (input, minimized) {
            var days = Math.floor(input / 86400);
            input -= days * 86400;
            var hours = Math.floor(input / 3600) % 24;
            input -= hours * 3600;
            var minutes = Math.floor(input / 60) % 60;
            input -= minutes * 60;
            var seconds = input % 60;

            var numbers = [days, hours, minutes, seconds];
            var words = minimized ?
                    [$filter('translate')('FILTERS.CONVERTDATES.D'),
                        $filter('translate')('FILTERS.CONVERTDATES.H'),
                        $filter('translate')('FILTERS.CONVERTDATES.M'),
                        $filter('translate')('FILTERS.CONVERTDATES.S')] :
                    [$filter('translate')('FILTERS.CONVERTDATES.DIA'),
                        $filter('translate')('FILTERS.CONVERTDATES.HORA'),
                        $filter('translate')('FILTERS.CONVERTDATES.MINUTO'),
                        $filter('translate')('FILTERS.CONVERTDATES.SEGUNDO')];

            var b = [];
            for (var j = 0; j < numbers.length; j++) {
                if (numbers[j] > 0)
                    b.push(numbers[j] + words[j] + ((numbers[j] > 1 && !minimized) ? 's' : ''));
            }

            var a = '';
            for (var i = 0; i < b.length; i++) {
                a += (b[i]);
                if (i < b.length - 2)
                    a += ', ';
                if (i === b.length - 2)
                    a += $filter('translate')('FILTERS.CONVERTDATES.Y');
            }

            if (!a)
                a = minimized ? 0 + $filter('translate')('FILTERS.CONVERTDATES.S') : 0 + $filter('translate')('FILTERS.CONVERTDATES.SEGUNDO') + 's';

            return a;
        };
    }

    function convertSecondsWithoutDays($filter) {
        return function (input, minimized) {
            var hours = Math.floor(input / 3600);
            input -= hours * 3600;
            var minutes = Math.floor(input / 60) % 60;
            input -= minutes * 60;
            var seconds = input % 60;

            var numbers = [hours, minutes, seconds];
            var words = minimized ?
                    [$filter('translate')('FILTERS.CONVERTDATES.H'),
                        $filter('translate')('FILTERS.CONVERTDATES.M'),
                        $filter('translate')('FILTERS.CONVERTDATES.S')] :
                    [$filter('translate')('FILTERS.CONVERTDATES.HORA'),
                        $filter('translate')('FILTERS.CONVERTDATES.MINUTO'),
                        $filter('translate')('FILTERS.CONVERTDATES.SEGUNDO')];

            var b = [];
            for (var j = 0; j < numbers.length; j++) {
                if (numbers[j] > 0)
                    b.push(numbers[j] + words[j] + ((numbers[j] > 1 && !minimized) ? 's' : ''));
            }

            var a = '';
            for (var i = 0; i < b.length; i++) {
                a += (b[i]);
                if (i < b.length - 2)
                    a += ', ';
                if (i === b.length - 2)
                    a += $filter('translate')('FILTERS.CONVERTDATES.Y');
            }

            if (!a)
                a = minimized ? 0 + $filter('translate')('FILTERS.CONVERTDATES.S') : 0 + $filter('translate')('FILTERS.CONVERTDATES.SEGUNDO') + 's';

            return a;
        };
    }

    function replacePath(JSONconfig) {
        return function (input, from, to) {
            if (!input)
                return;

            if (from && to) {
                return input.replace(from, to);
            } else {
                return input.replace(JSONconfig.logosPath.from, JSONconfig.logosPath.to);
            }
        };
    }

    function stringifyArray() {
        return function (array, limits, separator) {
            if (!Array.isArray(array)) {
                return array; // if not array return original - can also throw error
            }
            var aux = array.join(separator || ', ');
            return limits ? '[' + aux + ']' : aux;
        };
    }

    function parseJSON() {
        return function (str) {
            var a, b;
            try {
                a = JSON.parse(str);
                b = arguments[1] ? eval('a.' + arguments[1]) : a;
            } catch (e) {
                console.log('Error en formato de JSON');
                return '';
            }
            return b;
        };
    }

    function formatBytes() {//Pasa bytes a otros formatos
        return function (bytes, decimals) {
            if (bytes === 0)
                return '0 Bytes';
            var k = 1000,
                    dm = decimals || 2,
                    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        };
    }

    function trustUrl($sce) {
        return function (recordingUrl) {
            return $sce.trustAsResourceUrl(recordingUrl);
        };
    }

    function formatReportName() { //toDate: true -> en tipo Date() / false -> en string
        return function (input, toDate) {
            if (input)
                return toDate ? new Date(input.split('.json')[0]) : input.split('.json')[0];
        };
    }

    function tryParseInt() {
        return function (input) {
            var p = parseInt(input);

            return isNaN(p) ? input : p;
        };
    }

    function pxeSplit() {
        return function (input, result) { //result: 'color' o 'bool'
            if (!input.lastSystem)
                return 'lightcoral';

            if (!input.matchSystem) {
                var a = input.lastSystem.split('=');
                if (a[1] === 'PXE' && a[0] === input.systemNow) {
                    return (result === 'color') ? 'lightblue' : false;
                } else {
                    return (result === 'color') ? 'lightcoral' : true;
                }
            } else {
                return (result === 'color') ? 'lightgreen' : false;
            }
        };
    }

    function translateStat($filter) {
        return function (input) {
            var a = $filter('translate')("ESTADISTICAS.SCREENS." + input);
            if (a.indexOf("ESTADISTICAS.SCREENS.") === 0)
                return input;
            else
                return a;
        };
    }

    function groupBy() {
        return function (input, property) {
            if (!angular.isArray(input))
                return;

            var o = {};

            $.each(input, function (index, value) {
                var prop = value[property] || "";

                if (!o[prop])
                    o[prop] = [];
                o[prop].push(value);
            });

            var arr = [];
            $.each(o, function (key, value) {
                arr.push({key: key, value: value});
            });

            return arr;
        };
    }

    function generateCode() {
        return function (input) {
            if (!input)
                return null;
            return ('0000' + ((input * input) + input)).slice(-4);
        };
    }

    function signalToPercent() {
        return function (input, min, max) {
            if (!input)
                return null;
            var a = ((parseFloat(input) - min) / (max - min)) * 100;
            var b = Math.min(100, Math.max(0, a));
            return Math.round(b);
        };
    }

})();

(function ()
{
    'use strict';
    angular
            .module('project')
            .directive('onLastRepeat', onLastRepeat)
            .directive('onErrorImage', onErrorImage)
            .directive('apsUploadFile', apsUploadFile)
            .directive('onNoImage', onNoImage)
            .directive('getTranslateJson', getTranslateJSON)
            .directive('navigationSearch', navigationSearch)
            .directive('exportToFile', ExportFile)
            .directive('ngRightClick', ngRightClick)
            .directive('stbScreenshot', stbScreenshot)
            .directive('copyToClipboard', copyToClipboard);

    function onLastRepeat($timeout) {
        return function (scope, element, attrs) {
            if (scope.$last || (scope[attrs.onLastRepeat] && scope[attrs.onLastRepeat].length === 0))
                $timeout(function () {
                    scope.$emit('onRepeatLast', element, attrs);
                });
        };
    }

    function onErrorImage() {
        return function (scope, iElement, iAttrs) {
            iElement.bind('error', function () {
                angular.element(this).attr("src", iAttrs.onErrorImage || "/assets/quantionImagenes/img-error.png");
            });
        };
    }

    function apsUploadFile() {
        var directive = {
            restrict: 'E',
            scope: {
                target: '=targetVariable'
            },
            template: '<input id="fileInput" type="file" accept="{{inputAccept}}" class="ng-hide"> <md-button id="uploadButton" class="md-raised md-primary" aria-label="attach_file">{{buttonText}}</md-button><h3>{{target.name}}</h3>',
            link: function apsUploadFileLink(scope, element, attrs) {
                scope.buttonText = attrs.buttonText;
                scope.inputAccept = attrs.inputAccept;
                var input = $(element[0].querySelector('#fileInput'));
                var button = $(element[0].querySelector('#uploadButton'));
                if (input.length && button.length) {
                    button.click(function (e) {
                        input.click();
                    });
                }

                input.on('change', function (e) {
                    var files = e.target.files;
                    console.log(files);
                    if (files[0] && files[0].type.split('/')[0] === 'image') {
                        scope.target = {
                            file: files[0],
                            name: files[0].name,
                            extension: files[0].type.split('/')[1],
                            size: files[0].size,
                            keyName: +new Date() + '.' + files[0].type.split('/')[1]
                        };
                    } else {
                        scope.target = null;
                    }
                    scope.$apply();
                });
            }
        };
        return directive;
    }

    function onNoImage() {
        return function (scope, iElement, iAttrs) {
            iElement.attr("src", iAttrs.onNoImage || "/assets/quantionImagenes/img-error.png");
        };
    }

    function getTranslateJSON() {
        var directive = {
            restrict: 'E',
            template: '<md-icon md-font-icon="icon-earth"></md-icon>',
            link: function apsUploadFileLink(scope, element, attrs) {
                var button = $(element[0].querySelector('md-icon'));
                if (button.length) {
                    button.click(function (e) {
                        var o = {};
                        $(attrs.elementName + ' [t]').each(function (index) {
                            expand($(this)[0].attributes.t.value, o, $(this)[0].innerText);
                        });
                        console.warn('Reemplazar todas las etiquetas "t" por "translate"');
                        console.info(angular.toJson(o, true));
                    });
                }
            }
        };
        return directive;
    }

    function expand(mystr, obj, content) {
        var items = mystr.split(".");
        var output = {};
        var ref = obj;
        for (var i = 0; i < items.length - 1; i++) {
            if (!ref[items[i]])
                ref[items[i]] = {};
            ref = ref[items[i]];
        }

        ref[items[items.length - 1]] = content || "";
        return output;
    }

    function navigationSearch(RoleService, $filter, $rootScope, $state) {
        var directive = {
            restrict: 'E',
            template:
                    '<md-autocomplete md-input-id="navSearchInput" md-selected-item="selectedItem"' +
                    '   md-search-text="searchText" md-selected-item-change="selectedItemChange(item)"' +
                    '   md-items="item in querySearch(searchText)" md-item-text="item.translate|translate"' +
                    '   md-min-length="0" placeholder="{{\'TOOLBAR.PLACEHOLDERBUSCADOR\'|translate}}" md-autoselect>' +
                    '       <md-item-template>' +
                    '           <md-icon class="{{item.icon}}" style="font-size: 24px;height: 24px;line-height: 24px"></md-icon>' +
                    '           <span md-highlight-text="searchText" md-highlight-flags="^i">{{item.translate|translate}}</span>' +
                    '       </md-item-template>' +
                    '       <md-not-found>No hay resultados</md-not-found>' +
                    '</md-autocomplete>',
            link: function (scope, element, attrs) {
                scope.lista = RoleService.getUserStoredNodes();

                scope.lista.sort(function (a, b) {
                    return angular.lowercase(a.title).localeCompare(angular.lowercase(b.title));
                });

//                var lastTime;

//                $(document).keydown(function (event) {
//                    var t = +(new Date());
//
//                    if (event.which === 16) {
//                        if ((t - lastTime) < 500)
//                            $('#navSearchInput').focus();
//                        lastTime = t;
//                    }
//                });

                scope.querySearch = function (query) {
                    return query ? scope.lista.filter(createFilterFor(query)) : scope.lista;
                };

                function createFilterFor(query) {
                    var lowercaseQuery = angular.lowercase(query);

                    return function (node) {
                        return (angular.lowercase($filter('translate')(node.translate)).indexOf(lowercaseQuery) !== -1);
                    };
                }

                scope.selectedItemChange = function (item) {
                    if (item && item.state)
                        $state.go(item.state);
                };
            }
        };
        return directive;
    }

    function ExportFile() {
        var directive = {
            restrict: 'E',
            scope: {
                data: '='
            },
            template: ' <md-button id="exportButton" class="md-fab md-mini md-primary">' +
                    '       <md-icon md-font-icon="icon-download" class="icon"></md-icon>' +
                    '       <md-tooltip md-direction="bottom"><span>{{tooltipText}}</span></md-tooltip>' +
                    '   </md-button>' +
                    '   <a href="#" id="link" download="" hidden/>',
            link: function (scope, element, attrs) {
                scope.tooltipText = attrs.tooltipText;

                var a = $(element[0].querySelector('#link'));
                var button = $(element[0].querySelector('#exportButton'));

                if (button.length && a.length) {
                    button.click(function (e) {
                        var file;
                        var properties = {type: 'text/plain'};
                        file = new Blob([angular.toJson(scope.data, true)], properties);
                        var url = URL.createObjectURL(file);
                        a[0].download = attrs.filename + ' (' + (new Date()).toLocaleDateString('es-ES') + ').json';
                        a[0].href = url;
                        a[0].click();
                    });
                }
            }
        };
        return directive;
    }

    function ngRightClick($parse) {
        return function (scope, element, attrs) {
            var fn = $parse(attrs.ngRightClick);
            element.bind('contextmenu', function (event) {
                scope.$apply(function () {
                    event.preventDefault();
                    fn(scope, {$event: event});
                });
            });
        };
    }

    function stbScreenshot(quantionApi) {
        var directive = {
            restrict: 'E',
            scope: {
                stb: '=',
                size: '='
            },
            template: '<div ng-click="getImage()">\n\
                <img src="" id="img" alt=""/>\n\
                <div layout="row" layout-align="center center" ng-if="loading">\n\
                    <md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular>\n\
                </div>\n\
            </div>',
            link: function (scope, element, attrs) {
                var img = $(element[0].querySelector('#img'));

                scope.$watch('stb', function (stb) {
                    if (stb) {
                        if (stb && scope.stb && stb.idStb !== scope.stb.idStb) {
                            img[0].src = "";
                        }
                        scope.stb = stb;
                        scope.getImage();
                    }
                });

                scope.getImage = function () {
                    scope.loading = true;
                    quantionApi.screenshotStb(scope.stb.idStb, scope.size).then(function (dataResponse) {
                        img[0].src = 'data:image/jpeg;base64,' + dataResponse.data;
                        scope.loading = false;
                    }, function () {
                        img[0].src = "";
                        scope.loading = false;
                    });
                };
            }
        };
        return directive;
    }

    function copyToClipboard($mdToast) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.click(function () {
                    if (attrs.copyToClipboard) {
                        var $temp_input = $("<input>");
                        $("body").append($temp_input);
                        $temp_input.val(attrs.copyToClipboard).select();
                        document.execCommand("copy");
                        $temp_input.remove();
                        $mdToast.show($mdToast.simple().textContent('Copiado al portapapeles').position('top right').hideDelay(3000));
                    }
                });
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
            .module('project')
            .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        vm.themes = fuseTheming.themes;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('project');
})();

(function ()
{
    'use strict';

    angular
            .module('project')
            .config(config);

    /** @ngInject */
    function config($mdThemingProvider, $mdDateLocaleProvider, $httpProvider)
    {
        //Configuración para los calendarios
        $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
        $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD-MM-YYYY');
        };

        $httpProvider.interceptors.push(['$injector', function ($injector) {
            return {
                'request': function (config) {
                    var $rootScope = $injector.get('$rootScope');

                    if (config.url.indexOf('/Solertia') !== -1 && $rootScope.user) {
                        config.headers['solertia-user'] = $rootScope.user.name;
                    }

                    var incidencesConfig = $injector.get('IncidencesConfig');

                    if (config.url.indexOf(incidencesConfig.urlIncidencias) !== -1 &&
                            config.url.indexOf('users/login') === -1) {
                        var token = $injector.get('incidencesApi').getToken();

                        if (token) {
                            config.headers.Authorization = 'Bearer ' + token;
                        }
                    }

                    return config;
                },
                'responseError': function (rejection) {
                    if (rejection.config) {
                        var incidencesConfig = $injector.get('IncidencesConfig');

                        if (rejection.config.url.indexOf(incidencesConfig.urlIncidencias) !== -1 &&
                                rejection.status === 401) {
                            $injector.get('incidencesApi').clearToken();
                        }
                    }

                    return rejection;
                }
            };
        }]);
    }

})();
(function ()
{
    'use strict';

    angular
            .module('project')
            .service('quantionApi', quantionApiService)
            .service('incidencesApi', incidencesApiService)
            .service('incidencesStateService', incidencesStateService)
            .service('translateApi', translateApiService)
            .service('messagesApi', messagesApiService)
            .service('dirayaApi', dirayaApiService);

    function quantionApiService($http, JSONconfig, FilePaths, $rootScope) {

        var api = this;

        api.baseUrl = JSONconfig.Protocol + JSONconfig.BaseUrl + JSONconfig.APIPort + '/Solertia';
        api.statsUrl = JSONconfig.Protocol + JSONconfig.BaseUrl + JSONconfig.APIPort + '/Stats';
        api.flowUrl = JSONconfig.urlFlow + '/' + JSONconfig.tipoFlow;

        document.title = JSONconfig.tituloVentana;

        //****************** Servidor activo *******************
        this.serverOn = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/serveron'
            });
        };

        //***************** Nombre de instalación **************
        this.installationName = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/name/installation'
            });
        };

        //***************** Nombre de la flow ******************
        this.installationFlow = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/name/flow'
            });
        };

        //*************** Versión de middleware ****************
        this.middlewareVersion = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/version'
            });
        };

        //**************************STB*************************

        this.addStb = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbs',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.getStbs = function (simple, extended) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '' + (simple ? '/stbs/pagination/simple' : '/stbs'),
                params: {
                    extended: extended
                },
//                headers: {'solertia-user': $rootScope.user.name}
            });
        };

        this.getStbsPag = function (page, number) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/pagination/' + page + '/' + number
            });
        };

        this.getStb = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/id/find',
                params: {
                    id: idStb
                }
            });
        };

        this.getStbByIp = function (ip) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + ip
            });
        };

        this.updateStb = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs',
                headers: {'Content-Type': 'application/json'},
                data: json //formato de json: {"ip": "192.168.150.120", "mac": "11:11:11:11:11:00", ...}
            });
        };

        this.patchStb = function (id, json) {
            return $http({
                method: 'PATCH',
                url: api.baseUrl + '/stbs/' + id,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteStb = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/' + id
            });
        };

        this.createOrUpdateWifiPassword = function (idStb) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbs/' + idStb + '/qr'
            });
        };

        this.getBalance = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/balance'
            });
        };

        this.getCheck = function (obj) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + obj.idStb + '/check',
                params: {
                    idStb: obj.idStb,
                    limit: obj.limit,
                    check: obj.check, //In, Out o ChangeRoom
                    follow: obj.follow //null o true
                }
            });
        };

        this.updateCheck = function (idStb, check) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/' + idStb + '/check',
                params: {
                    check: check, //'Out' o 'In'
                    place: 'Front'
                },
//                headers: {'solertia-user': $rootScope.user.name}
            });
        };

        this.changeVersionAndInstallation = function (idStb, typeInstall, typeVersion) {//SOLO DESARROLLO
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/' + idStb + '/installtype',
                params: {
                    typeInstall: typeInstall,
                    typeVersion: typeVersion
                }
            });
        };

        this.changeRoom = function (from, to, options) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/change',
                params: {
                    from: from,
                    to: to,
                    name: options && options.changeName,
                    checkout: options && options.checkout,
                    merge: options && options.merge
                }
            });
        };

        this.connectVNC = function (idStb) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/vnc',
                params: {
                    id: idStb
                },
//                headers: {'solertia-user': $rootScope.user.name}
            });
        };

        this.getUptime = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/uptime',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getDispositivosConectados = function (ipStb, wifiPassword) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/wifi/auto',
                headers: {'Content-Type': 'application/json'},
                params: {
                    ipStb: ipStb,
                    user: wifiPassword
                }
            });
        };

        this.setDynamic = function (idStb) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/dynamic/' + idStb,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.updateInstalacionDeStb = function (idStb, idInstalacion) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/' + idStb + '/installation/' + idInstalacion,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getApsDisponibles = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/check/ap',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteCacheEdid = function (idStb) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/' + idStb + '/edid'
            });
        };

        this.getCardLog = function (ipStb) {
            return api.baseUrl + '/stbs/cardreader/log?ipStb=' + ipStb;
//            return $http({
//                method: 'GET',
//                url: api.baseUrl + '/stbs/cardreader/log',
//                params: {ipStb: ipStb}
//            });
        };

        this.resetUsbHubStb = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/resethub'
            });
        };

        this.screenshotStb = function (idStb, size) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/screenshot/' + (size || 30)
//                url: 'https://' + ipStb + ':8091/screenshot/' + (size || 30)
            });
        };

        this.openVideocall = function (idStb, roomName) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbs/' + idStb + '/videocall/' + roomName
            });
        };

        this.closeVideocall = function (idStb) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/' + idStb + '/videocall'
            });
        };

        this.openMonitoring = function (idStb) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbs/' + idStb + '/monitoring'
            });
        };

        this.closeMonitoring = function (idStb) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/' + idStb + '/monitoring'
            });
        };

        //************************ LOTES ****************************
        this.patchStbLotes = function (idArray, json) {
            return $http({
                method: 'PATCH',
                url: api.baseUrl + '/stbs/update/lotes',
                headers: {'Content-Type': 'application/json'},
                data: json,
                params: {
                    ids: idArray.toString()
                }
            });
        };

        this.igualarExtensionLotes = function (idArray) {
            return $http({
                method: 'PATCH',
                url: api.baseUrl + '/stbs/update/extension/lotes',
                headers: {'Content-Type': 'application/json'},
                params: {
                    ids: idArray.toString()
                }
            });
        };

        this.updateCheckLotes = function (idArray, check) {
            return $http({
                method: 'PATCH',
                url: api.baseUrl + '/stbs/checkInOut/lotes',
                headers: {'Content-Type': 'application/json'},
                params: {
                    ids: idArray.toString(),
                    checkType: check //'Out' o 'In'
                }
            });
        };

        this.deleteStbLotes = function (idArray) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/delete/lotes',
                params: {
                    ids: idArray.toString()
                }
            });
        };

        //**************************EVENTO LOG*************************
        this.getEventosLog = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/events/logs'
            });
        };

        //**************************EVENTO*************************

        this.addEvento = function (evento) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/events',
                headers: {'Content-Type': 'application/json'},
                data: evento
            });
        };

        //Elimina TODO, eventoLog, eventos y eventosProg
        this.deleteEventos = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/events'
            });
        };

        this.getEventos = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/events'
            });
        };

        this.getNotificacionLogos = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                params: {
                    folder: FilePaths.notificaciones
                }
            });
        };

        this.deleteEvento = function (idEvento) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/events/normal/' + idEvento
            });
        };

        //***********************EVENTO PROGRAMADO*************************

        this.addEventoProgramado = function (ep) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/events/programmed',
                headers: {'Content-Type': 'application/json'},
                data: ep
                        //Formato ep: {"evento":{"title":"Prueba","message":"Mensaje de prueba","displaytime":10000,"ips":["192.168.150.108","192.168.150.109"]},"fIni":"2016-05-11T08:33:40.563Z","fFin":"2016-05-11T08:33:40.563Z","intervalo":60}
            });
        };

        this.getEventosProgramados = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/events/programmed',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteEventoProgramado = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/events/programmed/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        //***************** TAREAS PROGRAMADAS *******************
        this.getTasks = function (type, command, excludeCommands) {
            return $http({
                method: 'GET',
                url: api.baseUrl + (type ? '/tasks/type' : '/tasks/task'),
                headers: {'Content-Type': 'application/json'},
                params: {
                    type: type,
                    command: command,
                    excludeCommands: angular.toJson(excludeCommands)
                }
            });
        };

        this.getTasksPaginated = function (options) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/tasks/type/pagination/' + (options && options.page || 1) + '/' + (options && options.num || 20),
                headers: {'Content-Type': 'application/json'},
                params: {
                    type: options && options.type,
                    command: options && options.command,
                    excludeCommands: options && angular.toJson(options.excludeCommands)
                }
            });
        };

        this.countTasksPaginated = function (options) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/tasks/type/pagination/countPages',
                headers: {'Content-Type': 'application/json'},
                params: {
                    type: options && options.type,
                    num: options && options.num || 20
                }
            });
        };

        this.addTask = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/tasks/task',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteTask = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/tasks/task/' + id
            });
        };

        this.deleteAllTasks = function (type) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/tasks/task',
                params: {
                    type: type
                }
            });
        };

        //******************** Procesos **********************
        this.getProcesos = function (type, command, excludeCommands) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/procesos',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteProceso = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/procesos/' + id
            });
        };

        //*********************** IDIOMA *************************
        this.getIdiomas = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/langs',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addIdioma = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/langs',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateIdioma = function (obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/langs',
                headers: {'Content-Type': 'application/json'},
                params: {
                    idLang: obj.idIdioma,
                    language: obj.idioma,
                    routeIcon: obj.rutaIcono
                }
            });
        };

        this.deleteIdioma = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/langs/' + id
            });
        };

        //*********************** GESTION DE RECURSOS *************************
        this.getDisk = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                params: {
                    folder: FilePaths.misContenidos
                }
            });
        };

        //***************WEATHER************
        this.getWeather = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/weather',
                headers: {'Content-Type': 'application/json'}
            });
        };

        //**************************CANALES*************************
        this.addCanal = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/channels',
                headers: {'Content-Type': 'application/json'},
                data: json //{"tvgId":"TVE TDT HD4.sp","tvgLogo":"TVE","nombre":"La 1 HD SPA", "urlStreaming":"udp://@239.255.4.36:1234","idioma":"es","tipo":0}
            });
        };

        this.getCanales = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/channels'
            });
        };

        this.getCanalesTV = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/channels/tv'
            });
        };

        this.getCanalesRadio = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/channels/radio'
            });
        };

        this.getCanal = function (idCanal) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/channels/' + idCanal
            });
        };

        this.updateCanal = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/channels',
                headers: {'Content-Type': 'application/json'},
                data: json //{"idCanal":X,"tvgId":"TVE TDT HD4.sp","tvgLogo":"TVE","nombre":"La 1 HD SPA", "urlStreaming":"udp://@239.255.4.36:1234","idioma":"es","tipo":0}
            });
        };

        this.deleteCanal = function (idCanal) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/channels/' + idCanal
            });
        };

        this.getLogosTv = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                params: {
                    folder: FilePaths.logos.tv
                }
            });
        };

        this.getLogosRadio = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                params: {
                    folder: FilePaths.logos.radio
                }
            });
        };

        this.deleteTodosCanales = function () {//BORRA TODOS LOS CANALES
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/channels'
            });
        };

        this.deleteCanalesRadio = function () {//BORRA TODOS LOS CANALES
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/channels/delete/radio'
            });
        };

        this.deleteCanalesTV = function () {//BORRA TODOS LOS CANALES
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/channels/delete/tv'
            });
        };

        //**************************RADIO ONLINE*************************
        this.getCanalesRadioOnline = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/radio'
            });
        };

        this.getCanalRadioOnline = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/radio/' + id
            });
        };

        this.getCanalesRadioOnlinePorPais = function (idioma) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/radio/country',
                params: {
                    country: idioma
                }
            });
        };

        this.addCanalRadioOnline = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/radio',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateCanalRadioOnline = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/radio',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteTodosCanalesRadioOnline = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/radio'
            });
        };

        this.deleteCanalRadioOnline = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/radio/' + id
            });
        };

        //**************************FUNCIONES RÁPIDAS*************************
        this.rebootStb = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/reboot'
            });
        };

        this.rebootInterface = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/serviceReboot'
            });
        };

        //************************** USUARIOS *************************
        this.getUsuarios = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users'
            });
        };

        this.getUsuario = function (nombre) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users/' + nombre
            });
        };

        this.getUsuarioPorId = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users/id/' + id
            });
        };

        this.existUserById = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users/exists/' + id
            });
        };

        this.addUsuario = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/users',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.loginUsuario = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/users/login',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteUsuario = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/users/' + id
            });
        };

        this.updateUsuario = function (id, json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/users/' + id,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updatePasswordUsuario = function (id, oldPassword, newPassword) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/users/' + id + '/password',
                headers: {'Content-Type': 'application/json'},
                params: {
                    oldpassword: oldPassword,
                    newpassword: newPassword
                }
            });
        };

        this.getHistorialLogin = function (obj) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/users/historic/date',
                params: obj
            });
        };

        //************************** FLOW / EPG *************************
        this.getCanalesFlow = function (idFlow) {
            return $http({
                method: 'GET',
                url: api.flowUrl + '/find/' + idFlow + '/channels'
            });
        };

        this.getFlow = function (idFlow) {
            return $http({
                method: 'GET',
                url: api.flowUrl + '/find/' + idFlow + '/json/web'
            });
        };

        //************************** PAQUETES *************************
        this.getPaquetes = function (resumed) {
            return $http({
                method: 'GET',
                url: api.baseUrl + (resumed ? '/packages/language' : '/packages')
            });
        };

        this.getPaquetesActivos = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/packages?active=true'
            });
        };

        this.addPaquete = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/packages',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.getPaquetesPorTipo = function (tipo) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/packages/type/' + tipo
            });
        };

        this.deletePaquete = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/packages/' + id
            });
        };

        this.getPaquete = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/packages/' + id
            });
        };

        this.updatePaquete = function (id, json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/packages/' + id,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteDuracionDePaquete = function (idPaquete, duracion) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/packages/' + idPaquete + '/duration/' + duracion
            });
        };

        this.addPrecioDuracionDePaquete = function (idPaquete, duracion, precio) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/packages/' + idPaquete + '/duration/' + duracion + '/price/' + precio
            });
        };

        this.updatePrecioDuracionDePaquete = function (idPaquete, duracion, precio) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/packages/' + idPaquete + '/duration/' + duracion + '/price/' + precio
            });
        };

        this.deleteServicioPromocionalDePaquete = function (idPaquete, idServicio) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/packages/' + idPaquete + '/promotional/' + idServicio
            });
        };

        this.addServicioPromocionalAPaquete = function (idPaquete, idServicio, duracion) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/packages/' + idPaquete + '/promotional/' + idServicio + '/duration/' + duracion
            });
        };

        this.updateServicioPromocionalDePaquete = function (idPaquete, idServicio, duracion) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/packages/' + idPaquete + '/promotional/' + idServicio + '/duration/' + duracion
            });
        };

        this.deleteServicioOrdinarioDePaquete = function (idPaquete, idServicio) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/packages/' + idPaquete + '/service/' + idServicio
            });
        };

        this.addServicioOrdinarioAPaquete = function (idPaquete, idServicio) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/packages/' + idPaquete + '/service/' + idServicio
            });
        };

        this.getLogosPaquetesServicios = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                params: {
                    folder: FilePaths.servicios_paquetes
                }
            });
        };

        //************************** SERVICIOS *************************

        this.getServicios = function (resume) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/services',
                params: {
                    resume: resume
                }
            });
        };

        this.getServiciosPorTipo = function (type, resume) {//detalle: true o false
            return $http({
                method: 'GET',
                url: api.baseUrl + '/services',
                params: {
                    type: type,
                    resume: resume
                }
            });
        };

        this.addServicio = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/services',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteServicio = function (idServicio) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/services/' + idServicio
            });
        };

        this.getServicio = function (id, resume) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/services/' + id,
                params: {
                    resume: resume
                }
            });
        };

        this.updateServicio = function (idServicio, json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/services/' + idServicio,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.getTiposServicio = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/services/types'
            });
        };

        this.uploadServiceLogo = function (file, acl, themes, fileName) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media/service',
                data: file,
                headers: {'Content-Type': undefined},
                params: {
                    acl: acl,
                    themes: Array.isArray(themes) ? themes.join(',') : themes, //Se debe mandar el contenido del array separado por comas
                    name: fileName
                },
                transformRequest: angular.identity
            });
        };

        this.getAcls = function (type) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/services/acls' + (type ? ('/type?type=' + type) : '')
            });
        };

        this.exportServices = function (services, themes) {
            return api.baseUrl + '/files/services/export?services=' + services + '&themes=' + themes;
        };

        this.importServices = function (file) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/services/import',
                data: file,
                headers: {'Content-Type': undefined},
                transformRequest: angular.identity
            });
        };

        //************************** Listado y borrado de archivos *************************
        this.uploadArchivoMedia = function (formData, nombre) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media',
                data: formData,
                headers: {'Content-Type': undefined},
                params: {
                    fileName: nombre,
                    folder: FilePaths.misContenidos
                },
                transformRequest: angular.identity
            });
        };

        this.deleteArchivoMedia = function (nombre) {//Para archivos de imagenes y video
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/media/' + nombre,
                params: {
                    folder: FilePaths.misContenidos
                }
            });
        };

        this.getFiles = function (tipo) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/image',
                headers: {'Content-Type': 'application/json'},
                params: {
                    type: tipo
                }
            });
        };

        this.deleteFiles = function (id, force) {//Para archivos de versiones de sistema, dinámicas y BIOS
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/image/' + id,
                headers: {'Content-Type': 'application/json'},
                params: {
                    force: force
                }
            });
        };

        //************************** Web Central *************************

        this.getWebCentral = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/webCentral'
            });
        };

        this.updateWebCentral = function (id, installation, modules) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/webCentral',
                headers: {'Content-Type': 'application/json'},
                data: modules,
                params: {
                    id: id,
                    installation: installation
                }
            });
        };

        this.updateAllWebCentral = function (modules) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/webCentral/hotelAndHospital',
                headers: {'Content-Type': 'application/json'},
                data: modules
            });
        };

        this.deleteModule = function (id, moduleName) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/webCentral/module',
                params: {
                    id: id,
                    module: moduleName
                }
            });
        };

        //************************** Grupos de STB *************************
        this.getGrupos = function (group) {
            return $http({
                method: 'GET',
                url: api.baseUrl + (group ? '/stbgroups/places' : '/stbgroups')
            });
        };

        this.getGruposMin = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbgroups/min'
            });
        };

        this.addGrupo = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbgroups',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateGrupo = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbgroups',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateImageVersionDeArrayStbs = function (json, nuevaVersion) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbgroups/imageversion/' + nuevaVersion,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateSystemVersionDeArrayStbs = function (json, nuevaVersion) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbgroups/systemversion/' + nuevaVersion,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteGrupo = function (idGrupo) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbgroups/' + idGrupo
            });
        };

        this.updateImageVersionDeGrupo = function (idGrupo, nuevaVersion) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbgroups/' + idGrupo + "/imageversion",
                headers: {'Content-Type': 'application/json'},
                data: nuevaVersion
            });
        };

        this.updateSystemVersionDeGrupo = function (idGrupo, nuevaVersion) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbgroups/' + idGrupo + "/systemversion",
                headers: {'Content-Type': 'application/json'},
                data: nuevaVersion
            });
        };

        this.setDynamicGrupo = function (stbs) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/dynamic',
                headers: {'Content-Type': 'application/json'},
                data: stbs
            });
        };

        //******************** Compra de paquetes *******************

        this.getAccountant = function (obj) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/accountant',
                params: obj
            });
        };

        this.getAccountantByID = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/accountant/' + id
            });
        };

        this.acquireBalance = function (obj, comment) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/accountant/balance',
                headers: {'Content-Type': 'text/plain'},
                data: comment,
                params: {
                    stb: obj.stb,
                    wallet: obj.wallet,
                    accountant: obj.accountant,
                    amount: obj.amount,
                    payment: obj.payment,
                    language: obj.language,
                    policy: obj.policy,
                    place: obj.place,
                    username: obj.username
                }
            });
        };

        this.acquirePackage = function (obj, comment) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/accountant/package',
                headers: {'Content-Type': 'text/plain'},
                data: comment,
                params: {
                    stb: obj.stb,
                    wallet: obj.wallet,
                    accountant: obj.accountant,
                    package: obj.package,
                    duration: obj.duration,
                    payment: obj.payment,
                    language: obj.language,
                    policy: obj.policy,
                    place: obj.place,
                    username: obj.username
                }
            });
        };

        this.revokeOperation = function (obj, comment) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/accountant/revoke',
                headers: {'Content-Type': 'text/plain'},
                data: comment,
                params: {
                    identifier: obj.identifier,
                    policy: obj.policy,
                    place: obj.place,
                    refund: obj.refund,
                    username: obj.username
                }
            });
        };

        this.acquireService = function (obj, objectNode) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/accountant/service',
                headers: {'Content-Type': 'application/json'},
                data: objectNode,
                params: {
                    stb: obj.stb,
                    wallet: obj.wallet,
                    duration: obj.duration,
                    language: obj.language,
                    place: obj.place,
                    username: obj.username
                }
            });
        };

        this.getBalanceLimit = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/balanceLimit',
                headers: {'Content-Type': 'application/json'}
            });
        };

        //***************** Estadisticas *********************
        this.getListaReportes = function () {
            return $http({
                method: 'GET',
                url: api.statsUrl + '/stats/listReports',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getReporte = function (reportName) {
            return $http({
                method: 'GET',
                url: api.statsUrl + '/stats/report/' + reportName,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getEstadisticasDeStb = function (macStb, inicio, fin) {
            return $http({
                method: 'GET',
                url: api.statsUrl + '/stats/findAllWindowsForAStb/' + encodeURIComponent(macStb),
                headers: {'Content-Type': 'application/json'},
                params: {//Se quitarán ambos parámetros
                    fechaAnterior: (inicio || new Date(0)).toString(),
                    fechaActual: (fin || new Date()).toString()
                }
            });
        };

        this.getStatus = function (macStb) {
            return $http({
                method: 'GET',
                url: api.statsUrl + '/status',
                headers: {'Content-Type': 'application/json'},
                params: {
                    macStb: macStb
                }
            });
        };

        this.getStatusAll = function (active) {
            return $http({
                method: 'GET',
                url: api.statsUrl + '/status/all' + (active ? '/active' : ''),
                headers: {'Content-Type': 'application/json'}
            });
        };

        //********************* Contabilidad (saldos) **********************
        this.getReporteSaldo = function (obj, idStbs) {
            if (!idStbs) {
                console.log('Version GET');
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/balance',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate, //Por defecto: 1970-1-1 -> Formato YYYY-MM-DD
                        toDate: obj.toDate, //Por defecto: Fecha de hoy
                        available: obj.available, //true:saldo actual o false:mostrar comparación
                        sum: obj.sum //true: suma , false: por separado
                    }
                });
            } else {
                console.log('Version POST');
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/balance',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate,
                        available: obj.available,
                        sum: obj.sum
                    },
                    data: idStbs
                });
            }
        };

        //******************* Contabilidad (Cajeros) ****************
        this.getReporteCajeros = function (obj) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/report/atm',
                headers: {'Content-Type': 'application/json'},
                params: {
                    fromDate: obj.fromDate, //Por defecto: 1970-1-1 -> Formato YYYY-MM-DD
                    toDate: obj.toDate //Por defecto: Fecha de hoy
                }
            });
        };

        this.getAtm = function (idAtm) {
            return $http({
                method: 'GET',
                url: api.baseUrl + (idAtm ? ('/atm/' + idAtm) : '/atm'),
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addAtm = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/atm',
                headers: {'Content-Type': 'application/json'},
                data: jsonObj
            });
        };

        this.updateAtm = function (jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/atm',
                headers: {'Content-Type': 'application/json'},
                data: jsonObj
            });
        };

        this.deleteAtm = function (idAtm) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/atm/' + idAtm,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.registryAtm = function () {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/atm/registry',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getReporteAtmAdmin = function (obj) {
            if (obj.atm) {
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/atm/admin',
                    headers: {'Content-Type': 'application/json'},
                    data: [obj.atm],
                    params: {
                        idArqueo: obj.idArqueo
                    }
                });
            } else {
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/atm/admin',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate
                    }
                });
            }
        };

        this.getReporteAtmClientCash = function (obj) {
            if (obj.atm) {
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/atm/client/cash',
                    headers: {'Content-Type': 'application/json'},
                    data: [obj.atm],
                    params: {
                        idArqueo: obj.idArqueo
                    }
                });
            } else {
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/atm/client/cash',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate
                    }
                });
            }
        };

        this.getReporteAtmClientCard = function (obj) {
            if (obj.atm) {
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/atm/client/card',
                    headers: {'Content-Type': 'application/json'},
                    data: [obj.atm],
                    params: {
                        idArqueo: obj.idArqueo
                    }
                });
            } else {
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/atm/client/card',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate
                    }
                });
            }
        };

        this.getReporteAtmClientRc = function (obj) {
            if (obj.atm) {
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/atm/client/rc',
                    headers: {'Content-Type': 'application/json'},
                    data: [obj.atm],
                    params: {
                        idArqueo: obj.idArqueo
                    }
                });
            } else {
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/atm/client/rc',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate,
                        package: obj.package
                    }
                });
            }
        };

        this.getReporteAtmClientFree = function (obj) {
            if (obj.atm) {
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/atm/client/free',
                    headers: {'Content-Type': 'application/json'},
                    data: [obj.atm],
                    params: {
                        idArqueo: obj.idArqueo
                    }
                });
            } else {
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/atm/client/free',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate
                    }
                });
            }
        };

        //******************** Edicion por lotes **********************
        this.updateVersionLote = function (obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/updateVariousStbs',
                headers: {'Content-Type': 'application/json'},
                data: obj.listIds,
                params: {
                    codigo: 'abcde',
                    imagen: obj.imagen,
                    updateSystem: obj.updateSystem,
                    updateBios: obj.updateBios,
                    tipo: obj.tipo //STANDARD, COMPRA o PREMIUM
                }
            });
        };

        this.rebootLote = function (list) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/rebootListStb',
                headers: {'Content-Type': 'application/json'},
                data: list
            });
        };

        this.serviceRebootLote = function (list) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/serviceRebootListStb',
                headers: {'Content-Type': 'application/json'},
                data: list
            });
        };

        //************ DHCP *****************
        this.getDhcpEquipos = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/DHCP/equipos',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.updateDhcpEquipos = function (doc) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/DHCP/equipos',
                headers: {'Content-Type': 'application/json'},
                data: doc
            });
        };

        //************ CONTABILIDAD PAQUETES *************
        this.getReportePaquetes = function (obj, idStbs, extended) {
            if (!idStbs || idStbs.length === 0) {
                console.log('Version GET');
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/package',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate, //Por defecto: 1970-1-1 -> Formato YYYY-MM-DD
                        toDate: obj.toDate, //Por defecto: Fecha de hoy
                        resume: obj.resume, //Por defecto: null
                        extended: extended,
                        remote: obj.remote
                    }
                });
            } else {
                console.log('Version POST');
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/package',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate,
                        resume: obj.resume,
                        extended: extended,
                        remote: obj.remote
                    },
                    data: idStbs
                });
            }
        };

        //************ CONTABILIDAD POR CONCEPTO *************
        this.getReporteConcepto = function (obj, idStbs) {
            if (!idStbs || idStbs.length === 0) {
                console.log('Version GET');
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/concept',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate, //Por defecto: 1970-1-1 -> Formato YYYY-MM-DD
                        toDate: obj.toDate, //Por defecto: Fecha de hoy
                        resume: obj.resume, //Por defecto: null
                        concept: obj.concept,
                        remote: obj.remote
                    }
                });
            } else {
                console.log('Version POST');
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/concept',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate,
                        resume: obj.resume,
                        concept: obj.concept,
                        remote: obj.remote
                    },
                    data: idStbs
                });
            }
        };

        //************ CONTABILIDAD PAQUETES *************
        this.getReportePago = function (obj, idStbs) {
            if (!idStbs || idStbs.length === 0) {
                console.log('Version GET');
                return $http({
                    method: 'GET',
                    url: api.baseUrl + '/report/payment',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate, //Por defecto: 1970-1-1 -> Formato YYYY-MM-DD
                        toDate: obj.toDate, //Por defecto: Fecha de hoy
                        resume: obj.resume, //Por defecto: null
                        payment: obj.payment,
                        remote: obj.remote,
                        place: obj.place
                    }
                });
            } else {
                console.log('Version POST');
                return $http({
                    method: 'POST',
                    url: api.baseUrl + '/report/payment',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        fromDate: obj.fromDate,
                        toDate: obj.toDate,
                        resume: obj.resume,
                        payment: obj.payment,
                        remote: obj.remote,
                        place: obj.place
                    },
                    data: idStbs
                });
            }
        };

        //********************* BANNERS **********************
        this.uploadArchivoMediaPubli = function (formData, nombre) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media',
                data: formData,
                headers: {'Content-Type': undefined},
                params: {
                    fileName: nombre,
                    folder: FilePaths.publicidad
                },
                transformRequest: angular.identity
            });
        };

        this.deleteArchivoMediaPubli = function (nombre) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/media/' + nombre,
                params: {
                    folder: FilePaths.publicidad
                }
            });
        };

        this.getBanners = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/banners',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getBannerById = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/banners/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getBannerByUrl = function (url) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/banners/delete/' + url,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getBannerActivos = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/banners/active',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getArchivosBanner = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/banners/local',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addBanner = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/banners',
                headers: {'Content-Type': 'application/json'},
                data: jsonObj
            });
        };

        this.updateBanner = function (jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/banners',
                headers: {'Content-Type': 'application/json'},
                data: jsonObj
            });
        };

        this.deleteAllBanners = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/banners',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteBannerById = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/banners/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteBannerByUrl = function (url) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/banners',
                headers: {'Content-Type': 'application/json'},
                params: {
                    url: url
                }
            });
        };

        //***************** Grupos de banners *****************
        this.getGruposBanner = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/bannergroups',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addGrupoBanner = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/bannergroups',
                headers: {'Content-Type': 'application/json'},
                data: jsonObj
            });
        };

        this.updateGrupoBanner = function (jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/bannergroups',
                headers: {'Content-Type': 'application/json'},
                data: jsonObj
            });
        };

        this.deleteGrupoBanner = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/bannergroups/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getStbSinGrupo = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/bannergroups/nogroup',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.notifyGrupoBanner = function (id) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/banners/update/bannerlist',
                headers: {'Content-Type': 'application/json'},
                params: {
                    idBannerGroup: id
                }
            });
        };

        //**************** Instalaciones ***************
        this.getInstalaciones = function (simple) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/installation' + (simple ? '/simple' : ''),
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getInstalacion = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/installation/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addInstalacion = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/installation',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateInstalacion = function (id, json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/installation/' + id,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteInstalacion = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/installation/' + id
            });
        };

        this.getInstalacionThemes = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/installation/themes',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getThemeProperties = function (theme, fileName) {
            return $http({
                method: 'GET',
                url: JSONconfig.logosPath.to + '/' + FilePaths.temas + '/' + theme + '/' + fileName,
                headers: {'Content-Type': 'application/json'}
            });
        };

        //**************** Modelos STB ***************
        this.getModelos = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/models',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getModelo = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/models/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addModelo = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbs/models',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateModelo = function (id, json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/stbs/models/' + id,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteModelo = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/models/' + id
            });
        };

        this.getFeaturesModelos = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/models/features',
                headers: {'Content-Type': 'application/json'}
            });
        };

        //******************* Encuestas ***********************
        this.deleteQuestions = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/questions'
            });
        };

        this.getQuestions = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/questions',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addQuestion = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/questions',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateQuestion = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/questions',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.getQuestionsTypes = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/questions/types',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteQuestion = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/questions/' + id
            });
        };

        this.getQuestion = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/questions/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        // -----------------

        this.deleteResponses = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/responses'
            });
        };

        this.getResponses = function (idSurvey) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/responses',
                headers: {'Content-Type': 'application/json'},
                params: {
                    idSurvey: idSurvey
                }
            });
        };

        this.addResponse = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/responses',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateResponse = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/responses',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.getResponsesRangeDate = function (obj) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/responses/date',
                headers: {'Content-Type': 'application/json'},
                params: {
                    ini: obj.ini,
                    fin: obj.fin,
                    type: obj.type
                }
            });
        };

        this.deleteResponse = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/responses/' + id
            });
        };

        this.getResponse = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/responses/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        // ------------

        this.deleteSurveys = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/surveys'
            });
        };

        this.getSurveys = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/surveys',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addSurvey = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/surveys',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateSurvey = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/surveys',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.getSurveysByLang = function (lang) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/surveys/lang',
                headers: {'Content-Type': 'application/json'},
                params: {
                    lang: lang
                }
            });
        };

        this.deleteSurvey = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/surveys/' + id
            });
        };

        this.getSurvey = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/surveys/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.uploadFileSurvey = function (fileObj, nombre) {
            var formData = new FormData();
            formData.append('fileName', nombre || fileObj.keyName);
            formData.append('file', fileObj.file);

            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media',
                data: formData,
                headers: {'Content-Type': undefined},
                params: {
                    fileName: nombre || fileObj.keyName,
                    folder: FilePaths.encuestas
                },
                transformRequest: angular.identity
            });
        };

        this.getFilesSurvey = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: FilePaths.encuestas
                }
            });
        };

        this.deleteFileSurvey = function (name) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/media/' + name,
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: FilePaths.encuestas
                }
            });
        };

        //*********** Monederos virtuales **************

        this.getWallets = function (resume) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/wallets',
                headers: {'Content-Type': 'application/json'},
                params: {
                    resume: resume
                }
            });
        };

        this.addWallet = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/wallets',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteWallet = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/wallets/' + id
            });
        };

        this.getWallet = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/wallets/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.updateWalletCheck = function (id, checkType) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/wallets/' + id + '/check/' + checkType,
                headers: {'Content-Type': 'application/json'},
                params: {
                    place: "Front"
                }
            });
        };

        this.getWalletChecks = function (id, checkType, limit) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/wallets/' + id + '/check',
                params: {
                    limit: limit || 10,
                    check: checkType
                }
            });
        };

        this.getStbWallet = function (idStb) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/' + idStb + '/wallets',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.DesvincularStbWallet = function (idStb) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/stbs/' + idStb + '/wallets',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.VincularStbWallet = function (idStb, idWallet) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/stbs/' + idStb + '/wallets/' + idWallet,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.updateWalletLogoutOnDisconnect = function (id, newValue) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/wallets/' + id + '/logoutOnDisconnect/' + newValue
            });
        };

        //***************** Encriptación *******************
        this.encrypt = function (word) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/encrypt',
                headers: {'Content-Type': 'application/json'},
                params: {
                    password: word
                }
            });
        };

        //************************** Listado y subida de temas *************************
        this.uploadTema = function (formData) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/skin',
                data: formData,
                headers: {'Content-Type': undefined},
                params: {
                    fileName: 'subida.zip'
                },
                transformRequest: angular.identity
            });
        };

        this.getTemas = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/skins',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.downloadTema = function (nombre) {
            return api.baseUrl + '/files/skin?name=' + nombre;
        };

        //******************* VOIP **********************
        this.getExtensionesStb = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/extension/all',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getExtensionStbByMac = function (mac) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/extension/mac',
                headers: {'Content-Type': 'application/json'},
                param: {
                    mac: mac
                }
            });
        };

        this.getExtensionStbByIp = function (ip) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/stbs/extension/' + ip,
                headers: {'Content-Type': 'application/json'}
            });
        };
        /////
        this.getExtensiones = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/extensions',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getExtensionById = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/extensions/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addExtension = function (jsonObj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/extensions',
                data: jsonObj,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.updateExtension = function (jsonObj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/extensions',
                data: jsonObj,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteExtensiones = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/extensions',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteExtension = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/extensions/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        //************ Explorador de archivos ******************
        this.uploadGenericFile = function (formData, fileName, folder) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media',
                data: formData,
                headers: {'Content-Type': undefined},
                params: {
                    fileName: fileName,
                    folder: folder
                },
                transformRequest: angular.identity
            });
        };

        this.getGenericFiles = function (folder) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/files/media',
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: folder || ''
                }
            });
        };

        this.deleteGenericFile = function (fileName, folder) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/media/' + fileName,
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: folder
                }
            });
        };

        this.createFolder = function (folder, folderName) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/files/media',
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: folder,
                    fileName: folderName,
                    isFolder: true
                }
            });
        };

        this.deleteFolder = function (folder, parentFolder) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/files/media/' + folder,
                headers: {'Content-Type': 'application/json'},
                params: {
                    folder: parentFolder,
                    isFolder: true
                }
            });
        };

        //******************** Tarifas ************************
        this.getTarifas = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/tarifications',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getTarifa = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/tarifications/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addTarifa = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/tarifications',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateTarifa = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/tarifications',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteTarifas = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/tarifications',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteTarifa = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/tarifications/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getTarifaParaNumero = function (numero) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/tarifications/number/' + numero,
                headers: {'Content-Type': 'application/json'}
            });
        };

        //**************** Llamadas (knocks) ********************
        this.getLlamadas = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/knocks',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getLlamadasActivas = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/knocks/active',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getLlamada = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/knocks/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getLlamadasTotal = function (obj) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/knocks/total',
                headers: {'Content-Type': 'application/json'},
                params: {
                    extension: obj.extension,
                    ini: obj.ini,
                    fin: obj.fin
                }
            });
        };

        //************** Paises radio online *********************
        this.getRadioCountries = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/radio/radioCountry',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRadioCountry = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/radio/radioCountry/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addRadioCountry = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/radio/radioCountry',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updateRadioCountry = function (json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/radio/radioCountry',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deleteRadioCountries = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/radio/radioCountry',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteRadioCountry = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/radio/radioCountry/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        //************** Puntos de acceso *********************
        this.getPuntosAcceso = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/wifi',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getPuntoAcceso = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/wifi/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getTiposPuntoAcceso = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/wifi/types',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addPuntoAcceso = function (json) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/wifi',
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.updatePuntoAcceso = function (id, json) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/wifi/' + id,
                headers: {'Content-Type': 'application/json'},
                data: json
            });
        };

        this.deletePuntoAcceso = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/wifi/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        //**************** Tarjetas con acción ******************
        this.getCardsIntegration = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/cards/integration',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getCardIntegration = function (uuid) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/cards/integration/' + uuid,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addCardIntegration = function (obj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/cards/integration',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.updateCardIntegration = function (uuid, obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/cards/integration/' + uuid,
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.deleteCardIntegration = function (uuid) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/cards/integration/' + uuid,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getCardTypes = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/cards/types',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getCardType = function (name) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/cards/types/' + name,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addCardType = function (obj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/cards/types',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.updateCardType = function (name, obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/cards/types/' + name,
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.deleteCardType = function (name) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/cards/types/' + name,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getCardsVars = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/cards/vars',
                headers: {'Content-Type': 'application/json'}
            });
        };

        //******************** Properties *********************
        this.getProperties = function (installation, key) { //installation: true/false
            return $http({
                method: 'GET',
                url: api.baseUrl + '/properties' + (installation ? '/installation' : '') + (key ? '/value' : '/all'),
                headers: {'Content-Type': 'application/json'},
                params: {
                    key: key
                }
            });
        };

        this.updateProperties = function (installation, key, value) { //installation: true/false
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/properties' + (installation ? '/installation' : '') + '/value',
                headers: {'Content-Type': 'application/json'},
                params: {
                    key: key,
                    value: value
                }
            });
        };

        //************************ No provisionados **************************
        this.getUnprovisioned = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/unprovisioned',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getUnprovisionedByMac = function (mac) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/unprovisioned/' + mac,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.deleteUnprovisionedByMac = function (mac) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/unprovisioned/' + mac
            });
        };

        //************************ Controles **************************
        this.getControls = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/controls',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getControl = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/controls/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addControl = function (obj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/controls',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.updateControl = function (obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/controls',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.deleteControl = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/controls/' + id
            });
        };

        this.deleteControls = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/controls'
            });
        };

        //**************** Gateways (pasarela de pago) ******************
        this.getGateways = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/gateways',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getGateway = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/gateways/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addGateway = function (obj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/gateways',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.updateGateway = function (obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/gateways',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.deleteGateway = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/gateways/' + id
            });
        };

        this.deleteGateways = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/gateways'
            });
        };

        //**************** Nº agenda ******************
        this.getDiarys = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/diarys',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getDiary = function (id) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/diarys/' + id,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.addDiary = function (obj) {
            return $http({
                method: 'POST',
                url: api.baseUrl + '/diarys',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.updateDiary = function (obj) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/diarys',
                headers: {'Content-Type': 'application/json'},
                data: obj
            });
        };

        this.deleteDiary = function (id) {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/diarys/' + id
            });
        };

        this.deleteDiarys = function () {
            return $http({
                method: 'DELETE',
                url: api.baseUrl + '/diarys'
            });
        };

        //**************************** Reportes Valentín ****************************
        this.getVReport = function (from, to) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/vreport/' + from + '/' + to,
                headers: {'Content-Type': 'application/json'}
            });
        };
        this.resetVReport = function (from, to) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/vreport/' + from + '/' + to,
                headers: {'Content-Type': 'application/json'}
            });
        };
        this.putVReport = function (body) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/vreport',
                headers: {'Content-Type': 'application/json'},
                data: body
            });
        };

        //********************************* Ruckus ***********************************
        this.getRuckusApByMac = function (mac) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/aps/' + mac,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusApsBssids = function (configuration) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/aps/-/bssids',
                params: {
                    configuration: !!configuration
                },
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusApsBssidsByMac = function (mac, configuration) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/aps/' + mac + '/bssids',
                params: {
                    configuration: !!configuration
                },
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusApsClients = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/aps/-/clients',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusApsClientsByMac = function (mac) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/aps/' + mac + '/clients',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusAlarms = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/alarms',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusAlarmsByMac = function (mac) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/alarms/-/aps/' + mac,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusEvents = function () {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/events',
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.getRuckusEventsByMac = function (mac) {
            return $http({
                method: 'GET',
                url: api.baseUrl + '/ruckus/events/-/aps/' + mac,
                headers: {'Content-Type': 'application/json'}
            });
        };

        this.rebootRuckusApByMac = function (mac) {
            return $http({
                method: 'PUT',
                url: api.baseUrl + '/ruckus/aps/' + mac + '/reboot'
            });
        };
    }

    function incidencesApiService($http, IncidencesConfig) {
        var api = this;
        var JWT_KEY = 'incidencias-jwt';
        var JWT_EXPIRES_KEY = 'incidencias-jwt-expires';

        api.url = IncidencesConfig.urlIncidencias;
        api.instalacion = IncidencesConfig.instalacion;

        this.login = function (name, password) {
            return $http({
                method: 'POST',
                url: api.url + 'users/login',
                headers: {'Content-Type': 'application/json'},
                data: {name: name, password: password}
            });
        };

        this.setToken = function (jwt, expiresAt) {
            localStorage.setItem(JWT_KEY, jwt);
            localStorage.setItem(JWT_EXPIRES_KEY, String(expiresAt));
        };

        this.getToken = function () {
            var jwt = localStorage.getItem(JWT_KEY);
            var expiresAt = Number(localStorage.getItem(JWT_EXPIRES_KEY) || 0);

            if (!jwt || !expiresAt || Date.now() >= expiresAt) {
                this.clearToken();
                return null;
            }

            return jwt;
        };

        this.clearToken = function () {
            localStorage.removeItem(JWT_KEY);
            localStorage.removeItem(JWT_EXPIRES_KEY);
        };

        this.isAuthenticated = function () {
            return !!this.getToken();
        };

        this.getIncidenciasPorInstalacion = function (pending, solved) {
            return $http({
                method: 'GET',
                url: api.url + (pending ? 'incidences/installation/pending' : 'incidences/installation'),
                params: {
                    installation: api.instalacion,
                    solved: solved
                }
            });
        };

        this.getIncidenciasPreventivasPorInstalacion = function (pending, solved) {
            return $http({
                method: 'GET',
                url: api.url + (pending ? 'prevents/installation/pending' : 'prevents/installation'),
                params: {
                    installation: api.instalacion,
                    solved: solved
                }
            });
        };
    }

    function incidencesStateService($rootScope, $interval, $filter, $mdToast, $translate, $q, incidencesApi, quantionApi) {
        var POLL_MS = 60000;
        var pollPromise = null;
        var mapaPorRoom = {};
        var roomMapLoaded = false;

        var state = {
            incidences: [],
            prevents: [],
            loadingIncidences: false,
            loadingPrevents: false,
            errorIncidences: null,
            errorPrevents: null,
            lastRefresh: null,
            countIncidences: 0,
            countPrevents: 0
        };

        function classifyError(err, hasToken) {
            if (!hasToken || (err && err.status === 401)) {
                return 'auth';
            }
            if (!err || err.status === 0) {
                return 'network';
            }
            return 'unknown';
        }

        function parseTypeStyle(type) {
            if (!type) {
                return {};
            }

            try {
                var props = type.customProperties;

                if (typeof props === 'string') {
                    props = JSON.parse(props);
                }

                if (props && props.color) {
                    return {
                        'background-color': props.color,
                        color: props.fontColor || '#fff'
                    };
                }
            } catch (e) {
                return {};
            }

            return {};
        }

        this.getState = function () {
            return state;
        };

        this.getByRoom = function (room) {
            if (!room) {
                return {incidences: [], prevents: []};
            }

            var roomLower = room.toLowerCase();

            return {
                incidences: state.incidences.filter(function (inc) {
                    return inc.room && inc.room.toLowerCase() === roomLower;
                }),
                prevents: state.prevents.filter(function (inc) {
                    return inc.room && inc.room.toLowerCase() === roomLower;
                })
            };
        };

        this.getTypeStyle = parseTypeStyle;

        this.createCardCtrl = function ($state, urlGestor) {
            return {
                getTypeStyle: parseTypeStyle,
                getGestorUrl: function (item, isPrevent) {
                    if (isPrevent) {
                        return urlGestor + '/prevent/' + item.idPrevent;
                    }

                    return urlGestor + '/id/' + item.idIncidence;
                },
                goToRoom: function (room) {
                    incidencesStateService.goToRoom(room, $state);
                }
            };
        };

        this.buildRoomMap = function () {
            return quantionApi.getStbs(true).then(function (dataResponse) {
                mapaPorRoom = {};
                roomMapLoaded = true;

                angular.forEach(dataResponse.data, function (stb) {
                    if (stb.room) {
                        mapaPorRoom[stb.room.toLowerCase()] = stb.idStb;
                    }
                });
            }, function () {
                roomMapLoaded = false;
            });
        };

        this.goToRoom = function (room, $state) {
            if (!room) {
                return;
            }

            var navigate = function () {
                var idStb = mapaPorRoom[room.toLowerCase()];

                if (idStb) {
                    $state.go('app.Quantion_habitaciones_ver_mas', {ip: idStb});
                } else {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent($translate.instant('QUICKPANEL.INCIDENCIAS.ROOM_NOT_FOUND'))
                            .position('top right')
                            .hideDelay(4000)
                    );
                }
            };

            if (roomMapLoaded) {
                navigate();
            } else {
                this.buildRoomMap().then(navigate, navigate);
            }
        };

        this.refresh = function () {
            var hasToken = incidencesApi.isAuthenticated();

            if (!hasToken) {
                state.incidences = [];
                state.prevents = [];
                state.countIncidences = 0;
                state.countPrevents = 0;
                state.errorIncidences = 'auth';
                state.errorPrevents = 'auth';
                state.lastRefresh = new Date();
                $rootScope.$broadcast('incidencesReceived', {incidences: [], list: []});
                $rootScope.$broadcast('preventsReceived', {incidences: [], list: []});
                return $q.resolve();
            }

            state.loadingIncidences = true;
            state.loadingPrevents = true;
            state.errorIncidences = null;
            state.errorPrevents = null;

            var incidencesPromise = incidencesApi.getIncidenciasPorInstalacion(true, false).then(function (dataResponse) {
                state.incidences = $filter('orderBy')(dataResponse.data, '-idIncidence');
                state.countIncidences = state.incidences.length;
                state.errorIncidences = null;

                $rootScope.$broadcast('incidencesReceived', {
                    incidences: state.incidences.map(function (e) {
                        return e.room && e.room.toLowerCase();
                    }),
                    list: state.incidences
                });
            }, function (err) {
                state.incidences = [];
                state.countIncidences = 0;
                state.errorIncidences = classifyError(err, hasToken);
                $rootScope.$broadcast('incidencesReceived', {incidences: [], list: []});
            }).finally(function () {
                state.loadingIncidences = false;
            });

            var preventsPromise = incidencesApi.getIncidenciasPreventivasPorInstalacion(true, false).then(function (dataResponse) {
                state.prevents = $filter('orderBy')(dataResponse.data, '-idPrevent');
                state.countPrevents = state.prevents.length;
                state.errorPrevents = null;

                $rootScope.$broadcast('preventsReceived', {
                    incidences: state.prevents.map(function (e) {
                        return e.room && e.room.toLowerCase();
                    }),
                    list: state.prevents
                });
            }, function (err) {
                state.prevents = [];
                state.countPrevents = 0;
                state.errorPrevents = classifyError(err, hasToken);
                $rootScope.$broadcast('preventsReceived', {incidences: [], list: []});
            }).finally(function () {
                state.loadingPrevents = false;
            });

            return $q.all([incidencesPromise, preventsPromise]).then(function () {
                state.lastRefresh = new Date();
            });
        };

        this.startPolling = function () {
            this.stopPolling();

            if (!incidencesApi.isAuthenticated()) {
                return;
            }

            this.refresh();
            this.buildRoomMap();
            pollPromise = $interval(function () {
                incidencesStateService.refresh();
            }, POLL_MS);
        };

        var incidencesStateService = this;

        this.stopPolling = function () {
            if (pollPromise) {
                $interval.cancel(pollPromise);
                pollPromise = null;
            }
        };
    }

    function translateApiService($http) {

        this.translate = function (sourceLang, targetLang, sourceText) {
            return $http({
                method: 'GET',
                url: "https://translate.googleapis.com/translate_a/single",
                params: {
                    client: 'gtx',
                    sl: sourceLang || 'auto',
                    tl: targetLang || 'en',
                    dt: 't',
                    q: sourceText || ''
                }
            });
        };
    }

    function messagesApiService($http, IncidencesConfig) {
        var url = 'https://api.messages.solertia-hospitality.com';

        this.sendMessage = function (options) {
            return $http({
                method: 'POST',
                url: url + '/message',
                data: JSON.stringify({
                    title: options && options.title,
                    message: options && options.message,
                    origin: 'solertia-admin',
                    domain: IncidencesConfig.instalacion
                })
            });
        };
    }

    function dirayaApiService($http, JSONconfig) {
        var url = 'https://api.instalaciones.solertia-hospitality.com';

        this.DOMAIN = JSONconfig.installation;

        this.getDirayaRoom = function (room) {
            return $http({
                method: 'GET',
                url: url + '/diraya/room',
                params: {
                    room: room,
                    installation: this.DOMAIN
                }
            });
        };

        this.getDirayaAll = function (room) {
            return $http({
                method: 'GET',
                url: url + '/diraya/all'
            });
        };

        this.postDirayaRoom = function (body) {
            return $http({
                method: 'POST',
                url: url + '/diraya',
                headers: {'Content-Type': 'application/json'},
                data: body
            });
        };

        this.putDirayaRoom = function (body) {
            return $http({
                method: 'PUT',
                url: url + '/diraya',
                headers: {'Content-Type': 'application/json'},
                data: body
            });
        };

        this.putDirayaRoomArray = function (body) {
            return $http({
                method: 'PUT',
                url: url + '/diraya/array',
                headers: {'Content-Type': 'application/json'},
                data: [body]
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('app.Quantion.gestionCompras.recaudacion_simple', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.Quantion_gestionCompras_recaudacion_simple', {
            url: '/recaudacion-simple',
            views: {
                'content@app': {
                    templateUrl: 'app/main/Quantion/gestionCompras/recaudacion_simple/recaudacion_simple.html',
                    controller: 'recaudacionSimpleController as vm'
                }
            },
            data: {
                authorization: true
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/Quantion/gestionCompras/recaudacion_simple');
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.Quantion', [
                'app.Quantion.principal',
                'app.Quantion.auth.login',
                'app.Quantion.auth.error-500',
                'app.Quantion.auth.error-404',
                'app.Quantion.auth.error-401',
                'app.Quantion.habitaciones.listado',
                'app.Quantion.habitaciones.aps',
                'app.Quantion.habitaciones.modelos',
                'app.Quantion.habitaciones.wallets',
                'app.Quantion.habitaciones.ver_mas',
                'app.Quantion.habitaciones.voip',
                'app.Quantion.habitaciones.mantenimiento',
                'app.Quantion.habitaciones.unprovisioned',
                'app.Quantion.iptv.listaIptv',
                'app.Quantion.iptv.importexport',
                'app.Quantion.avisos.enviar',
                'app.Quantion.avisos.publi',
                'app.Quantion.avisos.listado',
                'app.Quantion.archivos.banners',
                'app.Quantion.archivos.fileExplorer',
                'app.Quantion.archivos.documentExplorer',
                'app.Quantion.archivos.servicios',
                'app.Quantion.wifiAdm',
                'app.Quantion.precios',
                'app.Quantion.gestionCompras.operaciones',
                'app.Quantion.gestionCompras.contabilidad',
                'app.Quantion.gestionCompras.recaudacion',
                'app.Quantion.estadisticas',
                'app.Quantion.estadisticas.tv',
                'app.Quantion.estadisticas.urls',
                'app.Quantion.estadisticas.banners',
                'app.Quantion.estadisticas.instantanea',
                'app.Quantion.usuarios',
                'app.Quantion.tasks.servidor',
                'app.Quantion.tasks.equipos',
                'app.Quantion.tasks.procesos',
                'app.Quantion.root.gservicios.paquetes',
                'app.Quantion.root.gservicios.servicios',
                'app.Quantion.lotes',
                'app.Quantion.root.cversiones',
                'app.Quantion.root.gruposStb',
                'app.Quantion.root.idiomas',
                'app.Quantion.root.dhcpEquipos',
                'app.Quantion.root.gCajeros',
                'app.Quantion.root.instalaciones',
                'app.Quantion.root.temas',
                'app.Quantion.root.encuestas',
                'app.Quantion.root.tarjetas',
                'app.Quantion.root.properties',
                'app.Quantion.root.traduccion',
                'app.Quantion.root.controls',
                'app.Quantion.administradorCajeros',
                'app.Quantion.gestionCompras.recaudacion_completa',
                'app.Quantion.gestionCompras.recaudacion_simple',
                'app.Quantion.gestionCompras.recaudacion_v',
                'app.Quantion.gestionCompras.contabilidad_sin_precios',
                'app.Quantion.gestionCompras.estadoComercial',
                //Añadir los nuevos campos
            ]);
})();

angular.module("project").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/incidence-card.tmpl.html","<md-card class=\"incidence-card\"><md-card-title><md-card-title-text><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"incidence-card-header\"><span class=\"incidence-type-chip\" \nng-style=\"cardCtrl.getTypeStyle(item.type)\" ng-if=\"item.type\">{{item.type.type}} </span><a \nclass=\"incidence-room-link md-accent-fg\" ng-if=\"item.room\" ng-click=\"cardCtrl.goToRoom(item.room)\">\n{{\'QUICKPANEL.INCIDENCIAS.ROOM\' | translate}} {{item.room}}</a></div><span class=\"descripcion\">{{item.description}}\n</span><div class=\"incidence-meta md-subhead\"><span class=\"md-warn-fg\"><b>{{item.autor}}</b>\n - {{(item.modificado || item.fecha) | date:\'dd/MM/yyyy HH:mm\'}} </span><span class=\"md-accent-fg\" \nng-if=\"item.installation\"><b>{{item.installation.installation}}</b></span></div><a \nng-href=\"{{cardCtrl.getGestorUrl(item, isPrevent)}}\" target=\"_blank\" class=\"incidence-gestor-link\">\n{{\'QUICKPANEL.INCIDENCIAS.OPEN_IN_GESTOR\' | translate}}</a></md-card-title-text></md-card-title></md-card>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\" md-selected=\"vm.selectedTab\"><md-tab \nlabel=\"{{\'QUICKPANEL.INCIDENCIAS.TAB\' | translate}}\"><md-list class=\"incidencias\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"incidencias-header\"><md-subheader class=\"md-no-sticky\">\n{{\'QUICKPANEL.INCIDENCIAS.TITLE\' | translate}} ({{vm.state.countIncidences}})</md-subheader><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.refresh()\" \naria-label=\"{{\'QUICKPANEL.INCIDENCIAS.REFRESH\' | translate}}\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n</md-button><a href=\"{{vm.urlGestor}}\" target=\"_blank\" class=\"padding-16\">\n{{\'QUICKPANEL.INCIDENCIAS.GO_TO_GESTOR\' | translate}}</a></div></div><md-progress-circular class=\"md-accent md-hue-1\" \nmd-diameter=\"96\" style=\"margin: auto\" ng-show=\"vm.state.loadingIncidences\"></md-progress-circular><div \nclass=\"incidencias-status\" ng-if=\"!vm.state.loadingIncidences && vm.state.errorIncidences === \'auth\'\"><h3 \nclass=\"incidencias-error\">{{\'QUICKPANEL.INCIDENCIAS.ERROR_AUTH\' | translate}}</h3></div><div \nclass=\"incidencias-status\" \nng-if=\"!vm.state.loadingIncidences && vm.state.errorIncidences && vm.state.errorIncidences !== \'auth\'\"><h3 \nclass=\"incidencias-error\">{{\'QUICKPANEL.INCIDENCIAS.ERROR\' | translate}}</h3><md-button class=\"md-raised md-accent\" \nng-click=\"vm.refresh()\">{{\'QUICKPANEL.INCIDENCIAS.RETRY\' | translate}}</md-button></div><div \nclass=\"incidencias-status\" \nng-if=\"!vm.state.loadingIncidences && !vm.state.errorIncidences && vm.state.incidences.length === 0\"><h3>\n{{\'QUICKPANEL.INCIDENCIAS.EMPTY\' | translate}}</h3></div><div \nng-if=\"!vm.state.loadingIncidences && !vm.state.errorIncidences && vm.state.incidences.length > 0\"><div \nng-repeat=\"inc in vm.state.incidences\" ng-include=\"\'app/quick-panel/incidence-card.tmpl.html\'\" \nng-init=\"item = inc; isPrevent = false; cardCtrl = vm.cardCtrl\"></div></div></md-list></md-tab><md-tab \nlabel=\"{{\'QUICKPANEL.PREVENTS.TAB\' | translate}}\"><md-list class=\"incidencias\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"incidencias-header\"><md-subheader class=\"md-no-sticky\">\n{{\'QUICKPANEL.PREVENTS.TITLE\' | translate}} ({{vm.state.countPrevents}})</md-subheader><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.refresh()\" \naria-label=\"{{\'QUICKPANEL.INCIDENCIAS.REFRESH\' | translate}}\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n</md-button><a href=\"{{vm.urlGestor}}/preventivas\" target=\"_blank\" class=\"padding-16\">\n{{\'QUICKPANEL.INCIDENCIAS.GO_TO_GESTOR\' | translate}}</a></div></div><md-progress-circular class=\"md-accent md-hue-1\" \nmd-diameter=\"96\" style=\"margin: auto\" ng-show=\"vm.state.loadingPrevents\"></md-progress-circular><div \nclass=\"incidencias-status\" ng-if=\"!vm.state.loadingPrevents && vm.state.errorPrevents === \'auth\'\"><h3 \nclass=\"incidencias-error\">{{\'QUICKPANEL.INCIDENCIAS.ERROR_AUTH\' | translate}}</h3></div><div \nclass=\"incidencias-status\" \nng-if=\"!vm.state.loadingPrevents && vm.state.errorPrevents && vm.state.errorPrevents !== \'auth\'\"><h3 \nclass=\"incidencias-error\">{{\'QUICKPANEL.INCIDENCIAS.ERROR\' | translate}}</h3><md-button class=\"md-raised md-accent\" \nng-click=\"vm.refresh()\">{{\'QUICKPANEL.INCIDENCIAS.RETRY\' | translate}}</md-button></div><div \nclass=\"incidencias-status\" \nng-if=\"!vm.state.loadingPrevents && !vm.state.errorPrevents && vm.state.prevents.length === 0\"><h3>\n{{\'QUICKPANEL.PREVENTS.EMPTY\' | translate}}</h3></div><div \nng-if=\"!vm.state.loadingPrevents && !vm.state.errorPrevents && vm.state.prevents.length > 0\"><div \nng-repeat=\"inc in vm.state.prevents\" ng-include=\"\'app/quick-panel/incidence-card.tmpl.html\'\" \nng-init=\"item = inc; isPrevent = true; cardCtrl = vm.cardCtrl\"></div></div></md-list></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\" \nstyle=\"background: url({{backgroundUrl}}) no-repeat; background-size: cover\"><md-toolbar id=\"toolbar\" \nclass=\"md-whiteframe-1dp md-primary-bg\" ui-view=\"toolbar\" show-gt-sm></md-toolbar><md-toolbar id=\"second-toolbar\" \nlayout=\"row\"><div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"toggleNavigation()\" \naria-label=\"Toggle Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><navigation-search hide \nshow-gt-sm></navigation-search><div class=\"section-name\" translate=\"TOOLBAR.SECTIONS.{{seccion}}\" flex>{{seccion}}\n</div><div class=\"toolbar-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"toggleMainToolbar()\" \naria-label=\"Toggle Main Toolbar\"><md-icon md-font-icon=\"icon-unfold-more\"></md-icon></md-button></div></md-toolbar>\n<md-content id=\"content\" class=\"animate-slide-left md-background md-hue-1 _background_\" ui-view=\"content\" flex>\n</md-content><div id=\"pantallaCarga\" layout-align=\"center center\" class=\"lsHidden\"><div class=\"content\" \nlayout=\"column\" layout-align=\"center center\"><h1>{{lsText|translate}}</h1><md-progress-circular class=\"md-warn\" \nmd-mode=\"indeterminate\" md-diameter=\"120\"></md-progress-circular></div></div></div><div id=\"expire-license-message\" \nng-if=\"expireLicense && !hiddenLicenseMessage\" class=\"layout-row layout-align-start-center\"><span \ntranslate=\"EXPIRE_LICENSE\" translate-values=\"{date: expireLicense}\" flex></span><md-button class=\"md-icon-button\" \naria-label=\"\" ng-click=\"hideLicenseMessage()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/Quantion/administradorCajeros/administradorCajeros.html","<div id=\"administradorCajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><h2>Selecciona un cajero</h2><div layout=\"column\"><div layout=\"row\" \nng-repeat=\"caj in cajeros\"><md-button class=\"md-raised md-primary flex\" style=\"white-space: initial\" \nui-sref=\"app.Quantion_administradorCajeros_{{caj.config.mode}}({installation:\'{{caj.idAtm}}\'})\"><span>\n{{caj.config.title}}</span></md-button><md-button class=\"md-raised md-warn copy-button\" ng-click=\"logs(caj)\" \nng-disabled=\"caj.type == \'sumup\'\"><md-icon md-font-icon=\"icon-file-document\"></md-icon><md-tooltip>Ver logs\n</md-tooltip></md-button><md-button class=\"md-raised md-warn copy-button\" ng-click=\"copyIp(caj)\" \nng-disabled=\"caj.type == \'sumup\'\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip>\nCopiar IP al portapapeles</md-tooltip></md-button><md-button class=\"md-raised md-warn copy-button\" \nng-click=\"copyPass(caj)\" ng-disabled=\"caj.type == \'sumup\'\"><md-icon md-font-icon=\"icon-multiplication-box\"></md-icon>\n<md-tooltip>Copiar contraseña al portapapeles</md-tooltip></md-button><input type=\"text\" id=\"caj-ip-{{caj.idAtm}}\" \nng-model=\"caj.config.ipVnc\" class=\"input-copy\"> <input type=\"text\" id=\"caj-pass-{{caj.idAtm}}\" \nng-model=\"caj.config.passVnc\" class=\"input-copy\"></div></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/lotes/lotes.html","<div id=\"lotes\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"LOTES.ACCION\">Acción</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"vm.action\" \nlayout=\"column\" required ng-change=\"vm.secondaryAction = null\"><h4 translate=\"LOTES.ELIGEACCION\">Elige una acción</h4>\n<md-radio-button value=\"instalacion\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.ASIGNARINSTALACION\'\"><span translate=\"LOTES.ASIGNARINSTALACION\">Asignar instalación\n</span></md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'instalacion\'\"><md-radio-button ng-repeat=\"inst in vm.listaInstalaciones\" \nng-value=\"{installation: inst.idInstallation}\" ng-click=\"vm.secondaryActionTitle = inst.name\">{{inst.name}}\n</md-radio-button></md-radio-group><md-radio-button value=\"modelo\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.ASIGNARMODELO\'\"><span translate=\"LOTES.ASIGNARMODELO\">Asignar modelo</span>\n</md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'modelo\'\"><md-radio-button ng-repeat=\"mod in vm.listaModelos\" ng-value=\"{model: mod.idStbModel}\" \nng-click=\"vm.secondaryActionTitle = mod.name\">{{mod.name}}</md-radio-button></md-radio-group><md-radio-button \nvalue=\"skin\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.ASIGNARSKIN\'\"><span \ntranslate=\"LOTES.ASIGNARSKIN\">Asignar skin</span></md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" \nlayout=\"column\" required ng-if=\"vm.action === \'skin\'\"><md-radio-button ng-repeat=\"theme in vm.listaThemes\" \nng-value=\"{properties:{themeOverride: theme}}\" ng-click=\"vm.secondaryActionTitle = theme\">{{theme}}</md-radio-button>\n</md-radio-group><md-radio-button value=\"updateDynamic\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.FORZARACTDIN\'\"><span translate=\"LOTES.FORZARACTDIN\">\nForzar actualización de imagen dinámica</span></md-radio-button><md-radio-button value=\"updateSystem\" \nng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.FORZARACTSIS\'\"><span \ntranslate=\"LOTES.FORZARACTSIS\">Forzar actualización de sistema</span></md-radio-button><md-radio-group \nng-model=\"vm.secondaryAction\" layout=\"column\" required ng-if=\"vm.action === \'updateSystem\'\"><md-radio-button \nng-value=\"{updated:{forceSystem:true}}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR\'\"><span \ntranslate=\"LOTES.ACTIVAR\">Activar</span></md-radio-button><md-radio-button \nng-value=\"{updated:{forceSystem:true}, systemVersion:null}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR3\'\"><span\n translate=\"LOTES.ACTIVAR3\">Activar y asignar versión por defecto del modelo</span></md-radio-button><md-radio-button \nng-value=\"{updated:{forceSystem:false}}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.DESACTIVAR\'\"><span \ntranslate=\"LOTES.DESACTIVAR\">Desactivar</span></md-radio-button></md-radio-group><md-radio-button value=\"lastSystem\" \nng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.ASIGNARULTSIS\'\"><span \ntranslate=\"LOTES.ASIGNARULTSIS\">Asignar última versión sistema</span></md-radio-button><md-radio-button \nvalue=\"cleanSystem\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.CLEANSYSTEM\'\"><span translate=\"LOTES.CLEANSYSTEM\">Reinstalar versión de sistema\n</span></md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'cleanSystem\'\"><md-radio-button ng-value=\"{updated:{forceSystem:true, cleanSystem: true}}\" \nng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR\'\"><span translate=\"LOTES.ACTIVAR\">Activar</span></md-radio-button>\n<md-radio-button ng-value=\"{updated:{forceSystem:false, cleanSystem: false}}\" \nng-click=\"vm.secondaryActionTitle = \'LOTES.DESACTIVAR\'\"><span translate=\"LOTES.DESACTIVAR\">Desactivar</span>\n</md-radio-button></md-radio-group><md-radio-button value=\"rebootLote\" ng-click=\"vm.actionTitle = \'LOTES.REINICIAR\'\">\n<span translate=\"LOTES.REINICIAR\">Reiniciar dispositivo</span></md-radio-button><md-radio-button \nvalue=\"serviceRebootLote\" ng-click=\"vm.actionTitle = \'LOTES.RECARGAR\'\"><span translate=\"LOTES.RECARGAR\">\nRecargar interfaz</span></md-radio-button><md-radio-button value=\"dynamic\" \nng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.DYNAMIC\'\"><span \ntranslate=\"LOTES.DYNAMIC\">Actualizar dynamic</span></md-radio-button><md-radio-button value=\"volume\" \nng-click=\"vm.actionTitle = \'LOTES.VOLUME\'\"><span translate=\"LOTES.VOLUME\">Cambiar volumen máximo</span>\n</md-radio-button><md-slider-container flex ng-if=\"vm.action === \'volume\'\"><md-slider flex md-discrete min=\"0\" \nmax=\"130\" ng-model=\"volume\" \nng-change=\"vm.secondaryAction={properties:{volume:volume}}; vm.secondaryActionTitle = volume\" aria-label=\"volumen\">\n</md-slider></md-slider-container><md-radio-button value=\"txPower\" ng-click=\"vm.actionTitle = \'LOTES.TXPOWER\'\"><span \ntranslate=\"LOTES.TXPOWER\">Cambiar alcance WiFi (txPower)</span></md-radio-button><md-slider-container flex \nng-if=\"vm.action === \'txPower\'\"><md-slider flex md-discrete min=\"0\" max=\"100\" ng-model=\"txPower\" \nng-change=\"vm.secondaryAction={properties:{txPower:txPower}}; vm.secondaryActionTitle = txPower\" aria-label=\"txPower\">\n</md-slider></md-slider-container><md-radio-button value=\"delete\" ng-click=\"vm.actionTitle = \'LOTES.ELIMINAR\'\"><span \ntranslate=\"LOTES.ELIMINAR\">Eliminar habitación</span></md-radio-button><md-radio-button value=\"checkout\" \nng-click=\"vm.actionTitle = \'LOTES.CHECKOUT\'\"><span translate=\"LOTES.CHECKOUT\">Hacer check-out</span></md-radio-button>\n<md-radio-button value=\"checkin\" ng-click=\"vm.actionTitle = \'LOTES.CHECKIN\'\"><span translate=\"LOTES.CHECKIN\">\nHacer check-in</span></md-radio-button><md-radio-button value=\"igualarextension\" \nng-click=\"vm.actionTitle = \'LOTES.IGUALAREXTENSION\'\"><span translate=\"LOTES.IGUALAREXTENSION\">\nPoner como extensión el número de habitación</span></md-radio-button><md-radio-button value=\"dashboard\" \nng-click=\"vm.actionTitle = \'LOTES.DASHBOARD\'\"><span translate=\"LOTES.DASHBOARD\">Activar/desactivar dashboard</span>\n</md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'dashboard\'\"><md-radio-button ng-value=\"{properties:{sidebar:true}}\" \nng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR\'\"><span translate=\"LOTES.ACTIVAR\">Activar</span></md-radio-button>\n<md-radio-button ng-value=\"{properties:{sidebar: false}}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.DESACTIVAR\'\"><span\n translate=\"LOTES.DESACTIVAR\">Desactivar</span></md-radio-button></md-radio-group><md-radio-button value=\"autorun\" \nng-click=\"vm.actionTitle = \'LOTES.AUTORUN\'\"><span translate=\"LOTES.AUTORUN\">Pantalla de arranque (autorun)</span>\n</md-radio-button><div layout=\"row\" ng-if=\"vm.action === \'autorun\'\" layout-align=\"space-between center\">\n<md-autocomplete flex=\"60\" ng-disabled=\"vm.aclIsNull\" md-selected-item=\"vm.selectedAcl\" placeholder=\"Buscar ACL\" \nmd-require-match md-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" md-min-length=\"0\" \nmd-input-minlength=\"0\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item}}</span>\n</md-item-template><md-not-found>-</md-not-found></md-autocomplete><md-checkbox ng-model=\"vm.aclIsNull\" \naria-label=\"ACL is null\">NULL (Menú home)</md-checkbox></div></md-radio-group></form></md-tab-body></md-tab><md-tab \nng-disabled=\"paso1.$invalid\" md-on-select=\"updateHtml()\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"LOTES.STBS\">STBs</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><h2 \nstyle=\"text-align: center; background-color: lightgray\">\n{{vm.actionTitle|translate}} &rightarrow; {{vm.secondaryActionTitle|translate}}</h2><md-button \nclass=\"md-raised md-primary\" ng-click=\"marcarTodo(true)\" translate=\"LOTES.MARCARTODO\">Marcar todo</md-button><md-button\n class=\"md-raised md-primary\" ng-click=\"marcarTodo(false)\" translate=\"LOTES.DESMARCARTODO\">Desmarcar todo</md-button>\n<md-button class=\"md-raised md-primary\" ng-click=\"marcarStorage()\" translate=\"LOTES.MARCARSTORAGE\">Marcar almacenados\n<md-tooltip md-direction=\"right\"><span translate=\"LOTES.MARCARSTORAGETOOLTIP\"></span></md-tooltip></md-button><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-wrap id=\"groupListContainer\"><div class=\"groupContainer\" \nng-repeat=\"grupo in listaGrupos\" layout=\"column\" on-last-repeat><div class=\"groupHeader\" layout=\"row\" \nlayout-align=\"center-center\"><div flex>{{grupo.nombre}} <span ng-if=\"grupo.place\">({{grupo.place}})</span></div>\n<md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo.idStbGroup, true)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo.idStbGroup, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div class=\"groupBody\" \nlayout=\"column\"><md-checkbox ng-repeat=\"stb in grupo.cStbs|orderBy:\'room\'\" ng-model=\"stb.seleccionado\" \naria-label=\"seleccionado\">{{stb.room}} - {{stb.username}}<ng-include src=\"vm.action\"></ng-include></md-checkbox></div>\n</div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">Anterior</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Siguiente</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"enviar(msWizard)\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete() || vm.yaEnviado\">\nEnviar</md-button><img ng-if=\"cargando\" src=\"/assets/quantionImagenes/cargando.gif\"></div></ms-form-wizard>\n</md-content></div></div><script type=\"text/ng-template\" id=\"instalacion\">\n<span class=\"d\">({{stb.installation.name}})</span></script><script type=\"text/ng-template\" id=\"modelo\">\n<span class=\"d\">({{stb.model.name}})</span></script><script type=\"text/ng-template\" id=\"skin\">\n<span class=\"d\">({{stb.properties.themeOverride}})</span></script><script type=\"text/ng-template\" id=\"updateDynamic\">\n<span class=\"d\" translate=\"LOTES.ACTUALDIN_{{stb.updated.forceDynamic?\'SI\':\'NO\'}}\">(Act. auto. img. din.:)</span>\n    <md-tooltip md-direction=\"right\"><span translate=\"LOTES.ACTUALIMGDIN\">Ult. ver. img. din.:</span> <em translate=\"{{stb.viewed.lastDynamic||\'LOTES.NINGUNA\'}}\"></em></md-tooltip>\n</script><script type=\"text/ng-template\" id=\"updateSystem\">\n<span class=\"d\" translate=\"LOTES.ACTUALSIS_{{stb.updated.forceSystem?\'SI\':\'NO\'}}\">(Act. auto. sistema:)</span>\n    <md-tooltip md-direction=\"right\"><span translate=\"LOTES.ACTUALIMGSIS\">Ult. ver. sistema:</span> <em translate=\"{{stb.viewed.lastSystem||\'LOTES.NINGUNA\'}}\"></em></md-tooltip>\n</script><script type=\"text/ng-template\" id=\"updateBios\">\n<span class=\"d\" translate=\"LOTES.ACTUALBIOS_{{stb.updated.forceBios?\'SI\':\'NO\'}}\">(Act. auto. BIOS:)</span>\n    <md-tooltip md-direction=\"right\"><span translate=\"LOTES.ACTUALIMGBIOS\">Ult. Bios:</span> <em translate=\"{{stb.viewed.lastBios||\'LOTES.NINGUNA\'}}\"></em></md-tooltip>\n</script><script type=\"text/ng-template\" id=\"lastSystem\">\n<span class=\"d\">(<em translate=\"{{stb.systemVersion.name||\'LOTES.NINGUNA\'}}\"></em>)</span></script><script \ntype=\"text/ng-template\" id=\"cleanSystem\"></script><script type=\"text/ng-template\" id=\"rebootLote\"></script><script \ntype=\"text/ng-template\" id=\"serviceRebootLote\"></script><script type=\"text/ng-template\" id=\"dynamic\"></script><script \ntype=\"text/ng-template\" id=\"volume\"><span class=\"d\">({{stb.properties.volume}})</span></script><script \ntype=\"text/ng-template\" id=\"txPower\"><span class=\"d\">({{stb.properties.txPower}})</span></script><script \ntype=\"text/ng-template\" id=\"delete\"></script><script type=\"text/ng-template\" id=\"checkout\">\n<span class=\"d\">({{stb.check.type}})</span></script><script type=\"text/ng-template\" id=\"checkin\">\n<span class=\"d\">({{stb.check.type}})</span></script><script type=\"text/ng-template\" id=\"igualarextension\">\n<span class=\"d\">(Nº {{stb.extension.number}})</span></script><script type=\"text/ng-template\" id=\"dashboard\">\n<span class=\"d\" translate=\"LOTES.DASHBOARD_{{stb.properties.sidebar?\'SI\':\'NO\'}}\"></span></script><script \ntype=\"text/ng-template\" id=\"autorun\"><span class=\"d\">({{stb.autorun}})</span></script>");
$templateCache.put("app/main/Quantion/estadisticas/estadisticas.html","<div id=\"estadisticas\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><form name=\"busquedaForm\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between start\" flex><md-radio-group ng-model=\"selectedOption\" required><md-radio-button \nvalue=\"Todos\"><span translate=\"ESTADISTICAS.TODOS\">Todos</span></md-radio-button><md-radio-button value=\"Varios\"><span \ntranslate=\"ESTADISTICAS.VARIOSSTB\">Varios equipos</span></md-radio-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.asignarStbs($event)\" ng-if=\"selectedOption === \'Varios\'\">Seleccionar equipos ({{vm.selectedStbs.length}})\n</md-button><md-radio-button value=\"Individual\"><span translate=\"ESTADISTICAS.UNSTB\">Un STB</span></md-radio-button>\n</md-radio-group><div><div layout=\"column\" layout-gt-sm=\"row\" class=\"margin-bottom-15\"><div layout=\"column\"><span \ntranslate=\"ESTADISTICAS.REPORTEINICIO\">Reporte inicio</span> <input type=\"date\" name=\"ini\" ng-model=\"inicioBusqueda\" \nrequired></div><div layout=\"column\"><span translate=\"ESTADISTICAS.REPORTEFIN\">Reporte fin</span> <input type=\"date\" \nname=\"fin\" ng-model=\"finBusqueda\" required></div></div><md-autocomplete md-selected-item=\"selectedStb\" flex \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)|orderBy:\'room\'\" \nmd-item-text=\"item.room + \' - \' + item.username + \' (\' + item.mac + \')\'\" md-min-length=\"0\" md-select-on-match=\"true\" \nplaceholder=\"{{\'ESTADISTICAS.BUSCARSTB\'|translate}}\" ng-show=\"selectedOption === \'Individual\'\" name=\"stb\" required>\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.room}} - {{item.username}} ({{item.mac}})</span></md-item-template></md-autocomplete></div><md-button \nclass=\"md-fab md-mini\" ng-click=\"CargarEstadisticas(inicioBusqueda, finBusqueda)\" \nng-disabled=\"busquedaForm.$invalid || (selectedOption === \'Individual\' && !selectedStb) || (selectedOption === \'Varios\' && vm.selectedStbs.length <= 0)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"ESTADISTICAS.BUSCAR\">\nBuscar</span></md-tooltip></md-button></form><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nng-show=\"vm.completeStatsObj\"><md-tab label=\"{{\'ESTADISTICAS.GRAFICO\'|translate}}\"><div layout-gt-sm=\"row\" \nlayout=\"column\"><ms-widget flippable=\"false\" layout=\"column\" flex><div \nclass=\"ph-16 pv-20 mb-10 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h3\">Total</span><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{vm.completeStatsObj[\'TV\'].time|convertSecondsWithoutDays}}</div>\n</div></div></div><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"ESTADISTICAS.CANALESMASVISTOS\">Canales más vistos</div>\n</div><md-content><div class=\"ph-16 pv-20 border-bottom\" \nng-repeat=\"elm in vm.completeStatsObj[\'TV\'].inArray| orderBy:\'-time\'\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\" flex><span class=\"h4 pb-10\">{{elm.channel}}</span><md-progress-linear class=\"md-accent\" \nmd-mode=\"determinate\" value=\"{{100 * elm.time / vm.completeStatsObj[\'TV\'].time}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{100 * elm.time / vm.completeStatsObj[\'TV\'].time|number:1}}%\n<md-tooltip md-direction=\"bottom\">{{elm.time|convertSecondsWithoutDays}}</md-tooltip></div></div></md-content>\n</ms-widget-front><md-button class=\"md-raised md-primary\" ng-click=\"downloadCsv(\'TV\')\" style=\"margin: 8px auto\">\nExportar CSV</md-button></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex><div \nclass=\"ph-16 pv-20 mb-10 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h3\">Total</span><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{vm.completeStatsObj[\'HOME\'].time|convertSecondsWithoutDays}}</div>\n</div></div></div><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"ESTADISTICAS.WEBSMASVISITADAS\">Webs más visitadas</div>\n</div><md-content><div class=\"ph-16 pv-20 border-bottom\" \nng-repeat=\"elm in vm.completeStatsObj[\'HOME\'].inArray| orderBy:\'-time\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">{{elm.channel}}</span>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{100 * elm.time / vm.completeStatsObj[\'HOME\'].time}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{100 * elm.time / vm.completeStatsObj[\'HOME\'].time|number:1}}%\n<md-tooltip md-direction=\"bottom\">{{elm.time|convertSecondsWithoutDays}}</md-tooltip></div></div></md-content>\n</ms-widget-front><md-button class=\"md-raised md-primary\" ng-click=\"downloadCsv(\'HOME\')\" style=\"margin: 8px auto\">\nExportar CSV</md-button></ms-widget></div></md-tab><md-tab label=\"{{\'ESTADISTICAS.TIMELINE\'|translate}}\" \nng-disabled=\"!singleStbTimeline\"><md-checkbox ng-model=\"showAllInfo\" class=\"margin-16 right\">Mostrar info completa\n</md-checkbox><div layout=\"row\" layout-align=\"start center\" flex=\"100\" layout-wrap id=\"timeline-container\" \nng-class=\"{\'complete\':showAllInfo}\"></div></md-tab><md-tab label=\"{{\'ESTADISTICAS.DETALLES\'|translate}}\"><fieldset \nng-repeat=\"(screen, details) in vm.completeStatsObj\"><legend>{{screen}} ({{details.time|convertSecondsWithoutDays}})\n</legend><ol><li ng-repeat=\"elm in details.inArray| orderBy:\'-time\'\" class=\"stats_shadow\" ng-click=\"openShadow(elm)\" \nng-dblclick=\"closeShadow(elm)\"><span>{{elm.channel}} ({{elm.time|convertSecondsWithoutDays}})</span><ul \nstyle=\"display: {{elm.view ?\'block\' :\'none\'}};position: relative\"><li ng-repeat=\"sh in elm.shadow| orderBy:\'-value\'\">\n{{sh.key}} ({{sh.value|convertSecondsWithoutDays}})</li><span \nstyle=\"position: absolute;top: -20px;right: 4px;color: darkred;font-size: smaller\" \ntranslate=\"ESTADISTICAS.CERRARDOBLECLICK\">Cerrar con doble-click</span></ul></li></ol></fieldset></md-tab></md-tabs><h3\n class=\"errorStats\" ng-show=\"!vm.completeStatsObj\">{{dataError}}</h3></md-content></div></div>");
$templateCache.put("app/main/Quantion/precios/precios.html","<div id=\"precios\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><h3 translate=\"PRECIOS.PAQUETES\">Paquetes</h3><div layout=\"row\" layout-align=\"start\" layout-wrap><div\n class=\"pkg\" ng-repeat=\"pkg in ::vm.listaPaquetes|orderBy:\'name|formatNameDesc\'\" flex-gt-sm=\"30\" flex=\"100\" \nflex-sm=\"45\"><div class=\"pkgTitle\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{::pkg.logo|replacePath}}\">\n<h3 flex>{{::pkg.name|formatNameDesc}}</h3><md-icon md-font-icon=\"icon-checkbox-marked\" ng-if=\"pkg.active\"></md-icon>\n</div><ul><li ng-repeat=\"dp in ::pkg.durationPrice\"><h4>{{::dp.duration|convertMinutesInHHMMSS}}: {{::dp.price}} €</h4>\n</li></ul></div></div><md-divider></md-divider><h3 translate=\"PRECIOS.SERVICIOS\">Servicios</h3><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"md-accent-bg srv\" ng-repeat=\"srv in ::lServicios|orderBy:\'-count\'\" \nflex-gt-sm=\"30\" flex=\"100\" flex-sm=\"45\"><div class=\"srvTitle\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"{{::srv.service.logo|replacePath}}\"><h3 flex>{{::srv.service.name|formatNameDesc}}</h3><h4><span \ntranslate=\"PRECIOS.ACTIVOEN\">Activo en</span> {{srv.count}}</h4></div></div></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/principal/principal.html","<div id=\"principal\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-align-gt-xs=\"center center\"><div\n class=\"buscador\" layout=\"row\" layout-align=\"start stretch\" flex><md-button class=\"md-fab md-mini\" \nng-click=\"focusBuscador()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-input-container \nclass=\"md-block\" md-no-float flex><input ng-model=\"vm.searchText\" ng-model-options=\"{debounce: 500}\" \nng-change=\"saveSearchText()\" md-select-on-focus id=\"buscador\" placeholder=\"{{\'PRINCIPAL.BUSCADOR.TEXT\'|translate}}\">\n</md-input-container></div><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"toggleSimpleList(1)\" \nng-show=\"!slOpened && userRoleGroups.length <= 0\"><span translate=\"PRINCIPAL.BUSCADOR.VISTARESUMIDA\">Vista resumida\n</span></md-button><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"toggleSimpleList(0)\" \nng-show=\"slOpened && userRoleGroups.length <= 0\"><span translate=\"PRINCIPAL.BUSCADOR.VISTAPLANTAS\">Vista por plantas\n</span></md-button></div><div flex=\"5\" hide-xs hide-sm></div><md-content class=\"md-padding\" md-whiteframe=\"5\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"70\" style=\"margin: auto\" ng-if=\"listLoading\">\n</md-progress-circular><md-tabs md-border-bottom md-dynamic-height md-selected=\"slOpened\" class=\"hide-tab-label\">\n<md-tab label=\"vista por grupos\"><div layout=\"row\" layout-wrap><div ng-repeat=\"(place,groups) in vm.groupsGrouped\" \nlayout=\"column\" class=\"group-box\" flex><span class=\"group-box-title md-accent-bg\">{{place}}</span><md-button \nclass=\"md-raised md-primary\" \nng-class=\"{\'md-warn\': selectedGroup.idStbGroup === grupo.idStbGroup, \'notification-incidences\': grupo.hasIncidences, \'notification-prevents\': grupo.hasPrevents}\" \nng-repeat=\"grupo in groups\" ng-click=\"cambiarGrupo(grupo)\">{{grupo.nombre}}<md-badge class=\"md-green-bg\">\n{{vm.stbsFiltradosPorGrupo[grupo.idStbGroup].numActivos}}<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRINCIPAL.TOOLTIP.ACTIVOS\">Activos</span></md-tooltip></md-badge><md-badge class=\"md-red-bg\" \nng-show=\"vm.stbsFiltradosPorGrupo[grupo.idStbGroup].numInactivos > 0\">\n{{vm.stbsFiltradosPorGrupo[grupo.idStbGroup].numInactivos}}<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRINCIPAL.TOOLTIP.INACTIVOS\">Inactivos</span></md-tooltip></md-badge><md-badge class=\"md-black-bg\" \nng-show=\"vm.stbsFiltradosPorGrupo[grupo.idStbGroup].numDesconocidos\">\n{{vm.stbsFiltradosPorGrupo[grupo.idStbGroup].numDesconocidos}}<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRINCIPAL.TOOLTIP.DESCONOCIDOS\">Desconocidos</span></md-tooltip></md-badge></md-button></div></div>\n<md-content id=\"groupListContainer\"></md-content></md-tab><md-tab label=\"vista resumida\"><md-content \nclass=\"simpleList\" layout=\"row\" layout-wrap id=\"simpleListContainer\"></md-content></md-tab></md-tabs></md-content><div \nlayout=\"row\" flex=\"100\" layout-align=\"center stretch\" layout-wrap><div \nclass=\"wdgt wdgt-Activo green-bg white-fg layout-row layout-align-center-center layout-wrap\" \nng-click=\"toggleFiltroWidgets(\'Activo\')\"><img src=\"/assets/quantionImagenes/click.gif\" \nclass=\"click-gif margin-right-8\"><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETUSUARIOS.TITLE\"></div><h1>\n{{vm.widgetUsuariosConectados.usuariosActivos}} / {{vm.widgetUsuariosConectados.totalUsuarios}}</h1><span \nclass=\"text-boxed-light\">{{vm.widgetUsuariosConectados.porcentaje}}%</span></div><div \nclass=\"wdgt wdgt-Inactivo red-bg white-fg layout-row layout-align-center-center layout-wrap\" \nng-click=\"toggleFiltroWidgets(\'Inactivo\')\"><img src=\"/assets/quantionImagenes/click.gif\" \nclass=\"click-gif margin-right-8\"><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETUSUARIOS2.TITLE\"></div><h1>\n{{vm.widgetUsuariosDesconectados.usuariosActivos}} / {{vm.widgetUsuariosDesconectados.totalUsuarios}}</h1><span \nclass=\"text-boxed-light\">{{vm.widgetUsuariosDesconectados.porcentaje}}%</span></div><div \nclass=\"wdgt wdgt-Boton orange-bg white-fg layout-row layout-align-center-center layout-wrap\" \nng-click=\"toggleFiltroWidgets(\'Boton\')\" ng-if=\"JSONconfig.mostrarEstadoNaranja\"><img \nsrc=\"/assets/quantionImagenes/click.gif\" class=\"click-gif margin-right-8\"><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETUSUARIOS4.TITLE\"></div><h1>\n{{vm.widgetUsuariosDesconectadosBoton.usuariosActivos}} / {{vm.widgetUsuariosDesconectadosBoton.totalUsuarios}}</h1>\n<span class=\"text-boxed-light\">{{vm.widgetUsuariosDesconectadosBoton.porcentaje}}%</span></div><div \nclass=\"wdgt wdgt-Desconocido black-bg white-fg layout-row layout-align-center-center layout-wrap\" \nng-click=\"toggleFiltroWidgets(\'Desconocido\')\"><img src=\"/assets/quantionImagenes/click.gif\" \nclass=\"click-gif margin-right-8\"><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETUSUARIOS3.TITLE\"></div><h1>\n{{vm.widgetUsuariosNegro.usuariosActivos}} / {{vm.widgetUsuariosNegro.totalUsuarios}}</h1><span \nclass=\"text-boxed-light\">{{vm.widgetUsuariosNegro.porcentaje}}%</span></div><div \nclass=\"wdgt purple-bg white-fg layout-row layout-align-center-center layout-wrap\" ng-show=\"JSONconfig.sistemaDePago\">\n<md-icon md-font-icon=\"icon-credit-card\" class=\"margin-right-5 secondary-text\"></md-icon><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETTARJETAS.TITLE\"></div><h1>{{vm.widgetTarjetas.conTarjeta}} / {{vm.widgetTarjetas.total}}\n</h1><span class=\"text-boxed-light\">{{vm.widgetTarjetas.porcentaje}}%</span></div><div \nclass=\"wdgt brown-500-bg white-fg layout-row layout-align-center-center layout-wrap\"><md-icon \nmd-font-icon=\"icon-cart-outline\" class=\"margin-right-5 secondary-text\"></md-icon><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETSERVICIOS.TITLE\"></div><h1>\n{{vm.widgetServicios.conServicios}} / {{vm.widgetServicios.total}}</h1><span class=\"text-boxed-light\">\n{{vm.widgetServicios.porcentaje}}%</span></div><div \nclass=\"wdgt blue-bg white-fg layout-row layout-align-center-center layout-wrap wdgt-clickable\" \nng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB && JSONconfig.soporteIncidencias\" \nng-click=\"openIncidencesPanel(\'incidences\')\"><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETINCIDENCIAS.TITLE\"></div><h1>{{vm.widgetIncidencias.numIncidencias}}</h1></div><div \nclass=\"wdgt pink-bg white-fg layout-row layout-align-center-center layout-wrap wdgt-clickable\" \nng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB && JSONconfig.soporteIncidencias\" \nng-click=\"openIncidencesPanel(\'prevents\')\"><div \nclass=\"h4 font-weight-500 secondary-text margin-right-15 flex-xs-100 flex-sm-100\" \ntranslate=\"PRINCIPAL.WIDGETPREVENTS.TITLE\"></div><h1>{{vm.widgetIncidencias.numPrevents}}</h1></div></div></md-content>\n</div></div>");
$templateCache.put("app/main/Quantion/usuarios/crearusuario.tmpl.html","<md-dialog id=\"usuarios\" aria-label=\"Crear usuario\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{::(DialogTitle|translate)}}</h2></div></md-toolbar><md-dialog-content><form \nname=\"registerForm\" novalidate><md-input-container class=\"md-block\"><label translate=\"USUARIOS.CREAR.NOMBRE\">\nNombre de usuario</label><input name=\"usuario\" ng-model=\"user.name\" required autofocus></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"USUARIOS.CREAR.IMAGEN\">Imagen</label><input name=\"imagen\" \nng-model=\"user.mapRole.img\"></md-input-container><div layout=\"row\" layout-align=\"space-between start\">\n<md-input-container flex=\"45\"><label translate=\"USUARIOS.CREAR.IDIOMA\">Idioma</label><md-select \nng-model=\"user.language\" required class=\"lang-select\"><md-option ng-repeat=\"lang in listaIdiomas\" \nng-value=\"lang.idioma\"><img ng-src=\"{{lang.rutaIcono|replacePath}}\" style=\"max-height: 24px\"></md-option></md-select>\n</md-input-container><md-input-container flex=\"45\"><label translate=\"USUARIOS.CREAR.ROL\">Rol de acceso</label>\n<md-select ng-model=\"user.userRole\" required><md-option ng-repeat=\"rol in listaRoles\" ng-value=\"rol\" \nng-if=\"showRoleRadio(rol)\"><span translate=\"USUARIOS.ROLES.{{::rol}}\"></span></md-option></md-select>\n</md-input-container></div><div class=\"passDiv\"><md-checkbox ng-checked=\"changePass\" ng-click=\"change()\" \nng-if=\"!creating\" aria-label=\"check contraseña\"><span translate=\"USUARIOS.CREAR.CAMBIARPASS\">Cambiar contraseña</span>\n</md-checkbox><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" ng-if=\"changePass\"><md-input-container \nclass=\"md-block no-errors-spacer\" ng-if=\"!creating\" flex><label translate=\"USUARIOS.CREAR.PASSACTUAL\">Contraseña actual\n</label><input type=\"password\" ng-model=\"passObj.oldPass\" required></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex><label translate=\"USUARIOS.CREAR.PASSNUEVA\">Nueva contraseña</label><input \ntype=\"password\" ng-model=\"passObj.newPass\" required></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex><label translate=\"USUARIOS.CREAR.PASSNUEVA2\">Repetir nueva contraseña</label>\n<input type=\"password\" ng-model=\"passObj.newPass2\" ng-required=\"newPass\"></md-input-container></div></div><div \nstyle=\"color: red; text-align: center; margin-top: 20px\">{{mensajeError|translate}}</div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"USUARIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" style=\"margin-right:20px\" translate=\"USUARIOS.GUARDAR\">\nGuardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/usuarios/permisos.tmpl.html","<md-dialog id=\"permisos\" aria-label=\"Permisos usuario\" flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{::(DialogTitle|translate)}}</h2></div></md-toolbar><md-dialog-content><md-tabs \nmd-dynamic-height class=\"md-primary\"><md-tab label=\"{{\'USUARIOS.PERMISOS.RUTAS\'|translate}}\"><md-content \nclass=\"md-padding\"><div layout=\"row\" class=\"routes\" layout-wrap><md-checkbox ng-repeat=\"route in allRoutes\" \nng-checked=\"checkedRoute(route)\" ng-click=\"toggleRoute(route)\">{{route}}</md-checkbox></div></md-content></md-tab>\n<md-tab label=\"{{\'USUARIOS.PERMISOS.MENULATERAL\'|translate}}\"><md-content class=\"md-padding\"><div class=\"routes\">\n<md-checkbox ng-repeat=\"(key,node) in allNodes\" ng-checked=\"checkedNode(key)\" ng-click=\"toggleNode(key)\" \naria-label=\"{{key}}\"><span translate=\"{{node.translate|uppercase}}\">{{node.title}}</span></md-checkbox></div>\n</md-content></md-tab><md-tab label=\"{{\'USUARIOS.PERMISOS.ACCIONESPERMITIDAS\'|translate}}\"><md-content \nclass=\"md-padding\"><div class=\"routes\"><md-checkbox ng-repeat=\"action in allActions\" \nng-checked=\"checkedAction(action)\" ng-click=\"toggleAction(action)\" aria-label=\"{{action}}\"><span \ntranslate=\"USUARIOS.PERMISOS.ACCIONES.{{action}}\">{{action}}</span></md-checkbox></div></md-content></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"USUARIOS.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"guardar()\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" \nstyle=\"margin-right:20px\" translate=\"USUARIOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/usuarios/usuarios.html","<div id=\"usuarios\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><md-list flex layout=\"row\" layout-wrap layout-xs=\"column\"><md-list-item \nng-repeat=\"item in vm.usuarios\" class=\"usuario {{item.userRole}}\"><p class=\"role\" \ntranslate=\"USUARIOS.ROLES.{{item.userRole}}\"></p><img class=\"md-avatar\" ng-src=\"{{item.img}}\" \non-error-image=\"assets/quantionImagenes/user.png\" src=\"assets/quantionImagenes/user.png\"><h3 flex>{{ item.name}}</h3>\n</md-list-item></md-list><div><h4>Historial de accesos</h4><ul><li ng-repeat=\"acc in ::vm.listaLogin\">\n{{::acc.login|date:\'dd/MM/yyyy HH:mm\'}} - <b>{{::acc.name}}</b></li></ul></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/wifiAdm/dispositivos.tmpl.html","<md-dialog-content class=\"md-dialog-content\" md-theme=\"{{$root.theme}}\"><h2 class=\"md-title\" \ntranslate=\"WIFIADM.DISPOSITIVOSCONECTADOS\">Dispositivos conectados</h2><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data track by $index\">{{disp}}</div><span style=\"color: lightslategrey\" ng-show=\"noHay\" \ntranslate=\"WIFIADM.NODISPOSITIVOS\">(No hay dispositivos conectados)</span></div></md-dialog-content>");
$templateCache.put("app/main/Quantion/wifiAdm/listado.html","<div id=\"wifiAdm\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nclass=\"white-bg\"><div layout=\"row\" layout-align=\"start center\"><h4>Selecciona un grupo</h4><md-select \nng-model=\"grupoSeleccionado\"><md-option ng-repeat=\"grupo in listaGrupos\" ng-value=\"{{grupo}}\"><span \nng-if=\"grupo.place\">{{grupo.place}} - </span>{{grupo.nombre}} ({{grupo.stbs.length}})</md-option></md-select><md-button\n class=\"md-fab md-mini\" ng-click=\"getAllDispositivos(grupoSeleccionado)\" aria-label=\"uptime all\" \nng-disabled=\"!grupoSeleccionado\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"APS.BUSCAR\">Consultar datos</span></md-tooltip></md-button><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"90\" ng-if=\"loading\"></md-progress-circular></div><h2 ng-if=\"stbs\"><span \ntranslate=\"WIFIADM.TOTALDISPOSITIVOS\"></span> {{totalDispositivos}}</h2><table ng-if=\"stbs\"><tr><th \nclass=\"column-title\"><span translate=\"WIFIADM.NHAB\">Nº hab.</span></th><th class=\"column-title\" \nng-if=\"::JSONconfig.mostrarNombreHabitacion\"><span translate=\"WIFIADM.CLIENTE\">Cliente</span></th><th \nclass=\"column-title\" ng-if=\"::JSONconfig.sistemaDePago\"><span translate=\"WIFIADM.WIFICONTRATADO\">WiFi contratado</span>\n</th><th class=\"column-title\"><span translate=\"WIFIADM.CLAVEWIFI\">Clave WIFI</span></th><th class=\"column-title\"><span \ntranslate=\"WIFIADM.DISPOSITIVOSCONECTADOS\">Dispositivos conectados</span></th><th></th></tr><tr \nng-repeat=\"hab in stbs| orderBy: \'room|tryParseInt\' track by $index\" on-last-repeat><td>{{ hab.room}}</td><td \nng-if=\"::JSONconfig.mostrarNombreHabitacion\">{{ hab.username}}</td><td ng-if=\"::JSONconfig.sistemaDePago\"><span hidden>\n{{hab.hasWifiService}}</span><md-icon class=\"green-check\" md-font-icon=\"icon-checkbox-marked\" \nng-if=\"hab.hasWifiService\"></md-icon><md-icon class=\"red-cross\" md-font-icon=\"icon-close-circle\" \nng-if=\"!hab.hasWifiService\"></md-icon></td><td>{{hab.properties.wifiPassword}}</td><td><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.verDispositivosConectados(hab)\" ng-disabled=\"hab.dispositivos.length < 1\">\n<span translate=\"WIFIADM.LISTADISPOSITIVOS\">Ver dispositivos</span> ({{hab.dispositivos.length}})</md-button></td><td \nlayout=\"row\"><div><md-button class=\"md-fab md-mini\" ng-click=\"vm.confirmarCambioClave($event, hab)\" \nng-if=\"(!JSONconfig.sistemaDePago || hab.hasWifiService) && hab.properties.wifiPassword.length > 0\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"WIFIADM.CAMBIARCLAVE\">\nCambiar clave</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.confirmarGenerarClave($event, hab)\" \nng-if=\"(!JSONconfig.sistemaDePago || hab.hasWifiService) && hab.properties.wifiPassword.length < 1\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"WIFIADM.GENERARCLAVE\">\nGenerar clave</span></md-tooltip></md-button></div></td></tr></table></md-content></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" \nng-click=\"goHome()\"><img class=\"part1\" ng-src=\"{{logoEstablecimiento}}/parte1.png\" alt=\"\"> <img class=\"part2\" \nng-src=\"{{logoEstablecimiento}}/parte2.png\" alt=\"\"></div></div><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon><div \nclass=\"versionText\" ng-click=\"updateDeletingCache()\">{{version}}</div></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\" flex></ms-navigation><div class=\"widgets md-primary-bg\" hide \nshow-gt-sm><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div \nclass=\"pv-8\" layout=\"column\" layout-align=\"space-around center\"><div class=\"h1 secondary-text\">\n{{vm.nowWidget.now.hour}}</div><div class=\"h3 secondary-text\"><span \ntranslate=\"WEEKDAYS.{{vm.nowWidget.now.now|date:\'EEEE\'}}\">{{vm.nowWidget.now.now|date:\"EEEE\"}}</span>\n, {{vm.nowWidget.now.date}}</div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div class=\"toolbarTitle\" layout=\"row\" \nlayout-align=\"space-between center\" flex ng-click=\"goHome()\"><span class=\"installationName\">{{installationName}}</span>\n</div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><div class=\"user-button\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img class=\"avatar\" ng-src=\"{{user.img}}\" \nsrc=\"/assets/quantionImagenes/user.png\" on-error-image=\"/assets/quantionImagenes/user.png\"></div><span \nclass=\"username\" hide-xs>{{user.name}}</span></div></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"logout()\" aria-label=\"logout\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TOOLBAR.CERRARSESION\">Cerrar sesión</span></md-tooltip></md-button><div class=\"toolbar-separator\" \nng-if=\"JSONconfig.soporteIncidencias\"></div><md-button id=\"incidences-panel-toggle\" \nclass=\"md-icon-button md-accent-bg incidences-toolbar-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" ng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB && JSONconfig.soporteIncidencias\">\n<md-icon md-font-icon=\"icon-tooltip-edit\" class=\"icon\"></md-icon><span class=\"incidences-badge incidences-badge-inc\" \nng-if=\"vm.formatBadgeCount(vm.incidencesState.countIncidences)\">\n{{vm.formatBadgeCount(vm.incidencesState.countIncidences)}} </span><span \nclass=\"incidences-badge incidences-badge-prev\" ng-if=\"vm.formatBadgeCount(vm.incidencesState.countPrevents)\">\n{{vm.formatBadgeCount(vm.incidencesState.countPrevents)}}</span><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TOOLBAR.INCIDENCIAS\">Incidencias</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/Quantion/archivos/fileExplorer/fileExplorer.html","<div id=\"fileExplorer\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-mini\" aria-label=\"Upload\" ng-click=\"upload()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"FILEEXPLORER.SUBIRARCHIVO\">Subir archivo</span></md-tooltip></md-button><input \ntype=\"file\" id=\"uploadFile\" hidden multiple=\"multiple\"><md-button class=\"md-fab md-mini\" aria-label=\"nueva carpeta\" \nng-click=\"newFolder(actualPath)\"><md-icon md-font-icon=\"icon-folder-plus\"></md-icon><md-tooltip md-direction=\"left\">\n<span translate=\"FILEEXPLORER.NUEVACARPETA\">Nueva carpeta</span></md-tooltip></md-button></div><md-list class=\"bar\">\n<md-list-item class=\"md-primary-bg\"><div class=\"md-list-item-inner flex\"><md-icon md-font-icon=\"icon-undo-variant\" \nclass=\"md-primary-bg\" ng-click=\"goBack()\"></md-icon><p>/{{actualPath}}</p><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"md-primary-bg\" ng-if=\"grid\" ng-click=\"toggleGrid()\"></md-icon><md-icon \nmd-font-icon=\"icon-apps\" class=\"md-primary-bg\" ng-if=\"!grid\" ng-click=\"toggleGrid()\"></md-icon></div></md-list-item>\n</md-list><md-list class=\"archivos\" ng-class=\"{\'grid\': grid, \'layout-row\': grid, \'layout-wrap\': grid}\"><md-list-item \nng-repeat=\"file in listaArchivos\"><div class=\"md-list-item-inner flex\" ng-click=\"openFolder(file)\" \nng-class=\"{\'folder\': !file.file, \'layout-column\': grid}\"><img \nng-src=\"{{!file.file ? \'/assets/quantionImagenes/FileExplorer/folder.png\' : getIconFromExtension(file)}}\" \nclass=\"md-avatar\" on-error-image=\"/assets/quantionImagenes/FileExplorer/unknown.png\"><p flex>{{file.name}}</p><p \nng-if=\"file.file && !grid\" hide show-gt-xs>{{file.modified|date:\'dd/MM/yy HH:mm\'}}</p><p ng-if=\"file.file && !grid\" \nhide show-gt-xs>{{file.size|formatBytes}}</p></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"file.file\">\n<md-button ng-click=\"download(file)\"><md-icon md-font-icon=\"icon-download\" md-menu-align-target></md-icon><span \ntranslate=\"FILEEXPLORER.DESCARGAR\">Descargar</span></md-button></md-menu-item><md-menu-item ng-if=\"file.file\">\n<md-button ng-click=\"eliminar(file)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"FILEEXPLORER.ELIMINAR\">Eliminar</span></md-button></md-menu-item><md-menu-item ng-if=\"!file.file\"><md-button\n ng-click=\"eliminarCarpeta(file)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"FILEEXPLORER.ELIMINAR\">Eliminar carpeta</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><a id=\"hiddenLink\" href=\"\" download hidden></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/archivos/fileExplorer/newFolder.tmpl.html","<md-dialog id=\"nueva-carpeta\" aria-label=\"Carpeta\" ng-cloak md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"FILEEXPLORER.NUEVACARPETA\">Nueva carpeta</h2></div></md-toolbar>\n<md-dialog-content><form name=\"form\" novalidate><md-input-container class=\"md-block\"><label \ntranslate=\"FILEEXPLORER.CARPETA.NOMBRE\">Nombre de usuario</label><input name=\"usuario\" ng-model=\"folder\" required \nautofocus></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"guardar(folder)\" \nng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" translate=\"USUARIOS.GUARDAR\">Guardar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/servicios/servicios.html","<div id=\"servicios\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div><md-button class=\"md-raised md-primary\" ng-repeat=\"tipo in tiposServicio\" \nng-class=\"{\'md-warn\':tipo === selectedType}\" ng-click=\"selectType(tipo)\" ng-if=\"vm.listaServicios[tipo].length > 0\">\n<span translate=\"SERVICIOS.TIPOS.{{tipo}}\">{{tipo}}</span> ({{vm.listaServicios[tipo].length}})</md-button></div>\n<md-divider></md-divider><md-list id=\"service-container\"></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/link.tmpl.html","<md-dialog id=\"setLink-banner\" aria-label=\"Banner link\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"BANNERS.ENLACEBANNER\">\nEnlace del banner</h2></div></md-toolbar><md-dialog-content><form name=\"Form\" novalidate layout=\"column\" \nlayout-gt-sm=\"row\"><div layout=\"column\" flex class=\"margin-horizontal-8\"><md-input-container><label \ntranslate=\"BANNERS.LINK\">URL del recurso</label><input name=\"url\" ng-model=\"banner.link\" required><div class=\"hint\">\nEj: https://rsc.solertia.sol...</div></md-input-container><md-radio-group ng-model=\"banner.type\"><label \ntranslate=\"BANNERS.TIPO.TIPO\">Tipo</label><md-radio-button value=\"IMG\"><span translate=\"BANNERS.TIPO.IMAGEN\">Imagen\n</span></md-radio-button><md-radio-button value=\"VIDEO\"><span translate=\"BANNERS.TIPO.VIDEO\">Video</span>\n</md-radio-button></md-radio-group><md-input-container class=\"no-errors-spacer\"><label translate=\"BANNERS.DURACION\">\nDuración</label><input ng-model=\"banner.timeon\" type=\"number\"></md-input-container><md-checkbox \nng-model=\"banner.isMuted\" aria-label=\"is muted\" ng-true-value=\"false\" ng-false-value=\"true\" \nng-show=\"banner.type === \'VIDEO\'\"><span translate=\"BANNERS.ISMUTED\">¿Tiene sonido?</span></md-checkbox>\n<md-input-container><label>Prioridad</label><md-select ng-model=\"banner.priority\"><md-option ng-value=\"0\">Normal\n</md-option><md-option ng-value=\"1\">Alta</md-option><md-option ng-value=\"2\">Muy alta</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex class=\"margin-horizontal-8\"><md-checkbox \nng-model=\"toActionInputType\" class=\"md-warn\"><span translate=\"SERVICIOS.MODALEDITAR.AVANZADO\">Avanzado</span>\n</md-checkbox><div ng-show=\"toActionInputType\"><md-input-container class=\"md-block no-errors-spacer\"><label>\ntoAction.method</label><md-select ng-model=\"toActionAdv.method\"><md-option \nng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'PATCH\', \'OPTIONS\', \'CONNECT\', \'HEAD\']\" value=\"{{method}}\">\n{{method}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label>\ntoAction.url</label><input name=\"url\" ng-model=\"toActionAdv.url\"><div class=\"hint\">\nEj: https://wc.solertia.sol:8091/browser</div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>toAction.data</label><input name=\"data\" ng-model=\"toActionAdv.data\"><div \nclass=\"hint\">Browser: {\"url\": \"###\"}</div><div class=\"hint\">Browser: {\"url\": \"###\", \"argv\": [\"###\", \"###\"]}</div><div \nclass=\"hint\">Java: {\"path\": \"###\", \"argv\": [\"###\", \"###\"]}</div></md-input-container></div><div \nng-show=\"!toActionInputType\"><md-input-container class=\"md-block\"><label translate=\"SERVICIOS.MODALEDITAR.TIPO\">\nTipo de enlace</label><md-select ng-model=\"url\"><md-option value=\"browser\"><span translate=\"BANNERS.ASIGNAURL.BROWSER\">\nEnlace externo</span></md-option><md-option value=\"href\"><span translate=\"BANNERS.ASIGNAURL.HREF\">Enlace interno</span>\n</md-option><md-option value=\"store\"><span translate=\"BANNERS.ASIGNAURL.STORE\">Tienda</span></md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-show=\"url !== \'store\'\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.URL\"></label><input ng-model=\"toActionBasic.data\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"url === \'store\'\"><label translate=\"BANNERS.ASIGNAURL.PAQUETE\">Paquete\n</label><md-select ng-model=\"pack\"><md-option></md-option><md-option ng-repeat=\"paquete in listaPaquetes\" \nvalue=\"{{paquete.idPackage}}\">{{paquete.name|formatNameDesc}}</md-option></md-select></md-input-container></div>\n<md-button ng-click=\"editSites()\" class=\"md-raised md-accent\"><span transalate=\"BANNERS.SITES\">\nSeleccionar sitios de aparición</span> ({{banner.sites.length}})</md-button><div layout=\"column\" layout-wrap \nclass=\"margin-top-8\"><div class=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>\nFecha/hora de inicio *</label><input type=\"datetime-local\" ng-model=\"banner.fechaini\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Fecha/hora de fin *</label>\n<input type=\"datetime-local\" ng-model=\"banner.fechafin\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Hora de inicio (diario) **\n</label><input type=\"time\" ng-model=\"banner.horaini\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Hora de fin (diario) **</label>\n<input type=\"time\" ng-model=\"banner.horafin\"></div><span class=\"text-boxed margin-top-8\">\n* Rango de tiempo en el que el banner estará activo</span> <span class=\"text-boxed\">\n** Intervalo de tiempo en el que se visualizará el banner cada día</span></div></div></form><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-z2 padding-horizontal-16 padding-vertical-5\" md-component-id=\"right\"><md-content>\n<div layout=\"column\"><md-checkbox ng-checked=\"exists(\'home\', banner.sites)\" ng-click=\"toggle(\'home\', banner.sites)\">\nHome</md-checkbox><md-checkbox ng-checked=\"exists(\'digitalsignage\', banner.sites)\" \nng-click=\"toggle(\'digitalsignage\', banner.sites)\">Digital Signage</md-checkbox><md-checkbox \nng-checked=\"exists(\'screensaver-left\', banner.sites)\" ng-click=\"toggle(\'screensaver-left\', banner.sites)\">\nSalvapantallas (izq)</md-checkbox><md-checkbox ng-checked=\"exists(\'screensaver-right\', banner.sites)\" \nng-click=\"toggle(\'screensaver-right\', banner.sites)\">Salvapantallas (der)</md-checkbox><div layout=\"row\" layout-wrap><p\n flex=\"100\">Grupos:</p><md-checkbox ng-repeat=\"acl in listaAcls track by $index\" \nng-checked=\"exists(acl, banner.sites)\" ng-click=\"toggle(acl, banner.sites)\" flex=\"33\" flex-xs=\"100\">{{acl}}\n</md-checkbox></div></div><form layout=\"column\" class=\"margin-top-8\"><md-input-container flex=\"100\" \nclass=\"no-errors-spacer\"><label>Otros sitios (separados por comas)</label><input ng-model=\"otherSites\">\n</md-input-container></form></md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><p \ntranslate=\"BANNERS.NOSITESWARNING\" ng-show=\"banner.sites.length < 1\" class=\"orange-700-fg bold\"></p><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"Guardar()\" \nstyle=\"margin-right:20px\" ng-disabled=\"Form.$invalid || dataLoading\" translate=\"BANNERS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/link_iframe.tmpl.html","<md-dialog id=\"setLink-banner\" aria-label=\"Banner link\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"BANNERS.ENLACEBANNER\">\nEnlace del banner</h2></div></md-toolbar><md-dialog-content><form name=\"Form\" novalidate layout=\"column\" \nlayout-gt-sm=\"row\"><div layout=\"column\" flex class=\"margin-horizontal-8\"><md-input-container><label \ntranslate=\"BANNERS.LINK\">URL del recurso</label><input name=\"url\" ng-model=\"banner.link\" required><div class=\"hint\">\nEj: https://rsc.solertia.sol...</div></md-input-container><md-radio-group ng-model=\"banner.type\"><label \ntranslate=\"BANNERS.TIPO.TIPO\">Tipo</label><md-radio-button value=\"IFRAME\" disabled=\"disabled\"><span \ntranslate=\"BANNERS.TIPO.IFRAME\">Página web embebida</span></md-radio-button></md-radio-group><md-input-container \nclass=\"no-errors-spacer\"><label translate=\"BANNERS.DURACION\">Duración</label><input ng-model=\"banner.timeon\" \ntype=\"number\"></md-input-container><md-input-container><label>Prioridad</label><md-select ng-model=\"banner.priority\">\n<md-option ng-value=\"0\">Normal</md-option><md-option ng-value=\"1\">Alta</md-option><md-option ng-value=\"2\">Muy alta\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex class=\"margin-horizontal-8\"><md-button \nng-click=\"editSites()\" class=\"md-raised md-accent\"><span transalate=\"BANNERS.SITES\">Seleccionar sitios de aparición\n</span> ({{banner.sites.length}})</md-button><div layout=\"column\" layout-wrap class=\"margin-top-8\"><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Fecha/hora de inicio *</label>\n<input type=\"datetime-local\" ng-model=\"banner.fechaini\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Fecha/hora de fin *</label>\n<input type=\"datetime-local\" ng-model=\"banner.fechafin\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Hora de inicio (diario) **\n</label><input type=\"time\" ng-model=\"banner.horaini\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\"><label>Hora de fin (diario) **</label>\n<input type=\"time\" ng-model=\"banner.horafin\"></div><span class=\"text-boxed margin-top-8\">\n* Rango de tiempo en el que el banner estará activo</span> <span class=\"text-boxed\">\n** Intervalo de tiempo en el que se visualizará el banner cada día</span></div></div></form><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-z2 padding-horizontal-16 padding-vertical-5\" md-component-id=\"right\"><md-content>\n<div layout=\"column\"><md-checkbox ng-checked=\"exists(\'home\', banner.sites)\" ng-click=\"toggle(\'home\', banner.sites)\">\nHome</md-checkbox><md-checkbox ng-checked=\"exists(\'digitalsignage\', banner.sites)\" \nng-click=\"toggle(\'digitalsignage\', banner.sites)\">Digital Signage</md-checkbox><md-checkbox \nng-checked=\"exists(\'screensaver-left\', banner.sites)\" ng-click=\"toggle(\'screensaver-left\', banner.sites)\">\nSalvapantallas (izq)</md-checkbox><md-checkbox ng-checked=\"exists(\'screensaver-right\', banner.sites)\" \nng-click=\"toggle(\'screensaver-right\', banner.sites)\">Salvapantallas (der)</md-checkbox><div layout=\"row\" layout-wrap><p\n flex=\"100\">Grupos:</p><md-checkbox ng-repeat=\"acl in listaAcls track by $index\" \nng-checked=\"exists(acl, banner.sites)\" ng-click=\"toggle(acl, banner.sites)\" flex=\"33\" flex-xs=\"100\">{{acl}}\n</md-checkbox></div></div><form layout=\"column\" class=\"margin-top-8\"><md-input-container flex=\"100\" \nclass=\"no-errors-spacer\"><label>Otros sitios (separados por comas)</label><input ng-model=\"otherSites\">\n</md-input-container></form></md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><p \ntranslate=\"BANNERS.NOSITESWARNING\" ng-show=\"banner.sites.length < 1\" class=\"orange-700-fg bold\"></p><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"Guardar()\" \nstyle=\"margin-right:20px\" ng-disabled=\"Form.$invalid || dataLoading\" translate=\"BANNERS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/link_lite.tmpl.html","<md-dialog id=\"setLink-banner\" aria-label=\"Banner link\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"BANNERS.ENLACEBANNER\">\nEnlace del banner</h2></div></md-toolbar><md-dialog-content><form name=\"Form\" novalidate layout=\"column\"><div \nlayout=\"column\" flex><h2 translate=\"BANNERS.PROPIEDADES\">Propiedades</h2><div layout-gt-sm=\"row\" layout-wrap flex \nclass=\"layout-align-gt-sm-start-center\"><md-input-container class=\"no-errors-spacer\" flex-gt-sm=\"33\"><label \ntranslate=\"BANNERS.DURACION\">Duración</label><input ng-model=\"banner.timeon\" type=\"number\"></md-input-container>\n<md-checkbox ng-model=\"banner.isMuted\" aria-label=\"is muted\" ng-true-value=\"false\" ng-false-value=\"true\" \nng-show=\"banner.type === \'VIDEO\'\" flex-gt-sm=\"33\"><span translate=\"BANNERS.ISMUTED\">¿Tiene sonido?</span></md-checkbox>\n<md-input-container flex-gt-sm=\"33\"><label>Prioridad</label><md-select ng-model=\"banner.priority\"><md-option \nng-value=\"0\">Normal</md-option><md-option ng-value=\"1\">Alta</md-option><md-option ng-value=\"2\">Muy alta</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"100\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.URL\"></label><input ng-model=\"toAction.data\"></md-input-container><md-button \nng-click=\"editSites()\" class=\"md-raised md-accent\"><span transalate=\"BANNERS.SITES\">Seleccionar sitios de aparición\n</span> ({{banner.sites.length}})</md-button></div></div><div layout=\"column\" flex><h2 \ntranslate=\"BANNERS.TEMPORIZACION\">Temporización</h2><div layout-gt-sm=\"row\" layout-wrap \nclass=\"layout-align-gt-sm-space-between-center\"><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\" flex-gt-sm=\"45\"><label>\nFecha/hora de inicio *</label><input type=\"datetime-local\" ng-model=\"banner.fechaini\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\" flex-gt-sm=\"45\"><label>\nFecha/hora de fin *</label><input type=\"datetime-local\" ng-model=\"banner.fechafin\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\" flex-gt-sm=\"45\"><label>\nHora de inicio (diario) **</label><input type=\"time\" ng-model=\"banner.horaini\"></div><div \nclass=\"md-block layout-row layout-align-space-between-center flex margin-top-8\" flex-gt-sm=\"45\"><label>\nHora de fin (diario) **</label><input type=\"time\" ng-model=\"banner.horafin\"></div></div><span \nclass=\"text-boxed margin-top-8\">* Rango de tiempo en el que el banner estará activo</span> <span class=\"text-boxed\">\n** Intervalo de tiempo en el que se visualizará el banner cada día</span></div></form><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-z2 padding-horizontal-16 padding-vertical-5\" md-component-id=\"right\"><md-content>\n<div layout=\"column\"><md-checkbox ng-checked=\"exists(\'home\', banner.sites)\" ng-click=\"toggle(\'home\', banner.sites)\">\nHome</md-checkbox><md-checkbox ng-checked=\"exists(\'digitalsignage\', banner.sites)\" \nng-click=\"toggle(\'digitalsignage\', banner.sites)\">Digital Signage</md-checkbox><md-checkbox \nng-checked=\"exists(\'screensaver-left\', banner.sites)\" ng-click=\"toggle(\'screensaver-left\', banner.sites)\">\nSalvapantallas (izq)</md-checkbox><md-checkbox ng-checked=\"exists(\'screensaver-right\', banner.sites)\" \nng-click=\"toggle(\'screensaver-right\', banner.sites)\">Salvapantallas (der)</md-checkbox><div layout=\"row\" layout-wrap><p\n flex=\"100\">Grupos:</p><md-checkbox ng-repeat=\"acl in listaAcls track by $index\" \nng-checked=\"exists(acl, banner.sites)\" ng-click=\"toggle(acl, banner.sites)\" flex=\"33\" flex-xs=\"100\">{{acl}}\n</md-checkbox></div></div><form layout=\"column\" class=\"margin-top-8\"><md-input-container flex=\"100\" \nclass=\"no-errors-spacer\"><label>Otros sitios (separados por comas)</label><input ng-model=\"otherSites\">\n</md-input-container></form></md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><p \ntranslate=\"BANNERS.NOSITESWARNING\" ng-show=\"banner.sites.length < 1\" class=\"orange-700-fg bold\"></p><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"Guardar()\" \nstyle=\"margin-right:20px\" ng-disabled=\"Form.$invalid || dataLoading\" translate=\"BANNERS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/nombreRandom.html","<div class=\"avisoAdblock\" ng-hide=\"ok\"><span translate=\"BANNERS.AVISOADBLOCK\">\nSi no aparece el contenido, desactiva AdBlock para esta página.</span><md-icon md-font-icon=\"icon-close\" \nng-click=\"ok = true\"></md-icon></div><div id=\"publicidad\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content\" layout=\"column\"><md-content layout-padding layout=\"column\"><div layout=\"row\" \nng-click=\"toggle(\'#container1\', \'hide\')\" class=\"toggler\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"margin-right-15 margin-left-0\"></md-icon><h2>Lista de archivos</h2><md-icon md-font-icon=\"icon-unfold-more\" \nclass=\"margin-horizontal-24\"></md-icon></div><div id=\"container1\" class=\"hide\"><form name=\"subirImagen\" \nclass=\"md-inline-form\" novalidate><fieldset class=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend \nclass=\"form-title\" translate=\"BANNERS.SUBIRNUEVO\">Subir nuevo archivo</legend><div layout=\"row\" \nlayout-align=\"start center\" style=\"min-height: 150px; width: 100%\" ng-if=\"vm.file\" layout-padding layout-wrap><div \nclass=\"fileData\" layout=\"row\" layout-align=\"center center\" md-whiteframe=\"3\" layout-padding><img \nsrc=\"/assets/quantionImagenes/image.png\"><div><strong>{{fileInfo.name}}</strong> ({{vm.file.type|| \'n/a\'}})<br><span \ntranslate=\"BANNERS.TAMANO\">Tamaño:</span> {{(vm.file.size / 1000000).toFixed(2)}} mb<br><span \ntranslate=\"BANNERS.ULTMODIFICACION\">Últ. modificación:</span>\n {{vm.file.lastModifiedDate ? vm.file.lastModifiedDate.toLocaleDateString(\'es-ES\') : \'n/a\'}}<br><span \ntranslate=\"BANNERS.DURACION\">Duración:</span> {{fileInfo.duration}}</div></div><div flex=\"5\"></div><div \nlayout=\"column\" flex><md-input-container><label translate=\"BANNERS.NOMBREARCHIVO\">Nombre del archivo</label><input \nng-model=\"fileInfo.name\" name=\"nombre\" type=\"text\" maxlength=\"30\" required ng-change=\"checkName()\"><div \nng-messages=\"subirImagen.nombre.$error\"><div ng-message=\"required\" translate=\"BANNERS.REQUIRED\">\nEl archivo debe tener un nombre.</div><div ng-message=\"maxlength\" translate=\"BANNERS.MAXLENGTH\">\nEl nombre debe tener menos de 30 caracteres.</div></div><div class=\"hint\" translate=\"BANNERS.HINTEXTENSION\">\nSe añadirá la extensión automáticamente.</div><div class=\"hint\" style=\"color: red;bottom: -10px\" \nng-show=\"coincideNombre\" translate=\"BANNERS.HINTEXISTENTE\">El nombre coincide con un archivo existente.</div>\n</md-input-container></div></div><div layout-align=\"space-between center\"><md-button class=\"md-raised md-primary\">\n<label for=\"files\" style=\"cursor: pointer\"><md-icon md-font-icon=\"icon-box-upload\" class=\"icon\"></md-icon><span \ntranslate=\"BANNERS.SELECCIONARARCHIVO\">Seleccionar archivo</span></label></md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.enviarArchivo()\" \nng-disabled=\"!vm.file || subirImagen.nombre.$invalid || coincideNombre\"><md-icon md-font-icon=\"icon-send\" class=\"icon\">\n</md-icon><span translate=\"BANNERS.ENVIARARCHIVO\">Enviar archivo</span></md-button><input type=\"file\" id=\"files\" \nhidden aria-label=\"Seleccionar archivo\" required accept=\"image/*,video/*\"></div></fieldset></form><div \nclass=\"listaArchivos\" layout=\"row\" layout-wrap layout-align=\"start start\"><div \nng-repeat=\"file in listaArchivos track by $index\" class=\"elemento layout-column layout-align-center-center\"><img \nng-src=\"{{file.path|replacePath}}\" class=\"imagen\" ng-if=\"file.type === \'IMG\'\" id=\"media-{{$index}}\"><video \nng-if=\"file.type === \'VIDEO\'\" id=\"media-{{$index}}\"><source ng-src=\"{{file.path| replacePath | trustUrl}}\" \ntype=\"video/mp4\"></video><div>{{file.name}}</div><md-icon md-font-icon=\"icon-video\" class=\"md-accent\" \nng-if=\"file.type === \'VIDEO\'\"></md-icon><md-icon md-font-icon=\"icon-close\" ng-click=\"vm.eliminarArchivo(file, $event)\">\n</md-icon></div></div></div></md-content><md-content layout-padding layout=\"column\" id=\"grupos-banners\" \nclass=\"margin-top-8\"><div class=\"md-headline\" translate=\"GRUPOSSTB.LOTESTITLE\">Lotes de banners</div><div \nclass=\"md-subhead\" translate=\"GRUPOSSTB.LOTESSUBTITLE\">\nSe puede asignar un grupo de banners a unos terminales en concreto</div><div layout=\"row\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.ventanaNuevo()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"GRUPOSSTB.NUEVO\">Nuevo grupo</span></md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.ventanaAyuda($event)\"><md-icon md-font-icon=\"icon-help\"></md-icon><span translate=\"BANNERS.AYUDA\">Ayuda\n</span></md-button></div><md-list><div ng-repeat=\"grupo in vm.bannerGroupList track by grupo.idBannerGroup\" \nclass=\"group-container\"><md-list-item class=\"secondary-button-padding md-2-line\"><div class=\"md-list-item-text\"><h3>\n{{::grupo.nombre}}</h3><p>{{::grupo.description}}</p></div><div class=\"md-secondary\"><md-button class=\"md-fab md-mini\" \nng-click=\"vm.asignarStbAGrupo($event, grupo)\" ng-hide=\"grupo.idBannerGroup === 1\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"GRUPOSSTB.ASIGNARSTBAGRUPO\">Asignar STB al grupo</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.ventanaEditar($event, grupo)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"GRUPOSSTB.MODIFICAR\">Modificar grupo</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarGrupo($event, grupo)\" ng-disabled=\"grupo.idBannerGroup === 1\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"GRUPOSSTB.ELIMINAR\">\nEliminar grupo</span></md-tooltip></md-button></div></md-list-item><div class=\"listaImgs\" layout=\"row\" layout-wrap><div\n ng-repeat=\"img in grupo.listbanner track by img.idBanner\"><div \nclass=\"elemento {{img.active ?\'div-selected\' :\'\'}} layout-row layout-align-center-center\"><img \nng-src=\"{{img.link|replacePath}}\" class=\"imagen\" ng-if=\"img.type === \'IMG\'\"><video ng-if=\"img.type === \'VIDEO\'\" \nclass=\"imagen\"><source ng-src=\"{{img.link| replacePath | trustUrl}}\" type=\"video/mp4\"></video><a \nng-href=\"{{img.link}}\" ng-if=\"img.type === \'IFRAME\'\">{{img.link}}</a><md-tooltip md-direction=\"top\">{{img.link}}\n</md-tooltip><div class=\"overlay\"><div class=\"zoom\" ng-click=\"vm.zoomImagen(img)\"><md-icon \nmd-font-icon=\"icon-open-in-new\" class=\"icon\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"BANNERS.PANTALLACOMPLETA\">Pantalla completa</span></md-tooltip></div><div class=\"borrar\" \nng-click=\"vm.eliminarBanner(img, $event, grupo)\"><md-icon md-font-icon=\"icon-close\" class=\"icon\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"BANNERS.ELIMINAR\">Eliminar</span></md-tooltip></div><div class=\"url\" \nng-click=\"vm.setLink(img, $event, grupo)\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"BANNERS.LINK\">Link</span></md-tooltip></div></div><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"check\" ng-class=\"{\'selected\':img.active, \'noSelected\':!img.active}\" \nng-click=\"toggleActive(img, grupo)\"></md-icon><div layout=\"row\" class=\"top-left-icons\"><md-icon \nmd-font-icon=\"icon-video\" class=\"md-accent\" ng-if=\"img.type === \'VIDEO\'\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"md-accent\" ng-if=\"img.priority === 1\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-double-up\" class=\"md-accent\" ng-if=\"img.priority >= 2\"></md-icon><md-icon \nmd-font-icon=\"icon-volume\" class=\"md-accent\" ng-if=\"!img.isMuted\"></md-icon><md-icon md-font-icon=\"icon-web\" \nclass=\"md-accent\" ng-if=\"img.type === \'IFRAME\'\"></md-icon></div></div><div layout=\"row\" layout-wrap \nclass=\"sites-container\"><div ng-repeat=\"acl in img.sites | limitTo: 5 track by acl\" \nclass=\"text-boxed-light md-primary-bg\">{{acl}}</div><div ng-if=\"img.sites.length > 5\" \nclass=\"text-boxed-light md-accent-bg\">+ {{img.sites.length - 5}}</div></div></div></div><div layout=\"row\" layout-wrap>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.asignarBanners($event, grupo)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><span translate=\"GRUPOSSTB.ASIGNARBANNERSAGRUPO\">Asignar banners al grupo</span></md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.asignarBannerIframe($event, grupo)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><span translate=\"GRUPOSSTB.ASIGNARBANNERIFRAME\">Añadir banner de tipo web</span></md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.notificarEquipos($event, grupo)\" \nng-disabled=\"grupo.fechamod <= grupo.fechasync\"><md-icon md-font-icon=\"icon-sync\"></md-icon><span \ntranslate=\"BANNERS.NOTIFICAR\">Notificar a equipos</span></md-button></div></div></md-list></md-content><md-content \nlayout-padding layout=\"column\" class=\"margin-top-8\"><div class=\"md-subhead\" translate=\"GRUPOSSTB.STBSSINGRUPO\">\nEquipos sin grupo (solo tendrán los banners del grupo por defecto)</div><div id=\"sin-grupo-container\" \nclass=\"layout-row layout-wrap\"></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/archivos/documentExplorer/documentExplorer.html","<div id=\"documentExplorer\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-mini\" aria-label=\"Upload\" ng-click=\"upload()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"FILEEXPLORER.SUBIRARCHIVO\">Subir archivo</span></md-tooltip></md-button><input \ntype=\"file\" id=\"uploadFile\" hidden multiple=\"multiple\"><md-button class=\"md-fab md-mini\" aria-label=\"nueva carpeta\" \nng-click=\"newFolder(actualPath)\"><md-icon md-font-icon=\"icon-folder-plus\"></md-icon><md-tooltip md-direction=\"left\">\n<span translate=\"FILEEXPLORER.NUEVACARPETA\">Nueva carpeta</span></md-tooltip></md-button></div><md-list class=\"bar\">\n<md-list-item class=\"md-primary-bg\"><div class=\"md-list-item-inner flex\"><md-icon md-font-icon=\"icon-undo-variant\" \nclass=\"md-primary-bg\" ng-click=\"goBack()\"></md-icon><p>/{{actualPath}}</p><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"md-primary-bg\" ng-if=\"grid\" ng-click=\"toggleGrid()\"></md-icon><md-icon \nmd-font-icon=\"icon-apps\" class=\"md-primary-bg\" ng-if=\"!grid\" ng-click=\"toggleGrid()\"></md-icon></div></md-list-item>\n</md-list><md-list class=\"archivos\" ng-class=\"{\'grid\': grid, \'layout-row\': grid, \'layout-wrap\': grid}\"><md-list-item \nng-repeat=\"file in listaArchivos\"><div class=\"md-list-item-inner flex\" ng-click=\"openFolder(file)\" \nng-class=\"{\'folder\': !file.file, \'layout-column\': grid}\"><img \nng-src=\"{{!file.file ? \'/assets/quantionImagenes/FileExplorer/folder.png\' : getIconFromExtension(file)}}\" \nclass=\"md-avatar\" on-error-image=\"/assets/quantionImagenes/FileExplorer/unknown.png\"><p flex>{{file.name}}</p><p \nng-if=\"file.file && !grid\" hide show-gt-xs>{{file.modified|date:\'dd/MM/yy HH:mm\'}}</p><p ng-if=\"file.file && !grid\" \nhide show-gt-xs>{{file.size|formatBytes}}</p></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"file.file\">\n<md-button ng-click=\"download(file)\"><md-icon md-font-icon=\"icon-download\" md-menu-align-target></md-icon><span \ntranslate=\"FILEEXPLORER.DESCARGAR\">Descargar</span></md-button></md-menu-item><md-menu-item ng-if=\"file.file\">\n<md-button ng-click=\"eliminar(file)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"FILEEXPLORER.ELIMINAR\">Eliminar</span></md-button></md-menu-item><md-menu-item ng-if=\"!file.file\"><md-button\n ng-click=\"eliminarCarpeta(file)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"FILEEXPLORER.ELIMINAR\">Eliminar carpeta</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><a id=\"hiddenLink\" href=\"\" download hidden></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/archivos/documentExplorer/newFolder.tmpl.html","<md-dialog id=\"nueva-carpeta\" aria-label=\"Carpeta\" ng-cloak md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"FILEEXPLORER.NUEVACARPETA\">Nueva carpeta</h2></div></md-toolbar>\n<md-dialog-content><form name=\"form\" novalidate><md-input-container class=\"md-block\"><label \ntranslate=\"FILEEXPLORER.CARPETA.NOMBRE\">Nombre de usuario</label><input name=\"usuario\" ng-model=\"folder\" required \nautofocus></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"guardar(folder)\" \nng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" translate=\"USUARIOS.GUARDAR\">Guardar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/auth/login/login.html","<div id=\"quantionLogin\" class=\"flex-scrollable\" layout=\"column\" ms-scroll \nstyle=\"background: url({{backgroundUrl}}) no-repeat; background-size: cover\"><div id=\"login-form-wrapper\" layout=\"row\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo_ md-primary-bg\"><img \nng-src=\"{{vm.logoEstablecimiento}}/completo.png\" alt=\"Quantion Logo\"><h1>{{installationName}}</h1></div><div \nclass=\"title\" translate=\"LOGIN.TITLE\">Accede a tu cuenta</div><form name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\"><label translate=\"LOGIN.USUARIO\">Usuario</label><input type=\"text\" name=\"usuario\" \nng-model=\"vm.user.name\" required autofocus></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"LOGIN.PASSWORD\">Contraseña</label><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nrequired></md-input-container><div style=\"color: red; text-align: center\">{{vm.mensajeError}}</div><div \nstyle=\"color: #01cd3e; text-align: center\" ng-show=\"vm.loggedSuccesfully\">Entrando...</div><img \nng-show=\"vm.dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Entrar\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nng-click=\"vm.login()\" translate=\"LOGIN.SUBMIT\">Entrar</md-button></form></div></div></div>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/dispensar.tmpl.html","<md-dialog id=\"dispensar-mandos\" aria-label=\"Dispensar mandos\" flex><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDispensar mandos</h2></div></md-toolbar><md-dialog-content><form class=\"layout-column\"><md-input-container><label>\nIntroduzca password</label><input type=\"password\" ng-model=\"password\"></md-input-container><md-input-container \nclass=\"block\"><label>Comentario</label><input ng-model=\"comentario\"></md-input-container></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancelar</md-button><md-button ng-click=\"dispensar()\" \nng-disabled=\"!password || !comentario\">Dispensar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/logs.tmpl.html","<md-dialog id=\"cajeros-logs\" aria-label=\"Nueva compra\" ng-cloak md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Logs de cajero</h2></div></md-toolbar><md-dialog-content><div layout=\"row\"><div \nlayout=\"column\" ng-repeat=\"(key,value) in logObject\" class=\"list\"><p>{{key}}</p><a ng-repeat=\"log in value\" \nng-href=\"{{cajero.config.ip}}:20001/open/{{key}}/{{log}}\" target=\"_blank\">{{log}}</a></div></div><div \nstyle=\"color: red; text-align: center\" ng-show=\"!logObject && error\">{{error}}</div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/mandos.html","<div id=\"administradorCajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><h1>{{CAJERO.title}}</h1><section class=\"status\" layout=\"row\" layout-wrap><div \nclass=\"info\" flex=\"33\" flex-sm=\"66\" flex-xs=\"100\"><div class=\"green estado\" ng-if=\"status.cajeroIniciado\">Iniciado\n</div><div class=\"red estado\" ng-if=\"!status.cajeroIniciado\">Apagado</div><div><md-button \nng-if=\"status.cajeroIniciado\" ng-click=\"off()\" class=\"md-fab md-primary\" aria-label=\"apagar\"><md-tooltip \nmd-direction=\"top\">Apagar</md-tooltip><md-icon md-font-icon=\"icon-power\"></md-icon></md-button><md-button \nng-if=\"!status.cajeroIniciado\" ng-click=\"on()\" class=\"md-fab md-primary\" aria-label=\"iniciar\"><md-tooltip \nmd-direction=\"top\">Iniciar</md-tooltip><md-icon md-font-icon=\"icon-power\"></md-icon></md-button><md-button \nng-click=\"reboot()\" class=\"md-fab md-primary\" aria-label=\"reiniciar\"><md-tooltip md-direction=\"top\">Reiniciar\n</md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div><span>\nTiempo de inicio: {{status.tiempoOnline.enInicio| date:\'dd/MM/yy HH:mm\'}}</span> <span>\nMando depositado: {{status.mandoDepositado?\"Si\" :\"No\"}}</span><div class=\"disponibilidad\"><span>\nuID mando: {{status.uidMando}}</span><md-switch ng-model=\"mandoStatus.isAvailable\" aria-label=\"Switch 1\" \nng-change=\"changeDisp()\" ng-value=\"mandoStatus.isAvailable\">{{ mandoStatus.isAvailable ?\"Disponible\" :\"No disponible\"}}\n</md-switch></div><div class=\"trampilla\"><span>Trampilla:</span><md-switch ng-model=\"status.trampillaAbierta\" \naria-label=\"Switch 1\" ng-change=\"toggleTrampilla()\" ng-value=\"status.trampillaAbierta\">\n{{status.trampillaAbierta ? \"Abierta\" : \"Cerrada\"}}</md-switch></div><span>\nTipo de operación: {{status.operacionEnCurso.description}}</span> <span ng-if=\"status.operacionEnCurso.id === 1\">\nFijado: {{status.importe.cobro.fijado}}</span> <span ng-if=\"status.operacionEnCurso.id === 1\">\nRestante: {{status.importe.cobro.restante}}</span> <span ng-if=\"status.operacionEnCurso.id === 2\">\nFijado: {{status.importe.pago.fijado}}</span> <span ng-if=\"status.operacionEnCurso.id === 2\">\nEntregado: {{status.importe.pago.entregado}}</span> <span>\nMandos disponibles: {{cantidad1.number}}(Tipo 1) + {{cantidad2.number}}(Tipo 2) = {{cantidad1.number + cantidad2.number}}\n</span><div class=\"tolvas\"><div ng-class=\"tolva.available ? \'tolva\' : \'tolva empty\'\" ng-repeat=\"tolva in tolvas\"><span \nng-if=\"tolva.linea === 1 && tolva.available\">T1</span> <span ng-if=\"tolva.linea === 2 && tolva.available\">T2</span> \n<span class=\"empty\" ng-if=\"!tolva.available\">0</span></div></div></div><div class=\"actions\" flex=\"33\" flex-xs=\"100\">\n<div layout=\"row\" layout-align=\"center center\" layout-sm=\"column\" layout-align-sm=\"center stretch\"><md-input-container \nflex><label>Cantidad a pagar (EUR)</label><input type=\"number\" ng-model=\"payment\" min=\"1\" max=\"50\">\n</md-input-container><md-button ng-click=\"pay(payment)\" class=\"md-raised md-primary\" ng-disabled=\"!payment\">Pagar\n</md-button></div><div layout=\"row\" layout-align=\"center center\" layout-sm=\"column\" layout-align-sm=\"center stretch\">\n<md-input-container flex><label>Tipo</label><md-select ng-model=\"type\"><md-option ng-repeat=\"value in tipos\" \nng-value=\"{{value.tipoMando}}\">{{value.modeloTv}} (Tipo {{value.tipoMando}})</md-option></md-select>\n</md-input-container><md-button ng-click=\"dispensar()\" class=\"md-raised md-primary\" ng-disabled=\"!type\">Dispensar\n</md-button></div></div><div class=\"saldo\" flex=\"100\" flex-gt-sm=\"33\"><div><h3>\nDisponible devoluciones: {{pagadores.total}} €</h3><div layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"moneda layout-row layout-align-center-start\" ng-repeat=\"(moneda,cantidad) in pagadores.hopper\" ng-if=\"cantidad\">\n<img ng-src=\"assets/cajeros/{{moneda}}e.png\" alt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div><div \nclass=\"moneda layout-row layout-align-center-start\" ng-repeat=\"(billete,cantidad) in pagadores.billetes\" \nng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{billete}}e.jpg\" alt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div>\n</div></div><div><h3>Retirado a caja: {{nopagadores.total}} €</h3><div layout=\"row\" layout-wrap \nlayout-align=\"center end\"><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(billete,cantidad) in nopagadores.stacker\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{billete}}e.jpg\" \nalt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div></div></div></div></section><section class=\"log\"><md-content \nclass=\"md-padding history\"><md-tabs><md-tab><md-tab-label>Operaciones dispensar</md-tab-label><md-tab-body><div \nclass=\"pantallaCarga\" layout-align=\"center center\" ng-show=\"isLoading1\"><div class=\"cargaCentral content\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"120\"></md-progress-circular></div></div><md-content class=\"content-table\" ms-scroll><table><tr><th>\nID operacion</th><th>Fecha</th><th>Cantidad</th><th>Habitacion</th><th>Tipo mando</th><th>Pago de 10 €</th><th>\nPago de 5 €</th><th>Pago de 1 €</th><th>Cobrado 50 €</th><th>Cobrado 20 €</th><th>Cobrado 10 €</th><th>Cobrado 5 €</th>\n</tr><tr ng-repeat=\"dispensacion in logDispensar\"><td>{{dispensacion.idOperacion}}</td><td>\n{{dispensacion.fecha| date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{dispensacion.cantidad}} €</td><td>{{dispensacion.habitacion}}\n</td><td>{{dispensacion.tipoMando}}</td><td class=\"blueDark\">{{dispensacion.Pagado1000}}</td><td class=\"blueDark\">\n{{dispensacion.Pagado500}}</td><td class=\"blueDark\">{{dispensacion.Pagado100}}</td><td class=\"blue\">\n{{dispensacion.Cobrado5000}}</td><td class=\"blue\">{{dispensacion.Cobrado2000}}</td><td class=\"blue\">\n{{dispensacion.Cobrado1000}}</td><td class=\"blue\">{{dispensacion.Cobrado500}}</td></tr></table></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label>Operaciones de recoger</md-tab-label><md-tab-body><div \nclass=\"pantallaCarga\" layout-align=\"center center\" ng-show=\"isLoading2\"><div class=\"cargaCentral content\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"120\"></md-progress-circular></div></div><md-content class=\"content-table\" ms-scroll><table><tr><th>\nID operacion</th><th>Fecha</th><th>Cantidad</th><th>Pagado</th><th>uID mando</th><th>Billetes de 20€</th><th>\nBilletes de 10€</th><th>Billetes de 5€</th><th>Monedas de 1€</th></tr><tr ng-repeat=\"recogida in logRecoger\"><td>\n{{recogida.idOperacion}}</td><td>{{recogida.fecha| date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{recogida.cantidad}} €</td><td \nclass=\"pagado\" ng-if=\"recogida.pagado\"><p class=\"green pagado\">Pagado</p></td><td class=\"nopagado\" \nng-if=\"!recogida.pagado\"><p class=\"red nopagado nopagado-background\">No pagado</p><md-button ng-click=\"marcarPagado()\" \nclass=\"md-raised md-primary\">Realizar pago</md-button></td><td>{{recogida.uidMando}}</td><td>{{recogida.Pagado2000}}\n</td><td>{{recogida.Pagado1000}}</td><td>{{recogida.Pagado500}}</td><td>{{recogida.Pagado100}}</td></tr></table>\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label>Mandos Registrados</md-tab-label><md-tab-body><div \nclass=\"pantallaCarga\" layout-align=\"center center\" ng-show=\"isLoading3\"><div class=\"cargaCentral content\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"120\"></md-progress-circular></div></div><md-content class=\"content-table\" ms-scroll><table><tr><th>\nuID mando</th><th>Disponibilidad</th><th>Precio</th></tr><tr ng-repeat=\"mando in mandos\"><td>{{mando.uID}}</td><td>\n<md-checkbox ng-model=\"mando.isAvailable\" aria-label=\"Switch 1\"></md-checkbox></td><td>{{mando.price}} €</td></tr>\n</table></md-content></md-tab-body></md-tab><md-tab><md-tab-label>Cupones sin usar</md-tab-label><md-tab-body><div \nclass=\"md-dialog-content-body\"><table><tr><th><span translate=\"GCAJEROS.IDCUPON\">ID cupón:</span></th><th><span \ntranslate=\"GCAJEROS.GENERADO\">Generado:</span></th></tr><tr \nng-repeat=\"cupon in CAJERO.cuponNoUsado| orderBy:\'-generado\'\"><td>{{::cupon.idCupon}}</td><td>\n{{::cupon.generado|date:\"dd/MM/yyyy HH:mm\"}}</td></tr></table></div></md-tab-body></md-tab><md-tab><md-tab-label>\nCupones usados</md-tab-label><md-tab-body><div class=\"md-dialog-content-body\"><md-content class=\"content-table\" \nms-scroll><table><tr><th><span translate=\"GCAJEROS.IDCUPON\">ID cupón:</span></th><th>ID operación</th><th><span \ntranslate=\"GCAJEROS.GENERADO\">Generado:</span></th><th>Usado</th></tr><tr \nng-repeat=\"cupon in CAJERO.cupon| orderBy:\'-generado\'\"><td>{{::cupon.idCupon}}</td><td>{{::cupon.idOperacion}}</td><td>\n{{::cupon.generado|date:\"dd/MM/yyyy HH:mm\"}}</td><td>{{::cupon.usado|date:\"dd/MM/yyyy HH:mm\"}}</td></tr></table>\n</md-content></div></md-tab-body></md-tab></md-tabs></md-content><div class=\"dates\" layout-xs=\"column\"><md-datepicker \nng-model=\"fInicio\" md-placeholder=\"Fecha inicio\" ng-change=\"date_changed()\"></md-datepicker><md-datepicker \nng-model=\"fFin\" md-placeholder=\"Fecha fin\" ng-change=\"date_changed()\"></md-datepicker></div></section></md-content>\n</div></div>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/mensajeFservicio.tmpl.html","<md-dialog aria-label=\"mensaje\"><form><md-dialog-content><h2>¿Activar la pantalla de \'Fuera de Servicio\'?</h2><h3>\nPuede indicar un mensaje en el campo de texto, que aparecerá en esta pantalla.<br>\nSi se deja vacío se pondrá un mensaje por defecto</h3><md-input-container style=\"width: 100%\"><label>Mensaje</label>\n<input ng-model=\"mensaje\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><img \nsrc=\"assets/quantionImagenes/cargando.gif\" ng-if=\"isLoading\"><md-button ng-click=\"hide()\" style=\"margin-right:20px\">\nCancelar</md-button><md-button ng-click=\"enviar(mensaje)\" ng-disabled=\"isLoading\">Aceptar</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/mensajeFservicioSinMensaje.tmpl.html","<md-dialog aria-label=\"mensaje\"><form><md-dialog-content><h2>¿Activar la pantalla de \'Fuera de Servicio\'?</h2>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img src=\"assets/quantionImagenes/cargando.gif\" ng-if=\"isLoading\">\n<md-button ng-click=\"hide()\" style=\"margin-right:20px\">Cancelar</md-button><md-button ng-click=\"enviar(mensaje)\" \nng-disabled=\"isLoading\">Aceptar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/pagar.tmpl.html","<md-dialog id=\"pagar-mandos\" aria-label=\"Pagar\" flex><md-toolbar><div class=\"md-toolbar-tools\"><h2>Pagar</h2></div>\n</md-toolbar><md-dialog-content><form class=\"layout-column\"><md-input-container><label>Introduzca password</label>\n<input type=\"password\" ng-model=\"password\"></md-input-container><md-input-container class=\"block\"><label>Comentario\n</label><input ng-model=\"comentario\"></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"cancel()\">Cancelar</md-button><md-button ng-click=\"pagar()\" \nng-disabled=\"!password || !comentario\">Pagar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/paquetes.html","<div id=\"administradorCajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><h1>{{CAJERO.title}}</h1><section class=\"status\"><div \nclass=\"info layout-align-center-center layout-align-gt-sm-space-between-center layout-gt-sm-row layout-wrap\"><div \nclass=\"layout-gt-xs-row layout-column layout-align-center-center\"><div class=\"green estado\" \nng-if=\"status.cajeroIniciado\">Iniciado</div><div class=\"red estado\" ng-if=\"!status.cajeroIniciado\">Apagado</div><div>\n<md-button ng-if=\"status.cajeroIniciado\" ng-click=\"off()\" class=\"md-fab md-primary\" aria-label=\"apagar\"><md-tooltip \nmd-direction=\"top\">Apagar</md-tooltip><md-icon md-font-icon=\"icon-power\"></md-icon></md-button><md-button \nng-if=\"!status.cajeroIniciado\" ng-click=\"on()\" class=\"md-fab md-primary\" aria-label=\"iniciar\"><md-tooltip \nmd-direction=\"top\">Iniciar</md-tooltip><md-icon md-font-icon=\"icon-power\"></md-icon></md-button><md-button \nng-click=\"reboot()\" class=\"md-fab md-primary\" aria-label=\"reiniciar\"><md-tooltip md-direction=\"top\">Reiniciar\n</md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div></div><div layout=\"column\"><span>\nTiempo de inicio: {{status.tiempoOnline.enInicio| date:\'dd/MM/yy HH:mm\'}}</span> <span>\nTipo de operación: {{status.operacionEnCurso.description}}</span> <span ng-if=\"status.operacionEnCurso.id === 1\">\nFijado: {{status.importe.cobro.fijado}}</span> <span ng-if=\"status.operacionEnCurso.id === 1\">\nRestante: {{status.importe.cobro.restante}}</span> <span ng-if=\"status.operacionEnCurso.id === 2\">\nFijado: {{status.importe.pago.fijado}}</span> <span ng-if=\"status.operacionEnCurso.id === 2\">\nEntregado: {{status.importe.pago.entregado}}</span> <span ng-if=\"status.admite.metalico\">Admite metálico</span> <span \nng-if=\"!status.admite.metalico\">No admite metálico</span> <span ng-if=\"status.admite.tarjeta\">Admite tarjeta</span> \n<span ng-if=\"!status.admite.tarjeta\">No admite tarjeta</span> <span>{{status.cantidadPapel.description}}</span></div>\n</div><div class=\"saldo\"><div><h3>Total pagadores: {{pagadores.total}} €</h3><div layout=\"row\" layout-wrap \nlayout-align=\"center center\"><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(moneda,cantidad) in pagadores.tubo\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{moneda}}e.png\" alt=\"\">\n<div class=\"cantidad\">{{cantidad}}</div></div><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(billete,cantidad) in pagadores.billetes\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{billete}}e.jpg\" \nalt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div></div></div><div><h3>Total no pagadores: {{nopagadores.total}} €\n</h3><div layout=\"row\" layout-wrap layout-align=\"center end\"><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(moneda,cantidad) in nopagadores.cajon\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{moneda}}e.png\" \nalt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(billete,cantidad) in nopagadores.stacker\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{billete}}e.jpg\" \nalt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div></div></div></div></section></md-content></div></div>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/sumup.html","<div id=\"administradorCajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><h1>{{CAJERO.title}}</h1><section class=\"status\"><div \nclass=\"info layout-align-center-center layout-align-gt-sm-space-around-center layout-gt-sm-row layout-wrap\"><div \nclass=\"green estado\" ng-if=\"status\">Iniciado</div><div class=\"red estado\" ng-if=\"!status\">Apagado</div><div \nlayout=\"column\"><md-button ng-click=\"reboot()\" class=\"md-raised md-primary\" aria-label=\"reiniciar\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Reiniciar</md-button><md-button ng-click=\"restart()\" \nclass=\"md-raised md-primary\" aria-label=\"restart\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Recargar interfaz\n</md-button><md-button ng-click=\"startFservicio()\" class=\"md-raised md-primary\" aria-label=\"poner fuera de servicio\" \nng-if=\"CAJERO.fueraServicio && !fueraServicio\"><md-icon md-font-icon=\"icon-alert-box\"></md-icon>Poner fuera de servicio\n</md-button><md-button ng-click=\"stopFservicio()\" class=\"md-raised md-primary\" aria-label=\"quitar fuera de servicio\" \nng-if=\"CAJERO.fueraServicio && fueraServicio\"><md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon>\nQuitar fuera de servicio</md-button><md-button ng-click=\"updateSumupMode(\'prod\')\" class=\"md-raised md-primary\" \naria-label=\"poner fuera de servicio\" ng-if=\"sumupMode === \'dev\'\"><md-icon md-font-icon=\"icon-currency-eur\"></md-icon>\nCambiar a modo \"prod\"</md-button><md-button ng-click=\"updateSumupMode(\'dev\')\" class=\"md-raised md-primary\" \naria-label=\"quitar fuera de servicio\" ng-if=\"sumupMode === \'prod\'\"><md-icon md-font-icon=\"icon-code-tags\"></md-icon>\nCambiar a modo \"dev\"</md-button></div><div layout=\"column\" class=\"layout-align-start-start\"><span>\nTiempo de inicio: {{info.tiempoOnline | date:\'dd/MM/yy HH:mm\'}}</span> <span>\nModo de pago: {{sumupMode}} ({{sumupMode === \'dev\' ? \'Desarrollo\' : \'Producción\'}})</span> <span>\nVersión: {{info.version}}</span> <span>IP: {{info.ipWifi || info.ipEth}}</span> <span>SO: {{info.os}}</span></div>\n</div><div class=\"layout-align-center-center layout-row margin-top-24\"><div class=\"screenshot-container\" \nng-click=\"getScreenshot()\"><img ng-src=\"{{screenshot}}\" ng-if=\"screenshot\" class=\"md-whiteframe-z2\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"screenshotLoading\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div></div></div></section></md-content></div></div>");
$templateCache.put("app/main/Quantion/administradorCajeros/views/tarjetas.html","<div id=\"administradorCajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><h1>{{CAJERO.title}}</h1><section class=\"status\"><div \nclass=\"info layout-align-center-center layout-align-gt-sm-space-between-center layout-gt-sm-row layout-wrap\"><div \nclass=\"layout-gt-xs-row layout-column layout-align-center-center\"><div class=\"green estado\" \nng-if=\"status.cajeroIniciado\">Iniciado</div><div class=\"red estado\" ng-if=\"!status.cajeroIniciado\">Apagado</div><div \nlayout=\"column\"><md-button ng-if=\"status.cajeroIniciado\" ng-click=\"off()\" class=\"md-raised md-primary\" \naria-label=\"apagar\"><md-icon md-font-icon=\"icon-power\"></md-icon>Apagar</md-button><md-button \nng-if=\"!status.cajeroIniciado\" ng-click=\"on()\" class=\"md-raised md-primary\" aria-label=\"iniciar\"><md-icon \nmd-font-icon=\"icon-power\"></md-icon>Iniciar</md-button><md-button ng-click=\"reboot()\" class=\"md-raised md-primary\" \naria-label=\"reiniciar\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Reiniciar</md-button><md-button \nng-click=\"rebootOCX()\" class=\"md-raised md-primary\" aria-label=\"reiniciar\"><md-icon md-font-icon=\"icon-refresh\">\n</md-icon>Reiniciar OCX</md-button><md-button ng-click=\"rebootRele()\" class=\"md-raised md-primary\" \naria-label=\"reiniciar\" ng-if=\"CAJERO.rele\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Reinicio de corriente (Relé)\n</md-button><md-button ng-click=\"startFservicio()\" class=\"md-raised md-primary\" aria-label=\"poner fuera de servicio\" \nng-if=\"CAJERO.fueraServicio && !status.fueraServicio.mostrar\"><md-icon md-font-icon=\"icon-alert-box\"></md-icon>\nPoner fuera de servicio</md-button><md-button ng-click=\"stopFservicio()\" class=\"md-raised md-primary\" \naria-label=\"quitar fuera de servicio\" ng-if=\"CAJERO.fueraServicio && status.fueraServicio.mostrar\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon>Quitar fuera de servicio</md-button></div></div><div layout=\"column\">\n<span>Tiempo de inicio: {{status.tiempoOnline.enInicio| date:\'dd/MM/yy HH:mm\'}}</span> <span>\nTipo de operación: {{status.operacionEnCurso.description}}</span> <span ng-if=\"status.operacionEnCurso.id === 1\">\nFijado: {{status.importe.cobro.fijado}}</span> <span ng-if=\"status.operacionEnCurso.id === 1\">\nRestante: {{status.importe.cobro.restante}}</span> <span ng-if=\"status.operacionEnCurso.id === 2\">\nFijado: {{status.importe.pago.fijado}}</span> <span ng-if=\"status.operacionEnCurso.id === 2\">\nEntregado: {{status.importe.pago.entregado}}</span> <span>\nTarjeta en el retenedor: {{status.tarjetero.retenedor?\'Si\':\'No\'}}</span> <span>\n{{status.tarjetero.dispensador}} tarjetas en el dispensador</span> <span ng-if=\"status.admite.metalico\">Admite metálico\n</span> <span ng-if=\"!status.admite.metalico\">No admite metálico</span> <span ng-if=\"status.admite.tarjeta\">\nAdmite tarjeta</span> <span ng-if=\"!status.admite.tarjeta\">No admite tarjeta</span> <span>\n{{status.cantidadPapel.description}}</span></div></div><div class=\"saldo\"><div><h3>\nTotal pagadores: {{pagadores.total}} €</h3><div layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"moneda layout-row layout-align-center-start\" ng-repeat=\"(moneda,cantidad) in pagadores.tubo\" ng-if=\"cantidad\">\n<img ng-src=\"assets/cajeros/{{moneda}}e.png\" alt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div><div \nclass=\"moneda layout-row layout-align-center-start\" ng-repeat=\"(billete,cantidad) in pagadores.billetes\" \nng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{billete}}e.jpg\" alt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div>\n</div></div><div><h3>Total no pagadores: {{nopagadores.total}} €</h3><div layout=\"row\" layout-wrap \nlayout-align=\"center end\"><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(moneda,cantidad) in nopagadores.cajon\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{moneda}}e.png\" \nalt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div><div class=\"moneda layout-row layout-align-center-start\" \nng-repeat=\"(billete,cantidad) in nopagadores.stacker\" ng-if=\"cantidad\"><img ng-src=\"assets/cajeros/{{billete}}e.jpg\" \nalt=\"\"><div class=\"cantidad\">{{cantidad}}</div></div></div></div></div></section></md-content></div></div>");
$templateCache.put("app/main/Quantion/avisos/enviar/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenNotif\" aria-label=\"Elegir imagen\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</h2></div></md-toolbar><md-dialog-content>\n<div layout=\"row\" layout-wrap layout-align=\"center center\"><div ng-repeat=\"img in listaLogos\"><img \nng-src=\"{{img.path|replacePath}}\" ng-click=\"escogerImagen(img.path)\"></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/enviar/enviar.html","<div id=\"enviarAviso\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\"><md-content \nlayout-padding layout=\"column\"><div layout=\"row\" ng-if=\"!isPlantilla\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.MENSAJE\">Mensaje</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"vm.event.type\" required>\n<h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"space-around center\" class=\"tipo-aviso\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div></div></md-radio-group>\n<md-input-container md-no-float class=\"md-block\" ng-if=\"vm.event.type === \'simple\'\"><h4 translate=\"ENVIAR.TEXTO\">Texto\n</h4><input type=\"text\" name=\"stitle\" ng-model=\"vm.event.title\" placeholder=\"{{\'ENVIAR.TEXTO\'|translate}}\" \nmd-maxlength=\"255\" required><div ng-messages=\"paso1.stitle.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD1\">El nombre debe tener menos de 255 caracteres.</div></div></md-input-container><div \nng-if=\"vm.event.type === \'completo\'\"><md-input-container md-no-float class=\"md-block\"><h4 translate=\"ENVIAR.TITULO\">\nTítulo</h4><input type=\"text\" name=\"title\" ng-model=\"vm.event.title\" placeholder=\"{{\'ENVIAR.TITULO\'|translate}}\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container><div \nflex=\"10\" hide-xs hide-sm></div><md-input-container md-no-float class=\"md-block\"><h4 translate=\"ENVIAR.CONTENIDO\">\nContenido del aviso</h4><textarea style=\"height: 100px\" name=\"message\" ng-model=\"vm.event.message\" md-maxlength=\"255\" \nrows=\"5\" placeholder=\"{{\'ENVIAR.CONTENIDO\'|translate}}\" required></textarea><div ng-messages=\"paso1.message.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD3\">\nEl mensaje debe tener menos de 255 caracteres.</div></div></md-input-container><div flex=\"10\" hide-xs hide-sm></div>\n<md-input-container md-no-float class=\"md-block\"><h4 translate=\"ENVIAR.IMAGEN\">Imagen</h4><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><img ng-src=\"{{vm.event.logo|replacePath}}\" alt=\"{{vm.event.logo}}\" \nng-click=\"vm.elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"logo\" ng-model=\"vm.event.logo\" required><div ng-messages=\"paso1.logo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"vm.stbSearch.mode\" \nlayout=\"row\" layout-xs=\"column\"><md-radio-button value=\"{{mode.value}}\" ng-repeat=\"mode in vm.stbSearch.modes\"><span \ntranslate=\"ENVIAR.{{mode.text}}\">{{mode.text}}</span></md-radio-button></md-radio-group><div style=\"margin-top: 30px\" \nng-show=\'vm.stbSearch.mode === \"individual\"\'><fieldset class=\"standard\"><legend translate=\"ENVIAR.AVIND\">\nAviso individual</legend><md-chips ng-model=\"vm.stbSearch.modes.individual.selectedStbObjs\" md-autocomplete-snap=\"\" \nmd-require-match=\"true\" md-on-add=\"vm.actualizarRestantes()\" md-on-remove=\"vm.actualizarRestantes()\" md-min-length=\"0\" \nplaceholder=\"Enter para añadir\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)|orderBy:\'room\'\" md-item-text=\"item\" md-no-cache=\"true\" \nmd-min-length=\"0\"><span md-highlight-text=\"vm.searchText\">{{item.room + \" - \" + item.username}}</span>\n</md-autocomplete><md-chip-template><span><strong>{{$chip.room + \" - \" + $chip.username}}</strong></span>\n</md-chip-template></md-chips></fieldset></div><div style=\"margin-top: 30px\" ng-show=\'vm.stbSearch.mode === \"group\"\' \nlayout=\"column\"><md-checkbox ng-checked=\"item.selected\" ng-click=\"vm.stbSearch.modes.group.toogle(item)\" \nng-repeat=\"item in vm.stbSearch.modes.group.groupList\">{{item.nombre}} <span ng-if=\"item.place\">({{item.place}})</span>\n</md-checkbox></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label>\n<span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i class=\"icon-check s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">Temporización</span></span>\n</md-tab-label><md-tab-body><form name=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form novalidate>\n<md-input-container><h5 translate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</h5><input name=\"displaytime\" \ntype=\"number\" ng-model=\"vm.event.displaytime\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container><md-radio-group ng-model=\"vm.temp_modo\" \nlayout=\"row\"><md-radio-button value=\"inmediato\"><span translate=\"ENVIAR.INMEDIATO\">Inmediato</span></md-radio-button>\n<md-radio-button value=\"programado\"><span translate=\"ENVIAR.PROGRAMADO\">Programado</span></md-radio-button>\n</md-radio-group><div class=\"temporizacion\" style=\"margin-top: 30px\" layout=\"column\" \nng-show=\"vm.temp_modo === \'programado\'\"><div layout=\"row\" layout-align=\"center space-between\" layout-wrap><div \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"45\" flex-gt-md=\"30\" md-whiteframe=\"5\" layout-margin>\n<h5 style=\"margin-top: 15px\" translate=\"ENVIAR.TINICIO\">Inicio periodo</h5><md-datepicker ng-model=\"vm.temp_fini\" \nmd-placeholder=\"Inicio\" md-min-date=\"vm.fechaMinima\"></md-datepicker><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><label translate=\"ENVIAR.HORAS\">Horas</label><input type=\"number\" ng-model=\"vm.ini_hours\" min=\"0\" \nmax=\"23\" required></md-input-container><md-input-container><label translate=\"ENVIAR.MINUTOS\">Minutos</label><input \ntype=\"number\" ng-model=\"vm.ini_minutes\" min=\"0\" max=\"59\" required></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"45\" flex-gt-md=\"30\" md-whiteframe=\"5\" layout-margin>\n<h5 style=\"margin-top: 15px\" translate=\"ENVIAR.TFIN\">Fin periodo</h5><md-datepicker ng-model=\"vm.temp_ffin\" \nmd-placeholder=\"Fin\" md-min-date=\"vm.temp_fini\"></md-datepicker><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><label translate=\"ENVIAR.HORAS\">Horas</label><input type=\"number\" ng-model=\"vm.fin_hours\" min=\"0\" \nmax=\"23\" required></md-input-container><md-input-container><label translate=\"ENVIAR.MINUTOS\">Minutos</label><input \ntype=\"number\" ng-model=\"vm.fin_minutes\" min=\"0\" max=\"59\" required></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"60\" flex-gt-md=\"30\" md-whiteframe=\"5\" layout-margin>\n<h5 style=\"margin-top: 15px\" translate=\"ENVIAR.TREPET\">Intervalo de repetición</h5><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between center\"><span \nstyle=\"margin: 7px; min-height:58px; line-height: 35px; min-width: 90px\" translate=\"ENVIAR.REPET\">Repetir cada</span>\n<md-input-container style=\"margin: 0\"><input name=\"tiemporepet\" type=\"number\" ng-model=\"vm.temp_repet2\" min=\"1\" \nmax=\"999\" required aria-label=\"tiemporepet\"></md-input-container><md-input-container \nstyle=\"margin: 0; min-height: 58px\"><md-select ng-model=\"vm.temp_repet\" aria-label=\"temp_repet\"><md-option \nvalue=\"minutos\"><span translate=\"ENVIAR.MINUTOS\">Minutos</span></md-option><md-option value=\"horas\"><span \ntranslate=\"ENVIAR.HORAS\">Horas</span></md-option><md-option value=\"dias\"><span translate=\"ENVIAR.DIAS\">Dias</span>\n</md-option></md-select></md-input-container></div></div></div></div></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"ENVIAR.ANTERIOR\">Anterior\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\n                                              \'selected md-accent-bg\':msWizard.selectedIndex === $index}\">\n</span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || vm.yaEnviado\" translate=\"ENVIAR.ENVIAR\">Enviar evento</md-button></div>\n</ms-form-wizard></div><div ng-if=\"isPlantilla\"><form name=\"plantilla\" class=\"md-inline-form\" novalidate>\n<md-radio-group ng-model=\"vm.event.type\" required><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-around center\" class=\"tipo-aviso\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div></div></md-radio-group>\n<md-input-container md-no-float class=\"md-block\" ng-if=\"vm.event.type === \'simple\'\"><h4 translate=\"ENVIAR.TEXTO\">Texto\n</h4><input type=\"text\" name=\"stitle\" ng-model=\"vm.event.title\" placeholder=\"{{\'ENVIAR.TEXTO\'|translate}}\" \nmd-maxlength=\"255\" required><div ng-messages=\"plantilla.stitle.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD1\">El nombre debe tener menos de 80 caracteres.</div></div></md-input-container><div \nng-if=\"vm.event.type === \'completo\'\"><md-input-container md-no-float class=\"md-block\"><h4 translate=\"ENVIAR.TITULO\">\nTítulo</h4><input type=\"text\" name=\"title\" ng-model=\"vm.event.title\" placeholder=\"{{\'ENVIAR.TITULO\'|translate}}\" \nmd-maxlength=\"80\" required><div ng-messages=\"plantilla.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container><div \nflex=\"10\" hide-xs hide-sm></div><md-input-container md-no-float class=\"md-block\"><h4 translate=\"ENVIAR.CONTENIDO\">\nContenido del aviso</h4><textarea style=\"height: 100px\" name=\"message\" ng-model=\"vm.event.message\" md-maxlength=\"255\" \nrows=\"5\" placeholder=\"{{\'ENVIAR.CONTENIDO\'|translate}}\" required></textarea><div \nng-messages=\"plantilla.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 150 caracteres.</div></div></md-input-container><div \nflex=\"10\" hide-xs hide-sm></div><md-input-container md-no-float class=\"md-block\"><h4 translate=\"ENVIAR.IMAGEN\">Imagen\n</h4><div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img ng-src=\"{{vm.event.logo}}\" \nalt=\"{{vm.event.logo}}\" ng-click=\"vm.elegirImagen($event)\" style=\"cursor: pointer\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen\n</md-button></div><input type=\"hidden\" name=\"logo\" ng-model=\"vm.event.logo\" required><div \nng-messages=\"plantilla.logo.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container></div></form><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.guardarPlantilla()\" ng-disabled=\"plantilla.$invalid || vm.yaEnviado\" \ntranslate=\"ENVIAR.GUARDARPLANTILLA\">Guardar plantilla</md-button></div></md-content></div><div class=\"pantallaCarga\" \nlayout-align=\"center center\" ng-show=\"vm.enviando\"><div class=\"content\" layout=\"column\" layout-align=\"center center\">\n<h1 translate=\"ENVIAR.ENVIANDO\">Enviando...</h1><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"120\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/Quantion/avisos/enviarpubli/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenNotif\" aria-label=\"Elegir imagen\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</h2></div></md-toolbar><md-dialog-content>\n<div layout=\"row\" layout-wrap layout-align=\"center center\"><div ng-repeat=\"img in listaLogos\"><img \nng-src=\"{{img.path|replacePath}}\" ng-click=\"escogerImagen(img.path)\"></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/enviarpubli/enviarpubli.html","<div id=\"enviarPubli\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\"><md-content \nlayout-padding layout=\"column\"><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"PUBLI.MENSAJE\">Mensaje</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"vm.event.type\" required>\n<h4 translate=\"PUBLI.TIPOAVISO\">Tipo de aviso</h4><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"space-around center\" class=\"tipo-aviso\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"PUBLI.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"PUBLI.COMPLETO\">Completo</span></md-radio-button></div></div></md-radio-group>\n<md-input-container md-no-float class=\"md-block\" ng-if=\"vm.event.type === \'simple\'\"><h4 translate=\"PUBLI.TEXTO\">Texto\n</h4><input type=\"text\" name=\"stitle\" ng-model=\"vm.event.title\" placeholder=\"{{\'PUBLI.TEXTO\'|translate}}\" \nmd-maxlength=\"255\" required><div ng-messages=\"paso1.stitle.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"PUBLI.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"PUBLI.MAXLONGITUD1\">El nombre debe tener menos de 255 caracteres.</div></div></md-input-container><div \nng-if=\"vm.event.type === \'completo\'\"><md-input-container md-no-float class=\"md-block\"><h4 translate=\"PUBLI.TITULO\">\nTítulo</h4><input type=\"text\" name=\"title\" ng-model=\"vm.event.title\" placeholder=\"{{\'PUBLI.TITULO\'|translate}}\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"PUBLI.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"PUBLI.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container><div \nflex=\"10\" hide-xs hide-sm></div><md-input-container md-no-float class=\"md-block\"><h4 translate=\"PUBLI.CONTENIDO\">\nContenido del aviso</h4><textarea style=\"height: 100px\" name=\"message\" ng-model=\"vm.event.message\" md-maxlength=\"255\" \nrows=\"5\" placeholder=\"{{\'PUBLI.CONTENIDO\'|translate}}\" required></textarea><div ng-messages=\"paso1.message.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"PUBLI.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"md-maxlength\" translate=\"PUBLI.MAXLONGITUD3\">\nEl mensaje debe tener menos de 255 caracteres.</div></div></md-input-container><div flex=\"10\" hide-xs hide-sm></div>\n<md-input-container md-no-float class=\"md-block\"><h4 translate=\"PUBLI.IMAGEN\">Imagen</h4><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><img ng-src=\"{{vm.event.logo|replacePath}}\" alt=\"{{vm.event.logo}}\" \nng-click=\"vm.elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.elegirImagen($event)\" translate=\"PUBLI.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"logo\" ng-model=\"vm.event.logo\" required><div ng-messages=\"paso1.logo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"PUBLI.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"PUBLI.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div class=\"envioInfo\" translate=\"PUBLI.INFO\">\nSe enviará el aviso a los usuarios que NO tengan alguno de los servicios marcados.</div><div layout=\"row\" \nlayout-xs=\"column\" layout-wrap layout-align=\"start start\" layout-align-xs=\"center stretch\"><div \nng-repeat=\"pkg in vm.listaPaquetes\" class=\"package\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-accent-bg\"><span>{{pkg.name|formatNameDesc}}</span><md-checkbox ng-checked=\"pkg.selected\" \nng-click=\"togglePackage(pkg)\" class=\"md-primary\" aria-label=\"paquete\"></md-checkbox></div><div layout=\"column\" \nclass=\"package-content\"><md-list-item layout=\"row\" layout-align=\"start center\" ng-repeat=\"srv in pkg.ordinaryServices\">\n<md-checkbox ng-checked=\"srv.selected\" ng-click=\"toggleService(srv, pkg)\" aria-label=\"servicio\"></md-checkbox><img \nng-src=\"{{::(JSONconfig.logosPath.to + \'/\' + FilePaths.servicios_paquetes + \'/\' + srv.acl + \'.png\')|replacePath}}\" \nclass=\"md-avatar\"><div>{{srv.name|formatNameDesc}}</div></md-list-item></div></div></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"PUBLI.TEMPORIZACION\">Temporización</span></span></md-tab-label>\n<md-tab-body><form name=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-input-container><h5 \ntranslate=\"PUBLI.DISPLAY\">Tiempo de visualización (en segundos)</h5><input name=\"displaytime\" type=\"number\" \nng-model=\"vm.event.displaytime\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"PUBLI.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"PUBLI.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"PUBLI.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container><div class=\"temporizacion\" \nstyle=\"margin-top: 30px\" layout=\"column\"><div layout=\"row\" layout-align=\"center space-between\" layout-wrap><div \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"45\" flex-gt-md=\"30\" md-whiteframe=\"5\" layout-margin>\n<h5 style=\"margin-top: 15px\" translate=\"PUBLI.TINICIO\">Inicio periodo</h5><md-datepicker ng-model=\"vm.temp_fini\" \nmd-placeholder=\"Inicio\" md-min-date=\"vm.fechaMinima\"></md-datepicker><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><label translate=\"PUBLI.HORAS\">Horas</label><input type=\"number\" ng-model=\"vm.ini_hours\" min=\"0\" \nmax=\"23\" required></md-input-container><md-input-container><label translate=\"PUBLI.MINUTOS\">Minutos</label><input \ntype=\"number\" ng-model=\"vm.ini_minutes\" min=\"0\" max=\"59\" required></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"45\" flex-gt-md=\"30\" md-whiteframe=\"5\" layout-margin>\n<h5 style=\"margin-top: 15px\" translate=\"PUBLI.TFIN\">Fin periodo</h5><md-datepicker ng-model=\"vm.temp_ffin\" \nmd-placeholder=\"Fin\" md-min-date=\"vm.temp_fini\"></md-datepicker><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><label translate=\"PUBLI.HORAS\">Horas</label><input type=\"number\" ng-model=\"vm.fin_hours\" min=\"0\" \nmax=\"23\" required></md-input-container><md-input-container><label translate=\"PUBLI.MINUTOS\">Minutos</label><input \ntype=\"number\" ng-model=\"vm.fin_minutes\" min=\"0\" max=\"59\" required></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"60\" flex-gt-md=\"30\" md-whiteframe=\"5\" layout-margin>\n<h5 style=\"margin-top: 15px\" translate=\"PUBLI.TREPET\">Intervalo de repetición</h5><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><span style=\"margin: 7px; min-height:58px; line-height: 35px; min-width: 90px\" \ntranslate=\"PUBLI.REPET\">Repetir cada</span><md-input-container style=\"margin: 0\"><input name=\"tiemporepet\" \ntype=\"number\" ng-model=\"vm.temp_repet2\" min=\"1\" max=\"999\" required aria-label=\"tiemporepet\"></md-input-container>\n<md-input-container style=\"margin: 0; min-height: 58px\"><md-select ng-model=\"vm.temp_repet\" aria-label=\"temp_repet\">\n<md-option value=\"minutos\"><span translate=\"PUBLI.MINUTOS\">Minutos</span></md-option><md-option value=\"horas\"><span \ntranslate=\"PUBLI.HORAS\">Horas</span></md-option><md-option value=\"dias\"><span translate=\"PUBLI.DIAS\">Dias</span>\n</md-option></md-select></md-input-container></div></div></div></div></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"PUBLI.ANTERIOR\">Anterior</md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\n                                              \'selected md-accent-bg\':msWizard.selectedIndex === $index}\">\n</span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"PUBLI.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || vm.yaEnviado\" translate=\"PUBLI.ENVIAR\">Enviar evento</md-button></div>\n</ms-form-wizard></div></md-content><div class=\"pantallaCarga\" layout-align=\"center center\" ng-show=\"vm.enviando\"><div \nclass=\"content\" layout=\"column\" layout-align=\"center center\"><h1 translate=\"PUBLI.ENVIANDO\">Enviando...</h1>\n<md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"120\"></md-progress-circular></div></div>\n</div></div>");
$templateCache.put("app/main/Quantion/avisos/listado/listado.html","<div id=\"listadoAvisos\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div class=\"type-selector layout-row layout-wrap\"><div \nng-class=\"{\'md-warn-bg\': typeSelected === \'programmed\'}\" ng-click=\"selectType(\'programmed\')\" flex=\"50\" flex-xs=\"100\">\n<span translate=\"LISTADOAVISOS.AVISOSPROGRAMADOS\">Avisos Programados</span><md-badge class=\"md-accent-bg\">\n{{badgeValues.numProgPendientes}}<md-tooltip md-direction=\"bottom\"><span translate=\"LISTADOAVISOS.ACTIVOS\">Activos\n</span></md-tooltip></md-badge><md-badge class=\"md-primary-bg\">{{badgeValues.numProgEnviados}}<md-tooltip \nmd-direction=\"bottom\"><span translate=\"LISTADOAVISOS.FINALIZADOS\">Finalizados</span></md-tooltip></md-badge></div><div \nng-class=\"{\'md-warn-bg\': typeSelected === \'publi\'}\" ng-click=\"selectType(\'publi\')\" flex=\"50\" flex-xs=\"100\" \nng-if=\"JSONconfig.sistemaDePago\"><span translate=\"LISTADOAVISOS.AVISOSPUBLICITARIOS\">Avisos Publicitarios</span>\n<md-badge class=\"md-accent-bg\">{{badgeValues.numPubliPendientes}}<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LISTADOAVISOS.ACTIVOS\">Activos</span></md-tooltip></md-badge><md-badge class=\"md-primary-bg\">\n{{badgeValues.numPubliEnviados}}<md-tooltip md-direction=\"bottom\"><span translate=\"LISTADOAVISOS.FINALIZADOS\">\nFinalizados</span></md-tooltip></md-badge></div><div ng-class=\"{\'md-warn-bg\': typeSelected === \'inmediate\'}\" \nng-click=\"selectType(\'inmediate\')\" flex=\"50\" flex-xs=\"100\"><span translate=\"LISTADOAVISOS.AVISOSINMEDIATOS\">\nAvisos Inmediatos</span><md-badge class=\"md-primary-bg\">{{vm.eventosInmediatos.length}}</md-badge></div><div \nng-class=\"{\'md-warn-bg\': typeSelected === \'publi-inmediate\'}\" ng-click=\"selectType(\'publi-inmediate\')\" flex=\"50\" \nflex-xs=\"100\" ng-if=\"JSONconfig.sistemaDePago\"><span translate=\"LISTADOAVISOS.AVISOSPUBLICITARIOSINMEDIATOS\">\nAvisos Publicitarios Inmediatos</span><md-badge class=\"md-primary-bg\">{{vm.eventosPubliInmediatos.length}}</md-badge>\n</div><div ng-class=\"{\'md-warn-bg\': typeSelected === \'template\'}\" ng-click=\"selectType(\'template\')\" flex=\"50\" \nflex-xs=\"100\"><span translate=\"LISTADOAVISOS.PLANTILLAS\">Plantillas</span><md-badge class=\"md-primary-bg\">\n{{vm.plantillas.length}}</md-badge></div></div></md-content><md-content layout-padding layout=\"column\" \nclass=\"margin-top-15\" ng-hide=\"!typeSelected\"><div class=\"event-container\"><md-list \nng-show=\"typeSelected === \'programmed\'\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento programado\" \nng-click=\"addEvent()\" ng-if=\"!JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini\" aria-label=\"Nuevo evento programado\" ng-click=\"addEventQT()\" ng-if=\"JSONconfig.avisosQT\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">Crear aviso QT</md-tooltip></md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"addEventFromClipboard()\">Crear aviso desde portapapeles</md-button>\n<md-subheader class=\"md-no-sticky\"><div layout=\"row\" layout-align=\"start center\"><div flex>\nEn curso ({{vm.eventosProgramados.encurso.length}})</div><md-button class=\"md-icon-button\" aria-label=\"select\" \nng-click=\"selectAll(vm.eventosProgramados.encurso)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\">\n</md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosProgramados.encurso)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"prog in vm.eventosProgramados.encurso\" ng-click=\"details(prog)\"><md-checkbox \nng-checked=\"existsSelect(prog.idTask)\" ng-click=\"toggleSelect(prog.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(prog.header.icon || prog.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{prog.title|| prog.header.properties.title.text}}</h3><h4>\n{{prog.description|| prog.header.properties.description.text}}</h4><p>\n{{prog.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{prog.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{prog.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(prog)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(prog)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, prog.idTask, true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><div layout=\"row\" \nlayout-align=\"start center\"><div flex>Sin empezar ({{vm.eventosProgramados.pendientes.length}})</div><md-button \nclass=\"md-icon-button\" aria-label=\"select\" ng-click=\"selectAll(vm.eventosProgramados.pendientes)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosProgramados.pendientes)\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip>\n</md-button><md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"prog in vm.eventosProgramados.pendientes\" ng-click=\"details(prog)\"><md-checkbox \nng-checked=\"existsSelect(prog.idTask)\" ng-click=\"toggleSelect(prog.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(prog.header.icon || prog.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{prog.title|| prog.header.properties.title.text}}</h3><h4>\n{{prog.description|| prog.header.properties.description.text}}</h4><p>\n{{prog.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{prog.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{prog.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(prog)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(prog)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, prog.idTask, true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><div layout=\"row\" \nlayout-align=\"start center\"><div flex>Finalizados ({{vm.eventosProgramados.finalizados.length}})</div><md-button \nclass=\"md-icon-button\" aria-label=\"select\" ng-click=\"selectAll(vm.eventosProgramados.finalizados)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosProgramados.finalizados)\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip>\n</md-button><md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"prog in vm.eventosProgramados.finalizados\" ng-click=\"details(prog)\"><md-checkbox \nng-checked=\"existsSelect(prog.idTask)\" ng-click=\"toggleSelect(prog.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(prog.header.icon || prog.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{prog.title|| prog.header.properties.title.text}}</h3><h4>\n{{prog.description|| prog.header.properties.description.text}}</h4><p>\n{{prog.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{prog.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{prog.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(prog)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(prog)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, prog.idTask, true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'publi\'\"><md-button class=\"md-fab md-mini\" \naria-label=\"Nuevo evento programado\" ng-click=\"addEventPubli()\" ng-if=\"!JSONconfig.avisosQT\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento programado\" \nng-click=\"addEventPubliQT()\" ng-if=\"JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Crear aviso QT</md-tooltip></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"addEventPubliFromClipboard()\">Crear aviso desde portapapeles</md-button><md-subheader class=\"md-no-sticky\">\n<div layout=\"row\" layout-align=\"start center\"><div flex>En curso ({{vm.eventosPubli.encurso.length}})</div><md-button \nclass=\"md-icon-button\" aria-label=\"select\" ng-click=\"selectAll(vm.eventosPubli.encurso)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosPubli.encurso)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"publi in vm.eventosPubli.encurso\" ng-click=\"details(publi)\"><md-checkbox \nng-checked=\"existsSelect(publi.idTask)\" ng-click=\"toggleSelect(publi.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(publi.header.icon || publi.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{publi.title|| publi.header.properties.title.text}}</h3><h4>\n{{publi.description|| publi.header.properties.description.text}}</h4><p>\n{{publi.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{publi.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{publi.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenvioPubli(publi)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(publi)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, publi.idTask, true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><div layout=\"row\" \nlayout-align=\"start center\"><div flex>Sin empezar ({{vm.eventosPubli.pendientes.length}})</div><md-button \nclass=\"md-icon-button\" aria-label=\"select\" ng-click=\"selectAll(vm.eventosPubli.pendientes)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosPubli.pendientes)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"publi in vm.eventosPubli.pendientes\" ng-click=\"details(publi)\"><md-checkbox \nng-checked=\"existsSelect(publi.idTask)\" ng-click=\"toggleSelect(publi.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(publi.header.icon || publi.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{publi.title|| publi.header.properties.title.text}}</h3><h4>\n{{publi.description|| publi.header.properties.description.text}}</h4><p>\n{{publi.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{publi.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{publi.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenvioPubli(publi)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(publi)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, publi.idTask, true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><div layout=\"row\" \nlayout-align=\"start center\"><div flex>Finalizados ({{vm.eventosPubli.finalizados.length}})</div><md-button \nclass=\"md-icon-button\" aria-label=\"select\" ng-click=\"selectAll(vm.eventosPubli.finalizados)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosPubli.finalizados)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"publi in vm.eventosPubli.finalizados\" ng-click=\"details(publi)\"><md-checkbox \nng-checked=\"existsSelect(publi.idTask)\" ng-click=\"toggleSelect(publi.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(publi.header.icon || publi.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{publi.title|| publi.header.properties.title.text}}</h3><h4>\n{{publi.description|| publi.header.properties.description.text}}</h4><p>\n{{publi.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{publi.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{publi.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenvioPubli(publi)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(publi)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, publi.idTask, true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'inmediate\'\"><md-button class=\"md-fab md-mini\" \naria-label=\"Nuevo evento normal\" ng-click=\"addEvent()\" ng-if=\"!JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento programado\" ng-click=\"addEventQT()\" \nng-if=\"JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\nCrear aviso QT</md-tooltip></md-button><md-button class=\"md-raised md-accent\" ng-click=\"addEventFromClipboard()\">\nCrear aviso desde portapapeles</md-button><md-subheader class=\"md-no-sticky\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"select\" \nng-click=\"selectAll(vm.eventosInmediatos)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon>\n<md-tooltip>Seleccionar todos</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"unselect\" \nng-click=\"unselectAll(vm.eventosInmediatos)\"><md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon>\n<md-tooltip>Deseleccionar todos</md-tooltip></md-button><md-button class=\"md-icon-button md-accent\" \naria-label=\"delete\" ng-click=\"deleteSelected()\" ng-disabled=\"selectedTasks.length < 1\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados</md-tooltip></md-button></div></md-subheader>\n<md-list-item class=\"md-3-line\" ng-repeat=\"inm in vm.eventosInmediatos\" ng-click=\"details(inm)\"><md-checkbox \nng-checked=\"existsSelect(inm.idTask)\" ng-click=\"toggleSelect(inm.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(inm.header.icon || inm.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{inm.title|| inm.header.properties.title.text}}</h3><h4>\n{{inm.description|| inm.header.properties.description.text}}</h4><p>\n{{inm.fecha|date:\"dd/MM/yyyy HH:mm\"}} ({{inm.displaytime| convertSeconds}})</p></div><md-menu><md-button \naria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nclass=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.reenviar(inm)\">\n<md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.copyToClipboard(inm)\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><span translate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteEvent($event, inm.idTask)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button>\n</md-menu-item></md-menu-content></md-menu></md-list-item></md-list><md-list \nng-show=\"typeSelected === \'publi-inmediate\'\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento normal\" \nng-click=\"addEventPubli()\" ng-if=\"!JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento normal\" ng-click=\"addEventPubliQT()\" \nng-if=\"JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\nCrear aviso QT</md-tooltip></md-button><md-button class=\"md-raised md-accent\" ng-click=\"addEventPubliFromClipboard()\">\nCrear aviso desde portapapeles</md-button><md-subheader class=\"md-no-sticky\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"select\" \nng-click=\"selectAll(vm.eventosPubliInmediatos)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\">\n</md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"unselect\" ng-click=\"unselectAll(vm.eventosPubliInmediatos)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"inm in vm.eventosPubliInmediatos\" ng-click=\"details(inm)\"><md-checkbox \nng-checked=\"existsSelect(inm.idTask)\" ng-click=\"toggleSelect(inm.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(inm.header.icon || inm.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{inm.title|| inm.header.properties.title.text}}</h3><h4>\n{{inm.description|| inm.header.properties.description.text}}</h4><p>\n{{inm.fecha|date:\"dd/MM/yyyy HH:mm\"}} ({{inm.displaytime| convertSeconds}})</p></div><md-menu><md-button \naria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nclass=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.reenvioPubli(inm)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyToClipboard(inm)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span \ntranslate=\"LISTADOAVISOS.COPYTOCLIPBOARD\">Copiar al portapapeles</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteEvent($event, inm.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'template\'\"><md-button class=\"md-fab md-mini\" \naria-label=\"Nueva plantilla\" ng-click=\"addTemplate()\" ng-if=\"!JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Nueva plantilla\" ng-click=\"addTemplateQT()\" \nng-if=\"JSONconfig.avisosQT\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\nCrear aviso QT</md-tooltip></md-button><md-subheader class=\"md-no-sticky\"><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button\" aria-label=\"select\" ng-click=\"selectAll(vm.plantillas)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon><md-tooltip>Seleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"unselect\" ng-click=\"unselectAll(vm.plantillas)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-tooltip>Deseleccionar todos</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteSelected()\" \nng-disabled=\"selectedTasks.length < 1\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Eliminar seleccionados\n</md-tooltip></md-button></div></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"tmpl in vm.plantillas\" \nng-click=\"details(tmpl)\"><md-checkbox ng-checked=\"existsSelect(tmpl.idTask)\" \nng-click=\"toggleSelect(tmpl.idTask, $event)\"></md-checkbox><img \nng-src=\"{{(tmpl.header.icon || tmpl.header.properties.image.logo) | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{tmpl.title|| tmpl.header.properties.title.text}}</h3><h4>\n{{tmpl.description|| tmpl.header.properties.description.text}}</h4></div><md-menu><md-button aria-label=\"menu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.reenviar(tmpl, true)\"><md-icon \nmd-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"LISTADOAVISOS.REENVIARNORMAL\">Reenviar</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.reenvioPubli(tmpl, true)\"><md-icon \nmd-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"LISTADOAVISOS.REENVIARPUBLI\">Reenviar</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteEvent($event, tmpl.idTask, false, true)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button>\n</md-menu-item></md-menu-content></md-menu></md-list-item></md-list></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/gestionCompras/consumo/contabilidad.html","<div id=\"contabilidad\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div layout-padding><form name=\"BusquedaPaquetes\" novalidate layout=\"row\" layout-xs=\"column\"><div flex>\n<div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" layout-xs=\"column\" flex layout-wrap layout-align=\"start start\">\n<div class=\"md-block margin-right-32\" layout=\"column\"><label translate=\"CONSUMO.FECHAINICIO\">Fecha de inicio</label>\n<input type=\"date\" ng-model=\"busquedaPaquetes.fromDate\" required></div><div class=\"md-block\" layout=\"column\"><label \ntranslate=\"CONSUMO.FECHAFIN\">Fecha de fin</label><input type=\"date\" ng-model=\"busquedaPaquetes.toDate\" required></div>\n</div></div><div><md-radio-group ng-model=\"option\" layout=\"row\" layout-xs=\"column\" style=\"margin: 20px 0\">\n<md-radio-button value=\"todos\"><span translate=\"CONSUMO.TODOS\">Todos</span></md-radio-button><md-radio-button \nvalue=\"individual\"><span translate=\"CONSUMO.INDIVIDUAL\">Individual</span></md-radio-button><md-radio-button \nvalue=\"grupo\"><span translate=\"CONSUMO.GRUPO\">Grupo</span></md-radio-button></md-radio-group><fieldset \nstyle=\"margin-top: 20px\" ng-if=\"option === \'grupo\'\"><legend translate=\"CONSUMO.GRUPOS\">Grupos</legend><md-checkbox \nng-repeat=\"gr in vm.listaGrupos\" ng-checked=\"gr.selected\" ng-click=\"toggle(gr)\">{{gr.nombre}} <span ng-if=\"gr.place\">\n({{gr.place}})</span></md-checkbox></fieldset><fieldset style=\"margin-top: 20px\" ng-if=\"option === \'individual\'\">\n<legend><span translate=\"CONSUMO.INDIVIDUAL\">Individual</span> <span style=\"font-size: 12px\" \ntranslate=\"CONSUMO.PINCHARARRASTRAR\">(pinchar y arrastrar para seleccionar un rango)</span></legend><md-checkbox \nng-repeat=\"ind in vm.listaStbs\" ng-checked=\"ind.selected\" ng-click=\"toggle(ind)\" ng-mousedown=\"saveIndex($index)\" \nng-mouseup=\"selectRange($index)\" class=\"ind-checkbox\">{{ind.room}}</md-checkbox></fieldset></div></div><div \nlayout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.buscarOperacionesPaquetes()\" \nng-disabled=\"BusquedaPaquetes.$invalid || !vm.listaStbs\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"CONSUMO.BUSCAROPERACIONES\">Buscar operaciones</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.resetFormPaquetes()\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"CONSUMO.REINICIARCAMPOS\">Reiniciar campos</span></md-tooltip>\n</md-button></div></form><span class=\"red-700-fg font-size-12\">Buscar más allá de 3 meses puede requerir más tiempo\n</span><md-progress-linear md-mode=\"indeterminate\" ng-show=\"loadingPaquetes\"></md-progress-linear><div \nstyle=\"overflow: auto\" class=\"padding-0\"><table class=\"row-border hover\" ng-if=\"vm.listaOperacionesPaquetes\"><thead>\n<tr><th></th><th ng-repeat=\"pkg in vm.listaOperacionesPaquetes.total.packages\" ng-if=\"pkg.totalAmount > 0\">\n{{pkg.name|formatNameDesc}}</th><th ng-if=\"option === \'todos\' && JSONconfig.hayMandos\" translate=\"CONSUMO.MANDOS\">\nMandos</th><th translate=\"CONSUMO.VOIP\">Voip</th><th translate=\"CONSUMO.DEVOLUCIONES\">Devoluciones</th><th \ntranslate=\"CONSUMO.CORTESIAS\">Devoluciones</th><th translate=\"CONSUMO.RECARGAS\">Recargas desde admin</th><th \ntranslate=\"CONSUMO.TOTAL\">Total</th></tr></thead><tbody class=\"scrollable\"><tr \nng-repeat=\"day in vm.listaOperacionesPaquetes.eachDay\" ng-click=\"selectDay(day.day)\" on-last-repeat><td>\n{{day.day|date:\'dd/MM/yy\'}}</td><td ng-repeat=\"pkg in day.reportMod.packages\" \nclass=\"{{pkg.totalAmount > 0?\'bold\':\'zero\'}}\" \nng-if=\"vm.listaOperacionesPaquetes.total.packages[$index].totalAmount > 0\">{{pkg.totalAmount}}€</td><td \nng-if=\"option === \'todos\' && JSONconfig.hayMandos\">\n{{vm.listaOperacionesMandos.eachDay[$index].report.amount}}€ ({{vm.listaOperacionesMandos.eachDay[$index].report.times}} \n<span translate=\"CONSUMO.UDS\">uds.</span>)</td><td>\n{{vm.listaOperacionesVoip.eachDay[$index].report.virtualAmount|abs}}€ ({{vm.listaOperacionesVoip.eachDay[$index].report.times}} \n<span translate=\"CONSUMO.LLAMADAS\">llamadas</span>)</td><td class=\"refund-td\" \nng-click=\"verDevoluciones(vm.listaDevoluciones.eachDay[$index], $event)\">\n{{-vm.listaDevoluciones.eachDay[$index].report.totalAmount}}€ ({{vm.listaDevoluciones.eachDay[$index].report.times}} dev.)\n</td><td class=\"cortesy-td\" ng-click=\"verCortesias(vm.listaCortesias.eachDay[$index], $event)\">\n{{vm.listaCortesias.eachDay[$index].report.times}} cor.</td><td class=\"balance-td\" \nng-click=\"verRecargas(vm.listaRecargasFront.eachDay[$index], $event)\">\n{{vm.listaRecargasFront.eachDay[$index].report.totalAmount}}€ ({{vm.listaRecargasFront.eachDay[$index].report.times}} op.)\n</td><td>\n{{suma(day.report.totalAmount, vm.listaOperacionesMandos.eachDay[$index].report.amount, vm.listaOperacionesVoip.eachDay[$index].report.virtualAmount, -vm.listaDevoluciones.eachDay[$index].report.totalAmount)}}€\n</td></tr><tr><td translate=\"CONSUMO.TOTAL\">Total</td><td \nng-repeat=\"pkg in vm.listaOperacionesPaquetes.total.packages\" ng-if=\"pkg.totalAmount > 0\">{{pkg.totalAmount}}€\n<md-tooltip md-direction=\"top\">{{pkg.totalAmount / numStbs|roundDecimals: 2}}€/STB</md-tooltip></td><td \nng-if=\"option === \'todos\' && JSONconfig.hayMandos\">\n{{vm.listaOperacionesMandos.amount}}€ ({{vm.listaOperacionesMandos.times}} <span translate=\"CONSUMO.UDS\">uds.</span>)\n<md-tooltip md-direction=\"top\">{{vm.listaOperacionesMandos.amount / numStbs|roundDecimals: 2}}€/STB</md-tooltip></td>\n<td>{{vm.listaOperacionesVoip.total.virtualAmount|abs}}€ ({{vm.listaOperacionesVoip.total.times}} <span \ntranslate=\"CONSUMO.LLAMADAS\">llamadas</span>)<md-tooltip md-direction=\"top\">\n{{vm.listaOperacionesVoip.total.virtualAmount / numStbs|abs |roundDecimals: 2}}€/STB</md-tooltip></td><td \nclass=\"refund-td\">{{-vm.listaDevoluciones.total.totalAmount}}€ ({{vm.listaDevoluciones.total.times}} dev.)<md-tooltip \nmd-direction=\"top\">{{-vm.listaDevoluciones.total.totalAmount / numStbs |roundDecimals: 2}}€/STB</md-tooltip></td><td \nclass=\"cortesy-td\">{{vm.listaCortesias.total.times}} cor.</td><td class=\"balance-td\">\n{{vm.listaRecargasFront.total.totalAmount}}€ ({{vm.listaRecargasFront.total.times}} op.)<md-tooltip md-direction=\"top\">\n{{vm.listaRecargasFront.total.totalAmount / numStbs |roundDecimals: 2}}€/STB</md-tooltip></td><td>\n{{suma(vm.listaOperacionesPaquetes.total.totalAmount, vm.listaOperacionesMandos.amount, vm.listaOperacionesVoip.total.virtualAmount, -vm.listaDevoluciones.total.totalAmount) | roundDecimals: 2}}€\n<md-tooltip md-direction=\"top\">\n{{suma(vm.listaOperacionesPaquetes.total.totalAmount, vm.listaOperacionesMandos.amount, vm.listaOperacionesVoip.total.virtualAmount, -vm.listaDevoluciones.total.totalAmount, numStbs) | roundDecimals: 2}}€/STB\n</md-tooltip></td></tr><tr><td translate=\"CONSUMO.MEDIADIARIA\">Media diaria</td><td \nng-repeat=\"pkg in vm.listaOperacionesPaquetes.total.packages\" ng-if=\"pkg.totalAmount > 0\">\n{{(pkg.totalAmount / vm.listaOperacionesPaquetes.eachDay.length)|roundDecimals: 2}}€/<span translate=\"CONSUMO.DIA\">dia\n</span><md-tooltip md-direction=\"bottom\">\n{{(pkg.totalAmount / vm.listaOperacionesPaquetes.eachDay.length)/numStbs|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span>*STB</md-tooltip></td><td ng-if=\"option === \'todos\' && JSONconfig.hayMandos\">\n{{(vm.listaOperacionesMandos.amount / vm.listaOperacionesPaquetes.eachDay.length)|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span><md-tooltip md-direction=\"bottom\">\n{{(vm.listaOperacionesMandos.amount / vm.listaOperacionesPaquetes.eachDay.length)/numStbs|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span>*STB</md-tooltip></td><td>\n{{(vm.listaOperacionesVoip.total.virtualAmount / vm.listaOperacionesVoip.eachDay.length)|abs|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span><md-tooltip md-direction=\"bottom\">\n{{(vm.listaOperacionesVoip.total.virtualAmount / vm.listaOperacionesVoip.eachDay.length)/numStbs|abs|roundDecimals: 2}}€/\n<span translate=\"CONSUMO.DIA\">dia</span>*STB</md-tooltip></td><td class=\"refund-td\">\n{{(-vm.listaDevoluciones.total.totalAmount / vm.listaDevoluciones.eachDay.length)|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span><md-tooltip md-direction=\"bottom\">\n{{(-vm.listaDevoluciones.total.totalAmount / vm.listaDevoluciones.eachDay.length)/numStbs|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span>*STB</md-tooltip></td><td class=\"cortesy-td\">\n{{(vm.listaCortesias.total.times / vm.listaDevoluciones.eachDay.length)|roundDecimals: 2}} cor./<span \ntranslate=\"CONSUMO.DIA\">dia</span></td><td class=\"balance-td\">\n{{(vm.listaRecargasFront.total.totalAmount / vm.listaRecargasFront.eachDay.length)|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span><md-tooltip md-direction=\"bottom\">\n{{(vm.listaRecargasFront.total.totalAmount / vm.listaRecargasFront.eachDay.length)/numStbs|roundDecimals: 2}}€/<span \ntranslate=\"CONSUMO.DIA\">dia</span>*STB</md-tooltip></td><td>\n{{suma(vm.listaOperacionesPaquetes.total.totalAmount, vm.listaOperacionesMandos.amount, vm.listaOperacionesVoip.total.virtualAmount, -vm.listaDevoluciones.total.totalAmount, vm.listaOperacionesPaquetes.eachDay.length) | roundDecimals: 2}}€/\n<span translate=\"CONSUMO.DIA\">dia</span><md-tooltip md-direction=\"bottom\">\n{{suma(vm.listaOperacionesPaquetes.total.totalAmount, vm.listaOperacionesMandos.amount, vm.listaOperacionesVoip.total.virtualAmount, -vm.listaDevoluciones.total.totalAmount, vm.listaOperacionesPaquetes.eachDay.length) / numStbs | roundDecimals: 2}}€/\n<span translate=\"CONSUMO.DIA\">dia</span>*STB</md-tooltip></td></tr></tbody></table></div><h4 ng-show=\"error\" \nstyle=\"color: red; text-align: center\" translate=\"CONSUMO.ERROR\">Error al recibir datos.</h4></div></md-content></div>\n</div>");
$templateCache.put("app/main/Quantion/gestionCompras/consumo/day.tmpl.html","<md-dialog id=\"contabilidad\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><md-progress-circular md-mode=\"indeterminate\" ng-show=\"loading\"></md-progress-circular><div \nlayout=\"column\"><md-list class=\"md-dense\" flex><md-subheader class=\"md-no-sticky md-accent-bg\"><span \ntranslate=\"CONSUMO.DAY.TOTALPAQUETES\">Total recaudado en paquetes:</span> {{reportPaquetes.totalAmount}}€\n</md-subheader><div class=\"pkgOper\" ng-repeat=\"pkg in reportPaquetes.packages\" on-last-repeat><md-list-item \nclass=\"md-2-line\"><img ng-src=\"{{pkg.logo|replacePath}}\" class=\"md-avatar\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{pkg.name|formatNameDesc}}</h3><p translate=\"CONSUMO.DAY.COMPRADO\" \ntranslate-values=\"{times:\'{{pkg.totalTimes}}\',amount:\'{{pkg.totalAmount}}\'}\">\nComprado: {{pkg.totalTimes}} veces - Recaudados {{pkg.totalAmount}}€</p></div></md-list-item><ul><li \nng-repeat=\"dur in pkg.duration|orderBy:\'seconds\'\" translate=\"CONSUMO.DAY.DURACION\" \ntranslate-values=\"{seconds:\'{{dur.seconds|convertMinutesInHHMMSS}}\',times:\'{{dur.times}}\',amount:\'{{dur.amount}}\'}\">\nDuración: {{dur.seconds|convertMinutesInHHMMSS}} - Comprado {{dur.times}} veces - Recaudación: {{dur.amount}}€</li>\n</ul></div></md-list><md-list class=\"md-dense\" flex ng-if=\"JSONconfig.hayMandos\"><md-subheader \nclass=\"md-no-sticky md-accent-bg\"><span translate=\"CONSUMO.DAY.TOTALMANDOS\">Total recaudado en mandos:</span>\n {{reportMandos.amount}}€</md-subheader><div class=\"pkgOper\" ng-repeat=\"caj in reportMandos.atm\" on-last-repeat>\n<md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{caj.model}}</h3><p \ntranslate=\"CONSUMO.DAY.COMPRADO\" translate-values=\"{times:\'{{caj.times}}\',amount:\'{{caj.amount}}\'}\">\nComprado: {{caj.times}} veces - Recaudados {{caj.amount}}€</p></div></md-list-item><ul><li \nng-repeat=\"oper in caj.details|orderBy:\'date\'\">{{oper.date|date:\'dd/MM/yy HH:mm\'}}: {{oper.amount}}€</li></ul></div>\n</md-list></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/consumo/list-operations.tmpl.html","<md-dialog id=\"contabilidad\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><md-progress-circular md-mode=\"indeterminate\" ng-show=\"loading\"></md-progress-circular><div \nlayout=\"column\" id=\"gestionCompras\"><md-list class=\"md-dense\" flex><md-subheader class=\"md-no-sticky md-accent-bg\">\n<span>{{title| translate}}</span> {{report.report.totalAmount}}€</md-subheader><md-list-item \nclass=\"md-3-line _{{oper.concept}}\" ng-repeat=\"oper in report.all\" on-last-repeat><div class=\"idAccountant\" \nlayout=\"column\"><md-icon md-font-icon=\"{{icons[oper.concept]}}\"></md-icon><span>{{oper.idAccountant}}<md-tooltip \nmd-direction=\"bottom\"><span translate=\"OPERACIONES.NUMOPERACION\">Nº de operación</span></md-tooltip></span></div>\n<ng-include src=\"oper.concept\" flex></ng-include></md-list-item></md-list></div></md-dialog-content></md-dialog><script\n type=\"text/ng-template\" id=\"Package\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-if=\"oper.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.PACKAGE.PAQUETECOMPRADO\'>Paquete comprado:</span> {{::oper.extendedConcept.snapshotPackage.name|formatNameDesc}} ({{::oper.extendedConcept.durationChosen|convertMinutesInHHMMSS}}/\n    <span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n\n    <div class=\"md-list-item-text\" layout=\"column\" ng-if=\"!oper.extendedConcept.snapshotPackage && oper.extendedConcept.snapshotAccountant\">\n    <h3>\n    [{{oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{oper.room}} - <span translate=\'OPERACIONES.PACKAGE.FINALIZADA\'>Finalizada la operación</span> {{oper.extendedConcept.snapshotAccountant.idAccountant}}\n    (<span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Service\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\"OPERACIONES.SERVICE.SERVICIOCORTESIA\">Servicio de cortesía</span> \'{{::oper.extendedConcept.snapshotContract[0].service.name|formatNameDesc}}\' ({{::((oper.extendedConcept.snapshotContract[0].end - oper.extendedConcept.snapshotContract[0].start) / 60000) | convertMinutesInHHMMSS}})</h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Cancellation\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.CANCELACION.CANCELACION\'>Cancelación de compra</span> - <span translate=\"OPERACIONES.CANCELACION.IMPORTEDEVUELTO\">Importe devuelto:</span> {{::oper.amount}}€ <span translate=\"OPERACIONES.CANCELACION.ENMETALICO\">en metálico</span>, {{::oper.virtualAmount|abs}}€ <span translate=\"OPERACIONES.CANCELACION.ENSALDO\">en saldo</span></h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Balance\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.BALANCE.RECARGADE\'>Recarga de saldo de</span> {{::(oper.extendedConcept.current - oper.extendedConcept.before)}}€ ({{::oper.extendedConcept.before}}€&RightArrow;{{::oper.extendedConcept.current}}€)</h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Refund\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-if=\"oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.REVOCACION.REVOCACIONPAQUETE\'>Revocación del paquete</span> \'{{::oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage.name|formatNameDesc}}\' ({{::oper.extendedConcept.snapshotAccountant.extendedConcept.durationChosen|convertMinutesInHHMMSS}} /\n    <span ng-if=\"oper.amount !== 0\">{{::oper.amount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n\n    <div class=\"md-list-item-text\" layout=\"column\" ng-if=\"!oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] Hab. {{::oper.room}} - <span translate=\'OPERACIONES.REVOCACION.REVOCACIONSALDO\'>Revocación de saldo</span> ({{::oper.amount|abs}}€)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"ChangeRoom\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] El usuario de la hab. {{::oper.room}} cambió del STB {{::oper.idStb}} al STB {{::(oper.extendedConcept.to||oper.extendedConcept.from)}}</h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Wallet\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] \n    <span ng-if=\"oper.idStb\"><span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - </span>\n    <span translate=\'OPERACIONES.WALLET.EXPEDIDA\' ng-if=\"oper.amount>0\">Expedida tarjeta con</span>\n    <span ng-if=\"oper.amount>0\">{{::oper.extendedConcept.balance.current}}€ + {{::oper.extendedConcept.deposit.current}}€ </span>\n    <span translate=\'OPERACIONES.WALLET.RECOGIDA\' ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current !== oper.extendedConcept.deposit.before)\">Recogida tarjeta con</span> \n    <span translate=\'OPERACIONES.WALLET.DEVOLUCION_SALDO\' ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current === oper.extendedConcept.deposit.before)\">Devuelto saldo de tarjeta: </span> \n    <span ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current !== oper.extendedConcept.deposit.before)\">{{::oper.extendedConcept.balance.before}}€ + {{::oper.extendedConcept.deposit.before}}€ </span>\n    <span ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current === oper.extendedConcept.deposit.before)\">{{::oper.extendedConcept.balance.before}}€</span>\n    <span translate=\"OPERACIONES.WALLET.FIANZA\" ng-if=\"oper.extendedConcept.deposit.current !== oper.extendedConcept.deposit.before\">Fianza</span></h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Voip\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] \n    <span ng-if=\"oper.idStb\"><span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - </span>\n    <span translate=\'OPERACIONES.VOIP.DESDE\'>Llamada desde</span><b>{{::oper.extendedConcept.snapshotCall.extension}}</b>\n    <span translate=\'OPERACIONES.VOIP.A\'>a</span> <b>{{::oper.extendedConcept.snapshotCall.destiny}}</b>\n    <span>({{::((oper.extendedConcept.snapshotCall.fin-oper.extendedConcept.snapshotCall.ini)/1000)|convertSeconds}} / {{::oper.virtualAmount|abs}}€)</span>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script>");
$templateCache.put("app/main/Quantion/gestionCompras/consumo_sin_precios/contabilidad.html","<div id=\"contabilidad-sin-precios\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content \nlayout-padding layout=\"column\"><div layout-padding><form name=\"BusquedaPaquetes\" novalidate layout=\"row\" \nlayout-xs=\"column\"><div flex><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" layout-xs=\"column\" flex \nlayout-wrap layout-align=\"start start\"><div class=\"md-block margin-right-32\" layout=\"column\"><label \ntranslate=\"CONSUMO_SIN_PRECIOS.FECHAINICIO\">Fecha de inicio</label><input type=\"date\" \nng-model=\"busquedaPaquetes.fromDate\" required></div><div class=\"md-block\" layout=\"column\"><label \ntranslate=\"CONSUMO_SIN_PRECIOS.FECHAFIN\">Fecha de fin</label><input type=\"date\" ng-model=\"busquedaPaquetes.toDate\" \nrequired></div></div></div><div><md-radio-group ng-model=\"option\" layout=\"row\" layout-xs=\"column\" \nstyle=\"margin: 20px 0\"><md-radio-button value=\"todos\"><span translate=\"CONSUMO_SIN_PRECIOS.TODOS\">Todos</span>\n</md-radio-button><md-radio-button value=\"individual\"><span translate=\"CONSUMO_SIN_PRECIOS.INDIVIDUAL\">Individual\n</span></md-radio-button><md-radio-button value=\"grupo\"><span translate=\"CONSUMO_SIN_PRECIOS.GRUPO\">Grupo</span>\n</md-radio-button></md-radio-group><fieldset style=\"margin-top: 20px\" ng-if=\"option === \'grupo\'\"><legend \ntranslate=\"CONSUMO_SIN_PRECIOS.GRUPOS\">Grupos</legend><md-checkbox ng-repeat=\"gr in vm.listaGrupos\" \nng-checked=\"gr.selected\" ng-click=\"toggle(gr)\">{{gr.nombre}} <span ng-if=\"gr.place\">({{gr.place}})</span></md-checkbox>\n</fieldset><fieldset style=\"margin-top: 20px\" ng-if=\"option === \'individual\'\"><legend><span \ntranslate=\"CONSUMO_SIN_PRECIOS.INDIVIDUAL\">Individual</span> <span style=\"font-size: 12px\" \ntranslate=\"CONSUMO_SIN_PRECIOS.PINCHARARRASTRAR\">(pinchar y arrastrar para seleccionar un rango)</span></legend>\n<md-checkbox ng-repeat=\"ind in vm.listaStbs\" ng-checked=\"ind.selected\" ng-click=\"toggle(ind)\" \nng-mousedown=\"saveIndex($index)\" ng-mouseup=\"selectRange($index)\" class=\"ind-checkbox\">{{ind.room}}</md-checkbox>\n</fieldset></div></div><div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.buscarOperacionesPaquetes()\" \nng-disabled=\"BusquedaPaquetes.$invalid || !vm.listaStbs\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"CONSUMO_SIN_PRECIOS.BUSCAROPERACIONES\">Buscar operaciones</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.resetFormPaquetes()\"><md-icon md-font-icon=\"icon-eraser\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"CONSUMO_SIN_PRECIOS.REINICIARCAMPOS\">Reiniciar campos\n</span></md-tooltip></md-button></div></form><span class=\"red-700-fg font-size-12\">\nBuscar más allá de 3 meses puede requerir más tiempo</span><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"loadingPaquetes\"></md-progress-linear><div layout=\"column\" ng-if=\"reportPaquetes\"><md-list class=\"md-dense\" \nflex><md-subheader class=\"md-no-sticky md-accent-bg\"><span translate=\"CONSUMO_SIN_PRECIOS.DAY.TOTALPAQUETES\">\nTotal recaudado en paquetes:</span></md-subheader><div class=\"pkgOper\" ng-repeat=\"pkg in reportPaquetes.packages\" \non-last-repeat><md-list-item class=\"md-2-line\"><img ng-src=\"{{pkg.logo|replacePath}}\" class=\"md-avatar\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{pkg.name|formatNameDesc}}</h3><p \ntranslate=\"CONSUMO_SIN_PRECIOS.DAY.COMPRADO\" translate-values=\"{times:\'{{pkg.totalTimes}}\'}\">\nComprado: {{pkg.totalTimes}} veces</p></div></md-list-item><ul><li ng-repeat=\"dur in pkg.duration|orderBy:\'seconds\'\" \ntranslate=\"CONSUMO_SIN_PRECIOS.DAY.DURACION\" \ntranslate-values=\"{seconds:\'{{dur.seconds|convertMinutesInHHMMSS}}\',times:\'{{dur.times}}\'}\">\nDuración: {{dur.seconds|convertMinutesInHHMMSS}} - Comprado {{dur.times}} veces</li></ul></div></md-list></div><h4 \nng-show=\"error\" style=\"color: red; text-align: center\" translate=\"CONSUMO_SIN_PRECIOS.ERROR\">Error al recibir datos.\n</h4></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/gestionCompras/consumo_sin_precios/day.tmpl.html","<md-dialog id=\"contabilidad\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><md-progress-circular md-mode=\"indeterminate\" ng-show=\"loading\"></md-progress-circular><div \nlayout=\"column\"><md-list class=\"md-dense\" flex><md-subheader class=\"md-no-sticky md-accent-bg\"><span \ntranslate=\"CONSUMO.DAY.TOTALPAQUETES\">Total recaudado en paquetes:</span> {{reportPaquetes.totalAmount}}€\n</md-subheader><div class=\"pkgOper\" ng-repeat=\"pkg in reportPaquetes.packages\" on-last-repeat><md-list-item \nclass=\"md-2-line\"><img ng-src=\"{{pkg.logo|replacePath}}\" class=\"md-avatar\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{pkg.name|formatNameDesc}}</h3><p translate=\"CONSUMO.DAY.COMPRADO\" \ntranslate-values=\"{times:\'{{pkg.totalTimes}}\',amount:\'{{pkg.totalAmount}}\'}\">\nComprado: {{pkg.totalTimes}} veces - Recaudados {{pkg.totalAmount}}€</p></div></md-list-item><ul><li \nng-repeat=\"dur in pkg.duration|orderBy:\'seconds\'\" translate=\"CONSUMO.DAY.DURACION\" \ntranslate-values=\"{seconds:\'{{dur.seconds|convertMinutesInHHMMSS}}\',times:\'{{dur.times}}\',amount:\'{{dur.amount}}\'}\">\nDuración: {{dur.seconds|convertMinutesInHHMMSS}} - Comprado {{dur.times}} veces - Recaudación: {{dur.amount}}€</li>\n</ul></div></md-list><md-list class=\"md-dense\" flex ng-if=\"JSONconfig.hayMandos\"><md-subheader \nclass=\"md-no-sticky md-accent-bg\"><span translate=\"CONSUMO.DAY.TOTALMANDOS\">Total recaudado en mandos:</span>\n {{reportMandos.amount}}€</md-subheader><div class=\"pkgOper\" ng-repeat=\"caj in reportMandos.atm\" on-last-repeat>\n<md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{caj.model}}</h3><p \ntranslate=\"CONSUMO.DAY.COMPRADO\" translate-values=\"{times:\'{{caj.times}}\',amount:\'{{caj.amount}}\'}\">\nComprado: {{caj.times}} veces - Recaudados {{caj.amount}}€</p></div></md-list-item><ul><li \nng-repeat=\"oper in caj.details|orderBy:\'date\'\">{{oper.date|date:\'dd/MM/yy HH:mm\'}}: {{oper.amount}}€</li></ul></div>\n</md-list></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/estado-comercial/estado-comercial.html","<div id=\"estado-comercial\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><table id=\"main-table\"><thead><tr><th class=\"column-title md-accent-bg\" \nng-class=\"{\'ord-no\':orderProp !== \'stb.room\', \'ord-asc\':orderProp === \'stb.room\' && !orderReverse, \'ord-desc\':orderProp === \'stb.room\' && orderReverse}\" \nng-click=\"sortBy(\'stb.room\')\">Hab.</th><th class=\"column-title md-accent-bg\" \nng-class=\"{\'ord-no\':orderProp !== \'services.tv.remainingTimeInMinutes\', \'ord-asc\':orderProp === \'services.tv.remainingTimeInMinutes\' && !orderReverse, \'ord-desc\':orderProp === \'services.tv.remainingTimeInMinutes\' && orderReverse}\" \nng-click=\"sortBy(\'services.tv.remainingTimeInMinutes\')\">Televisión</th><th class=\"column-title md-accent-bg\" \nng-class=\"{\'ord-no\':orderProp !== \'services.internet.remainingTimeInMinutes\', \'ord-asc\':orderProp === \'services.internet.remainingTimeInMinutes\' && !orderReverse, \'ord-desc\':orderProp === \'services.internet.remainingTimeInMinutes\' && orderReverse}\" \nng-click=\"sortBy(\'services.internet.remainingTimeInMinutes\')\">Internet</th><th class=\"column-title md-accent-bg\" \nng-class=\"{\'ord-no\':orderProp !== \'services.wifi.remainingTimeInMinutes\', \'ord-asc\':orderProp === \'services.wifi.remainingTimeInMinutes\' && !orderReverse, \'ord-desc\':orderProp === \'services.wifi.remainingTimeInMinutes\' && orderReverse}\" \nng-click=\"sortBy(\'services.wifi.remainingTimeInMinutes\')\">Wifi</th><th class=\"column-title md-accent-bg\" \nng-class=\"{\'ord-no\':orderProp !== \'group.nombre\', \'ord-asc\':orderProp === \'group.nombre\' && !orderReverse, \'ord-desc\':orderProp === \'group.nombre\' && orderReverse}\" \nng-click=\"sortBy(\'group.nombre\')\">Grupo</th></tr></thead><tbody></tbody></table></md-content></div></div>");
$templateCache.put("app/main/Quantion/gestionCompras/operaciones/gestionCompras.html","<div id=\"gestionCompras\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div layout=\"row\" layout-wrap><md-button class=\"md-fab md-mini\" ng-click=\"vm.nuevaCompra($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.NUEVAOPERACION\">Nueva operación</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.nuevaAsignacionServicio($event)\"><md-icon md-font-icon=\"icon-gift\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"OPERACIONES.ASIGNARSERVICIOCORTESIA\">Asignar servicio como cortesía\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.recargaSaldo($event)\"><md-icon \nmd-font-icon=\"icon-currency-eur\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.RECARGARSALDO\">Recargar saldo</span></md-tooltip></md-button><span flex hide-xs></span>\n<md-button class=\"md-raised md-warn\" ng-click=\"vm.exportar()\"><span translate=\"OPERACIONES.EXPORTARCSV\">Exportar CSV\n</span></md-button><a href=\"#\" id=\"link\" download=\"\" hidden></a></div><form name=\"Busqueda\" novalidate layout=\"row\" \nlayout-xs=\"column\"><div layout=\"row\" flex layout-wrap><div layout=\"column\" flex=\"50\" flex-xs=\"100\" flex-sm=\"65\">\n<md-radio-group ng-model=\"stbOrWallet\" layout=\"row\"><md-radio-button value=\"stb\" checked=\"checked\"><span \ntranslate=\"OPERACIONES.ISSTB\">Nº habitación</span></md-radio-button><md-radio-button value=\"wallet\"><span \ntranslate=\"OPERACIONES.ISWALLET\">ID de monedero virtual</span></md-radio-button></md-radio-group><md-autocomplete \nmd-input-name=\"autocompleteField\" md-input-minlength=\"0\" md-selected-item=\"busqueda.selectedStb\" \nmd-search-text=\"searchText\" md-items=\"item in vm.querySearch(searchText)|orderBy:\'room\'\" md-item-text=\"item.room\" \nmd-min-length=\"0\" md-require-match md-floating-label=\"{{\'OPERACIONES.STBID\'|translate}}\" md-no-cache=\"true\" \nmd-select-on-match=\"true\"><md-item-template><span md-highlight-text=\"searchText\">\n{{\'OPERACIONES.DISPLAYTEXT\'|translate:\"{room:\'\"+item.room+\"\',username:\'\"+item.username+\"\',balance:\'\"+(item.virtualBalance||item.personalBalance)+\"\'}\"}}\n</span></md-item-template></md-autocomplete></div><md-input-container class=\"md-block\" flex=\"25\" flex-xs=\"50\" \nflex-sm=\"35\"><label translate=\"OPERACIONES.NUMEROOPERACIONES\">Número de operaciones</label><md-select \nng-model=\"busqueda.limit\" name=\"limit\"><md-option ng-repeat=\"(key, value) in opcionesBusqueda.limites\" \nng-value=\"value\"><span translate=\"{{key}}\"></span></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"25\" flex-xs=\"50\" flex-sm=\"33\"><label translate=\"OPERACIONES.MODODEPAGO\">Modo de pago</label>\n<md-select ng-model=\"busqueda.payment\" name=\"payment\"><md-option ng-repeat=\"(key, value) in opcionesBusqueda.payment\" \nng-value=\"value\" class=\"{{value}}_\"><span translate=\"{{key}}\"></span></md-option></md-select></md-input-container><div \nlayout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"66\"><md-input-container class=\"md-block\"><label \ntranslate=\"OPERACIONES.INICIOBUSQUEDA\">Inicio de búsqueda</label><md-select ng-model=\"busqueda.check\" name=\"check\">\n<md-option ng-repeat=\"(key, value) in opcionesBusqueda.check\" ng-value=\"value\"><span translate=\"{{key}}\"></span>\n</md-option></md-select></md-input-container><div layout=\"column\" ng-if=\"busqueda.check === \'Date\'\"><label \nclass=\"hint\">Inicio</label><input type=\"date\" ng-model=\"busqueda.date\" max=\"{{opcionesBusqueda.maxDate}}\" required \nclass=\"margin-bottom-8\"><label class=\"hint\">Fin</label><input type=\"date\" ng-model=\"busqueda.until\" \nmin=\"{{busqueda.date}}\" max=\"{{opcionesBusqueda.maxDate}}\" required class=\"margin-bottom-8\"> <span \nclass=\"red-700-fg font-size-12\" ng-if=\"(TODAY - busqueda.date) > 7889400000\">\nBuscar más allá de 3 meses puede requerir más tiempo</span></div></div><md-input-container class=\"md-block\" flex=\"33\" \nflex-xs=\"50\" flex-sm=\"50\"><label translate=\"OPERACIONES.CANCELABLE\">Cancelable</label><md-select \nng-model=\"busqueda.revokable\" name=\"revokable\"><md-option ng-repeat=\"(key, value) in opcionesBusqueda.revokable\" \nng-value=\"value\"><span translate=\"{{key}}\"></span></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"33\" flex-xs=\"50\" flex-sm=\"50\"><label translate=\"OPERACIONES.TIPOOPERACION\">Tipo de operación\n</label><md-select ng-model=\"busqueda.concept\" name=\"concept\"><md-option \nng-repeat=\"(key, value) in opcionesBusqueda.concept\" ng-value=\"value\" class=\"_{{value}}\"><span translate=\"{{key}}\">\n</span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"33\" flex-xs=\"50\" \nflex-sm=\"50\"><label translate=\"OPERACIONES.PLACE\">Origen de la operación</label><md-select ng-model=\"busqueda.place\" \nname=\"place\"><md-option ng-repeat=\"(key, value) in opcionesBusqueda.places\" value=\"{{value}}\"><span \ntranslate=\"{{key}}\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"33\" \nflex-xs=\"50\" flex-sm=\"50\" ng-show=\"busqueda.place === \'Cajero\'\"><label translate=\"OPERACIONES.CAJERO\">Selecciona cajero\n</label><md-select ng-model=\"busqueda.extendedPlace\" name=\"extendedPlace\"><md-option ng-value=\"null\"></md-option>\n<md-option ng-repeat=\"atm in vm.listaCajeros\" value=\"{{atm.ip}}\"><span translate=\"{{atm.model}}\"></span></md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"33\" flex-xs=\"50\" flex-sm=\"50\" \nng-if=\"user.mapRole.actions.CONT_SEARCH_BY_USER\"><label translate=\"OPERACIONES.USUARIO\">Usuario</label><md-select \nng-model=\"busqueda.username\" name=\"username\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"us in vm.listaUsuarios\" value=\"{{us.name}}\">{{us.name}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.buscarOperaciones()\" ng-disabled=\"Busqueda.$invalid\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.BUSCAROPERACIONES\">Buscar operaciones</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.resetForm()\"><md-icon md-font-icon=\"icon-eraser\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"OPERACIONES.REINICIARCAMPOS\">Reiniciar campos</span></md-tooltip></md-button>\n</div></form><md-divider></md-divider><form name=\"BusquedaID\" layout=\"row\" class=\"md-warn-bg\" \nstyle=\"border-radius: 8px\"><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"OPERACIONES.BUSCARID\">Buscar por ID de operación</label><input type=\"number\" ng-model=\"busquedaID\" required>\n</md-input-container><md-button class=\"md-fab md-mini\" ng-click=\"vm.buscarPorID(busquedaID)\" ng-disabled=\"!busquedaID\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.BUSCAROPERACIONID\">Buscar operación</span></md-tooltip></md-button></form><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"loading\" class=\"margin-top-5\"></md-progress-linear><h3 \ntranslate=\"OPERACIONES.NUMOPERACIONES\" translate-values=\"{num: \'{{vm.listaOperaciones.length}}\'}\" \nng-show=\"vm.listaOperaciones\"></h3><h3 class=\"red-fg\" ng-show=\"error\">{{error}}</h3><div layout=\"column\"><md-list \nclass=\"md-dense\" flex><md-list-item class=\"md-3-line _{{oper.concept}}\" ng-repeat=\"oper in vm.listaOperaciones\" \non-last-repeat><div class=\"idAccountant\" layout=\"column\"><md-icon md-font-icon=\"{{icons[oper.concept]}}\"></md-icon>\n<span>{{oper.idAccountant}}<md-tooltip md-direction=\"bottom\"><span translate=\"OPERACIONES.NUMOPERACION\">Nº de operación\n</span></md-tooltip></span></div><ng-include src=\"oper.concept\" flex></ng-include><md-button class=\"md-fab md-mini\" \nng-click=\"vm.finishPendingOperation($event, oper)\" \nng-if=\"oper.policyDescription === \'TwoPending\' && oper.revokedBy === 0 && oper.policyType === \'Acquire\'\"><md-icon \nmd-font-icon=\"icon-bookmark-check\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.REGISTRARPAGOPENDIENTE\">Registrar pago de esta operación pendiente</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.abortPendingOperation($event, oper)\" \nng-if=\"oper.policyDescription === \'TwoPending\' && oper.revokedBy === 0 && oper.policyType === \'Acquire\'\"><md-icon \nmd-font-icon=\"icon-bookmark-remove\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.ABORTARPENDIENTE\">Abortar esta operación pendiente</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.revokeOperation($event, oper)\" \nng-if=\"oper.revokable && oper.policyType === \'Acquire\'\"><md-icon md-font-icon=\"icon-backup-restore\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"OPERACIONES.REVOCAROPERACION\">Revocar operación</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.finishPendingRevokation($event, oper)\" \nng-if=\"oper.policyDescription === \'TwoPending\' && oper.revokedBy === 0 && oper.policyType === \'Revoke\'\"><md-icon \nmd-font-icon=\"icon-bookmark-check\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.REGISTRARDEVOLUCIONPENDIENTE\">Registrar devolución pendiente</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.abortPendingRevokation($event, oper)\" \nng-if=\"oper.policyDescription === \'TwoPending\' && oper.revokedBy === 0 && oper.policyType === \'Revoke\'\"><md-icon \nmd-font-icon=\"icon-bookmark-remove\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.ABORTARDEVOLUCIONPENDIENTE\">Abortar devolución pendiente</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.reimprimirTicket($event, oper)\" \nng-if=\"oper.concept === \'Wallet\' || oper.concept === \'Balance\'\"><md-icon md-font-icon=\"icon-receipt\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"OPERACIONES.REIMPRIMIR\">Reimprimir ticket</span></md-tooltip>\n</md-button></md-list-item></md-list></div></md-content></div></div><script type=\"text/ng-template\" id=\"Package\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-if=\"oper.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.PACKAGE.PAQUETECOMPRADO\'>Paquete comprado:</span> {{::oper.extendedConcept.snapshotPackage.name|formatNameDesc}} ({{::oper.extendedConcept.durationChosen|convertMinutesInHHMMSS}}/\n    <span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n\n    <div class=\"md-list-item-text\" layout=\"column\" ng-if=\"!oper.extendedConcept.snapshotPackage && oper.extendedConcept.snapshotAccountant\">\n    <h3>\n    [{{oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{oper.room}} - <span translate=\'OPERACIONES.PACKAGE.FINALIZADA\'>Finalizada la operación</span> {{oper.extendedConcept.snapshotAccountant.idAccountant}}\n    (<span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Service\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\"OPERACIONES.SERVICE.SERVICIOCORTESIA\">Servicio de cortesía</span> \'{{::oper.extendedConcept.snapshotContract[0].service.name|formatNameDesc}}\' ({{::((oper.extendedConcept.snapshotContract[0].end - oper.extendedConcept.snapshotContract[0].start) / 60000) | convertMinutesInHHMMSS}})</h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Cancellation\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.CANCELACION.CANCELACION\'>Cancelación de compra</span> - <span translate=\"OPERACIONES.CANCELACION.IMPORTEDEVUELTO\">Importe devuelto:</span> {{::oper.amount}}€ <span translate=\"OPERACIONES.CANCELACION.ENMETALICO\">en metálico</span>, {{::oper.virtualAmount|abs}}€ <span translate=\"OPERACIONES.CANCELACION.ENSALDO\">en saldo</span></h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Balance\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.BALANCE.RECARGADE\'>Recarga de saldo de</span> {{::(oper.extendedConcept.current - oper.extendedConcept.before)}}€ ({{::oper.extendedConcept.before}}€&RightArrow;{{::oper.extendedConcept.current}}€)</h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Refund\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-if=\"oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.REVOCACION.REVOCACIONPAQUETE\'>Revocación del paquete</span> \'{{::oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage.name|formatNameDesc}}\' ({{::oper.extendedConcept.snapshotAccountant.extendedConcept.durationChosen|convertMinutesInHHMMSS}} /\n    <span ng-if=\"oper.amount !== 0\">{{::oper.amount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n\n    <div class=\"md-list-item-text\" layout=\"column\" ng-if=\"!oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] Hab. {{::oper.room}} - <span translate=\'OPERACIONES.REVOCACION.REVOCACIONSALDO\'>Revocación de saldo</span> ({{::oper.amount|abs}}€)\n    </h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"ChangeRoom\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] El usuario de la hab. {{::oper.room}} cambió del STB {{::oper.idStb}} al STB {{::(oper.extendedConcept.to||oper.extendedConcept.from)}}</h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Wallet\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] \n    <span ng-if=\"oper.idStb\"><span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - </span>\n    <span translate=\'OPERACIONES.WALLET.EXPEDIDA\' ng-if=\"oper.amount>0\">Expedida tarjeta con</span>\n    <span ng-if=\"oper.amount>0\">{{::oper.extendedConcept.balance.current}}€ + {{::oper.extendedConcept.deposit.current}}€ </span>\n    <span translate=\'OPERACIONES.WALLET.RECOGIDA\' ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current !== oper.extendedConcept.deposit.before)\">Recogida tarjeta con</span> \n    <span translate=\'OPERACIONES.WALLET.DEVOLUCION_SALDO\' ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current === oper.extendedConcept.deposit.before)\">Devuelto saldo de tarjeta: </span> \n    <span ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current !== oper.extendedConcept.deposit.before)\">{{::oper.extendedConcept.balance.before}}€ + {{::oper.extendedConcept.deposit.before}}€ </span>\n    <span ng-if=\"oper.amount<=0 && (oper.extendedConcept.deposit.current === oper.extendedConcept.deposit.before)\">{{::oper.extendedConcept.balance.before}}€</span>\n    <span translate=\"OPERACIONES.WALLET.FIANZA\" ng-if=\"oper.extendedConcept.deposit.current !== oper.extendedConcept.deposit.before\">Fianza</span></h3>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Voip\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] \n    <span ng-if=\"oper.idStb\"><span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - </span>\n    <span translate=\'OPERACIONES.VOIP.DESDE\'>Llamada desde</span><b>{{::oper.extendedConcept.snapshotCall.extension}}</b>\n    <span translate=\'OPERACIONES.VOIP.A\'>a</span> <b>{{::oper.extendedConcept.snapshotCall.destiny}}</b>\n    <span>({{::((oper.extendedConcept.snapshotCall.fin-oper.extendedConcept.snapshotCall.ini)/1000)|convertSeconds}} / {{::oper.virtualAmount|abs}}€)</span>\n    <h4 layout-xs=\"column\"><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span> <span>{{::oper.uuidVirtualWallet}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/cajeros.html","<div id=\"recaudacion\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div layout-padding><form name=\"BusquedaStbs\" novalidate layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\"><md-radio-group ng-model=\"searchMode\"><md-radio-button value=\"fecha\"><span \ntranslate=\"RECAUDACION.PORFECHA\">Por fecha</span></md-radio-button><md-radio-button value=\"arqueo\" \nng-disabled=\"!vm.listaAtm || vm.listaAtm.length === 0\"><span translate=\"RECAUDACION.PORCIERRE\">Por cierre contable\n</span></md-radio-button></md-radio-group><div layout-gt-sm=\"row\" layout=\"column\" layout-wrap \nng-if=\"searchMode === \'fecha\'\"><div class=\"md-block margin-right-8\" flex layout=\"column\"><label \ntranslate=\"RECAUDACION.FECHAINICIO\">Fecha de inicio</label><input type=\"date\" ng-model=\"busqueda.fromDate\" required>\n</div><div class=\"md-block\" flex layout=\"column\"><label translate=\"RECAUDACION.FECHAFIN\">Fecha de fin</label><input \ntype=\"date\" ng-model=\"busqueda.toDate\" required></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-wrap \nng-if=\"searchMode === \'arqueo\'\"><md-input-container style=\"padding-right: 1em\" flex><label \ntranslate=\"RECAUDACION.CAJERO\">Cajero</label><md-select ng-model=\"busqueda.atm\"><md-option \nng-repeat=\"caj in vm.listaAtm\" ng-value=\"caj\">{{caj.model}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"RECAUDACION.CIERRECONTABLE\">Cierre contable</label><md-select \nng-model=\"busqueda.idArqueo\" ng-disabled=\"!busqueda.atm\"><md-option \nng-repeat=\"arq in busqueda.atm.arqueoInzacard|orderBy:\'-apertura\'\" ng-value=\"arq.idArqueo\">\n{{arq.apertura|date:\'dd-MM-yyyy\'}} / {{arq.cierre|date:\'dd-MM-yyyy\'}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"obtenerReporte()\" \nng-disabled=\"BusquedaStbs.$invalid || !searchMode || (searchMode === \'arqueo\' && !busqueda.atm)\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"RECAUDACION.BUSCAROPERACIONES\">Buscar operaciones</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"resetForm()\"><md-icon md-font-icon=\"icon-eraser\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"RECAUDACION.REINICIARCAMPOS\">Reiniciar campos</span></md-tooltip></md-button>\n</div></form><span class=\"red-700-fg font-size-12\">Buscar más allá de 3 meses puede requerir más tiempo</span>\n<md-progress-linear md-mode=\"determinate\" value=\"{{(numRequestsFinished / numRequests) * 100}}\" \nng-show=\"numRequestsFinished < numRequests\"></md-progress-linear><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-around\" layout-wrap><table ng-show=\"vm.reporte.atm\"><tr><th colspan=\"4\" class=\"md-primary-bg\" \ntranslate=\"RECAUDACION.OPERACIONESADMIN\">Operaciones administrador</th></tr><tr><th class=\"md-accent-bg\"></th><th \nclass=\"md-accent-bg\" translate=\"RECAUDACION.RECARGAS\">Recargas</th><th class=\"md-accent-bg\" \ntranslate=\"RECAUDACION.DESCARGAS\">Descargas</th><th class=\"md-accent-bg\" translate=\"RECAUDACION.BALANCE\">Balance</th>\n</tr><tr ng-repeat=\"cajero in vm.reporte.atm\" on-last-repeat><td>{{cajero.model}}</td><td \nng-click=\"operationAdminDetails(cajero, \'Recarga\')\" class=\"specialTd\">{{cajero.totalUpload}}€</td><td \nng-click=\"operationAdminDetails(cajero, \'Descarga\')\" class=\"specialTd\">{{cajero.totalDownload}}€</td><td>\n{{(cajero.totalUpload - cajero.totalDownload)|roundDecimals:2}}€</td></tr><tr><td translate=\"RECAUDACION.TOTAL\">Total\n</td><td>{{vm.reporte.totalUpload}}€</td><td>{{vm.reporte.totalDownload}}€</td><td>\n{{(vm.reporte.totalUpload - vm.reporte.totalDownload)|roundDecimals:2}}€</td></tr></table><table \nng-show=\"vm.reporteClient.cash\"><tr><th colspan=\"4\" class=\"md-primary-bg\" translate=\"RECAUDACION.OPERACIONESMETALICO\">\nOperaciones clientes (Metálico)</th></tr><tr><th class=\"md-accent-bg\"></th><th class=\"md-accent-bg\" \ntranslate=\"RECAUDACION.INGRESOS\">Ingresos</th><th class=\"md-accent-bg\" translate=\"RECAUDACION.ABONOS\">Abonos</th><th \nclass=\"md-accent-bg\" translate=\"RECAUDACION.BALANCE\">Balance</th></tr><tr \nng-repeat=\"cajero in vm.reporteClient.cash.atm\" on-last-repeat><td>{{cajero.model}}</td><td \nng-click=\"operationClientesDetailsCash(cajero, \'In\')\" class=\"specialTd\">{{cajero.totalIn}}€</td><td \nng-click=\"operationClientesDetailsCash(cajero, \'Out\')\" class=\"specialTd\">{{cajero.totalOut}}€</td><td>\n{{cajero.totalBalance}}€</td></tr><tr><td translate=\"RECAUDACION.TOTAL\">Total</td><td>\n{{vm.reporteClient.cash.totalIn}}€</td><td>{{vm.reporteClient.cash.totalOut}}€</td><td>\n{{vm.reporteClient.cash.totalBalance}}€</td></tr></table><table ng-show=\"vm.reporteClient.card\"><tr><th colspan=\"4\" \nclass=\"md-primary-bg\" translate=\"RECAUDACION.OPERACIONESTARJETA\">Operaciones clientes (Tarjeta)</th></tr><tr><th \nclass=\"md-accent-bg\"></th><th class=\"md-accent-bg\" translate=\"RECAUDACION.FINALIZADAS\">Finalizadas</th><th \nclass=\"md-accent-bg\" translate=\"RECAUDACION.ABORTADAS\">Abortadas</th></tr><tr \nng-repeat=\"cajero in vm.reporteClient.card.atm\" on-last-repeat><td>{{cajero.model}}</td><td \nng-click=\"operationClientesDetailsCard(cajero, \'Yes\')\" class=\"specialTd\">{{cajero.amount.completed}}€</td><td \nng-click=\"operationClientesDetailsCard(cajero, \'No\')\" class=\"specialTd\">{{cajero.amount.uncompleted}}€</td></tr><tr><td\n translate=\"RECAUDACION.TOTAL\">Total</td><td>{{vm.reporteClient.card.total.completed}}€</td><td>\n{{vm.reporteClient.card.total.uncompleted}}€</td></tr></table><table ng-show=\"vm.reporteClient.free.atm.length > 0\">\n<tr><th colspan=\"4\" class=\"md-primary-bg\" translate=\"RECAUDACION.OPERACIONESGRATIS\">Operaciones clientes (Gratis)</th>\n</tr><tr><th class=\"md-accent-bg\"></th><th class=\"md-accent-bg\" translate=\"RECAUDACION.DISPENSAR\">Dispensar</th><th \nclass=\"md-accent-bg\" translate=\"RECAUDACION.PAGAR\">Pagar</th></tr><tr ng-repeat=\"cajero in vm.reporteClient.free.atm\" \non-last-repeat><td>{{cajero.model}}</td><td ng-click=\"operationClientesDetailsFree(cajero, \'dispensar\')\" \nclass=\"specialTd\">{{cajero.total.Dispensar.amount + 0}}€ ({{cajero.total.Dispensar.times + 0}} op.)</td><td \nng-click=\"operationClientesDetailsFree(cajero, \'pagar\')\" class=\"specialTd\">\n{{cajero.total.Pagar.amount + 0}}€ ({{cajero.total.Pagar.times + 0}} op.)</td></tr><tr><td \ntranslate=\"RECAUDACION.TOTAL\">Total</td><td>\n{{vm.reporteClient.free.total.Dispensar.amount + 0}}€ ({{vm.reporteClient.free.total.Dispensar.times + 0}} op.)</td>\n<td>{{vm.reporteClient.free.total.Pagar.amount + 0}}€ ({{vm.reporteClient.free.total.Pagar.times + 0}} op.)</td></tr>\n</table><table ng-show=\"vm.reporteClient.rc\" ng-if=\"JSONconfig.hayMandos\"><tr><th colspan=\"4\" class=\"md-primary-bg\" \ntranslate=\"RECAUDACION.OPERACIONESMANDOS\">Operaciones clientes (Mandos)</th></tr><tr><th class=\"md-accent-bg\"></th><th \nclass=\"md-accent-bg\" translate=\"RECAUDACION.DISPENSAR\">Dispensar</th><th class=\"md-accent-bg\" \ntranslate=\"RECAUDACION.RECOGER\">Recoger</th><th class=\"md-accent-bg\" translate=\"RECAUDACION.CUPONES\">Cupones</th></tr>\n<tr ng-repeat=\"cajero in vm.reporteClient.rc.atm\" on-last-repeat><td>{{cajero.model}}</td><td \nng-click=\"operationClientesDetailsRc(cajero, \'dispensar\')\" class=\"specialTd\">{{cajero.total.dispensar.amount}}€<br>\n({{cajero.total.dispensar.times}} op.)</td><td ng-click=\"operationClientesDetailsRc(cajero, \'recoger\')\" \nclass=\"specialTd\">{{cajero.total.recoger.amount}}€<br>({{cajero.total.recoger.times}} op.)</td><td \nng-click=\"operationClientesDetailsRc(cajero, \'cupones\')\" class=\"specialTd\">{{cajero.total.cupon.amount}}€<br>\n({{cajero.total.cupon.times}} op.)</td></tr><tr><td translate=\"RECAUDACION.TOTAL\">Total</td><td>\n{{vm.reporteClient.rc.total.dispensar.amount}}€<br>({{vm.reporteClient.rc.total.dispensar.times}} op.)</td><td>\n{{vm.reporteClient.rc.total.recoger.amount}}€<br>({{vm.reporteClient.rc.total.recoger.times}} op.)</td><td>\n{{vm.reporteClient.rc.total.cupon.amount}}€<br>({{vm.reporteClient.rc.total.cupon.times}} op.)</td></tr></table><table \nng-show=\"vm.reporteClient.paypal\"><tr><th colspan=\"2\" class=\"md-primary-bg\" translate=\"RECAUDACION.OPERACIONESPAYPAL\">\nOperaciones PayPal</th></tr><tr><td translate=\"OPERACIONES.BUSQUEDA.PLACE.STB\">Stb</td><td \nng-click=\"operationPaypalDetails(\'Stb\')\" class=\"specialTd\">\n{{vm.reporteClient.paypal.Stb.total.amount}}€ ({{vm.reporteClient.paypal.Stb.total.times}} op.)</td></tr><tr><td \ntranslate=\"OPERACIONES.BUSQUEDA.PLACE.TIENDAJOYCLINIC\">Tienda Joyclinic</td><td \nng-click=\"operationPaypalDetails(\'TiendaJoyclinic\')\" class=\"specialTd\">\n{{vm.reporteClient.paypal.TiendaJoyclinic.total.amount}}€ ({{vm.reporteClient.paypal.TiendaJoyclinic.total.times}} op.)\n</td></tr><tr><td>Front</td><td ng-click=\"operationPaypalDetails(\'Front\')\" class=\"specialTd\">\n{{vm.reporteClient.paypal.Front.total.amount}}€ ({{vm.reporteClient.paypal.Front.total.times}} op.)</td></tr><tr><td \ntranslate=\"RECAUDACION.TOTAL\">Total</td><td>\n{{vm.reporteClient.paypal.Stb.total.amount + vm.reporteClient.paypal.TiendaJoyclinic.total.amount + vm.reporteClient.paypal.Front.total.amount}}€ ({{vm.reporteClient.paypal.Stb.total.times + vm.reporteClient.paypal.TiendaJoyclinic.total.times + vm.reporteClient.paypal.Front.total.times}} op.)\n</td></tr></table><table ng-show=\"vm.reporteClient.papam\"><tr><th colspan=\"2\" class=\"md-primary-bg\" \ntranslate=\"RECAUDACION.OPERACIONESPAPAM\">Operaciones Papam</th></tr><tr><td translate=\"OPERACIONES.BUSQUEDA.PLACE.STB\">\nStb</td><td ng-click=\"operationPapamDetails(\'Stb\')\" class=\"specialTd\">\n{{vm.reporteClient.papam.Stb.total.amount}}€ ({{vm.reporteClient.papam.Stb.total.times}} op.)</td></tr><tr><td \ntranslate=\"OPERACIONES.BUSQUEDA.PLACE.TIENDAJOYCLINIC\">Tienda Joyclinic</td><td \nng-click=\"operationPapamDetails(\'TiendaJoyclinic\')\" class=\"specialTd\">\n{{vm.reporteClient.papam.TiendaJoyclinic.total.amount}}€ ({{vm.reporteClient.papam.TiendaJoyclinic.total.times}} op.)\n</td></tr><tr><td>Front</td><td ng-click=\"operationPapamDetails(\'Front\')\" class=\"specialTd\">\n{{vm.reporteClient.papam.Front.total.amount}}€ ({{vm.reporteClient.papam.Front.total.times}} op.)</td></tr><tr><td \ntranslate=\"RECAUDACION.TOTAL\">Total</td><td>\n{{vm.reporteClient.papam.Stb.total.amount + vm.reporteClient.papam.TiendaJoyclinic.total.amount + vm.reporteClient.papam.Front.total.amount}}€ ({{vm.reporteClient.papam.Stb.total.times + vm.reporteClient.papam.TiendaJoyclinic.total.times + vm.reporteClient.papam.Front.total.times}} op.)\n</td></tr></table></div></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion_completa/recaudacion_completa.html","<div id=\"recaudacion_completa\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div layout-padding><form name=\"BusquedaStbs\" novalidate layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\"><div layout-gt-sm=\"row\" layout=\"column\" layout-wrap><div \nclass=\"md-block margin-right-8\" flex layout=\"column\"><label translate=\"RECAUDACION.FECHAINICIO\">Fecha de inicio</label>\n<input type=\"date\" ng-model=\"busqueda.fromDate\" required></div><div class=\"md-block\" flex layout=\"column\"><label \ntranslate=\"RECAUDACION.FECHAFIN\">Fecha de fin</label><input type=\"date\" ng-model=\"busqueda.toDate\" required></div>\n</div><div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"obtenerReporte()\" \nng-disabled=\"BusquedaStbs.$invalid\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"RECAUDACION.BUSCAROPERACIONES\">Buscar operaciones</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"resetForm()\"><md-icon md-font-icon=\"icon-eraser\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"RECAUDACION.REINICIARCAMPOS\">Reiniciar campos</span></md-tooltip></md-button>\n</div></form><span class=\"red-700-fg font-size-12\">Buscar más allá de 3 meses puede requerir más tiempo</span>\n<md-progress-linear md-mode=\"determinate\" value=\"{{(numRequestsFinished / numRequests) * 100}}\" \nng-show=\"numRequestsFinished < numRequests\"></md-progress-linear><div layout=\"column\"><table \nng-repeat-start=\"atm in vm.informe\" ng-if=\"atm.arqueoInzacard.length > 0\"><tr><th colspan=\"2\" rowspan=\"2\" \nstyle=\"font-size: 150%\">{{atm.model}}</th><th colspan=\"3\">Entradas</th><th colspan=\"3\">Salidas</th></tr><tr><th \ncolspan=\"2\">Clientes</th><th>Admin</th><th colspan=\"2\">Clientes</th><th>Admin</th><th rowspan=\"2\">Desfase E/S</th><th \nrowspan=\"2\">Ingreso banco</th><th rowspan=\"2\">Recarga en apertura</th></tr><tr><th>Cierre contable</th><th>\nRemanente anterior</th><th>Saldo</th><th>Fianzas</th><th>Recargas</th><th>Abonos</th><th>Fianzas</th><th>Descargas</th>\n</tr><tr ng-repeat=\"arq in atm.arqueoInzacard\"><td>\n{{arq.apertura|date:\'dd-MM-yyyy\'}} / {{arq.cierre|date:\'dd-MM-yyyy\'}}</td><td>{{arq.atmAdmin.firstUpload.total}}</td>\n<td>{{arq.entradaClientesSaldo()}}</td><td>{{arq.deposits.acquire.amount}}</td><td>{{arq.entradaAdminRecargas()}}</td>\n<td>{{arq.salidaClientesAbonos()}}</td><td>{{arq.deposits.revoke.amount}}</td><td>{{arq.atmAdmin.totalDownload}}</td>\n<td>{{arq.desfase()}}</td><td>{{arq.ingresoBanco()}}</td><td>{{arq.recargaApertura()}}</td></tr></table><h2 \nng-repeat-end ng-if=\"atm.arqueoInzacard.length <= 0\" class=\"text-center text-uppercase red-700-fg\">\nNo hay cierres contables de {{atm.model}}</h2><table ng-if=\"vm.informe\"><tr><th colspan=\"2\" rowspan=\"2\" \nstyle=\"font-size: 150%\">Total</th><th colspan=\"3\">Entradas</th><th colspan=\"3\">Salidas</th></tr><tr><th colspan=\"2\">\nClientes</th><th>Admin</th><th colspan=\"2\">Clientes</th><th>Admin</th><th rowspan=\"2\">Desfase E/S</th><th rowspan=\"2\">\nIngreso banco</th><th rowspan=\"2\">Recarga en apertura</th></tr><tr><th>Cierre contable</th><th>Remanente anterior</th>\n<th>Saldo</th><th>Fianzas</th><th>Recargas</th><th>Abonos</th><th>Fianzas</th><th>Descargas</th></tr><tr><td>-</td><td>\n{{vm.informeTotal().atmAdmin.firstUpload.total}}</td><td>{{vm.informeTotal().entradaClientesSaldo}}</td><td>\n{{vm.informeTotal().deposits.acquire.amount}}</td><td>{{vm.informeTotal().entradaAdminRecargas}}</td><td>\n{{vm.informeTotal().salidaClientesAbonos}}</td><td>{{vm.informeTotal().deposits.revoke.amount}}</td><td>\n{{vm.informeTotal().atmAdmin.totalDownload}}</td><td>{{vm.informeTotal().desfase}}</td><td>\n{{vm.informeTotal().ingresoBanco}}</td><td>{{vm.informeTotal().recargaApertura}}</td></tr></table></div><md-button \nclass=\"md-raised md-primary\" ng-click=\"exportarCSV()\" ng-if=\"vm.informe\" \nng-disabled=\"numRequestsFinished < numRequests\">Exportar</md-button></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion_simple/recaudacion_simple.html","<div id=\"recaudacion\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div><h3>\nInicio: {{busqueda.fromDate| date: \'dd/MM/yyyy\'}} - Fin: {{busqueda.toDate| date: \'dd/MM/yyyy\'}}</h3>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"loading\"></md-progress-linear><table \nng-if=\"vm.reporte && !loading\"><tr><th colspan=\"4\" class=\"md-primary-bg\" translate=\"RECAUDACION.OPERACIONESADMIN\">\nOperaciones administrador</th></tr><tr><th class=\"md-accent-bg\"></th><th class=\"md-accent-bg\" \ntranslate=\"RECAUDACION.RECARGAS\">Recargas</th><th class=\"md-accent-bg\" translate=\"RECAUDACION.DESCARGAS\">Descargas</th>\n<th class=\"md-accent-bg\" translate=\"RECAUDACION.BALANCE\">Balance</th></tr><tr ng-repeat=\"cajero in vm.reporte.atm\" \non-last-repeat><td>{{cajero.model}}</td><td ng-click=\"operationAdminDetails(cajero, \'Recarga\')\" class=\"specialTd\">\n{{cajero.totalUpload}}€</td><td ng-click=\"operationAdminDetails(cajero, \'Descarga\')\" class=\"specialTd\">\n{{cajero.totalDownload}}€</td><td>{{(cajero.totalUpload - cajero.totalDownload)|roundDecimals:2}}€</td></tr><tr><td \ntranslate=\"RECAUDACION.TOTAL\">Total</td><td>{{vm.reporte.totalUpload}}€</td><td>{{vm.reporte.totalDownload}}€</td><td>\n{{(vm.reporte.totalUpload - vm.reporte.totalDownload)|roundDecimals:2}}€</td></tr></table></div></md-content></div>\n</div>");
$templateCache.put("app/main/Quantion/habitaciones/aps/aps.html","<div id=\"puntos-de-acceso\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\" md-whiteframe=\"4\"><input type=\"file\" id=\"files\" \naria-label=\"Seleccionar archivo\" hidden><md-tabs class=\"md-accent\" md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"APS.STBS\">Equipos</span></md-tab-label><md-tab-body><div layout=\"row\" layout-align=\"start center\"><h4>\nSelecciona un grupo</h4><md-select ng-model=\"grupoSeleccionado\"><md-option ng-repeat=\"grupo in listaGrupos\" \nng-value=\"{{grupo}}\"><span ng-if=\"grupo.place\">{{grupo.place}} - </span>{{grupo.nombre}} ({{grupo.stbs.length}})\n</md-option></md-select><md-button class=\"md-fab md-mini\" ng-click=\"getAllUptimes(grupoSeleccionado)\" \naria-label=\"uptime all\" ng-disabled=\"!grupoSeleccionado\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate=\"APS.BUSCAR\">Consultar datos</span></md-tooltip></md-button><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"90\" ng-if=\"loading\"></md-progress-circular></div><md-divider></md-divider><div \nlayout=\"row\"><div class=\"tag activo\" translate=\"APS.TAGS.ACTIVO\">Encendido</div><div class=\"tag inactivo\" \ntranslate=\"APS.TAGS.INACTIVO\">Apagado</div><div class=\"tag desconocido\" translate=\"APS.TAGS.DESCONOCIDO\">\nDesconocido (sin última conexión)</div></div><div layout=\"row\"><div class=\"tag verde\" translate=\"APS.TAGS.COINCIDE\">\nCoincide el AP asignado y el AP conectado</div><div class=\"tag amarillo\" translate=\"APS.TAGS.NOCOINCIDE\">\nNo coincide el AP asignado y el AP conectado</div><div class=\"tag gris\" translate=\"APS.TAGS.NODATOS\">\nNo se pueden obtener los datos del AP conectado</div></div><div style=\"width: 100%; overflow-x: auto\"><table \nng-if=\"stbs\"><tr><th class=\"column-title\"><span translate=\"LISTADO_STB.HEADERS.IDHAB\">ID hab.</span></th><th \nclass=\"column-title\"><span translate=\"LISTADO_STB.HEADERS.CLIENTE\">Cliente</span></th><th class=\"column-title\"><span \ntranslate=\"LISTADO_STB.HEADERS.IP\">IP</span></th><th class=\"column-title\"><span translate=\"LISTADO_STB.HEADERS.MAC\">MAC\n</span></th><th class=\"column-title\"><span translate=\"APS.APASIGNADO\">PA asignado</span></th><th class=\"column-title\">\n<span translate=\"APS.APCONECTADO\"></span></th><th class=\"column-title\"><span translate=\"APS.SIGNAL\"></span></th><th>\nWallet BD / Equipo</th><th></th></tr><tr ng-repeat=\"hab in stbs| orderBy: \'room|tryParseInt\' track by $index\" \non-last-repeat \nclass=\"{{(hab.status !== \'activo\') ? \'gris\' : \'\'}} {{(hab.properties.wifiAp.bssid.toLowerCase() === hab.uptime.ap.toLowerCase()) ? \'verde\' : \'amarillo\'}}\">\n<td class=\"{{hab.status}}\">{{hab.room}}</td><td>{{(hab.check.type !== \'In\') ? \'\' : hab.username}}</td><td>{{ hab.ip}}\n</td><td>{{ hab.mac | uppercase}}</td><td>{{hab.properties.wifiAp.name}} ({{hab.properties.wifiAp.bssid}})</td><td>\n{{vm.mapAps[hab.uptime.ap.toLowerCase()].name}} ({{hab.uptime.ap}})</td><td>{{hab.uptime.signal}}</td><td \nng-style=\"{\'background-color\': (hab.uptime.wallet && (hab.wallet.identifier !== hab.uptime.wallet)) ? \'red\' : \'green\'}\">\n({{hab.wallet.type}}) {{hab.wallet.identifier}} / {{hab.uptime.wallet}}</td><td><div layout=\"row\" layout-align=\"end\">\n<md-button class=\"md-fab md-mini\" ng-click=\"cambiarAp(hab)\" aria-label=\"editar ap\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"APS.CAMBIARAP\">Cambiar punto de acceso</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"getUptime(hab)\" aria-label=\"uptime\"><md-icon \nmd-font-icon=\"icon-radio-tower\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"APS.RECONSULTAR\">\nVolver a consultar</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"reiniciarStb(hab, $event)\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"LISTADO_STB.BOTONESSTB.REINICIO\">Reiniciar STB</span></md-tooltip></md-button></div></td></tr></table>\n</div></md-tab-body></md-tab><md-tab><md-tab-label>Puntos de acceso</md-tab-label><md-tab-body><div layout=\"row\" \nlayout-wrap><md-button class=\"md-fab md-mini\" ng-click=\"nuevoAP()\" aria-label=\"add AP\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"APS.NUEVO\">Nuevo punto de acceso\n</span></md-tooltip></md-button><md-menu><md-button class=\"md-fab md-mini md-orange-600-bg\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"showApRuckusEvents()\"><md-icon \nmd-font-icon=\"icon-calendar-text\" md-menu-align-target></md-icon><span translate=\"APS.EVENTS\">Eventos</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusAlarms()\"><md-icon md-font-icon=\"icon-alert\" \nmd-menu-align-target></md-icon><span translate=\"APS.ALARMS\">Alarmas</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"importApsFromRuckus()\"><md-icon md-font-icon=\"icon-import\" md-menu-align-target></md-icon><span \ntranslate=\"APS.IMPORTAR_RUCKUS\">Importar desde Ruckus</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"importarArchivo()\"><md-icon md-font-icon=\"icon-file\" md-menu-align-target></md-icon><span \ntranslate=\"APS.IMPORTAR\">Importar desde archivo</span></md-button></md-menu-item></md-menu-content></md-menu></div><div\n layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"center center\" class=\"buscador\">\n<div layout=\"row\" layout-align=\"center center\" class=\"md-primary-bg\"><div><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></div><md-input-container class=\"md-block\"><input ng-model=\"search\" ng-model-options=\"{debounce: 500}\" \nng-change=\"filterAps()\" aria-label=\"search\"></md-input-container><span style=\"margin-left: 3px;margin-right: 8px\">\n({{filtered.length}})</span></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" ng-click=\"currentPage = 0\">&LeftArrowBar;\n</md-button><md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" \nng-click=\"currentPage = currentPage - 1\">&LeftArrow;</md-button><span><span translate=\"WALLETS.PAGINA\">Pág.</span>\n{{currentPage + 1}} / {{numberOfPages()}}</span><md-button class=\"md-raised md-primary pagination-button\" \nng-disabled=\"(currentPage + 1) >= numberOfPages()\" ng-click=\"currentPage = currentPage + 1\">&RightArrow;</md-button>\n<md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"(currentPage + 1) >= numberOfPages()\" \nng-click=\"currentPage = (numberOfPages() - 1)\">&RightArrowBar;</md-button></div><div><span translate=\"VOIP.MOSTRAR\">\nMostrar</span><md-input-container><md-select ng-model=\"pageSize\" aria-label=\"mostrar\"><md-option ng-value=\"v\" \nng-repeat=\"v in [5, 10, 25]\">{{v}}</md-option></md-select></md-input-container></div></div><table \nng-if=\"vm.puntosAcceso\"><tr><th class=\"column-title\"><span translate=\"APS.NAME\">Nombre</span></th><th \nclass=\"column-title\"><span translate=\"APS.ESSID\">ESSID</span></th><th class=\"column-title\"><span translate=\"APS.BSSID\">\nBSSID</span></th><th class=\"column-title\"><span translate=\"APS.BANDA\">Banda</span></th><th class=\"column-title\"><span \ntranslate=\"APS.HIDDEN\">Oculta</span></th><th class=\"column-title\"><span translate=\"APS.STATUS\">Estado</span></th><th>\n</th></tr><tr \nng-repeat=\"ap in filtered|orderBy:[\'name\', \'band\']| startFrom:currentPage * pageSize | limitTo:pageSize track by $index\" \non-last-repeat><td>{{ap.name}}</td><td>{{ap.essid}}</td><td>{{ap.bssid}}</td><td>{{ap.band}}</td><td \ntranslate=\"APS.HIDDEN_{{ap.hidden}}\">{{ap.hidden}}</td><td><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"40\" ng-if=\"loadingRuckus\" style=\"margin: auto\"></md-progress-circular><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"ap.ruckus\"><md-icon md-font-icon=\"icon-check\" \nng-if=\"ap.ruckus.more.status === \'Online\'\" class=\"green-700-fg\"></md-icon><md-icon md-font-icon=\"icon-flag-variant\" \nng-if=\"ap.ruckus.more.status === \'Flagged\'\" class=\"orange-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-if=\"ap.ruckus.more.status === \'Offline\'\" class=\"red-700-fg\"></md-icon><span\n class=\"margin-horizontal-5\">{{ap.ruckus.more.status}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nng-click=\"showApRuckusInfo(ap)\" style=\"cursor: pointer\"></md-icon></div></td><td><div layout=\"row\" layout-align=\"end\">\n<md-button class=\"md-fab md-mini md-primary\" ng-click=\"completarParejaAP(ap, \'B_5_GHZ\')\" aria-label=\"update AP\" \nng-show=\"ap.band === \'B_2_GHZ\' && !registeredAPs[\'B_5_GHZ\'][ap.name]\"><md-icon \nmd-font-icon=\"icon-numeric-5-box-outline\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"APS.CREAR5\">\nCrear un AP de 5GHz a partir de este</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-click=\"completarParejaAP(ap, \'B_2_GHZ\')\" aria-label=\"update AP\" \nng-show=\"ap.band === \'B_5_GHZ\' && !registeredAPs[\'B_2_GHZ\'][ap.name]\"><md-icon \nmd-font-icon=\"icon-numeric-2-box-outline\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"APS.CREAR2\">\nCrear un AP de 2.4GHz a partir de este</span></md-tooltip></md-button><md-menu ng-if=\"ap.ruckus\"><md-button \nclass=\"md-fab md-mini md-orange-600-bg\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"showApRuckusEvents(ap)\"><md-icon md-font-icon=\"icon-calendar-text\" md-menu-align-target></md-icon><span \ntranslate=\"APS.EVENTS\">Eventos</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"showApRuckusAlarms(ap)\"><md-icon md-font-icon=\"icon-alert\" md-menu-align-target></md-icon><span \ntranslate=\"APS.ALARMS\">Alarmas</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"rebootAP($event, ap)\"><md-icon md-font-icon=\"icon-refresh\" md-menu-align-target></md-icon><span \ntranslate=\"APS.REBOOT\">Reiniciar</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-fab md-mini\" ng-click=\"editarAP(ap)\" aria-label=\"update AP\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"APS.EDITAR\">Editar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminarAP($event, ap)\" aria-label=\"delete AP\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"APS.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</div></td></tr></table></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion_v/recaudacion_v.html","<div id=\"recaudacion_v\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div layout-padding><form name=\"BusquedaStbs\" novalidate layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between start\"><div layout-gt-sm=\"row\" layout=\"column\" layout-wrap><div \nclass=\"md-block margin-right-8\" flex layout=\"column\"><label translate=\"RECAUDACION_V.FECHAINICIO\">Fecha de inicio\n</label><input type=\"date\" ng-model=\"busqueda.fromDate\" required></div><div class=\"md-block\" flex layout=\"column\">\n<label translate=\"RECAUDACION_V.FECHAFIN\">Fecha de fin</label><input type=\"date\" ng-model=\"busqueda.toDate\" required>\n</div></div><div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"obtenerReporte()\" \nng-disabled=\"BusquedaStbs.$invalid || loading\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"RECAUDACION_V.BUSCAROPERACIONES\">Buscar operaciones</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"resetForm()\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"RECAUDACION_V.REINICIARCAMPOS\">Reiniciar campos</span></md-tooltip>\n</md-button></div></form><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-around\" layout-wrap><table \nng-show=\"vm.reporte.total.atm\"><tr><th colspan=\"2\" class=\"md-primary-bg\" translate=\"RECAUDACION_V.OPERACIONESCAJEROS\">\nOperaciones Cajeros</th></tr><tr><td translate=\"RECAUDACION_V.OPERACIONESMETALICO\">Metálico</td><td \nng-click=\"operationDetails(\'atm\', \'cash\')\" class=\"specialTd\">{{vm.reporte.total.atm.cash.balance}}€</td></tr><tr><td \ntranslate=\"RECAUDACION_V.OPERACIONESTARJETA\">Tarjeta</td><td ng-click=\"operationDetails(\'atm\', \'card\')\" \nclass=\"specialTd\">{{vm.reporte.total.atm.card.balance}}€</td></tr><tr><td translate=\"RECAUDACION_V.TOTAL\">Total</td>\n<td>{{vm.reporte.total.total.atm.balance}}€</td></tr></table><table ng-show=\"vm.reporte.total.paypal\"><tr><th \ncolspan=\"2\" class=\"md-primary-bg\" translate=\"RECAUDACION_V.OPERACIONESPAYPAL\">Operaciones PayPal</th></tr><tr><td \ntranslate=\"OPERACIONES.BUSQUEDA.PLACE.STB\">Stb</td><td ng-click=\"operationDetails(\'paypal\', \'stb\')\" class=\"specialTd\">\n{{vm.reporte.total.paypal.stb.balance}}€</td></tr><tr><td translate=\"OPERACIONES.BUSQUEDA.PLACE.TIENDAJOYCLINIC\">\nTienda Joyclinic</td><td ng-click=\"operationDetails(\'paypal\', \'tiendaJoyclinic\')\" class=\"specialTd\">\n{{vm.reporte.total.paypal.tiendaJoyclinic.balance}}€</td></tr><tr><td>Front</td><td \nng-click=\"operationDetails(\'paypal\', \'front\')\" class=\"specialTd\">{{vm.reporte.total.paypal.front.balance}}€</td></tr>\n<tr><td translate=\"RECAUDACION_V.TOTAL\">Total</td><td>{{vm.reporte.total.total.paypal.balance}}€</td></tr></table>\n<table ng-show=\"vm.reporte.total.card\"><tr><th colspan=\"2\" class=\"md-primary-bg\" \ntranslate=\"RECAUDACION_V.OPERACIONESPAPAM\">Operaciones Papam</th></tr><tr><td \ntranslate=\"OPERACIONES.BUSQUEDA.PLACE.STB\">Stb</td><td ng-click=\"operationDetails(\'card\', \'stb\')\" class=\"specialTd\">\n{{vm.reporte.total.card.stb.balance}}€</td></tr><tr><td translate=\"OPERACIONES.BUSQUEDA.PLACE.TIENDAJOYCLINIC\">\nTienda Joyclinic</td><td ng-click=\"operationDetails(\'card\', \'tiendaJoyclinic\')\" class=\"specialTd\">\n{{vm.reporte.total.card.tiendaJoyclinic.balance}}€</td></tr><tr><td>Front</td><td \nng-click=\"operationDetails(\'card\', \'front\')\" class=\"specialTd\">{{vm.reporte.total.card.front.balance}}€</td></tr><tr>\n<td translate=\"RECAUDACION_V.TOTAL\">Total</td><td>{{vm.reporte.total.total.card.balance}}€</td></tr></table></div><h1 \nclass=\"md-accent-fg\" ng-if=\"vm.reporte\"><span translate=\"RECAUDACION_V.TOTAL_TOTAL\"></span>\n {{vm.reporte.total.total.atm.balance + vm.reporte.total.total.paypal.balance + vm.reporte.total.total.card.balance}}€\n</h1></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/habitaciones/listado/listado.html","<div id=\"listadoHabitaciones\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div><div layout=\"row\" layout-align=\"start center\" layout-wrap><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaNuevo($event)\" ng-if=\"user.mapRole.actions.CREATE_EDIT_STB\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO_STB.BOTONES.ADD\">Añadir</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.CargarStbs()\"><md-icon md-font-icon=\"icon-rotate-3d\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO_STB.BOTONES.REFRESCAR\">Refrescar datos</span>\n</md-tooltip></md-button></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" \nlayout-align-xs=\"center center\" class=\"buscador\"><div layout=\"row\" layout-align=\"center center\" class=\"md-primary-bg\">\n<div><md-icon md-font-icon=\"icon-magnify\"></md-icon></div><md-input-container class=\"md-block\"><input \nng-model=\"search\" ng-model-options=\"{debounce: 500}\" ng-change=\"filterStbs()\" aria-label=\"search\"></md-input-container>\n<span>({{filtered.length}})</span><div><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"vm.tableProperties()\">\n</md-icon></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" ng-click=\"currentPage = 0\">&LeftArrowBar;\n</md-button><md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" \nng-click=\"currentPage = currentPage - 1\">&LeftArrow;</md-button><span><span translate=\"WALLETS.PAGINA\">Pág.</span>\n{{currentPage + 1}} / {{numberOfPages()}}</span><md-button class=\"md-raised md-primary pagination-button\" \nng-disabled=\"(currentPage + 1) >= numberOfPages()\" ng-click=\"currentPage = currentPage + 1\">&RightArrow;</md-button>\n<md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"(currentPage + 1) >= numberOfPages()\" \nng-click=\"currentPage = (numberOfPages() - 1)\">&RightArrowBar;</md-button></div><div><span translate=\"VOIP.MOSTRAR\">\nMostrar</span><md-input-container><md-select ng-model=\"pageSize\" aria-label=\"mostrar\"><md-option ng-value=\"v\" \nng-repeat=\"v in [5, 10, 25]\">{{v}}</md-option></md-select></md-input-container><md-input-container><md-select \nng-model=\"filtroEstado\" ng-change=\"filterStbs()\" aria-label=\"estado\"><md-option ng-value=\"v\" \nng-repeat=\"v in [\'\', \'Activo\', \'Inactivo\', \'Boton\', \'Desconocido\']\"><span translate=\"LISTADO_STB.FILTROESTADO.{{v}}\">\n{{v}}</span></md-option></md-select></md-input-container></div></div></div><div style=\"width: 100%; overflow-x: auto\">\n<table><tr><th ng-show=\"vm.tableOptions[\'showChecks\']\"><md-menu><md-button aria-label=\"menu seleccion\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"marcar(filtered, true)\">\nMarcar todos (filtrados)</md-button></md-menu-item><md-menu-item><md-button ng-click=\"marcar(filtered, false)\">\nDesmarcar todos (filtrados)</md-button></md-menu-item><md-menu-item><md-button ng-click=\"marcar(null)\">Desmarcar todos\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ui-sref=\"app.Quantion_lotes\">\nIr a acciones por lotes</md-button></md-menu-item></md-menu-content></md-menu></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'room|tryParseInt\', \'ord-asc\':orderProp === \'room|tryParseInt\' && !orderReverse, \'ord-desc\':orderProp === \'room|tryParseInt\' && orderReverse}\" \nng-click=\"sortBy(\'room|tryParseInt\')\" ng-show=\"vm.tableOptions[\'room\']\"><span translate=\"LISTADO_STB.HEADERS.IDHAB\">\nID hab.</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'username\', \'ord-asc\':orderProp === \'username\' && !orderReverse, \'ord-desc\':orderProp === \'username\' && orderReverse}\" \nng-click=\"sortBy(\'username\')\" ng-show=\"vm.tableOptions[\'username\']\"><span translate=\"LISTADO_STB.HEADERS.CLIENTE\">\nCliente</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'ip\', \'ord-asc\':orderProp === \'ip\' && !orderReverse, \'ord-desc\':orderProp === \'ip\' && orderReverse}\" \nng-click=\"sortBy(\'ip\')\" ng-show=\"vm.tableOptions[\'ip\']\"><span translate=\"LISTADO_STB.HEADERS.IP\">IP</span></th><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'mac\', \'ord-asc\':orderProp === \'mac\' && !orderReverse, \'ord-desc\':orderProp === \'mac\' && orderReverse}\" \nng-click=\"sortBy(\'mac\')\" ng-show=\"vm.tableOptions[\'mac\']\"><span translate=\"LISTADO_STB.HEADERS.MAC\">MAC</span></th><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'extension\', \'ord-asc\':orderProp === \'extension\' && !orderReverse, \'ord-desc\':orderProp === \'extension\' && orderReverse}\" \nng-click=\"sortBy(\'extension\')\" ng-show=\"vm.tableOptions[\'extension\']\"><span translate=\"LISTADO_STB.HEADERS.EXTENSION\">\nExtensión VOIP</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'lang\', \'ord-asc\':orderProp === \'lang\' && !orderReverse, \'ord-desc\':orderProp === \'lang\' && orderReverse}\" \nng-click=\"sortBy(\'lang\')\" ng-show=\"vm.tableOptions[\'lang\']\"><span translate=\"LISTADO_STB.HEADERS.IDIOMA\">Idioma</span>\n</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'typeWallet\', \'ord-asc\':orderProp === \'typeWallet\' && !orderReverse, \'ord-desc\':orderProp === \'typeWallet\' && orderReverse}\" \nng-click=\"sortBy(\'typeWallet\')\" ng-show=\"JSONconfig.sistemaDePago && vm.tableOptions[\'wallet\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.MONEDEROVIRTUAL\">Monedero virtual</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'balance\', \'ord-asc\':orderProp === \'balance\' && !orderReverse, \'ord-desc\':orderProp === \'balance\' && orderReverse}\" \nng-click=\"sortBy(\'balance\')\" ng-show=\"JSONconfig.sistemaDePago && vm.tableOptions[\'balance\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.SALDO\">Saldo</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'services\', \'ord-asc\':orderProp === \'services\' && !orderReverse, \'ord-desc\':orderProp === \'services\' && orderReverse}\" \nng-click=\"sortBy(\'services\')\" ng-show=\"JSONconfig.sistemaDePago && vm.tableOptions[\'services\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.SERVICIOS\">Servicios contratados</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'installation\', \'ord-asc\':orderProp === \'installation\' && !orderReverse, \'ord-desc\':orderProp === \'installation\' && orderReverse}\" \nng-click=\"sortBy(\'installation\')\" ng-show=\"vm.tableOptions[\'installation\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.INSTALACION\">Instalación</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'theme\', \'ord-asc\':orderProp === \'theme\' && !orderReverse, \'ord-desc\':orderProp === \'theme\' && orderReverse}\" \nng-click=\"sortBy(\'theme\')\" ng-show=\"vm.tableOptions[\'theme\']\"><span translate=\"LISTADO_STB.HEADERS.TEMA\">Tema</span>\n</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'model\', \'ord-asc\':orderProp === \'model\' && !orderReverse, \'ord-desc\':orderProp === \'model\' && orderReverse}\" \nng-click=\"sortBy(\'model\')\" ng-show=\"vm.tableOptions[\'model\']\"><span translate=\"LISTADO_STB.HEADERS.MODELO\">Modelo\n</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'wifiAp\', \'ord-asc\':orderProp === \'wifiAp\' && !orderReverse, \'ord-desc\':orderProp === \'wifiAp\' && orderReverse}\" \nng-click=\"sortBy(\'wifiAp\')\" ng-show=\"vm.tableOptions[\'wifiAp\']\"><span translate=\"LISTADO_STB.HEADERS.WIFIAP\">\nPunto de acceso WiFi</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'lastDynamic\', \'ord-asc\':orderProp === \'lastDynamic\' && !orderReverse, \'ord-desc\':orderProp === \'lastDynamic\' && orderReverse}\" \nng-click=\"sortBy(\'lastDynamic\')\" ng-show=\"vm.tableOptions[\'lastDynamic\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.IMGLAST\">Img/lastViewed</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'lastSystem\', \'ord-asc\':orderProp === \'lastSystem\' && !orderReverse, \'ord-desc\':orderProp === \'lastSystem\' && orderReverse}\" \nng-click=\"sortBy(\'lastSystem\')\" ng-show=\"vm.tableOptions[\'lastSystem\']\"><span translate=\"LISTADO_STB.HEADERS.SYSTEM\">\nSystem</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'forceSystem\', \'ord-asc\':orderProp === \'forceSystem\' && !orderReverse, \'ord-desc\':orderProp === \'forceSystem\' && orderReverse}\" \nng-click=\"sortBy(\'forceSystem\')\" ng-show=\"vm.tableOptions[\'forceSystem\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.FORCESYSTEM\">Pendiente de actualizar</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'cleanSystem\', \'ord-asc\':orderProp === \'cleanSystem\' && !orderReverse, \'ord-desc\':orderProp === \'cleanSystem\' && orderReverse}\" \nng-click=\"sortBy(\'cleanSystem\')\" ng-show=\"vm.tableOptions[\'cleanSystem\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.CLEANSYSTEM\">Pendiente de actualizar</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'status.ultConexion\', \'ord-asc\':orderProp === \'status.ultConexion\' && !orderReverse, \'ord-desc\':orderProp === \'status.ultConexion\' && orderReverse}\" \nng-click=\"sortBy(\'status.ultConexion\')\" ng-show=\"vm.tableOptions[\'status.ultConexion\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.ULTCON\">Ult. conexión</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'status.parsed\', \'ord-asc\':orderProp === \'status.parsed\' && !orderReverse, \'ord-desc\':orderProp === \'status.parsed\' && orderReverse}\" \nng-click=\"sortBy(\'status.parsed\')\" ng-show=\"vm.tableOptions[\'status.parsed\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.PANTALLA\">PANTALLA</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'screenshot\', \'ord-asc\':orderProp === \'screenshot\' && !orderReverse, \'ord-desc\':orderProp === \'screenshot\' && orderReverse}\" \nng-click=\"sortBy(\'screenshot\')\" ng-show=\"vm.tableOptions[\'screenshot\']\"><span \ntranslate=\"LISTADO_STB.HEADERS.SCREENSHOT\">PANTALLA</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'group\', \'ord-asc\':orderProp === \'group\' && !orderReverse, \'ord-desc\':orderProp === \'group\' && orderReverse}\" \nng-click=\"sortBy(\'group\')\" ng-show=\"vm.tableOptions[\'group\']\"><span translate=\"LISTADO_STB.HEADERS.GROUP\">Grupo</span>\n</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'lastMacs\', \'ord-asc\':orderProp === \'lastMacs\' && !orderReverse, \'ord-desc\':orderProp === \'lastMacs\' && orderReverse}\" \nng-click=\"sortBy(\'lastMacs\')\" ng-show=\"vm.tableOptions[\'lastMacs\']\"><span translate=\"LISTADO_STB.HEADERS.LASTMACS\">\nÚltimas MAC</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'diraya.centro\', \'ord-asc\':orderProp === \'diraya.centro\' && !orderReverse, \'ord-desc\':orderProp === \'diraya.centro\' && orderReverse}\" \nng-click=\"sortBy(\'diraya.centro\')\" ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.centro\']\"><span>\nDiraya-Centro</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'diraya.modulo\', \'ord-asc\':orderProp === \'diraya.modulo\' && !orderReverse, \'ord-desc\':orderProp === \'diraya.modulo\' && orderReverse}\" \nng-click=\"sortBy(\'diraya.modulo\')\" ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.modulo\']\"><span>\nDiraya-Módulo</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'diraya.cama\', \'ord-asc\':orderProp === \'diraya.cama\' && !orderReverse, \'ord-desc\':orderProp === \'diraya.cama\' && orderReverse}\" \nng-click=\"sortBy(\'diraya.cama\')\" ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.cama\']\"><span>Diraya-Cama\n</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'diraya.codigofuncional\', \'ord-asc\':orderProp === \'diraya.codigofuncional\' && !orderReverse, \'ord-desc\':orderProp === \'diraya.codigofuncional\' && orderReverse}\" \nng-click=\"sortBy(\'diraya.codigofuncional\')\" \nng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.codigofuncional\']\"><span>Diraya-Cod.funcional</span></th><th\n class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'diraya.unidadfuncional\', \'ord-asc\':orderProp === \'diraya.unidadfuncional\' && !orderReverse, \'ord-desc\':orderProp === \'diraya.unidadfuncional\' && orderReverse}\" \nng-click=\"sortBy(\'diraya.unidadfuncional\')\" \nng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.unidadfuncional\']\"><span>Diraya-Ud.funcional</span></th><th>\n</th></tr><tr \nng-repeat=\"hab in filtered| orderBy: orderProp:orderReverse | startFrom:currentPage * pageSize | limitTo:pageSize track by $index\" \nng-class=\"hab.checkInOut === \'In\' ? \'fila\' : \'filaBloqueada\'\" ng-dblclick=\"vm.ventanaEditar($event, hab)\" \non-last-repeat><td ng-show=\"vm.tableOptions[\'showChecks\']\"><md-checkbox ng-checked=\"marcados[hab.idStb]\" \nng-click=\"marcar(hab.idStb)\" aria-label=\"checked\"></md-checkbox></td><td class=\"{{hab.status.active}}\" \nng-show=\"vm.tableOptions[\'room\']\">{{hab.room}}</td><td ng-show=\"vm.tableOptions[\'username\']\">{{hab.username}}</td><td \nng-show=\"vm.tableOptions[\'ip\']\"><span copy-to-clipboard=\"{{hab.ip}}\">{{hab.ip}}<md-tooltip>\nClick para copiar al portapapeles</md-tooltip></span></td><td ng-show=\"vm.tableOptions[\'mac\']\"><span \ncopy-to-clipboard=\"{{hab.mac}}\">{{ hab.mac | uppercase}}<md-tooltip>Click para copiar al portapapeles</md-tooltip>\n</span></td><td ng-show=\"vm.tableOptions[\'extension\']\">{{hab.extension}}</td><td ng-show=\"vm.tableOptions[\'lang\']\"><img\n ng-src=\"/assets/quantionImagenes/Banderas/{{hab.lang}}.png\" alt=\"{{hab.lang}}\" style=\"max-height: 24px\"></td><td \nng-show=\"JSONconfig.sistemaDePago && vm.tableOptions[\'wallet\']\"><div><md-icon md-font-icon=\"icon-credit-card\" \nng-if=\"hab.typeWallet === \'virtual\'\" class=\"icono-tarjeta\"><md-tooltip>{{hab.uuidVirtualWallet}}</md-tooltip></md-icon>\n</div></td><td ng-show=\"JSONconfig.sistemaDePago && vm.tableOptions[\'balance\']\">\n{{(hab.checkInOut!==\'In\') ? \'\' : (hab.balance || 0)+\' €\'}}</td><td \nng-show=\"JSONconfig.sistemaDePago && vm.tableOptions[\'services\']\"><div ng-hide=\"hab.checkInOut !== \'In\'\" layout=\"row\" \nlayout-align=\"center center\"><span ng-if=\"hab.services.length < 1 || !hab.activeContracts\" \ntranslate=\"LISTADO_STB.SERVICIOS.SIN\">Sin servicios activos</span><md-menu md-position-mode=\"target-right target\" \nng-if=\"hab.activeContracts && (!hab.services || hab.services.length > 0)\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"getServices(hab, $mdOpenMenu, $event)\" aria-label=\"mdOpenMenu\"><span \nng-if=\"!hab.services\" translate=\"LISTADO_STB.SERVICIOS.OBTENER\">Obtener servicios</span> <span \nng-if=\"hab.services.length > 0\" translate=\"LISTADO_STB.SERVICIOS.LISTA\">Ver lista</span></md-button><md-menu-content \nstyle=\"max-height: 90vh\"><md-list class=\"md-dense\" flex><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"LISTADO_STB.SERVICIOS.ACTIVOS\">Servicios activos</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"serv in ::hab.services\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{::serv.name[$translate.use()]}}\n</h3><p><span translate=\"LISTADO_STB.SERVICIOS.FINALIZA\">Finaliza el</span>\n {{::serv.endDate|date:\'d/M/yyyy HH:mm\'}} ({{::serv.remainingTimeInMinutes|convertMinutesInHHMMSS}})</p></div>\n</md-list-item></md-list></md-menu-content></md-menu><md-icon md-font-icon=\"icon-exclamation\" \nng-if=\"hab.hasCrushedServices\" class=\"md-accent\"><md-tooltip><span translate=\"VERMAS.CRUSHEDSERVICES\">\nTiene servicios en el monedero del equipo</span></md-tooltip></md-icon></div></td><td \nng-show=\"vm.tableOptions[\'installation\']\"><span>{{hab.installation}}</span></td><td ng-show=\"vm.tableOptions[\'theme\']\">\n<span>{{hab.theme}}</span></td><td ng-show=\"vm.tableOptions[\'model\']\"><span>{{hab.model}}</span></td><td \nng-show=\"vm.tableOptions[\'wifiAp\']\"><span>{{hab.wifiAp}} ({{hab.wifiBand}})</span></td><td \nng-show=\"vm.tableOptions[\'lastDynamic\']\"><span \nstyle=\"background-color: {{hab.matchDynamic ?\'lightgreen\':\'lightcoral\'}}\">{{hab.lastDynamic}}</span><span \nstyle=\"background-color: {{hab.matchDynamic ?\'lightgreen\':\'lightcoral\'}}\" ng-if=\"!hab.matchDynamic\">\n >>> {{hab.dynamicNow}}</span></td><td ng-show=\"vm.tableOptions[\'lastSystem\']\"><span \nstyle=\"background-color: {{hab|pxeSplit:\'color\'}}\">{{hab.lastSystem}}</span><span \nstyle=\"background-color: {{hab|pxeSplit:\'color\'}}\" ng-if=\"(hab|pxeSplit:\'bool\')\"> >>> {{hab.systemNow}}</span></td><td \nng-show=\"vm.tableOptions[\'forceSystem\']\" style=\"text-align: center\"><span><md-icon md-font-icon=\"icon-download\" \nng-show=\"hab.forceSystem\" style=\"color: blue\"></md-icon></span></td><td ng-show=\"vm.tableOptions[\'cleanSystem\']\" \nstyle=\"text-align: center\"><span><md-icon md-font-icon=\"icon-harddisk\" ng-show=\"hab.cleanSystem\" style=\"color: green\">\n</md-icon></span></td><td ng-show=\"vm.tableOptions[\'status.ultConexion\']\">\n{{hab.status.ultConexion|date:\'dd/MM/yyyy HH:mm\'}}</td><td ng-show=\"vm.tableOptions[\'status.parsed\']\"><div \nlayout=\"row\" layout-align=\"start center\"><img ng-src=\"{{mapServicios[hab.status.currentScreen].logo | replacePath}}\" \nng-show=\"mapServicios[hab.status.currentScreen].logo\" style=\"width: 30px; height: 30px; object-fit: contain\"> <span \nclass=\"margin-horizontal-5\">\n{{mapServicios[hab.status.currentScreen].nameInt[$translate.use()] || hab.status.currentScreen}}</span> <span \nng-show=\"hab.status.currentScreen === \'TV\'\" layout=\"row\" layout-align=\"start center\">(<img \nng-src=\"{{mapCanales[hab.status.currentInfo].tvgLogo | replacePath}}\" \nstyle=\"width: 25px;height: 25px; object-fit: contain; margin: 0 2px\" \nng-show=\"mapCanales[hab.status.currentInfo].tvgLogo\">{{hab.status.currentInfo}})</span><md-tooltip>\n{{hab.status.parsed}}</md-tooltip></div></td><td ng-if=\"vm.tableOptions[\'screenshot\']\"><stb-screenshot stb=\"hab\" \nsize=\"10\" ng-if=\"hab.status.active === \'Activo\' && hab.status.currentScreen !== \'Apagado\'\"></stb-screenshot></td><td \nng-show=\"vm.tableOptions[\'group\']\">{{hab.group}}</td><td ng-show=\"vm.tableOptions[\'lastMacs\']\"><div><md-menu \nmd-position-mode=\"target-right target\" ng-if=\"hab.lastMacs.length > 0\"><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"mdOpenMenu\"><span translate=\"LISTADO_STB.SERVICIOS.LISTA\">Ver lista</span>\n ({{::hab.lastMacs.length}})</md-button><md-menu-content style=\"max-height: 90vh\"><md-list class=\"md-dense\" flex>\n<md-list-item ng-repeat=\"mac in ::hab.lastMacs track by $index\">{{::mac|uppercase}}</md-list-item></md-list>\n</md-menu-content></md-menu></div></td><td ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.centro\']\">\n{{hab.diraya.centro}}</td><td ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.modulo\']\">\n{{hab.diraya.modulo}}</td><td ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.cama\']\">{{hab.diraya.cama}}\n</td><td ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.codigofuncional\']\">{{hab.diraya.codigofuncional}\n</td><td ng-show=\"JSONconfig.datosDiraya && vm.tableOptions[\'diraya.unidadfuncional\']\">{{hab.diraya.unidadfuncional}}\n</td><td><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.connectVNC(hab, $event)\">\n<md-icon md-font-icon=\"icon-camcorder-box\" md-menu-align-target></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LISTADO_STB.BOTONESSTB.VNC\">Conectar por VNC</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.reiniciarStb(hab, $event)\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO_STB.BOTONESSTB.REINICIO\">Reiniciar STB</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.recargarInterfaz(hab, $event)\"><md-icon \nmd-font-icon=\"icon-screen-rotation\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LISTADO_STB.BOTONESSTB.RECARGA\">Recargar interfaz</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" href=\"/habitaciones/{{hab.idStb}}\"><md-icon md-font-icon=\"icon-account-box\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO_STB.BOTONESSTB.DETALLES\">Ver más</span></md-tooltip>\n</md-button><div><md-menu md-position-mode=\"target-right target\"><md-button class=\"md-fab md-mini\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"LISTADO_STB.BOTONESSTB.OPCIONES\">Opciones</span></md-tooltip></md-button><md-menu-content width=\"4\" \nstyle=\"max-height: 90vh\"><md-menu-item ng-if=\"user.mapRole.actions.CREATE_EDIT_STB\"><md-button \nng-click=\"vm.setDynamic(hab, $event)\"><md-icon md-font-icon=\"icon-arrow-up-bold-hexagon-outline\" md-menu-align-target>\n</md-icon><span translate=\"LISTADO_STB.BOTONESSTB.ACTUALIZAR\">Actualizar</span></md-button></md-menu-item><md-menu-item\n ng-if=\"hab.checkInOut !== \'In\' && !hab.locked\"><md-button ng-click=\"vm.checkIn(hab, $event)\"><md-icon \nmd-font-icon=\"icon-account-plus\" md-menu-align-target></md-icon><span translate=\"LISTADO_STB.BOTONESSTB.CHECKIN\">\nCheck-in</span></md-button></md-menu-item><md-menu-item ng-if=\"hab.checkInOut === \'In\' && !hab.locked\"><md-button \nng-click=\"vm.checkOut(hab, $event)\"><md-icon md-font-icon=\"icon-account-remove\" md-menu-align-target></md-icon><span \ntranslate=\"LISTADO_STB.BOTONESSTB.CHECKOUT\">Check-out</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.ventanaEditar($event, hab)\"><md-icon md-font-icon=\"icon-pencil\" md-menu-align-target></md-icon><span \ntranslate=\"LISTADO_STB.BOTONESSTB.EDITAR\">Editar</span></md-button></md-menu-item><md-menu-item \nng-if=\"!hab.locked && user.mapRole.actions.BLOCK_STB\"><md-button ng-click=\"vm.changeLock(hab, true, $event)\"><md-icon \nmd-font-icon=\"icon-lock\" md-menu-align-target></md-icon><span translate=\"LISTADO_STB.BOTONESSTB.BLOQUEAR\">Bloquear STB\n</span></md-button></md-menu-item><md-menu-item ng-if=\"hab.locked && user.mapRole.actions.BLOCK_STB\"><md-button \nng-click=\"vm.changeLock(hab, false, $event)\"><md-icon md-font-icon=\"icon-lock-unlocked\" md-menu-align-target></md-icon>\n<span translate=\"LISTADO_STB.BOTONESSTB.DESBLOQUEAR\">Desbloquear STB</span></md-button></md-menu-item><md-menu-item \nng-if=\"user.mapRole.actions.CREATE_EDIT_STB\"><md-button ng-click=\"vm.deleteCacheEdid($event, hab)\"><md-icon \nmd-font-icon=\"icon-image-broken\" md-menu-align-target></md-icon><span translate=\"LISTADO_STB.BOTONESSTB.EDID\">\nLimpiar caché Edid</span></md-button></md-menu-item><md-menu-item ng-if=\"user.mapRole.actions.CREATE_EDIT_STB\">\n<md-button ng-click=\"vm.resetHubUsb($event, hab)\"><md-icon md-font-icon=\"icon-usb\" md-menu-align-target></md-icon><span\n translate=\"LISTADO_STB.BOTONESSTB.HUB_USB\">Limpiar caché Edid</span></md-button></md-menu-item><md-menu-item \nng-if=\"JSONconfig.webcam && user.mapRole.actions.WEBCAM\"><md-button ng-click=\"vm.webcam(hab, $event)\"><md-icon \nmd-font-icon=\"icon-webcam\" md-menu-align-target></md-icon><span translate=\"PRINCIPAL.SIDENAV.BOTONES.WEBCAM\">\nMonitorizar webcam</span></md-button></md-menu-item><md-menu-item \nng-if=\"JSONconfig.videocall && user.mapRole.actions.VIDEOCALL\"><md-button ng-click=\"vm.videocall(hab, $event)\"><md-icon\n md-font-icon=\"icon-camera-front-variant\" md-menu-align-target></md-icon><span \ntranslate=\"PRINCIPAL.SIDENAV.BOTONES.VIDEOCALL\">Videollamada</span></md-button></md-menu-item><md-menu-item \nng-if=\"hab.typeWallet === \'virtual\'\"><md-button ng-click=\"vm.unlinkWallet(hab, $event)\"><md-icon \nmd-font-icon=\"icon-credit-card-multiple\" md-menu-align-target></md-icon><span \ntranslate=\"LISTADO_STB.BOTONESSTB.UNLINKWALLET\">Desvincular tarjeta</span></md-button></md-menu-item><md-menu-item \nng-if=\"user.mapRole.actions.CREATE_EDIT_STB\"><md-button ng-click=\"vm.eliminarStb($event, hab)\"><md-icon \nmd-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span translate=\"LISTADO_STB.BOTONESSTB.ELIMINAR\">Eliminar\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></td></tr></table></div></md-content></div>\n</div>");
$templateCache.put("app/main/Quantion/habitaciones/mantenimiento/mantenimiento.html","<div id=\"mantenimiento\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><md-button class=\"md-raised md-primary\" translate=\"MANTENIMIENTO.SWAPMAC.BUTTON\" \nng-click=\"vm.swapMac($event)\" ng-disabled=\"!vm.listaStbs\">Intercambiar MAC</md-button><md-button \nclass=\"md-raised md-primary\" translate=\"MANTENIMIENTO.DEVICES.BUTTON\" ng-click=\"vm.usbDevices($event)\" \nng-disabled=\"!vm.listaStbs\">Dispositivos conectados</md-button><md-button class=\"md-raised md-primary\" \ntranslate=\"MANTENIMIENTO.UPDATES.BUTTON\" ng-click=\"vm.updates($event)\" \nng-disabled=\"!vm.listaStbs || !statsLoaded || !vm.modelos\">Actualizaciones</md-button></md-content></div></div>");
$templateCache.put("app/main/Quantion/habitaciones/modelos/crearmodelo.tmpl.html","<md-dialog id=\"modelos\" aria-label=\"Crear modelo\" ng-cloak style=\"width:500px\" md-theme=\"{{$root.theme}}\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{windowTitle}}</h2></div></md-toolbar><md-dialog-content><form name=\"Form\" \nnovalidate><md-input-container class=\"md-block\"><label translate=\"MODELOS.NOMBRE\"></label><input name=\"model\" \nng-model=\"modelo.name\" required></md-input-container><div><label translate=\"MODELOS.CARACTERISTICAS\">Características\n</label><md-chips name=\"features\" ng-model=\"modelo.features\" placeholder=\"{{\'MODELOS.ENTER\'|translate}}\">\n<md-chip-template><strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"hint\"><span \ntranslate=\"MODELOS.SUGERENCIAS\">Sugerencias:</span> <span ng-repeat=\"feature in listaFeatures\"><a \nng-click=\"addFeature(feature)\" style=\"cursor: pointer\">{{feature}}</a>,</span></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"MODELOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"Form.$invalid\" style=\"margin-right:20px\" translate=\"MODELOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/modelos/importModelos.tmpl.html","<md-dialog id=\"import-modelos\" aria-label=\"Importar modelos de archivo\" ng-cloak flex=\"70\" style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MODELOS.IMPORT_TITLE\">\nImportar modelos</h2></div></md-toolbar><md-dialog-content><md-list class=\"md-dense\" flex layout=\"row\" layout-wrap><div\n class=\"modelo\" ng-repeat=\"mdl in listaModelos\"><md-checkbox ng-model=\"mdl.seleccionado\" aria-label=\"seleccionado\"><h4>\n<b>{{::mdl.name}}</b></h4></md-checkbox></div></md-list><p translate=\"MODELOS.MENSAJE\">\nSe deberán subir y asignar las versiones manualmente tras la importación</p></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"MODELOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"MODELOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/modelos/modelos.html","<div id=\"modelos\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><div layout=\"row\" layout-xs=\"column\" layout-align-gt-xs=\"space-between\"><div><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODELOS.REGISTRAR\">Registrar nuevo modelo</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.importFile()\"><md-icon md-font-icon=\"icon-box-upload\" \nclass=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MODELOS.IMPORTAR\">Importar modelos de archivo\n</span></md-tooltip></md-button><input type=\"file\" id=\"files\" aria-label=\"Seleccionar archivo\" hidden><export-to-file \nfilename=\"Backup-Modelos\" tooltip-text=\"Exportar modelos\" data=\"vm.listaModelos\"></export-to-file></div><md-button \nclass=\"md-raised md-primary\" href=\"/root/cversiones\" translate=\"MODELOS.IR_CONTROL\">Ir a control de versiones\n</md-button></div><md-list flex><md-list-item class=\"md-3-line layout-wrap\" ng-repeat=\"modelo in vm.listaModelos\" \non-last-repeat><img class=\"md-avatar\" \nng-src=\"{{JSONconfig.logosPath.to}}/LogosModelosStb/{{::modelo.name|lowercase}}.png\" on-error-image \nng-dblclick=\"uploadLogo(modelo)\"><div class=\"md-list-item-text\" layout=\"column\"><h3><span translate=\"MODELOS.NOMBRE\">\nNombre:</span> {{::modelo.name}}</h3><h4><span translate=\"MODELOS.CARACTERISTICAS\">Características:</span>\n {{::modelo.features|stringifyArray}}</h4></div><div layout=\"row\" layout-align=\"space-between\"><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.gestionarVersiones($event, modelo)\"><md-icon \nmd-font-icon=\"icon-code-not-equal-variant\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"MODELOS.VERSIONES_\">Gestionar versiones</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaEditar($event, modelo)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODELOS.EDITAR\">Editar modelo</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.eliminarModelo($event, modelo)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODELOS.ELIMINAR\">Eliminar modelo</span></md-tooltip></md-button>\n</div></md-list-item></md-list><input type=\"file\" accept=\"image/png\" id=\"logoUpload\" aria-label=\"Seleccionar archivo\" \nhidden></md-content></div></div>");
$templateCache.put("app/main/Quantion/habitaciones/modelos/versiones.tmpl.html","<md-dialog id=\"modelos_versiones\" aria-label=\"Versiones\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MODELOS.VERSIONES.TITLE\">Versiones</h2></div></md-toolbar><md-dialog-content>\n<md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\"><md-tab \nng-repeat=\"type in [\'dynamicList\', \'systemImage\', \'biosList\']\"><md-tab-label><span \ntranslate=\"MODELOS.VERSIONES.{{type}}\">{{type}}</span></md-tab-label><md-tab-body><div layout=\"row\" layout-wrap \nng-if=\"type !== \'systemImage\'\"><div ng-repeat=\"vrsn in modelo[type].completeList\" class=\"version\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"defaultVersion(type, vrsn)\"><md-icon \nmd-font-icon=\"icon-star-outline\" ng-if=\"vrsn.idItemVersion !== modelo[type].defaultItem.idItemVersion\" \nclass=\"md-primary-bg\"></md-icon><md-icon md-font-icon=\"icon-star\" \nng-if=\"vrsn.idItemVersion === modelo[type].defaultItem.idItemVersion\"></md-icon></md-button><h3 class=\"versionName\">\n{{vrsn.name}}</h3><div class=\"deleteButton md-accent-bg\" ng-click=\"eliminarVersion(type, $index)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></div></div></div><div layout=\"row\" ng-if=\"type !== \'systemImage\'\"><form \nng-submit=\"addVersion(type, nuevaVersion)\" layout=\"column\" layout-align=\"center-stretch\" class=\"version\"><md-select \nng-model=\"nuevaVersion\" placeholder=\"{{\'MODELOS.VERSIONES.ARCHIVO\'|translate}}\" class=\"md-no-underline\" flex><md-option\n ng-repeat=\"file in listaVersiones[type]| orderBy:\'-idItemVersion\'\" ng-value=\"file\">{{file.name}}</md-option>\n</md-select><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"!nuevaVersion\" \ntranslate=\"MODELOS.VERSIONES.ADD\">Añadir</md-button></form></div><div ng-if=\"type === \'systemImage\'\"><md-radio-group \nng-model=\"modelo.systemImage\" layout=\"row\" class=\"padding-16\"><md-radio-button \nng-repeat=\"vrsn in listaVersiones.systemList\" value=\"{{vrsn.idItemVersion}}\">{{vrsn.idItemVersion}}</md-radio-button>\n</md-radio-group><md-button class=\"md-raised md-accent\" ng-disabled=\"!modelo.systemImage\" \ntranslate=\"MODELOS.VERSIONES.GUARDAR\" ng-click=\"changeSysVersion()\">Guardar</md-button></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"dataLoading\"></md-progress-linear></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/unprovisioned/unprovisioned.html","<div id=\"unprovisioned\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div><div layout=\"row\" layout-align=\"start center\" layout-wrap><md-button class=\"md-fab md-mini\" \nng-click=\"vm.CargarStbs()\"><md-icon md-font-icon=\"icon-rotate-3d\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"UNPROVISIONED.BOTONES.REFRESCAR\">Refrescar datos</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"center center\" class=\"buscador\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"md-primary-bg\"><div><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</div><md-input-container class=\"md-block\"><input ng-model=\"search\" ng-model-options=\"{debounce: 500}\" \nng-change=\"filterStbs()\" aria-label=\"search\"></md-input-container><span>({{filtered.length}})</span><div><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"vm.tableProperties()\"></md-icon></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" \nng-click=\"currentPage = 0\">&LeftArrowBar;</md-button><md-button class=\"md-raised md-primary pagination-button\" \nng-disabled=\"currentPage <= 0\" ng-click=\"currentPage = currentPage - 1\">&LeftArrow;</md-button><span><span \ntranslate=\"WALLETS.PAGINA\">Pág.</span>{{currentPage + 1}} / {{numberOfPages()}}</span><md-button \nclass=\"md-raised md-primary pagination-button\" ng-disabled=\"(currentPage + 1) >= numberOfPages()\" \nng-click=\"currentPage = currentPage + 1\">&RightArrow;</md-button><md-button \nclass=\"md-raised md-primary pagination-button\" ng-disabled=\"(currentPage + 1) >= numberOfPages()\" \nng-click=\"currentPage = (numberOfPages() - 1)\">&RightArrowBar;</md-button></div><div><span translate=\"VOIP.MOSTRAR\">\nMostrar</span><md-input-container><md-select ng-model=\"pageSize\" aria-label=\"mostrar\"><md-option ng-value=\"v\" \nng-repeat=\"v in [5, 10, 25]\">{{v}}</md-option></md-select></md-input-container></div></div></div><div \nstyle=\"width: 100%; overflow-x: auto\"><table><tr><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'ip\', \'ord-asc\':orderProp === \'ip\' && !orderReverse, \'ord-desc\':orderProp === \'ip\' && orderReverse}\" \nng-click=\"sortBy(\'ip\')\" ng-show=\"vm.tableOptions[\'ip\']\"><span translate=\"UNPROVISIONED.HEADERS.IP\">IP</span></th><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'mac\', \'ord-asc\':orderProp === \'mac\' && !orderReverse, \'ord-desc\':orderProp === \'mac\' && orderReverse}\" \nng-click=\"sortBy(\'mac\')\" ng-show=\"vm.tableOptions[\'mac\']\"><span translate=\"UNPROVISIONED.HEADERS.MAC\">MAC</span></th>\n<th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'lastMacs\', \'ord-asc\':orderProp === \'lastMacs\' && !orderReverse, \'ord-desc\':orderProp === \'lastMacs\' && orderReverse}\" \nng-click=\"sortBy(\'lastMacs\')\" ng-show=\"vm.tableOptions[\'lastMacs\']\"><span translate=\"UNPROVISIONED.HEADERS.LASTMACS\">\nÚltimas MAC</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'firstSeen\', \'ord-asc\':orderProp === \'firstSeen\' && !orderReverse, \'ord-desc\':orderProp === \'firstSeen\' && orderReverse}\" \nng-click=\"sortBy(\'firstSeen\')\" ng-show=\"vm.tableOptions[\'firstSeen\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.FIRSTSEEN\"></span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'lastSeen\', \'ord-asc\':orderProp === \'lastSeen\' && !orderReverse, \'ord-desc\':orderProp === \'lastSeen\' && orderReverse}\" \nng-click=\"sortBy(\'lastSeen\')\" ng-show=\"vm.tableOptions[\'lastSeen\']\"><span translate=\"UNPROVISIONED.HEADERS.LASTSEEN\">\n</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'retryCount\', \'ord-asc\':orderProp === \'retryCount\' && !orderReverse, \'ord-desc\':orderProp === \'retryCount\' && orderReverse}\" \nng-click=\"sortBy(\'retryCount\')\" ng-show=\"vm.tableOptions[\'retryCount\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.RETRYCOUNT\"></span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'viewed.lastDynamic\', \'ord-asc\':orderProp === \'viewed.lastDynamic\' && !orderReverse, \'ord-desc\':orderProp === \'viewed.lastDynamic\' && orderReverse}\" \nng-click=\"sortBy(\'viewed.lastDynamic\')\" ng-show=\"vm.tableOptions[\'viewed.lastDynamic\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.LASTDYNAMIC\"></span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'viewed.lastSystem\', \'ord-asc\':orderProp === \'viewed.lastSystem\' && !orderReverse, \'ord-desc\':orderProp === \'viewed.lastSystem\' && orderReverse}\" \nng-click=\"sortBy(\'viewed.lastSystem\')\" ng-show=\"vm.tableOptions[\'viewed.lastSystem\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.LASTSYSTEM\"></span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'viewed.lastSystemInstallation\', \'ord-asc\':orderProp === \'viewed.lastSystemInstallation\' && !orderReverse, \'ord-desc\':orderProp === \'viewed.lastSystemInstallation\' && orderReverse}\" \nng-click=\"sortBy(\'viewed.lastSystemInstallation\')\" ng-show=\"vm.tableOptions[\'viewed.lastSystemInstallation\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.LASTSYSTEMINSTALLATION\"></span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'viewed.lastSystemUpdate\', \'ord-asc\':orderProp === \'viewed.lastSystemUpdate\' && !orderReverse, \'ord-desc\':orderProp === \'viewed.lastSystemUpdate\' && orderReverse}\" \nng-click=\"sortBy(\'viewed.lastSystemUpdate\')\" ng-show=\"vm.tableOptions[\'viewed.lastSystemUpdate\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.LASTSYSTEMUPDATE\"></span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'viewed.lastBios\', \'ord-asc\':orderProp === \'viewed.lastBios\' && !orderReverse, \'ord-desc\':orderProp === \'viewed.lastBios\' && orderReverse}\" \nng-click=\"sortBy(\'viewed.lastBios\')\" ng-show=\"vm.tableOptions[\'viewed.lastBios\']\"><span \ntranslate=\"UNPROVISIONED.HEADERS.LASTBIOS\"></span></th><th></th></tr><tr \nng-repeat=\"hab in filtered| orderBy: orderProp:orderReverse | startFrom:currentPage * pageSize | limitTo:pageSize track by $index\" \nclass=\"fila\" on-last-repeat><td ng-show=\"vm.tableOptions[\'ip\']\"><span>{{ hab.ip}}</span></td><td \nng-show=\"vm.tableOptions[\'mac\']\"><span>{{ hab.mac | uppercase}}</span></td><td ng-show=\"vm.tableOptions[\'lastMacs\']\">\n<div><md-menu md-position-mode=\"target-right target\" ng-if=\"hab.lastMacs.length > 0\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"mdOpenMenu\"><span \ntranslate=\"UNPROVISIONED.SERVICIOS.LISTA\">Ver lista</span> ({{::hab.lastMacs.length}})</md-button><md-menu-content \nstyle=\"max-height: 90vh\"><md-list class=\"md-dense\" flex><md-list-item \nng-repeat=\"mac in ::hab.lastMacs track by $index\">{{::mac|uppercase}}</md-list-item></md-list></md-menu-content>\n</md-menu></div></td><td ng-show=\"vm.tableOptions[\'firstSeen\']\">{{hab.firstSeen|date:\'dd/MM/yyyy HH:mm\'}}</td><td \nng-show=\"vm.tableOptions[\'lastSeen\']\">{{hab.lastSeen|date:\'dd/MM/yyyy HH:mm\'}}</td><td \nng-show=\"vm.tableOptions[\'retryCount\']\">{{hab.retryCount}}</td><td ng-show=\"vm.tableOptions[\'viewed.lastDynamic\']\">\n{{hab.viewed.lastDynamic}}</td><td ng-show=\"vm.tableOptions[\'viewed.lastSystem\']\">{{hab.viewed.lastSystem}}</td><td \nng-show=\"vm.tableOptions[\'viewed.lastSystemInstallation\']\">{{hab.viewed.lastSystemInstallation}}</td><td \nng-show=\"vm.tableOptions[\'viewed.lastSystemUpdate\']\">{{hab.viewed.lastSystemUpdate}}</td><td \nng-show=\"vm.tableOptions[\'viewed.lastBios\']\">{{hab.viewed.lastBios}}</td><td><div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-fab md-mini\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"UNPROVISIONED.BOTONESSTB.OPCIONES\">Opciones</span></md-tooltip></md-button><md-menu-content width=\"4\" \nstyle=\"max-height: 90vh\"><md-menu-item><md-button ng-click=\"vm.provisionar($event, hab)\"><md-icon \nmd-font-icon=\"icon-plus\" md-menu-align-target></md-icon><span translate=\"UNPROVISIONED.BOTONESSTB.PROVISIONAR\">\nProvisionar</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.eliminarStb($event, hab)\"><md-icon \nmd-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span translate=\"UNPROVISIONED.BOTONESSTB.ELIMINAR\">Eliminar\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></table></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/habitaciones/voip/voip.html","<div id=\"voip\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.verTarifas($event)\"><md-icon \nmd-font-icon=\"icon-currency-eur\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"VOIP.TARIFAS_\">\nVer tarifas</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.verListaLlamadas($event)\">\n<md-icon md-font-icon=\"icon-phone-log\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"VOIP.KNOCKS_\">\nVer llamadas</span></md-tooltip></md-button></div><md-tabs md-dynamic-height md-stretch-tabs=\"always\"><md-tab>\n<md-tab-label><span translate=\"VOIP.STBS\">STBs</span></md-tab-label><md-tab-body><div class=\"md-padding\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" class=\"buscador\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"md-primary-bg\"><div><md-icon md-font-icon=\"icon-magnify\"></md-icon></div>\n<md-input-container class=\"md-block\"><input ng-model=\"search\" ng-model-options=\"{debounce: 500}\" \nng-change=\"filterStbs()\"></md-input-container><span>({{listaStbsFiltered.length}})</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" \nng-click=\"currentPage = currentPage - 1\">&leftarrow;</md-button><span><span translate=\"WALLETS.PAGINA\">Pág.</span>\n{{currentPage + 1}} / {{numberOfPages() + 1}}</span><md-button class=\"md-raised md-primary pagination-button\" \nng-disabled=\"currentPage >= numberOfPages()\" ng-click=\"currentPage = currentPage + 1\">&rightarrow;</md-button></div>\n<div><span translate=\"VOIP.MOSTRAR\">Mostrar</span><md-input-container><md-select ng-model=\"pageSize\"><md-option \nng-value=\"v\" ng-repeat=\"v in [5, 10, 25, 50, 100]\">{{v}}</md-option></md-select></md-input-container></div></div><div \nclass=\"scrollable\"><table><tr><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'room\', \'ord-asc\':orderProp === \'room\' && !orderReverse, \'ord-desc\':orderProp === \'room\' && orderReverse}\" \nng-click=\"sortBy(\'room\')\" translate=\"VOIP.NHAB\">Nº hab.</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'username\', \'ord-asc\':orderProp === \'username\' && !orderReverse, \'ord-desc\':orderProp === \'username\' && orderReverse}\" \nng-click=\"sortBy(\'username\')\" translate=\"VOIP.CLIENTE\">Cliente</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'extension.number\', \'ord-asc\':orderProp === \'extension.number\' && !orderReverse, \'ord-desc\':orderProp === \'extension.number\' && orderReverse}\" \nng-click=\"sortBy(\'extension.number\')\" translate=\"VOIP.EXTENSION\">Extensión</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'extension.password\', \'ord-asc\':orderProp === \'extension.password\' && !orderReverse, \'ord-desc\':orderProp === \'extension.password\' && orderReverse}\" \nng-click=\"sortBy(\'extension.password\')\" translate=\"VOIP.CONTRASENA\">Contraseña</th><th></th></tr><tr \nng-repeat=\"stb in listaStbsFiltered| orderBy: orderProp:orderReverse | startFrom:currentPage * pageSize | limitTo:pageSize track by $index\" \non-last-repeat class=\"fila\"><td>{{stb.room}}</td><td>{{stb.username}}</td><td>{{stb.extension.number|| \'-\'}}</td><td>\n{{stb.extension.password|| \'-\'}}</td><td><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-mini\" \nng-click=\"vm.editarExtensionStb($event, stb)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"VOIP.CAMBIAREXTENSION\">Cambiar extensión</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarExtensionStb($event, stb)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"VOIP.ELIMINAREXTENSION\">Eliminar extensión</span>\n</md-tooltip></md-button></div></td></tr></table></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"VOIP.ESPECIALES\">Especiales</span></md-tab-label><md-tab-body><div class=\"md-padding\"><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.addExtension($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"VOIP.CREAREXTENSION\">Añadir extensión</span></md-tooltip></md-button><div \nclass=\"scrollable\"><table><tr><th class=\"column-title\" translate=\"VOIP.IDEXTENSION\">Identificador</th><th \nclass=\"column-title\" translate=\"VOIP.EXTENSION\">Extensión</th><th class=\"column-title\" translate=\"VOIP.CONTRASENA\">\nContraseña</th><th></th></tr><tr ng-repeat=\"ext in listaExtensiones| orderBy: \'usuario\' track by $index\" \non-last-repeat class=\"fila\"><td>{{ext.usuario}}</td><td>{{ext.number|| \'-\'}}</td><td>{{ext.password|| \'-\'}}</td><td>\n<div layout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.editarExtension($event, ext)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"VOIP.CAMBIAREXTENSION\">Cambiar extensión</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.eliminarExtension($event, ext)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"VOIP.ELIMINAREXTENSION\">Eliminar extensión</span></md-tooltip></md-button></div>\n</td></tr></table></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"VOIP.DIARYS\">\nNum. predefinidos</span></md-tab-label><md-tab-body><div class=\"md-padding\"><md-button class=\"md-fab md-mini\" \nng-click=\"vm.addDiary($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"VOIP.CREARDIARY\">Añadir predefinido</span></md-tooltip></md-button><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diary in vm.listaDiarys\"><img ng-src=\"{{diary.logo | replacePath}}\" class=\"md-avatar\" alt=\"\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>\n{{diary.name|formatNameDesc}} ({{\'VOIP.MODALEDITARDIARY.ORDEN\' | translate}}: {{diary.orden}})</h3><h4>\n{{diary.description|formatNameDesc}}</h4><p>{{diary.number}}</p></div><div layout=\"row\" layout-align=\"space-between\" \nclass=\"md-secondary\"><md-icon md-font-icon=\"icon-eye\" ng-show=\"diary.visible\" class=\"green-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-show=\"!diary.visible\" class=\"red-fg\"></md-icon><md-button class=\"md-fab md-mini\" \nng-click=\"vm.editarDiary($event, diary)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"VOIP.EDITDIARY\">Editar diary</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.eliminarDiary($event, diary)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"VOIP.DELETEDIARY\">Eliminar diary</span></md-tooltip></md-button>\n</div></md-list-item></md-list></div></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/Quantion/habitaciones/wallets/wallets.html","<div id=\"wallets\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><div><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"WALLETS.REGISTRAR\">\nRegistrar nuevo monedero</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.CargarWallets()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"WALLETS.RECARGAR\">Recargar datos</span></md-tooltip></md-button><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\" class=\"buscador\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary-bg\"><div><md-icon md-font-icon=\"icon-magnify\"></md-icon></div><md-input-container class=\"md-block\">\n<input ng-model=\"search\" ng-model-options=\"{debounce: 500}\" ng-change=\"filterWallets()\"></md-input-container><span>\n({{listaWalletsFiltered.length}})</span></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" ng-click=\"currentPage = 0\">&LeftArrowBar;\n</md-button><md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" \nng-click=\"currentPage = currentPage - 1\">&LeftArrow;</md-button><span><span translate=\"WALLETS.PAGINA\">Pág.</span>\n{{currentPage + 1}} / {{numberOfPages()}}</span><md-button class=\"md-raised md-primary pagination-button\" \nng-disabled=\"(currentPage + 1) >= numberOfPages()\" ng-click=\"currentPage = currentPage + 1\">&RightArrow;</md-button>\n<md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"(currentPage + 1) >= numberOfPages()\" \nng-click=\"currentPage = (numberOfPages() - 1)\">&RightArrowBar;</md-button></div><div><span translate=\"WALLETS.MOSTRAR\">\nMostrar</span><md-input-container><md-select ng-model=\"pageSize\"><md-option ng-value=\"v\" \nng-repeat=\"v in [5, 10, 25, 50, 100]\">{{v}}</md-option></md-select></md-input-container></div></div></div><div><table>\n<tr><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'uuidVirtualWallet\', \'ord-asc\':orderProp === \'uuidVirtualWallet\' && !orderReverse, \'ord-desc\':orderProp === \'uuidVirtualWallet\' && orderReverse}\" \nng-click=\"sortBy(\'uuidVirtualWallet\')\"><span translate=\"WALLETS.UUID\">UUID</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'stbAsociated\', \'ord-asc\':orderProp === \'stbAsociated\' && !orderReverse, \'ord-desc\':orderProp === \'stbAsociated\' && orderReverse}\" \nng-click=\"sortBy(\'stbAsociated\')\"><span translate=\"WALLETS.STBASOCIATED\">STB asociado</span></th><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'checkType\', \'ord-asc\':orderProp === \'checkType\' && !orderReverse, \'ord-desc\':orderProp === \'checkType\' && orderReverse}\" \nng-click=\"sortBy(\'checkType\')\"><span translate=\"WALLETS.CHECK\">Check</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'checkDate\', \'ord-asc\':orderProp === \'checkDate\' && !orderReverse, \'ord-desc\':orderProp === \'checkDate\' && orderReverse}\" \nng-click=\"sortBy(\'checkDate\')\"><span translate=\"WALLETS.FECHAHORA\">Fecha/hora check</span></th><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'balance\', \'ord-asc\':orderProp === \'balance\' && !orderReverse, \'ord-desc\':orderProp === \'balance\' && orderReverse}\" \nng-click=\"sortBy(\'balance\')\"><span translate=\"WALLETS.SALDO\">Saldo</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'logoutOnDisconnect\', \'ord-asc\':orderProp === \'logoutOnDisconnect\' && !orderReverse, \'ord-desc\':orderProp === \'logoutOnDisconnect\' && orderReverse}\" \nng-click=\"sortBy(\'logoutOnDisconnect\')\"><span translate=\"WALLETS.LOGOUTONDISCONNECT\">Checkout al retirar</span></th><th\n class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'services\', \'ord-asc\':orderProp === \'services\' && !orderReverse, \'ord-desc\':orderProp === \'services\' && orderReverse}\" \nng-click=\"sortBy(\'services\')\"><span translate=\"WALLETS.SERVICIOS\">Servicios</span></th><th class=\"column-title\" \nng-if=\"user.mapRole.actions.WALLET_PINCODE\" \nng-class=\"{\'ord-no\':orderProp !== \'pin\', \'ord-asc\':orderProp === \'pin\' && !orderReverse, \'ord-desc\':orderProp === \'pin\' && orderReverse}\" \nng-click=\"sortBy(\'pin\')\"><span translate=\"WALLETS.PIN\">PIN de devolución</span></th><th></th></tr><tr \nng-repeat=\"wallet in listaWalletsFiltered| orderBy: orderProp:orderReverse | startFrom:currentPage * pageSize | limitTo:pageSize track by $index\" \non-last-repeat><td>{{wallet.uuidVirtualWallet}}</td><td><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\" ng-if=\"wallet.stbAsociated\"><md-tooltip>\n{{wallet.stbAsociated.room}} - {{wallet.stbAsociated.username}}</md-tooltip></md-icon></div></td><td \nclass=\"check-{{wallet.checkType}}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"wallet.checkType === \'In\'\"></md-icon><md-icon md-font-icon=\"icon-cancel\" \nng-if=\"wallet.checkType === \'Out\'\"></md-icon><span>{{wallet.checkType}}</span></div></td><td>\n{{wallet.checkDate|date:\"dd/MM/yy HH:mm\"}}</td><td>{{wallet.balance}} €</td><td><md-icon \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"wallet.logoutOnDisconnect\" class=\"green-800-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-cancel\" ng-if=\"!wallet.logoutOnDisconnect\" class=\"red-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-sync\" ng-click=\"changeLogoutOnDisconnect(wallet)\" id=\"icon-status-{{wallet.uuidVirtualWallet}}\">\n</md-icon></td><td><div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"openMenu($mdOpenMenu, $event, wallet)\" \ntranslate=\"WALLETS.SERVICIOSLISTA\">Ver lista</md-button><md-menu-content style=\"max-height: 90vh\"><md-list \nclass=\"md-dense\" flex><md-subheader class=\"md-no-sticky\"><span translate=\"WALLETS.SERVICIOSACTIVOS\">Servicios activos\n</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"serv in ::wallet.services\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{::serv.name[$translate.use()]}}</h3><p><span \ntranslate=\"WALLETS.SERVICIOSFINALIZA\">Finaliza el</span>\n {{::serv.endDate|date:\'d/M/yyyy HH:mm\'}} ({{::serv.remainingTimeInMinutes|convertMinutesInHHMMSS}})</p></div>\n</md-list-item></md-list></md-menu-content></md-menu></div></td><td ng-if=\"user.mapRole.actions.WALLET_PINCODE\"><span \nng-if=\"wallet.pin\">{{wallet.pin}}</span><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"obtainPin(wallet)\" \ntranslate=\"WALLETS.OBTENERPIN\" ng-if=\"wallet.checkType === \'In\' && !wallet.pin\">Obtener PIN</md-button></td><td><div \nlayout=\"row\" layout-align=\"end\"><md-button class=\"md-fab md-mini md-warn\" ng-click=\"vm.vincularStb($event, wallet)\" \nng-if=\"!wallet.stbAsociated\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"WALLETS.VINCULASTB\">Vincular STB</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"vm.desvincularStb($event, wallet)\" ng-if=\"wallet.stbAsociated\"><md-icon \nmd-font-icon=\"icon-account-minus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"WALLETS.DESVINCULASTB\">\nDesvincular STB</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.checkWallet($event, wallet, \'In\')\" ng-if=\"wallet.checkType === \'Out\'\"><md-icon \nmd-font-icon=\"icon-bookmark-check\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"WALLETS.CHECKIN\">\nCheck-in</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.checkWallet($event, wallet, \'Out\')\" ng-if=\"wallet.checkType === \'In\'\"><md-icon \nmd-font-icon=\"icon-bookmark-remove\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"WALLETS.CHECKOUT\">\nCheck-out</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.listaChecks($event, wallet)\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"WALLETS.LISTACHECKS\">Historial check in/out</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.eliminarWallet($event, wallet)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"WALLETS.ELIMINAR\">Eliminar</span></md-tooltip></md-button></div>\n</td></tr></table></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/habitaciones/ver_mas/avisoRapido.tmpl.html","<md-dialog aria-label=\"Aviso rapido\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"AVISO.TITLE\">Enviar aviso rápido</h2></div></md-toolbar><md-dialog-content>\n<form name=\"formulario\" layout=\"column\"><md-input-container flex><label translate=\"AVISO.CONTENIDO\">Contenido del aviso\n</label><textarea style=\"height: 100px\" name=\"message\" ng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" \nrows=\"5\" required></textarea><div ng-messages=\"formulario.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div\n ng-message=\"required\" translate=\"AVISO.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"AVISO.LONGITUD\">El mensaje debe tener menos de 150 caracteres.</div></div></md-input-container>\n<md-input-container flex><label translate=\"AVISO.TIEMPO\">Tiempo de visualización (en segundos)</label><input \nname=\"displaytime\" type=\"number\" ng-model=\"event.header.properties.frame.time\" min=\"1\" max=\"100000\" required><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"AVISO.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"AVISO.MIN\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"AVISO.MAX\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"hide()\" translate=\"AVISO.CERRAR\">Cerrar</md-button><md-button ng-click=\"enviar()\" \nng-disabled=\"formulario.$invalid\" style=\"margin-right:20px\" translate=\"AVISO.ENVIAR\">Enviar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/ver_mas/compras.tmpl.html","<md-dialog id=\"ver_masHabitacion\" aria-label=\"Check-in\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"VERMAS.COMPRAS.TITLE\">\nServicios contratados</h2></div></md-toolbar><md-dialog-content><md-tabs md-border-bottom class=\"white-bg\" \nmd-stretch-tabs=\"always\" style=\"min-height: 600px\"><md-tab><md-tab-label><span translate=\"VERMAS.COMPRAS.ACTIVOS\">\nServicios activos</span></md-tab-label><md-tab-body><md-list class=\"md-dense\" flex><md-list-item class=\"md-2-line\" \nng-repeat=\"serv in activeServices\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{::serv.name[$translate.use()]}}\n</h3><p><span translate=\"LISTADO_STB.SERVICIOS.FINALIZA\">Finaliza el</span>\n {{::serv.endDate|date:\'d/M/yyyy HH:mm\'}} ({{::serv.remainingTimeInMinutes|convertMinutesInHHMMSS}})</p></div>\n</md-list-item></md-list></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"VERMAS.COMPRAS.HISTORIAL\" \ntranslate-values=\"{numOp:listaOperaciones.length}\">\nHistorial de paquetes comprados ({{listaOperaciones.length}} operaciones)</span></md-tab-label><md-tab-body><md-list \nclass=\"md-dense\" flex><md-list-item class=\"md-3-line _{{oper.concept}}\" ng-repeat=\"oper in listaOperaciones\"><div \nclass=\"idAccountant\" layout=\"column\"><span>{{oper.idAccountant}}<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.NUMOPERACION\">Nº de operación</span></md-tooltip></span></div><ng-include src=\"oper.concept\" \nflex></ng-include></md-list-item></md-list></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"hide()\" translate=\"VERMAS.COMPRAS.CERRAR\">Cerrar</md-button></md-dialog-actions>\n</md-dialog><script type=\"text/ng-template\" id=\"Package\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-if=\"oper.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.PACKAGE.PAQUETECOMPRADO\'>Paquete comprado:</span> {{::oper.extendedConcept.snapshotPackage.name|formatNameDesc}} ({{::oper.extendedConcept.durationChosen|convertMinutesInHHMMSS}}/\n    <span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n\n    <div class=\"md-list-item-text\" layout=\"column\" ng-if=\"!oper.extendedConcept.snapshotPackage && oper.extendedConcept.snapshotAccountant\">\n    <h3>\n    [{{oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{oper.room}} - <span translate=\'OPERACIONES.PACKAGE.FINALIZADA\'>Finalizada la operación</span> {{oper.extendedConcept.snapshotAccountant.idAccountant}}\n    (<span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Service\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\"OPERACIONES.SERVICE.SERVICIOCORTESIA\">Servicio de cortesía</span> \'{{::oper.extendedConcept.snapshotContract[0].service.name|formatNameDesc}}\' ({{::((oper.extendedConcept.snapshotContract[0].end - oper.extendedConcept.snapshotContract[0].start) / 60000) | convertMinutesInHHMMSS}})</h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Cancellation\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.CANCELACION.CANCELACION\'>Cancelación de compra</span> - <span translate=\"OPERACIONES.CANCELACION.IMPORTEDEVUELTO\">Importe devuelto:</span> {{::oper.amount}}€ <span translate=\"OPERACIONES.CANCELACION.ENMETALICO\">en metálico</span>, {{::oper.virtualAmount|abs}}€ <span translate=\"OPERACIONES.CANCELACION.ENSALDO\">en saldo</span></h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Balance\">\n<div class=\"md-list-item-text\" layout=\"column\">\n    <h3>[{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.BALANCE.RECARGADE\'>Recarga de saldo de</span> {{::(oper.extendedConcept.current - oper.extendedConcept.before)}}€ ({{::oper.extendedConcept.before}}€&RightArrow;{{::oper.extendedConcept.current}}€)</h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script><script type=\"text/ng-template\" id=\"Refund\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-if=\"oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] <span translate=\'OPERACIONES.PACKAGE.HAB\'>Hab.</span> {{::oper.room}} - <span translate=\'OPERACIONES.REVOCACION.REVOCACIONPAQUETE\'>Revocación del paquete</span> \'{{::oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage.name|formatNameDesc}}\' ({{::oper.extendedConcept.snapshotAccountant.extendedConcept.durationChosen|convertMinutesInHHMMSS}}/\n    <span ng-if=\"oper.amount !== 0\">{{::oper.amount}}€ <span translate=\'OPERACIONES.PACKAGE.EFECTIVO\'>en efectivo</span></span>\n    <span ng-if=\"oper.virtualAmount !== 0\">{{::oper.virtualAmount|abs}}€ <span translate=\'OPERACIONES.PACKAGE.DESALDO\'>de saldo</span></span>\n    <span ng-if=\"oper.virtualAmount === 0 && oper.amount === 0\" translate=\'OPERACIONES.PACKAGE.GRATIS\'>Gratis</span>)\n    </h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n\n    <div class=\"md-list-item-text\" layout=\"column\" ng-if=\"!oper.extendedConcept.snapshotAccountant.extendedConcept.snapshotPackage\">\n    <h3>\n    [{{::oper.date|date:\'d/M/yy HH:mm\'}}] Hab. {{::oper.room}} - <span translate=\'OPERACIONES.REVOCACION.REVOCACIONSALDO\'>Revocación de saldo</span> ({{::oper.amount|abs}}€)\n    </h3>\n    <h4><span translate=\"OPERACIONES.PACKAGE.DESDE\">Desde</span> {{::oper.place}} (IP: {{::oper.extendedPlace}}). <span class=\"{{::oper.payment}}\" style=\"padding: 5px\">{{::transPayment[oper.payment]|translate}}</span></h4>\n    <p><span translate=\"OPERACIONES.PACKAGE.COMENTARIO\">Comentario:</span> {{::oper.comments|| \' - \'}}</p>\n    <p>{{::oper.username}}</p>\n    </div>\n</script>");
$templateCache.put("app/main/Quantion/habitaciones/ver_mas/ver_mas.html","<div id=\"ver_masHabitacion\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<div><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"back()\" translate=\"VERMAS.VOLVER\">Volver</md-button>\n</div><md-content layout-padding layout=\"column\"><form name=\"updateHabitacion\" class=\"md-inline-form\" novalidate>\n<fieldset class=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.DATOSCLIENTE\">Datos del cliente</legend><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.NOMBRE\">Nombre del cliente:</span>\n {{::vm.habitacion.username}}</div><div layout=\"row\" layout-align=\"start center\" flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.IDIOMA\" style=\"margin-right: 10px\">Idioma:</span><div><img \nng-src=\"/assets/quantionImagenes/Banderas/{{::vm.habitacion.lang}}.png\" alt=\"{{::vm.habitacion.lang}}\" \nstyle=\"max-height: 24px\"></div></div></div></fieldset><fieldset class=\"standard\" flex=\"100\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.DATOSSTB\">Datos del STB</legend><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\">\n<span translate=\"VERMAS.NOMBREHAB\">Nombre de habitación:</span> {{::vm.habitacion.room}}</div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.INSTALACION\">Instalación</span>\n {{::vm.habitacion.installation.name}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.TEMA\">Tema</span> {{::vm.habitacion.properties.themeOverride}}</div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.TACTIL\">Tactil</span> <span \ntranslate=\"VERMAS.TACTIL_{{::vm.habitacion.properties.touch}}\">{{::vm.habitacion.properties.touch}}</span></div><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.MODELO\">Modelo</span>\n {{::vm.habitacion.model.name}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.IP\">IP:</span> {{::vm.habitacion.ip}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.VOLUMEN\">Volumen máximo de la TV:</span>\n {{::vm.habitacion.properties.volume}} %</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"vm.habitacion.uptime\"><span translate=\"VERMAS.TEMPERATURA\">Temperatura:</span>\n {{::vm.habitacion.uptime.temp1}}ºC /{{::vm.habitacion.uptime.temp2}}ºC</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" \nflex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.EXTENSION\">Extensión VOIP:</span>\n {{::vm.habitacion.extension.number}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"vm.habitacion.uptime\"><span translate=\"VERMAS.RESOLUCION\">Resolución:</span>\n {{::vm.habitacion.uptime.resolution}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"vm.habitacion.uptime.ethernet\"><span translate=\"VERMAS.ETHERNET\">Conexión cableada (Ethernet):</span> <span \ntranslate=\"VERMAS.TACTIL_{{vm.habitacion.uptime.ethernet}}\">{{::vm.habitacion.uptime.ethernet}}</span></div><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"vm.habitacion.uptime.disk\"><span \ntranslate=\"VERMAS.DISK\">Tamaño de disco:</span> {{::vm.habitacion.uptime.disk}}</div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"vm.habitacion.uptime.usbList2\"><span translate=\"VERMAS.USBWIFI\">\nDispositivos USB conectados: </span>({{vm.habitacion.uptime.usbList2.length}}) <a ng-click=\"showLi = !showLi\" href=\"\" \nclass=\"md-warn-fg\"><span translate=\"VERMAS.MOSTRAR\" ng-if=\"!showLi\" class=\"md-warn-fg\">Mostrar</span><span \ntranslate=\"VERMAS.OCULTAR\" ng-if=\"showLi\" class=\"md-warn-fg\">Ocultar</span></a><li \nng-repeat=\"dev in vm.habitacion.uptime.usbList2|orderBy: \'-known\'\" ng-show=\"showLi\" ng-class=\"{strong:dev.known}\" \nstyle=\"color: {{dev.color}}\">{{dev.name}}</li></div></div></fieldset><fieldset class=\"standard\" flex=\"100\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.RED\">Red</legend><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.MAC\">MAC:</span> {{vm.habitacion.mac| uppercase}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" \nflex=\"100\" class=\"text-gray\" ng-if=\"vm.habitacion.lastMacs\"><span translate=\"VERMAS.LASTMACS\">Últimas MAC utilizadas\n</span>({{vm.habitacion.lastMacs.length}}) <a ng-click=\"showLi = !showLi\" href=\"\" class=\"md-warn-fg\"><span \ntranslate=\"VERMAS.MOSTRAR\" ng-if=\"!showLi\">Mostrar</span><span translate=\"VERMAS.OCULTAR\" ng-if=\"showLi\">Ocultar</span>\n</a><li ng-repeat=\"mac in vm.habitacion.lastMacs track by $index\" ng-show=\"showLi\">{{::mac|uppercase}}</li></div><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"vm.habitacion.properties.wifiAp\"><span \ntranslate=\"VERMAS.APASIGNADO\">Punto de acceso asignado:</span>\n {{vm.habitacion.properties.wifiAp.name}} ({{vm.habitacion.properties.wifiAp.band===\'B_2_GHZ\'?\'2.4 GHz\':\'5 GHz\'}}) ({{vm.habitacion.properties.wifiAp.bssid}})\n<div layout=\"row\" layout-align=\"center center\" ng-if=\"assignedAp\" style=\"display: inline-block\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"assignedAp.status === \'Online\'\" class=\"green-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-flag-variant\" ng-if=\"assignedAp.status === \'Flagged\'\" class=\"orange-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-if=\"assignedAp.status === \'Offline\'\" class=\"red-700-fg\"></md-icon><span \nclass=\"margin-horizontal-5\">{{assignedAp.status}}</span><md-menu><md-button class=\"md-fab md-mini md-orange-600-bg\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"showApRuckusInfo(assignedAp)\">\n<md-icon md-font-icon=\"icon-information\" md-menu-align-target></md-icon><span>Info y clientes</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusEvents(assignedAp)\"><md-icon \nmd-font-icon=\"icon-calendar-text\" md-menu-align-target></md-icon><span translate=\"APS.EVENTS\">Eventos</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusAlarms(assignedAp)\"><md-icon \nmd-font-icon=\"icon-alert\" md-menu-align-target></md-icon><span translate=\"APS.ALARMS\">Alarmas</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"rebootAP($event, assignedAp)\"><md-icon md-font-icon=\"icon-refresh\" \nmd-menu-align-target></md-icon><span translate=\"APS.REBOOT\">Reiniciar</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"vm.habitacion.uptime.ap\"><span translate=\"VERMAS.AP\">Punto de acceso conectado:</span><span \nng-if=\"vm.mapAps[vm.habitacion.uptime.ap.toLowerCase()]\" \nstyle=\"color: {{(vm.habitacion.properties.wifiAp.bssid.toLowerCase() === vm.habitacion.uptime.ap.toLowerCase()) ? \'green\' : \'red\'}}\">\n{{vm.mapAps[vm.habitacion.uptime.ap.toLowerCase()].name}} ({{vm.mapAps[vm.habitacion.uptime.ap.toLowerCase()].band === \'B_2_GHZ\' ? \'2.4 GHz\' : \'5 GHz\'}}) ({{vm.habitacion.uptime.ap}})\n</span><div layout=\"row\" layout-align=\"center center\" ng-if=\"connectedAp\" style=\"display: inline-block\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"connectedAp.status === \'Online\'\" class=\"green-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-flag-variant\" ng-if=\"connectedAp.status === \'Flagged\'\" class=\"orange-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-if=\"connectedAp.status === \'Offline\'\" class=\"red-700-fg\"></md-icon><span \nclass=\"margin-horizontal-5\">{{connectedAp.status}}</span><md-menu><md-button class=\"md-fab md-mini md-orange-600-bg\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"showApRuckusInfo(connectedAp)\">\n<md-icon md-font-icon=\"icon-information\" md-menu-align-target></md-icon><span>Info y clientes</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusEvents(connectedAp)\"><md-icon \nmd-font-icon=\"icon-calendar-text\" md-menu-align-target></md-icon><span translate=\"APS.EVENTS\">Eventos</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusAlarms(connectedAp)\"><md-icon \nmd-font-icon=\"icon-alert\" md-menu-align-target></md-icon><span translate=\"APS.ALARMS\">Alarmas</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"rebootAP($event, connectedAp)\"><md-icon md-font-icon=\"icon-refresh\" \nmd-menu-align-target></md-icon><span translate=\"APS.REBOOT\">Reiniciar</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"vm.habitacion.uptime.ap\"><span translate=\"VERMAS.APDISPONIBLES\">APs disponibles: </span><a ng-click=\"getAps()\" \nhref=\"\" class=\"md-warn-fg\"><span translate=\"VERMAS.MOSTRAR\" ng-if=\"!vm.listaAps && !loadingAps\" class=\"md-warn-fg\">\nMostrar</span> <span translate=\"VERMAS.REFRESCAR\" ng-if=\"vm.listaAps && !loadingAps\" class=\"md-warn-fg\">Refrescar\n</span> </a><span translate=\"VERMAS.CARGANDO\" ng-if=\"loadingAps\" class=\"md-warn-fg\">Cargando</span><li \nng-repeat=\"ap in vm.listaAps|orderBy: \'signal\'\"><span ng-if=\"vm.mapAps[ap.mac.toLowerCase()]\" \nng-class=\"{underline:(ap.mac.toLowerCase() === vm.habitacion.uptime.ap.toLowerCase())}\">\n{{vm.mapAps[ap.mac.toLowerCase()].name}} ({{vm.mapAps[ap.mac.toLowerCase()].band === \'B_2_GHZ\' ? \'2.4 GHz\' : \'5 GHz\'}})\n</span> <span class=\"md-warn-fg\">{{ap.mac}} ({{ap.essid}} / {{ap.signal}} / Canal {{ap.channel}})</span></li></div><div\n flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"vm.habitacion.uptime.signal\"><span \ntranslate=\"VERMAS.SIGNAL\">Alcance de señal:</span> {{vm.habitacion.uptime.signal}}<div \nclass=\"signal-meter-container margin-left-8\"><div class=\"signal-meter {{signalStatus}}\" \nstyle=\"width: {{signalStatusPercent}}%\"></div></div></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" \nclass=\"text-gray\" ng-if=\"vm.habitacion.wifiList\"><span translate=\"VERMAS.WIFILIST\">Dispositivos conectados al WiFi:\n</span>({{vm.habitacion.wifiList.length}}) <a ng-click=\"showLi = !showLi\" href=\"\" class=\"md-warn-fg\"><span \ntranslate=\"VERMAS.MOSTRAR\" ng-if=\"!showLi\">Mostrar</span><span translate=\"VERMAS.OCULTAR\" ng-if=\"showLi\">Ocultar</span>\n</a><li ng-repeat=\"dev in vm.habitacion.wifiList\" ng-show=\"showLi\">{{dev}}</li></div></div></fieldset><fieldset \nclass=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.VERSIONES\">\nVersiones</legend><div layout=\"row\" layout-align=\"start start\" layout-wrap><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.IMAGEN2\">Versión de imagen asignada:</span>\n {{::vm.habitacion.dynamicVersion.name}}</div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.IMAGEN\">Versión de imagen en pantalla:</span> {{::vm.habitacion.viewed.lastDynamic}}</div><div \nflex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.SISTEMA2\">Versión de sistema asignada:</span>\n {{::vm.habitacion.systemVersion.name}}</div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.SISTEMA\">Versión del sistema:</span> {{::vm.habitacion.viewed.lastSystem}}</div><div flex-gt-sm=\"50\" \nflex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.BIOS2\">Versión de bios asignada:</span>\n {{::vm.habitacion.biosVersion.name}}</div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.BIOS\">Versión de BIOS:</span> {{::vm.habitacion.viewed.lastBios}}</div></div></fieldset><fieldset \nclass=\"standard\" flex=\"100\" ng-if=\"vm.tipoFront.sistemaDePago\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.OPCIONESPAGO\">Opciones de pago</legend><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start start\" layout-wrap><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.SALDO\">Saldo disponible:</span> {{::vm.habitacion.wallet.balance}} €</div><div flex-gt-sm=\"50\" \nflex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.TARJETAASOCIADA\">Tarjeta asociada: </span><span \ntranslate=\"VERMAS.TACTIL_{{vm.habitacion.wallet.type === \'virtual\'}}\"></span></div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\" ng-if=\"vm.habitacion.wallet.type === \'virtual\'\"><span translate=\"VERMAS.IDWALLET\">ID tarjeta</span>\n {{::vm.habitacion.wallet.identifier}} <a ng-click=\"moveWallet()\" class=\"md-warn-fg\" style=\"cursor: pointer\" \ntranslate=\"VERMAS.MOVEWALLET\">Mover</a></div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.ULTIMOWALLET\">Último ID tarjeta leído</span> {{::vm.habitacion.uptime.wallet}}<md-icon \nmd-font-icon=\"icon-check\" style=\"color: green\" \nng-show=\"vm.habitacion.uptime.wallet === vm.habitacion.wallet.identifier\"><md-tooltip md-direction=\"right\">\nCoincide con el ID de monedero asignado</md-tooltip></md-icon><md-icon md-font-icon=\"icon-close\" style=\"color: red\" \nng-show=\"vm.habitacion.uptime.wallet !== vm.habitacion.wallet.identifier\"><md-tooltip md-direction=\"right\">\nNo coincide con el ID de monedero asignado</md-tooltip></md-icon></div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\" ng-if=\"lastCheckinOperation\"><span translate=\"VERMAS.ULTIMOWALLETPIN\">PIN de devolución</span>\n {{lastCheckinOperation.idAccountant| generateCode}}</div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><a \nng-click=\"getCardLog()\" class=\"md-warn-fg\" style=\"cursor: pointer\" translate=\"VERMAS.CARDLOG\">Ver log tarjetero</a>\n</div></div></fieldset><fieldset class=\"standard\" flex=\"100\" ng-if=\"vm.tipoFront.sistemaDePago\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\"><span translate=\"VERMAS.SERVICIOSACTIVOS\">Servicios activos\n</span> <a ng-click=\"vm.verOperaciones()\" translate=\"PRINCIPAL.SIDENAV.SERVICIOS.LINK\" style=\"cursor: pointer\">\n(Ver operaciones)</a></legend><div layout=\"column\" layout-align=\"start start\" layout-wrap><span \nng-repeat=\"serv in vm.habitacion.wallet.services\"><b>{{::serv.name[$translate.use()]}}</b> - <span \ntranslate=\"PRINCIPAL.SIDENAV.SERVICIOS.FINALIZA\">Finaliza el</span>\n {{::serv.endDate|date:\'d/M/yyyy HH:mm\'}} ({{::serv.remainingTimeInMinutes|convertMinutesInHHMMSS}})</span></div><div \nclass=\"grey-500-fg text-italic\" translate=\"VERMAS.CRUSHEDSERVICES\" ng-if=\"vm.habitacion.hasCrushedServices\">\nTiene servicios en el monedero del equipo</div><a ng-click=\"changeRoom()\" class=\"md-warn-fg\" style=\"cursor: pointer\" \ntranslate=\"VERMAS.MOVEPERSONAL\">Mover servicios y saldo</a></fieldset><fieldset class=\"standard\" flex=\"100\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.DATOSUSO\">Datos de uso</legend><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><span flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.ULTCON\">Última conexión:</span> {{::vm.habitacion.status.ultConexion| date:\'dd/MM/yyyy HH:mm\'}} \n</span><span flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.PANTALLA\">Pantalla actual:</span>\n {{::vm.habitacion.status.currentScreen}} ({{::vm.habitacion.status.currentInfo}} / {{::vm.habitacion.status.currentShadow}}) \n</span><span flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.WELCOME\">Mensaje de bienvenida</span>\n <span translate=\"VERMAS.WELCOME_{{::vm.habitacion.properties.displayWelcome}}\"></span> </span><span flex-gt-sm=\"50\" \nflex=\"100\" class=\"text-gray\" ng-if=\"vm.habitacion.uptime\"><span translate=\"VERMAS.UPTIME\">Encendido hace</span>\n {{::vm.habitacion.uptime.uptime}}</span><stb-screenshot stb=\"vm.habitacion\" size=\"30\" class=\"margin-top-8\">\n</stb-screenshot></div></fieldset><fieldset class=\"standard\" flex=\"100\" ng-if=\"listaIncidencias.length\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.INCIDENCIASABIERTAS\">Incidencias abiertas\n</legend><div ng-repeat=\"inc in listaIncidencias\" ng-include=\"\'app/quick-panel/incidence-card.tmpl.html\'\" \nng-init=\"item = inc; isPrevent = false; cardCtrl = incidencesCardCtrl\"></div></fieldset><fieldset class=\"standard\" \nflex=\"100\" ng-if=\"listaPreventivas.length\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.PREVENTIVASABIERTAS\">Incidencias preventivas abiertas</legend><div \nng-repeat=\"inc in listaPreventivas\" ng-include=\"\'app/quick-panel/incidence-card.tmpl.html\'\" \nng-init=\"item = inc; isPrevent = true; cardCtrl = incidencesCardCtrl\"></div></fieldset><md-divider></md-divider><div \nlayout=\"row\" layout-wrap><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"vm.mostrarVentanaEventoRapido($event)\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"30\" translate=\"VERMAS.ENVIAR\">\nEnviar aviso rápido</md-button><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"vm.connectVNC($event)\" \nflex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"30\" translate=\"VERMAS.VNC\">Conectar por VNC</md-button><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"vm.mostrarConfirmacionReinicio($event)\" flex=\"100\" flex-gt-sm=\"45\" \nflex-gt-md=\"30\" translate=\"VERMAS.REINICIO\">Reinicio de sistema</md-button><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"vm.mostrarConfirmacionRecargaInterfaz($event)\" flex=\"100\" \nflex-gt-sm=\"45\" flex-gt-md=\"30\" translate=\"VERMAS.RECARGA\">Recarga de interfaz</md-button></div></form></md-content>\n</div></div>");
$templateCache.put("app/main/Quantion/habitaciones/ver_mas/vnc.tmpl.html","<md-dialog aria-label=\"vnc\" md-theme=\"{{$root.theme}}\"><md-dialog-content class=\"md-dialog-content\"><h2 \nclass=\"md-title\" translate=\"VNC.TITLE\">Conexión establecida</h2><div class=\"md-dialog-content-body\"><p \ntranslate=\"VNC.TEXT\" translate-values=\"{ ip: ip}\">\nTiene 2 minutos para abrir su cliente VNC e introducir la IP {{ip}}. Si cierra el cliente VNC, tendrá que volver a establecer la conexión.\n</p></div></md-dialog-content><md-dialog-actions><input type=\"text\" id=\"formIP\" ng-model=\"ip\" md-select-on-focus \nstyle=\"opacity: 0\"><md-button class=\"md-primary md-button\" ng-click=\"selectIP()\" aria-label=\"Copiar\" \ntranslate=\"VNC.COPIAR\">Copiar IP al portapapeles</md-button><md-button class=\"md-primary md-button\" ng-click=\"hide()\" \naria-label=\"Cerrar\" translate=\"VNC.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/iptv/listaIptv/editar.tmpl.html","<md-dialog id=\"editarCanal\" aria-label=\"Editar canal\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"EDITAR.TITLE\">Editar canal</h2></div></md-toolbar>\n<md-dialog-content><form name=\"formulario\" layout=\"column\"><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container \nlayout=\"column\" class=\"no-errors-spacer flex-gt-xs-50 md-input-has-value\"><label translate=\"CREAR.LOGO\">Logo</label>\n<div class=\"logo-container\" ng-click=\"canal.tipo ? elegirLogo($event) : null\"><img \nng-src=\"{{canal.tvgLogo|replacePath}}\" alt=\"\" ng-show=\"canal.tvgLogo\"></div><div ng-messages=\"\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-if=\"!canal.tvgLogo\" style=\"font-size: 12px\" translate=\"CREAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><div layout=\"column\" flex-gt-xs=\"50\"><md-input-container \nclass=\"no-errors-spacer\"><label translate=\"CREAR.NOMBRE\">Nombre</label><input type=\"text\" name=\"nombre\" \nng-model=\"canal.nombre\" required><div ng-messages=\"formulario.nombre.$error\" multiple=\"multiple\" md-auto-hide=\"false\">\n<div ng-message=\"required\" translate=\"CREAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n<md-input-container class=\"no-errors-spacer\"><label translate=\"CREAR.URL\">URL del streaming</label><input type=\"text\" \nname=\"ipStr\" ng-model=\"canal.urlStreaming\" required><div class=\"hint\">Ej: udp://@239.255.4.36:1234</div><div \nng-messages=\"formulario.ipStr.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"CREAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container></div></div><md-input-container \nclass=\"no-errors-spacer md-input-has-value\"><label translate=\"CREAR.IDIOMA\">Idiomas</label><md-chips \nng-model=\"canal.idiomas\" placeholder=\"Enter para añadir\"><md-chip-template>{{$chip}}</md-chip-template></md-chips>\n</md-input-container><div layout=\"row\" layout-align=\"center center\" ng-if=\"canal.tipo !== \'radio\'\"><md-checkbox \nng-model=\"canal.visible\" aria-label=\"visible\" style=\"margin-top: 16px\" flex=\"50\"><span translate=\"CREAR.VISIBLE\">Activo\n</span></md-checkbox><md-input-container flex=\"50\" class=\"md-input-has-value\"><label translate=\"CREAR.TIPO\">Tipo\n</label><div layout=\"row\" layout-align=\"start center\"><span translate=\"CREAR.TIPO_HD\">HD</span><md-switch \nng-model=\"canal.tipo\" value=\"hd\" aria-label=\"Calidad\" ng-true-value=\"\'sd\'\" ng-false-value=\"\'hd\'\" class=\"md-warn\">\n</md-switch><span translate=\"CREAR.TIPO_SD\">SD</span></div><div ng-messages=\"formulario.tipo.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"CREAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"loading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"CREAR.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"formulario.$invalid\" \nstyle=\"margin-right:20px\" translate=\"CREAR.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/iptv/listaIptv/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenCanal\" aria-label=\"Elegir imagen\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-dialog-content><div layout=\"row\" layout-align=\"start center\"><input type=\"file\" \nid=\"channelLogo\" required accept=\"image/*\"><md-button ng-click=\"uploadFile()\" class=\"md-raised md-primary\"><span \ntranslate=\"FILEEXPLORER.SUBIRARCHIVO\">Enviar archivo</span></md-button></div><md-divider></md-divider><div \nlayout=\"row\" layout-wrap layout-align=\"start stretch\"><div ng-repeat=\"obj in listaLogos| filter: {name:logo_}\" \nlayout=\"column\" layout-align=\"start center\" class=\"element\"><div class=\"img-container\"><img \nng-src=\"{{::(obj.path|replacePath)}}\" ng-click=\"escogerImagen(obj)\"></div><span>{{::obj.name}}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-icon-float md-block no-errors-spacer\"><label translate=\"BUSCAR.BUSCAR\">Buscar</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"logo_\" type=\"text\" id=\"buscador\" \nng-model-options=\"{debounce: 500}\"></md-input-container><span flex></span><md-button \nng-click=\"escogerImagen({path: \'\'})\" translate=\"\">Eliminar logo</md-button><md-button ng-click=\"hide()\" \ntranslate=\"CREAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/iptv/listaIptv/listaIptv.html","<div id=\"listaIptv\" class=\"page-layout simple fullwidth\"><div class=\"content\" layout=\"column\"><md-content \nlayout-padding layout=\"column\"><div layout-gt-sm=\"row\" layout=\"column\"><div layout=\"row\"><md-button \nclass=\"md-fab md-mini md-primary\" ui-sref=\"app.Quantion_iptv_importexport\"><md-icon md-font-icon=\"icon-box-upload\" \nclass=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO.IMPORTAR\">Importar canales</span>\n</md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.exportData()\"><md-icon \nmd-font-icon=\"icon-box-download\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LISTADO.EXPORTAR\">Exportar canales</span></md-tooltip></md-button></div><a href=\"#\" id=\"link\" \ndownload=\"Canales-IPTV\" style=\"display: none\"></a><div layout=\"row\" layout-xs=\"column\" flex \nlayout-align=\"space-between center\"><div class=\"{{vm.flowTemp.status}} flex-gt-xs-50\"><md-icon \nmd-font-icon=\"icon-thermometer\"></md-icon><span><span translate=\"IMPEXP.TEMPFLOW\">Temperatura de la Flow:</span>\n {{vm.flowTemp.temperature}}</span></div><div class=\"alarmas\" ng-if=\"listaAlarmas.length > 0\" flex-gt-xs=\"50\"><div \nng-repeat=\"alm in listaAlarmas\" layout=\"row\" layout-align=\"end center\"><md-icon md-font-icon=\"icon-alert-octagon\">\n</md-icon><span>{{alm.description}}</span></div></div></div></div><md-tabs md-dynamic-height md-border-bottom \nclass=\"white-bg md-whiteframe-4dp\"><md-tab><md-tab-label><span translate=\"LISTADO.CANALESTV\">Canales de Televisión\n</span><md-badge class=\"md-primary-bg\">{{vm.canalesTV.length}}</md-badge></md-tab-label><md-tab-body><div><div \nlayout=\"row\" style=\"margin-bottom: 6px\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo($event, \'tv\')\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO.ADD\">\nAñadir canal de TV</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.eliminarTodosTV($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"LISTADO.ELIMINARTODOTV\">Eliminar todos los canales de TV</span></md-tooltip></md-button></div><table \nid=\"tablaTV\"><thead><tr><th class=\"secondary-text\" flex-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LISTADO.NOMBRE\">Nombre</span></div></th><th class=\"secondary-text\" flex-gt-sm><div class=\"table-header\">\n<span class=\"column-title\" translate=\"LISTADO.LOGO\">Logo</span></div></th><th class=\"secondary-text\" flex-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LISTADO.URL\">URL de streaming</span></div></th><th \nclass=\"secondary-text\" flex-gt-sm><div class=\"table-header\"><span class=\"column-title\" translate=\"LISTADO.IDIOMA\">\nIdioma</span></div></th><th class=\"secondary-text\" flex-gt-sm><div class=\"table-header\"><span class=\"column-title\">\n</span></div></th></tr></thead><tbody id=\"channelTvContainer\"></tbody></table></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"LISTADO.CANALESRL\">Canales de Radio Local</span><md-badge class=\"md-primary-bg\">\n{{vm.canalesRadio.length}}</md-badge></md-tab-label><md-tab-body><div><div layout=\"row\" style=\"margin-bottom: 6px\">\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo($event, \'radio\')\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO.ADD\">Añadir canal de radio local</span>\n</md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarTodosRadio($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LISTADO.ELIMINARTODORADIO\">\nEliminar todos los canales de radio</span></md-tooltip></md-button></div><table id=\"tablaRadio\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LISTADO.NOMBRE\">Nombre</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LISTADO.LOGO\">\nLogo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LISTADO.URL\">URL de streaming</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LISTADO.IDIOMA\">Idioma</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody id=\"channelRadioContainer\">\n</tbody></table></div></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/Quantion/iptv/importexport/importexport.html","<div id=\"importexport\" class=\"page-layout simple fullwidth\"><div class=\"content\" layout=\"column\"><md-content \nlayout-padding layout=\"column\" md-whiteframe=\"1\"><div layout=\"column\"><div layout-gt-xs=\"row\" layout=\"column\" \nflex=\"100\" layout-align=\"space-between center\"><div layout-gt-xs=\"row\" layout=\"column\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.getFlowChannels()\" flex-xs><md-icon md-font-icon=\"icon-data\" class=\"icon\">\n</md-icon><span translate=\"IMPEXP.IMPORT\">Importar de Flow</span></md-button><input type=\"file\" id=\"files\" \naria-label=\"Seleccionar archivo\" hidden><md-button class=\"md-raised md-primary\" ng-click=\"vm.seleccionarArchivo()\" \nflex-xs><md-icon md-font-icon=\"icon-box-upload\" class=\"icon\"></md-icon><span translate=\"IMPEXP.SELECCIONAR\">\nSeleccionar archivo</span></md-button></div><div ng-if=\"vm.listaCanalesImportados\"><md-button \nclass=\"md-icon-button md-raised md-primary\" ng-click=\"vm.guardarSeleccion()\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"IMPEXP.GUARDAR\">Guardar canales seleccionados\n</span></md-tooltip></md-button><md-button class=\"md-icon-button md-raised md-primary\" ng-click=\"vm.seleccionarTodo()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"IMPEXP.SELTODO\">Seleccionar todo</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-raised md-primary\" ng-click=\"vm.deseleccionarTodo()\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"IMPEXP.DESELTODO\">Deseleccionar todo</span></md-tooltip></md-button></div></div><div layout-xs=\"column\" \nlayout=\"row\" flex=\"100\"><div class=\"{{vm.flowTemp.status}} flex-gt-xs-50\"><md-icon md-font-icon=\"icon-thermometer\">\n</md-icon><span><span translate=\"IMPEXP.TEMPFLOW\">Temperatura de la Flow:</span> {{vm.flowTemp.temperature}}</span>\n</div><div class=\"alarmas\" ng-if=\"listaAlarmas.length > 0\" flex-gt-xs=\"50\"><div ng-repeat=\"alm in listaAlarmas\" \nlayout=\"row\" layout-align=\"end center\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span>{{alm.description}}\n</span></div></div></div><div class=\"adv\"><md-icon md-font-icon=\"icon-alert\"></md-icon><span translate=\"IMPEXP.ADV\">\nEl canal aparecerá tachado si su URL de streaming ya pertenece a un canal existente.</span></div><md-list \nclass=\"md-dense\" flex layout=\"row\" layout-wrap><md-subheader class=\"md-no-sticky flex-100 md-accent-bg\">Canales TV\n</md-subheader><md-list-item class=\"md-3-line canal-list-item\" \nng-class=\"{\'disabled\' : vm.incluidos[canal.urlStreaming]}\" ng-repeat=\"canal in vm.listaCanalesImportados.TV\" \nng-click=\"toogleChannel(canal)\"><div class=\"iconoCanal\"><img ng-src=\"{{canal.tvgLogo|replacePath}}\"></div><div \nclass=\"md-list-item-text\" layout=\"column\"><h4 style=\"white-space: normal\"><b>{{canal.nombre}}</b>\n {{canal.idiomas|stringifyArray:true}}</h4><p>{{canal.urlStreaming}}</p></div><md-tooltip md-direction=\"top\" \nng-if=\"vm.incluidos[canal.urlStreaming]\"><span translate=\"IMPEXP.EXISTECANAL\">\nYa existe un canal con esta URL de streaming</span></md-tooltip><md-icon md-font-icon=\"icon-check-circle\" \nclass=\"iconSelected\" ng-show=\"vm.seleccionados[canal.urlStreaming]\"></md-icon></md-list-item></md-list><md-list \nclass=\"md-dense\" flex layout=\"row\" layout-wrap><md-subheader class=\"md-no-sticky flex-100 md-accent-bg\">Canales Radio\n</md-subheader><md-list-item class=\"md-3-line canal-list-item\" \nng-class=\"{\'disabled\' : vm.incluidos[canal.urlStreaming]}\" ng-repeat=\"canal in vm.listaCanalesImportados.RADIO\" \nng-click=\"toogleChannel(canal)\"><div class=\"iconoCanal\"><img ng-src=\"{{canal.tvgLogo|replacePath}}\"></div><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><b>{{canal.nombre}}</b> {{canal.idiomas|stringifyArray:true}}</h4><p>\n{{canal.urlStreaming}}</p></div><md-tooltip md-direction=\"top\" ng-if=\"vm.incluidos[canal.urlStreaming]\"><span \ntranslate=\"IMPEXP.EXISTECANAL\">Ya existe un canal con esta URL de streaming</span></md-tooltip><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"iconSelected\" ng-show=\"vm.seleccionados[canal.urlStreaming]\"></md-icon>\n</md-list-item></md-list><h4 \nng-if=\"vm.canalesExistentesNoImportadosPorFlow && vm.canalesExistentesNoImportadosPorFlow.length > 0\">\nEstos canales se encuentran en la base de datos, pero no se han encontrado en la Flow:</h4><md-list class=\"md-dense\" \nflex layout=\"row\" layout-wrap><md-list-item class=\"md-2-line canal-list-item\" \nng-repeat=\"canal in vm.canalesExistentesNoImportadosPorFlow\"><div class=\"iconoCanal\"><img \nng-src=\"{{canal.tvgLogo|replacePath}}\"></div><div class=\"md-list-item-text\" layout=\"column\"><h4><b>{{canal.nombre}}</b>\n</h4><p>{{canal.urlStreaming}}</p></div><md-button class=\"md-icon-button\" ng-click=\"eliminarCanalDeBD(canal)\" \naria-label=\"Eliminar\"><md-icon md-font-icon=\"icon-trash\" class=\"icon\"></md-icon></md-button></md-list-item></md-list>\n<div class=\"pantallaCarga\" layout-align=\"center center\" ng-show=\"isLoading\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><h1 translate=\"IMPEXP.PROCESANDO\">Procesando canales</h1><h3 translate=\"IMPEXP.TEXTO\">\nEsta acción puede tardar unos segundos</h3><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"120\"></md-progress-circular></div></div></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/lotes/new/lotes.html","<div id=\"lotes\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"LOTES.STBS\">STBs</span></span></md-tab-label><md-tab-body><div><table \nclass=\"stb-filter-form\"><tr><td translate=\"PROPERTIES.room\"></td><td><input ng-model=\"stbFilter.room\" \nng-model-options=\"{debounce: 500}\"></td></tr><tr><td translate=\"PROPERTIES.username\"></td><td><input \nng-model=\"stbFilter.username\" ng-model-options=\"{debounce: 500}\"></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'ip\'}\"><td translate=\"PROPERTIES.ip\"></td><td><input \nng-model=\"stbFilter.ip\" ng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'ip\'\"></md-icon></td></tr><tr ng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'mac\'}\"><td \ntranslate=\"PROPERTIES.mac\"></td><td><input ng-model=\"stbFilter.mac\" ng-model-options=\"{debounce: 500}\"></td><td>\n<md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'mac\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'extension\'}\"><td translate=\"PROPERTIES.extension\"></td><td><input \nng-model=\"stbFilter.extension.$\" ng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'extension\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'lang\'}\"><td translate=\"PROPERTIES.lang\"></td><td><input \nng-model=\"stbFilter.lang\" ng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'lang\'\"></md-icon></td></tr><tr ng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'wallet\'}\">\n<td>Tarjeta y servicios</td><td><input ng-model=\"stbFilter.wallet.$\" ng-model-options=\"{debounce: 500}\"></td><td>\n<md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'wallet\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'instalacion\'}\"><td translate=\"PROPERTIES.installation\"></td><td>\n<input ng-model=\"stbFilter.installation.$\" ng-model-options=\"{debounce: 500}\"><select \nng-model=\"stbFilter.installation.$\"><option ng-repeat=\"inst in vm.listaInstalaciones\" value=\"{{inst.name}}\">\n{{inst.name}}</option></select></td><td><md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'instalacion\'\">\n</md-icon></td></tr><tr ng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'skin\'}\"><td translate=\"PROPERTIES.theme\">\n</td><td><input ng-model=\"stbFilter.properties.themeOverride\" ng-model-options=\"{debounce: 500}\"><select \nng-model=\"stbFilter.properties.themeOverride\"><option ng-repeat=\"theme in vm.listaThemes\" value=\"{{theme}}\">{{theme}}\n</option></select></td><td><md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'skin\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'modelo\'}\"><td translate=\"PROPERTIES.model\"></td><td><input \nng-model=\"stbFilter.model.$\" ng-model-options=\"{debounce: 500}\"><select ng-model=\"stbFilter.model.$\"><option \nng-repeat=\"model in vm.listaModelos\" value=\"{{model.name}}\">{{model.name}}</option></select></td><td><md-icon \nmd-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'modelo\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'wifiAp\'}\"><td translate=\"PROPERTIES.wifiAp\"></td><td><input \nng-model=\"stbFilter.properties.wifiAp.$\" ng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'wifiAp\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'lastDynamic\'}\"><td translate=\"PROPERTIES.lastDynamic\"></td><td><input\n ng-model=\"stbFilter.viewed.lastDynamic\" ng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'lastDynamic\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'lastSystem\'}\"><td translate=\"PROPERTIES.lastSystem\"></td><td><input \nng-model=\"stbFilter.viewed.lastSystem\" ng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'lastSystem\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'forceSystem\'}\"><td translate=\"PROPERTIES.forceSystem\"></td><td>\n<select ng-model=\"stbFilter.updated.forceSystem\"><option value=\"\"></option><option ng-value=\"true\">Si</option><option \nng-value=\"false\">No</option></select></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'forceSystem\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'cleanSystem\'}\"><td translate=\"PROPERTIES.cleanSystem\"></td><td>\n<select ng-model=\"stbFilter.updated.cleanSystem\"><option value=\"\"></option><option ng-value=\"true\">Si</option><option \nng-value=\"false\">No</option></select></td><td><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.actionLabel = \'cleanSystem\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'touch\'}\"><td translate=\"PROPERTIES.touch\"></td><td><select \nng-model=\"stbFilter.properties.touch\"><option value=\"\"></option><option ng-value=\"true\">Si</option><option \nng-value=\"false\">No</option></select></td><td><md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'touch\'\">\n</md-icon></td></tr><tr ng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'resolution\'}\"><td \ntranslate=\"PROPERTIES.resolution\"></td><td><input ng-model=\"stbFilter.properties.resolution\" \nng-model-options=\"{debounce: 500}\"></td><td><md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'resolution\'\">\n</md-icon></td></tr><tr ng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'dashboard\'}\"><td \ntranslate=\"PROPERTIES.sidebar\"></td><td><select ng-model=\"stbFilter.properties.sidebar\"><option value=\"\"></option>\n<option ng-value=\"true\">Si</option><option ng-value=\"false\">No</option></select></td><td><md-icon \nmd-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'dashboard\'\"></md-icon></td></tr><tr \nng-class=\"{\'md-yellow-300-bg\':vm.actionLabel === \'pxehw\'}\"><td translate=\"PROPERTIES.pxehw\"></td><td><select \nng-model=\"stbFilter.properties.pxehw\"><option value=\"\"></option><option ng-value=\"true\">Si</option><option \nng-value=\"false\">No</option></select></td><td><md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.actionLabel = \'pxehw\'\">\n</md-icon></td></tr></table><div layout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"aplicarFiltro()\">\nAplicar filtro</md-button><md-button class=\"md-raised md-accent\" ng-click=\"limpiarFiltro()\">Limpiar filtro</md-button>\n</div></div><form name=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><h2 \nstyle=\"text-align: center; background-color: lightgray\">\n{{vm.actionTitle|translate}} &rightarrow; {{vm.secondaryActionTitle|translate}}</h2><md-button \nclass=\"md-raised md-primary\" ng-click=\"marcarTodo(true)\" translate=\"LOTES.MARCARTODO\">Marcar todo</md-button><md-button\n class=\"md-raised md-primary\" ng-click=\"marcarTodo(false)\" translate=\"LOTES.DESMARCARTODO\">Desmarcar todo</md-button>\n<md-button class=\"md-raised md-primary\" ng-click=\"marcarStorage()\" translate=\"LOTES.MARCARSTORAGE\">Marcar almacenados\n<md-tooltip md-direction=\"right\"><span translate=\"LOTES.MARCARSTORAGETOOLTIP\"></span></md-tooltip></md-button><span>\n<span translate=\"LOTES.NUMMARCADOS\">Seleccionados:</span> {{selected.length}}</span><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-wrap id=\"groupListContainer\"><div class=\"groupContainer\" ng-repeat=\"grupo in listaGrupos\" \nlayout=\"column\" on-last-repeat><div class=\"groupHeader\" layout=\"row\" layout-align=\"center-center\"><div flex>\n{{grupo.nombre}} <span ng-if=\"grupo.place\">({{grupo.place}})</span></div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(grupo, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div class=\"groupBody\" \nlayout=\"column\"><div layout=\"row\" ng-repeat=\"stb in grupo.cStbs| orderBy:\'room\'\"><input type=\"checkbox\" \nng-checked=\"exists(stb.idStb, selected)\" ng-click=\"toggle(stb.idStb, selected)\" aria-label=\"seleccionado\">\n {{stb.room}} - {{stb.username}}<ng-include src=\"vm.actionLabel\"></ng-include></div></div></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"selected.length < 1\"><md-tab-label><span class=\"ms-form-wizard-step-label\">\n<span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"LOTES.ACCION\">Acción</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"vm.action\" \nlayout=\"column\" required ng-change=\"vm.secondaryAction = null\"><h4 translate=\"LOTES.ELIGEACCION\">Elige una acción</h4>\n<md-radio-button value=\"instalacion\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.ASIGNARINSTALACION\'\"><span translate=\"LOTES.ASIGNARINSTALACION\">Asignar instalación\n</span></md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'instalacion\'\"><md-radio-button ng-repeat=\"inst in vm.listaInstalaciones\" \nng-value=\"{installation: inst.idInstallation}\" ng-click=\"vm.secondaryActionTitle = inst.name\">{{inst.name}}\n</md-radio-button></md-radio-group><md-radio-button value=\"modelo\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.ASIGNARMODELO\'\"><span translate=\"LOTES.ASIGNARMODELO\">Asignar modelo</span>\n</md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'modelo\'\"><md-radio-button ng-repeat=\"mod in vm.listaModelos\" ng-value=\"{model: mod.idStbModel}\" \nng-click=\"vm.secondaryActionTitle = mod.name\">{{mod.name}}</md-radio-button></md-radio-group><md-radio-button \nvalue=\"skin\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.ASIGNARSKIN\'\"><span \ntranslate=\"LOTES.ASIGNARSKIN\">Asignar skin</span></md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" \nlayout=\"column\" required ng-if=\"vm.action === \'skin\'\"><md-radio-button ng-repeat=\"theme in vm.listaThemes\" \nng-value=\"{properties:{themeOverride: theme}}\" ng-click=\"vm.secondaryActionTitle = theme\">{{theme}}</md-radio-button>\n</md-radio-group><md-radio-button value=\"updateDynamic\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.FORZARACTDIN\'\"><span translate=\"LOTES.FORZARACTDIN\">\nForzar actualización de imagen dinámica</span></md-radio-button><md-radio-button value=\"updateSystem\" \nng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.FORZARACTSIS\'\"><span \ntranslate=\"LOTES.FORZARACTSIS\">Forzar actualización de sistema</span></md-radio-button><md-radio-group \nng-model=\"vm.secondaryAction\" layout=\"column\" required ng-if=\"vm.action === \'updateSystem\'\"><md-radio-button \nng-value=\"{updated:{forceSystem:true}}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR\'\"><span \ntranslate=\"LOTES.ACTIVAR\">Activar</span></md-radio-button><md-radio-button \nng-value=\"{updated:{forceSystem:true}, systemVersion:null}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR3\'\"><span\n translate=\"LOTES.ACTIVAR3\">Activar y asignar versión por defecto del modelo</span></md-radio-button><md-radio-button \nng-value=\"{updated:{forceSystem:false}}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.DESACTIVAR\'\"><span \ntranslate=\"LOTES.DESACTIVAR\">Desactivar</span></md-radio-button></md-radio-group><md-radio-button value=\"lastSystem\" \nng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.ASIGNARULTSIS\'\"><span \ntranslate=\"LOTES.ASIGNARULTSIS\">Asignar última versión sistema</span></md-radio-button><md-radio-button \nvalue=\"cleanSystem\" ng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" \nng-click=\"vm.actionTitle = \'LOTES.CLEANSYSTEM\'\"><span translate=\"LOTES.CLEANSYSTEM\">Reinstalar versión de sistema\n</span></md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'cleanSystem\'\"><md-radio-button ng-value=\"{updated:{forceSystem:true, cleanSystem: true}}\" \nng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR\'\"><span translate=\"LOTES.ACTIVAR\">Activar</span></md-radio-button>\n<md-radio-button ng-value=\"{updated:{forceSystem:false, cleanSystem: false}}\" \nng-click=\"vm.secondaryActionTitle = \'LOTES.DESACTIVAR\'\"><span translate=\"LOTES.DESACTIVAR\">Desactivar</span>\n</md-radio-button></md-radio-group><md-radio-button value=\"rebootLote\" ng-click=\"vm.actionTitle = \'LOTES.REINICIAR\'\">\n<span translate=\"LOTES.REINICIAR\">Reiniciar dispositivo</span></md-radio-button><md-radio-button \nvalue=\"serviceRebootLote\" ng-click=\"vm.actionTitle = \'LOTES.RECARGAR\'\"><span translate=\"LOTES.RECARGAR\">\nRecargar interfaz</span></md-radio-button><md-radio-button value=\"dynamic\" \nng-if=\"user.mapRole.actions.ADVANCED_GROUP_ACTIONS\" ng-click=\"vm.actionTitle = \'LOTES.DYNAMIC\'\"><span \ntranslate=\"LOTES.DYNAMIC\">Actualizar dynamic</span></md-radio-button><md-radio-button value=\"volume\" \nng-click=\"vm.actionTitle = \'LOTES.VOLUME\'\"><span translate=\"LOTES.VOLUME\">Cambiar volumen máximo</span>\n</md-radio-button><md-slider-container flex ng-if=\"vm.action === \'volume\'\"><md-slider flex md-discrete min=\"0\" \nmax=\"130\" ng-model=\"volume\" \nng-change=\"vm.secondaryAction={properties:{volume:volume}}; vm.secondaryActionTitle = volume\" aria-label=\"volumen\">\n</md-slider></md-slider-container><md-radio-button value=\"txPower\" ng-click=\"vm.actionTitle = \'LOTES.TXPOWER\'\"><span \ntranslate=\"LOTES.TXPOWER\">Cambiar alcance WiFi (txPower)</span></md-radio-button><md-slider-container flex \nng-if=\"vm.action === \'txPower\'\"><md-slider flex md-discrete min=\"0\" max=\"100\" ng-model=\"txPower\" \nng-change=\"vm.secondaryAction={properties:{txPower:txPower}}; vm.secondaryActionTitle = txPower\" aria-label=\"txPower\">\n</md-slider></md-slider-container><md-radio-button value=\"delete\" ng-click=\"vm.actionTitle = \'LOTES.ELIMINAR\'\"><span \ntranslate=\"LOTES.ELIMINAR\">Eliminar habitación</span></md-radio-button><md-radio-button value=\"checkout\" \nng-click=\"vm.actionTitle = \'LOTES.CHECKOUT\'\"><span translate=\"LOTES.CHECKOUT\">Hacer check-out</span></md-radio-button>\n<md-radio-button value=\"checkin\" ng-click=\"vm.actionTitle = \'LOTES.CHECKIN\'\"><span translate=\"LOTES.CHECKIN\">\nHacer check-in</span></md-radio-button><md-radio-button value=\"igualarextension\" \nng-click=\"vm.actionTitle = \'LOTES.IGUALAREXTENSION\'\"><span translate=\"LOTES.IGUALAREXTENSION\">\nPoner como extensión el número de habitación</span></md-radio-button><md-radio-button value=\"dashboard\" \nng-click=\"vm.actionTitle = \'LOTES.DASHBOARD\'\"><span translate=\"LOTES.DASHBOARD\">Activar/desactivar dashboard</span>\n</md-radio-button><md-radio-group ng-model=\"vm.secondaryAction\" layout=\"column\" required \nng-if=\"vm.action === \'dashboard\'\"><md-radio-button ng-value=\"{properties:{sidebar:true}}\" \nng-click=\"vm.secondaryActionTitle = \'LOTES.ACTIVAR\'\"><span translate=\"LOTES.ACTIVAR\">Activar</span></md-radio-button>\n<md-radio-button ng-value=\"{properties:{sidebar: false}}\" ng-click=\"vm.secondaryActionTitle = \'LOTES.DESACTIVAR\'\"><span\n translate=\"LOTES.DESACTIVAR\">Desactivar</span></md-radio-button></md-radio-group><md-radio-button value=\"autorun\" \nng-click=\"vm.actionTitle = \'LOTES.AUTORUN\'\"><span translate=\"LOTES.AUTORUN\">Pantalla de arranque (autorun)</span>\n</md-radio-button><div layout=\"row\" ng-if=\"vm.action === \'autorun\'\" layout-align=\"space-between center\">\n<md-autocomplete flex=\"60\" ng-disabled=\"vm.aclIsNull\" md-selected-item=\"vm.selectedAcl\" placeholder=\"Buscar ACL\" \nmd-require-match md-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" md-min-length=\"0\" \nmd-input-minlength=\"0\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item}}</span>\n</md-item-template><md-not-found>-</md-not-found></md-autocomplete><md-checkbox ng-model=\"vm.aclIsNull\" \naria-label=\"ACL is null\">NULL (Menú home)</md-checkbox></div><md-radio-button value=\"edidCache\" \nng-click=\"vm.actionTitle = \'LOTES.CACHEEDID\'\"><span translate=\"LOTES.CACHEEDID\">Limpiar caché EDID</span>\n</md-radio-button><md-radio-button value=\"patch\" ng-click=\"vm.actionTitle = \'LOTES.PATCH\'\" style=\"margin-top: 18px\" \nclass=\"md-accent-fg\"><span translate=\"LOTES.PATCH\">Editar campos personalizados</span></md-radio-button>\n</md-radio-group><div ng-show=\"vm.action === \'patch\'\"><md-divider></md-divider><h4>Editar campos</h4><table \nclass=\"patch-attr\"><tr><td><md-checkbox ng-checked=\"exists(\'installation\', patchAttr)\" \nng-click=\"toggle(\'installation\', patchAttr)\">Instalación</md-checkbox></td><td \nng-show=\"exists(\'installation\', patchAttr)\"><md-select ng-model=\"patchObj.installation\"><md-option \nng-repeat=\"inst in vm.listaInstalaciones\" ng-value=\"{{inst.idInstallation}}\">{{inst.name}}</md-option></md-select></td>\n</tr><tr><td><md-checkbox ng-checked=\"exists(\'themeOverride\', patchAttr)\" \nng-click=\"toggle(\'themeOverride\', patchAttr)\">Tema</md-checkbox></td><td ng-show=\"exists(\'themeOverride\', patchAttr)\">\n<md-select ng-model=\"patchObj.properties.themeOverride\"><md-option ng-repeat=\"theme in vm.listaThemes\" \nvalue=\"{{theme}}\">{{theme}}</md-option></md-select></td></tr><tr><td><md-checkbox \nng-checked=\"exists(\'model\', patchAttr)\" ng-click=\"toggle(\'model\', patchAttr)\">Modelo</md-checkbox></td><td \nng-show=\"exists(\'model\', patchAttr)\"><md-select ng-model=\"patchObj.model\"><md-option \nng-repeat=\"model in vm.listaModelos\" ng-value=\"{{model.idStbModel}}\">{{model.name}}</md-option></md-select></td></tr>\n<tr><td><md-checkbox ng-checked=\"exists(\'volume\', patchAttr)\" ng-click=\"toggle(\'volume\', patchAttr)\">Volumen máximo\n</md-checkbox></td><td ng-show=\"exists(\'volume\', patchAttr)\"><md-slider-container flex><md-slider flex md-discrete \nmin=\"0\" max=\"130\" ng-model=\"patchObj.properties.volume\" aria-label=\"volumen\"></md-slider></md-slider-container></td>\n</tr><tr><td><md-checkbox ng-checked=\"exists(\'txPower\', patchAttr)\" ng-click=\"toggle(\'txPower\', patchAttr)\">\nAlcance WiFi (txPower)</md-checkbox></td><td ng-show=\"exists(\'txPower\', patchAttr)\"><md-slider-container flex>\n<md-slider flex md-discrete min=\"0\" max=\"100\" ng-model=\"patchObj.properties.txPower\" aria-label=\"txPower\"></md-slider>\n</md-slider-container></td></tr><tr><td><md-checkbox ng-checked=\"exists(\'sidebar\', patchAttr)\" \nng-click=\"toggle(\'sidebar\', patchAttr)\">Dashboard</md-checkbox></td><td ng-show=\"exists(\'sidebar\', patchAttr)\">\n<md-select ng-model=\"patchObj.properties.sidebar\"><md-option ng-value=\"true\">Si</md-option><md-option ng-value=\"false\">\nNo</md-option></md-select></td></tr><tr><td><md-checkbox ng-checked=\"exists(\'touch\', patchAttr)\" \nng-click=\"toggle(\'touch\', patchAttr)\">¿Es táctil?</md-checkbox></td><td ng-show=\"exists(\'touch\', patchAttr)\"><md-select\n ng-model=\"patchObj.properties.touch\"><md-option ng-value=\"true\">Si</md-option><md-option ng-value=\"false\">No\n</md-option></md-select></td></tr><tr><td><md-checkbox ng-checked=\"exists(\'pxehw\', patchAttr)\" \nng-click=\"toggle(\'pxehw\', patchAttr)\">PXE Hardware</md-checkbox></td><td ng-show=\"exists(\'pxehw\', patchAttr)\">\n<md-select ng-model=\"patchObj.properties.pxehw\"><md-option ng-value=\"true\">Si</md-option><md-option ng-value=\"false\">No\n</md-option></md-select></td></tr><tr><td><md-checkbox ng-checked=\"exists(\'displayWelcome\', patchAttr)\" \nng-click=\"toggle(\'displayWelcome\', patchAttr)\">Mensaje de bienvenida</md-checkbox></td><td \nng-show=\"exists(\'displayWelcome\', patchAttr)\"><md-select ng-model=\"patchObj.properties.displayWelcome\"><md-option \nng-value=\"true\">Si</md-option><md-option ng-value=\"false\">No</md-option></md-select></td></tr><tr><td><md-checkbox \nng-checked=\"exists(\'forceSystem\', patchAttr)\" ng-click=\"toggle(\'forceSystem\', patchAttr)\">Forzar act. sistema\n</md-checkbox></td><td ng-show=\"exists(\'forceSystem\', patchAttr)\"><md-select ng-model=\"patchObj.updated.forceSystem\">\n<md-option ng-value=\"true\">Si</md-option><md-option ng-value=\"false\">No</md-option></md-select></td></tr><tr><td>\n<md-checkbox ng-checked=\"exists(\'cleanSystem\', patchAttr)\" ng-click=\"toggle(\'cleanSystem\', patchAttr)\">\nInst. sistema desde cero</md-checkbox></td><td ng-show=\"exists(\'cleanSystem\', patchAttr)\"><md-select \nng-model=\"patchObj.updated.cleanSystem\"><md-option ng-value=\"true\">Si</md-option><md-option ng-value=\"false\">No\n</md-option></md-select></td></tr><tr><td><md-checkbox ng-checked=\"exists(\'dynamicVersion\', patchAttr)\" \nng-click=\"toggle(\'dynamicVersion\', patchAttr)\">Imagen dinámica</md-checkbox></td><td \nng-show=\"exists(\'dynamicVersion\', patchAttr)\"><md-select ng-model=\"patchObj.dynamicVersion\"><md-option ng-value=\"null\">\nLa última</md-option><md-option ng-value=\"item.idItemVersion\" \nng-repeat=\"item in dynamicIntersectionList track by $index\">{{item.name}}</md-option></md-select></td></tr></table>\n</div></form></md-tab-body></md-tab><md-tab ng-disabled=\"selected.length < 1 || !vm.action\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$invalid\">3</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"LOTES.PROGRESO\">Progreso</span></span></md-tab-label><md-tab-body><form \nname=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"vm.launchOpt.mode\" \nlayout=\"column\" required><h4 translate=\"LOTES.MODOLANZAR\">Elige modo</h4><md-radio-button value=\"simultaneo\">A la vez\n</md-radio-button><md-radio-button value=\"progresivo\" ng-disabled=\"vm.action !== \'patch\'\">\nProgresivo (Solo para la opción \"Editar campos personalizados\")</md-radio-button></md-radio-group><md-input-container \nclass=\"md-block no-errors-spacer\" ng-if=\"vm.launchOpt.mode === \'progresivo\'\"><label>Intervalo (en segundos)</label>\n<input required type=\"number\" name=\"intervalo\" ng-model=\"vm.launchOpt.interval\" min=\"0\" max=\"9999\">\n</md-input-container><md-radio-group ng-model=\"vm.launchOpt.postAction\" layout=\"column\" required><h4 \ntranslate=\"LOTES.POSTACTION\">Acción tras modificación</h4><md-radio-button value=\"ninguna\">Ninguna</md-radio-button>\n<md-radio-button value=\"recarga\">Recarga de interfaz</md-radio-button><md-radio-button value=\"dynamic\" \nng-disabled=\"vm.launchOpt.mode !== \'progresivo\'\">Actualizar dynamic</md-radio-button><md-radio-button value=\"reinicio\">\nReinicio</md-radio-button></md-radio-group></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">Anterior</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Siguiente</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"enviar(msWizard)\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete() || vm.yaEnviado\">\nEnviar</md-button><img ng-if=\"cargando\" src=\"/assets/quantionImagenes/cargando.gif\"></div></ms-form-wizard>\n</md-content><md-content layout-padding layout=\"column\" md-whiteframe=\"1\" class=\"margin-top-8\"><div \nclass=\"progress-log-container\"><div class=\"progress-log-container-header md-primary-bg layout-row\"><p flex>Progreso</p>\n<div class=\"layout-row\"><md-button class=\"md-icon-button md-warn\" aria-label=\"play\" ng-click=\"resumeProcess()\" \nng-show=\"paused\"><md-icon md-font-icon=\"icon-play\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" \naria-label=\"pause\" ng-click=\"pauseProcess()\" ng-hide=\"paused\"><md-icon md-font-icon=\"icon-pause\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-warn\" aria-label=\"stop\" ng-click=\"stopProcess()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div><div id=\"progressLog\" layout=\"column\"></div></div>\n</md-content></div></div><script type=\"text/ng-template\" id=\"ip\"><span class=\"d\">({{stb.ip}})</span></script><script \ntype=\"text/ng-template\" id=\"mac\"><span class=\"d\">({{stb.mac}})</span></script><script type=\"text/ng-template\" \nid=\"extension\"><span class=\"d\">({{stb.extension.number}})</span></script><script type=\"text/ng-template\" id=\"lang\">\n<span class=\"d\">({{stb.lang}})</span></script><script type=\"text/ng-template\" id=\"wallet\">\n<span class=\"d\">({{stb.wallet.type}}/{{stb.wallet.identifier}})</span></script><script type=\"text/ng-template\" \nid=\"instalacion\"><span class=\"d\">({{stb.installation.name}})</span></script><script type=\"text/ng-template\" id=\"skin\">\n<span class=\"d\">({{stb.properties.themeOverride}})</span></script><script type=\"text/ng-template\" id=\"modelo\">\n<span class=\"d\">({{stb.model.name}})</span></script><script type=\"text/ng-template\" id=\"wifiAp\">\n<span class=\"d\">({{stb.properties.wifiAp.name}})</span></script><script type=\"text/ng-template\" id=\"updateDynamic\">\n<span class=\"d\" translate=\"LOTES.ACTUALDIN_{{stb.updated.forceDynamic?\'SI\':\'NO\'}}\">(Act. auto. img. din.:)</span>\n    <md-tooltip md-direction=\"right\"><span translate=\"LOTES.ACTUALIMGDIN\">Ult. ver. img. din.:</span> <em translate=\"{{stb.viewed.lastDynamic||\'LOTES.NINGUNA\'}}\"></em></md-tooltip>\n</script><script type=\"text/ng-template\" id=\"updateSystem\">\n<span class=\"d\" translate=\"LOTES.ACTUALSIS_{{stb.updated.forceSystem?\'SI\':\'NO\'}}\">(Act. auto. sistema:)</span>\n    <md-tooltip md-direction=\"right\"><span translate=\"LOTES.ACTUALIMGSIS\">Ult. ver. sistema:</span> <em translate=\"{{stb.viewed.lastSystem||\'LOTES.NINGUNA\'}}\"></em></md-tooltip>\n</script><script type=\"text/ng-template\" id=\"updateBios\">\n<span class=\"d\" translate=\"LOTES.ACTUALBIOS_{{stb.updated.forceBios?\'SI\':\'NO\'}}\">(Act. auto. BIOS:)</span>\n    <md-tooltip md-direction=\"right\"><span translate=\"LOTES.ACTUALIMGBIOS\">Ult. Bios:</span> <em translate=\"{{stb.viewed.lastBios||\'LOTES.NINGUNA\'}}\"></em></md-tooltip>\n</script><script type=\"text/ng-template\" id=\"lastDynamic\">\n<span class=\"d\">(<em translate=\"{{stb.viewed.lastDynamic||\'LOTES.NINGUNA\'}}\"></em> >> <em translate=\"{{stb.dynamicVersion.name||\'LOTES.NINGUNA\'}}\"></em>)</span>\n</script><script type=\"text/ng-template\" id=\"lastSystem\">\n<span class=\"d\">(<em translate=\"{{stb.viewed.lastSystem||\'LOTES.NINGUNA\'}}\"></em> >> <em translate=\"{{stb.systemVersion.name||\'LOTES.NINGUNA\'}}\"></em>)</span>\n</script><script type=\"text/ng-template\" id=\"forceSystem\">\n<md-icon md-font-icon=\"icon-check\" style=\"color: green\" ng-if=\"stb.updated.forceSystem\"></md-icon>\n    <md-icon md-font-icon=\"icon-close\" style=\"color: red\" ng-if=\"!stb.updated.forceSystem\"></md-icon>\n</script><script type=\"text/ng-template\" id=\"cleanSystem\">\n<md-icon md-font-icon=\"icon-check\" style=\"color: green\" ng-if=\"stb.updated.cleanSystem\"></md-icon>\n    <md-icon md-font-icon=\"icon-close\" style=\"color: red\" ng-if=\"!stb.updated.cleanSystem\"></md-icon>\n</script><script type=\"text/ng-template\" id=\"touch\">\n<md-icon md-font-icon=\"icon-check\" style=\"color: green\" ng-if=\"stb.properties.touch\"></md-icon>\n    <md-icon md-font-icon=\"icon-close\" style=\"color: red\" ng-if=\"!stb.properties.touch\"></md-icon>\n</script><script type=\"text/ng-template\" id=\"resolution\">\n<span class=\"d\">(<em>{{stb.properties.resolution===\'1x1\'?\'Auto\':stb.properties.resolution}}</em>)</span></script>\n<script type=\"text/ng-template\" id=\"dashboard\">\n<md-icon md-font-icon=\"icon-check\" style=\"color: green\" ng-if=\"stb.properties.sidebar\"></md-icon>\n    <md-icon md-font-icon=\"icon-close\" style=\"color: red\" ng-if=\"!stb.properties.sidebar\"></md-icon>\n</script><script type=\"text/ng-template\" id=\"pxehw\">\n<md-icon md-font-icon=\"icon-check\" style=\"color: green\" ng-if=\"stb.properties.pxehw\"></md-icon>\n    <md-icon md-font-icon=\"icon-close\" style=\"color: red\" ng-if=\"!stb.properties.pxehw\"></md-icon>\n</script><script type=\"text/ng-template\" id=\"rebootLote\"></script><script type=\"text/ng-template\" \nid=\"serviceRebootLote\"></script><script type=\"text/ng-template\" id=\"dynamic\"></script><script type=\"text/ng-template\" \nid=\"volume\"><span class=\"d\">({{stb.properties.volume}})</span></script><script type=\"text/ng-template\" id=\"txPower\">\n<span class=\"d\">({{stb.properties.txPower}})</span></script><script type=\"text/ng-template\" id=\"delete\"></script>\n<script type=\"text/ng-template\" id=\"checkout\"><span class=\"d\">({{stb.check.type}})</span></script><script \ntype=\"text/ng-template\" id=\"checkin\"><span class=\"d\">({{stb.check.type}})</span></script><script \ntype=\"text/ng-template\" id=\"igualarextension\"><span class=\"d\">(Nº {{stb.extension.number}})</span></script><script \ntype=\"text/ng-template\" id=\"autorun\"><span class=\"d\">({{stb.autorun}})</span></script><script type=\"text/ng-template\" \nid=\"patch\"></script>");
$templateCache.put("app/main/Quantion/estadisticas/banners/banners.html","<div id=\"estadisticas-urls\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><form name=\"busquedaForm\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between start\" flex><md-radio-group ng-model=\"selectedOption\" required><md-radio-button \nvalue=\"Todos\"><span translate=\"ESTADISTICAS.TODOS\">Todos</span></md-radio-button><md-radio-button value=\"Varios\"><span \ntranslate=\"ESTADISTICAS.VARIOSSTB\">Varios equipos</span></md-radio-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.asignarStbs($event)\" ng-if=\"selectedOption === \'Varios\'\">Seleccionar equipos ({{vm.selectedStbs.length}})\n</md-button><md-radio-button value=\"Individual\"><span translate=\"ESTADISTICAS.UNSTB\">Un STB</span></md-radio-button>\n</md-radio-group><div><div layout=\"column\" layout-gt-sm=\"row\" class=\"margin-bottom-15\"><div layout=\"column\"><span \ntranslate=\"ESTADISTICAS.REPORTEINICIO\">Reporte inicio</span> <input type=\"date\" name=\"ini\" ng-model=\"inicioBusqueda\" \nrequired></div><div layout=\"column\"><span translate=\"ESTADISTICAS.REPORTEFIN\">Reporte fin</span> <input type=\"date\" \nname=\"fin\" ng-model=\"finBusqueda\" required></div></div><md-autocomplete md-selected-item=\"selectedStb\" flex \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)|orderBy:\'room\'\" \nmd-item-text=\"item.room + \' - \' + item.username + \' (\' + item.mac + \')\'\" md-min-length=\"0\" md-select-on-match=\"true\" \nplaceholder=\"{{\'ESTADISTICAS.BUSCARSTB\'|translate}}\" ng-show=\"selectedOption === \'Individual\'\" name=\"stb\" required>\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.room}} - {{item.username}} ({{item.mac}})</span></md-item-template></md-autocomplete></div><md-button \nclass=\"md-fab md-mini\" ng-click=\"CargarEstadisticas(inicioBusqueda, finBusqueda)\" \nng-disabled=\"busquedaForm.$invalid || (selectedOption === \'Individual\' && !selectedStb) || (selectedOption === \'Varios\' && vm.selectedStbs.length <= 0)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"ESTADISTICAS.BUSCAR\">\nBuscar</span></md-tooltip></md-button></form><div layout=\"row\" ng-show=\"vm.completeStatsObj\"><ms-widget \nflippable=\"false\" layout=\"column\" flex><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"ESTADISTICAS.BANNERSMASPOPULARES\">Banners más populares\n</div></div><md-content><div class=\"ph-16 pv-20 border-bottom\" \nng-repeat=\"elm in vm.completeStatsObj.banners| orderBy:\'-value.visits\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h4 pb-10\">{{elm.key}}</span><div class=\"pl-32 h3 font-weight-500 secondary-text\">{{elm.value.visits}} \n<span translate=\"ESTADISTICAS.VISITAS\">visitas</span> ({{elm.value.time|convertSeconds}})</div></div>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{100 * elm.value.visits / vm.completeStatsObj.visits}}\"></md-progress-linear></div></div></md-content>\n</ms-widget-front></ms-widget></div><h3 class=\"errorStats\" ng-show=\"!vm.completeStatsObj\">{{dataError}}</h3>\n</md-content></div></div>");
$templateCache.put("app/main/Quantion/estadisticas/instantanea/instantanea.html","<div id=\"instantanea\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><form name=\"busquedaForm\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between start\" flex><md-radio-group ng-model=\"selectedOption\" required><md-radio-button \nvalue=\"Todos\"><span translate=\"ESTADISTICAS.TODOS\">Todos</span></md-radio-button><md-radio-button value=\"Individual\">\n<span translate=\"ESTADISTICAS.VARIOSSTB\">Varios equipos</span></md-radio-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.asignarStbs($event)\" ng-if=\"selectedOption === \'Individual\'\">\nSeleccionar equipos</md-button></md-radio-group><div layout=\"column\" class=\"date-container\"><span \ntranslate=\"ESTADISTICAS.FECHAEXACTA\" flex=\"100\">Fecha y hora</span> <input type=\"datetime-local\" \nng-model=\"fechaBusqueda\" flex=\"100\" required></div><md-button class=\"md-fab md-mini\" \nng-click=\"CargarEstadisticas(fechaBusqueda)\" \nng-disabled=\"busquedaForm.$invalid || (selectedOption === \'Individual\' && vm.selectedStbs.length < 1) || !vm.mapStbByMac\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"ESTADISTICAS.BUSCAR\">\nBuscar</span></md-tooltip></md-button></form><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nng-show=\"vm.listaEstadisticas\"><md-tab label=\"{{\'ESTADISTICAS.POREQUIPO\'|translate}}\"><table><tr><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'fullStb.room\', \'ord-asc\':orderProp === \'fullStb.room\' && !orderReverse, \'ord-desc\':orderProp === \'fullStb.room\' && orderReverse}\" \nng-click=\"sortBy(\'fullStb.room\')\">Habitación</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'status\', \'ord-asc\':orderProp === \'status\' && !orderReverse, \'ord-desc\':orderProp === \'status\' && orderReverse}\" \nng-click=\"sortBy(\'status\')\">Módulo</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'info\', \'ord-asc\':orderProp === \'info\' && !orderReverse, \'ord-desc\':orderProp === \'info\' && orderReverse}\" \nng-click=\"sortBy(\'info\')\">Info</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'screen\', \'ord-asc\':orderProp === \'screen\' && !orderReverse, \'ord-desc\':orderProp === \'screen\' && orderReverse}\" \nng-click=\"sortBy(\'screen\')\">Pantalla</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'shadow\', \'ord-asc\':orderProp === \'shadow\' && !orderReverse, \'ord-desc\':orderProp === \'shadow\' && orderReverse}\" \nng-click=\"sortBy(\'shadow\')\">Shadow</th></tr><tr class=\"filter-tr\"><td><input type=\"text\" ng-model=\"flt.fullStb.room\" \nng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" ng-model=\"flt.status\" \nng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" ng-model=\"flt.info\" ng-model-options=\"{debounce: 500}\">\n</td><td><input type=\"text\" ng-model=\"flt.screen\" ng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" \nng-model=\"flt.shadow\" ng-model-options=\"{debounce: 500}\"></td></tr><tr \nng-repeat=\"stat in vm.listaEstadisticas| filter: flt| orderBy: orderProp: orderReverse track by $index\"><td>\n{{stat.fullStb.room|| \'?\'}}</td><td>{{stat.status}}</td><td>{{stat.info}}</td><td>{{stat.screen}}</td><td>\n{{stat.shadow}}</td></tr></table></md-tab><md-tab label=\"{{\'ESTADISTICAS.AGRUPADAS\'|translate}}\"><table><tr><th \nclass=\"column-title\" \nng-class=\"{\'ord-no\':orderProp2 !== \'status\', \'ord-asc\':orderProp2 === \'status\' && !orderReverse2, \'ord-desc\':orderProp2 === \'status\' && orderReverse2}\" \nng-click=\"sortBy2(\'status\')\">Módulo</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp2 !== \'info\', \'ord-asc\':orderProp2 === \'info\' && !orderReverse2, \'ord-desc\':orderProp2 === \'info\' && orderReverse2}\" \nng-click=\"sortBy2(\'info\')\">Info</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp2 !== \'screen\', \'ord-asc\':orderProp2 === \'screen\' && !orderReverse2, \'ord-desc\':orderProp2 === \'screen\' && orderReverse2}\" \nng-click=\"sortBy2(\'screen\')\">Pantalla</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp2 !== \'shadow\', \'ord-asc\':orderProp2 === \'shadow\' && !orderReverse2, \'ord-desc\':orderProp2 === \'shadow\' && orderReverse2}\" \nng-click=\"sortBy2(\'shadow\')\">Shadow</th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp2 !== \'stbs.length\', \'ord-asc\':orderProp2 === \'stbs.length\' && !orderReverse2, \'ord-desc\':orderProp2 === \'stbs.length\' && orderReverse2}\" \nng-click=\"sortBy2(\'stbs.length\')\">Habitaciones</th></tr><tr class=\"filter-tr\"><td><input type=\"text\" \nng-model=\"flt.status\" ng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" ng-model=\"flt.info\" \nng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" ng-model=\"flt.screen\" \nng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" ng-model=\"flt.shadow\" \nng-model-options=\"{debounce: 500}\"></td><td><input type=\"text\" ng-model=\"flt.stbs\" ng-model-options=\"{debounce: 500}\">\n</td></tr><tr \nng-repeat=\"stat in vm.estadisticasAgrupadas| filter: flt| orderBy: orderProp2: orderReverse2 track by $index\"><td>\n{{stat.status}}</td><td>{{stat.info}}</td><td>{{stat.screen}}</td><td>{{stat.shadow}}</td><td><b>({{stat.stbs.length}})\n</b> {{stat.stbs|orderBy|stringifyArray}}</td></tr></table></md-tab></md-tabs><h3 class=\"errorStats\" \nng-show=\"!vm.completeStatsObj\">{{dataError}}</h3></md-content></div></div>");
$templateCache.put("app/main/Quantion/estadisticas/tv/tv.html","<div id=\"estadisticas-tv\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><form name=\"busquedaForm\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between start\" flex><md-radio-group ng-model=\"selectedOption\" required><md-radio-button \nvalue=\"Todos\"><span translate=\"ESTADISTICAS.TODOS\">Todos</span></md-radio-button><md-radio-button value=\"Varios\"><span \ntranslate=\"ESTADISTICAS.VARIOSSTB\">Varios equipos</span></md-radio-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.asignarStbs($event)\" ng-if=\"selectedOption === \'Varios\'\">Seleccionar equipos ({{vm.selectedStbs.length}})\n</md-button><md-radio-button value=\"Individual\"><span translate=\"ESTADISTICAS.UNSTB\">Un STB</span></md-radio-button>\n</md-radio-group><div><div layout=\"column\" layout-gt-sm=\"row\" class=\"margin-bottom-15\"><div layout=\"column\"><span \ntranslate=\"ESTADISTICAS.REPORTEINICIO\">Reporte inicio</span> <input type=\"date\" name=\"ini\" ng-model=\"inicioBusqueda\" \nrequired></div><div layout=\"column\"><span translate=\"ESTADISTICAS.REPORTEFIN\">Reporte fin</span> <input type=\"date\" \nname=\"fin\" ng-model=\"finBusqueda\" required></div></div><md-autocomplete md-selected-item=\"selectedStb\" flex \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)|orderBy:\'room\'\" \nmd-item-text=\"item.room + \' - \' + item.username + \' (\' + item.mac + \')\'\" md-min-length=\"0\" md-select-on-match=\"true\" \nplaceholder=\"{{\'ESTADISTICAS.BUSCARSTB\'|translate}}\" ng-show=\"selectedOption === \'Individual\'\" name=\"stb\" required>\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.room}} - {{item.username}} ({{item.mac}})</span></md-item-template></md-autocomplete></div><md-button \nclass=\"md-fab md-mini\" ng-click=\"CargarEstadisticas(inicioBusqueda, finBusqueda)\" \nng-disabled=\"busquedaForm.$invalid || (selectedOption === \'Individual\' && !selectedStb) || (selectedOption === \'Varios\' && vm.selectedStbs.length <= 0)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"ESTADISTICAS.BUSCAR\">\nBuscar</span></md-tooltip></md-button></form><div layout=\"row\" ng-show=\"vm.completeStatsObj\"><ms-widget \nflippable=\"false\" layout=\"column\" flex><div class=\"ph-16 pv-20 mb-10 border-bottom md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h3\">Total</span><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{vm.completeStatsObj[\'TV\'].time|convertSecondsWithoutDays}}</div></div></div></div><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"ESTADISTICAS.CANALESMASVISTOS\">Canales más vistos</div></div><md-content style=\"border-radius: 0\"><div \nclass=\"ph-16 pv-20 border-bottom\" ng-repeat=\"elm in vm.completeStatsObj[\'TV\'].inArray| orderBy:\'-time\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"pb-10\"><span class=\"h4\">{{elm.channel}}</span><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{100 * elm.time / vm.completeStatsObj[\'TV\'].time|number:1}}% ({{elm.time|convertSecondsWithoutDays}})</div></div>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{100 * elm.time / vm.completeStatsObj[\'TV\'].time}}\"></md-progress-linear></div></div></md-content>\n</ms-widget-front><md-button class=\"md-raised md-primary\" ng-click=\"downloadCsv(\'TV\')\" style=\"margin: 8px auto\">\nExportar CSV</md-button></ms-widget></div><h3 class=\"errorStats\" ng-show=\"!vm.completeStatsObj\">{{dataError}}</h3>\n</md-content></div></div>");
$templateCache.put("app/main/Quantion/estadisticas/urls/urls.html","<div id=\"estadisticas-urls\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\">\n<md-content layout-padding layout=\"column\"><form name=\"busquedaForm\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between start\" flex><md-radio-group ng-model=\"selectedOption\" required><md-radio-button \nvalue=\"Todos\"><span translate=\"ESTADISTICAS.TODOS\">Todos</span></md-radio-button><md-radio-button value=\"Varios\"><span \ntranslate=\"ESTADISTICAS.VARIOSSTB\">Varios equipos</span></md-radio-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.asignarStbs($event)\" ng-if=\"selectedOption === \'Varios\'\">Seleccionar equipos ({{vm.selectedStbs.length}})\n</md-button><md-radio-button value=\"Individual\"><span translate=\"ESTADISTICAS.UNSTB\">Un STB</span></md-radio-button>\n</md-radio-group><div><div layout=\"column\" layout-gt-sm=\"row\" class=\"margin-bottom-15\"><div layout=\"column\"><span \ntranslate=\"ESTADISTICAS.REPORTEINICIO\">Reporte inicio</span> <input type=\"date\" name=\"ini\" ng-model=\"inicioBusqueda\" \nrequired></div><div layout=\"column\"><span translate=\"ESTADISTICAS.REPORTEFIN\">Reporte fin</span> <input type=\"date\" \nname=\"fin\" ng-model=\"finBusqueda\" required></div></div><md-autocomplete md-selected-item=\"selectedStb\" flex \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)|orderBy:\'room\'\" \nmd-item-text=\"item.room + \' - \' + item.username + \' (\' + item.mac + \')\'\" md-min-length=\"0\" md-select-on-match=\"true\" \nplaceholder=\"{{\'ESTADISTICAS.BUSCARSTB\'|translate}}\" ng-show=\"selectedOption === \'Individual\'\" name=\"stb\" required>\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.room}} - {{item.username}} ({{item.mac}})</span></md-item-template></md-autocomplete></div><md-button \nclass=\"md-fab md-mini\" ng-click=\"CargarEstadisticas(inicioBusqueda, finBusqueda)\" \nng-disabled=\"busquedaForm.$invalid || (selectedOption === \'Individual\' && !selectedStb) || (selectedOption === \'Varios\' && vm.selectedStbs.length <= 0)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"ESTADISTICAS.BUSCAR\">\nBuscar</span></md-tooltip></md-button></form><div layout=\"row\" ng-show=\"vm.completeStatsObj\"><ms-widget \nflippable=\"false\" layout=\"column\" flex><div class=\"ph-16 pv-20 mb-10 border-bottom md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h3\">Total</span><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{vm.completeStatsObj.time|convertSecondsWithoutDays}}</div></div></div></div><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"ESTADISTICAS.WEBSMASVISITADAS\">Webs más visitadas</div></div><md-content><div \nclass=\"ph-16 pv-20 border-bottom\" ng-repeat=\"elm in vm.completeStatsObj.shadows| orderBy:\'-time\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h4 pb-10\">{{elm.shadow}}</span><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{100 * elm.time / vm.completeStatsObj.time|number:1}}% ({{elm.time|convertSecondsWithoutDays}})</div></div>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{100 * elm.time / vm.completeStatsObj.time}}\">\n</md-progress-linear></div></div></md-content></ms-widget-front></ms-widget></div><h3 class=\"errorStats\" \nng-show=\"!vm.completeStatsObj\">{{dataError}}</h3></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/cversiones/cversiones.html","<div id=\"cVersiones\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\" layout-xs=\"column\" layout-align-gt-xs=\"space-between\">\n<export-to-file filename=\"Backup-Versiones\" tooltip-text=\"{{\'CVERSIONES.EXPORTARDATOS\'|translate}}\" \ndata=\"vm.fileLists\"></export-to-file><md-button class=\"md-raised md-primary\" href=\"/habitaciones/modelos\" \ntranslate=\"CVERSIONES.IR_MODELOS\">Ir a modelos</md-button></div><form name=\"subirVersion\" class=\"md-inline-form\" \nnovalidate><fieldset class=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"CVERSIONES.SUBIRNUEVA\">Subir nueva versión</legend><div layout=\"row\" layout-align=\"start center\" \nstyle=\"min-height: 150px; width: 100%\" ng-if=\"vm.fileOptions.file\" layout-padding layout-wrap><div class=\"fileData\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" md-whiteframe=\"3\" layout-padding><img \nng-src=\"{{vm.fileIcons[vm.fileOptions.fileType]}}\" alt=\"\"><div layout=\"column\"><span><strong \nng-style=\"{color: subirVersion.fileName.$invalid ? \'red\' : \'auto\'}\">\n{{subirVersion.fileName.$invalid ? \'???\' :vm.fileOptions.fileName}}</strong> ({{vm.fileOptions.file.type|| \'n/a\'}}) \n</span><span><span translate=\"CVERSIONES.TAMANO\">Tamaño:</span> {{(vm.fileOptions.file.size / 1000000).toFixed(2)}} mb \n</span><span><span translate=\"CVERSIONES.ULTMOD\">Últ. modificación:</span>\n {{vm.fileOptions.file.lastModifiedDate ? vm.fileOptions.file.lastModifiedDate.toLocaleDateString(\'es-ES\') : \'n/a\'}}\n</span></div></div><div flex=\"5\"></div><div layout=\"row\"><md-radio-group name=\"fileType\" \nng-model=\"vm.fileOptions.fileType\" layout=\"column\" required ng-change=\"checkExistent()\"><md-radio-button \nvalue=\"dynamic\"><span translate=\"CVERSIONES.DYNAMIC\">Paquete dinámico (DYNAMIC)</span></md-radio-button>\n<md-radio-button value=\"bios\"><span translate=\"CVERSIONES.BIOS\">Versión de la BIOS (BIOS)</span></md-radio-button>\n</md-radio-group></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\" layout-wrap layout-align=\"start start\">\n<md-input-container flex=\"50\" flex-xs=\"100\" class=\"no-errors-spacer\"><label translate=\"CVERSIONES.NOMBREVERSION\">\nNombre de la versión</label><input ng-model=\"vm.fileOptions.fileName\" name=\"fileName\" type=\"text\" maxlength=\"40\" \nrequired ng-change=\"checkExistent()\"><div ng-messages=\"subirVersion.fileName.$error\"><div ng-message=\"required\" \ntranslate=\"CVERSIONES.REQUIRED\">El archivo debe tener un nombre.</div><div ng-message=\"maxlength\" \ntranslate=\"CVERSIONES.MAX\">El nombre debe tener menos de 40 caracteres.</div></div><div class=\"hint\" \ntranslate=\"CVERSIONES.HINTEXTENSION\">Añadir la extensión del archivo si la tuviera.</div><div class=\"error\" \nng-show=\"fileNameExistent\" translate=\"CVERSIONES.ERRORSOBREESCRIBIR\">\nYa existe un archivo con este nombre. Si continúa, se sobreescribirá el que ya existe.</div></md-input-container>\n<md-input-container flex=\"50\" flex-xs=\"100\" class=\"no-errors-spacer\"><label translate=\"CVERSIONES.HASHMD5\">Hash MD5\n</label><input ng-model=\"vm.fileOptions.fileMD5\" name=\"hashMD5\" type=\"text\" required ng-change=\"hideMD5message()\"><div \nng-messages=\"subirVersion.hashMD5.$error\"><div ng-message=\"required\" translate=\"CVERSIONES.REQUIREDMD5\">\nDebe indicar el HashMD5 del archivo.</div></div><div class=\"error\" ng-show=\"md5Wrong\" translate=\"CVERSIONES.ERRORMD5\">\nEl MD5 no es correcto.</div><div class=\"hint\" translate=\"CVERSIONES.HINTCOMANDOMD5\">\nPuedes obtener el HashMD5 desde la consola de Linux: con el comando \'<em>md5sum (nombre de archivo)</em>\'</div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" class=\"no-errors-spacer\"><label \ntranslate=\"CVERSIONES.HASHSHA1\">Hash SHA1</label><input ng-model=\"vm.fileOptions.fileSHA\" name=\"hashSHA1\" type=\"text\">\n<div class=\"hint\" translate=\"CVERSIONES.HINTCOMANDOSHA1\">\nPuedes obtener el SHA1 desde la consola de Linux: con el comando \'<em>sha1sum (nombre de archivo)</em>\'</div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" class=\"no-errors-spacer\"><label \ntranslate=\"CVERSIONES.HASHSHA256\">Hash SHA256</label><input ng-model=\"vm.fileOptions.fileSHA256\" name=\"hashSHA256\" \ntype=\"text\"><div class=\"hint\" translate=\"CVERSIONES.HINTCOMANDOSHA256\">\nPuedes obtener el SHA256 desde la consola de Linux: con el comando \'<em>sha256sum (nombre de archivo)</em>\'</div>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer flex-100\"><label>Change log</label><textarea \nng-model=\"vm.fileOptions.changelog\" md-maxlength=\"10000\" rows=\"8\"></textarea></md-input-container><md-checkbox \nng-model=\"vm.fileOptions.overwrite\">Sobreescribir si existe</md-checkbox></div></div><div \nlayout-align=\"space-between center\"><md-button class=\"md-raised md-primary\"><label for=\"files\" style=\"cursor: pointer\">\n<md-icon md-font-icon=\"icon-box-upload\" class=\"icon\"></md-icon><span translate=\"CVERSIONES.SELECCIONARARCHIVO\">\nSeleccionar archivo</span></label></md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.uploadFile()\" \nng-disabled=\"!vm.fileOptions.file || subirVersion.fileName.$invalid || subirVersion.hashMD5.$invalid\"><md-icon \nmd-font-icon=\"icon-send\" class=\"icon\"></md-icon><span translate=\"CVERSIONES.ENVIARARCHIVO\">Enviar archivo</span>\n</md-button><input type=\"file\" id=\"files\" aria-label=\"Seleccionar archivo\" required hidden></div></fieldset></form>\n<fieldset class=\"standard\" style=\"margin-bottom: 20px; position: relative\" flex><legend class=\"form-title\" \ntranslate=\"CVERSIONES.PAQUETESDINAMICOS\">Paquetes dinámicos</legend><div layout=\"row\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" \nng-repeat=\"vrsn in vm.fileLists.dynamic|orderBy:\'-idItemVersion\' track by vrsn.idItemVersion\" \nclass=\"vrsn md-primary-bg\"><span flex>{{vrsn.name}}</span><md-button class=\"md-fab md-mini\" \nng-click=\"deleteFile(vrsn.idItemVersion)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"CVERSIONES.ELIMINARARCHIVO\">Eliminar archivo</span></md-tooltip></md-button>\n<md-tooltip ng-if=\"vrsn.changelog\">{{vrsn.changelog}}</md-tooltip></div></div></fieldset><fieldset class=\"standard\" \nstyle=\"margin-bottom: 20px; position: relative\" flex><legend class=\"form-title\" translate=\"CVERSIONES.VERSIONESBIOS\">\nVersiones de la BIOS</legend><div layout=\"row\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"vrsn in vm.fileLists.bios|orderBy:\'-idItemVersion\' track by vrsn.idItemVersion\" class=\"vrsn md-primary-bg\">\n<span flex>{{vrsn.name}}</span><md-button class=\"md-fab md-mini\" ng-click=\"deleteFile(vrsn.idItemVersion)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"CVERSIONES.ELIMINARARCHIVO\">\nEliminar archivo</span></md-tooltip></md-button><md-tooltip ng-if=\"vrsn.changelog\">{{vrsn.changelog}}</md-tooltip>\n</div></div></fieldset><h4><md-icon md-font-icon=\"icon-alert\"></md-icon><span translate=\"CVERSIONES.RECELIMINAR\">\nSe recomienda eliminar versiones antiguas y sin uso, para ahorrar espacio en el servidor.</span></h4></md-content><div \nclass=\"pantallaCarga\" layout-align=\"center center\" ng-show=\"vm.fileOptions.isUploading\"><div class=\"content\" \nlayout=\"column\" layout-align=\"center center\"><h1 translate=\"CVERSIONES.SUBIENDOARCHIVO\">Subiendo archivo...</h1><h3 \ntranslate=\"CVERSIONES.NOCIERRE\">No cierre la ventana</h3><md-progress-circular class=\"md-warn\" md-mode=\"determinate\" \nvalue=\"{{vm.fileOptions.uploadProgress.percent}}\" md-diameter=\"120\"></md-progress-circular><h3>\n{{vm.fileOptions.uploadProgress.current}} <span translate=\"CVERSIONES.DE\">de</span>\n {{vm.fileOptions.uploadProgress.total}} ({{vm.fileOptions.uploadProgress.percent|number:0}}%)</h3></div></div></div>\n</div>");
$templateCache.put("app/main/Quantion/root/controls/controls.html","<div id=\"controls\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><md-button class=\"md-fab md-mini\" ng-click=\"addControl(control)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"CONTROLS.NUEVO\">Nuevo</span>\n</md-tooltip></md-button><div layout=\"column\"><div ng-repeat=\"control in vm.listaControls\" \nclass=\"control md-primary-bg layout-row layout-align-center-center\" on-last-repeat><h2 flex>{{control.model}}</h2>\n<md-button class=\"md-fab md-mini\" ng-click=\"editControl(control)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"CONTROLS.EDITAR\">Editar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"deleteControl(control)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"CONTROLS.ELIMINAR\">Eliminar</span></md-tooltip></md-button></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/Quantion/root/dhcpEquipos/dhcpEquipos.html","<div id=\"dhcpEquipos\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.guardar()\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"SERVICIOS.GUARDAR\">\nGuardar</span></md-tooltip></md-button><md-input-container class=\"md-block\"><textarea ng-model=\"vm.fileContent\" \naria-label=\"t\" md-no-autogrow></textarea></md-input-container></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/encuestas/encuestas.html","<div id=\"encuestas\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.nuevaEncuesta($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"encuestas.nueva\">Nueva encuesta</span></md-tooltip></md-button><export-to-file \nfilename=\"Backup-Encuestas\" tooltip-text=\"{{\'encuestas.EXPORTAR\'|translate}}\" data=\"vm.listaEncuestas\">\n</export-to-file></div><md-input-container style=\"min-width: 150px\"><label translate=\"encuestas.filtraridioma\">\nFiltrar por idioma</label><md-select ng-model=\"langFilter\"><md-option value=\"\" translate=\"encuestas.todos\">Todos\n</md-option><md-option ng-repeat=\"lang in vm.listaIdiomas\" value=\"{{lang.idioma}}\"><img \nng-src=\"{{lang.rutaIcono|replacePath}}\" alt=\"{{lang.idioma}}\" style=\"max-height: 24px\"></md-option></md-select>\n</md-input-container></div><md-list flex><md-list-item class=\"md-2-line\" \nng-repeat=\"enc in vm.listaEncuestas|filter: {lang:langFilter}\" on-last-repeat layout-wrap><img class=\"md-avatar\" \nng-src=\"{{::enc.img|replacePath}}\" on-error-image=\"/assets/quantionImagenes/img-error.png\" \non-no-image=\"/assets/quantionImagenes/icon_tick.png\"><div class=\"md-list-item-text\" layout=\"column\"><h3><span \ntranslate=\"encuestas.nombre\">Nombre:</span> {{::enc.name}}</h3><h4><span translate=\"encuestas.preguntas\">Preguntas:\n</span> {{::enc.questions.length}}</h4><h4><span translate=\"encuestas.idioma\">Idioma:</span> {{::enc.lang}}</h4></div>\n<div style=\"align-self: center\" flex-xs=\"100\" flex-sm=\"100\" layout-wrap><md-button class=\"md-fab md-mini md-primary\" \nng-click=\"vm.verRespuestas($event, enc)\"><md-icon md-font-icon=\"icon-checkbox-marked-outline\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"encuestas.respuestas\">Ver respuestas</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"vm.verEstadisticasRespuestas($event, enc)\"><md-icon \nmd-font-icon=\"icon-chart-bar\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"encuestas.estadisticas\">\nVer estadísticas</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.verPreguntas($event, enc)\"><md-icon md-font-icon=\"icon-help\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"encuestas.preguntas_\">Preguntas</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.editarEncuesta($event, enc)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"encuestas.modificar\">Modificar encuesta</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarEncuesta($event, enc)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"encuestas.eliminar\">Eliminar encuesta</span></md-tooltip>\n</md-button></div></md-list-item></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/gCajeros/gCajeros.html","<div id=\"gCajeros\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\" layout-align=\"space-between\"><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaNuevo($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"GCAJEROS.REGISTRAR\">Registrar nuevo cajero</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.registryAtm()\"><md-icon md-font-icon=\"icon-data\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"GCAJEROS.SINCRONIZAR\">Sincronizar base de datos</span></md-tooltip></md-button></div><h3 \nclass=\"m-0 text-right\">Se recomienda editar los cajeros desde el <a href=\"https://atms.solertia-hospitality.com/\" \ntarget=\"_blank\">gestor centralizado</a> y sincronizar.</h3><md-list flex><md-list-item \nclass=\"md-3-line layout-xs-column layout-sm-column\" ng-repeat=\"cajero in vm.listaCajeros\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><span translate=\"GCAJEROS.NOMBRE\">Nombre:</span> {{::cajero.model}}<span \nng-if=\"cajero.phone\" class=\"phone\"> · {{::cajero.phone}}</span></h3><h4>\nIP: {{::cajero.ip}} - MAC: {{::cajero.mac|uppercase}}</h4><p>v. {{::cajero.version}} - <span \ntranslate=\"GCAJEROS.SINCRONIZARBD\">Sincronizar BBDD:</span> {{::cajero.synchronizeDatabase?\'Si\':\'No\'}}</p><p><span \ntranslate=\"GCAJEROS.CHATIDS\">Chats:</span> {{::(cajero.chats|stringifyArray)}}</p></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between\" flex><div layout=\"row\" class=\"features\"><md-icon \nmd-font-icon=\"{{::featureIcons[e].icon || \'icon-help\'}}\" ng-repeat=\"e in cajero.features track by $index\"><md-tooltip \nmd-direction=\"top\"><span>{{::(featureIcons[e].text|translate) || e}}</span></md-tooltip></md-icon></div><div \nlayout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.verMandos($event, cajero)\" \nng-if=\"cajero.mandosRegistrados\"><md-icon md-font-icon=\"icon-remote\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"GCAJEROS.VERMANDOSREGISTRADOS\">Ver mandos registrados</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.verCupones($event, cajero)\" ng-if=\"cajero.cuponNoUsado\" \nng-disabled=\"cajero.cuponNoUsado.length < 1\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"GCAJEROS.VERCUPONES\">Ver cupones sin usar</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.verArqueos($event, cajero)\"><md-icon md-font-icon=\"icon-swap-vertical\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"GCAJEROS.VERARQUEOS\">Ver arqueos</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaEditar($event, cajero)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"GCAJEROS.EDITAR\">Editar cajero\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarCajero($event, cajero)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"GCAJEROS.ELIMINAR\">\nEliminar cajero</span></md-tooltip></md-button></div></div></md-list-item></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/gruposStb/gruposStb.html","<div id=\"gruposStb\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"GRUPOSSTB.NUEVO\">Nuevo grupo\n</span></md-tooltip></md-button><md-list flex><md-list-item class=\"md-2-line\" \nng-repeat=\"grupo in vm.listaGrupos|orderBy: \'orden\'\" ng-dblclick=\"vm.ventanaEditar($event, grupo)\" on-last-repeat \nlayout-wrap><md-icon md-font-icon class=\"{{grupo.countable ? \'icon-eye green-fg\' : \'icon-eye-off red-fg\'}}\" \nstyle=\"margin: auto; margin-right: 20px\"></md-icon><div class=\"md-list-item-text\" layout=\"column\"><h3><span \ntranslate=\"GRUPOSSTB.NOMBRE\">Nombre:</span> {{ grupo.nombre}} <span ng-if=\"grupo.place\">({{grupo.place}})</span></h3>\n<h4><span translate=\"GRUPOSSTB.STBSINCLUIDOS\">Stbs incluidos:</span> {{ grupo.stbs.length}}</h4><h4><span \ntranslate=\"GRUPOSSTB.ORDEN\">Orden:</span> {{ grupo.orden}}</h4></div><div layout=\"row\" layout-wrap flex-xs=\"100\" \nstyle=\"align-self: center\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.asignarStbAGrupo($event, grupo)\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"GRUPOSSTB.ASIGNARSTBAGRUPO\">Asignar STB al grupo</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.ventanaEditar($event, grupo)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"GRUPOSSTB.MODIFICAR\">Modificar grupo</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarGrupo($event, grupo)\" ng-disabled=\"grupo.idStbGroup === 1\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"GRUPOSSTB.ELIMINAR\">\nEliminar grupo</span></md-tooltip></md-button></div></md-list-item></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/idiomas/creareditaridioma.tmpl.html","<md-dialog id=\"idiomas\" aria-label=\"Idiomas\" md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><form name=\"form\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><label translate=\"IDIOMAS.ABREVIATURAISO\">Abreviatura ISO</label><input name=\"idioma\" \nng-model=\"idioma\" ng-model-options=\"{debounce: 500}\" ng-change=\"langIcon(idioma)\" required><div \nstyle=\"font-size: 12px;line-height: 14px;transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);color: grey\"><span \ntranslate=\"IDIOMAS.HINT1\">El nombre debe seguir la norma ISO 639-1.</span> <a \nhref=\"https://www.loc.gov/standards/iso639-2/php/code_list.php\" target=\"_blank\" translate=\"IDIOMAS.HINT2\">(Mas info). \n</a><span translate=\"IDIOMAS.HINT3\">Ejemplo: es, en, fr.</span></div><div ng-messages=\"form.idioma.$error\"><div \nng-message=\"required\" translate=\"IDIOMAS.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><div \nlayout=\"row\" flex layout-align=\"center center\"><img ng-src=\"{{rutaIcono|replacePath}}\" \nstyle=\"width: 48px; margin-right:10px\" on-error-image><md-input-container class=\"md-block\" md-no-float flex><label \ntranslate=\"IDIOMAS.RUTAICONO\">Ruta del icono</label><input name=\"rutaIcono\" ng-model=\"rutaIcono\" \nng-model-options=\"{debounce: 500}\" required><div ng-messages=\"form.rutaIcono.$error\"><div ng-message=\"required\" \ntranslate=\"IDIOMAS.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container></div><div \nstyle=\"color: red; text-align: center; margin-top: 20px\">{{mensajeError}}</div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" translate=\"IDIOMAS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/idiomas/idiomas.html","<div id=\"idiomas\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><div layout=\"row\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"IDIOMAS.NUEVOIDIOMA\">Nuevo idioma\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.importFile()\"><md-icon \nmd-font-icon=\"icon-box-upload\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"IDIOMAS.IMPORTAR\">Importar idiomas de archivo</span></md-tooltip></md-button><input type=\"file\" id=\"files\" \naria-label=\"Seleccionar archivo\" hidden><export-to-file filename=\"Backup-Idiomas\" \ntooltip-text=\"{{\'IDIOMAS.EXPORTAR\'|translate}}\" data=\"vm.listaIdiomas\"></export-to-file></div><md-list flex>\n<md-list-item ng-repeat=\"idioma in vm.listaIdiomas\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{idioma.rutaIcono|replacePath}}\" on-error-image ng-dblclick=\"uploadLogo(idioma)\"> <span flex><span \ntranslate=\"IDIOMAS.{{idioma.idioma}}\"></span> ({{ idioma.idioma}})</span><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaEditar($event, idioma)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"IDIOMAS.MODIFICAR\">Modificar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.eliminarIdioma($event, idioma)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"IDIOMAS.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list><input type=\"file\" accept=\"image/png\" id=\"logoUpload\" aria-label=\"Seleccionar archivo\" hidden>\n</md-content></div></div>");
$templateCache.put("app/main/Quantion/root/instalaciones/instalaciones.html","<div id=\"instalaciones\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\"><md-button class=\"md-fab md-mini\" \nng-click=\"vm.nuevaInstalacion($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"INSTALACIONES.NUEVA\">Nueva instalación</span></md-tooltip></md-button><md-menu><md-button \nclass=\"md-fab md-mini\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"INSTALACIONES.COPIAR\">Copiar instalación</span></md-tooltip></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"item in vm.listaSinAgrupar\"><md-button ng-click=\"CopiarInstalacion(item)\">\n{{item.name}}</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-fab md-mini md-primary\" \nng-click=\"vm.importFile()\"><md-icon md-font-icon=\"icon-box-upload\" class=\"icon\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"INSTALACIONES.IMPORTAR\">Importar instalaciones de archivo</span></md-tooltip>\n</md-button><input type=\"file\" id=\"files\" aria-label=\"Seleccionar archivo\" hidden><export-to-file \nfilename=\"Backup-Instalaciones\" tooltip-text=\"{{\'INSTALACIONES.EXPORTAR\'|translate}}\" data=\"vm.listaSinAgrupar\">\n</export-to-file></div><md-list flex ng-repeat=\"o in vm.listaInstalaciones|orderBy:\'key\'\"><md-subheader \nclass=\"md-no-sticky md-primary-bg\" ng-hide=\"!o.key\">{{o.key}}</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"inst in o.value\" on-last-repeat layout-wrap><img class=\"md-avatar\" ng-src=\"{{inst.logo|replacePath}}\" \nsrc=\"assets/quantionImagenes/img-error.png\" on-error-image ng-dblclick=\"uploadLogo(inst)\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><span translate=\"INSTALACIONES.NOMBRE\">Nombre:</span> {{::inst.name}} \n<span ng-if=\"inst.description\">({{::inst.description}})</span></h3><h4><span \ntranslate=\"INSTALACIONES.SERVICIOSINCLUIDOS\">Servicios incluidos:</span> {{::inst.registerBase.length}} <span \ntranslate=\"INSTALACIONES.BASE\">Base</span> + {{::inst.registerPurchasable.length}} <span \ntranslate=\"INSTALACIONES.COMPRA\">Compra</span></h4><h4><span translate=\"INSTALACIONES.ACLS\">ACLs:</span>\n {{::inst.availableAcls|stringifyArray}}</h4></div><div layout=\"row\" layout-wrap flex-xs=\"100\" \nstyle=\"align-self: center\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.paquetes($event, inst)\"><md-icon \nmd-font-icon=\"icon-package-variant\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"INSTALACIONES.ORDENPAQUETES\">Paquetes</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ordenarHome($event, inst)\"><md-icon md-font-icon=\"icon-view-carousel\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"INSTALACIONES.ORDENHOME\">Orden del menú Home</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.editarInstalacion($event, inst)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODIFICAR\">Modificar instalación</span>\n</md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarInstalacion($event, inst)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.ELIMINAR\">\nEliminar instalación</span></md-tooltip></md-button></div></md-list-item></md-list><input type=\"file\" \naccept=\"image/png\" id=\"logoUpload\" aria-label=\"Seleccionar archivo\" hidden></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/properties/properties.html","<div id=\"properties\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><table><tr ng-repeat=\"(key,value) in vm.listaPropertiesInstallation\" on-last-repeat>\n<td>{{key}}</td><td><input ng-model=\"vm.listaPropertiesInstallation[key]\"></td><td><div layout=\"row\"><md-button \nclass=\"md-icon-button md-warn\" aria-label=\"save\" \nng-disabled=\"vm.listaPropertiesInstallationOrig[key] === vm.listaPropertiesInstallation[key]\" \nng-click=\"save(true, key, vm.listaPropertiesInstallation[key])\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n<md-tooltip><span translate=\"PROPERTIES.TOOLTIP_GUARDAR\">Guardar</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"restart\" \nng-disabled=\"vm.listaPropertiesInstallationOrig[key] === vm.listaPropertiesInstallation[key]\" \nng-click=\"restart(true, key)\"><md-icon md-font-icon=\"icon-undo-variant\"></md-icon><md-tooltip><span \ntranslate=\"PROPERTIES.TOOLTIP_RESTART\">Deshacer</span></md-tooltip></md-button></div></td></tr></table></md-content>\n<md-content layout-padding layout=\"column\" md-whiteframe=\"1\" class=\"margin-top-24\"><table><tr \nng-repeat=\"(key,value) in vm.listaProperties\" on-last-repeat><td>{{key}}</td><td><input \nng-model=\"vm.listaProperties[key]\"></td><td><div layout=\"row\" style=\"width: fit-content\"><md-button \nclass=\"md-icon-button md-warn\" aria-label=\"save\" ng-disabled=\"vm.listaPropertiesOrig[key] === vm.listaProperties[key]\" \nng-click=\"save(false, key, vm.listaProperties[key])\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>\n<span translate=\"PROPERTIES.TOOLTIP_GUARDAR\">Guardar</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"restart\" \nng-disabled=\"vm.listaPropertiesOrig[key] === vm.listaProperties[key]\" ng-click=\"restart(false, key)\"><md-icon \nmd-font-icon=\"icon-undo-variant\"></md-icon><md-tooltip><span translate=\"PROPERTIES.TOOLTIP_RESTART\">Deshacer</span>\n</md-tooltip></md-button></div></td></tr></table></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/tarjetas/tarjetas.html","<div id=\"tarjetas\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\" class=\"margin-bottom-24\"><h2 translate=\"TARJETAS.TARJETAS\">Tarjetas</h2><div>\n<md-button class=\"md-fab md-mini\" ng-click=\"CargarTarjetas()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"WALLETS.RECARGAR\">Recargar datos</span></md-tooltip></md-button><div\n layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" class=\"buscador\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"md-primary-bg\"><div><md-icon md-font-icon=\"icon-magnify\"></md-icon></div>\n<md-input-container class=\"md-block\"><input ng-model=\"search\" ng-model-options=\"{debounce: 500}\" \nng-change=\"filterTarjetas()\"></md-input-container><span>({{vm.cardListFiltered.length}})</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised md-primary pagination-button\" ng-disabled=\"currentPage <= 0\" \nng-click=\"currentPage = currentPage - 1\">&leftarrow;</md-button><span><span translate=\"WALLETS.PAGINA\">Pág.</span>\n{{currentPage + 1}} / {{numberOfPages() + 1}}</span><md-button class=\"md-raised md-primary pagination-button\" \nng-disabled=\"currentPage >= numberOfPages()\" ng-click=\"currentPage = currentPage + 1\">&rightarrow;</md-button></div>\n<div><span translate=\"WALLETS.MOSTRAR\">Mostrar</span><md-input-container><md-select ng-model=\"pageSize\"><md-option \nng-value=\"v\" ng-repeat=\"v in [5, 10, 25, 50, 100]\">{{v}}</md-option></md-select></md-input-container></div></div></div>\n<table><thead><tr><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'uuidAuthCard\', \'ord-asc\':orderProp === \'uuidAuthCard\' && !orderReverse, \'ord-desc\':orderProp === \'uuidAuthCard\' && orderReverse}\" \nng-click=\"sortBy(\'uuidAuthCard\')\"><span translate=\"WALLETS.UUID\">UUID</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'card.actions\', \'ord-asc\':orderProp === \'card.actions\' && !orderReverse, \'ord-desc\':orderProp === \'card.actions\' && orderReverse}\" \nng-click=\"sortBy(\'card.actions\')\"><span translate=\"TARJETAS.ACCIONES_\">Acciones</span></th><th class=\"column-title\" \nng-class=\"{\'ord-no\':orderProp !== \'card.actionsOnDisconnect\', \'ord-asc\':orderProp === \'card.actionsOnDisconnect\' && !orderReverse, \'ord-desc\':orderProp === \'card.actionsOnDisconnect\' && orderReverse}\" \nng-click=\"sortBy(\'card.actionsOnDisconnect\')\"><span translate=\"TARJETAS.ACCIONESDISCONNECT\">Acciones disconnect</span>\n</th></tr></thead><tbody><tr \nng-repeat=\"card in vm.cardListFiltered| orderBy: orderProp:orderReverse | startFrom:currentPage * pageSize | limitTo:pageSize track by $index\" \non-last-repeat><td>{{card.uuidAuthCard}}</td><td><div layout=\"column\"><a ng-click=\"actionDetails(act)\" \nng-repeat=\"act in card.actions\">{{act.name}}</a></div></td><td><div layout=\"column\"><a ng-click=\"actionDetails(act)\" \nng-repeat=\"act in card.actionsOnDisconnect\">{{act.name}}</a></div></td></tr></tbody></table></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/temas/temas.html","<div id=\"temas\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\"><form name=\"subirImagen\" class=\"md-inline-form\" novalidate><fieldset class=\"standard\" flex=\"100\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"TEMAS.SUBIR\">Subir nuevo archivo</legend><div \nlayout=\"row\" layout-align=\"start center\" style=\"min-height: 150px; width: 100%\" ng-if=\"vm.file\" layout-padding \nlayout-wrap><div class=\"fileData\" layout=\"row\" layout-align=\"center center\" md-whiteframe=\"3\" layout-padding><img \nsrc=\"/assets/quantionImagenes/zipImg.png\"><div><strong>{{vm.file.name}}</strong> ({{vm.file.type|| \'n/a\'}})<br><span \ntranslate=\"TEMAS.TAMANO\">Tamaño:</span> {{(vm.file.size / 1000000).toFixed(2)}} mb<br><span translate=\"TEMAS.ULTMOD\">\nÚlt. modificación:</span> {{vm.file.lastModifiedDate ? vm.file.lastModifiedDate.toLocaleDateString(\'es-ES\') : \'n/a\'}}\n</div></div></div><div layout-align=\"space-between center\"><md-button class=\"md-raised md-primary\"><label for=\"files\" \nstyle=\"cursor: pointer\"><md-icon md-font-icon=\"icon-box-upload\" class=\"icon\"></md-icon><span \ntranslate=\"TEMAS.SELECCIONARARCHIVO\">Seleccionar archivo</span></label></md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.enviarArchivo()\" ng-disabled=\"!vm.file\"><md-icon md-font-icon=\"icon-send\" \nclass=\"icon\"></md-icon><span translate=\"TEMAS.ENVIARARCHIVO\">Enviar archivo</span></md-button><input type=\"file\" \nid=\"files\" aria-label=\"Seleccionar archivo\" required hidden></div></fieldset></form><div layout=\"row\" layout-wrap><div \nng-repeat=\"(nombre,tema) in vm.listaTemas\" class=\"tema md-primary-bg layout-row layout-align-center-center tooltip\" \non-last-repeat><h2>{{tema.name}}</h2><md-button class=\"md-fab md-mini\" ng-click=\"showInfo(tema)\" \nng-disabled=\"!tema.properties\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TEMAS.INFO\">Info del tema</span></md-tooltip></md-button><a \nhref=\"{{tema.download}}\"><md-button class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TEMAS.DESCARGAR\">Descargar</span></md-tooltip></md-button></a></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/Quantion/root/traduccion/traduccion.html","<div id=\"traduccion\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Paquetes\"><table><tr><th>\nLogo</th><th ng-repeat=\"lang in listaIdiomas track by $index\"><img ng-src=\"{{lang.rutaIcono | replacePath}}\"></th><th>\n</th></tr><tr ng-repeat=\"pkg in listaPaquetes track by $index\"><td><img ng-src=\"{{pkg.logo | replacePath}}\"></td><td \nng-repeat=\"lang in listaIdiomas track by $index\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\">\n<input type=\"text\" ng-model=\"pkg.nameInt[lang.idioma]\"><md-icon md-font-icon=\"icon-format-text\" \nng-click=\"tryTranslate(pkg.nameInt, lang.idioma)\" style=\"margin-right: 8px\"><md-tooltip>Obtener traducción</md-tooltip>\n</md-icon></div><div layout=\"row\"><textarea type=\"text\" ng-model=\"pkg.descriptionInt[lang.idioma]\"></textarea><md-icon \nmd-font-icon=\"icon-format-text\" ng-click=\"tryTranslate(pkg.descriptionInt, lang.idioma)\" style=\"margin-right: 8px\">\n<md-tooltip>Obtener traducción</md-tooltip></md-icon></div></div></td><td><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-content-copy\" ng-click=\"copyAllFrom(pkg)\"><md-tooltip>Copiar valor de \'{{idiomaPrincipal}}\' en todos\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-content-save\" ng-click=\"updatePackage(pkg)\"><md-tooltip>Guardar\n</md-tooltip></md-icon></div></td></tr></table></md-tab><md-tab label=\"Servicios\"><table><tr><th>Logo</th><th \nng-repeat=\"lang in listaIdiomas track by $index\"><img ng-src=\"{{lang.rutaIcono | replacePath}}\"></th><th></th></tr><tr \nng-repeat=\"srvc in listaServicios track by $index\" on-last-repeat><td><img ng-src=\"{{srvc.logo | replacePath}}\"></td>\n<td ng-repeat=\"lang in listaIdiomas track by $index\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\">\n<input type=\"text\" ng-model=\"srvc.nameInt[lang.idioma]\"><md-icon md-font-icon=\"icon-format-text\" \nng-click=\"tryTranslate(srvc.nameInt, lang.idioma)\" style=\"margin-right: 8px\"><md-tooltip>Obtener traducción\n</md-tooltip></md-icon></div><div layout=\"row\"><textarea type=\"text\" ng-model=\"srvc.descriptionInt[lang.idioma]\">\n</textarea><md-icon md-font-icon=\"icon-format-text\" ng-click=\"tryTranslate(srvc.descriptionInt, lang.idioma)\" \nstyle=\"margin-right: 8px\"><md-tooltip>Obtener traducción</md-tooltip></md-icon></div></div></td><td><div layout=\"row\">\n<md-icon md-font-icon=\"icon-content-copy\" ng-click=\"copyAllFrom(srvc)\"><md-tooltip>\nCopiar valor de \'{{idiomaPrincipal}}\' en todos</md-tooltip></md-icon><md-icon md-font-icon=\"icon-content-save\" \nng-click=\"updateService(srvc)\"><md-tooltip>Guardar</md-tooltip></md-icon></div></td></tr></table></md-tab></md-tabs>\n</md-content></div></div>");
$templateCache.put("app/main/Quantion/principal/templates/details.tmpl.html","<md-dialog id=\"principal-details\" aria-label=\"Detalles habitacion\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 class=\"md-toolbar-tools\"><span \ntranslate=\"PRINCIPAL.SIDENAV.HABITACION\">Habitación:</span> {{stb.room}}</h1><md-button class=\"md-icon-button\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content><fieldset class=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend \nclass=\"form-title\" translate=\"VERMAS.DATOSCLIENTE\">Datos del cliente</legend><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.NOMBRE\" class=\"md-accent-fg\">Nombre del cliente:</span> {{::stb.username}}</div><div layout=\"row\" \nlayout-align=\"start center\" flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.IDIOMA\" \nstyle=\"margin-right: 10px\" class=\"md-accent-fg\">Idioma:</span><div><img \nng-src=\"/assets/quantionImagenes/Banderas/{{::stb.lang}}.png\" alt=\"{{::stb.lang}}\" style=\"max-height: 24px\"></div>\n</div></div></fieldset><fieldset class=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.DATOSSTB\">Datos del STB</legend><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.NOMBREHAB\" class=\"md-accent-fg\">\nNombre de habitación:</span> {{::stb.room}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\">\n<span translate=\"VERMAS.INSTALACION\" class=\"md-accent-fg\">Instalación</span> {{::stb.installation.name}}</div><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.TEMA\" class=\"md-accent-fg\">Tema\n</span> {{::stb.properties.themeOverride}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span\n translate=\"VERMAS.TACTIL\" class=\"md-accent-fg\">Tactil</span> <span translate=\"VERMAS.TACTIL_{{stb.properties.touch}}\">\n{{::stb.properties.touch}}</span></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.MODELO\" class=\"md-accent-fg\">Modelo</span> {{::stb.model.name}}</div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.IP\" class=\"md-accent-fg\">IP:</span> {{::stb.ip}}\n</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.VOLUMEN\" \nclass=\"md-accent-fg\">Volumen máximo de la TV:</span> {{::stb.properties.volume}} %</div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"stb.uptime\"><span translate=\"VERMAS.TEMPERATURA\" \nclass=\"md-accent-fg\">Temperatura:</span> {{::stb.uptime.temp1}}ºC /{{::stb.uptime.temp2}}ºC</div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.EXTENSION\" class=\"md-accent-fg\">Extensión VOIP:\n</span> {{::stb.extension.number}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.RESOLUCION\" class=\"md-accent-fg\">Resolución:</span> {{::stb.properties.resolution}}</div><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"stb.uptime.ethernet\"><span \ntranslate=\"VERMAS.ETHERNET\" class=\"md-accent-fg\">Conexión cableada (Ethernet):</span> <span \ntranslate=\"VERMAS.TACTIL_{{stb.uptime.ethernet}}\">{{::stb.uptime.ethernet}}</span></div><div flex-gt-sm=\"50\" \nflex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"stb.uptime.disk\"><span translate=\"VERMAS.DISK\" \nclass=\"md-accent-fg\">Tamaño de disco:</span> {{::stb.uptime.disk}}</div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" \nflex=\"100\" class=\"text-gray\" ng-if=\"stb.uptime.usbList2\"><span translate=\"VERMAS.USBWIFI\" class=\"md-accent-fg\">\nDispositivos USB conectados:</span>({{stb.uptime.usbList2.length}}) <a ng-click=\"showLi = !showLi\" href=\"\" \nclass=\"md-warn-fg\"><span translate=\"VERMAS.MOSTRAR\" ng-if=\"!showLi\">Mostrar</span><span translate=\"VERMAS.OCULTAR\" \nng-if=\"showLi\">Ocultar</span></a><li ng-repeat=\"dev in stb.uptime.usbList2|orderBy: \'-known\'\" ng-show=\"showLi\" \nng-class=\"{strong:dev.known}\" style=\"color: {{dev.color}}\">{{dev.name}}</li></div></div></fieldset><fieldset \nclass=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.RED\">Red</legend>\n<div layout=\"row\" layout-align=\"start start\" layout-wrap><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.MAC\" class=\"md-accent-fg\">MAC:</span> {{::stb.mac| uppercase}}</div><div \nflex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"stb.lastMacs\"><span translate=\"VERMAS.LASTMACS\" \nclass=\"md-accent-fg\">Últimas MAC utilizadas</span>({{stb.lastMacs.length}}) <a ng-click=\"showLi = !showLi\" href=\"\" \nclass=\"md-warn-fg\"><span translate=\"VERMAS.MOSTRAR\" ng-if=\"!showLi\">Mostrar</span><span translate=\"VERMAS.OCULTAR\" \nng-if=\"showLi\">Ocultar</span></a><li ng-repeat=\"mac in stb.lastMacs track by $index\" ng-show=\"showLi\">\n{{::mac|uppercase}}</li></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"stb.properties.wifiAp\"><span translate=\"VERMAS.APASIGNADO\" class=\"md-accent-fg\">Punto de acceso asignado:</span>\n {{::stb.properties.wifiAp.name}} ({{::stb.properties.wifiAp.band===\'B_2_GHZ\'?\'2.4 GHz\':\'5 GHz\'}}) ({{::stb.properties.wifiAp.bssid}})\n<div layout=\"row\" layout-align=\"center center\" ng-if=\"assignedAp\" style=\"display: inline-block\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"assignedAp.status === \'Online\'\" class=\"green-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-flag-variant\" ng-if=\"assignedAp.status === \'Flagged\'\" class=\"orange-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-if=\"assignedAp.status === \'Offline\'\" class=\"red-700-fg\"></md-icon><span \nclass=\"margin-horizontal-5\">{{assignedAp.status}}</span><md-menu><md-button class=\"md-fab md-mini md-orange-600-bg\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"showApRuckusInfo(assignedAp)\">\n<md-icon md-font-icon=\"icon-information\" md-menu-align-target></md-icon><span>Info y clientes</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusEvents(assignedAp)\"><md-icon \nmd-font-icon=\"icon-calendar-text\" md-menu-align-target></md-icon><span translate=\"APS.EVENTS\">Eventos</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusAlarms(assignedAp)\"><md-icon \nmd-font-icon=\"icon-alert\" md-menu-align-target></md-icon><span translate=\"APS.ALARMS\">Alarmas</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"rebootAP($event, assignedAp)\"><md-icon md-font-icon=\"icon-refresh\" \nmd-menu-align-target></md-icon><span translate=\"APS.REBOOT\">Reiniciar</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"stb.uptime.ap\"><span translate=\"VERMAS.AP\" class=\"md-accent-fg\">Punto de acceso conectado:</span><span \nng-if=\"mapAps[stb.uptime.ap.toLowerCase()]\" \nstyle=\"color: {{(stb.properties.wifiAp.bssid.toLowerCase() === stb.uptime.ap.toLowerCase()) ? \'green\' : \'red\'}}\">\n{{mapAps[stb.uptime.ap.toLowerCase()].name}} ({{mapAps[stb.uptime.ap.toLowerCase()].band === \'B_2_GHZ\' ? \'2.4 GHz\' : \'5 GHz\'}}) ({{::stb.uptime.ap}})\n</span><div layout=\"row\" layout-align=\"center center\" ng-if=\"connectedAp\" style=\"display: inline-block\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"connectedAp.status === \'Online\'\" class=\"green-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-flag-variant\" ng-if=\"connectedAp.status === \'Flagged\'\" class=\"orange-700-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-if=\"connectedAp.status === \'Offline\'\" class=\"red-700-fg\"></md-icon><span \nclass=\"margin-horizontal-5\">{{connectedAp.status}}</span><md-menu><md-button class=\"md-fab md-mini md-orange-600-bg\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"opciones\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"showApRuckusInfo(connectedAp)\">\n<md-icon md-font-icon=\"icon-information\" md-menu-align-target></md-icon><span>Info y clientes</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusEvents(connectedAp)\"><md-icon \nmd-font-icon=\"icon-calendar-text\" md-menu-align-target></md-icon><span translate=\"APS.EVENTS\">Eventos</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"showApRuckusAlarms(connectedAp)\"><md-icon \nmd-font-icon=\"icon-alert\" md-menu-align-target></md-icon><span translate=\"APS.ALARMS\">Alarmas</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"rebootAP($event, connectedAp)\"><md-icon md-font-icon=\"icon-refresh\" \nmd-menu-align-target></md-icon><span translate=\"APS.REBOOT\">Reiniciar</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" \nng-if=\"stb.uptime.ap\"><span translate=\"VERMAS.APDISPONIBLES\" class=\"md-accent-fg\">APs disponibles: </span><a \nng-click=\"getAps()\" href=\"\" class=\"md-warn-fg\"><span translate=\"VERMAS.MOSTRAR\" ng-if=\"!listaAps && !loadingAps\" \nclass=\"md-warn-fg\">Mostrar</span> <span translate=\"VERMAS.REFRESCAR\" ng-if=\"listaAps && !loadingAps\" \nclass=\"md-warn-fg\">Refrescar</span> </a><span translate=\"VERMAS.CARGANDO\" ng-if=\"loadingAps\" class=\"md-warn-fg\">\nCargando</span><li ng-repeat=\"ap in listaAps|orderBy: \'signal\'\"><span ng-if=\"mapAps[ap.mac.toLowerCase()]\" \nng-class=\"{underline:(ap.mac.toLowerCase() === stb.uptime.ap.toLowerCase())}\">\n{{mapAps[ap.mac.toLowerCase()].name}} ({{mapAps[ap.mac.toLowerCase()].band === \'B_2_GHZ\' ? \'2.4 GHz\' : \'5 GHz\'}})\n</span> <span class=\"md-warn-fg\">{{ap.mac}} ({{ap.essid}} / {{ap.signal}} / Canal {{ap.channel}})</span></li></div><div\n flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" class=\"text-gray\" ng-if=\"stb.uptime.signal\"><span \ntranslate=\"VERMAS.SIGNAL\" class=\"md-accent-fg\">Alcance de señal:</span> {{::stb.uptime.signal}}<div \nclass=\"signal-meter-container margin-left-8\"><div class=\"signal-meter {{signalStatus}}\" \nstyle=\"width: {{signalStatusPercent}}%\"></div></div></div><div flex-gt-sm=\"50\" flex-gt-md=\"33\" flex=\"100\" \nclass=\"text-gray\" ng-if=\"stb.wifiList\"><span translate=\"VERMAS.WIFILIST\" class=\"md-accent-fg\">\nDispositivos conectados al WiFi:</span>({{stb.wifiList.length}}) <a ng-click=\"showLi = !showLi\" href=\"\" \nclass=\"md-warn-fg\"><span translate=\"VERMAS.MOSTRAR\" ng-if=\"!showLi\">Mostrar</span><span translate=\"VERMAS.OCULTAR\" \nng-if=\"showLi\">Ocultar</span></a><li ng-repeat=\"dev in stb.wifiList\" ng-show=\"showLi\">{{dev}}</li></div></div>\n</fieldset><fieldset class=\"standard\" flex=\"100\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.VERSIONES\">Versiones</legend><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nflex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.IMAGEN2\" class=\"md-accent-fg\">\nVersión de imagen asignada:</span> {{::stb.dynamicVersion.name}}</div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.IMAGEN\" class=\"md-accent-fg\">Versión de imagen en pantalla:</span>\n {{::stb.viewed.lastDynamic}}</div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.SISTEMA2\" \nclass=\"md-accent-fg\">Versión de sistema asignada:</span> {{::stb.systemVersion.name}}</div><div flex-gt-sm=\"50\" \nflex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.SISTEMA\" class=\"md-accent-fg\">Versión del sistema:</span>\n {{::stb.viewed.lastSystem}}</div><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.BIOS2\" \nclass=\"md-accent-fg\">Versión de bios asignada:</span> {{::stb.biosVersion.name}}</div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.BIOS\" class=\"md-accent-fg\">Versión de BIOS:</span> {{::stb.viewed.lastBios}}\n</div></div></fieldset><fieldset class=\"standard\" flex=\"100\" ng-if=\"sistemaDePago\" style=\"margin-bottom: 20px\"><legend \nclass=\"form-title\" translate=\"VERMAS.OPCIONESPAGO\">Opciones de pago</legend><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start start\" layout-wrap><div flex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span \ntranslate=\"VERMAS.SALDO\" class=\"md-accent-fg\">Saldo disponible:</span> {{::stb.wallet.balance}} €</div><div \nflex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\"><span translate=\"VERMAS.TARJETAASOCIADA\" class=\"md-accent-fg\">\nTarjeta asociada: </span><span translate=\"VERMAS.TACTIL_{{stb.wallet.type === \'virtual\'}}\"></span></div><div \nflex-gt-sm=\"50\" flex=\"100\" class=\"text-gray\" ng-if=\"stb.wallet.type === \'virtual\'\"><span translate=\"VERMAS.IDWALLET\" \nclass=\"md-accent-fg\">ID tarjeta</span> {{::stb.wallet.identifier}} <a ng-click=\"moveWallet()\" class=\"md-warn-fg\" \nstyle=\"cursor: pointer\" translate=\"VERMAS.MOVEWALLET\">Mover</a> / <a ng-click=\"unlinkWallet()\" class=\"md-warn-fg\" \nstyle=\"cursor: pointer\" translate=\"VERMAS.UNLINKWALLET\">Desvincular</a></div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\"><span translate=\"VERMAS.ULTIMOWALLET\" class=\"md-accent-fg\">Último ID tarjeta leído</span>\n {{::stb.uptime.wallet}}<md-icon md-font-icon=\"icon-check\" style=\"color: green\" \nng-show=\"stb.uptime.wallet === stb.wallet.identifier\"><md-tooltip md-direction=\"right\">\nCoincide con el ID de monedero asignado</md-tooltip></md-icon><md-icon md-font-icon=\"icon-close\" style=\"color: red\" \nng-show=\"stb.uptime.wallet !== stb.wallet.identifier\"><md-tooltip md-direction=\"right\">\nNo coincide con el ID de monedero asignado</md-tooltip></md-icon></div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\" ng-if=\"lastCheckinOperation\"><span translate=\"VERMAS.ULTIMOWALLETPIN\" class=\"md-accent-fg\">\nPIN de devolución</span> {{lastCheckinOperation.idAccountant| generateCode}}</div><div flex-gt-sm=\"50\" flex=\"100\" \nclass=\"text-gray\"><a ng-click=\"getCardLog()\" class=\"md-warn-fg\" style=\"cursor: pointer\" translate=\"VERMAS.CARDLOG\">\nVer log tarjetero</a></div></div></fieldset><fieldset class=\"standard\" flex=\"100\" ng-if=\"sistemaDePago\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\"><span translate=\"VERMAS.SERVICIOSACTIVOS\">Servicios activos\n</span> <a ng-click=\"verOperaciones(stb)\" translate=\"PRINCIPAL.SIDENAV.SERVICIOS.LINK\" style=\"cursor: pointer\">\n(Ver operaciones)</a></legend><div layout=\"column\" layout-align=\"start start\" layout-wrap><span \nng-repeat=\"serv in stb.wallet.services\"><b>{{::serv.name[$translate.use()]}}</b> - <span \ntranslate=\"PRINCIPAL.SIDENAV.SERVICIOS.FINALIZA\">Finaliza el</span>\n {{::serv.endDate|date:\'d/M/yyyy HH:mm\'}} ({{::serv.remainingTimeInMinutes|convertMinutesInHHMMSS}})</span></div><div \nclass=\"grey-500-fg text-italic\" translate=\"VERMAS.CRUSHEDSERVICES\" ng-if=\"stb.hasCrushedServices\">\nTiene servicios en el monedero del equipo</div><a ng-click=\"changeRoom()\" class=\"md-warn-fg\" style=\"cursor: pointer\" \ntranslate=\"VERMAS.MOVEPERSONAL\">Mover servicios y saldo</a></fieldset><fieldset class=\"standard\" flex=\"100\" \nstyle=\"margin-bottom: 20px\"><legend class=\"form-title\" translate=\"VERMAS.DATOSUSO\">Datos de uso</legend><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><span flex-gt-sm=\"50\" flex=\"100\"><span translate=\"VERMAS.ULTCON\" \nclass=\"md-accent-fg\">Última conexión:</span> {{::stb.status.ultConexion| date:\'dd/MM/yyyy HH:mm\'}} </span><span \nflex-gt-sm=\"50\" flex=\"100\"><span translate=\"VERMAS.PANTALLA\" class=\"md-accent-fg\">Pantalla actual:</span>\n {{::stb.status.currentScreen}} ({{::stb.status.currentInfo}} / {{::stb.status.currentShadow}}) </span><span \nflex-gt-sm=\"50\" flex=\"100\"><span translate=\"VERMAS.WELCOME\" class=\"md-accent-fg\">Mensaje de bienvenida</span> <span \ntranslate=\"VERMAS.WELCOME_{{::stb.properties.displayWelcome}}\"></span> </span><span flex-gt-sm=\"50\" flex=\"100\" \nng-if=\"stb.uptime\"><span translate=\"VERMAS.UPTIME\" class=\"md-accent-fg\">Encendido hace</span> {{::stb.uptime.uptime}}\n</span><stb-screenshot stb=\"stb\" size=\"30\" class=\"margin-top-8\"></stb-screenshot></div></fieldset><fieldset \nclass=\"standard\" flex=\"100\" ng-if=\"listaIncidencias.length\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.INCIDENCIASABIERTAS\">Incidencias abiertas</legend><div ng-repeat=\"inc in listaIncidencias\" \nng-include=\"\'app/quick-panel/incidence-card.tmpl.html\'\" \nng-init=\"item = inc; isPrevent = false; cardCtrl = incidencesCardCtrl\"></div></fieldset><fieldset class=\"standard\" \nflex=\"100\" ng-if=\"listaPreventivas.length\" style=\"margin-bottom: 20px\"><legend class=\"form-title\" \ntranslate=\"VERMAS.PREVENTIVASABIERTAS\">Incidencias preventivas abiertas</legend><div \nng-repeat=\"inc in listaPreventivas\" ng-include=\"\'app/quick-panel/incidence-card.tmpl.html\'\" \nng-init=\"item = inc; isPrevent = true; cardCtrl = incidencesCardCtrl\"></div></fieldset><fieldset class=\"standard\" \nflex=\"100\" ng-if=\"diraya\" style=\"margin-bottom: 20px\"><legend class=\"form-title\">Datos de Diraya</legend><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><span flex-gt-sm=\"33\" flex=\"100\"><span class=\"md-accent-fg\">\nCentro:</span> {{diraya.centro}} </span><span flex-gt-sm=\"33\" flex=\"100\"><span class=\"md-accent-fg\">Módulo:</span>\n {{diraya.modulo}} </span><span flex-gt-sm=\"33\" flex=\"100\"><span class=\"md-accent-fg\">Cama:</span> {{diraya.cama}} \n</span><span flex-gt-sm=\"33\" flex=\"100\"><span class=\"md-accent-fg\">Unidad funcional:</span> {{diraya.unidadfuncional}} \n</span><span flex-gt-sm=\"33\" flex=\"100\"><span class=\"md-accent-fg\">Código unidad:</span> {{diraya.codigounidad}}</span>\n</div></fieldset><a ng-click=\"verEstadisticas(stb)\" href=\"#\" class=\"md-warn-fg\"><span translate=\"VERMAS.ESTADISTICAS\">\nVer últimas estadísticas</span></a></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"start center\" flex=\"noshrink\"><md-button class=\"md-fab md-mini md-warn\" \nng-click=\"connectVNC(stb, $event)\"><md-icon md-font-icon=\"icon-camcorder-box\" md-menu-align-target></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"PRINCIPAL.SIDENAV.BOTONES.VNC\">Conectar por VNC</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini md-warn\" ng-click=\"webcam(stb, $event)\" \nng-if=\"JSONconfig.webcam && $root.user.mapRole.actions.WEBCAM\"><md-icon md-font-icon=\"icon-webcam\" \nmd-menu-align-target></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PRINCIPAL.SIDENAV.BOTONES.WEBCAM\">\nMonitorizar webcam</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-click=\"videocall(stb, $event)\" ng-if=\"JSONconfig.videocall && $root.user.mapRole.actions.VIDEOCALL\"><md-icon \nmd-font-icon=\"icon-camera-front-variant\" md-menu-align-target></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRINCIPAL.SIDENAV.BOTONES.VIDEOCALL\">Videollamada</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"reiniciarStb(stb, $event)\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"PRINCIPAL.SIDENAV.BOTONES.REINICIO\">Reiniciar STB</span>\n</md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" ng-click=\"recargarInterfaz(stb, $event)\"><md-icon \nmd-font-icon=\"icon-screen-rotation\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRINCIPAL.SIDENAV.BOTONES.RECARGA\">Recargar interfaz</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"goDetails(stb)\" aria-label=\"Ver detalles\"><md-icon \nmd-font-icon=\"icon-account-box\"></md-icon><md-tooltip><span translate=\"PRINCIPAL.SIDENAV.BOTONES.DETALLES\">Ver detalles\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" ng-click=\"ventanaEditar($event, stb)\" \nng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"PRINCIPAL.SIDENAV.BOTONES.EDITAR\">Editar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"setDynamic(stb, $event)\" ng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB\">\n<md-icon md-font-icon=\"icon-arrow-up-bold-hexagon-outline\"></md-icon><md-tooltip><span \ntranslate=\"LISTADO_STB.BOTONESSTB.ACTUALIZAR\">Actualizar dynamic</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"deleteCacheEdid(stb, $event)\" \nng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB\"><md-icon md-font-icon=\"icon-image-broken\"></md-icon><md-tooltip>\n<span translate=\"LISTADO_STB.BOTONESSTB.EDID\">Limpiar caché Edid</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"resetHubUsb(stb, $event)\" ng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB\">\n<md-icon md-font-icon=\"icon-usb\"></md-icon><md-tooltip><span translate=\"LISTADO_STB.BOTONESSTB.HUB_USB\">\nReiniciar Hub USB</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-if=\"stb.checkTypeInOut !== \'In\' && !stb.properties.locked\" ng-click=\"checkIn(stb, $event)\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip><span translate=\"LISTADO_STB.BOTONESSTB.CHECKIN\">Check-in</span>\n</md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-if=\"stb.checkTypeInOut === \'In\' && !stb.properties.locked\" ng-click=\"checkOut(stb, $event)\"><md-icon \nmd-font-icon=\"icon-account-remove\"></md-icon><md-tooltip><span translate=\"LISTADO_STB.BOTONESSTB.CHECKOUT\">Check-out\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-if=\"!stb.properties.locked && $root.user.mapRole.actions.BLOCK_STB\" ng-click=\"changeLock(stb, true, $event)\">\n<md-icon md-font-icon=\"icon-lock\"></md-icon><md-tooltip><span translate=\"LISTADO_STB.BOTONESSTB.BLOQUEAR\">Bloquear STB\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-warn\" \nng-if=\"stb.properties.locked && $root.user.mapRole.actions.BLOCK_STB\" ng-click=\"changeLock(stb, false, $event)\">\n<md-icon md-font-icon=\"icon-lock-unlocked\"></md-icon><md-tooltip><span translate=\"LISTADO_STB.BOTONESSTB.DESBLOQUEAR\">\nDesbloquear STB</span></md-tooltip></md-button><span flex></span><md-button class=\"md-fab md-mini\" \nng-click=\"nuevaCompra($event)\" ng-if=\"sistemaDePago && $root.user.mapRole.actions.CREATE_EDIT_STB\"><md-icon \nmd-font-icon=\"icon-package-variant\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRINCIPAL.SIDENAV.BOTONES.NUEVAOPERACION\">Nueva operación</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" ng-click=\"openSidenavLlamadas(stb)\" \nng-if=\"$root.user.mapRole.actions.CREATE_EDIT_STB\"><md-icon md-font-icon=\"icon-phone-log\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"PRINCIPAL.SIDENAV.BOTONES.LLAMADAS\">Lista de llamadas</span></md-tooltip>\n</md-button></md-dialog-actions><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"llamadas\" \nstyle=\"min-width: fit-content\"><md-toolbar class=\"md-theme-light\" layout-align=\"center center\"><div \nclass=\"md-toolbar-tools\"><h1 class=\"md-toolbar-tools\"><span translate=\"PRINCIPAL.SIDENAV.LLAMADAS.TITLE\">\nLista de llamadas</span></h1><md-button class=\"md-icon-button\" ng-click=\"closeSidenavLlamadas()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-content id=\"knocks\">\n<form name=\"busquedaForm\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><label class=\"hint\">\nInicio</label><input type=\"date\" ng-model=\"busqueda.ini\" required></div><div layout=\"column\"><label class=\"hint\">Fin\n</label><input type=\"date\" ng-model=\"busqueda.fin\" required></div><md-button class=\"md-fab md-mini\" \nng-click=\"buscar()\" ng-disabled=\"busquedaForm.$invalid\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"VOIP.KNOCKS.BUSCAR\">Buscar</span></md-tooltip></md-button></form><table \nng-show=\"listaLlamadas.length > 0\"><tr class=\"md-accent-bg\"><th translate=\"VOIP.KNOCKS.FECHA\">Fecha / hora</th><th \ntranslate=\"VOIP.KNOCKS.DURACION\">Duración</th><th translate=\"VOIP.KNOCKS.DESTINO\">Destino</th><th \ntranslate=\"VOIP.KNOCKS.COSTE\">Coste</th><th translate=\"VOIP.KNOCKS.TARIFA\">Tarifa</th><th \ntranslate=\"VOIP.KNOCKS.STATUS\">Estado</th></tr><tr ng-repeat=\"knock in listaLlamadas\"><td>\n{{::knock.ini|date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{::(knock.fin - knock.ini)/1000|convertSeconds:true}}</td><td>\n{{::knock.destiny}}</td><td>{{::knock.amount}}€</td><td>{{::knock.tarification.price}}€/min.</td><td>{{::knock.status}}\n</td></tr></table><h3 style=\"color: red\" ng-show=\"listaLlamadas.length < 1\">No hay llamadas registradas</h3>\n</md-content></md-sidenav></md-dialog>");
$templateCache.put("app/main/Quantion/principal/templates/nuevacompra.tmpl.html","<md-dialog id=\"gestionCompras\" aria-label=\"Nueva compra\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\" style=\"max-height: 100%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"OPERACIONES.NUEVACOMPRA.TITLE\">Comprar paquete a un STB</h2></div></md-toolbar><md-dialog-content><form \nname=\"CompraPaquete\" novalidate><h2>\n{{\'OPERACIONES.DISPLAYTEXT\'|translate:\"{room:\'\"+compra.selectedStb.room+\"\',username:\'\"+compra.selectedStb.username+\"\',balance:\'\"+compra.selectedStb.wallet.balance+\"\'}\"}}\n</h2><div layout=\"row\" layout-xs=\"column\" flex><md-input-container class=\"md-block\" flex=\"50\" flex-xs=\"100\"><label \ntranslate=\"OPERACIONES.NUEVACOMPRA.PAQUETE\">Paquete</label><md-select ng-model=\"compra.selectedPackage\" name=\"paquete\" \nrequired><md-option ng-repeat=\"pkg in listaPaquetes\" ng-value=\"pkg\">{{pkg.name|formatNameDesc}}</md-option></md-select>\n<div ng-messages=\"CompraPaquete.paquete.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nclass=\"layout-column md-block\" flex=\"50\" flex-xs=\"100\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"OPERACIONES.NUEVACOMPRA.DURACION\">Duración</label><md-select ng-model=\"compra.duration\" name=\"duracion\" \nrequired ng-disabled=\"!compra.selectedPackage\"><md-option ng-repeat=\"dur in compra.selectedPackage.durationPrice\" \nvalue=\"{{dur.duration}}\">{{dur.duration|convertMinutesInHHMMSS}}: {{dur.price}}€</md-option><md-option \nng-disabled=\"compra.payment !== \'Cortesy\'\" value=\"custom\">Personalizada (solo cortesía)</md-option></md-select><div \nng-messages=\"CompraPaquete.duracion.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nng-if=\"compra.duration === \'custom\'\"><md-input-container class=\"md-block no-errors-spacer margin-0\" flex><label><span \ntranslate=\"OPERACIONES.SERVICIOCORTESIA.DURACION\">Duración</span> ({{compra.customDuration|convertMinutesInHHMMSS}})\n</label><input type=\"number\" ng-model=\"compra.customDuration\" name=\"duracion\" step=\"60\"><div \nng-messages=\"Form.duracion.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><md-button \nclass=\"md-raised md-accent\" ng-click=\"compra.customDuration = compra.customDuration + 60\">+ 1h</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"compra.customDuration = compra.customDuration + 1440\">+ 1d</md-button></div>\n</div></div><md-radio-group ng-model=\"compra.payment\" layout-margin required><md-radio-button value=\"Cortesy\" \naria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.REGALO\">Regalo (cortesía)</span></md-radio-button>\n<md-radio-button value=\"Balance\" aria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.SALDO\">Pagado mediante saldo\n</span></md-radio-button><md-radio-button value=\"Cash\" aria-label=\"a\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.EFECTIVO\">Pagado en efectivo</span></md-radio-button><md-radio-button value=\"Card\" \naria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.TARJETA\">Pagado con tarjeta</span></md-radio-button>\n<md-radio-button value=\"TwoPending\" aria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.PENDIENTE\">\nDejar pendiente de pago</span></md-radio-button></md-radio-group><div class=\"comentario\" \nng-show=\"compra.payment === \'TwoPending\'\" translate=\"OPERACIONES.NUEVACOMPRA.COMENTARIOPENDIENTE\">\nAl dejar la compra pendiente, especifique los detalles del pago en el comentario (Fecha de pago, causa, etc.)<br>\nCuando se efectúe el pago, deberá indicarlo buscando esta operación y marcándola como pagada.</div><md-input-container \nclass=\"md-block\"><label translate=\"OPERACIONES.RECARGASALDO.COMENTARIO\">Comentario</label><input name=\"comment\" \nng-model=\"compra.comment\" md-maxlength=\"1000\" required><div ng-messages=\"CompraPaquete.comment.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">\nEste campo es obligatorio.</div></div></md-input-container><div style=\"color: red; text-align: center\" \ntranslate=\"{{mensajeError}}\" ng-show=\"mensajeError\">{{mensajeError}}</div></form></md-dialog-content><md-dialog-actions\n layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"CompraPaquete.$invalid || CompraPaquete.$pristine || dataLoading\" style=\"margin-right:20px\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/equipos/tasks.html","<div id=\"tasks\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\">\n<div class=\"type-selector layout-row layout-wrap\"><div ng-class=\"{\'md-warn-bg\': typeSelected === \'programmed\'}\" \nng-click=\"selectType(\'programmed\')\" flex=\"50\" flex-xs=\"100\"><span translate=\"TASKS.PROGRAMADAS\">Tareas programadas\n</span></div><div ng-class=\"{\'md-warn-bg\': typeSelected === \'inmediate\'}\" ng-click=\"selectType(\'inmediate\')\" flex=\"50\" \nflex-xs=\"100\"><span translate=\"TASKS.NORMALES\">Tareas inmediatas</span></div><div \nng-class=\"{\'md-warn-bg\': typeSelected === \'template\'}\" ng-click=\"selectType(\'template\')\" flex=\"50\" flex-xs=\"100\"><span \ntranslate=\"LISTADOAVISOS.PLANTILLAS\">Plantillas</span></div></div></md-content><md-content layout-padding \nlayout=\"column\" class=\"margin-top-15\" ng-hide=\"!typeSelected\"><div class=\"event-container\"><md-list \nng-show=\"typeSelected === \'programmed\'\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento programado\" \nng-click=\"addTask()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Borrar todo\" ng-click=\"deleteAllTasks(\'eventProgrammed\')\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><span>Página</span><md-input-container \nclass=\"margin-vertical-5 margin-left-16\"><md-select ng-model=\"vm.taskProgrammedNum\" \nng-change=\"CargarTasks(typeSelected, vm.taskProgrammedNum)\"><md-option ng-repeat=\"page in vm.taskProgrammedPages\" \nvalue=\"{{page}}\">{{page}}</md-option></md-select></md-input-container></div></div><md-subheader class=\"md-no-sticky\">\nEn curso ({{vm.tasksProgrammed.encurso.length}})</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasksProgrammed.encurso\" ng-click=\"details(task)\"><img ng-src=\"{{task.header.icon}}\" \nclass=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}\n</h3><h4>{{task.description}}</h4><p>\n{{task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{task.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{task.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.copyTask(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"TASKS.COPIAR\">Copiar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">\nSin empezar ({{vm.tasksProgrammed.pendientes.length}})</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasksProgrammed.pendientes\" ng-click=\"details(task)\"><img ng-src=\"{{task.header.icon}}\" \nclass=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}\n</h3><h4>{{task.description}}</h4><p>\n{{task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{task.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{task.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">\nFinalizados ({{vm.tasksProgrammed.finalizados.length}})</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasksProgrammed.finalizados\" ng-click=\"details(task)\"><img ng-src=\"{{task.header.icon}}\" \nclass=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}\n</h3><h4>{{task.description}}</h4><p>\n{{task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{task.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{task.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'inmediate\'\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" \naria-label=\"Nuevo evento programado\" ng-click=\"addTask()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"Borrar todo\" ng-click=\"deleteAllTasks(\'event\')\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><span>Página\n</span><md-input-container class=\"margin-vertical-5 margin-left-16\"><md-select ng-model=\"vm.taskProgrammedNum\" \nng-change=\"CargarTasks(typeSelected, vm.taskProgrammedNum)\"><md-option ng-repeat=\"page in vm.taskProgrammedPages\" \nvalue=\"{{page}}\">{{page}}</md-option></md-select></md-input-container></div></div><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasks\" ng-click=\"details(task)\"><img ng-src=\"{{task.header.icon}}\" class=\"md-avatar\" alt=\"\" \nng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}</h3><h4>{{task.description}}\n</h4><h4>ID: {{task.idTask}}</h4></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.copyTask(task)\"><md-icon \nmd-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"TASKS.COPIAR\">Copiar</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'template\'\"><div layout=\"row\" layout-align=\"space-between\">\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" aria-label=\"Nueva plantilla\" \nng-click=\"addTemplate()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Borrar todo\" ng-click=\"deleteAllTasks(\'templateEvent\')\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><span>Página</span><md-input-container \nclass=\"margin-vertical-5 margin-left-16\"><md-select ng-model=\"vm.taskProgrammedNum\" \nng-change=\"CargarTasks(typeSelected, vm.taskProgrammedNum)\"><md-option ng-repeat=\"page in vm.taskProgrammedPages\" \nvalue=\"{{page}}\">{{page}}</md-option></md-select></md-input-container></div></div><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.templates\" ng-click=\"details(task)\"><img ng-src=\"{{task.header.icon}}\" class=\"md-avatar\" alt=\"\" \nng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}</h3><h4>{{task.description}}\n</h4><h4 class=\"md-accent-fg text-boxed\">{{task.command}}</h4></div><md-menu><md-button aria-label=\"menu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\">\n</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.copyTask(task)\"><md-icon \nmd-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"TASKS.COPIAR\">Copiar</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list></div></md-content></div></div>");
$templateCache.put("app/main/Quantion/tasks/procesos/procesos.html","<div id=\"procesos\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\"><div class=\"event-container\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"proceso in vm.procesos | orderBy: \'-fecha\' | limitTo: limit\" on-last-repeat><img \nng-src=\"{{proceso.header.icon}}\" class=\"md-avatar\" alt=\"\" ng-if=\"proceso.header.icon\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{proceso.title}}</h3><h4>{{proceso.description}}</h4><p>{{proceso.command}}</p><p>\nPID: {{proceso.pid}} - {{proceso.fecha|date:\"dd/MM/yyyy HH:mm\"}}</p></div><md-button class=\"md-fab md-mini md-accent\" \naria-label=\"eliminar\" ng-click=\"vm.eliminar(proceso.idProceso)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip><span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-tooltip></md-button></md-list-item></md-list>\n</div><md-button class=\"md-raised md-primary\" ng-click=\"loadMore()\" ng-if=\"limit < vm.procesos.length\" \nstyle=\"margin: 10px auto\">Cargar más</md-button></md-content></div></div>");
$templateCache.put("app/main/Quantion/tasks/servidor/tasks.html","<div id=\"tasks\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding layout=\"column\">\n<div class=\"type-selector layout-row layout-wrap\"><div ng-class=\"{\'md-warn-bg\': typeSelected === \'programmed\'}\" \nng-click=\"selectType(\'programmed\')\" flex=\"50\" flex-xs=\"100\"><span translate=\"TASKS.PROGRAMADAS\">Tareas programadas\n</span></div><div ng-class=\"{\'md-warn-bg\': typeSelected === \'inmediate\'}\" ng-click=\"selectType(\'inmediate\')\" flex=\"50\" \nflex-xs=\"100\"><span translate=\"TASKS.NORMALES\">Tareas inmediatas</span></div><div \nng-class=\"{\'md-warn-bg\': typeSelected === \'template\'}\" ng-click=\"selectType(\'template\')\" flex=\"50\" flex-xs=\"100\"><span \ntranslate=\"LISTADOAVISOS.PLANTILLAS\">Plantillas</span></div></div></md-content><md-content layout-padding \nlayout=\"column\" class=\"margin-top-15\" ng-hide=\"!typeSelected\"><div class=\"event-container\"><md-list \nng-show=\"typeSelected === \'programmed\'\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo evento programado\" \nng-click=\"addTask()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Borrar todo\" ng-click=\"deleteAllTasks(\'taskProgrammed\')\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><span>Página</span><md-input-container \nclass=\"margin-vertical-5 margin-left-16\"><md-select ng-model=\"vm.taskProgrammedNum\" \nng-change=\"CargarTasks(typeSelected, vm.taskProgrammedNum)\"><md-option ng-repeat=\"page in vm.taskProgrammedPages\" \nvalue=\"{{page}}\">{{page}}</md-option></md-select></md-input-container></div></div><md-subheader class=\"md-no-sticky\">\nEn curso ({{vm.tasksProgrammed.encurso.length}})</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasksProgrammed.encurso\" ng-click=\"details(task)\"><img \nng-src=\"{{task.header.icon| replacePath}}\" class=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}</h3><h4>{{task.description}}</h4><p>\n{{task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{task.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{task.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.copyTask(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"TASKS.COPIAR\">Copiar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">\nSin empezar ({{vm.tasksProgrammed.pendientes.length}})</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasksProgrammed.pendientes\" ng-click=\"details(task)\"><img \nng-src=\"{{task.header.icon| replacePath}}\" class=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}</h3><h4>{{task.description}}</h4><p>\n{{task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{task.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{task.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\">\nFinalizados ({{vm.tasksProgrammed.finalizados.length}})</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.tasksProgrammed.finalizados\" ng-click=\"details(task)\"><img \nng-src=\"{{task.header.icon| replacePath}}\" class=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}</h3><h4>{{task.description}}</h4><p>\n{{task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{task.fFin|date:\"dd/MM/yyyy HH:mm\"}} (Cada {{task.intervalo| convertMinutesInHHMMSS}})\n</p></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.reenviar(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span \ntranslate=\"LISTADOAVISOS.REENVIAR\">Reenviar</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'inmediate\'\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" \naria-label=\"Nuevo evento programado\" ng-click=\"addTask()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"Borrar todo\" ng-click=\"deleteAllTasks(\'task\')\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><span>Página\n</span><md-input-container class=\"margin-vertical-5 margin-left-16\"><md-select ng-model=\"vm.taskNum\" \nng-change=\"CargarTasks(typeSelected, vm.taskNum)\"><md-option ng-repeat=\"page in vm.taskPages\" value=\"{{page}}\">{{page}}\n</md-option></md-select></md-input-container></div></div><md-list-item class=\"md-3-line\" ng-repeat=\"task in vm.tasks\" \nng-click=\"details(task)\"><img ng-src=\"{{task.header.icon| replacePath}}\" class=\"md-avatar\" alt=\"\" \nng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}</h3><h4>{{task.description}}\n</h4><h4>ID: {{task.idTask}}</h4></div><md-menu><md-button aria-label=\"menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"md-hue-3\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.copyTask(task)\"><md-icon \nmd-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"TASKS.COPIAR\">Copiar</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><md-list ng-show=\"typeSelected === \'template\'\"><div layout=\"row\" layout-align=\"space-between\">\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" aria-label=\"Nueva plantilla\" \nng-click=\"addTemplate()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Borrar todo\" ng-click=\"deleteAllTasks(\'templateTask\')\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><span>Página</span><md-input-container \nclass=\"margin-vertical-5 margin-left-16\"><md-select ng-model=\"vm.templateTaskNum\" \nng-change=\"CargarTasks(typeSelected, vm.templateTaskNum)\"><md-option ng-repeat=\"page in vm.templateTaskPages\" \nvalue=\"{{page}}\">{{page}}</md-option></md-select></md-input-container></div></div><md-list-item class=\"md-3-line\" \nng-repeat=\"task in vm.templates\" ng-click=\"details(task)\"><img ng-src=\"{{task.header.icon| replacePath}}\" \nclass=\"md-avatar\" alt=\"\" ng-if=\"task.header.icon\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{task.title}}\n</h3><h4>{{task.description}}</h4><h4 class=\"md-accent-fg text-boxed\">{{task.command}}</h4></div><md-menu><md-button \naria-label=\"menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nclass=\"md-hue-3\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.copyTask(task)\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon><span translate=\"TASKS.COPIAR\">Copiar\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.eliminarTask($event, task.idTask)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"LISTADOAVISOS.ELIMINAR\">Eliminar</span></md-button>\n</md-menu-item></md-menu-content></md-menu></md-list-item></md-list></div></md-content></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/Quantion/archivos/servicios/templates/calendario.tmpl.html","<md-dialog id=\"calendar\" aria-label=\"Calendario\" ng-cloak flex style=\"max-height: 95vh\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.CALENDAR.TITLE\">Eventos de calendario</h2></div>\n</md-toolbar><md-dialog-content><div style=\"min-height: 60vh\"><md-button class=\"md-fab md-mini md-warn\" \nng-click=\"add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.NUEVOELEMENTO\">Nuevo elemento</span></md-tooltip></md-button><md-list \nng-repeat=\"(day, events) in service.dates\"><md-subheader class=\"md-no-sticky\"><span>{{day}}</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"event in events\"><img ng-src=\"{{event.image}}\" class=\"md-avatar\"><div \nclass=\"md-list-item-text\"><h3>{{event.title|formatNameDesc}}</h3></div><md-button class=\"md-fab md-mini\" \nng-click=\"editar(day, $index, event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"SERVICIOS.LISTASAMPLES.MODIFICAR\">Modificar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminar(day, $index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list></div><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\">\n<md-toolbar class=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\"><span translate=\"SERVICIOS.CALENDAR.SIDENAV\">\nDatos del evento</span></h1></md-toolbar><md-content layout-padding><form class=\"edicion layout-column\" name=\"form\">\n<md-tabs md-dynamic-height md-stretch-tabs=\"always\" class=\"pest\" flex><md-tab ng-repeat=\"idioma in listaIdiomas\">\n<md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" style=\"max-height: 24px\"></md-tab-label><md-tab-body><div \nlayout=\"column\"><md-input-container flex><label translate=\"SERVICIOS.CALENDAR.NOMBRE\">Nombre</label><input \nng-model=\"sample.title[idioma.idioma]\"></md-input-container><md-input-container flex><label \ntranslate=\"SERVICIOS.CALENDAR.DESCRIPCION\">Descripción</label><input ng-model=\"sample.description[idioma.idioma]\">\n</md-input-container></div></md-tab-body></md-tab></md-tabs><md-input-container flex=\"100\"><label \ntranslate=\"SERVICIOS.CALENDAR.CATEGORIA\">Categoria</label><input ng-model=\"sample.category\"></md-input-container>\n<md-input-container flex=\"100\"><label translate=\"SERVICIOS.CALENDAR.IMAGE\">Miniatura</label><input \nng-model=\"sample.image\"></md-input-container><div layout-gt-sm=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"SERVICIOS.CALENDAR.FECHA\">Fecha</label><input ng-model=\"sample.date\" type=\"date\" required name=\"date\"><div \nng-messages=\"form.date.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><md-input-container \nflex=\"50\"><label translate=\"SERVICIOS.CALENDAR.HINICIO\">Hora de inicio</label><input ng-model=\"sample.startTime\" \ntype=\"time\" required name=\"time\"><div ng-messages=\"form.time.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n</div><md-input-container flex=\"100\"><label translate=\"SERVICIOS.CALENDAR.DURACION\">Duración</label><input \nng-model=\"sample.duration\" type=\"number\" step=\"60\" min=\"0\"> <span>{{sample.duration|convertSeconds}}</span>\n</md-input-container><div layout=\"row\" layout-align=\"end\"><md-button ng-click=\"close()\" translate=\"SERVICIOS.CERRAR\">\nCerrar</md-button><md-button ng-click=\"updateList()\" style=\"margin-right:20px\" \ntranslate=\"SERVICIOS.CALENDAR.ANADIREVENTO\" ng-disabled=\"form.$invalid\">Añadir evento</md-button></div></form>\n</md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/servicios/templates/crearservicio.tmpl.html","<md-dialog id=\"servicios\" aria-label=\"Crear servicio\" ng-cloak flex=\"100\" flex-gt-sm=\"90\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"{{title}}\" \ntranslate-values=\'{serviceType:\"{{::(\"SERVICIOS.TIPOS.\" + serviceType|translate)}}\"}\'></h2></div></md-toolbar>\n<md-dialog-content><form name=\"crearServicioForm\" novalidate layout-gt-sm=\"row\" layout=\"column\"><div flex><md-tabs \nmd-dynamic-height md-stretch-tabs=\"always\" class=\"pest\"><md-tab ng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img \nng-src=\"{{idioma.rutaIcono|replacePath}}\" style=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container \nclass=\"md-block\"><label translate=\"SERVICIOS.MODALEDITAR.NOMBRE\">Nombre del servicio</label><input \nname=\"name{{idioma.idioma}}\" ng-model=\"service.name[idioma.idioma]\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"SERVICIOS.MODALEDITAR.DESCRIPCION\">Descripción</label><textarea \nstyle=\"height: 100px\" name=\"description{{idioma.idioma}}\" ng-model=\"service.description[idioma.idioma]\" \nmd-maxlength=\"1000\" rows=\"5\"></textarea></md-input-container><md-input-container ng-if=\"service.type === \'tv\'\" \nclass=\"md-block\"><label translate=\"SERVICIOS.MODALEDITAR.VIDEOURL\">URL del video promocional</label><input \nname=\"videoUrl{{idioma.idioma}}\" ng-model=\"service.blockedVideo[idioma.idioma]\"></md-input-container>\n<md-input-container ng-if=\"service.type === \'tv\'\" class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.VISIBLEVIDEOURL\">URL del video de error</label><input \nname=\"visibleUrl{{idioma.idioma}}\" ng-model=\"service.visibleVideo[idioma.idioma]\"></md-input-container></md-tab-body>\n</md-tab></md-tabs><md-input-container ng-if=\"service.type === \'wifi\'\" class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.MAXCONEXIONES\">Nº máximo de conexiones</label><input name=\"maxConexiones\" \ntype=\"number\" min=\"1\" max=\"2147483647\" ng-model=\"service.maxConnections\" required><div \nng-messages=\"crearServicioForm.maxConexiones.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"SERVICIOS.MODALEDITAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" \ntranslate=\"SERVICIOS.MODALEDITAR.MIN\">El valor no puede ser menor que 1</div><div ng-message=\"max\" \ntranslate=\"SERVICIOS.MODALEDITAR.MAX\">El valor no puede ser mayor que 2147483647</div></div></md-input-container>\n<md-input-container ng-if=\"service.type === \'onlineradio\'\" class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.COUNTRIES\">Paises (separados por comas)</label><md-chips ng-model=\"service.countries\">\n</md-chips></md-input-container><md-input-container ng-if=\"service.type === \'weather\'\" class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.CITIES\">Ciudades (separadas por comas)</label><md-chips ng-model=\"service.cities\">\n</md-chips></md-input-container></div><div flex class=\"servicio-second-div layout-column\"><div class=\"pest\"><div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"SERVICIOS.MODALEDITAR.TIPO\">Tipo de enlace\n</label><md-select ng-model=\"toActionBasic.url\" disabled=\"disabled\"><md-option \nng-repeat=\"method in [\'https://wc.solertia.sol:8091/browser\', \'href\']\" value=\"{{method}}\"><span \ntranslate=\"SERVICIOS.MODALEDITAR.{{method}}\">Enlace externo / Enlace interno</span></md-option></md-select>\n</md-input-container><md-divider></md-divider><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.URL\"></label><input ng-model=\"toActionBasic.data\"></md-input-container></div></div>\n<md-checkbox ng-model=\"service.active\" aria-label=\"Active service\" class=\"margin-top-15\" style=\"margin-left: 0\"><span \ntranslate=\"SERVICIOS.MODALEDITAR.ACTIVO\">Activo</span></md-checkbox><md-input-container \nclass=\"md-block no-errors-spacer\" ng-if=\"service.type === \'group\' || service.type === \'files\'\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.STYLE\">Estilo visual</label><md-select ng-model=\"service.style\"><md-option \nng-value=\"null\"></md-option><md-option ng-repeat=\"s in [\'normal\', \'horizontal\', \'vertical\']\" value=\"{{s}}\">{{s}}\n</md-option></md-select></md-input-container></div></form><div style=\"color: red; text-align: center\" \ntranslate=\"{{mensajeError}}\">{{mensajeError}}</div></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"crearServicioForm.$invalid\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/servicios/templates/listaSamples.tmpl.html","<md-dialog id=\"samples\" aria-label=\"Archivos disponibles\" ng-cloak flex \nstyle=\"max-height: 95vh; height: -webkit-fill-available\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.LISTASAMPLES.TITLE\">Archivos disponibles</h2></div></md-toolbar>\n<md-dialog-content style=\"height: -webkit-fill-available\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.LISTAELEMENTOS\">Lista de elementos</span></md-subheader><md-button \nclass=\"md-fab md-mini md-warn btn-abs\" ng-click=\"add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.NUEVOELEMENTO\">Nuevo elemento</span></md-tooltip>\n</md-button><md-list-item class=\"md-2-line\" ng-repeat=\"smpl in service.samples\"><div class=\"md-list-item-img\"><img \nng-src=\"{{smpl.thumbnail|replacePath}}\" on-error-image=\"/assets/quantionImagenes/img-error.png\"></div><div \nclass=\"md-list-item-text\"><h3>{{smpl.name|formatNameDesc}}</h3><a href=\"{{smpl.url|formatNameDesc|replacePath}}\" \ntarget=\"blank\">{{smpl.url|formatNameDesc}}</a></div><md-button class=\"md-fab md-mini\" ng-click=\"editar($index, smpl)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.MODIFICAR\">Modificar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminar($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list><md-divider></md-divider><div style=\"position: relative\"><md-subheader class=\"md-no-sticky\">\n<span translate=\"SERVICIOS.LISTASAMPLES.LISTAARCHIVOS\">Lista de archivos</span></md-subheader><md-button \nclass=\"md-fab md-mini md-warn btn-abs\" ng-click=\"upload()\"><md-icon md-font-icon=\"icon-upload\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"FILEEXPLORER.SUBIRARCHIVO\">Subir archivo</span></md-tooltip></md-button><input \ntype=\"file\" id=\"uploadFile\" hidden><div layout=\"row\" layout-wrap><div ng-repeat=\"file in listaArchivos\" \nclass=\"enlace-archivo md-warn-bg\"><a ng-href=\"{{file.path|replacePath}}\" target=\"blank\" class=\"md-warn-bg\">\n{{file.name}}</a></div></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\">\n<md-toolbar class=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\"></h1></md-toolbar><md-content layout-padding><form><div \nclass=\"edicion layout-column\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" class=\"pest\" flex><md-tab \nng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><div layout=\"column\"><md-input-container flex><label \ntranslate=\"SERVICIOS.LISTASAMPLES.NOMBRE\">Nombre</label><input ng-model=\"sample.name[idioma.idioma]\">\n</md-input-container><md-input-container flex><label translate=\"SERVICIOS.LISTASAMPLES.DESCRIPCION\">Descripción</label>\n<input ng-model=\"sample.description[idioma.idioma]\"></md-input-container><md-input-container flex><label \ntranslate=\"SERVICIOS.LISTASAMPLES.URL\">URL</label><md-select ng-model=\"sample.url[idioma.idioma]\"><md-option \nng-repeat=\"file in listaArchivos\" value=\"{{file.path}}\">{{file.name}}</md-option></md-select><span \nng-click=\"replicar(sample.url[idioma.idioma])\" translate=\"SERVICIOS.LISTASAMPLES.REPLICAR\" \nclass=\"md-accent-fg replicar\">Pulsa aquí para asignar este recurso a todos los idiomas</span></md-input-container>\n</div></md-tab-body></md-tab></md-tabs><md-input-container flex=\"100\"><label \ntranslate=\"SERVICIOS.LISTASAMPLES.MINIATURA\">Miniatura</label><md-select ng-model=\"sample.thumbnail\"><md-option \nng-repeat=\"file in listaArchivos\" value=\"{{file.path}}\">{{file.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\"><label translate=\"SERVICIOS.LISTASAMPLES.MIME\">Tipo de archivo</label><md-select \nng-model=\"selectedMime\" ng-change=\"mimeChanged(selectedMime)\"><md-option value=\"video\">Video</md-option><md-option \nvalue=\"imagen\">Imagen</md-option><md-option value=\"audio\">Audio</md-option><md-option value=\"doc\">Documento</md-option>\n<md-option value=\"_\">Otro</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nng-show=\"selectedMime === \'_\'\"><label translate=\"SERVICIOS.LISTASAMPLES.CUSTOMMIME\">Indica el tipo</label><input \nng-model=\"customMime\" ng-change=\"mimeChanged(customMime)\"></md-input-container><div layout=\"row\" layout-align=\"end\">\n<md-button ng-click=\"close()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"updateList()\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></div></div></form></md-content>\n</md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/templates/asignarBanners.tmpl.html","<md-dialog id=\"publicidad\" aria-label=\"Asignar Stbs\" ng-cloak flex=\"100\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><div class=\"contenedorImgs\" \nlayout=\"column\"><div class=\"listaImgs\" layout=\"row\" layout-wrap><div ng-repeat=\"banner in listaArchivos\" \nclass=\"elemento {{exists(banner) ? \'div-selected\' : \'\'}} layout-row layout-align-center-center\"><img \nng-src=\"{{banner.path|replacePath}}\" class=\"imagen\" ng-if=\"banner.type === \'IMG\'\"><video \nng-if=\"banner.type === \'VIDEO\'\" class=\"imagen\"><source ng-src=\"{{banner.path| replacePath | trustUrl}}\" \ntype=\"video/mp4\"></video><md-tooltip>{{banner.name}}</md-tooltip><div class=\"overlay\"><div class=\"zoom\" \nng-click=\"zoomImagen(banner)\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"icon\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate=\"BANNERS.PANTALLACOMPLETA\">Pantalla completa</span></md-tooltip></div></div>\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"check\" \nng-class=\"{\'selected\':exists(banner) ,\'noSelected\':!exists(banner)}\" ng-click=\"toggle(banner,$event)\"></md-icon>\n<md-icon md-font-icon=\"icon-video\" class=\"top-left-icons md-accent\" ng-if=\"banner.type === \'VIDEO\'\"></md-icon></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"GRUPOSSTB.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"GRUPOSSTB.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/templates/asignarStb.tmpl.html","<md-dialog id=\"grupos-banners\" aria-label=\"Asignar Stbs\" ng-cloak flex=\"100\" md-theme=\"{{$root.theme}}\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><md-button \nclass=\"md-raised md-primary\" ng-click=\"marcarTodo(true)\" translate=\"LOTES.MARCARTODO\">Marcar todo</md-button><md-button\n class=\"md-raised md-primary\" ng-click=\"marcarTodo(false)\" translate=\"LOTES.DESMARCARTODO\">Desmarcar todo</md-button>\n<div layout-gt-sm=\"row\" layout=\"column\" layout-wrap><div class=\"groupContainer\" ng-repeat=\"grupo in listaGrupos\" \nlayout=\"column\" on-last-repeat><div class=\"groupHeader\" layout=\"row\" layout-align=\"center-center\"><div flex>\n{{grupo.nombre}} <span ng-if=\"grupo.place\">({{grupo.place}})</span></div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(grupo.idStbGroup, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" \nclass=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo\n</span></md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(grupo.idStbGroup, false)\"><md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\" \nclass=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo\n</span></md-tooltip></md-button></div><div class=\"groupBody\" layout=\"column\"><md-checkbox \nng-repeat=\"stb in grupo.cStbs|orderBy:\'room\'\" aria-label=\"seleccionado\" ng-checked=\"exists(stb.idStb)\" \nng-click=\"toggle(stb.idStb)\">{{stb.room}} - {{stb.username}}</md-checkbox></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"GRUPOSSTB.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" translate=\"GRUPOSSTB.GUARDAR\">Guardar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/templates/editarGrupo.tmpl.html","<md-dialog id=\"grupos-banners\" aria-label=\"Crear grupo\" md-theme=\"{{$root.theme}}\" flex flex-xs=\"100\" flex-sm=\"100\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><form \nname=\"form\" novalidate layout=\"column\"><md-input-container class=\"md-block no-errors-spacer\" md-no-float><label \ntranslate=\"GRUPOSSTB.EDITAR.NOMBRE\">Nombre del grupo</label><input name=\"nombre\" ng-model=\"grupo.nombre\" required><div \nng-messages=\"form.nombre.$error\"><div ng-message=\"required\" translate=\"GRUPOSSTB.EDITAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nmd-no-float><label translate=\"GRUPOSSTB.EDITAR.DESCRIPCION\">Descripción</label><textarea name=\"description\" \nng-model=\"grupo.description\" rows=\"5\" md-maxlength=\"200\" style=\"resize: vertical\"></textarea></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" md-no-float><label translate=\"GRUPOSSTB.EDITAR.ORDEN\">Orden\n</label><input name=\"orden\" ng-model=\"grupo.orden\" required type=\"number\"><div ng-messages=\"form.orden.$error\"><div \nng-message=\"required\" translate=\"GRUPOSSTB.EDITAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n<div style=\"color: red; text-align: center; margin-top: 20px\" ng-if=\"mensajeError\">{{mensajeError}}</div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"GRUPOSSTB.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"GRUPOSSTB.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/archivos/nombreRandom/templates/help.tmpl.html","<md-dialog id=\"publicidad-ayuda\" aria-label=\"Ayuda\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"selected\"></md-icon><p>Banner activado</p></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"noSelected\"></md-icon><p>\nBanner desactivado</p><p></p></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-video\" \nclass=\"md-accent\"></md-icon><p>Banner de video</p><p></p></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-web\" class=\"md-accent\"></md-icon><p>Banner con página web embebida</p><p></p></div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"md-accent\"></md-icon><p>\nPrioridad alta: Estos banners tienen preferencia sobre los de prioridad normal.</p><p></p></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-double-up\" class=\"md-accent\"></md-icon><p>\nPrioridad muy alta: Estos banners tienen preferencia sobre los de prioridad alta y normal.</p><p></p></div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-volume\" class=\"md-accent\"></md-icon><p>\nBanner con sonido</p><p></p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"hide()\" \ntranslate=\"GRUPOSSTB.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/auth/errores/404/error-404.html","<div id=\"error404\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"space-around center\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div><img src=\"/assets/quantionImagenes/error404.png\">\n</div><div layout=\"column\"><div class=\"error-code\" flex=\"50\">404</div><div class=\"message\" flex=\"50\" \ntranslate=\"E404.MESSAGE\">Página no encontrada</div></div></div><div><md-button class=\"md-raised md-primary\" \nng-click=\"goHome()\" translate=\"E404.GOHOME\">Volver a Inicio</md-button></div></div>");
$templateCache.put("app/main/Quantion/auth/errores/500/error-500.html","<div id=\"error500\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"space-around center\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div><img src=\"/assets/quantionImagenes/error500.png\">\n</div><div layout=\"column\"><div class=\"error-code\" flex=\"50\">500</div><div class=\"message\" flex=\"50\" \ntranslate=\"E500.MESSAGE\">Error interno del servidor</div></div></div><div class=\"buttons\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-click=\"goHome()\" ng-disabled=\"tryingReturn\" \ntranslate=\"E500.GOHOME\">Volver a Inicio</md-button><span ng-show=\"tryingReturn\" translate=\"E500.CONECTING\"><img \nsrc=\"/assets/quantionImagenes/cargando.gif\">Conectando...</span> <span ng-show=\"error\" style=\"color: red\" \ntranslate=\"E500.ERROR\">No se puede establecer la conexión. Vuelva a intentarlo más tarde</span></div></div>");
$templateCache.put("app/main/Quantion/auth/errores/401/error-401.html","<div id=\"error401\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"space-around center\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div><img src=\"/assets/quantionImagenes/error401.png\">\n</div><div layout=\"column\"><div class=\"error-code\" flex=\"50\">401</div><div class=\"message\" flex=\"50\" \ntranslate=\"E401.MESSAGE\">Acceso denegado</div></div></div><div><md-button class=\"md-raised md-primary\" \nng-click=\"goHome()\" translate=\"E401.GOHOME\">Volver a Inicio</md-button></div></div>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/details.tmpl.html","<md-dialog id=\"aviso-details\" aria-label=\"Detalles aviso\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"image-container\" ng-hide=\"!event.header.icon && !event.header.properties.image.logo\"><img \nng-src=\"{{::(event.header.icon || event.header.properties.image.logo) | replacePath}}\" alt=\"\"></div><div><h2>\n{{::(event.title || event.header.properties.title.text)}}</h2><h3>\n{{::(event.description || prog.header.properties.description.text)}}</h3><h4 ng-hide=\"!event.fIni\">\n{{::event.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{::event.fFin|date:\"dd/MM/yyyy HH:mm\"}} ({{::event.displaytime|convertSeconds}}, cada {{::event.intervalo| convertMinutesInHHMMSS}})\n</h4><h4 ng-hide=\"event.fIni\">{{::event.fecha|date:\"dd/MM/yyyy HH:mm\"}} ({{::event.displaytime|convertSeconds}})</h4>\n</div></div><fieldset ng-hide=\"!event.stbs || event.stbs.length < 1\"><legend>Equipos seleccionados</legend><div \nlayout=\"row\" layout-wrap ng-if=\"event.stbs.length !== allStbsLength\"><div class=\"room-container\" \nng-repeat=\"stb in event.cstbs track by $index\">{{::stb.room || \'?\'}}</div></div><p \nng-if=\"event.stbs.length === allStbsLength\" translate=\"LISTADOAVISOS.TODOS\">Todos</p></fieldset><fieldset \nng-hide=\"!event.services || event.services.length < 1\"><legend>Servicios seleccionados</legend><div layout=\"row\" \nlayout-wrap><div class=\"room-container\" ng-repeat=\"srvc in event.cservices track by $index\">\n{{::srvc.name|formatNameDesc}}</div></div></fieldset><a href=\"#\" ng-click=\"showJson = !showJson\">\nVer/ocultar JSON completo</a><pre ng-show=\"showJson\" class=\"md-light-blue-50-bg margin-0\">{{::event|json}}</pre>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenNotif\" aria-label=\"Elegir imagen\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-dialog-content><div layout=\"row\" layout-wrap layout-align=\"start stretch\"><div \nng-repeat=\"obj in listaLogos| filter: {name:logo_}\" layout=\"column\" layout-align=\"start center\" class=\"element\"><div \nclass=\"img-container\"><img ng-src=\"{{::(obj.path|replacePath)}}\" ng-click=\"escogerImagen(obj)\"></div></div></div><div \nlayout=\"row\" class=\"margin-top-30\"><input type=\"url\" ng-model=\"url\" flex flex-gt-sm=\"50\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"escogerImagen({path: url})\">Seleccionar URL</md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"hide()\" \ntranslate=\"CREAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/event-publi.tmpl.html","<md-dialog id=\"enviarAviso\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.MENSAJE\">Mensaje</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"event.arguments.type\" \nrequired><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"space-around center\" class=\"tipo-aviso\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div></div></md-radio-group>\n<md-input-container class=\"md-block\" ng-if=\"event.arguments.type === \'simple\'\"><label translate=\"ENVIAR.TEXTO\">Texto\n</label><input type=\"text\" name=\"stitle\" ng-model=\"event.header.title\" md-maxlength=\"255\" required><div \nng-messages=\"paso1.stitle.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD1\">El nombre debe tener menos de 255 caracteres.</div></div></md-input-container><div \nng-if=\"event.arguments.type === \'completo\'\"><md-input-container class=\"md-block\"><label translate=\"ENVIAR.TITULO\">\nTítulo</label><input type=\"text\" name=\"title\" ng-model=\"event.header.title\" md-maxlength=\"80\" required><div \nng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ENVIAR.CONTENIDO\">Contenido del aviso</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"event.header.body\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><span translate=\"ENVIAR.IMAGEN\">Imagen</span><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><img ng-src=\"{{event.header.icon|replacePath}}\" alt=\"{{event.header.icon}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"logo\" ng-model=\"event.header.icon\" required><div ng-messages=\"paso1.logo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-checkbox ng-model=\"event.toSmartPhones\" \nng-show=\"JSONconfig.avisosSmartphones\">Enviar a smartphones</md-checkbox><div class=\"envioInfo\" \ntranslate=\"LISTADOAVISOS.PUBLIINFO\">Se enviará el aviso a los usuarios que NO tengan alguno de los servicios marcados.\n</div><div layout=\"row\" layout-xs=\"column\" layout-wrap layout-align=\"start start\" layout-align-xs=\"center stretch\"><div\n ng-repeat=\"pkg in listaPaquetes\" class=\"groupContainer\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"groupHeader\"><div flex>{{pkg.name|formatNameDesc}}</div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(pkg, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(pkg, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div layout=\"column\" \nclass=\"groupBody\"><md-checkbox ng-repeat=\"srv in pkg.ordinaryServices\" \nng-checked=\"exists(srv.idService, event.services)\" ng-click=\"toggle(srv.idService, event.services)\" \naria-label=\"servicio\"><div><img ng-src=\"{{::srv.logo|replacePath}}\" class=\"md-avatar\">{{srv.name|formatNameDesc}}</div>\n</md-checkbox></div></div></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"paso3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i \nclass=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">\nTemporización</span></span></md-tab-label><md-tab-body><form name=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"row\" layout-xs=\"column\" layout-align-gt-xs=\"space-between\"><md-input-container flex=\"50\" \nflex-xs=\"100\"><label translate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</label><input name=\"displaytime\" \ntype=\"number\" ng-model=\"event.header.time\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container><md-radio-group ng-model=\"event.type\" \nlayout=\"row\" layout-xs=\"column\" required><md-radio-button value=\"event\"><span translate=\"ENVIAR.INMEDIATO\">Inmediato\n</span></md-radio-button><md-radio-button value=\"eventProgrammed\"><span translate=\"ENVIAR.PROGRAMADO\">Programado</span>\n</md-radio-button></md-radio-group></div><div class=\"temporizacion\" layout=\"row\" layout-wrap \nng-if=\"event.type === \'eventProgrammed\'\"><md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TINICIO\">\nInicio periodo</label><input type=\"datetime-local\" ng-model=\"event.fIni\" required></md-input-container>\n<md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TFIN\">Fin periodo</label><input \ntype=\"datetime-local\" ng-model=\"event.fFin\" required></md-input-container><md-input-container flex-xs=\"100\" flex=\"33\">\n<label translate=\"ENVIAR.REPET\">Repetir cada</label><input name=\"tiemporepet\" type=\"number\" ng-model=\"event.intervalo\" \nmin=\"1\" required aria-label=\"tiemporepet\"> <button ng-click=\"event.intervalo = event.intervalo + 1440\">+1D</button> \n<button ng-click=\"event.intervalo = event.intervalo + 60\">+1H</button> <span>{{event.intervalo|convertMinutesInHHMMSS}}\n</span></md-input-container><md-input-container flex-xs=\"50\" flex><label translate=\"ENVIAR.RANGOINICIO\">Inicio rango\n</label><input type=\"time\" ng-model=\"event.rangeInit\"></md-input-container><md-input-container flex-xs=\"50\" flex><label\n translate=\"ENVIAR.RANGOFIN\">Fin rango</label><input type=\"time\" ng-model=\"event.rangeEnd\"></md-input-container></div>\n<div ng-if=\"event.type === \'eventProgrammed\'\"><div class=\"md-accent-bg info-temp\"><em>\'Hora mínima\'</em> y <em>\n\'Hora máxima\'</em>\n sirven para restringir el intervalo de horas que se verá el aviso al día. Por ejemplo, si queremos que sólo se les muestre a los pacientes entre las 9:00 y las 20:00.\n<br>Si se deja vacío, se podrán mostrar a cualquier hora.</div><div class=\"md-warn-bg info-temp margin-top-5\">\nEl aviso se enviará a los equipos entre el <b>{{event.fIni|date:\'dd/MM/yyyy HH:mm\'}}</b> y el <b>\n{{event.fFin|date:\'dd/MM/yyyy HH:mm\'}}</b><br><span ng-show=\"event.rangeInit && event.rangeEnd\">\nSolo aparecerá en su pantalla entre las <b>{{event.rangeInit|date:\'HH:mm\'}}</b> y las <b>\n{{event.rangeEnd|date:\'HH:mm\'}}</b></span></div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"ENVIAR.ANTERIOR\">Anterior\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado || event.services.length < 1\" translate=\"ENVIAR.ENVIAR\">\nEnviar evento</md-button></div></ms-form-wizard></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/event-template.tmpl.html","<md-dialog id=\"enviarAviso\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><form name=\"paso1\" class=\"md-inline-form\" novalidate>\n<md-radio-group ng-model=\"event.arguments.type\" required><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-around center\" class=\"tipo-aviso\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div></div></md-radio-group>\n<md-input-container class=\"md-block\" ng-if=\"event.arguments.type === \'simple\'\"><label translate=\"ENVIAR.TEXTO\">Texto\n</label><input type=\"text\" name=\"stitle\" ng-model=\"event.header.title\" md-maxlength=\"255\" required><div \nng-messages=\"paso1.stitle.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD1\">El nombre debe tener menos de 255 caracteres.</div></div></md-input-container><div \nng-if=\"event.arguments.type === \'completo\'\"><md-input-container class=\"md-block\"><label translate=\"ENVIAR.TITULO\">\nTítulo</label><input type=\"text\" name=\"title\" ng-model=\"event.header.title\" md-maxlength=\"80\" required><div \nng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ENVIAR.CONTENIDO\">Contenido del aviso</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"event.header.body\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><span translate=\"ENVIAR.IMAGEN\">Imagen</span><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><img ng-src=\"{{event.header.icon|replacePath}}\" alt=\"{{event.header.icon}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"logo\" ng-model=\"event.header.icon\" required><div ng-messages=\"paso1.logo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div></form></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"loading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\" \nclass=\"md-raised md-warn\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"EDITAR_STB.GUARDAR\" class=\"md-raised md-warn\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/event.tmpl.html","<md-dialog id=\"enviarAviso\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.MENSAJE\">Mensaje</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"event.arguments.type\" \nrequired><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"space-around center\" class=\"tipo-aviso\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div></div></md-radio-group>\n<md-input-container class=\"md-block\" ng-if=\"event.arguments.type === \'simple\'\"><label translate=\"ENVIAR.TEXTO\">Texto\n</label><input type=\"text\" name=\"stitle\" ng-model=\"event.header.title\" md-maxlength=\"255\" required><div \nng-messages=\"paso1.stitle.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD1\">El nombre debe tener menos de 255 caracteres.</div></div></md-input-container><div \nng-if=\"event.arguments.type === \'completo\'\"><md-input-container class=\"md-block\"><label translate=\"ENVIAR.TITULO\">\nTítulo</label><input type=\"text\" name=\"title\" ng-model=\"event.header.title\" md-maxlength=\"80\" required><div \nng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ENVIAR.CONTENIDO\">Contenido del aviso</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"event.header.body\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><span translate=\"ENVIAR.IMAGEN\">Imagen</span><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><img ng-src=\"{{event.header.icon|replacePath}}\" alt=\"{{event.header.icon}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"logo\" ng-model=\"event.header.icon\" required><div ng-messages=\"paso1.logo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-button class=\"md-raised md-primary\" \nng-click=\"marcarTodo(true)\" translate=\"LOTES.MARCARTODO\">Marcar todo</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"marcarTodo(false)\" translate=\"LOTES.DESMARCARTODO\">Desmarcar todo</md-button>\n<md-button class=\"md-raised md-primary\" ng-click=\"marcarStorage()\" translate=\"LOTES.MARCARSTORAGE\">Marcar almacenados\n<md-tooltip md-direction=\"right\"><span translate=\"LOTES.MARCARSTORAGETOOLTIP\"></span></md-tooltip></md-button><md-menu>\n<md-button class=\"md-raised md-primary\" ng-click=\"$mdOpenMenu($event)\" translate=\"LOTES.MARCARIDIOMA\">Marcar por idioma\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"lang in listaIdiomas\"><md-button \nng-click=\"marcarPorIdioma(lang.idioma)\"><img ng-src=\"{{lang.rutaIcono | replacePath}}\" \nstyle=\"height: 30px;width: 30px;object-fit: contain;margin-right: 8px;vertical-align: middle\"> {{lang.idioma}}\n</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox ng-model=\"event.toSmartPhones\" \nng-show=\"JSONconfig.avisosSmartphones\">Enviar a smartphones</md-checkbox><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-wrap id=\"groupListContainer\"><div class=\"groupContainer\" ng-repeat=\"grupo in listaGrupos\" layout=\"column\" \non-last-repeat><div class=\"groupHeader\" layout=\"row\" layout-align=\"center-center\"><div flex>{{grupo.nombre}} <span \nng-if=\"grupo.place\">({{grupo.place}})</span></div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(grupo, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div class=\"groupBody\" \nlayout=\"column\"><md-checkbox ng-repeat=\"stb in grupo.cStbs| orderBy:\'room\'\" ng-click=\"toggle(stb.idStb, event.stbs)\" \nng-checked=\"exists(stb.idStb, event.stbs)\" aria-label=\"seleccionado\">{{stb.room}} - {{stb.username}}</md-checkbox>\n</div></div></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label>\n<span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i class=\"icon-check s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">Temporización</span></span>\n</md-tab-label><md-tab-body><form name=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" \nlayout-xs=\"column\" layout-align-gt-xs=\"space-between\"><md-input-container flex=\"50\" flex-xs=\"100\"><label \ntranslate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</label><input name=\"displaytime\" type=\"number\" \nng-model=\"event.header.time\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container><md-radio-group ng-model=\"event.type\" \nlayout=\"row\" layout-xs=\"column\" required><md-radio-button value=\"event\"><span translate=\"ENVIAR.INMEDIATO\">Inmediato\n</span></md-radio-button><md-radio-button value=\"eventProgrammed\"><span translate=\"ENVIAR.PROGRAMADO\">Programado</span>\n</md-radio-button></md-radio-group></div><div class=\"temporizacion\" layout=\"row\" layout-wrap \nng-if=\"event.type === \'eventProgrammed\'\"><md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TINICIO\">\nInicio periodo</label><input type=\"datetime-local\" ng-model=\"event.fIni\" required></md-input-container>\n<md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TFIN\">Fin periodo</label><input \ntype=\"datetime-local\" ng-model=\"event.fFin\" required></md-input-container><md-input-container flex-xs=\"100\" flex=\"33\">\n<label translate=\"ENVIAR.REPET\">Repetir cada</label><input name=\"tiemporepet\" type=\"number\" ng-model=\"event.intervalo\" \nmin=\"1\" required aria-label=\"tiemporepet\"> <button ng-click=\"event.intervalo = event.intervalo + 1440\">+1D</button> \n<button ng-click=\"event.intervalo = event.intervalo + 60\">+1H</button> <span>{{event.intervalo|convertMinutesInHHMMSS}}\n</span></md-input-container><md-input-container flex-xs=\"50\" flex><label translate=\"ENVIAR.RANGOINICIO\">Inicio rango\n</label><input type=\"time\" ng-model=\"event.rangeInit\"></md-input-container><md-input-container flex-xs=\"50\" flex><label\n translate=\"ENVIAR.RANGOFIN\">Fin rango</label><input type=\"time\" ng-model=\"event.rangeEnd\"></md-input-container></div>\n<div ng-if=\"event.type === \'eventProgrammed\'\"><div class=\"md-accent-bg info-temp\"><em>\'Hora mínima\'</em> y <em>\n\'Hora máxima\'</em>\n sirven para restringir el intervalo de horas que se verá el aviso al día. Por ejemplo, si queremos que sólo se les muestre a los pacientes entre las 9:00 y las 20:00.\n<br>Si se deja vacío, se podrán mostrar a cualquier hora.</div><div class=\"md-warn-bg info-temp margin-top-5\">\nEl aviso se enviará a los equipos entre el <b>{{event.fIni|date:\'dd/MM/yyyy HH:mm\'}}</b> y el <b>\n{{event.fFin|date:\'dd/MM/yyyy HH:mm\'}}</b><br><span ng-show=\"event.rangeInit && event.rangeEnd\">\nSolo aparecerá en su pantalla entre las <b>{{event.rangeInit|date:\'HH:mm\'}}</b> y las <b>\n{{event.rangeEnd|date:\'HH:mm\'}}</b></span></div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"ENVIAR.ANTERIOR\">Anterior\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado || event.stbs.length < 1\" translate=\"ENVIAR.ENVIAR\">Enviar evento\n</md-button></div></ms-form-wizard></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/qt-event-publi.tmpl.html","<md-dialog id=\"enviarAviso\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.MENSAJE\">Mensaje</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"event.arguments.type\" \nrequired><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"space-around center\" class=\"tipo-aviso margin-bottom-24\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_custom_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_custom_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"custom\"><span translate=\"ENVIAR.PERSONALIZADO\">Personalizado</span></md-radio-button></div></div>\n</md-radio-group><div ng-if=\"event.arguments.type === \'simple\'\" class=\"container\"><md-input-container class=\"md-block\">\n<label translate=\"ENVIAR.TEXTO\">Texto</label><input type=\"text\" name=\"stitle\" \nng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" required><div ng-messages=\"paso1.stitle.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD1\">\nEl nombre debe tener menos de 255 caracteres.</div></div></md-input-container></div><div \nng-if=\"event.arguments.type === \'completo\'\" class=\"container\"><md-input-container class=\"md-block\"><label \ntranslate=\"ENVIAR.TITULO\">Título</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.title.text\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ENVIAR.CONTENIDO\">Contenido del aviso</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" rows=\"5\" required>\n</textarea><div ng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><span translate=\"ENVIAR.IMAGEN\" class=\"hint\">Imagen</span><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img \nsrc=\"{{event.header.properties.image.logo|replacePath}}\" alt=\"{{event.header.properties.image.logo}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button><md-button \nclass=\"md-icon-button\" aria-label=\"close\" ng-click=\"event.header.properties.image.logo = null\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><input type=\"hidden\" name=\"imagelogo\" \nng-model=\"event.header.properties.image.logo\" required><div ng-messages=\"paso1.imagelogo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div><div ng-if=\"event.arguments.type === \'custom\'\"><div class=\"container\"><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.POSITION\">Posición</label><md-select \nng-model=\"event.header.properties.frame.position\"><md-option value=\"right\">Derecha</md-option><md-option value=\"left\">\nIzquierda</md-option><md-option value=\"top\">Arriba</md-option><md-option value=\"down\">Abajo</md-option><md-option \nvalue=\"down-mini\">Abajo (pequeño)</md-option><md-option value=\"center\">Centrado</md-option><md-option value=\"custom\">\nPersonalizado</md-option></md-select></md-input-container><div class=\"layout-row\" \nng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container class=\"md-block no-errors-spacer\" \nflex=\"25\"><label translate=\"ENVIAR.FRAME.W\">Ancho</label><input type=\"number\" name=\"w\" \nng-model=\"event.header.properties.frame.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.H\">Alto</label><input type=\"number\" \nname=\"h\" ng-model=\"event.header.properties.frame.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.X\">Posición X</label><input type=\"number\" \nname=\"x\" ng-model=\"event.header.properties.frame.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.Y\">Posición Y</label><input type=\"number\" \nname=\"y\" ng-model=\"event.header.properties.frame.y\" min=\"1\" max=\"9999\"></md-input-container></div><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.FRAME.THEME\">Tema</label><md-select ng-model=\"event.header.properties.frame.theme\"><md-option \nvalue=\"black\">Fondo negro, letras blancas</md-option><md-option value=\"blue\">Fondo azul, letras blancas</md-option>\n<md-option value=\"white\">Fondo blanco, letras negras</md-option><md-option value=\"custom\">Personalizado</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\" flex=\"33\"><label translate=\"ENVIAR.FRAME.COLOR1\">Color 1\n</label><input type=\"color\" name=\"color1\" ng-model=\"event.header.properties.frame.color1\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" ng-if=\"event.header.properties.frame.theme === \'custom\'\" \nflex=\"33\"><label translate=\"ENVIAR.FRAME.COLOR2\">Color 2</label><input type=\"color\" name=\"color2\" \nng-model=\"event.header.properties.frame.color2\"></md-input-container></div><div class=\"layout-row\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"50\"><label translate=\"ENVIAR.FRAME.BORDERCOLOR\">Color del borde</label><input \ntype=\"color\" name=\"bordercolor\" ng-model=\"event.header.properties.frame[\'border-color\']\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"50\"><label translate=\"ENVIAR.FRAME.BORDERWIDTH\">\nTamaño del borde (px)</label><input type=\"number\" name=\"borderwidth\" \nng-model=\"event.header.properties.frame[\'border-width\']\" min=\"0\" max=\"999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.OPACITY\">Opacidad (%)</label>\n<input type=\"number\" name=\"opacity\" ng-model=\"event.header.properties.frame.opacity\" min=\"0\" max=\"100\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.SOUND\">Sonido\n</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.frame.sound\"></md-input-container></div><div \nclass=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.TEXT\">Título\n</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.title.text\" md-maxlength=\"80\"><div \nng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.TITLE.FAMILY\">Fuente</label><md-select ng-model=\"event.header.properties.title.family\"><md-option \nvalue=\"{{family}}\" ng-repeat=\"family in fontFamilyList\">{{family}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.TITLE.POINTSIZE\">\nTamaño de letra</label><input type=\"number\" name=\"pointsize\" ng-model=\"event.header.properties.title.pointSize\" \nmin=\"1\" max=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\"><label translate=\"ENVIAR.TITLE.COLOR\">Color</label><input \ntype=\"color\" name=\"titlecolor\" ng-model=\"event.header.properties.title.color\"></md-input-container></div><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.W\">Ancho</label><input type=\"number\" \nname=\"titlew\" ng-model=\"event.header.properties.title.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.H\">Alto</label><input type=\"number\" \nname=\"titleh\" ng-model=\"event.header.properties.title.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.X\">Posición X</label><input type=\"number\" \nname=\"titlex\" ng-model=\"event.header.properties.title.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.Y\">Posición Y</label><input type=\"number\" \nname=\"titley\" ng-model=\"event.header.properties.title.y\" min=\"1\" max=\"9999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.URL\">URL de enlace</label><input \ntype=\"text\" name=\"titleurl\" ng-model=\"event.header.properties.title.url\" md-maxlength=\"300\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.SOMEDATA\">Datos a enviar (URL)\n</label><input type=\"text\" name=\"titleSomeData\" ng-model=\"event.header.properties.title.someData\" md-maxlength=\"300\">\n</md-input-container></div><div class=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.DESC.TEXT\">Contenido del aviso</label><textarea style=\"height: 100px\" name=\"message\" \nng-model=\"event.header.properties.desc.text\" md-maxlength=\"500\" rows=\"5\"></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 500 caracteres.</div></div></md-input-container><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.DESC.FAMILY\">Fuente</label><md-select ng-model=\"event.header.properties.desc.family\"><md-option \nvalue=\"{{family}}\" ng-repeat=\"family in fontFamilyList\">{{family}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.DESC.POINTSIZE\">\nTamaño de letra</label><input type=\"number\" name=\"pointsize\" ng-model=\"event.header.properties.desc.pointSize\" min=\"1\" \nmax=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\"><label translate=\"ENVIAR.DESC.COLOR\">Color</label><input \ntype=\"color\" name=\"desccolor\" ng-model=\"event.header.properties.desc.color\"></md-input-container></div><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.W\">Ancho</label><input type=\"number\" \nname=\"descw\" ng-model=\"event.header.properties.desc.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.H\">Alto</label><input type=\"number\" \nname=\"desch\" ng-model=\"event.header.properties.desc.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.X\">Posición X</label><input type=\"number\" \nname=\"descx\" ng-model=\"event.header.properties.desc.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.Y\">Posición Y</label><input type=\"number\" \nname=\"descy\" ng-model=\"event.header.properties.desc.y\" min=\"1\" max=\"9999\"></md-input-container></div></div><div \nclass=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><span translate=\"ENVIAR.IMAGEN\" class=\"hint\">\nImagen</span><div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img \nsrc=\"{{event.header.properties.image.logo|replacePath}}\" alt=\"{{event.header.properties.image.logo}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"imagelogo\" ng-model=\"event.header.properties.image.logo\"><div ng-messages=\"paso1.imagelogo.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nflex=\"50\"><label translate=\"ENVIAR.IMAGE.BORDERCOLOR\">Color del borde</label><input type=\"color\" \nname=\"imagebordercolor\" ng-model=\"event.header.properties.image[\'border-color\']\"></md-input-container><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.W\">Ancho</label><input type=\"number\" \nname=\"imagew\" ng-model=\"event.header.properties.image.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.H\">Alto</label><input type=\"number\" \nname=\"imageh\" ng-model=\"event.header.properties.image.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.X\">Posición X</label><input type=\"number\" \nname=\"imagex\" ng-model=\"event.header.properties.image.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.Y\">Posición Y</label><input type=\"number\" \nname=\"imagey\" ng-model=\"event.header.properties.image.y\" min=\"1\" max=\"9999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.IMAGE.URL\">URL de enlace</label><input \ntype=\"text\" name=\"imageurl\" ng-model=\"event.header.properties.image.url\" md-maxlength=\"300\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.IMAGE.SOMEDATA\">Datos a enviar (URL)\n</label><input type=\"text\" name=\"imageSomeData\" ng-model=\"event.header.properties.image.someData\" md-maxlength=\"300\">\n</md-input-container></div><div class=\"container\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo botón\" \nng-click=\"addButton()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"right\">Añadir botón\n</md-tooltip></md-button><div class=\"button-container\" ng-repeat=\"button in event.header.properties.buttons\"><md-button\n class=\"md-icon-button\" aria-label=\"Quitar botón\" ng-click=\"deleteButton($index)\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip md-direction=\"right\">Quitar botón</md-tooltip></md-button><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.BUTTONS.TEXT\">Texto</label><input type=\"text\" \nname=\"buttontext\" ng-model=\"button.text\" md-maxlength=\"80\"><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div \nng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div>\n</md-input-container><div class=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.BUTTONS.BORDERWIDTH\">Tamaño del borde (px)</label><input type=\"number\" name=\"buttonborderwidth\" \nng-model=\"border[\'border-width\']\" min=\"0\" max=\"999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.BUTTONS.BACKGROUNDCOLOR\">Color de fondo</label>\n<input type=\"color\" name=\"buttonbackgroundcolor\" ng-model=\"button[\'background-color\']\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.BUTTONS.TEXTCOLOR\">\nColor de letra</label><input type=\"color\" name=\"buttontextcolor\" ng-model=\"button[\'text-color\']\"></md-input-container>\n</div><div class=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.W\">Ancho</label><input type=\"number\" name=\"buttonw\" ng-model=\"button.w\" min=\"1\" max=\"9999\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.H\">Alto</label><input type=\"number\" name=\"buttonh\" ng-model=\"button.h\" min=\"1\" max=\"9999\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.X\">Posición X</label><input type=\"number\" name=\"buttonx\" ng-model=\"button.x\" min=\"1\" \nmax=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.Y\">Posición Y</label><input type=\"number\" name=\"buttony\" ng-model=\"button.y\" min=\"1\" \nmax=\"9999\"></md-input-container></div><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.BUTTONS.URL\">URL de enlace</label><input type=\"text\" name=\"titleurl\" ng-model=\"button.url\" \nmd-maxlength=\"300\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.BUTTONS.SOMEDATA\">Datos a enviar (URL)</label><input type=\"text\" name=\"titleSomeData\" \nng-model=\"button.someData\" md-maxlength=\"300\"></md-input-container></div></div></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"ENVIAR.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-checkbox ng-model=\"event.toSmartPhones\" \nng-show=\"JSONconfig.avisosSmartphones\">Enviar a smartphones</md-checkbox><div class=\"envioInfo\" \ntranslate=\"LISTADOAVISOS.PUBLIINFO\">Se enviará el aviso a los usuarios que NO tengan alguno de los servicios marcados.\n</div><div layout=\"row\" layout-xs=\"column\" layout-wrap layout-align=\"start start\" layout-align-xs=\"center stretch\"><div\n ng-repeat=\"pkg in listaPaquetes\" class=\"groupContainer\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"groupHeader\"><div flex>{{pkg.name|formatNameDesc}}</div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(pkg, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(pkg, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div layout=\"column\" \nclass=\"groupBody\"><md-checkbox ng-repeat=\"srv in pkg.ordinaryServices\" \nng-checked=\"exists(srv.idService, event.services)\" ng-click=\"toggle(srv.idService, event.services)\" \naria-label=\"servicio\"><div><img ng-src=\"{{::srv.logo|replacePath}}\" class=\"md-avatar\">{{srv.name|formatNameDesc}}</div>\n</md-checkbox></div></div></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"paso3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i \nclass=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">\nTemporización</span></span></md-tab-label><md-tab-body><form name=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"row\" layout-xs=\"column\" layout-align-gt-xs=\"space-between\"><md-input-container flex=\"50\" \nflex-xs=\"100\"><label translate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</label><input name=\"displaytime\" \ntype=\"number\" ng-model=\"event.header.properties.frame.time\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div\n ng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container><md-radio-group ng-model=\"event.type\" \nlayout=\"row\" layout-xs=\"column\" required><md-radio-button value=\"event\"><span translate=\"ENVIAR.INMEDIATO\">Inmediato\n</span></md-radio-button><md-radio-button value=\"eventProgrammed\"><span translate=\"ENVIAR.PROGRAMADO\">Programado</span>\n</md-radio-button></md-radio-group></div><div class=\"temporizacion\" layout=\"row\" layout-wrap \nng-if=\"event.type === \'eventProgrammed\'\"><md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TINICIO\">\nInicio periodo</label><input type=\"datetime-local\" ng-model=\"event.fIni\" required></md-input-container>\n<md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TFIN\">Fin periodo</label><input \ntype=\"datetime-local\" ng-model=\"event.fFin\" required></md-input-container><md-input-container flex-xs=\"100\" flex=\"33\">\n<label translate=\"ENVIAR.REPET\">Repetir cada</label><input name=\"tiemporepet\" type=\"number\" ng-model=\"event.intervalo\" \nmin=\"1\" required aria-label=\"tiemporepet\"> <button ng-click=\"event.intervalo = event.intervalo + 1440\">+1D</button> \n<button ng-click=\"event.intervalo = event.intervalo + 60\">+1H</button> <span>{{event.intervalo|convertMinutesInHHMMSS}}\n</span></md-input-container><md-input-container flex-xs=\"50\" flex><label translate=\"ENVIAR.RANGOINICIO\">Inicio rango\n</label><input type=\"time\" ng-model=\"event.rangeInit\"></md-input-container><md-input-container flex-xs=\"50\" flex><label\n translate=\"ENVIAR.RANGOFIN\">Fin rango</label><input type=\"time\" ng-model=\"event.rangeEnd\"></md-input-container></div>\n<div ng-if=\"event.type === \'eventProgrammed\'\"><div class=\"md-accent-bg info-temp\"><em>\'Hora mínima\'</em> y <em>\n\'Hora máxima\'</em>\n sirven para restringir el intervalo de horas que se verá el aviso al día. Por ejemplo, si queremos que sólo se les muestre a los pacientes entre las 9:00 y las 20:00.\n<br>Si se deja vacío, se podrán mostrar a cualquier hora.</div><div class=\"md-warn-bg info-temp margin-top-5\">\nEl aviso se enviará a los equipos entre el <b>{{event.fIni|date:\'dd/MM/yyyy HH:mm\'}}</b> y el <b>\n{{event.fFin|date:\'dd/MM/yyyy HH:mm\'}}</b><br><span ng-show=\"event.rangeInit && event.rangeEnd\">\nSolo aparecerá en su pantalla entre las <b>{{event.rangeInit|date:\'HH:mm\'}}</b> y las <b>\n{{event.rangeEnd|date:\'HH:mm\'}}</b></span></div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"ENVIAR.ANTERIOR\">Anterior\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado || event.services.length < 1\" translate=\"ENVIAR.ENVIAR\">\nEnviar evento</md-button><img src=\"/assets/quantionImagenes/cargando.gif\" alt=\"\" ng-show=\"yaEnviado\"></div>\n</ms-form-wizard></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/qt-event-template.tmpl.html","<md-dialog id=\"enviarAviso\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><form name=\"paso1\" class=\"md-inline-form\" novalidate>\n<md-radio-group ng-model=\"event.arguments.type\" required><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-around center\" class=\"tipo-aviso margin-bottom-24\"><div \nlayout=\"column\"><img src=\"/assets/quantionImagenes/avisos/hospital/aviso_simple_qt.png\" \nng-if=\"JSONconfig.sistemaDePago\"> <img src=\"/assets/quantionImagenes/avisos/hotel/aviso_simple_qt.png\" \nng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button value=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple\n</span></md-radio-button></div><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_completo_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_custom_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_custom_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"custom\"><span translate=\"ENVIAR.PERSONALIZADO\">Personalizado</span></md-radio-button></div></div>\n</md-radio-group><div ng-if=\"event.arguments.type === \'simple\'\" class=\"container\"><md-input-container class=\"md-block\">\n<label translate=\"ENVIAR.TEXTO\">Texto</label><input type=\"text\" name=\"stitle\" \nng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" required><div ng-messages=\"paso1.stitle.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD1\">\nEl nombre debe tener menos de 255 caracteres.</div></div></md-input-container></div><div \nng-if=\"event.arguments.type === \'completo\'\" class=\"container\"><md-input-container class=\"md-block\"><label \ntranslate=\"ENVIAR.TITULO\">Título</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.title.text\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ENVIAR.CONTENIDO\">Contenido del aviso</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" rows=\"5\" required>\n</textarea><div ng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><span translate=\"ENVIAR.IMAGEN\" class=\"hint\">Imagen</span><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img \nsrc=\"{{event.header.properties.image.logo|replacePath}}\" alt=\"{{event.header.properties.image.logo}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button><md-button \nclass=\"md-icon-button\" aria-label=\"close\" ng-click=\"event.header.properties.image.logo = null\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><input type=\"hidden\" name=\"imagelogo\" \nng-model=\"event.header.properties.image.logo\" required><div ng-messages=\"paso1.imagelogo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div><div ng-if=\"event.arguments.type === \'custom\'\"><div class=\"container\"><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.POSITION\">Posición</label><md-select \nng-model=\"event.header.properties.frame.position\"><md-option value=\"right\">Derecha</md-option><md-option value=\"left\">\nIzquierda</md-option><md-option value=\"top\">Arriba</md-option><md-option value=\"down\">Abajo</md-option><md-option \nvalue=\"down-mini\">Abajo (pequeño)</md-option><md-option value=\"center\">Centrado</md-option><md-option value=\"custom\">\nPersonalizado</md-option></md-select></md-input-container><div class=\"layout-row\" \nng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container class=\"md-block no-errors-spacer\" \nflex=\"25\"><label translate=\"ENVIAR.FRAME.W\">Ancho</label><input type=\"number\" name=\"w\" \nng-model=\"event.header.properties.frame.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.H\">Alto</label><input type=\"number\" \nname=\"h\" ng-model=\"event.header.properties.frame.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.X\">Posición X</label><input type=\"number\" \nname=\"x\" ng-model=\"event.header.properties.frame.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.Y\">Posición Y</label><input type=\"number\" \nname=\"y\" ng-model=\"event.header.properties.frame.y\" min=\"1\" max=\"9999\"></md-input-container></div><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.FRAME.THEME\">Tema</label><md-select ng-model=\"event.header.properties.frame.theme\"><md-option \nvalue=\"black\">Fondo negro, letras blancas</md-option><md-option value=\"blue\">Fondo azul, letras blancas</md-option>\n<md-option value=\"white\">Fondo blanco, letras negras</md-option><md-option value=\"custom\">Personalizado</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\" flex=\"33\"><label translate=\"ENVIAR.FRAME.COLOR1\">Color 1\n</label><input type=\"color\" name=\"color1\" ng-model=\"event.header.properties.frame.color1\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" ng-if=\"event.header.properties.frame.theme === \'custom\'\" \nflex=\"33\"><label translate=\"ENVIAR.FRAME.COLOR2\">Color 2</label><input type=\"color\" name=\"color2\" \nng-model=\"event.header.properties.frame.color2\"></md-input-container></div><div class=\"layout-row\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"50\"><label translate=\"ENVIAR.FRAME.BORDERCOLOR\">Color del borde</label><input \ntype=\"color\" name=\"bordercolor\" ng-model=\"event.header.properties.frame[\'border-color\']\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"50\"><label translate=\"ENVIAR.FRAME.BORDERWIDTH\">\nTamaño del borde (px)</label><input type=\"number\" name=\"borderwidth\" \nng-model=\"event.header.properties.frame[\'border-width\']\" min=\"0\" max=\"999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.OPACITY\">Opacidad (%)</label>\n<input type=\"number\" name=\"opacity\" ng-model=\"event.header.properties.frame.opacity\" min=\"0\" max=\"100\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.SOUND\">Sonido\n</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.frame.sound\"></md-input-container></div><div \nclass=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.TEXT\">Título\n</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.title.text\" md-maxlength=\"80\"><div \nng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.TITLE.FAMILY\">Fuente</label><md-select ng-model=\"event.header.properties.title.family\"><md-option \nvalue=\"{{family}}\" ng-repeat=\"family in fontFamilyList\">{{family}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.TITLE.POINTSIZE\">\nTamaño de letra</label><input type=\"number\" name=\"pointsize\" ng-model=\"event.header.properties.title.pointSize\" \nmin=\"1\" max=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\"><label translate=\"ENVIAR.TITLE.COLOR\">Color</label><input \ntype=\"color\" name=\"titlecolor\" ng-model=\"event.header.properties.title.color\"></md-input-container></div><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.W\">Ancho</label><input type=\"number\" \nname=\"titlew\" ng-model=\"event.header.properties.title.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.H\">Alto</label><input type=\"number\" \nname=\"titleh\" ng-model=\"event.header.properties.title.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.X\">Posición X</label><input type=\"number\" \nname=\"titlex\" ng-model=\"event.header.properties.title.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.Y\">Posición Y</label><input type=\"number\" \nname=\"titley\" ng-model=\"event.header.properties.title.y\" min=\"1\" max=\"9999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.URL\">URL de enlace</label><input \ntype=\"text\" name=\"titleurl\" ng-model=\"event.header.properties.title.url\" md-maxlength=\"300\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.SOMEDATA\">Datos a enviar (URL)\n</label><input type=\"text\" name=\"titleSomeData\" ng-model=\"event.header.properties.title.someData\" md-maxlength=\"300\">\n</md-input-container></div><div class=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.DESC.TEXT\">Contenido del aviso</label><textarea style=\"height: 100px\" name=\"message\" \nng-model=\"event.header.properties.desc.text\" md-maxlength=\"500\" rows=\"5\"></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 500 caracteres.</div></div></md-input-container><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.DESC.FAMILY\">Fuente</label><md-select ng-model=\"event.header.properties.desc.family\"><md-option \nvalue=\"{{family}}\" ng-repeat=\"family in fontFamilyList\">{{family}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.DESC.POINTSIZE\">\nTamaño de letra</label><input type=\"number\" name=\"pointsize\" ng-model=\"event.header.properties.desc.pointSize\" min=\"1\" \nmax=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\"><label translate=\"ENVIAR.DESC.COLOR\">Color</label><input \ntype=\"color\" name=\"desccolor\" ng-model=\"event.header.properties.desc.color\"></md-input-container></div><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.W\">Ancho</label><input type=\"number\" \nname=\"descw\" ng-model=\"event.header.properties.desc.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.H\">Alto</label><input type=\"number\" \nname=\"desch\" ng-model=\"event.header.properties.desc.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.X\">Posición X</label><input type=\"number\" \nname=\"descx\" ng-model=\"event.header.properties.desc.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.Y\">Posición Y</label><input type=\"number\" \nname=\"descy\" ng-model=\"event.header.properties.desc.y\" min=\"1\" max=\"9999\"></md-input-container></div></div><div \nclass=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><span translate=\"ENVIAR.IMAGEN\" class=\"hint\">\nImagen</span><div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img \nsrc=\"{{event.header.properties.image.logo|replacePath}}\" alt=\"{{event.header.properties.image.logo}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button></div><input type=\"hidden\" \nname=\"imagelogo\" ng-model=\"event.header.properties.image.logo\"><div ng-messages=\"paso1.imagelogo.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nflex=\"50\"><label translate=\"ENVIAR.IMAGE.BORDERCOLOR\">Color del borde</label><input type=\"color\" \nname=\"imagebordercolor\" ng-model=\"event.header.properties.image[\'border-color\']\"></md-input-container><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.W\">Ancho</label><input type=\"number\" \nname=\"imagew\" ng-model=\"event.header.properties.image.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.H\">Alto</label><input type=\"number\" \nname=\"imageh\" ng-model=\"event.header.properties.image.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.X\">Posición X</label><input type=\"number\" \nname=\"imagex\" ng-model=\"event.header.properties.image.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.Y\">Posición Y</label><input type=\"number\" \nname=\"imagey\" ng-model=\"event.header.properties.image.y\" min=\"1\" max=\"9999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.IMAGE.URL\">URL de enlace</label><input \ntype=\"text\" name=\"imageurl\" ng-model=\"event.header.properties.image.url\" md-maxlength=\"300\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.IMAGE.SOMEDATA\">Datos a enviar (URL)\n</label><input type=\"text\" name=\"imageSomeData\" ng-model=\"event.header.properties.image.someData\" md-maxlength=\"300\">\n</md-input-container></div><div class=\"container\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo botón\" \nng-click=\"addButton()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"right\">Añadir botón\n</md-tooltip></md-button><div class=\"button-container\" ng-repeat=\"button in event.header.properties.buttons\"><md-button\n class=\"md-icon-button\" aria-label=\"Quitar botón\" ng-click=\"deleteButton($index)\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip md-direction=\"right\">Quitar botón</md-tooltip></md-button><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.BUTTONS.TEXT\">Texto</label><input type=\"text\" \nname=\"buttontext\" ng-model=\"button.text\" md-maxlength=\"80\"><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div \nng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div>\n</md-input-container><div class=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.BUTTONS.BORDERWIDTH\">Tamaño del borde (px)</label><input type=\"number\" name=\"buttonborderwidth\" \nng-model=\"border[\'border-width\']\" min=\"0\" max=\"999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.BUTTONS.BACKGROUNDCOLOR\">Color de fondo</label>\n<input type=\"color\" name=\"buttonbackgroundcolor\" ng-model=\"button[\'background-color\']\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.BUTTONS.TEXTCOLOR\">\nColor de letra</label><input type=\"color\" name=\"buttontextcolor\" ng-model=\"button[\'text-color\']\"></md-input-container>\n</div><div class=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.W\">Ancho</label><input type=\"number\" name=\"buttonw\" ng-model=\"button.w\" min=\"1\" max=\"9999\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.H\">Alto</label><input type=\"number\" name=\"buttonh\" ng-model=\"button.h\" min=\"1\" max=\"9999\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.X\">Posición X</label><input type=\"number\" name=\"buttonx\" ng-model=\"button.x\" min=\"1\" \nmax=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.Y\">Posición Y</label><input type=\"number\" name=\"buttony\" ng-model=\"button.y\" min=\"1\" \nmax=\"9999\"></md-input-container></div><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.BUTTONS.URL\">URL de enlace</label><input type=\"text\" name=\"titleurl\" ng-model=\"button.url\" \nmd-maxlength=\"300\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.BUTTONS.SOMEDATA\">Datos a enviar (URL)</label><input type=\"text\" name=\"titleSomeData\" \nng-model=\"button.someData\" md-maxlength=\"300\"></md-input-container></div></div></div></form></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"loading\" src=\"/assets/quantionImagenes/cargando.gif\">\n<md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\" class=\"md-raised md-warn\">Cerrar</md-button><md-button \nng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"EDITAR_STB.GUARDAR\" class=\"md-raised md-warn\" \nng-disabled=\"loading\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/avisos/listado/templates/qt-event.tmpl.html","<md-dialog id=\"enviarAviso\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.MENSAJE\">Mensaje</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-radio-group ng-model=\"event.arguments.type\" \nrequired><h4 translate=\"ENVIAR.TIPOAVISO\">Tipo de aviso</h4><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"space-around center\" class=\"tipo-aviso margin-bottom-24\"><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_simple_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_simple_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"simple\" layout=\"row\"><span translate=\"ENVIAR.SIMPLE\">Simple</span></md-radio-button></div><div layout=\"column\">\n<img src=\"/assets/quantionImagenes/avisos/hospital/aviso_completo_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_completo_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"completo\"><span translate=\"ENVIAR.COMPLETO\">Completo</span></md-radio-button></div><div layout=\"column\"><img \nsrc=\"/assets/quantionImagenes/avisos/hospital/aviso_custom_qt.png\" ng-if=\"JSONconfig.sistemaDePago\"> <img \nsrc=\"/assets/quantionImagenes/avisos/hotel/aviso_custom_qt.png\" ng-if=\"!JSONconfig.sistemaDePago\"><md-radio-button \nvalue=\"custom\"><span translate=\"ENVIAR.PERSONALIZADO\">Personalizado</span></md-radio-button></div></div>\n</md-radio-group><div ng-if=\"event.arguments.type === \'simple\'\" class=\"container\"><md-input-container class=\"md-block\">\n<label translate=\"ENVIAR.TEXTO\">Texto</label><input type=\"text\" name=\"stitle\" \nng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" required><div ng-messages=\"paso1.stitle.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD1\">\nEl nombre debe tener menos de 255 caracteres.</div></div></md-input-container></div><div \nng-if=\"event.arguments.type === \'completo\'\" class=\"container\"><md-input-container class=\"md-block\"><label \ntranslate=\"ENVIAR.TITULO\">Título</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.title.text\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ENVIAR.CONTENIDO\">Contenido del aviso</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"event.header.properties.desc.text\" md-maxlength=\"255\" rows=\"5\" required>\n</textarea><div ng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><span translate=\"ENVIAR.IMAGEN\" class=\"hint\">Imagen</span><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img \nsrc=\"{{event.header.properties.image.logo|replacePath}}\" alt=\"{{event.header.properties.image.logo}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button><md-button \nclass=\"md-icon-button\" aria-label=\"close\" ng-click=\"event.header.properties.image.logo = null\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><input type=\"hidden\" name=\"imagelogo\" \nng-model=\"event.header.properties.image.logo\" required><div ng-messages=\"paso1.imagelogo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container></div><div ng-if=\"event.arguments.type === \'custom\'\"><div class=\"container\"><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.POSITION\">Posición</label><md-select \nng-model=\"event.header.properties.frame.position\"><md-option value=\"right\">Derecha</md-option><md-option value=\"left\">\nIzquierda</md-option><md-option value=\"top\">Arriba</md-option><md-option value=\"down\">Abajo</md-option><md-option \nvalue=\"down-mini\">Abajo (pequeño)</md-option><md-option value=\"center\">Centrado</md-option><md-option value=\"custom\">\nPersonalizado</md-option></md-select></md-input-container><div class=\"layout-row\" \nng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container class=\"md-block no-errors-spacer\" \nflex=\"25\"><label translate=\"ENVIAR.FRAME.W\">Ancho</label><input type=\"number\" name=\"w\" \nng-model=\"event.header.properties.frame.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.H\">Alto</label><input type=\"number\" \nname=\"h\" ng-model=\"event.header.properties.frame.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.X\">Posición X</label><input type=\"number\" \nname=\"x\" ng-model=\"event.header.properties.frame.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.FRAME.Y\">Posición Y</label><input type=\"number\" \nname=\"y\" ng-model=\"event.header.properties.frame.y\" min=\"1\" max=\"9999\"></md-input-container></div><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.FRAME.THEME\">Tema</label><md-select ng-model=\"event.header.properties.frame.theme\"><md-option \nvalue=\"black\">Fondo negro, letras blancas</md-option><md-option value=\"blue\">Fondo azul, letras blancas</md-option>\n<md-option value=\"white\">Fondo blanco, letras negras</md-option><md-option value=\"custom\">Personalizado</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\" flex=\"33\"><label translate=\"ENVIAR.FRAME.COLOR1\">Color 1\n</label><input type=\"color\" name=\"color1\" ng-model=\"event.header.properties.frame.color1\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" ng-if=\"event.header.properties.frame.theme === \'custom\'\" \nflex=\"33\"><label translate=\"ENVIAR.FRAME.COLOR2\">Color 2</label><input type=\"color\" name=\"color2\" \nng-model=\"event.header.properties.frame.color2\"></md-input-container></div><div class=\"layout-row\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"50\"><label translate=\"ENVIAR.FRAME.BORDERCOLOR\">Color del borde</label><input \ntype=\"color\" name=\"bordercolor\" ng-model=\"event.header.properties.frame[\'border-color\']\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"50\"><label translate=\"ENVIAR.FRAME.BORDERWIDTH\">\nTamaño del borde (px)</label><input type=\"number\" name=\"borderwidth\" \nng-model=\"event.header.properties.frame[\'border-width\']\" min=\"0\" max=\"999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.OPACITY\">Opacidad (%)</label>\n<input type=\"number\" name=\"opacity\" ng-model=\"event.header.properties.frame.opacity\" min=\"0\" max=\"100\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.FRAME.SOUND\">Sonido\n</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.frame.sound\"></md-input-container></div><div \nclass=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.TEXT\">Título\n</label><input type=\"text\" name=\"title\" ng-model=\"event.header.properties.title.text\" md-maxlength=\"80\"><div \nng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.TITLE.FAMILY\">Fuente</label><md-select ng-model=\"event.header.properties.title.family\"><md-option \nvalue=\"{{family}}\" ng-repeat=\"family in fontFamilyList\">{{family}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.TITLE.POINTSIZE\">\nTamaño de letra</label><input type=\"number\" name=\"pointsize\" ng-model=\"event.header.properties.title.pointSize\" \nmin=\"1\" max=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\"><label translate=\"ENVIAR.TITLE.COLOR\">Color</label><input \ntype=\"color\" name=\"titlecolor\" ng-model=\"event.header.properties.title.color\"></md-input-container></div><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.W\">Ancho</label><input type=\"number\" \nname=\"titlew\" ng-model=\"event.header.properties.title.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.H\">Alto</label><input type=\"number\" \nname=\"titleh\" ng-model=\"event.header.properties.title.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.X\">Posición X</label><input type=\"number\" \nname=\"titlex\" ng-model=\"event.header.properties.title.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.TITLE.Y\">Posición Y</label><input type=\"number\" \nname=\"titley\" ng-model=\"event.header.properties.title.y\" min=\"1\" max=\"9999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.URL\">URL de enlace</label><input \ntype=\"text\" name=\"titleurl\" ng-model=\"event.header.properties.title.url\" md-maxlength=\"300\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.TITLE.SOMEDATA\">Datos a enviar (URL)\n</label><input type=\"text\" name=\"titleSomeData\" ng-model=\"event.header.properties.title.someData\" md-maxlength=\"300\">\n</md-input-container></div><div class=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.DESC.TEXT\">Contenido del aviso</label><textarea style=\"height: 100px\" name=\"message\" \nng-model=\"event.header.properties.desc.text\" md-maxlength=\"500\" rows=\"5\"></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 500 caracteres.</div></div></md-input-container><div \nclass=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.DESC.FAMILY\">Fuente</label><md-select ng-model=\"event.header.properties.desc.family\"><md-option \nvalue=\"{{family}}\" ng-repeat=\"family in fontFamilyList\">{{family}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.DESC.POINTSIZE\">\nTamaño de letra</label><input type=\"number\" name=\"pointsize\" ng-model=\"event.header.properties.desc.pointSize\" min=\"1\" \nmax=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"event.header.properties.frame.theme === \'custom\'\"><label translate=\"ENVIAR.DESC.COLOR\">Color</label><input \ntype=\"color\" name=\"desccolor\" ng-model=\"event.header.properties.desc.color\"></md-input-container></div><div \nclass=\"layout-row\" ng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.W\">Ancho</label><input type=\"number\" \nname=\"descw\" ng-model=\"event.header.properties.desc.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.H\">Alto</label><input type=\"number\" \nname=\"desch\" ng-model=\"event.header.properties.desc.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.X\">Posición X</label><input type=\"number\" \nname=\"descx\" ng-model=\"event.header.properties.desc.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.DESC.Y\">Posición Y</label><input type=\"number\" \nname=\"descy\" ng-model=\"event.header.properties.desc.y\" min=\"1\" max=\"9999\"></md-input-container></div></div><div \nclass=\"container\"><md-input-container class=\"md-block no-errors-spacer\"><span translate=\"ENVIAR.IMAGEN\" class=\"hint\">\nImagen</span><div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img \nsrc=\"{{event.header.properties.image.logo|replacePath}}\" alt=\"{{event.header.properties.image.logo}}\" \nng-click=\"elegirImagen($event)\" style=\"cursor: pointer\"><md-button class=\"md-raised md-primary\" \nng-click=\"elegirImagen($event)\" translate=\"ENVIAR.ELEGIRIMAGEN\">Elegir imagen</md-button><md-button \nclass=\"md-icon-button\" aria-label=\"close\" ng-click=\"event.header.properties.image.logo = null\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><input type=\"hidden\" name=\"imagelogo\" \nng-model=\"event.header.properties.image.logo\"><div ng-messages=\"paso1.imagelogo.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"50\"><label \ntranslate=\"ENVIAR.IMAGE.BORDERCOLOR\">Color del borde</label><input type=\"color\" name=\"imagebordercolor\" \nng-model=\"event.header.properties.image[\'border-color\']\"></md-input-container><div class=\"layout-row\" \nng-if=\"event.header.properties.frame.position === \'custom\'\"><md-input-container class=\"md-block no-errors-spacer\" \nflex=\"25\"><label translate=\"ENVIAR.IMAGE.W\">Ancho</label><input type=\"number\" name=\"imagew\" \nng-model=\"event.header.properties.image.w\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.H\">Alto</label><input type=\"number\" \nname=\"imageh\" ng-model=\"event.header.properties.image.h\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.X\">Posición X</label><input type=\"number\" \nname=\"imagex\" ng-model=\"event.header.properties.image.x\" min=\"1\" max=\"9999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"25\"><label translate=\"ENVIAR.IMAGE.Y\">Posición Y</label><input type=\"number\" \nname=\"imagey\" ng-model=\"event.header.properties.image.y\" min=\"1\" max=\"9999\"></md-input-container></div>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.IMAGE.URL\">URL de enlace</label><input \ntype=\"text\" name=\"imageurl\" ng-model=\"event.header.properties.image.url\" md-maxlength=\"300\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.IMAGE.SOMEDATA\">Datos a enviar (URL)\n</label><input type=\"text\" name=\"imageSomeData\" ng-model=\"event.header.properties.image.someData\" md-maxlength=\"300\">\n</md-input-container></div><div class=\"container\"><md-button class=\"md-fab md-mini\" aria-label=\"Nuevo botón\" \nng-click=\"addButton()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"right\">Añadir botón\n</md-tooltip></md-button><div class=\"button-container\" ng-repeat=\"button in event.header.properties.buttons\"><md-button\n class=\"md-icon-button\" aria-label=\"Quitar botón\" ng-click=\"deleteButton($index)\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip md-direction=\"right\">Quitar botón</md-tooltip></md-button><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"ENVIAR.BUTTONS.TEXT\">Texto</label><input type=\"text\" \nname=\"buttontext\" ng-model=\"button.text\" md-maxlength=\"80\"><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div \nng-message=\"md-maxlength\" translate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div>\n</md-input-container><div class=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label \ntranslate=\"ENVIAR.BUTTONS.BORDERWIDTH\">Tamaño del borde (px)</label><input type=\"number\" name=\"buttonborderwidth\" \nng-model=\"border[\'border-width\']\" min=\"0\" max=\"999\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.BUTTONS.BACKGROUNDCOLOR\">Color de fondo</label>\n<input type=\"color\" name=\"buttonbackgroundcolor\" ng-model=\"button[\'background-color\']\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label translate=\"ENVIAR.BUTTONS.TEXTCOLOR\">\nColor de letra</label><input type=\"color\" name=\"buttontextcolor\" ng-model=\"button[\'text-color\']\"></md-input-container>\n</div><div class=\"layout-row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.W\">Ancho</label><input type=\"number\" name=\"buttonw\" ng-model=\"button.w\" min=\"1\" max=\"9999\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.H\">Alto</label><input type=\"number\" name=\"buttonh\" ng-model=\"button.h\" min=\"1\" max=\"9999\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.X\">Posición X</label><input type=\"number\" name=\"buttonx\" ng-model=\"button.x\" min=\"1\" \nmax=\"9999\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"25\"><label \ntranslate=\"ENVIAR.BUTTONS.Y\">Posición Y</label><input type=\"number\" name=\"buttony\" ng-model=\"button.y\" min=\"1\" \nmax=\"9999\"></md-input-container></div><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.BUTTONS.URL\">URL de enlace</label><input type=\"text\" name=\"titleurl\" ng-model=\"button.url\" \nmd-maxlength=\"300\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"ENVIAR.BUTTONS.SOMEDATA\">Datos a enviar (URL)</label><input type=\"text\" name=\"titleSomeData\" \nng-model=\"button.someData\" md-maxlength=\"300\"></md-input-container></div></div></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"ENVIAR.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-button class=\"md-raised md-primary\" \nng-click=\"marcarTodo(true)\" translate=\"LOTES.MARCARTODO\">Marcar todo</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"marcarTodo(false)\" translate=\"LOTES.DESMARCARTODO\">Desmarcar todo</md-button>\n<md-button class=\"md-raised md-primary\" ng-click=\"marcarStorage()\" translate=\"LOTES.MARCARSTORAGE\">Marcar almacenados\n<md-tooltip md-direction=\"right\"><span translate=\"LOTES.MARCARSTORAGETOOLTIP\"></span></md-tooltip></md-button><md-menu>\n<md-button class=\"md-raised md-primary\" ng-click=\"$mdOpenMenu($event)\" translate=\"LOTES.MARCARIDIOMA\">Marcar por idioma\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"lang in listaIdiomas\"><md-button \nng-click=\"marcarPorIdioma(lang.idioma)\"><img ng-src=\"{{lang.rutaIcono | replacePath}}\" \nstyle=\"height: 30px;width: 30px;object-fit: contain;margin-right: 8px;vertical-align: middle\"> {{lang.idioma}}\n</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox ng-model=\"event.toSmartPhones\" \nng-show=\"JSONconfig.avisosSmartphones\">Enviar a smartphones</md-checkbox><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-wrap id=\"groupListContainer\"><div class=\"groupContainer\" ng-repeat=\"grupo in listaGrupos\" layout=\"column\" \non-last-repeat><div class=\"groupHeader\" layout=\"row\" layout-align=\"center-center\"><div flex>{{grupo.nombre}} <span \nng-if=\"grupo.place\">({{grupo.place}})</span></div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(grupo, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div class=\"groupBody\" \nlayout=\"column\"><div layout=\"row\" ng-repeat=\"stb in grupo.cStbs| orderBy:\'room\'\"><md-checkbox \nng-click=\"toggle(stb.idStb, event.stbs)\" ng-checked=\"exists(stb.idStb, event.stbs)\" aria-label=\"seleccionado\">\n{{stb.room}} - {{stb.username}}</md-checkbox><img \nng-src=\"{{JSONconfig.logosPath.to}}/{{FilePaths.idiomas}}/{{stb.lang||\'es\'}}.png\" class=\"md-avatar\"></div></div></div>\n</div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$invalid\">3</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">Temporización</span></span></md-tab-label>\n<md-tab-body><form name=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" \nlayout-xs=\"column\" layout-align-gt-xs=\"space-between\"><md-input-container flex=\"50\" flex-xs=\"100\"><label \ntranslate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</label><input name=\"displaytime\" type=\"number\" \nng-model=\"event.header.properties.frame.time\" min=\"0\" max=\"100000\" required aria-label=\"displaytime\"> <span \nclass=\"hint\" translate=\"ENVIAR.HINTTIME\">Si el tiempo es cero, permanecerá fijo hasta pulsar en \"Visto\"</span><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div></md-input-container><md-radio-group ng-model=\"event.type\" \nlayout=\"row\" layout-xs=\"column\" required><md-radio-button value=\"event\"><span translate=\"ENVIAR.INMEDIATO\">Inmediato\n</span></md-radio-button><md-radio-button value=\"eventProgrammed\"><span translate=\"ENVIAR.PROGRAMADO\">Programado</span>\n</md-radio-button></md-radio-group></div><div class=\"temporizacion\" layout=\"row\" layout-wrap \nng-if=\"event.type === \'eventProgrammed\'\"><md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TINICIO\">\nInicio periodo</label><input type=\"datetime-local\" ng-model=\"event.fIni\" required></md-input-container>\n<md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TFIN\">Fin periodo</label><input \ntype=\"datetime-local\" ng-model=\"event.fFin\" required></md-input-container><md-input-container flex-xs=\"100\" flex=\"33\">\n<label translate=\"ENVIAR.REPET\">Repetir cada</label><input name=\"tiemporepet\" type=\"number\" ng-model=\"event.intervalo\" \nmin=\"1\" required aria-label=\"tiemporepet\"> <button ng-click=\"event.intervalo = event.intervalo + 1440\">+1D</button> \n<button ng-click=\"event.intervalo = event.intervalo + 60\">+1H</button> <span>{{event.intervalo|convertMinutesInHHMMSS}}\n</span></md-input-container><md-input-container flex-xs=\"50\" flex><label translate=\"ENVIAR.RANGOINICIO\">Inicio rango\n</label><input type=\"time\" ng-model=\"event.rangeInit\"></md-input-container><md-input-container flex-xs=\"50\" flex><label\n translate=\"ENVIAR.RANGOFIN\">Fin rango</label><input type=\"time\" ng-model=\"event.rangeEnd\"></md-input-container></div>\n<div ng-if=\"event.type === \'eventProgrammed\'\"><div class=\"md-accent-bg info-temp\"><em>\'Hora mínima\'</em> y <em>\n\'Hora máxima\'</em>\n sirven para restringir el intervalo de horas que se verá el aviso al día. Por ejemplo, si queremos que sólo se les muestre a los pacientes entre las 9:00 y las 20:00.\n<br>Si se deja vacío, se podrán mostrar a cualquier hora.</div><div class=\"md-warn-bg info-temp margin-top-5\">\nEl aviso se enviará a los equipos entre el <b>{{event.fIni|date:\'dd/MM/yyyy HH:mm\'}}</b> y el <b>\n{{event.fFin|date:\'dd/MM/yyyy HH:mm\'}}</b><br><span ng-show=\"event.rangeInit && event.rangeEnd\">\nSolo aparecerá en su pantalla entre las <b>{{event.rangeInit|date:\'HH:mm\'}}</b> y las <b>\n{{event.rangeEnd|date:\'HH:mm\'}}</b></span></div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"ENVIAR.ANTERIOR\">Anterior\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado || event.stbs.length < 1\" translate=\"ENVIAR.ENVIAR\">Enviar evento\n</md-button><img src=\"/assets/quantionImagenes/cargando.gif\" alt=\"\" ng-show=\"yaEnviado\"></div></ms-form-wizard>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/operaciones/templates/asignaServicios.tmpl.html","<md-dialog id=\"gestionCompras\" aria-label=\"Nueva compra\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"OPERACIONES.SERVICIOCORTESIA.TITLE\">Asignar servicio de cortesía</h2></div></md-toolbar><md-dialog-content>\n<form name=\"Form\" novalidate><md-radio-group ng-model=\"stbOrWallet\"><md-radio-button value=\"stb\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.STB\"></span></md-radio-button><md-radio-button value=\"wallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.WALLET\"></span></md-radio-button></md-radio-group><md-autocomplete flex required \nng-show=\"stbOrWallet === \'stb\'\" class=\"margin-bottom-16\" md-input-name=\"stb\" md-selected-item=\"compra.selectedStb\" \nmd-search-text=\"searchText\" md-items=\"item in stbSearch(searchText)|orderBy:\'room\'\" md-item-text=\"item.room\" \nmd-min-length=\"0\" md-require-match placeholder=\"{{\'OPERACIONES.NUEVACOMPRA.AUTOSTB\'|translate}}\" \nmd-select-on-match=\"true\"><md-item-template><span md-highlight-text=\"searchText\">\n{{\'OPERACIONES.DISPLAYTEXT\'|translate:\"{room:\'\"+item.room+\"\',username:\'\"+item.username+\"\',balance:\'\"+(item.virtualBalance||item.personalBalance)+\"\'}\"}}\n</span></md-item-template><div ng-messages=\"Form.stb.$error\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED1\">Este campo es obligatorio. Seleccione un elemento de la lista</div></div>\n</md-autocomplete><md-autocomplete flex required ng-show=\"stbOrWallet === \'wallet\'\" class=\"margin-bottom-16\" \nmd-input-name=\"wallet\" md-selected-item=\"compra.selectedWallet\" md-search-text=\"searchText2\" \nmd-items=\"item in walletSearch(searchText2)|orderBy:\'uuidVirtualWallet\'\" md-item-text=\"item.uuidVirtualWallet\" \nmd-min-length=\"0\" md-require-match placeholder=\"{{\'OPERACIONES.NUEVACOMPRA.AUTOWALLET\'|translate}}\" \nmd-select-on-match=\"true\"><md-item-template><span md-highlight-text=\"searchText2\">\n{{\'OPERACIONES.DISPLAYTEXTV\'|translate:\"{uuid:\'\"+item.uuidVirtualWallet+\"\',balance:\'\"+item.balance+\"\'}\"}}</span>\n</md-item-template><div ng-messages=\"Form.wallet.$error\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio</div></div></md-autocomplete><div layout=\"row\" \nlayout-xs=\"column\" flex><md-input-container class=\"md-block\" flex=\"50\" flex-xs=\"100\"><label \ntranslate=\"OPERACIONES.SERVICIOCORTESIA.SERVICIO\">Servicio</label><md-select ng-model=\"compra.selectedService\" \nname=\"servicio\" required ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><md-option \nng-repeat=\"srv in listaServicios|orderBy:\'name|formatNameDesc\'\" ng-value=\"srv\"><img ng-src=\"{{srv.logo}}\" width=\"50\" \nstyle=\"margin-right: 10px\"><span>{{srv.name|formatNameDesc}}</span></md-option></md-select><div \nng-messages=\"Form.servicio.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nflex=\"50\" flex-xs=\"100\"><md-input-container class=\"md-block no-errors-spacer margin-bottom-0\"><label><span \ntranslate=\"OPERACIONES.SERVICIOCORTESIA.DURACION\">Duración</span> ({{compra.duration|convertMinutesInHHMMSS}})</label>\n<input type=\"number\" ng-model=\"compra.duration\" name=\"duracion\" required \nng-disabled=\"!compra.selectedStb && !compra.selectedWallet\" step=\"60\"><div ng-messages=\"Form.duracion.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">\nEste campo es obligatorio.</div></div></md-input-container><md-button class=\"md-raised md-accent\" \nng-click=\"compra.duration = compra.duration + 60\" ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\">+ 1h\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"compra.duration = compra.duration + 1440\" \nng-disabled=\"!compra.selectedStb && !compra.selectedWallet\">+ 1d</md-button></div></div><md-input-container \nclass=\"md-block\"><label translate=\"OPERACIONES.RECARGASALDO.COMENTARIO\">Comentario</label><input name=\"comment\" \nng-model=\"compra.comment\" md-maxlength=\"1000\" required ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><div\n ng-messages=\"Form.comment.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nstyle=\"color: red; text-align: center\" translate=\"{{mensajeError}}\" ng-show=\"mensajeError\">{{mensajeError}}</div>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">\nCerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"Form.$invalid || Form.$pristine || (!compra.selectedStb && !compra.selectedWallet) || dataLoading\" \nstyle=\"margin-right:20px\" translate=\"OPERACIONES.NUEVACOMPRA.GUARDAR\">Guardar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/operaciones/templates/finishpending.tmpl.html","<md-dialog id=\"gestionCompras\" aria-label=\"Nueva compra\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OPERACIONES.REGISTRARPAGOPENDIENTE\">Registrar pago pendiente</h2></div>\n</md-toolbar><md-dialog-content><form name=\"Finish\" novalidate><md-radio-group ng-model=\"finish.payment\" layout-margin \nrequired><md-radio-button value=\"Cortesy\" aria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.REGALO2\">\nRegalo (cortesía)</span></md-radio-button><md-radio-button value=\"Balance\" aria-label=\"a\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.SALDO\">Pagado mediante saldo</span></md-radio-button><md-radio-button value=\"Cash\" \naria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.EFECTIVO\">Pagado en efectivo</span></md-radio-button>\n<md-radio-button value=\"Card\" aria-label=\"a\"><span translate=\"OPERACIONES.NUEVACOMPRA.TARJETA\">Pagado con tarjeta\n</span></md-radio-button></md-radio-group><md-input-container class=\"md-block\"><label \ntranslate=\"OPERACIONES.RECARGASALDO.COMENTARIO\">Comentario</label><input name=\"comment\" ng-model=\"finish.comment\" \nmd-maxlength=\"1000\" required></md-input-container><div style=\"color: red; text-align: center\" \ntranslate=\"{{mensajeError}}\" ng-show=\"mensajeError\">{{mensajeError}}</div></form></md-dialog-content><md-dialog-actions\n layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"Finish.$invalid || Finish.$pristine\" style=\"margin-right:20px\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/operaciones/templates/nuevacompra.tmpl.html","<md-dialog id=\"gestionCompras\" aria-label=\"Nueva compra\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\" style=\"max-height: 100%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"OPERACIONES.NUEVACOMPRA.TITLE\">Comprar paquete a un STB</h2></div></md-toolbar><md-dialog-content><form \nname=\"CompraPaquete\" novalidate><md-radio-group ng-model=\"stbOrWallet\"><md-radio-button value=\"stb\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.STB\"></span></md-radio-button><md-radio-button value=\"wallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.WALLET\"></span></md-radio-button></md-radio-group><md-autocomplete flex \nng-show=\"stbOrWallet === \'stb\'\" class=\"margin-bottom-16\" md-input-name=\"stb\" md-selected-item=\"compra.selectedStb\" \nmd-search-text=\"searchText\" md-items=\"item in stbSearch(searchText)|orderBy:\'room\'\" md-item-text=\"item.room\" \nmd-min-length=\"0\" md-require-match md-no-cache=\"true\" placeholder=\"{{\'OPERACIONES.NUEVACOMPRA.AUTOSTB\'|translate}}\" \nmd-select-on-match=\"true\" required><md-item-template><span md-highlight-text=\"searchText\">\n{{\'OPERACIONES.DISPLAYTEXT\'|translate:\"{room:\'\"+item.room+\"\',username:\'\"+item.username+\"\',balance:\'\"+(item.virtualBalance||item.personalBalance)+\"\'}\"}}\n</span></md-item-template><div ng-messages=\"CompraPaquete.stb.$error\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED1\">Este campo es obligatorio. Seleccione un elemento de la lista</div></div>\n</md-autocomplete><md-autocomplete flex ng-show=\"stbOrWallet === \'wallet\'\" class=\"margin-bottom-16\" \nmd-input-name=\"stb\" md-selected-item=\"compra.selectedWallet\" md-search-text=\"searchText2\" \nmd-items=\"item in walletSearch(searchText2)|orderBy:\'uuidVirtualWallet\'\" md-item-text=\"item.uuidVirtualWallet\" \nmd-min-length=\"0\" md-require-match md-no-cache=\"true\" placeholder=\"{{\'OPERACIONES.NUEVACOMPRA.AUTOWALLET\'|translate}}\" \nmd-select-on-match=\"true\" required><md-item-template><span md-highlight-text=\"searchText\">\n{{\'OPERACIONES.DISPLAYTEXTV\'|translate:\"{uuid:\'\"+item.uuidVirtualWallet+\"\',balance:\'\"+item.balance+\"\'}\"}}</span>\n</md-item-template><div ng-messages=\"CompraPaquete.stb.$error\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED1\">Este campo es obligatorio. Seleccione un elemento de la lista</div></div>\n</md-autocomplete><div layout=\"row\" layout-xs=\"column\" flex><md-input-container class=\"md-block\" flex=\"50\" \nflex-xs=\"100\"><label translate=\"OPERACIONES.NUEVACOMPRA.PAQUETE\">Paquete</label><md-select \nng-model=\"compra.selectedPackage\" name=\"paquete\" required ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\">\n<md-option ng-repeat=\"pkg in listaPaquetes\" ng-value=\"pkg\">{{pkg.name|formatNameDesc}}</md-option></md-select><div \nng-messages=\"CompraPaquete.paquete.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nclass=\"layout-column md-block\" flex=\"50\" flex-xs=\"100\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"OPERACIONES.NUEVACOMPRA.DURACION\">Duración</label><md-select ng-model=\"compra.duration\" name=\"duracion\" \nrequired ng-disabled=\"(!compra.selectedStb && !compra.selectedWallet) || !compra.selectedPackage\"><md-option \nng-repeat=\"dur in compra.selectedPackage.durationPrice\" value=\"{{dur.duration}}\">\n{{dur.duration|convertMinutesInHHMMSS}}: {{dur.price}}€</md-option><md-option \nng-disabled=\"compra.payment !== \'Cortesy\'\" value=\"custom\">Personalizada (solo cortesía)</md-option></md-select><div \nng-messages=\"CompraPaquete.duracion.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nng-if=\"compra.duration === \'custom\'\"><md-input-container class=\"md-block no-errors-spacer margin-0\" flex><label><span \ntranslate=\"OPERACIONES.SERVICIOCORTESIA.DURACION\">Duración</span> ({{compra.customDuration|convertMinutesInHHMMSS}})\n</label><input type=\"number\" ng-model=\"compra.customDuration\" name=\"duracion\" step=\"60\"><div \nng-messages=\"Form.duracion.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><md-button \nclass=\"md-raised md-accent\" ng-click=\"compra.customDuration = compra.customDuration + 60\">+ 1h</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"compra.customDuration = compra.customDuration + 1440\">+ 1d</md-button></div>\n</div></div><md-radio-group ng-model=\"compra.payment\" layout-margin required><md-radio-button value=\"Cortesy\" \naria-label=\"a\" ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.REGALO\">Regalo (cortesía)</span></md-radio-button><md-radio-button value=\"Balance\" \naria-label=\"a\" ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.SALDO\">Pagado mediante saldo</span></md-radio-button><md-radio-button value=\"Cash\" \naria-label=\"a\" ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.EFECTIVO\">Pagado en efectivo</span></md-radio-button><md-radio-button value=\"Card\" \naria-label=\"a\" ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.TARJETA\">Pagado con tarjeta</span></md-radio-button><md-radio-button \nvalue=\"TwoPending\" aria-label=\"a\" ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><span \ntranslate=\"OPERACIONES.NUEVACOMPRA.PENDIENTE\">Dejar pendiente de pago</span></md-radio-button></md-radio-group><div \nclass=\"comentario\" ng-show=\"compra.payment === \'TwoPending\'\" translate=\"OPERACIONES.NUEVACOMPRA.COMENTARIOPENDIENTE\">\nAl dejar la compra pendiente, especifique los detalles del pago en el comentario (Fecha de pago, causa, etc.)<br>\nCuando se efectúe el pago, deberá indicarlo buscando esta operación y marcándola como pagada.</div><md-input-container \nclass=\"md-block\"><label translate=\"OPERACIONES.RECARGASALDO.COMENTARIO\">Comentario</label><input name=\"comment\" \nng-model=\"compra.comment\" md-maxlength=\"1000\" required ng-disabled=\"!compra.selectedStb && !compra.selectedWallet\"><div\n ng-messages=\"CompraPaquete.comment.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio.</div></div></md-input-container><div \nstyle=\"color: red; text-align: center\" translate=\"{{mensajeError}}\" ng-show=\"mensajeError\">{{mensajeError}}</div>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">\nCerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"CompraPaquete.$invalid || CompraPaquete.$pristine || (!compra.selectedStb && !compra.selectedWallet) || dataLoading\" \nstyle=\"margin-right:20px\" translate=\"OPERACIONES.NUEVACOMPRA.GUARDAR\">Guardar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/operaciones/templates/recargasaldo.tmpl.html","<md-dialog id=\"gestionCompras\" aria-label=\"Recarga saldo\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"OPERACIONES.RECARGASALDO.TITLE\">\nRecargar saldo de un STB</h2></div></md-toolbar><md-dialog-content><form name=\"RecargaSaldo\" novalidate><md-radio-group\n ng-model=\"stbOrWallet\"><md-radio-button value=\"stb\"><span translate=\"OPERACIONES.NUEVACOMPRA.STB\"></span>\n</md-radio-button><md-radio-button value=\"wallet\"><span translate=\"OPERACIONES.NUEVACOMPRA.WALLET\"></span>\n</md-radio-button></md-radio-group><md-autocomplete flex required ng-show=\"stbOrWallet===\'stb\'\" \nclass=\"margin-bottom-16\" md-input-name=\"stb\" md-selected-item=\"recarga.selectedStb\" md-search-text=\"searchText\" \nmd-items=\"item in stbSearch(searchText)|orderBy:\'room\'\" md-item-text=\"item.room\" md-min-length=\"0\" md-require-match \nplaceholder=\"{{\'OPERACIONES.NUEVACOMPRA.AUTOSTB\'|translate}}\" md-select-on-match=\"true\"><md-item-template><span \nmd-highlight-text=\"searchText\">\n{{\'OPERACIONES.DISPLAYTEXT\'|translate:\"{room:\'\"+item.room+\"\',username:\'\"+item.username+\"\',balance:\'\"+(item.virtualBalance||item.personalBalance)+\"\'}\"}}\n</span></md-item-template><div ng-messages=\"RecargaSaldo.stb.$error\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio</div></div></md-autocomplete><md-autocomplete \nflex required ng-show=\"stbOrWallet===\'wallet\'\" class=\"margin-bottom-16\" md-input-name=\"wallet\" \nmd-selected-item=\"recarga.selectedWallet\" md-search-text=\"searchText2\" \nmd-items=\"item in walletSearch(searchText2)|orderBy:\'uuidVirtualWallet\'\" md-item-text=\"item.uuidVirtualWallet\" \nmd-min-length=\"0\" md-require-match placeholder=\"{{\'OPERACIONES.NUEVACOMPRA.AUTOWALLET\'|translate}}\" \nmd-select-on-match=\"true\"><md-item-template><span md-highlight-text=\"searchText2\">\n{{\'OPERACIONES.DISPLAYTEXTV\'|translate:\"{uuid:\'\"+item.uuidVirtualWallet+\"\',balance:\'\"+item.balance+\"\'}\"}}</span>\n</md-item-template><div ng-messages=\"RecargaSaldo.wallet.$error\"><div ng-message=\"required\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">Este campo es obligatorio</div></div></md-autocomplete><div layout=\"row\" \nlayout-xs=\"column\" layout-align-gt-xs=\"start center\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"30\" \nflex-xs=\"100\"><label translate=\"OPERACIONES.RECARGASALDO.INGRESO\">Ingreso</label><input type=\"number\" step=\"1\" \nname=\"amount\" ng-model=\"recarga.amount\" min=\"0\" \nmax=\"{{balanceLimit.MaxBalanceLimit - ((recarga.selectedStb.virtualBalance||recarga.selectedStb.personalBalance) || recarga.selectedWallet.balance)}}\" \nrequired ng-disabled=\"!recarga.selectedStb && !recarga.selectedWallet\"><div ng-messages=\"RecargaSaldo.amount.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">\nEste campo es obligatorio</div><div ng-message=\"max\" translate=\"OPERACIONES.RECARGASALDO.MAXRECARGA\" \ntranslate-values=\"{maxLimit:balanceLimit.MaxBalanceLimit}\">\nLa recarga no puede superar los 50€, y el saldo total no puede ser mayor que 50€.</div></div></md-input-container><div \nflex=\"5\"></div><div layout=\"column\" ng-show=\"recarga.selectedStb\"><span><span \ntranslate=\"OPERACIONES.RECARGASALDO.SALDOACTUAL\">Saldo actual:</span>\n {{recarga.selectedStb.virtualBalance||recarga.selectedStb.personalBalance}}€</span> <span><span \ntranslate=\"OPERACIONES.RECARGASALDO.SALDOFUTURO\">Saldo futuro:</span>\n {{(recarga.selectedStb.virtualBalance||recarga.selectedStb.personalBalance) + recarga.amount}}€<md-tooltip \nmd-direction=\"bottom\"><span translate=\"OPERACIONES.RECARGASALDO.MAXSALDO\" \ntranslate-values=\"{maxLimit:balanceLimit.MaxBalanceLimit}\">El saldo no puede ser mayor que 50€</span></md-tooltip>\n</span></div><div layout=\"column\" ng-show=\"recarga.selectedWallet\"><span><span \ntranslate=\"OPERACIONES.RECARGASALDO.SALDOACTUAL\">Saldo actual:</span> {{recarga.selectedWallet.balance}}€</span> <span>\n<span translate=\"OPERACIONES.RECARGASALDO.SALDOFUTURO\">Saldo futuro:</span>\n {{recarga.selectedWallet.balance + recarga.amount}}€<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"OPERACIONES.RECARGASALDO.MAXSALDO\" translate-values=\"{maxLimit:balanceLimit.MaxBalanceLimit}\">\nEl saldo no puede ser mayor que 50€</span></md-tooltip></span></div></div><md-radio-group ng-model=\"recarga.payment\" \nlayout-margin required><md-radio-button value=\"Cash\" aria-label=\"a\" \nng-disabled=\"!recarga.selectedStb && !recarga.selectedWallet\"><span translate=\"OPERACIONES.RECARGASALDO.EFECTIVO\">\nPagado en efectivo</span></md-radio-button><md-radio-button value=\"Card\" aria-label=\"a\" \nng-disabled=\"!recarga.selectedStb && !recarga.selectedWallet\"><span translate=\"OPERACIONES.RECARGASALDO.TARJETA\">\nPagado con tarjeta</span></md-radio-button></md-radio-group><md-input-container class=\"md-block\"><label \ntranslate=\"OPERACIONES.RECARGASALDO.COMENTARIO\">Comentario</label><input name=\"comment\" ng-model=\"recarga.comment\" \nmd-maxlength=\"1000\" required ng-disabled=\"!recarga.selectedStb && !recarga.selectedWallet\"><div \nng-messages=\"RecargaSaldo.comment.$error\"><div ng-message=\"required\" translate=\"OPERACIONES.NUEVACOMPRA.REQUIRED2\">\nEste campo es obligatorio</div></div></md-input-container><div style=\"color: red; text-align: center\" \ntranslate=\"{{mensajeError}}\" ng-show=\"mensajeError\">{{mensajeError}}</div></form></md-dialog-content><md-dialog-actions\n layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"RecargaSaldo.$invalid || RecargaSaldo.$pristine || (!recarga.selectedStb && !recarga.selectedWallet) || dataLoading\" \nstyle=\"margin-right:20px\" translate=\"OPERACIONES.NUEVACOMPRA.GUARDAR\">Guardar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/operaciones/templates/revokeoperation.tmpl.html","<md-dialog id=\"gestionCompras\" aria-label=\"Revocar compra\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OPERACIONES.DEVOLUCION.TITLE\">Devolver importe al cliente</h2></div>\n</md-toolbar><md-dialog-content><form name=\"Revoke\" novalidate><md-radio-group ng-model=\"revokation.policy\" \nlayout-margin required><md-radio-button value=\"OneShot\" aria-label=\"a\"><span translate=\"OPERACIONES.DEVOLUCION.AHORA\">\nDevolver ahora mismo</span></md-radio-button><md-radio-button value=\"TwoPending\" aria-label=\"a\"><span \ntranslate=\"OPERACIONES.DEVOLUCION.DEJARPENDIENTE\">Dejar pendiente la devolución</span></md-radio-button>\n</md-radio-group><div class=\"comentario\" ng-show=\"revokation.policy === \'TwoPending\'\" \ntranslate=\"OPERACIONES.DEVOLUCION.COMENTARIO\">\nAunque deje la devolución como pendiente, el cliente perderá los paquetes de esta operación<br>\nCuando se efectúe la devolución, deberá indicarlo buscando esta operación y marcándola como finalizada.</div>\n<md-input-container class=\"md-block\"><label translate=\"OPERACIONES.DEVOLUCION.IMPORTEDEVUELTO\">Importe devuelto</label>\n<input type=\"number\" step=\"1\" name=\"refund\" ng-model=\"revokation.refund\" min=\"0\" max=\"{{operation.maxImport}}\"><div \nclass=\"hint\" style=\"position: initial\" translate=\"OPERACIONES.DEVOLUCION.HINT\" \ntranslate-values=\"{maxImport:{{operation.maxImport}}}\">\nEste campo es opcional: Puede especificar un importe entre 0€ y {{operation.maxImport}}€ (precio que costó este paquete). Si no especifica nada, se devolverá el importe completo.\n</div><div ng-messages=\"Revoke.refund.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"max\" \ntranslate=\"OPERACIONES.DEVOLUCION.MENSAJEMAX\" translate-values=\"{maxImport:{{operation.maxImport}}}\">\nEl importe devuelto no puede superar los {{operation.maxImport}}€ (Precio de este paquete).</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"OPERACIONES.RECARGASALDO.COMENTARIO\">\nComentario</label><input name=\"comment\" ng-model=\"revokation.comment\" md-maxlength=\"1000\" required>\n</md-input-container><div style=\"color: red; text-align: center\" translate=\"{{mensajeError}}\" ng-show=\"mensajeError\">\n{{mensajeError}}</div></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"OPERACIONES.NUEVACOMPRA.CERRAR\">\nCerrar</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"Revoke.$invalid || Revoke.$pristine || dataLoading\" \nstyle=\"margin-right:20px\" translate=\"OPERACIONES.NUEVACOMPRA.GUARDAR\">Guardar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/admin.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><md-tabs md-dynamic-height md-stretch-tabs=\"always\">\n<md-tab><md-tab-label><span translate=\"RECAUDACION.PORFECHA\"></span></md-tab-label><md-tab-body><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"(fecha,dinero) in groupedData\" ng-class-odd=\"\'odd\'\"><span><strong>\n{{::fecha}}</strong>: {{::dinero}}€</span></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"RECAUDACION.LISTADOCOMPLETO\"></span></md-tab-label><md-tab-body><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data\" ng-class-odd=\"\'odd\'\"><span><strong>{{::disp.date|date:\"dd/MM/yy HH:mm\"}}</strong>\n: {{::disp.total}}€ <span ng-if=\"disp.total <= 0\" class=\"md-accent-fg\">\n(Operación de intercambio de dinero entre componentes)</span></span><div layout=\"row\" layout-wrap><div \nng-repeat=\"(key,value) in ::medidas\" class=\"flex-12\" layout=\"row\" layout-align=\"start center\" ng-if=\"disp[key] > 0\">\n<div class=\"_{{::key}}\">{{::value}}</div>x{{::disp[key]}}</div></div></div></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/card.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><md-tabs md-dynamic-height md-stretch-tabs=\"always\">\n<md-tab><md-tab-label><span translate=\"RECAUDACION.PORFECHA\"></span></md-tab-label><md-tab-body><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"(fecha,dinero) in groupedData\" ng-class-odd=\"\'odd\'\"><span><strong>\n{{::fecha}}</strong>: {{::dinero}}€</span></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"RECAUDACION.LISTADOCOMPLETO\"></span></md-tab-label><md-tab-body><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data\" ng-class-odd=\"\'odd\'\"><span><strong>{{::disp.date|date:\"dd/MM/yy HH:mm\"}}</strong>\n: {{::disp.amount}}€</span></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/cash.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><md-tabs md-dynamic-height md-stretch-tabs=\"always\">\n<md-tab><md-tab-label><span translate=\"RECAUDACION.PORFECHA\"></span></md-tab-label><md-tab-body><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"(fecha,dinero) in groupedData\" ng-class-odd=\"\'odd\'\"><span><strong>\n{{::fecha}}</strong>: {{::dinero}}€</span></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"RECAUDACION.LISTADOCOMPLETO\"></span></md-tab-label><md-tab-body><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data\" ng-class-odd=\"\'odd\'\" class=\"operation\"><span><strong>{{::disp.date|date:\"dd/MM/yy HH:mm\"}}\n</strong>: <span translate=\"RECAUDACION.CASHCONTENT\" \ntranslate-values=\'{amount:\"{{::disp.amount}}\",tipoOp:\"{{::tipoOp}}\",totalBalance:\"{{::disp.totalBalance}}\",totalIn:\"{{::disp.totalIn}}\",totalOut:\"{{::disp.totalOut|abs}}\"}\'>\nImporte: {{::disp.amount}}€, {{::tipoOp}} de {{::disp.totalBalance}}€ (Introducido {{::disp.totalIn}}€ / Devuelto {{::disp.totalOut|abs}}€)\n</span></span><div layout=\"row\" layout-wrap><span translate=\"RECAUDACION.CASHENTRADA\">Entrada:</span><div \nng-repeat=\"(key,value) in ::medidas\" class=\"flex-12\" layout=\"row\" layout-align=\"start center\" \nng-if=\"disp[\'c\' + key] > 0\"><div class=\"_{{::key}}\">{{::value}}</div>x{{::disp[\'c\' + key]}}</div></div><div \nlayout=\"row\" layout-wrap><span translate=\"RECAUDACION.CASHSALIDA\">Salida:</span><div \nng-repeat=\"(key,value) in ::medidas\" class=\"flex-12\" layout=\"row\" layout-align=\"start center\" \nng-if=\"disp[\'p\' + key] > 0\"><div class=\"_{{::key}}\">{{::value}}</div>x{{::disp[\'p\' + key]}}</div></div><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" ng-if=\"disp.completed\" style=\"color: green\"></md-icon><md-icon \nmd-font-icon=\"icon-close-circle\" ng-if=\"!disp.completed\" style=\"color:red\"></md-icon></div></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/cupones.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><div class=\"md-dialog-content-body\"><div \nng-repeat=\"cupon in data|orderBy:\'-generado\'\" ng-class-odd=\"\'odd\'\" layout=\"row\" layout-align=\"space-between\"><span \nstyle=\"min-width: 200px\"><span translate=\"RECAUDACION.IDCUPON\">ID cupón:</span> {{::cupon.idCupon}}</span> <span \nstyle=\"min-width: 200px\"><span translate=\"RECAUDACION.IDOPERACION\">ID operación:</span> {{::cupon.idOperacion}}</span> \n<span><span translate=\"RECAUDACION.GENERADO\">Generado:</span> {{::cupon.generado|date:\"dd/MM/yy HH:mm\"}} / <span \ntranslate=\"RECAUDACION.USADO\">Usado:</span> {{::cupon.usado|date:\"dd/MM/yy HH:mm\"}}</span></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/gratis.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data|orderBy:\'-fecha\'\" ng-class-odd=\"\'odd\'\" layout=\"row\" layout-align=\"space-between\"><span><strong>\n{{::disp.date|date:\"dd/MM/yy HH:mm\"}}</strong>: {{::disp.amount}}€</span> <span style=\"margin-left: 4em\">\n{{::disp.comment}}</span></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/mandos.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data|orderBy:\'-fecha\'\" ng-class-odd=\"\'odd\'\" layout=\"row\" layout-align=\"space-between\"><span><strong>\n{{::disp.fecha|date:\"dd/MM/yy HH:mm\"}}</strong>: {{::disp.cantidad}}€</span> <span ng-if=\"disp.habitacion\"><span \ntranslate=\"RECAUDACION.HABITACION\">Habitación</span> {{::disp.habitacion}}</span> <span ng-if=\"disp.uidMando\"><span \ntranslate=\"RECAUDACION.UIDMANDO\">UID mando</span> {{::disp.uidMando}}</span> <span ng-if=\"disp.tipoMando\"><span \ntranslate=\"RECAUDACION.TIPOMANDO\">Tipo mando</span> {{::disp.tipoMando}}</span></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion/templates/paypal.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data.eachDay|orderBy:\'-day\'\" ng-class-odd=\"\'odd\'\" layout=\"row\" layout-align=\"space-between\"><span>\n<strong>{{::disp.day|date:\"dd/MM/yy\"}}</strong>: {{::disp.report.amount}}€</span></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion_simple/templates/admin.tmpl.html","<md-dialog id=\"recaudacion\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><md-tabs md-dynamic-height md-stretch-tabs=\"always\">\n<md-tab><md-tab-label><span translate=\"RECAUDACION.PORFECHA\"></span></md-tab-label><md-tab-body><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"(fecha,dinero) in groupedData\" ng-class-odd=\"\'odd\'\"><span><strong>\n{{::fecha}}</strong>: {{::dinero}}€</span></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"RECAUDACION.LISTADOCOMPLETO\"></span></md-tab-label><md-tab-body><div class=\"md-dialog-content-body\"><div \nng-repeat=\"disp in data\" ng-class-odd=\"\'odd\'\"><span><strong>{{::disp.date|date:\"dd/MM/yy HH:mm\"}}</strong>\n: {{::disp.total}}€ <span ng-if=\"disp.total <= 0\" class=\"md-accent-fg\">\n(Operación de intercambio de dinero entre componentes)</span></span><div layout=\"row\" layout-wrap><div \nng-repeat=\"(key,value) in ::medidas\" class=\"flex-12\" layout=\"row\" layout-align=\"start center\" ng-if=\"disp[key] > 0\">\n<div class=\"_{{::key}}\">{{::value}}</div>x{{::disp[key]}}</div></div></div></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/apRuckusAlarms.tmpl.html","<md-dialog id=\"puntos-de-acceso\" aria-label=\"Alarmas AP\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"APS.MODAL_ALARMS.TITLE\">Alarmas\n</h2></div></md-toolbar><md-dialog-content><div layout=\"column\" flex><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"60\" ng-if=\"loadingAlarms\" style=\"margin: auto\"></md-progress-circular><div \nclass=\"brad-4 md-primary-bg md-whiteframe-2dp padding-10 margin-bottom-10\" layout=\"column\" \nng-repeat=\"alarm in alarms track by alarm.id\"><div class=\"font-size-20 margin-bottom-8\">\n({{alarm.severity}}/{{alarm.category}}) {{alarm.alarmType}}</div><div class=\"font-size-14 margin-bottom-8\">\n{{alarm.activity}}</div><div class=\"text-right md-warn-fg\">{{alarm.insertionTime | date: \'dd/MM/yyyy HH:mm:ss\'}}</div>\n</div><p translate=\"APS.MODAL_ALARMS.NO_EVENTS\" ng-if=\"!loadingAlarms && alarms.length <= 0\" \nclass=\"text-center font-size-22\">No hay alarmas</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button\n ng-click=\"hide()\" translate=\"APS.MODAL_ALARMS.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/apRuckusDetails.tmpl.html","<md-dialog id=\"puntos-de-acceso\" aria-label=\"Detalles AP\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"APS.MODAL_DETAILS.TITLE\" \ntranslate-values=\"{name: puntoAcceso.name}\">Info del AP {{puntoAcceso.name}}</h2></div></md-toolbar><md-dialog-content>\n<h3>Detalles:</h3><div layout=\"row\" layout-wrap flex class=\"font-size-14\"><div flex-xs=\"100\" flex-sm=\"100\" flex=\"33\">\n<span class=\"md-accent-fg text-capitalize text-bold\">Estado:</span> {{puntoAcceso.ruckus.more.status}}</div><div \nng-repeat=\"key in booleanProps\" flex-xs=\"100\" flex-sm=\"100\" flex=\"33\"><span \nclass=\"md-accent-fg text-capitalize text-bold\">{{key}}:</span> {{puntoAcceso.ruckus.more[key] ? \'Si\': \'No\'}}</div><div \nng-repeat=\"key in numericProps\" flex-xs=\"100\" flex-sm=\"100\" flex=\"33\"><span \nclass=\"md-accent-fg text-capitalize text-bold\">{{key}}:</span> {{puntoAcceso.ruckus.more[key]}}</div></div><h3>\nClientes conectados: ({{clients.length}})</h3><div layout=\"row\" layout-align=\"start start\" layout-wrap flex>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"60\" ng-if=\"loadingClients\"></md-progress-circular><div \nclass=\"brad-4 md-primary-bg md-whiteframe-2dp padding-5 margin-right-10 margin-bottom-10 font-size-14\" layout=\"column\" \nng-repeat=\"client in clients\"><div>IP: {{client.ipAddress}}</div><div>MAC: {{client.clientMac}}</div><div>\nHostname: {{client.hostname}}</div><div>RSSI: {{client.rssi}}</div><div>SNR: {{client.snr}}</div><div>\nUplink Rate: {{client.uplinkRate}}</div><div>Downlink Rate: {{client.downlinkRate}}</div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"hide()\" translate=\"APS.MODAL_DETAILS.CERRAR\">\nCerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/apRuckusEvents.tmpl.html","<md-dialog id=\"puntos-de-acceso\" aria-label=\"Eventos AP\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"APS.MODAL_EVENTS.TITLE\">Eventos\n</h2></div></md-toolbar><md-dialog-content><div layout=\"column\" flex><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"60\" ng-if=\"loadingEvents\" style=\"margin: auto\"></md-progress-circular><div \nclass=\"brad-4 md-primary-bg md-whiteframe-2dp padding-10 margin-bottom-10\" layout=\"column\" \nng-repeat=\"event in events track by event.id\"><div class=\"font-size-20 margin-bottom-8\">\n({{event.severity}}/{{event.category}}) {{event.eventType}}</div><div class=\"font-size-14 margin-bottom-8\">\n{{event.activity}}</div><div class=\"text-right md-warn-fg\">{{event.insertionTime | date: \'dd/MM/yyyy HH:mm:ss\'}}</div>\n</div><p translate=\"APS.MODAL_EVENTS.NO_EVENTS\" ng-if=\"!loadingEvents && events.length <= 0\" \nclass=\"text-center font-size-22\">No hay eventos</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button\n ng-click=\"hide()\" translate=\"APS.MODAL_EVENTS.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/cambiarAp.tmpl.html","<md-dialog id=\"puntos-de-acceso\" aria-label=\"Editar AP\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><form name=\"formulario\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"APS.MODAL_EDITAR.TITLE\">Editar punto de acceso</h2></div></md-toolbar><md-dialog-content><div \nlayout=\"column\" flex><md-checkbox ng-model=\"isEthernet\" aria-label=\"Ethernet\">Ethernet</md-checkbox><md-autocomplete \nflex required md-input-name=\"autocompleteField\" md-input-minlength=\"0\" md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-min-length=\"0\" md-items=\"ap in querySearch(searchText)\" md-item-text=\"ap.displayText\" \nmd-floating-label=\"{{\'APS.APASIGNADO\' | translate}}\" md-require-match ng-disabled=\"isEthernet\"><md-item-template><span \nmd-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{ap.displayText}}</span></md-item-template></md-autocomplete>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"cargando\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"Guardar()\" \nng-disabled=\"formulario.$invalid || (!selectedItem && !isEthernet) || cargando\" style=\"margin-right:20px\" \ntranslate=\"EDITAR_STB.GUARDAR\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/editar.tmpl.html","<md-dialog id=\"puntos-de-acceso\" aria-label=\"Editar AP\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><form name=\"formulario\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"APS.MODAL_EDITAR.TITLE\">Editar punto de acceso</h2></div></md-toolbar><md-dialog-content><div \nlayout=\"column\" flex><md-input-container flex class=\"no-errors-spacer\"><label translate=\"APS.NAME\">Nombre</label><input\n type=\"text\" name=\"name\" ng-model=\"puntoAcceso.name\" maxlength=\"50\" required><div ng-messages=\"formulario.name.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container flex class=\"no-errors-spacer\"><label \ntranslate=\"APS.ESSID\">ESSID</label><input type=\"text\" name=\"essid\" ng-model=\"puntoAcceso.essid\" maxlength=\"50\" \nrequired><div ng-messages=\"formulario.essid.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n<md-input-container flex class=\"no-errors-spacer\"><label translate=\"APS.PASSWORD\">Contraseña</label><input \ntype=\"password\" name=\"pwd\" ng-model=\"puntoAcceso.password\" minlength=\"8\" maxlength=\"64\" required><div \nng-messages=\"formulario.pwd.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"minlength\" \ntranslate=\"APS.ERRORMINMAX\">La contraseña debe tener entre 8 y 64 caracteres.</div><div ng-message=\"maxlength\" \ntranslate=\"APS.ERRORMINMAX\">La contraseña debe tener entre 8 y 64 caracteres.</div></div></md-input-container>\n<md-input-container flex class=\"no-errors-spacer\"><label translate=\"APS.BSSID\">BSSID</label><input type=\"text\" \nname=\"bssid\" ng-model=\"puntoAcceso.bssid\" ng-pattern=\"macPattern\" required><div ng-messages=\"formulario.bssid.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"pattern\" translate=\"EDITAR_STB.STB.MACPATTERN\">\nLa MAC no tiene el formato correcto.</div></div></md-input-container><md-input-container flex><label \ntranslate=\"APS.BANDA\">Banda</label><md-select ng-model=\"puntoAcceso.band\" name=\"band\" required><md-option \nng-repeat=\"band in bandList\" value=\"{{band}}\">{{band}}</md-option></md-select><div \nng-messages=\"formulario.band.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><md-checkbox \nng-model=\"puntoAcceso.hidden\" aria-label=\"hidden\"><span translate=\"APS.HIDDEN\">¿Oculta?</span></md-checkbox></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"cargando\" src=\"/assets/quantionImagenes/cargando.gif\">\n<md-button ng-click=\"Guardar()\" ng-disabled=\"formulario.$invalid || cargando\" style=\"margin-right:20px\" \ntranslate=\"EDITAR_STB.GUARDAR\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/importarAps.tmpl.html","<md-dialog id=\"import-aps\" aria-label=\"Importar puntos de acceso\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"APS.MODALIMPORTAR.TITLE\">\nImportar instalaciones</h2></div></md-toolbar><md-dialog-content><table><tr><th><input type=\"checkbox\" \nng-model=\"allSelected\" ng-change=\"toggleAll(allSelected)\" aria-label=\"seleccionado\"></th><th class=\"column-title\"><span\n translate=\"APS.NAME\">Nombre</span></th><th class=\"column-title\"><span translate=\"APS.ESSID\">ESSID</span></th><th \nclass=\"column-title\"><span translate=\"APS.BSSID\">BSSID</span></th><th class=\"column-title\"><span translate=\"APS.BANDA\">\nBanda</span></th><th class=\"column-title\"><span translate=\"APS.HIDDEN\">Oculta</span></th><th><span \ntranslate=\"APS.MODALIMPORTAR.EXISTE\">Existe</span><md-icon md-font-icon=\"icon-information-outline\"><md-tooltip \nmd-direction=\"bottom\" class=\"info-tooltip\"><span translate=\"APS.MODALIMPORTAR.INFOTOOLTIP\">\nSi está marcado, significa que ya existe un punto de acceso con la misma MAC. Se actualizarán sus propiedades con las de esta tabla.\n</span></md-tooltip></md-icon></th></tr><tr ng-repeat=\"ap in listaAps|orderBy:\'name\' track by $index\"><td><input \ntype=\"checkbox\" ng-model=\"ap.seleccionado\" aria-label=\"seleccionado\"></td><td>{{ap.name}}</td><td>{{ap.essid}}</td><td>\n{{ap.bssid}}</td><td>{{ap.band}}</td><td translate=\"APS.HIDDEN_{{ap.hidden}}\">{{ap.hidden}}</td><td><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"ap.exists\"></md-icon></td></tr></table></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"INSTALACIONES.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/aps/templates/importarApsRuckus.tmpl.html","<md-dialog id=\"import-aps\" aria-label=\"Importar puntos de acceso\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"APS.MODALIMPORTAR.TITLE\">\nImportar puntos de acceso</h2></div></md-toolbar><md-dialog-content><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"60\" ng-if=\"loadingRuckus\" style=\"margin: auto\"></md-progress-circular><div layout=\"column\" \nng-if=\"!loadingRuckus\"><div layout=\"row\" layout-align=\"end center\"><span>Seleccionar por ESSID</span> <input \nng-model=\"essidFilter\" class=\"margin-horizontal-8\"><md-button class=\"md-fab md-mini\" \nng-click=\"filterAps(\'essid\', essidFilter)\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button></div><table><tr>\n<th><input type=\"checkbox\" ng-model=\"allSelected\" ng-change=\"toggleAll(allSelected)\" aria-label=\"seleccionado\"></th><th\n class=\"column-title\"><span translate=\"APS.NAME\">Nombre</span></th><th class=\"column-title\"><span \ntranslate=\"APS.ESSID\">ESSID</span></th><th class=\"column-title\"><span translate=\"APS.BSSID\">BSSID</span></th><th \nclass=\"column-title\"><span translate=\"APS.BANDA\">Banda</span></th><th class=\"column-title\"><span \ntranslate=\"APS.HIDDEN\">Oculta</span></th><th class=\"column-title\"><span translate=\"APS.PASSWORD\">Contraseña</span></th>\n<th><span translate=\"APS.MODALIMPORTAR.EXISTE\">Existe</span><md-icon md-font-icon=\"icon-information-outline\">\n<md-tooltip md-direction=\"bottom\" class=\"info-tooltip\"><span translate=\"APS.MODALIMPORTAR.INFOTOOLTIP\">\nSi está marcado, significa que ya existe un punto de acceso con la misma MAC. Se actualizarán sus propiedades con las de esta tabla.\n</span></md-tooltip></md-icon></th></tr><tr \nng-repeat=\"ap in listaAps|orderBy:[\'name\', \'essid\', \'band\'] track by $index\" \nng-class=\"{\'grey-300-bg grey-600-fg\': ap.exists}\"><td><input type=\"checkbox\" ng-model=\"ap.seleccionado\" \naria-label=\"seleccionado\"></td><td>{{ap.name}}</td><td>{{ap.essid}}</td><td>{{ap.bssid}}</td><td \nng-class=\"{\'md-accent-fg\': ap.band.includes(\'2\'),\'md-warn-fg\': ap.band.includes(\'5\')}\">{{ap.band}}</td><td \ntranslate=\"APS.HIDDEN_{{ap.hidden}}\">{{ap.hidden}}</td><td>{{ap.password}}</td><td style=\"text-align: center\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"ap.exists\"></md-icon></td></tr></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"INSTALACIONES.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\" ng-disabled=\"dataLoading\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/gestionCompras/recaudacion_v/templates/operations.tmpl.html","<md-dialog id=\"recaudacion_v\" aria-label=\"day\" ng-cloak md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\">{{title}}</h2><div class=\"md-dialog-content-body\"><div \nng-repeat=\"day in days\" ng-class-odd=\"\'odd\'\" ng-dblclick=\"edit(day)\" class=\"no-select\"><span><strong>\n{{day | date:\"dd/MM/yy\"}}</strong>: {{data[day].balance}}€</span></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/listado/templates/actionPostEdit.tmpl.html","<md-dialog aria-label=\"Action\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\">\n¿Quieres realizar alguna acción para este equipo? (Hab. {{stb.room}})</div></md-toolbar><md-dialog-content><h3>\nPara aplicar un cambio de tema o de instalación, es necesario un <b>Actualizar dynamic</b></h3><h3>\nPara cambiar el estado del táctil, es necesario <b>reiniciar</b></h3></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"dynamic()\">Actualizar dynamic</md-button><md-button ng-click=\"interfaceReboot()\">\nRecargar interfaz</md-button><md-button ng-click=\"reboot()\">Reiniciar</md-button><md-button ng-click=\"hide()\">Cerrar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/listado/templates/cambiohabitacion.tmpl.html","<md-dialog id=\"vincularStb\" aria-label=\"Vincular STB\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{(title|| \'WALLETS.VINCULAR.TITLE\') | translate}}</h2></div></md-toolbar>\n<md-dialog-content><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\" class=\"margin-bottom-16\"><span>\nIntercambiar servicios/saldo entre origen/destino</span><md-switch ng-model=\"options.merge\" class=\"margin-vertical-0\" \nstyle=\"margin-left: 8px\"></md-switch><span>Combinar servicios/saldo en la habitación de destino</span></div>\n<md-checkbox ng-model=\"options.checkout\">Hacer check-out en la habitación de origen <b>después del cambio</b>\n</md-checkbox><md-checkbox ng-model=\"checkoutDest\">Hacer check-out en la habitación de destino <b>antes del cambio</b>\n</md-checkbox></div><md-divider></md-divider><h3>Habitación de destino</h3><md-input-container \nclass=\"md-icon-float md-block no-errors-spacer\"><label translate=\"CAMBIO.BUSCAR\">Buscar</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"searchText\" type=\"text\" style=\"background: none\">\n</md-input-container><md-radio-group ng-model=\"stbSelected\" class=\"layout-row layout-align-start-center layout-wrap\">\n<md-radio-button ng-value=\"stb\" ng-repeat=\"stb in listaStbs|filter:searchText\" flex=\"100\" flex-gt-xs=\"45\" \nflex-gt-sm=\"30\" flex-gt-md=\"20\"><span flex>{{stb.room}} - {{stb.username}}</span><md-icon \nmd-font-icon=\"icon-credit-card\" ng-if=\"stb.typeWallet === \'virtual\'\" class=\"md-accent-fg margin-left-5\"></md-icon>\n<md-icon md-font-icon=\"icon-cart-outline\" ng-if=\"stb.activeContracts || stb.hasCrushedServices\" \nclass=\"md-warn-fg margin-left-5\"></md-icon></md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-wrap style=\"min-height: max-content\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"> <span ng-if=\"options.merge && stbSelected.typeWallet === \'virtual\'\" \nclass=\"red-fg text-italic\">\nHay una tarjeta asociada en el destino, no se puede combinar monedero interno con una tarjeta</span><md-button \nng-click=\"hide()\" translate=\"WALLETS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"!stbSelected || dataLoading || (options.merge && stbSelected.typeWallet === \'virtual\')\" \nstyle=\"margin-right:20px\" translate=\"WALLETS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/listado/templates/checkin.tmpl.html","<md-dialog id=\"listadoHabitaciones\" aria-label=\"Check-in\" ng-cloak flex=\"50\" md-theme=\"{{$root.theme}}\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 translate=\"CHECKIN.TITLE\">Datos de check-in</h2></div></md-toolbar>\n<md-dialog-content><form name=\"formulario\"><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nflex-gt-sm=\"60\"><label translate=\"CHECKIN.CLIENTE\">Nombre del cliente</label><input type=\"text\" name=\"nombrecliente\" \nng-model=\"stb.username\" maxlength=\"100\"><div ng-messages=\"formulario.nombrecliente.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"CHECKIN.REQUIRED\">Este campo es obligatorio.</div><div \nng-message=\"maxlength\" translate=\"CHECKIN.LONGITUD\">Longitud máxima.</div></div></md-input-container><div flex=\"10\">\n</div><md-input-container flex-gt-sm=\"30\"><label translate=\"CHECKIN.IDIOMA\">Idioma</label><md-select \nng-model=\"stb.lang\" name=\"idioma\" required class=\"lang-select\"><md-option ng-repeat=\"id in listaIdiomas\" \nvalue=\"{{id.idioma}}\"><img ng-src=\"{{id.rutaIcono|replacePath}}\" alt=\"{{id.idioma}}\" style=\"max-height: 24px\">\n</md-option></md-select><div ng-messages=\"formulario.idioma.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"CHECKIN.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><div \nflex=\"10\"></div><md-checkbox ng-model=\"stb.properties.displayWelcome\" aria-label=\"Bienvenida\" class=\"md-warn\"><h4 \ntranslate=\"CHECKIN.WELCOME\">Mostrar mensaje de bienvenida</h4></md-checkbox></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"cargando\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"CheckIn()\" ng-disabled=\"formulario.$invalid || cargando\" style=\"margin-right:20px\" \ntranslate=\"CHECKIN.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/listado/templates/editar.tmpl.html","<md-dialog id=\"editarHabitacion\" aria-label=\"Editar habitacion\" ng-cloak flex=\"100\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"EDITAR_STB.TITLE\">Editar habitación</h2></div></md-toolbar>\n<md-dialog-content><md-tabs md-dynamic-height md-border-bottom class=\"white-bg md-whiteframe-4dp\" \nmd-stretch-tabs=\"always\" ng-hide=\"!stb\"><md-tab><md-tab-label><span translate=\"EDITAR_STB.DATOSSTB\">Datos del STB\n</span><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-accent-fg\" ng-if=\"form1.$invalid\"></md-icon></md-tab-label>\n<md-tab-body><form name=\"form1\"><div class=\"container\" layout-gt-sm=\"row\" layout=\"column\" \nlayout-align-gt-sm=\"space-around start\"><div layout=\"column\" flex><md-input-container flex><label \ntranslate=\"EDITAR_STB.STB.NOMBRE\">Nombre de habitación</label><input type=\"text\" name=\"habitacion\" ng-model=\"stb.room\" \nmaxlength=\"50\" required><div ng-messages=\"form1.habitacion.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n<md-slider-container flex><h5 translate=\"EDITAR_STB.STB.VOLUMEN\">Volumen máximo de la TV</h5><md-slider flex \nmd-discrete min=\"0\" max=\"130\" ng-model=\"stb.properties.volume\" aria-label=\"volumen\" hide show-gt-sm></md-slider><div \nlayout=\"row\" hide-gt-sm><input type=\"range\" min=\"0\" max=\"130\" ng-model=\"stb.properties.volume\" flex> <span>\n{{stb.properties.volume}}%</span></div></md-slider-container><md-checkbox ng-model=\"stb.properties.displayWelcome\" \naria-label=\"Bienvenida\"><span translate=\"EDITAR_STB.STB.WELCOME\">Mostrar mensaje de bienvenida</span></md-checkbox>\n<md-checkbox ng-model=\"stb.properties.touch\" aria-label=\"Touch\"><span translate=\"EDITAR_STB.STB.TOUCH\">¿Es táctil?\n</span></md-checkbox><md-checkbox ng-model=\"stb.properties.usb\" aria-label=\"usb\"><span translate=\"EDITAR_STB.STB.USB\">\n¿Admite USB?</span></md-checkbox><md-checkbox ng-model=\"stb.properties.sidebar\" aria-label=\"Sidebar\"><span \ntranslate=\"EDITAR_STB.STB.SIDEBAR\">¿Tiene barra lateral?</span></md-checkbox></div><div layout=\"column\" flex>\n<md-input-container flex><label translate=\"CREAR_STB.STB.MODELO\">Modelo</label><md-select ng-model=\"stb.model\" \nname=\"modelo\" required aria-label=\"a\" ng-change=\"getVersionLists()\"><md-option ng-repeat=\"model in listaModelos\" \nng-value=\"{{model.idStbModel}}\">{{model.name}}</md-option></md-select><div ng-messages=\"form1.modelo.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"CREAR_STB.STB.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container flex><label \ntranslate=\"CREAR_STB.STB.INSTALACION\">Instalacion</label><md-select ng-model=\"stb.installation\" name=\"instalacion\" \nrequired aria-label=\"a\" ng-change=\"getInstallationById(stb.installation)\"><md-option \nng-repeat=\"installation in listaInstalaciones\" ng-value=\"{{installation.idInstallation}}\">{{installation.name}}\n</md-option></md-select><div ng-messages=\"form1.instalacion.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"CREAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n<md-input-container flex><label translate=\"EDITAR_STB.STB.THEMEOVERRIDE\">Tema asignado</label><md-select \nng-model=\"stb.properties.themeOverride\" name=\"theme\"><md-option ng-value=\"null\"><em>\nEl de la instalación ({{installationChosed.theme}})</em></md-option><md-option ng-repeat=\"theme in listaThemes\" \nvalue=\"{{theme}}\">{{theme}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"no-errors-spacer\"><label translate=\"EDITAR_STB.STB.RESOLUCION\">Resolución</label><input type=\"text\" \nname=\"resolucion\" ng-model=\"stb.properties.resolution\" disabled=\"disabled\"></md-input-container><md-slider-container \nflex><h5 translate=\"EDITAR_STB.STB.TXPOWER\">Alcance del WiFi</h5><md-slider flex md-discrete min=\"0\" max=\"100\" \nng-model=\"stb.properties.txPower\" aria-label=\"txpower\" hide show-gt-sm></md-slider><div layout=\"row\" hide-gt-sm><input \ntype=\"range\" min=\"0\" max=\"100\" ng-model=\"stb.properties.txPower\" flex> <span>{{stb.properties.txPower}}%</span></div>\n</md-slider-container><md-input-container flex><label translate=\"EDITAR_STB.STB.AUTORUN\">Apertura al inicio</label>\n<md-select ng-model=\"stb.autorun\" name=\"autorun\"><md-option ng-value=\"null\"><em>[HOME]</em></md-option><md-option \nng-repeat=\"acl in listaAcls track by $index\" value=\"{{acl}}\">{{acl}}</md-option></md-select></md-input-container></div>\n</div></form></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EDITAR_STB.DATOSCLIENTE\">Datos del cliente\n</span><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-accent-fg\" ng-if=\"form2.$invalid\"></md-icon></md-tab-label>\n<md-tab-body><form name=\"form2\"><div class=\"container\"><div layout-gt-sm=\"row\" layout=\"column\" flex><md-input-container\n flex><label translate=\"EDITAR_STB.STB.CLIENTE\">Nombre del cliente</label><input type=\"text\" name=\"nombrecliente\" \nng-model=\"stb.username\" maxlength=\"50\" ng-change=\"stb.properties.displayWelcome = true\"><div \nng-messages=\"form2.nombrecliente.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"maxlength\" \ntranslate=\"EDITAR_STB.STB.LONGITUD\">Longitud máxima.</div></div></md-input-container><md-input-container flex><label \ntranslate=\"EDITAR_STB.STB.IDIOMA\">Idioma</label><md-select ng-model=\"stb.lang\" name=\"idioma\" required \nclass=\"lang-select\"><md-option ng-repeat=\"lang in listaIdiomas\" ng-value=\"lang.idioma\"><img \nng-src=\"{{lang.rutaIcono|replacePath}}\" alt=\"{{lang.idioma}}\" style=\"max-height: 24px\"></md-option></md-select><div \nng-messages=\"form2.idioma.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container></div></div></form>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EDITAR_STB.AVANZADO\">Avanzado</span><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-accent-fg\" ng-if=\"form3.$invalid\"></md-icon></md-tab-label><md-tab-body>\n<form name=\"form3\"><div class=\"container\" layout=\"column\"><div layout-gt-sm=\"row\" layout=\"column\" layout-wrap flex>\n<md-input-container flex flex-gt-sm=\"45\"><label><span translate=\"EDITAR_STB.STB.IP\">IP</span> <em \ntranslate=\"EDITAR_STB.STB.OPCIONAL\">(opcional)</em></label><input type=\"text\" name=\"ip\" ng-model=\"stb.ip\" \nng-pattern=\"ipPattern\"><div class=\"hint\">Ej. 128.1.2.1</div><div ng-messages=\"form3.ip.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div>\n<div ng-message=\"pattern\" translate=\"EDITAR_STB.STB.IPPATTERN\">La IP no tiene el formato correcto.</div></div>\n</md-input-container><md-input-container flex flex-gt-sm=\"45\"><label>MAC</label><input type=\"text\" name=\"mac\" \nng-model=\"stb.mac\" ng-pattern=\"macPattern\" required><div class=\"hint\">Ej. 00:11:22:33:44:55</div><div \nng-messages=\"form3.mac.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"pattern\" \ntranslate=\"EDITAR_STB.STB.MACPATTERN\">La MAC no tiene el formato correcto.</div></div></md-input-container>\n<md-input-container flex flex-gt-sm=\"45\"><label translate=\"EDITAR_STB.STB.CONTROL\">Mando asociado</label><md-select \nng-model=\"stb.control\" name=\"control\"><md-option ng-value=\"null\">-</md-option><md-option \nng-repeat=\"ctr in listaControls track by $index\" ng-value=\"{{ctr.idControl}}\">{{ctr.model}}</md-option></md-select>\n</md-input-container><md-input-container flex flex-gt-sm=\"45\"><label translate=\"EDITAR_STB.STB.IMAGE\">Imagen dinámica\n</label><md-select ng-model=\"stb.dynamicVersion\" name=\"image\" ng-disabled=\"!stb.model\"><md-option ng-value=\"null\">\nLa última ({{dynamicList.defaultItem.name}})</md-option><md-option ng-repeat=\"dyn in dynamicList.completeList\" \nng-value=\"dyn.idItemVersion\">{{dyn.name}}</md-option></md-select></md-input-container><md-checkbox \nng-model=\"stb.updated.forceSystem\" aria-label=\"updateSystem\" flex flex-gt-sm=\"45\"><span \ntranslate=\"EDITAR_STB.STB.ACTSYSTEM\">Actualizar versión del sistema</span><br>(<span translate=\"EDITAR_STB.STB.ACTUAL\">\nactual</span>: <em>{{stb.viewed.lastSystem|| \'-\'}}</em>)</md-checkbox><md-input-container flex flex-gt-sm=\"45\"><label \ntranslate=\"EDITAR_STB.STB.SYSTEM\">Imagen de sistema</label><md-select ng-model=\"stb.systemVersion\" name=\"system\" \nng-disabled=\"!stb.model\"><md-option ng-repeat=\"sys in systemList\" ng-value=\"sys.idItemVersion\">{{sys.name}}</md-option>\n</md-select></md-input-container><md-checkbox ng-model=\"stb.updated.cleanSystem\" aria-label=\"cleanSystem\" flex \nflex-gt-sm=\"45\"><span translate=\"EDITAR_STB.STB.CLEANSYSTEM\">Instalación de sistema desde cero</span></md-checkbox>\n<md-checkbox ng-model=\"stb.properties.pxehw\" aria-label=\"cleanSystem\" flex flex-gt-sm=\"45\"><span \ntranslate=\"EDITAR_STB.STB.PXEHW\">Permitir arranque por PXE Hardware</span></md-checkbox><md-checkbox \nng-model=\"stb.updated.forceBios\" aria-label=\"updateBios\" flex flex-gt-sm=\"45\"><span translate=\"EDITAR_STB.STB.ACTBIOS\">\nActualizar versión de la BIOS</span><br>(<span translate=\"EDITAR_STB.STB.ACTUAL\">actual</span>: <em>\n{{stb.viewed.lastBios|| \'-\'}}</em>)</md-checkbox><md-input-container flex flex-gt-sm=\"45\"><label \ntranslate=\"EDITAR_STB.STB.BIOS\">BIOS</label><md-select ng-model=\"stb.biosVersion\" name=\"system\" \nng-disabled=\"!stb.model\"><md-option ng-value=\"null\">La última ({{biosList.defaultItem.name}})</md-option><md-option \nng-repeat=\"bios in biosList.completeList\" ng-value=\"bios.idItemVersion\">{{bios.name}}</md-option></md-select>\n</md-input-container><md-input-container flex flex-gt-sm=\"45\"><label translate=\"EDITAR_STB.STB.WIFIAP\">WifiAp</label>\n<md-select ng-model=\"stb.properties.wifiAp\" name=\"wifiAp\"><md-option ng-value=\"null\">[Ethernet]</md-option><md-option \nng-repeat=\"ap in listaAp|orderBy:\'name\' track by $index\" ng-value=\"ap.idWiFiAp\">\n{{ap.name}} ({{ap.band}} - {{ap.bssid}})</md-option></md-select></md-input-container><md-input-container flex \nflex-gt-sm=\"45\"><label translate=\"EDITAR_STB.STB.EXTENSION\">Extensión</label><input type=\"text\" \nng-model=\"stb.extension.number\" name=\"extension\"></md-input-container></div></div></form></md-tab-body></md-tab><md-tab\n ng-if=\"JSONconfig.datosDiraya\"><md-tab-label><span translate=\"EDITAR_STB.DATOSDIRAYA\">Datos Diraya</span><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-accent-fg\" ng-if=\"form4.$invalid\"></md-icon></md-tab-label><md-tab-body>\n<form name=\"form4\"><div class=\"container\"><div layout=\"row\" layout-wrap flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>Habitación</label><input type=\"text\" name=\"diraya_room\" ng-model=\"stb.room\" \ndisabled=\"disabled\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>\nInstalación</label><input type=\"text\" name=\"diraya_installation\" ng-model=\"diraya.installation\" disabled=\"disabled\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>Centro</label><input \ntype=\"text\" name=\"diraya_centro\" ng-model=\"diraya.centro\"><div class=\"hint\">Columna <b>CENTRO</b>\n del Excel. Código numérico de 5 cifras</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"33\"><label>Módulo</label><input type=\"text\" name=\"diraya_modulo\" ng-model=\"diraya.modulo\"><div \nclass=\"hint\">Columna <b>Control-DAE-Cod</b> del Excel</div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>Cama</label><input type=\"text\" name=\"diraya_cama\" ng-model=\"diraya.cama\"><div \nclass=\"hint\">Columna <b>Cama-DAE-Cod</b> del Excel</div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>Unidad funcional</label><input type=\"text\" name=\"diraya_unidadfuncional\" \nng-model=\"diraya.unidadfuncional\"><div class=\"hint\">Columna <b>Unidad funcional</b> del Excel</div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\"><label>Código de Unidad</label>\n<input type=\"text\" name=\"diraya_codigounidad\" ng-model=\"diraya.codigounidad\"><div class=\"hint\">\nCódigo numérico que representa la unidad funcional</div></md-input-container></div></div></form></md-tab-body></md-tab>\n</md-tabs><div style=\"color: red; text-align: center\" translate=\"{{mensajeError}}\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"cargando\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"PAQUETES.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form1.$invalid || form2.$invalid || form3.$invalid || cargando\" style=\"margin-right:20px\" \ntranslate=\"EDITAR_STB.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/listado/templates/tableProperties.tmpl.html","<md-dialog id=\"listadoHabitaciones\" aria-label=\"Propiedades tabla\" ng-cloak flex md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"PROPERTIES.TITLE\">Opciones de la tabla</h2></div></md-toolbar>\n<md-dialog-content><md-button class=\"md-raised md-primary\" ng-click=\"setDefault()\" translate=\"PROPERTIES.DEFAULT\">\nPor defecto</md-button><md-button class=\"md-raised md-primary\" ng-click=\"setDefaultVer()\" \ntranslate=\"PROPERTIES.DEFAULTVER\">Checks de versión</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"setDefaultDiraya()\" ng-if=\"JSONconfig.datosDiraya\">Propiedades Diraya</md-button><md-checkbox \nng-model=\"tableOptions[\'showChecks\']\"><span translate=\"PROPERTIES.SHOWCHECKS\"></span></md-checkbox><h3 \ntranslate=\"PROPERTIES.MOSTRAR\">Buscar por...</h3><div layout=\"row\" layout-wrap><md-checkbox \nng-repeat=\"prop in allProperties\" ng-model=\"tableOptions[prop]\"><span translate=\"PROPERTIES.{{::prop}}\">{{::prop}}\n</span></md-checkbox></div><h3 translate=\"PROPERTIES.BUSCARPOR\">Buscar por...</h3><div layout=\"row\" layout-wrap>\n<md-checkbox ng-repeat=\"prop in searchProperties\" ng-model=\"searchOptions[prop]\"><span \ntranslate=\"PROPERTIES.{{::prop}}\">{{::prop}}</span></md-checkbox></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"hide()\" translate=\"CAMBIO.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/mantenimiento/templates/devices.tmpl.html","<md-dialog id=\"devices\" aria-label=\"Dispositivos conectados\" ng-cloak flex flex-sm=\"100\" flex-xs=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MANTENIMIENTO.DEVICES.TITLE\">\nDispositivos conectados</h2></div></md-toolbar><md-dialog-content><table><tr class=\"md-accent-bg\"><th \ntranslate=\"MANTENIMIENTO.DEVICES.HABITACION\">Habitación</th><th translate=\"MANTENIMIENTO.DEVICES.DESTACADOS\">Destacados\n</th><th translate=\"MANTENIMIENTO.DEVICES.TODOS\">Todos</th><th>Conexión de red</th><th>Incidencias</th><th>Preventivas\n</th><th>Hub USB</th></tr><tr ng-repeat=\"hab in listaStbs|orderBy:\'room|tryParseInt\'\"><td>{{::hab.room}}</td><td><span \nng-class=\"{\'grey-fg\': !hab.allList}\">{{hab.usbList|stringifyArray}}</span> <img ng-if=\"!hab.usbList\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"></td><td><a ng-click=\"s = !s\" ng-show=\"hab.allList.length > 0\">\nMostrar / ocultar</a><div style=\"white-space: pre\" ng-show=\"s\">{{hab.allList|stringifyArray:false:\'\\n\'}}</div></td><td>\n<div ng-if=\"hab.ethernet === true\" style=\"color: #EF6C00\">Cable</div><div ng-if=\"hab.ethernet === false\" \nstyle=\"color: #3998c3\">WiFi</div></td><td>{{habIncidencias.includes(hab.room) ? \'Si\' : \'\'}}</td><td>\n{{habPrevents.includes(hab.room) ? \'Si\' : \'\'}}</td><td><md-button class=\"md-icon-button\" \nng-click=\"resetHubUsb(hab.idStb)\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip>Reiniciar Hub</md-tooltip>\n</md-button></td></tr></table></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"loading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"VOIP.EDITAR.CERRAR\">Cerrar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/mantenimiento/templates/intercambiarMac.tmpl.html","<md-dialog id=\"swap-mac\" aria-label=\"Intercambiar MAC\" ng-cloak flex flex-sm=\"100\" flex-xs=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MANTENIMIENTO.SWAPMAC.TITLE\">\nCambiar extensión</h2></div></md-toolbar><md-dialog-content><form name=\"Form\" layout=\"column\" layout-gt-sm=\"row\"><div \nflex><md-autocomplete md-input-name=\"auto1\" md-input-minlength=\"0\" md-selected-item=\"stb1\" md-search-text=\"src1\" \nmd-items=\"item in querySearch(src1)|orderBy:\'room\'\" md-item-text=\"item.room\" md-min-length=\"0\" md-require-match \nrequired md-floating-label=\"{{\'MANTENIMIENTO.SWAPMAC.STB1\'|translate}}\" md-no-cache=\"true\" md-select-on-match=\"true\">\n<md-item-template><span md-highlight-text=\"src1\">{{item.room}} - {{item.username}} ({{item.ip}} | {{item.mac}})</span>\n</md-item-template></md-autocomplete><span ng-if=\"stb1\">{{stb1.room}} - {{stb1.username}} ({{stb1.ip}} | {{stb1.mac}})\n</span></div><md-icon md-font-icon=\"icon-swap-horizontal\" class=\"swap-icon margin-16\" hide show-gt-sm></md-icon>\n<md-icon md-font-icon=\"icon-swap-vertical\" class=\"swap-icon margin-top-8 margin-bottom-8\" hide-gt-sm></md-icon><div \nflex><md-autocomplete md-input-name=\"auto2\" md-input-minlength=\"0\" md-selected-item=\"stb2\" md-search-text=\"src2\" \nmd-items=\"item in querySearch(src2)|orderBy:\'room\'\" md-item-text=\"item.room\" md-min-length=\"0\" md-require-match \nrequired md-floating-label=\"{{\'MANTENIMIENTO.SWAPMAC.STB2\'|translate}}\" md-no-cache=\"true\" md-select-on-match=\"true\">\n<md-item-template><span md-highlight-text=\"src2\">{{item.room}} - {{item.username}} ({{item.ip}} | {{item.mac}})</span>\n</md-item-template></md-autocomplete><span ng-if=\"stb2\">{{stb2.room}} - {{stb2.username}} ({{stb2.ip}} | {{stb2.mac}})\n</span></div></form><div style=\"color: red\">{{mensajeError}}</div></md-dialog-content><md-dialog-actions layout=\"row\">\n<img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"VOIP.EDITAR.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"!stb1 || !stb2\" \nstyle=\"margin-right:20px\" translate=\"VOIP.EDITAR.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/mantenimiento/templates/updates.tmpl.html","<md-dialog id=\"updates\" aria-label=\"Actualizaciones\" flex=\"100\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MANTENIMIENTO.UPDATES.TITLE\">Actualizaciones</h2></div></md-toolbar>\n<md-dialog-content class=\"padding-0\"><form><md-chips ng-model=\"screens\" md-autocomplete-snap md-require-match=\"true\">\n<md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in querySearch(searchText)\" md-item-text=\"item\" md-input-minlength=\"0\" md-min-length=\"0\" \nplaceholder=\"Filtrar por pantalla\"><span md-highlight-text=\"searchText\">{{item}}</span></md-autocomplete>\n<md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></form><table><thead><tr class=\"md-accent-bg\">\n<th></th><th translate=\"MANTENIMIENTO.UPDATES.HABITACION\">Habitación</th><th \ntranslate=\"MANTENIMIENTO.UPDATES.ULTPANTALLA\">Última pantalla</th><th><span translate=\"MANTENIMIENTO.UPDATES.DYNAMIC\">\nImg. dinámica</span><md-tooltip md-direction=\"top\">Rojo: versión asignada distinta a la instalada</md-tooltip></th><th \nclass=\"clickable\"><md-menu><div ng-click=\"$mdOpenMenu()\"><span translate=\"MANTENIMIENTO.UPDATES.ACTDYNAMIC\">\nAsignar últ. ver. din.</span><md-tooltip md-direction=\"top\">Marcado: Asigna al STB la imagen dinámica del modelo.\n</md-tooltip></div><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"marcarActualizarVersionDinamica()\">\nMarcar todos los rojos</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"marcarActualizarVersionDinamica(true)\">Marcar rojos coincidiendo con pantalla</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"marcarActualizarVersionDinamicaStorage()\">Marcar almacenados</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"desmarcarActualizarVersionDinamica()\">Desmarcar toda la columna\n</md-button></md-menu-item></md-menu-content></md-menu></th><th class=\"clickable\"><md-menu><div \nng-click=\"$mdOpenMenu()\"><span translate=\"MANTENIMIENTO.UPDATES.ACTDYNAMICAHORA\">Actualizar ahora</span><md-tooltip \nmd-direction=\"top\">Marcado: Se hace la llamada /dynamic, y se descargará la nueva imagen progresivamente</md-tooltip>\n</div><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"marcarActualizarAhora()\">Marcar todos los rojos\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"marcarActualizarAhora(true)\">Marcar comparando pantalla\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"marcarActualizarAhoraStorage()\">Marcar almacenados\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"desmarcarActualizarAhora()\">Desmarcar toda la columna\n</md-button></md-menu-item></md-menu-content></md-menu></th><th translate=\"MANTENIMIENTO.UPDATES.SYSTEM\">Img. sistema\n</th><th class=\"clickable\"><md-menu><div ng-click=\"$mdOpenMenu()\"><span \ntranslate=\"MANTENIMIENTO.UPDATES.FORCEACTSYSTEM\">Forzar act. img. sistema</span><md-tooltip md-direction=\"top\">\nMarcado: Equivale al check \'Actualizar versión del sistema\' al editar</md-tooltip></div><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"marcarForzarActualizacionSistema()\">Marcar todos los rojos</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"marcarForzarActualizacionSistema(true)\">\nMarcar rojos coincidiendo con pantalla</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"marcarForzarActualizacionSistemaStorage()\">Marcar almacenados</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"desmarcarForzarActualizacionSistema()\">Desmarcar toda la columna</md-button></md-menu-item>\n</md-menu-content></md-menu></th><th class=\"clickable\"><md-menu><div ng-click=\"$mdOpenMenu()\"><span \ntranslate=\"MANTENIMIENTO.UPDATES.CLEANSYSTEM\">Inst. desde cero</span></div><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"marcarInstCero()\">Marcar todos los rojos</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"marcarInstCero(true)\">Marcar rojos coincidiendo con pantalla</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"marcarInstCeroStorage()\">Marcar almacenados</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"desmarcarInstCero()\">Desmarcar toda la columna</md-button></md-menu-item></md-menu-content></md-menu></th><th\n translate=\"MANTENIMIENTO.UPDATES.ULTSYSTEM\">Img. sistema de modelo</th><th class=\"clickable\"><md-menu><div \nng-click=\"$mdOpenMenu()\"><span translate=\"MANTENIMIENTO.UPDATES.ACTSYSTEM\">Asignar últ. ver. sis.</span><md-tooltip \nmd-direction=\"top\">Marcado: Asigna al STB la imagen de sistema del modelo.</md-tooltip></div><md-menu-content \nwidth=\"4\"><md-menu-item><md-button ng-click=\"marcarAsignarUltimaVersionSistema()\">Marcar todos los rojos</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"marcarAsignarUltimaVersionSistema(true)\">\nMarcar rojos coincidiendo con pantalla</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"marcarAsignarUltimaVersionSistemaStorage()\">Marcar almacenados</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"desmarcarAsignarUltimaVersionSistema()\">Desmarcar toda la columna</md-button></md-menu-item>\n</md-menu-content></md-menu></th><th class=\"clickable\"><md-menu><div ng-click=\"$mdOpenMenu()\"><span \ntranslate=\"MANTENIMIENTO.UPDATES.REINICIAR\">Reiniciar</span><md-tooltip md-direction=\"top\">\nSe reiniciarán los marcados progresivamente cada cierto tiempo.</md-tooltip></div><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"marcarReinicio()\">Marcar si tiene forzar act. img. sistema \"true\"</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"marcarReinicio(true)\">\nMarcar si tiene forzar act. img. sistema \"true\" y coincide pantalla</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"marcarReinicioStorage()\">Marcar almacenados</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"desmarcarReinicio()\">Desmarcar toda la columna</md-button></md-menu-item></md-menu-content></md-menu></th>\n</tr></thead><tbody id=\"table-content\"></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"inProgress\" src=\"/assets/quantionImagenes/cargando.gif\"> <span style=\"margin: 0 12px\" id=\"contador\"></span>\n<md-checkbox ng-model=\"randomizarStbs\" style=\"margin-bottom: 0; margin-right: 18px\">Aleatorizar proceso</md-checkbox>\n<div><label>Intervalo entre peticiones (en segundos)</label><input type=\"number\" ng-model=\"intervaloDynamicReinicios\">\n</div><md-button ng-click=\"hide()\" translate=\"VOIP.EDITAR.CERRAR\">Cerrar</md-button><md-button ng-click=\"enviar()\" \ntranslate=\"MANTENIMIENTO.UPDATES.ENVIAR\" ng-disabled=\"inProgress\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/unprovisioned/templates/tableProperties.tmpl.html","<md-dialog id=\"listadoHabitaciones\" aria-label=\"Propiedades tabla\" ng-cloak flex md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"PROPERTIES.TITLE\">Opciones de la tabla</h2></div></md-toolbar>\n<md-dialog-content><md-button class=\"md-raised md-primary\" ng-click=\"setDefault()\" translate=\"PROPERTIES.DEFAULT\">\nPor defecto</md-button><h3 translate=\"PROPERTIES.MOSTRAR\">Buscar por...</h3><div layout=\"row\" layout-wrap><md-checkbox \nng-repeat=\"prop in allProperties\" ng-model=\"tableOptions[prop]\"><span translate=\"PROPERTIES.{{::prop}}\">{{::prop}}\n</span></md-checkbox></div><h3 translate=\"PROPERTIES.BUSCARPOR\">Buscar por...</h3><div layout=\"row\" layout-wrap>\n<md-checkbox ng-repeat=\"prop in searchProperties\" ng-model=\"searchOptions[prop]\"><span \ntranslate=\"PROPERTIES.{{::prop}}\">{{::prop}}</span></md-checkbox></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"hide()\" translate=\"CAMBIO.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/voip/templates/editarDiary.tmpl.html","<md-dialog id=\"paquetes\" aria-label=\"Crear paquete\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{::(tituloVentana|translate)}}</h2></div>\n</md-toolbar><md-dialog-content><form name=\"crearPaqueteForm\" layout=\"row\" layout-wrap \nlayout-align=\"space-around start\"><div flex-gt-sm=\"60\" flex=\"100\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nclass=\"pest\"><md-tab ng-repeat=\"idioma in idiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.NOMBRE\"></label><input name=\"name{{idioma.idioma}}\" \nng-model=\"diary.nameInt[idioma.idioma]\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.DESCRIPCION\"></label><textarea style=\"height: 80px\" \nname=\"description{{idioma.idioma}}\" ng-model=\"diary.descriptionInt[idioma.idioma]\" md-maxlength=\"400\" rows=\"5\" \nmd-select-on-focus></textarea></md-input-container><span class=\"hint md-primary-fg\" style=\"white-space: pre-line\">\n{{\'VOIP.MODALEDITARDIARY.HINT\'|translate}}<ng-container ng-repeat=\"gr in listaGrupos\">{{gr}},</ng-container></span>\n</md-tab-body></md-tab></md-tabs></div><div layout=\"column\" flex-gt-sm=\"30\" flex=\"100\"><md-input-container><label \ntranslate=\"VOIP.MODALEDITARDIARY.LOGO\">Logo</label><md-select ng-model=\"diary.logo\"><md-option \nng-repeat=\"logo in listaLogos\" value=\"{{logo.path}}\"><img ng-src=\"{{logo.path | replacePath}}\" alt=\"\" \nstyle=\"height: 44px\"></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"VOIP.MODALEDITARDIARY.NUM\">Número</label><input name=\"number\" \nng-model=\"diary.number\"></md-input-container><md-checkbox ng-model=\"diary.visible\" aria-label=\"activo\" \nclass=\"margin-top-16\"><span translate=\"VOIP.MODALEDITARDIARY.VISIBLE\">Visible</span></md-checkbox><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"VOIP.MODALEDITARDIARY.ORDEN\">Orden</label><input name=\"number\" \nng-model=\"diary.orden\"></md-input-container></div></form><div style=\"color: red; text-align: center\">{{mensajeError}}\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"guardar()\" ng-disabled=\"crearPaqueteForm.$invalid || dataLoading\" style=\"margin-right:20px\" \ntranslate=\"PAQUETES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/voip/templates/editarExtension.tmpl.html","<md-dialog id=\"voip\" aria-label=\"Extension\" ng-cloak style=\"width:500px\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"VOIP.EDITAR.TITLE\">Cambiar extensión</h2></div></md-toolbar><md-dialog-content>\n<form name=\"Form\"><md-input-container class=\"md-block\"><label translate=\"VOIP.IDEXTENSION\">Identificador</label><input \nname=\"identificador\" ng-model=\"extension.usuario\" required><div ng-messages=\"Form.identificador.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"VOIP.EDITAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"VOIP.EXTENSION\">Extensión</label><input name=\"extension\" ng-model=\"extension.number\" required><div \nng-messages=\"Form.extension.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"VOIP.EDITAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"VOIP.CONTRASENA\">Contraseña</label><input name=\"extensionPwd\" \nng-model=\"extension.password\" required><div ng-messages=\"Form.extensionPwd.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"VOIP.EDITAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"VOIP.TIPOEXTENSION\">Tipo</label><md-select \nng-model=\"extension.type\"><md-option ng-repeat=\"type in [\'PRE\',\'FREE\',\'POST\']\" value=\"{{type}}\"><span \ntranslate=\"VOIP.TIPO.{{type}}\"></span></md-option></md-select></md-input-container></form><div style=\"color: red\">\n{{mensajeError}}</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"VOIP.EDITAR.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"Form.$invalid || Form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"VOIP.EDITAR.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/voip/templates/editarExtensionStb.tmpl.html","<md-dialog id=\"voip\" aria-label=\"Extension\" ng-cloak style=\"width:500px\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"VOIP.EDITAR.TITLE\">Cambiar extensión</h2></div></md-toolbar><md-dialog-content>\n<form name=\"Form\"><md-input-container class=\"md-block\"><label translate=\"VOIP.EXTENSION\">Extensión</label><input \nname=\"extension\" ng-model=\"stb.extension.number\" required ng-change=\"stb.extension.usuario = stb.extension.number\"><div\n ng-messages=\"Form.extension.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"VOIP.EDITAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"VOIP.CONTRASENA\">Contraseña</label><input name=\"extensionPwd\" \nng-model=\"stb.extension.password\" required><div ng-messages=\"Form.extensionPwd.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"VOIP.EDITAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"VOIP.TIPOEXTENSION\">Tipo</label><md-select \nng-model=\"stb.extension.type\"><md-option ng-repeat=\"type in [\'PRE\',\'FREE\',\'POST\']\" value=\"{{type}}\"><span \ntranslate=\"VOIP.TIPO.{{type}}\"></span></md-option></md-select></md-input-container></form><div style=\"color: red\">\n{{mensajeError}}</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"VOIP.EDITAR.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"Form.$invalid || Form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"VOIP.EDITAR.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/voip/templates/knocks.tmpl.html","<md-dialog id=\"knocks\" aria-label=\"Knocks\" flex md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2 translate=\"VOIP.KNOCKS.TITLE\">Listado de llamadas</h2></div></md-toolbar><md-dialog-content flex><form \nname=\"busquedaForm\" layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"no-errors-spacer\">\n<label><span translate=\"VOIP.KNOCKS.BUSCAREXTENSION\">Buscar por extensión</span></label><input \nng-model=\"busqueda.extension\"></md-input-container><div layout=\"column\"><label class=\"hint\">Inicio</label><input \ntype=\"date\" ng-model=\"busqueda.ini\" required></div><div layout=\"column\"><label class=\"hint\">Fin</label><input \ntype=\"date\" ng-model=\"busqueda.fin\" required></div><md-button class=\"md-fab md-mini\" ng-click=\"buscar()\" \nng-disabled=\"busquedaForm.$invalid\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"VOIP.KNOCKS.BUSCAR\">Buscar</span></md-tooltip></md-button></form><table \nng-show=\"listaLlamadas.length > 0\"><tr class=\"md-accent-bg\"><th translate=\"VOIP.KNOCKS.FECHA\">Fecha / hora</th><th \ntranslate=\"VOIP.KNOCKS.DURACION\">Duración</th><th translate=\"VOIP.KNOCKS.ORIGEN\">Origen</th><th \ntranslate=\"VOIP.KNOCKS.DESTINO\">Destino</th><th translate=\"VOIP.KNOCKS.COSTE\">Coste</th><th \ntranslate=\"VOIP.KNOCKS.TARIFA\">Tarifa</th><th translate=\"VOIP.KNOCKS.STATUS\">Estado</th></tr><tr \nng-repeat=\"knock in listaLlamadas\"><td>{{::knock.ini|date:\'dd/MM/yyyy HH:mm\'}}</td><td>\n{{::(knock.fin - knock.ini)/1000|convertSeconds:true}}</td><td>{{::knock.extension}}</td><td>{{::knock.destiny}}</td>\n<td>{{::knock.amount}}€</td><td>{{::knock.tarification.price}}€/min.</td><td>\n{{::knock.status|| \'Respondida correctamente\'}}</td></tr></table><h3 style=\"color: red\" \nng-show=\"listaLlamadas.length < 1\">No hay llamadas registradas</h3></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"hide()\" translate=\"VOIP.EDITAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/voip/templates/tarifas.tmpl.html","<md-dialog id=\"tarifas\" aria-label=\"Tarifas\" flex style=\"height: 90vh\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"VOIP.TARIFAS.TITLE\">Tarifas</h2></div></md-toolbar><md-dialog-content flex>\n<md-button class=\"md-fab md-mini md-warn\" ng-click=\"addTarifa()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><div layout=\"row\" layout-wrap><div ng-repeat=\"tarifa in listaTarifas\" class=\"tarifa layout-row\"><div><h3>\n{{::tarifa.description|formatNameDesc}}</h3><h1>{{::tarifa.price}} <span translate=\"VOIP.TARIFAS.PORMINUTO\">€/minuto\n</span></h1><h4>{{::tarifa.pattern}} ({{::tarifa.asterisk ? \'Asterisk\' : \'Java\'}})</h4></div><div layout=\"column\">\n<md-button class=\"md-icon-button\" aria-label=\"Editar\" ng-click=\"editarTarifa(tarifa)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Eliminar\" \nng-click=\"eliminarTarifa(tarifa)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><md-icon \nmd-font-icon=\"icon-eye\" ng-if=\"tarifa.visible\" style=\"color: lightseagreen\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-if=\"!tarifa.visible\" style=\"color: lightgray\"></md-icon></div></div></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\"><md-toolbar class=\"md-accent-bg\"></md-toolbar>\n<md-content layout-padding><form name=\"formTarifa\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" flex><md-tab \nng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"SERVICIOS.CALENDAR.DESCRIPCION\">Descripción</label><input ng-model=\"tarifa.description[idioma.idioma]\">\n</md-input-container></md-tab-body></md-tab></md-tabs><md-input-container class=\"md-icon-float md-icon-right md-block\">\n<label translate=\"VOIP.TARIFAS.PRECIOMINUTO\">Precio (por minuto)</label><input ng-model=\"tarifa.price\" type=\"number\" \nstep=\"0.01\" required><md-icon md-font-icon=\"icon-currency-eur\"></md-icon></md-input-container><div \nclass=\"layout-row layout-align-center-center\"><span>Java</span><md-switch ng-model=\"tarifa.asterisk\" \naria-label=\"Asterisk\"></md-switch><span>Asterisk</span></div><md-input-container class=\"md-block\"><label \ntranslate=\"VOIP.TARIFAS.PATTERN\">Expresión regular</label><input ng-model=\"tarifa.pattern\" required> <a \nhref=\"http://www.axelko.com/techblog/2013/11/curso-asterisk-iv-el-dialplan/\" target=\"blank\">+ Mas info (Asterisk)</a> \n<a href=\"https://docs.oracle.com/javase/tutorial/essential/regex/bounds.html\" target=\"blank\">+ Mas info (Java)</a>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"tarifa.visible\" aria-label=\"Visible\">\n<span translate=\"VOIP.TARIFAS.VISIBLE\">Visible</span></md-checkbox></md-input-container><md-button \nclass=\"md-raised md-primary\" translate=\"VOIP.EDITAR.GUARDAR\" ng-click=\"guardar()\" ng-disabled=\"formTarifa.$invalid\">\nGUARDAR</md-button></form></md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"VOIP.EDITAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/wallets/templates/crearwallet.tmpl.html","<md-dialog id=\"wallets\" aria-label=\"Crear wallet\" ng-cloak style=\"width:500px\" md-theme=\"{{$root.theme}}\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 translate=\"WALLETS.REGISTRAR\">Registrar monedero</h2></div></md-toolbar>\n<md-dialog-content><form name=\"Form\" ng-submit=\"guardar()\"><md-input-container class=\"md-block\"><label \ntranslate=\"WALLETS.UUID\">UUID</label><input id=\"uuid\" name=\"uuid\" ng-model=\"wallet.uuidVirtualWallet\" required \nautofocus></md-input-container><md-checkbox ng-model=\"wallet.logoutOnDisconnect\"><span \ntranslate=\"WALLETS.LOGOUTONDISCONNECT\">Desasociar del terminal al retirar tarjeta</span></md-checkbox></form><span \nng-if=\"!loading\" style=\"color: red\">{{mensajeError}}</span></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"WALLETS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"Form.$invalid || Form.$pristine\" style=\"margin-right:20px\" translate=\"WALLETS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/wallets/templates/listaChecks.tmpl.html","<md-dialog id=\"lista-check-in-out\" aria-label=\"Lista check in/out\" ng-cloak flex md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"WALLETS.LISTACHECKS\">Vincular monedero a un STB</h2></div>\n</md-toolbar><md-dialog-content><div><md-input-container><span translate=\"WALLETS.MOSTRAR\">Mostrar</span><md-select \nng-model=\"pageSize\" ng-change=\"refresh()\"><md-option ng-value=\"v\" ng-repeat=\"v in [5, 10, 25, 50, 100]\">{{v}}\n</md-option></md-select></md-input-container><md-input-container><span translate=\"WALLETS.TIPOCHECK\">Tipo de check\n</span><md-select ng-model=\"checkType\" ng-change=\"refresh()\"><md-option ng-value=\"null\"></md-option><md-option \nvalue=\"In\">Check-in</md-option><md-option value=\"Out\">Check-out</md-option></md-select></md-input-container></div>\n<table><tr><th translate=\"WALLETS.FECHAHORA\">Fecha</th><th translate=\"WALLETS.CHECK\">Check</th><th \ntranslate=\"WALLETS.STBASOCIATED\">Habitación</th><th>Nombre</th></tr><tr ng-repeat=\"check in listaChecks\" \nclass=\"{{check.checkType === \'In\' ? \'md-green-A100-bg\' : \'md-red-A100-bg\'}}\"><td>{{check.date|date:\'dd-MM-yyyy HH:mm\'}}\n</td><td>{{check.checkType}}</td><td>{{check.room}}</td><td>{{check.name}}</td></tr></table></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"WALLETS.CERRAR\" style=\"margin-right:20px\">Cerrar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Quantion/habitaciones/wallets/templates/vinculaStb.tmpl.html","<md-dialog id=\"vincularStb\" aria-label=\"Vincular STB\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{(title || \'WALLETS.VINCULAR.TITLE\') | translate}}</h2></div></md-toolbar>\n<md-dialog-content><md-input-container class=\"md-icon-float md-block no-errors-spacer\"><label \ntranslate=\"CAMBIO.BUSCAR\">Buscar</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"searchText\" \ntype=\"text\" style=\"background: none\"></md-input-container><md-radio-group ng-model=\"stbSelected\" \nclass=\"layout-row layout-align-start-center layout-wrap\"><md-radio-button ng-value=\"stb\" \nng-repeat=\"stb in listaStbs|filter:searchText\" flex=\"100\" flex-gt-xs=\"45\" flex-gt-sm=\"30\" flex-gt-md=\"20\">\n{{stb.room}} - {{stb.username}}</md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions layout=\"row\">\n<img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"WALLETS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"Form.$invalid || Form.$pristine\" style=\"margin-right:20px\" translate=\"WALLETS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/estadisticas/instantanea/templates/asignarStb.tmpl.html","<md-dialog id=\"instantanea\" aria-label=\"Asignar Stbs\" ng-cloak flex=\"95\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"></div></md-toolbar><md-dialog-content><div \nclass=\"margin-bottom-15\" layout=\"row\" layout-wrap><md-button class=\"md-raised md-primary\" ng-click=\"selectAll(true)\" \ntranslate=\"GRUPOSSTB.SELECCIONARTODO\">Seleccionar todo</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"selectAll(false)\" translate=\"GRUPOSSTB.DESELECCIONARTODO\">Deseleccionar todo</md-button></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-wrap><div class=\"groupContainer\" ng-repeat=\"grupo in listaGrupos\" \nlayout=\"column\"><div class=\"groupHeader\" layout=\"row\" layout-align=\"center-center\"><div flex>{{grupo.nombre}} <span \nng-if=\"grupo.place\">({{grupo.place}})</span></div><md-button class=\"md-icon-button md-primary\" \nng-click=\"marcarGrupo(grupo, true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div class=\"groupBody\" \nlayout=\"row\" layout-wrap><div ng-repeat=\"stb in grupo.cStbs\" \nclass=\"stb-container layout-row layout-align-center-center\" \nng-click=\"range ? selectRange($index, grupo.idStbGroup) : toggle(stb.mac, selectedStbs)\" \nng-class=\"{\'checked\':exists(stb.mac, selectedStbs), \'range-ini\': rangeIni === $index}\"><md-icon md-font-icon \nclass=\"{{exists(stb.mac, selectedStbs) ? \'icon-checkbox-marked-circle\' : \'icon-checkbox-blank-circle\'}}\"></md-icon>\n<span>{{stb.room}}</span></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"hide()\" translate=\"GRUPOSSTB.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/controls/templates/edit.tmpl.html","<md-dialog id=\"controls\" aria-label=\"Acciones\" md-theme=\"{{$root.theme}}\" flex-xs=\"100\" flex-sm=\"100\" flex><form \nname=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"></div></md-toolbar><md-dialog-content style=\"min-height: 320px\">\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"CONTROLS.NOMBRE\">Nombre de la tarea</label>\n<input ng-model=\"control.model\" name=\"model\" required><div ng-messages=\"form.model.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container><table><tr><th translate=\"CONTROLS.ORIGEN\">Tecla origen</th><th></th><th \ntranslate=\"CONTROLS.DESTINO\">Tecla destino</th><th></th></tr><tr ng-repeat=\"k in control.keyboardkeys\"><td><input \nng-model=\"k.key1\"></td><td><div><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></div></td><td><input \nng-model=\"k.key2\" ng-keyup=\"keyUp($event, $index)\"></td><td><div><md-button class=\"md-icon-button md-accent margin-0\" \naria-label=\"Remove\" ng-click=\"deleteRow($index)\"><md-icon md-font-icon=\"icon-minus-circle\"></md-icon></md-button></div>\n</td></tr><tr><td><div><md-button class=\"md-icon-button md-accent margin-0\" aria-label=\"Add\" ng-click=\"addRow()\">\n<md-icon md-font-icon=\"icon-plus-circle\"></md-icon></md-button></div></td></tr></table></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" \nng-disabled=\"form.$invalid\" style=\"margin-right:20px\" translate=\"IDIOMAS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/root/encuestas/templates/creareditarencuesta.tmpl.html","<md-dialog id=\"editarEncuesta\" aria-label=\"Crear encuesta\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"editarEncuesta.{{DialogTitle}}\">\n{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content layout-gt-xs=\"row\" layout-align-gt-xs=\"start start\"><div \nclass=\"image-container\"><img ng-src=\"{{survey.img|replacePath}}\" ng-click=\"elegirImagen($event)\" \nsrc=\"/assets/quantionImagenes/click.gif\"><md-tooltip><span translate=\"editarEncuesta.elegirimagen\">Elegir imagen</span>\n</md-tooltip></div><form name=\"form\" novalidate layout=\"column\" flex><md-input-container class=\"md-block\" md-no-float>\n<label translate=\"editarEncuesta.nombre\">Nombre</label><input name=\"nombre\" ng-model=\"survey.name\" required \nmd-maxlength=\"255\"><div ng-messages=\"form.nombre.$error\"><div ng-message=\"required\" \ntranslate=\"editarEncuesta.required\">Este campo es obligatorio.</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"45\"><label translate=\"editarEncuesta.idioma\">Idioma</label><md-select ng-model=\"survey.lang\" \nname=\"idioma\" required class=\"lang-select\"><md-option ng-repeat=\"lang in listaIdiomas\" value=\"{{lang.idioma}}\"><img \nng-src=\"{{lang.rutaIcono|replacePath}}\" alt=\"{{lang.idioma}}\" style=\"max-height: 24px\"></md-option></md-select><div \nng-messages=\"form.idioma.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"editarEncuesta.required\">Este campo es obligatorio.</div></div></md-input-container></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span ng-if=\"imgUploading\" translate=\"editarEncuesta.subiendo\">\nSubiendo imagen</span> <span ng-if=\"dataLoading\" translate=\"editarEncuesta.enviando\">Enviando datos></span> <img \nng-if=\"dataLoading || imgUploading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"editarEncuesta.cerrar\">Cerrar</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" \nstyle=\"margin-right:20px\" translate=\"editarEncuesta.guardar\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/encuestas/templates/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenCanal\" aria-label=\"Elegir imagen\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-dialog-content><md-button class=\"md-raised md-primary\" aria-label=\"Upload\" \nng-click=\"upload()\"><span translate=\"FILEEXPLORER.SUBIRARCHIVO\">Subir archivo</span></md-button><input type=\"file\" \nid=\"uploadFile\" hidden><div layout=\"row\" layout-wrap layout-align=\"center center\"><div \nng-repeat=\"img in listaImagenes\" layout=\"column\" layout-align=\"center center\" class=\"element\"><img \nng-src=\"{{::img.path|replacePath}}\" ng-click=\"escogerImagen(img.path)\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"hide()\" translate=\"CREAR.CERRAR\">Cerrar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/encuestas/templates/estadisticas.tmpl.html","<md-dialog id=\"respuestasEncuesta\" aria-label=\"Respuestas encuesta\" ng-cloak flex md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"preguntas.respuestas\">Respuestas</h2></div></md-toolbar>\n<md-dialog-content><div ng-repeat=\"(i,resp) in o track by $index\"><p>{{$index + 1}} - {{listaQuestions[i].question}}\n</p><div class=\"bar-container layout-row layout-align-start-stretch\"><div \nng-repeat=\"t in resp.data| orderBy: \'-percent\'\" style=\"width: {{t.percent}}%; background: {{colorList[$index]}}\" \nclass=\"bar\">{{t.key}}: {{t.y}} ({{t.percent|number: 2}}%)</div></div><md-divider style=\"margin-top: 8px\"></md-divider>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"preguntas.cerrar\">Cerrar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/encuestas/templates/preguntas.tmpl.html","<md-dialog id=\"preguntasEncuesta\" aria-label=\"Preguntas encuesta\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"preguntas.preguntas\">Preguntas</h2>\n</div></md-toolbar><md-dialog-content layout=\"row\"><md-content class=\"question-list md-primary-bg\" ms-scroll><div \nclass=\"element layout-row layout-align-center-center\" ng-class=\"{\'md-accent-bg\': $index === indexSelected}\" \nng-repeat=\"question in survey.questions\"><div ng-click=\"selectQuestion(question, $index)\" flex><span \ntranslate=\"preguntas.pregunta\">Pregunta</span> {{$index + 1}}</div><md-icon md-font-icon=\"icon-close\" \nng-click=\"deleteQuestion($index)\" class=\"white-fg\"></md-icon></div><md-button class=\"md-fab md-mini\" \nng-click=\"addQuestion()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span \ntranslate=\"preguntas.nuevaPregunta\">Añadir pregunta</span></md-tooltip></md-button></md-content><md-content ms-scroll \nflex><h3 ng-show=\"!questionSelected\" translate=\"preguntas.nuevaPreguntaHelp\">\n&LeftArrow; Pulsa aquí para añadir una pregunta</h3><form ng-show=\"questionSelected\"><div layout=\"row\" \nlayout-align=\"start center\"><img \nng-src=\"{{(questionSelected.img|replacePath) || \'assets/quantionImagenes/no-image.png\'}}\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"elegirImagen($event, questionSelected)\" translate=\"editarEncuesta.elegirimagen\">\nElegir imagen</md-button></div><md-input-container class=\"md-block\" md-no-float><label translate=\"preguntas.pregunta\">\nPregunta</label><input name=\"nombre\" ng-model=\"questionSelected.question\" md-maxlength=\"255\"></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label translate=\"preguntas.descripcion\">Descripción</label><input \nname=\"descripcion\" ng-model=\"questionSelected.description\" md-maxlength=\"255\"></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label translate=\"preguntas.mensaje\">Mensaje al completar encuesta</label><input \nname=\"modal\" ng-model=\"questionSelected.modal\" md-maxlength=\"255\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-around\"><md-input-container class=\"md-block\" md-no-float flex><label translate=\"preguntas.tipo\">\nTipo</label><md-select ng-model=\"questionSelected.type\" name=\"tipo\"><md-option ng-repeat=\"type in tiposPregunta\" \nng-value=\"type.key\" translate=\"preguntas.tipos.{{type.text}}\">{{type.text}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"preguntas.servicio\">Servicio asignado</label><md-select\n ng-model=\"questionSelected.idService\" name=\"servicio\"><md-option ng-value=\"0\"><span translate=\"preguntas.ninguno\">\nNinguno</span></md-option><md-option ng-repeat=\"srv in listaServicios|orderBy:\'name|formatNameDesc\'\" \nng-value=\"{{srv.idService}}\">{{::srv.name|formatNameDesc}}</md-option></md-select><div class=\"hint\" \ntranslate=\"preguntas.mensajeAsignacion\">Se asignarán 30 min. de este servicio al completar la encuesta</div>\n</md-input-container></div><md-divider></md-divider><div layout=\"column\" class=\"respuestas\"><div layout=\"row\" \nlayout-align=\"start center\"><h4 class=\"bold\" translate=\"preguntas.respuestas\">Lista de respuestas</h4><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"addResponse(questionSelected)\" \nng-if=\"questionSelected.type === \'Multi\' || questionSelected.type === \'Normal\'\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"right\"><span translate=\"preguntas.nuevaRespuesta\">Añadir respuesta</span>\n</md-tooltip></md-button></div><div ng-repeat=\"resp in questionSelected.responses track by $index\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"questionSelected.type === \'Multi\' || questionSelected.type === \'Normal\'\"><input \nng-model=\"questionSelected.responses[$index]\"><md-button class=\"md-icon-button md-accent\" \nng-click=\"deleteResponse(questionSelected, $index)\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate=\"preguntas.quitarRespuesta\">Quitar respuesta</span></md-tooltip></md-button></div>\n<h4 ng-if=\"questionSelected.type === \'Icons\'\" translate=\"preguntas.emoticonos\">Las respuestas serán emoticonos</h4><h4 \nng-if=\"questionSelected.type === \'Input\'\" translate=\"preguntas.campoTexto\">\nLas respuesta se escribirá en un campo de texto</h4></div></form></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"preguntas.cerrar\">Cerrar</md-button><md-button ng-click=\"Guardar()\" style=\"margin-right:20px\" \ntranslate=\"preguntas.guardar\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/encuestas/templates/respuestas.tmpl.html","<md-dialog id=\"respuestasEncuesta\" aria-label=\"Respuestas encuesta\" ng-cloak flex md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"preguntas.respuestas\">Respuestas</h2></div></md-toolbar>\n<md-dialog-content><div ng-repeat=\"resp in listaRespuestas\"><p>{{resp.fecha|date:\'dd/MM/yyyy HH:mm\'}} - <span \ntranslate=\"preguntas.habitacion\">Habitación</span> {{listaStbs[resp.idStb].room || \'?\'}}</p><ol><li \nng-repeat=\"r in resp.responses\">{{listaQuestions[r.idQuestion].question}}: <span>{{r.response|stringifyArray}}</span>\n</li></ol><md-divider></md-divider></div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"preguntas.cerrar\">Cerrar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gCajeros/templates/arqueos.tmpl.html","<md-dialog id=\"arqueos\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\" translate=\"GCAJEROS.ARQUEOS\">Arqueos</h2><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"arq in data|orderBy:\'idArqueo\'\" ng-class-odd=\"\'odd\'\" class=\"arqueo\" \nlayout=\"row\"><div layout=\"row\" layout-align=\"center center\"><span>{{arq.idArqueo}}</span></div><div layout=\"column\">\n<span><span translate=\"GCAJEROS.APERTURA\">Apertura:</span> {{::arq.apertura|date:\"dd/MM/yy HH:mm\"}}</span> <span><span \ntranslate=\"GCAJEROS.CIERRE\">Cierre:</span> {{::arq.cierre|date:\"dd/MM/yy HH:mm\"}}</span></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/root/gCajeros/templates/crearcajero.tmpl.html","<md-dialog id=\"gCajeros\" aria-label=\"Crear cajero\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{windowTitle}}</h2></div></md-toolbar>\n<md-dialog-content><form name=\"Form\" novalidate><div layout-gt-xs=\"row\" layout-wrap layout-align=\"space-between\" \nclass=\"container\"><md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.NOMBRE\">Nombre</label><input name=\"model\" ng-model=\"cajero.model\" required>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.IP\">IP</label><input name=\"ip\" ng-model=\"cajero.ip\" required></md-input-container>\n<md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label translate=\"GCAJEROS.MODALEDITAR.MAC\">MAC</label><input\n name=\"mac\" ng-model=\"cajero.mac\" required></md-input-container><md-input-container class=\"md-block\" flex \nflex-gt-xs=\"45\"><label translate=\"GCAJEROS.MODALEDITAR.PORT\">Port</label><input name=\"port\" ng-model=\"cajero.port\" \nrequired></md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.DIRECTPORT\">Puerto API</label><input name=\"directPort\" ng-model=\"cajero.directPort\" \nrequired></md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.PHONE\">Teléfono de contacto</label><input name=\"phone\" ng-model=\"cajero.phone\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.VERSION\">Versión</label><input name=\"version\" ng-model=\"cajero.version\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-xs=\"45\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.TYPE\">Tipo</label><md-select ng-model=\"cajero.type\"><md-option></md-option><md-option \nng-repeat=\"t in [\'card\', \'code\', \'sumup\']\" value=\"{{t}}\">{{t}}</md-option></md-select></md-input-container></div>\n<md-checkbox ng-model=\"cajero.synchronizeDatabase\" aria-label=\"Sync Database\" style=\"margin-top: 1em\"><span \ntranslate=\"GCAJEROS.MODALEDITAR.SINCRONIZARBD\">Sincronizar BBDD</span></md-checkbox><div layout=\"row\" layout-wrap \nlayout-align=\"space-between\" class=\"margin-top-15\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"30\">\n<label translate=\"GCAJEROS.MODALEDITAR.BLOCK\">Nº digitos (bloque)</label><input type=\"number\" name=\"block\" \nng-model=\"cajero.block\" min=\"0\" required><div ng-messages=\"Form.block.$error\" multiple=\"multiple\" md-auto-hide=\"false\">\n<div ng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"30\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.ROOM\">Nº digitos (nº hab.)</label><input type=\"number\" name=\"room\" \nng-model=\"cajero.room\" min=\"0\" required><div ng-messages=\"Form.room.$error\" multiple=\"multiple\" md-auto-hide=\"false\">\n<div ng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"30\"><label \ntranslate=\"GCAJEROS.MODALEDITAR.BED\">Nº digitos (cama)</label><input type=\"number\" name=\"bed\" ng-model=\"cajero.bed\" \nmin=\"0\" required><div ng-messages=\"Form.bed.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n</div><div layout=\"column\"><label translate=\"GCAJEROS.MODALEDITAR.FEATURES\">Features</label><md-chips name=\"features\" \nng-model=\"cajero.features\" placeholder=\"{{\'GCAJEROS.MODALEDITAR.CHIPSPLACEHOLDER\'|translate}}\"><md-chip-template>\n<strong>{{$chip}}</strong></md-chip-template></md-chips><div class=\"hint\">\nEj: InzRfid, InzCash, InzCard, InzRc, SpecialCard</div></div><div layout=\"column\" class=\"margin-top-15\"><label \ntranslate=\"GCAJEROS.CHATIDS\">Chat IDs</label><md-chips name=\"chats\" ng-model=\"cajero.chats\" \nplaceholder=\"{{\'GCAJEROS.MODALEDITAR.CHIPSPLACEHOLDER\'|translate}}\"><md-chip-template><strong>{{$chip}}</strong>\n</md-chip-template></md-chips></div><div style=\"color: red; text-align: center; margin-top: 20px\">{{mensajeError}}\n</div></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"GCAJEROS.MODALEDITAR.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"Form.$invalid || Form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"GCAJEROS.MODALEDITAR.GUARDAR\">Registrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gCajeros/templates/cupones.tmpl.html","<md-dialog id=\"cupones\" aria-label=\"day\" ng-cloak md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\" translate=\"GCAJEROS.CUPONESSINUSAR\">Cupones sin usar</h2><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"cupon in data|orderBy:\'-generado\'\" ng-class-odd=\"\'odd\'\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap><span style=\"min-width: 200px\"><span translate=\"GCAJEROS.IDCUPON\">ID cupón:\n</span> {{::cupon.idCupon}}</span> <span><span translate=\"GCAJEROS.GENERADO\">Generado:</span>\n {{::cupon.generado|date:\"dd/MM/yy HH:mm\"}}</span></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/root/gCajeros/templates/mandos.tmpl.html","<md-dialog id=\"mandos\" aria-label=\"day\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\" translate=\"GCAJEROS.MANDOSREGISTRADOS\">Mandos registrados</h2><div \nclass=\"md-dialog-content-body\"><div ng-repeat=\"mando in data|orderBy:\'-lastSeen\'\" ng-class-odd=\"\'odd\'\" class=\"mando\" \nlayout=\"row\"><div layout=\"row\" layout-align-gt-sm=\"center center\" layout-wrap><span>{{mando.uID}}</span> <span \nng-if=\"mando.isAvailable\" style=\"color: green\" translate=\"GCAJEROS.ENCAJERO\">En cajero</span> <span \nng-if=\"!mando.isAvailable\" style=\"color: red\" translate=\"GCAJEROS.FUERACAJERO\">Fuera de cajero</span> <span \nng-if=\"mando.lastSeen\"><span translate=\"GCAJEROS.ULTIMADEVOLUCION\">Última devolución:</span>\n {{::mando.lastSeen|date:\"dd/MM/yy HH:mm\"}}</span> <span ng-if=\"!mando.lastSeen\"><span \ntranslate=\"GCAJEROS.ULTIMADEVOLUCION\">Última devolución:</span> <span translate=\"GCAJEROS.NUNCA\">Nunca</span></span> \n<span><span translate=\"GCAJEROS.PRECIO\">Precio:</span> {{::mando.price}}€</span> <span><span translate=\"GCAJEROS.TIPO\">\nTipo:</span> {{::mando.type}}</span></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/root/gruposStb/templates/asignarStb.tmpl.html","<md-dialog id=\"gruposStb\" aria-label=\"Asignar Stbs\" ng-cloak flex=\"95\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar>\n<md-dialog-content><div ng-if=\"group.idStbGroup !== 1\" class=\"margin-bottom-15\" layout=\"row\" layout-wrap><md-button \nclass=\"md-raised md-primary\" ng-click=\"initRange()\" ng-class=\"{\'md-accent\': range}\" \ntranslate=\"GRUPOSSTB.SELECCIONARRANGO\">Seleccionar rango</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"selectAll(true)\" translate=\"GRUPOSSTB.SELECCIONARTODO\">Seleccionar todo</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"selectAll(false)\" translate=\"GRUPOSSTB.DESELECCIONARTODO\">Deseleccionar todo\n</md-button></div><div layout=\"row\" layout-wrap><div ng-repeat=\"stb in allStbs\" \nclass=\"stb-container layout-row layout-align-center-center\" \nng-click=\"range ? selectRange($index) : toggle(stb.idStb, group.stbs)\" \nng-class=\"{\'checked\':exists(stb.idStb,group.stbs), \'range-ini\': rangeIni === $index}\"><md-icon md-font-icon \nclass=\"{{exists(stb.idStb, group.stbs) ? \'icon-checkbox-marked-circle\' : \'icon-checkbox-blank-circle\'}}\"></md-icon>\n<span>{{stb.room}}</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"GRUPOSSTB.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"GRUPOSSTB.GUARDAR\" ng-if=\"group.idStbGroup !== 1\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gruposStb/templates/creareditargruposStb.tmpl.html","<md-dialog id=\"gruposStb\" aria-label=\"Crear grupo\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><form name=\"form\" novalidate \nlayout=\"column\"><md-input-container class=\"md-block no-errors-spacer\" md-no-float><label \ntranslate=\"GRUPOSSTB.EDITAR.NOMBRE\">Nombre del grupo</label><input name=\"nombre\" ng-model=\"grupo.nombre\" required><div \nng-messages=\"form.nombre.$error\"><div ng-message=\"required\" translate=\"GRUPOSSTB.EDITAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><label translate=\"GRUPOSSTB.EDITAR.PLACE\">Localización\n</label><md-autocomplete md-selected-item=\"grupo.place\" md-search-text=\"searchText\" \nmd-items=\"item in querySearch(searchText)\" md-min-length=\"0\" md-input-minlength=\"0\" class=\"margin-bottom-24\">\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template>\n</md-autocomplete><md-checkbox ng-model=\"grupo.countable\" aria-label=\"countable\"><span \ntranslate=\"GRUPOSSTB.EDITAR.COUNTABLE\"></span><md-tooltip><span translate=\"GRUPOSSTB.EDITAR.COUNTABLETOOLTIP\">\nNo se tendrán en cuenta para cálculos de consumo ni al contar equipos activos/inactivos</span></md-tooltip>\n</md-checkbox><md-input-container class=\"md-block no-errors-spacer\" md-no-float><label \ntranslate=\"GRUPOSSTB.EDITAR.ORDEN\">Orden</label><input name=\"orden\" ng-model=\"grupo.orden\" required type=\"number\"><div \nng-messages=\"form.orden.$error\"><div ng-message=\"required\" translate=\"GRUPOSSTB.EDITAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><div \nstyle=\"color: red; text-align: center; margin-top: 20px\" ng-if=\"mensajeError\" translate=\"{{mensajeError}}\">\n{{mensajeError}}</div></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"GRUPOSSTB.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"GRUPOSSTB.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/servicios.html","<div id=\"servicios\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\"><md-button class=\"md-fab md-mini md-primary\" \nng-click=\"vm.exportServices()\"><md-icon md-font-icon=\"icon-download\" class=\"icon\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.EXPORTAR\">Exportar servicios</span></md-tooltip></md-button><input \ntype=\"file\" id=\"files\" aria-label=\"Seleccionar archivo\" hidden accept=\".json,application/json\"> <input type=\"file\" \nid=\"files_rsc\" aria-label=\"Seleccionar archivo\" hidden accept=\".zip,application/zip\"><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu()\"><md-icon \nmd-menu-origin md-font-icon=\"icon-upload\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.IMPORTARDEARCHIVO\">Importar servicios de archivo</span></md-tooltip></md-button><md-menu-content \nwidth=\"4\"><md-menu-item><md-button ng-click=\"vm.importFile()\"><md-icon md-font-icon=\"icon-upload\" md-menu-align-target>\n</md-icon><span translate=\"SERVICIOS.IMPORTARDEARCHIVO\">Importar servicios de archivo</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.importRecursos()\"><md-icon md-font-icon=\"icon-folder-upload\" \nmd-menu-align-target></md-icon><span translate=\"SERVICIOS.IMPORTARZIP\">Importar recursos de tema</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div><md-button class=\"md-raised md-primary\" \nng-repeat=\"tipo in tiposServicio\" ng-class=\"{\'md-warn\':tipo === selectedType}\" \nng-click=\"selectType(tipo, showGroupedServices)\"><span translate=\"SERVICIOS.TIPOS.{{tipo}}\">{{tipo}}</span>\n ({{vm.listaServicios[tipo].length}})</md-button></div><md-divider></md-divider><div layout=\"row\"><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.ventanaNuevo($event, selectedType)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"SERVICIOS.CREARSERVICIO\">Crear servicio</span> <span \ntranslate=\"SERVICIOS.TIPOS.{{selectedType}}\">{{selectedType}}</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.radioCountries()\" ng-if=\"selectedType === \'onlineradio\'\"><md-icon \nmd-font-icon=\"icon-flag-variant\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.RADIOCOUNTRIES_\">Países de radio online</span></md-tooltip></md-button><div flex layout=\"row\" \nlayout-align=\"end center\"><md-checkbox ng-model=\"showGroupedServices\" \nng-change=\"selectType(selectedType, showGroupedServices)\" class=\"margin-bottom-0\"><span \ntranslate=\"SERVICIOS.CHECKAGRUPAR\">Agrupar servicios por categoría</span></md-checkbox></div></div><md-list \nid=\"service-container\"></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/paquetes.html","<div id=\"paquetes\" class=\"page-layout simple fullwidth\"><div class=\"content\"><md-content layout-padding \nlayout=\"column\" md-whiteframe=\"1\"><div layout=\"row\" style=\"padding-left: 21px; padding-right: 21px\"><h2 flex \nstyle=\"margin: 12px 0\" translate=\"PAQUETES.PAQUETES_TITLE\">Paquetes</h2><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaNuevo($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PAQUETES.CREARPAQUETE\">Crear paquete</span></md-tooltip></md-button><export-to-file \nfilename=\"Backup-Paquetes\" tooltip-text=\"{{\'PAQUETES.EXPORTAR\'|translate}}\" data=\"vm.listaPaquetes\"></export-to-file>\n<md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.importFile()\"><md-icon md-font-icon=\"icon-box-upload\" \nclass=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.IMPORTARDEARCHIVO\">\nImportar paquetes de archivo</span></md-tooltip></md-button><input type=\"file\" id=\"files\" \naria-label=\"Seleccionar archivo\" hidden></div><md-list flex ng-repeat=\"o in vm.groupPaquetes|orderBy:\'key\'\">\n<md-subheader class=\"md-no-sticky md-primary-bg\" ng-hide=\"!o.key\">{{o.key}}</md-subheader><md-list-item \nclass=\"md-3-line paquete\" ng-repeat=\"item in o.value\" ng-dblclick=\"vm.ventanaEditar($event, item)\" flex=\"100\" \non-last-repeat layout-wrap><img ng-src=\"{{item.logo|replacePath}}\" \non-error-image=\"/assets/quantionImagenes/img-error.png\"> <img ng-src=\"{{item.logoFocus|replacePath}}\" \non-error-image=\"/assets/quantionImagenes/img-error.png\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nng-if=\"item.active\"></md-icon><div class=\"md-list-item-text\" layout=\"column\" flex><h3><span \ntranslate=\"PAQUETES.NOMBRE\">Nombre:</span> {{ item.name|formatNameDesc}} ({{item.acl}})</h3><h4><span \ntranslate=\"PAQUETES.DESCRIPCION\">Descripción:</span> {{ item.description|formatNameDesc}}</h4><h4><span \ntranslate=\"PAQUETES.NUMSERVICIOS\">Nº servicios:</span> {{::item.ordinaryServices.length}} <span \nng-if=\"item.promotionalServices.length > 0\">+ {{::item.promotionalServices.length}} <span \ntranslate=\"PAQUETES.PROMOCIONALES\">promocionales</span></span></h4></div><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" flex-sm=\"100\" flex-xs=\"100\"><div><md-menu md-position-mode=\"target-right target\">\n<md-button class=\"md-fab md-mini\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.VERPRECIOSSERVICIOS\">Ver precios y servicios\n</span></md-tooltip></md-button><md-menu-content style=\"max-height: 95vh\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"PAQUETES.SERVICIOS\">Servicios</span></md-subheader><md-menu-item \nng-repeat=\"srv in item.ordinaryServices| orderBy:\'name|formatNameDesc\'\"><h6>\n{{$index + 1}} - {{srv.name|formatNameDesc}}</h6></md-menu-item><md-menu-item ng-if=\"item.ordinaryServices.length < 1\">\n<h6>-</h6></md-menu-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"PAQUETES.SERVICIOSPROMO\">Servicios promocionales</span></md-subheader><md-menu-item \nng-repeat=\"srv in item.promotionalServices| orderBy:\'service.name|formatNameDesc\'\"><h6>\n{{$index + 1}} - {{srv.service.name|formatNameDesc}}</h6></md-menu-item><md-menu-item \nng-if=\"item.promotionalServices.length < 1\"><h6>-</h6></md-menu-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"PAQUETES.PRECIOS\">Precios</span></md-subheader><md-menu-item \nng-repeat=\"prc in item.durationPrice| orderBy:\'duration\'\"><h6>{{prc.duration|convertMinutesInHHMMSS}}: {{prc.price}} €\n</h6></md-menu-item><md-menu-item ng-if=\"item.durationPrice.length < 1\"><h6>-</h6></md-menu-item></md-menu-content>\n</md-menu></div><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaPrecios($event, item)\"><md-icon \nmd-font-icon=\"icon-currency-eur\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.PRECIOS\">Precios\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaAsignarServicioOrdinario($event, item)\"><md-icon md-font-icon=\"icon-library-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.ADDSERVICIOS\">Añadir servicios</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.ventanaAsignarServicioPromo($event, item)\"><md-icon \nmd-font-icon=\"icon-gift\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.ADDSERVICIOPROMO\">\nAñadir servicio promocional</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.ventanaEditar($event, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"PAQUETES.MODIFICARPAQUETE\">Modificar paquete</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarPaquete($event, item)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.ELIMINARPAQUETE\">Eliminar paquete</span>\n</md-tooltip></md-button></div></md-list-item></md-list></md-content><md-content layout-padding layout=\"column\" \nmd-whiteframe=\"1\" class=\"margin-top-16\"><div layout=\"row\" style=\"padding-left: 21px; padding-right: 21px\"><h2 flex \nstyle=\"margin: 12px 0\" translate=\"PAQUETES.GATEWAYS_TITLE\">Pasarelas de pago</h2><md-button class=\"md-fab md-mini\" \nng-click=\"vm.crearGateway($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PAQUETES.CREARGATEWAY\">Crear pasarela de pago</span></md-tooltip></md-button></div><md-list><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.listaGateways\" ng-dblclick=\"vm.editarGateway($event, item)\" flex=\"100\" \non-last-repeat layout-wrap><img ng-src=\"{{item.logo|replacePath}}\" \non-error-image=\"/assets/quantionImagenes/img-error.png\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nng-if=\"item.active\"></md-icon><div class=\"md-list-item-text\" layout=\"column\" flex><h3><span \ntranslate=\"PAQUETES.NOMBRE\">Nombre:</span> {{ item.name|formatNameDesc}}</h3><h4><span \ntranslate=\"PAQUETES.DESCRIPCION\">Descripción:</span> {{ item.description|formatNameDesc}}</h4></div><div layout=\"row\" \nlayout-wrap layout-align=\"center center\" flex-sm=\"100\" flex-xs=\"100\"><md-button class=\"md-fab md-mini\" \nng-click=\"vm.editarGateway($event, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"PAQUETES.MODIFICARGATEWAY\">Modificar pasarela de pago</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" ng-click=\"vm.eliminarGateway($event, item)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"PAQUETES.ELIMINARGATEWAY\">\nEliminar pasarela de pago</span></md-tooltip></md-button></div></md-list-item></md-list></md-content></div></div>");
$templateCache.put("app/main/Quantion/root/instalaciones/templates/creareditarInstalacion.tmpl.html","<md-dialog id=\"instalaciones\" aria-label=\"Crear instalacion\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar>\n<md-dialog-content><form name=\"form\" novalidate layout=\"column\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"no-errors-spacer flex\"><label translate=\"INSTALACIONES.MODALEDITAR.NOMBRE\">Nombre</label>\n<input name=\"nombre\" ng-model=\"installation.name\" required><div ng-messages=\"form.nombre.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"INSTALACIONES.MODALEDITAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><md-input-container class=\"no-errors-spacer flex\"><label \ntranslate=\"INSTALACIONES.MODALEDITAR.CATEGORIA\">Categoria</label><input name=\"categoria\" \nng-model=\"installation.category\"></md-input-container><md-input-container class=\"flex\"><label \ntranslate=\"INSTALACIONES.MODALEDITAR.IDIOMA\">Idioma</label><md-select ng-model=\"installation.language\" name=\"idioma\" \nrequired class=\"lang-select\"><md-option ng-repeat=\"lang in listaIdiomas\" value=\"{{lang.idioma}}\"><img \nng-src=\"{{lang.rutaIcono|replacePath}}\" alt=\"{{lang.idioma}}\" style=\"max-height: 24px\"></md-option></md-select><div \nng-messages=\"form.idioma.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"INSTALACIONES.MODALEDITAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container></div>\n<md-input-container class=\"no-errors-spacer\"><label translate=\"INSTALACIONES.MODALEDITAR.DESCRIPCION\">Descripción\n</label><input name=\"descripcion\" ng-model=\"installation.description\"><div ng-messages=\"form.descripcion.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"INSTALACIONES.MODALEDITAR.REQUIRED\">\nEste campo es obligatorio.</div></div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"INSTALACIONES.MODALEDITAR.TEMA\">Tema</label><md-select ng-model=\"installation.theme\" \nname=\"tema\" required><md-option ng-repeat=\"theme in listaThemes\" value=\"{{theme}}\">{{theme}}</md-option></md-select>\n<div ng-messages=\"form.tema.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"INSTALACIONES.MODALEDITAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n<md-input-container flex><label translate=\"EDITAR_STB.STB.AUTORUN\">Apertura al inicio</label><md-select \nng-model=\"installation.autorun\" name=\"autorun\"><md-option ng-value=\"null\"><em>[HOME]</em></md-option><md-option \nng-repeat=\"acl in listaAcls track by $index\" value=\"{{acl}}\">{{acl}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"EDITAR_STB.STB.CONTROL\">Mando asociado</label><md-select \nng-model=\"installation.control\" name=\"control\"><md-option ng-value=\"null\">-</md-option><md-option \nng-repeat=\"ctr in listaControls track by $index\" ng-value=\"{{ctr.idControl}}\">{{ctr.model}}</md-option></md-select>\n</md-input-container><md-input-container class=\"no-errors-spacer flex\"><label>Brand</label><input name=\"brand\" \nng-model=\"installation.brand\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"INSTALACIONES.MODALEDITAR.WELCOMETYPE\">Tipo de mensaje de bienvenida</label><md-select \nng-model=\"installation.welcomeType\" name=\"welcomeType\"><md-option ng-repeat=\"type in [\'image\', \'video\', \'iframe\']\" \nvalue=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"INSTALACIONES.MODALEDITAR.CHECKTYPE\">Tipo de Check-out</label><md-select \nng-model=\"installation.checkoutType\" name=\"checkoutType\"><md-option ng-repeat=\"type in [\'image\', \'video\', \'iframe\']\" \nvalue=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"INSTALACIONES.MODALEDITAR.LOCKEDTYPE\">Tipo de pantalla de bloqueo</label><md-select \nng-model=\"installation.lockedType\" name=\"lockedType\"><md-option ng-repeat=\"type in [\'image\', \'video\', \'iframe\']\" \nvalue=\"{{type}}\">{{type}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"INSTALACIONES.MODALEDITAR.WELCOMEMESSAGE\">Mensaje de bienvenida</label>\n<textarea ng-model=\"installation.welcomeMessage\" name=\"welcomeMessage\" rows=\"6\"></textarea></md-input-container>\n<md-input-container flex><label translate=\"INSTALACIONES.MODALEDITAR.CHECKMESSAGE\">Mensaje de check-out</label>\n<textarea ng-model=\"installation.checkoutMessage\" name=\"checkoutMessage\" rows=\"6\"></textarea></md-input-container>\n</div></form></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"INSTALACIONES.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/instalaciones/templates/importInstalaciones.tmpl.html","<md-dialog id=\"import-instalaciones\" aria-label=\"Importar instalaciones de archivo\" ng-cloak flex \nstyle=\"max-height: 90vh\" md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"INSTALACIONES.MODALIMPORTAR.TITLE\">Importar instalaciones</h2></div></md-toolbar><md-dialog-content><md-list\n class=\"md-dense\" flex layout=\"row\" layout-xs=\"column\" layout-wrap><div class=\"instalacion\" \nng-repeat=\"inst in listaInstalaciones\"><md-checkbox ng-model=\"inst.seleccionado\" aria-label=\"seleccionado\"><h4><b>\n{{::inst.name}}</b></h4></md-checkbox></div></md-list></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"INSTALACIONES.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/instalaciones/templates/ordenHome.tmpl.html","<md-dialog id=\"ordenHome\" aria-label=\"Ver servicios\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" flex \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"INSTALACIONES.MODALORDEN.TITLE\">\nOrdenar \'Menú Home\'</h2></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-badge \ntranslate=\"INSTALACIONES.MODALORDEN.BADGEGRUPO\">Igual que su grupo</md-badge><md-badge \ntranslate=\"INSTALACIONES.MODALORDEN.BADGEBASE\">Base</md-badge><md-badge \ntranslate=\"INSTALACIONES.MODALORDEN.BADGEPURCH\">Comprable</md-badge></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"orden-sidebar\" layout=\"column\"><h3 \ntranslate=\"INSTALACIONES.MODALORDEN.SIDEBAR\">Sidebar</h3><div class=\"orden\" ng-model=\"installation.sidebar\" \nui-sortable=\"sortableOptionsY\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"elem elem-{{stateTree[srvc.idService]}}\" layout=\"column\" layout-align=\"space-between center\" \nng-repeat=\"srvc in installation.sidebar\"><img \nng-src=\"{{::(JSONconfig.logosPath.to + \'/\' + FilePaths.servicios_paquetes + \'/\' + srvc.acl + \'.png\')|replacePath}}\">\n<md-button class=\"md-fab md-mini-mini md-primary delete-button\" \nng-click=\"deleteServicio($index, installation.sidebar)\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini-mini md-primary change-state-button\" ng-click=\"openSidenav(srvc)\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"INSTALACIONES.MODALORDEN.CHANGESTATE\">Cambiar estado</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini-mini left-button\" ng-click=\"swap(installation.sidebar, $index, $index - 1)\" ng-disabled=\"$first\" \nhide show-xs show-sm aria-label=\"left\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini-mini right-button\" ng-click=\"swap(installation.sidebar, $index, $index + 1)\" ng-disabled=\"$last\" \nhide show-xs show-sm aria-label=\"right\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-tooltip>\n{{srvc.name|formatNameDesc}} (ACL: {{srvc.acl}})</md-tooltip></div></div><md-menu><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ANADIRSERVICIOGRUPO\">Añadir servicio/grupo\n</span></md-tooltip></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\"><md-menu-item \nng-repeat=\"item in listaSidebarRestantes|orderBy:\'name|formatNameDesc\'\"><md-button \nng-click=\"addServicio(item, installation.sidebar)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}}) (ACL: {{item.acl}})</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"column\" flex><div flex class=\"orden-home\"><div layout=\"row\" \nlayout-align=\"space-between start\"><h3 translate=\"INSTALACIONES.MODALORDEN.SERVICIOSHOME\">Servicios Home</h3><md-menu>\n<md-button class=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ANADIRSERVICIOGRUPO\">\nAñadir servicio/grupo</span></md-tooltip></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\"><md-menu-item \nng-repeat=\"item in listaHomeRestantes|orderBy:\'name|formatNameDesc\'\"><md-button \nng-click=\"addServicio(item, installation.homeServices)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}}) (ACL: {{item.acl}})</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"orden\" ng-model=\"installation.homeServices\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap ui-sortable=\"sortableOptionsX\"><div \nclass=\"elem elem-{{stateTree[srvc.idService]}}\" ng-repeat=\"srvc in installation.homeServices\"><img \nng-src=\"{{::(JSONconfig.logosPath.to + \'/\' + FilePaths.servicios_paquetes + \'/\' + srvc.acl + \'.png\')|replacePath}}\">\n<md-button class=\"md-fab md-mini-mini md-primary delete-button\" \nng-click=\"deleteServicio($index, installation.homeServices)\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini-mini md-primary change-state-button\" ng-click=\"openSidenav(srvc)\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"INSTALACIONES.MODALORDEN.CHANGESTATE\">Cambiar estado</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini-mini left-button\" ng-click=\"swap(installation.homeServices, $index, $index - 1)\" \nng-disabled=\"$first\" hide show-xs show-sm aria-label=\"left\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini-mini right-button\" \nng-click=\"swap(installation.homeServices, $index, $index + 1)\" ng-disabled=\"$last\" hide show-xs show-sm \naria-label=\"right\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button><md-tooltip>\n{{srvc.name|formatNameDesc}} (ACL: {{srvc.acl}})</md-tooltip></div></div></div><div class=\"orden-extra\"><div \nlayout=\"row\" layout-align=\"space-between start\"><h3 translate=\"INSTALACIONES.MODALORDEN.SERVICIOSEXTRA\">Servicios Extra\n</h3><md-menu><md-button class=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"INSTALACIONES.MODALORDEN.ANADIRSERVICIOGRUPO\">Añadir servicio/grupo</span></md-tooltip></md-button>\n<md-menu-content width=\"4\" style=\"max-height: 90vh\"><md-menu-item \nng-repeat=\"item in listaExtraRestantes.concat(listaHomeRestantes)|orderBy:\'name|formatNameDesc\' track by $index\">\n<md-button ng-click=\"addServicio(item, installation.extraServices)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}}) (ACL: {{item.acl}})</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"orden\" ng-model=\"installation.extraServices\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap ui-sortable=\"sortableOptionsX\"><div \nclass=\"elem elem-{{stateTree[srvc.idService]}}\" ng-repeat=\"srvc in installation.extraServices\"><img \nng-src=\"{{::(JSONconfig.logosPath.to + \'/\' + FilePaths.servicios_paquetes + \'/\' + srvc.acl + \'.png\')|replacePath}}\">\n<md-button class=\"md-fab md-mini-mini md-primary delete-button\" \nng-click=\"deleteServicio($index, installation.extraServices)\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini-mini md-primary change-state-button\" ng-click=\"openSidenav(srvc)\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"INSTALACIONES.MODALORDEN.CHANGESTATE\">Cambiar estado</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini-mini left-button\" ng-click=\"swap(installation.extraServices, $index, $index - 1)\" \nng-disabled=\"$first\" hide show-xs show-sm aria-label=\"left\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini-mini right-button\" \nng-click=\"swap(installation.extraServices, $index, $index + 1)\" ng-disabled=\"$last\" hide show-xs show-sm \naria-label=\"right\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button><md-tooltip>\n{{srvc.name|formatNameDesc}} (ACL: {{srvc.acl}})</md-tooltip></div></div></div></div></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\"><md-toolbar class=\"md-accent-bg\"><h1 \nclass=\"md-toolbar-tools\"><span translate=\"INSTALACIONES.ESTADOSERVICIO\">Estado del servicio</span></h1></md-toolbar>\n<md-content layout-padding><div class=\"layout-column botones-estado\"><md-button class=\"md-raised\" \nng-click=\"changeState(elem.idService)\" aria-label=\"null\"><span translate=\"INSTALACIONES.MODALORDEN.BADGEGRUPO\"></span>\n</md-button><md-button class=\"md-raised\" ng-click=\"changeState(elem.idService, \'base\')\" aria-label=\"base\"><span \ntranslate=\"INSTALACIONES.MODALORDEN.BADGEBASE\"></span></md-button><md-button class=\"md-raised\" \nng-click=\"changeState(elem.idService, \'purchasable\')\" aria-label=\"purchasable\"><span \ntranslate=\"INSTALACIONES.MODALORDEN.BADGEPURCH\"></span></md-button></div><ng-include src=\"\'group-services\'\" flex \nng-if=\"elem.elements\"></ng-include></md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"INSTALACIONES.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog><script type=\"text/ng-template\" \nid=\"group-services\">\n<div style=\'padding-left: 12px; border-left: 1px solid\' class=\"layout-column\">\n    <div ng-repeat=\"elem in elem.elements\" class=\"elem-{{stateTree[elem.idService]}}\">\n        <div layout=\"row\">\n            <span flex style=\"align-self: center\">{{elem.name|formatNameDesc}} (ACL: {{elem.acl}})</span>\n            <div layout=\"row\" class=\"botones-estado leds\">\n                <div ng-click=\"changeState(elem.idService)\"></div>\n                <div ng-click=\"changeState(elem.idService,\'base\')\"></div>\n                <div ng-click=\"changeState(elem.idService,\'purchasable\')\"></div>\n            </div>\n        </div>\n        <ng-include src=\"\'group-services\'\" flex ng-if=\'elem.elements\'></ng-include>\n    </div>\n</div>\n</script>");
$templateCache.put("app/main/Quantion/root/instalaciones/templates/paquetes.tmpl.html","<md-dialog id=\"ordenPaquetes\" aria-label=\"Paquetes\" ng-cloak flex-xs=\"100\" flex-sm=\"100\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"INSTALACIONES.MODALPAQUETES.TITLE\">Ordenar paquetes</h2></div>\n</md-toolbar><md-dialog-content><md-menu><md-button class=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"INSTALACIONES.MODALPAQUETES.ANADIRPAQUETE\">Añadir paquete</span></md-tooltip></md-button><md-menu-content \nwidth=\"4\" style=\"max-height: 90vh\"><md-menu-item ng-repeat=\"item in listaPaquetes\"><md-button \nng-click=\"addPaquete(item, installation.availablePackages)\" ng-disabled=\"exists(item, installation.availablePackages)\">\n<div layout=\"row\" flex><p flex>{{item.name|formatNameDesc}} ({{item.acl}})</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"orden\" ng-model=\"installation.availablePackages\" \nui-sortable=\"sortableOptionsY\" layout=\"column\"><div class=\"elem\" layout=\"row\" \nng-repeat=\"pkg in installation.availablePackages\"><div layout=\"column\" class=\"left-right-buttons md-primary-bg\">\n<md-button class=\"md-icon-button\" ng-click=\"swap(installation.availablePackages, $index, $index - 1)\" \nng-disabled=\"$first\" hide show-xs show-sm aria-label=\"left\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"white-fg\">\n</md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"swap(installation.availablePackages, $index, $index + 1)\" ng-disabled=\"$last\" hide show-xs show-sm \naria-label=\"right\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"white-fg\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\" flex><img ng-src=\"{{::pkg.logo|replacePath}}\"><h3 \nng-class=\"{\'text-strike\':!pkg.active}\">{{pkg.name|formatNameDesc}} ({{pkg.acl}})</h3><md-tooltip md-direction=\"bottom\" \nng-if=\"!pkg.active\"><span translate=\"INSTALACIONES.MODALORDEN.TACHADO\">Paquete inactivo actualmente</span></md-tooltip>\n</div><div class=\"delete-button md-primary-bg layout-row layout-align-center-center\"><md-button class=\"md-icon-button\" \nng-click=\"deletePaquete($index, installation.availablePackages)\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span>\n</md-tooltip></md-button></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"INSTALACIONES.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/instalaciones/templates/verServicios.tmpl.html","<md-dialog id=\"verServiciosInstalacion\" aria-label=\"Ver servicios\" ng-cloak flex md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"INSTALACIONES.MODALSERVICIOS.TITLE\" \ntranslate-values=\"{installationName:\'{{::installation.name}}\'}\">Servicios en \"{{::installation.name}}\"</h2></div>\n</md-toolbar><md-dialog-content><div layout-gt-sm=\"row\"><md-list flex><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"INSTALACIONES.MODALSERVICIOS.SERVICIOSBASE\">Servicios \'Base\'</span></md-subheader><md-menu><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALSERVICIOS.ANADIRBASE\">Añadir servicio \'Base\'\n</span></md-tooltip></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\"><md-menu-item \nng-repeat=\"item in listaServicios|orderBy:\'name|formatNameDesc\'\"><md-button \nng-click=\"addServicio(item, installation.registerBase)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}})</p></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-list-item layout=\"row\" ng-repeat=\"srvc in installation.registerBase\"><p>\n{{::srvc.name|formatNameDesc}} ({{::srvc.type|uppercase}})</p><md-button class=\"md-icon-button md-primary\" \nng-click=\"deleteServicio($index, srvc, installation.registerBase)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip>\n</md-button></md-list-item></md-list><md-list flex><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"INSTALACIONES.MODALSERVICIOS.SERVICIOSCOMPRABLES\">Servicios \'Comprables\'</span></md-subheader><md-menu>\n<md-button class=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALSERVICIOS.ANADIRCOMPRABLE\">\nAñadir servicio \'Comprable\'</span></md-tooltip></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\">\n<md-menu-item ng-repeat=\"item in listaServicios|orderBy:\'name|formatNameDesc\'\"><md-button \nng-click=\"addServicio(item, installation.registerPurchasable)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}})</p></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-list-item layout=\"row\" ng-repeat=\"srvc in installation.registerPurchasable\"><p>\n{{::srvc.name|formatNameDesc}} ({{::srvc.type|uppercase}})</p><md-button class=\"md-icon-button md-primary\" \nng-click=\"deleteServicio($index, srvc, installation.registerPurchasable)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip>\n</md-button></md-list-item></md-list><md-list flex><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"INSTALACIONES.MODALSERVICIOS.FUNCIONESEXTRA\">Funciones \'Extra\'</span></md-subheader><md-menu><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALSERVICIOS.ANADIREXTRA\">Añadir función \'Extra\'\n</span></md-tooltip></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\"><md-menu-item \nng-repeat=\"item in listaServicios|orderBy:\'name|formatNameDesc\'\"><md-button \nng-click=\"addServicio(item, installation.registerExtra, true)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}})</p></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-list-item layout=\"row\" ng-repeat=\"srvc in installation.registerExtra\"><p>\n{{::srvc.name|formatNameDesc}} ({{::srvc.type|uppercase}})</p><md-button class=\"md-icon-button md-primary\" \nng-click=\"deleteServicio($index, srvc, installation.registerExtra)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip>\n</md-button></md-list-item></md-list><md-list flex><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"INSTALACIONES.MODALSERVICIOS.GRUPOS\">Grupos</span></md-subheader><md-menu><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALSERVICIOS.ANADIRGRUPO\">Añadir grupo</span>\n</md-tooltip></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\"><md-menu-item \nng-repeat=\"item in listaGrupos|orderBy:\'name|formatNameDesc\'\"><md-button \nng-click=\"addGrupo(item, installation.registerGroup)\"><div layout=\"row\" flex><p flex>\n{{item.name|formatNameDesc}} ({{item.type|uppercase}})</p></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-list-item layout=\"row\" ng-repeat=\"srvc in installation.registerGroup\"><p>\n{{::srvc.name|formatNameDesc}} ({{::srvc.type|uppercase}})</p><md-button class=\"md-icon-button md-primary\" \nng-click=\"deleteGrupo($index, srvc, installation.registerGroup)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"INSTALACIONES.MODALORDEN.ELIMINAR\">Eliminar</span></md-tooltip>\n</md-button></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"INSTALACIONES.CERRAR\">Cerrar</md-button><md-button ng-click=\"Guardar()\" style=\"margin-right:20px\" \ntranslate=\"INSTALACIONES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/tarjetas/templates/acciones.tmpl.html","<md-dialog id=\"tarjetas\" aria-label=\"Acciones\" md-theme=\"{{$root.theme}}\" flex-xs=\"100\" flex-sm=\"100\" flex><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content style=\"min-height: 320px\">\n<md-button class=\"md-fab md-mini\" ng-click=\"addAction()\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target>\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"TARJETAS.ACCIONES.NUEVA\">Añadir nueva acción</span>\n</md-tooltip></md-button><table><tr ng-repeat=\"action in card.actions\"><td><pre>{{action|json}}</pre></td><td><div>\n<md-button class=\"md-fab md-mini\" ng-click=\"editAction(action, $index)\"><md-icon md-font-icon=\"icon-pencil\" \nmd-menu-align-target></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"TARJETAS.ACCIONES.EDITAR\">\nEditar acción</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" ng-click=\"deleteAction($index)\"><md-icon\n md-font-icon=\"icon-delete\" md-menu-align-target></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TARJETAS.ACCIONES.ELIMINAR\">Editar acción</span></md-tooltip></md-button></div></td></tr></table><md-sidenav\n class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\"><md-content layout-padding><form name=\"form\">\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"TARJETAS.ACCIONES.METHOD\">Method</label>\n<md-select ng-model=\"_action.method\"><md-option \nng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'PATCH\', \'OPTIONS\', \'TRACE\', \'HEAD\']\" value=\"{{method}}\">\n{{method}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\"><input \nng-model=\"_action.url\" placeholder=\"url\"><div class=\"hint\">Ej: https://wc.solertia.sol:8091/browser</div><div \nclass=\"hint\"><span translate=\"TARJETAS.ACCIONES.VARIABLES\">Lista de variables sustituibles</span>\n: {{::varList|stringifyArray}}</div></md-input-container><md-input-container class=\"md-block no-errors-spacer\"><input \nng-model=\"_action.data\" placeholder=\"data\"><div class=\"hint\">Browser: {\"url\": \"###\"}</div><div class=\"hint\">\nBrowser: {\"url\": \"###\", \"argv\": [\"###\", \"###\"]}</div><div class=\"hint\">Java: {\"path\": \"###\", \"argv\": [\"###\", \"###\"]}\n</div></md-input-container><md-button class=\"md-raised md-accent\" ng-click=\"Guardar()\" ng-disabled=\"form.$invalid\" \nstyle=\"margin-right:20px\" translate=\"IDIOMAS.GUARDAR\">Guardar</md-button></form></md-content></md-sidenav>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/tarjetas/templates/cambiarTipo.tmpl.html","<md-dialog id=\"tarjetas\" aria-label=\"Cambiar tipo\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><md-radio-group \nng-model=\"selectedType\"><md-radio-button ng-repeat=\"type in typeList\" value=\"{{type.name}}\">{{type.name}}\n</md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"IDIOMAS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/tarjetas/templates/importar.tmpl.html","<md-dialog id=\"tarjetas\" aria-label=\"Cambiar tipo\" md-theme=\"{{$root.theme}}\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"TARJETAS.IMPORTAR\">Importar desde archivo</h2></div></md-toolbar>\n<md-dialog-content><p class=\"text-boxed margin-bottom-8\" translate=\"TARJETAS.MENSAJEIMPORTAR\">\nEl archivo debe ser una ID por línea</p><div layout=\"row\" layout-align=\"space-between center\"><input type=\"file\" \nid=\"fileInput\" class=\"margin-right-20\"><md-button ng-click=\"readFile()\" class=\"md-raised md-accent\" \ntranslate=\"TARJETAS.BOTONLEER\">Leer</md-button></div><textarea ng-model=\"textcontent\" \nng-change=\"splitContent(textcontent)\" ng-model-options=\"{debounce: 500}\" required></textarea><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"TARJETAS.TIPO\">Tipo</label><md-select ng-model=\"type\" required>\n<md-option ng-repeat=\"type in typeList\" value=\"{{type.name}}\">{{type.name}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"IDIOMAS.GUARDAR\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/root/tarjetas/templates/nuevaTarjeta.tmpl.html","<md-dialog id=\"tarjetas\" aria-label=\"Cambiar tipo\" md-theme=\"{{$root.theme}}\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"md-block no-errors-spacer\"><input ng-model=\"card.uuidAuthCard\" placeholder=\"UUID\" required></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"IDIOMAS.GUARDAR\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/root/tarjetas/templates/nuevoTipo.tmpl.html","<md-dialog id=\"tarjetas\" aria-label=\"Cambiar tipo\" md-theme=\"{{$root.theme}}\"><form name=\"form\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{DialogTitle}}</h2></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"TARJETAS.TIPO\">Tipo</label><input ng-model=\"typeName\" required>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"IDIOMAS.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"Guardar()\" ng-disabled=\"form.$invalid || form.$pristine\" style=\"margin-right:20px\" \ntranslate=\"IDIOMAS.GUARDAR\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Quantion/root/tarjetas/templates/verAccion.tmpl.html","<md-dialog id=\"ver-accion\" aria-label=\"Cambiar tipo\" md-theme=\"{{$root.theme}}\"><md-toolbar></md-toolbar>\n<md-dialog-content><h3>{{action.name}}</h3><h4>{{action.method}} {{action.url}}</h4><h4 style=\"white-space: pre\">\n{{action.data|json: 4}}</h4></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"hide()\" \ntranslate=\"IDIOMAS.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/equipos/templates/details.tmpl.html","<md-dialog id=\"aviso-details\" aria-label=\"Detalles aviso\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><div layout=\"row\" layout-align=\"start start\"><div><h2>\n{{::task.title}}</h2><h3>{{::task.description}}</h3><h4 ng-hide=\"!task.fIni\">\n{{::task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{::task.fFin|date:\"dd/MM/yyyy HH:mm\"}} ({{::task.displaytime|convertSeconds}}, cada {{::task.intervalo| convertMinutesInHHMMSS}})\n</h4><code>{{::task.command}}</code></div></div><a href=\"#\" ng-click=\"showJson = !showJson\">Ver/ocultar JSON completo\n</a><pre ng-show=\"showJson\" class=\"md-light-blue-50-bg margin-0\">{{::task|json}}</pre></md-content></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/Quantion/tasks/equipos/templates/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenNotif\" aria-label=\"Elegir imagen\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-dialog-content><div layout=\"row\" layout-wrap layout-align=\"start stretch\"><div \nng-repeat=\"obj in listaLogos| filter: {name:logo_}\" layout=\"column\" layout-align=\"start center\" class=\"element\"><div \nclass=\"img-container\"><img ng-src=\"{{::(obj.path|replacePath)}}\" ng-click=\"escogerImagen(obj)\"></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"hide()\" \ntranslate=\"CREAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/equipos/templates/task-template.tmpl.html","<md-dialog id=\"task-template\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"TASKS.INFO\">Info</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.NOMBRE\">Nombre de la tarea</label><input type=\"text\" name=\"title\" ng-model=\"task.title\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DESCRIPCION\">Descripción</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"task.description\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span\n class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"TASKS.ACCION\">Acción</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div><md-checkbox \nng-model=\"task.arguments.taskroot\" aria-label=\"root\">Solo ROOT</md-checkbox><div layout=\"row\"><md-input-container \nclass=\"md-block\"><label translate=\"TASKS.METHOD\">Metodo</label><md-select ng-model=\"task.metodo\"><md-option \nng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'OPTIONS\']\" value=\"{{method}}\">{{method}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"TASKS.COMMAND\">Comando</label><input \ntype=\"text\" name=\"command\" ng-model=\"task.arguments.cmdline\" md-maxlength=\"255\" required><div \nng-messages=\"paso2.command.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El título debe tener menos de 255 caracteres.</div></div></md-input-container></div>\n<md-input-container class=\"md-block\"><label>Body</label><textarea ng-model=\"task.header\" md-maxlength=\"10000\" \nstyle=\"resize: vertical\"></textarea></md-input-container><div><md-subheader class=\"md-no-sticky\">Argumentos\n</md-subheader><div layout=\"row\" ng-repeat=\"arg in task.arguments.args track by $index\" \nclass=\"arg-container layout-align-space-between-center\" ng-class-odd=\"\'md-grey-400-bg\'\"><h2>#{{$index + 1}}</h2>\n<md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Nombre del argumento</label><input ng-model=\"arg.name\">\n</md-input-container><md-checkbox ng-model=\"arg.editable\" aria-label=\"Editable\">Editable</md-checkbox>\n<md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Tipo</label><md-select ng-model=\"arg.type\"><md-option \nng-repeat=\"type in argTypeList\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container>\n<md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Valor</label><input ng-model=\"arg.value\">\n</md-input-container><md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteArgument($index)\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-button class=\"md-icon-button md-primary md-raised\" \naria-label=\"add\" ng-click=\"addArgument()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" \ntranslate=\"ENVIAR.ANTERIOR\">Anterior</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"guardar()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado\" translate=\"EDITAR_STB.GUARDAR\">Guardar</md-button><img \nsrc=\"/assets/quantionImagenes/cargando.gif\" alt=\"\" ng-if=\"loading\"></div></ms-form-wizard></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/equipos/templates/task.tmpl.html","<md-dialog id=\"task-template\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"TASKS.INFO\">Info</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.NOMBRE\">Nombre de la tarea</label><input type=\"text\" name=\"title\" ng-model=\"task.title\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DESCRIPCION\">Descripción</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"task.description\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span\n class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"TASKS.ACCION\">Acción</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div><div layout=\"row\"><md-input-container \nclass=\"md-block\"><label translate=\"TASKS.METHOD\">Metodo</label><md-select ng-model=\"task.metodo\"><md-option \nng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'OPTIONS\']\" value=\"{{method}}\">{{method}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"TASKS.COMMAND\">Comando</label><input \ntype=\"text\" name=\"command\" ng-model=\"task.arguments.cmdline\" md-maxlength=\"255\" required><div \nng-messages=\"paso2.command.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El título debe tener menos de 255 caracteres.</div></div></md-input-container></div>\n<md-input-container class=\"md-block\"><label>Body</label><textarea ng-model=\"task.header\" md-maxlength=\"10000\" \nstyle=\"resize: vertical\"></textarea></md-input-container><div><md-subheader class=\"md-no-sticky\">Argumentos\n</md-subheader><div layout=\"row\" ng-repeat=\"arg in task.arguments.args track by $index\" \nclass=\"arg-container layout-align-space-between-center\" ng-class-odd=\"\'md-grey-400-bg\'\"><h2>#{{$index + 1}}</h2>\n<md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Nombre del argumento</label><input ng-model=\"arg.name\" \nng-disabled=\"!arg.editable\"></md-input-container><md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Tipo\n</label><md-select ng-model=\"arg.type\" ng-disabled=\"!arg.editable\"><md-option ng-repeat=\"type in argTypeList\" \nvalue=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><md-input-container class=\"no-errors-spacer\" \nflex-gt-sm><label>Valor</label><input ng-model=\"arg.value\" ng-disabled=\"!arg.editable\"></md-input-container><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"delete\" ng-click=\"deleteArgument($index)\" ng-disabled=\"!arg.editable\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-button class=\"md-icon-button md-primary md-raised\" \naria-label=\"add\" ng-click=\"addArgument()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$invalid\">3</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso3.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.DESTINO\">Destino</span></span></md-tab-label><md-tab-body><form \nname=\"paso3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-button class=\"md-raised md-primary\" \nng-click=\"marcarTodo(true)\" translate=\"LOTES.MARCARTODO\">Marcar todo</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"marcarTodo(false)\" translate=\"LOTES.DESMARCARTODO\">Desmarcar todo</md-button>\n<md-button class=\"md-raised md-primary\" ng-click=\"marcarStorage()\" translate=\"LOTES.MARCARSTORAGE\">Marcar almacenados\n<md-tooltip md-direction=\"right\"><span translate=\"LOTES.MARCARSTORAGETOOLTIP\"></span></md-tooltip></md-button><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-wrap id=\"groupListContainer\"><div class=\"groupContainer\" \nng-repeat=\"grupo in listaGrupos\" layout=\"column\" on-last-repeat><div class=\"groupHeader\" layout=\"row\" \nlayout-align=\"center-center\"><div flex>{{grupo.nombre}} <span ng-if=\"grupo.place\">({{grupo.place}})</span></div>\n<md-button class=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo, true)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.SELECCIONARTODO\">Seleccionar todo</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"marcarGrupo(grupo, false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOTES.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div><div class=\"groupBody\" \nlayout=\"column\"><md-checkbox ng-repeat=\"stb in grupo.cStbs| orderBy:\'room\'\" ng-click=\"toggle(stb.idStb, task.stbs)\" \nng-checked=\"exists(stb.idStb, task.stbs)\" aria-label=\"seleccionado\">{{stb.room}} - {{stb.username}}</md-checkbox></div>\n</div></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso4.$invalid\">4</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso4.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">Temporización</span></span></md-tab-label>\n<md-tab-body><form name=\"paso4\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" \nlayout-xs=\"column\" layout-align-gt-xs=\"space-between\"><md-input-container flex=\"50\" flex-xs=\"100\"><label \ntranslate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</label><input name=\"displaytime\" type=\"number\" \nng-model=\"task.displaytime\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div><span>{{task.displaytime|convertSeconds}}</span></md-input-container>\n<md-radio-group ng-model=\"task.type\" layout=\"row\" layout-xs=\"column\" required><md-radio-button value=\"event\"><span \ntranslate=\"ENVIAR.INMEDIATO\">Inmediato</span></md-radio-button><md-radio-button value=\"eventProgrammed\"><span \ntranslate=\"ENVIAR.PROGRAMADO\">Programado</span></md-radio-button></md-radio-group></div><div class=\"temporizacion\" \nlayout=\"row\" layout-wrap ng-if=\"task.type === \'eventProgrammed\'\"><md-input-container flex-xs=\"50\" flex=\"33\"><label \ntranslate=\"ENVIAR.TINICIO\">Inicio periodo</label><input type=\"datetime-local\" ng-model=\"task.fIni\" required>\n</md-input-container><md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TFIN\">Fin periodo</label>\n<input type=\"datetime-local\" ng-model=\"task.fFin\" required></md-input-container><md-input-container flex-xs=\"100\" \nflex=\"33\"><label translate=\"ENVIAR.REPET\">Repetir cada</label><input name=\"tiemporepet\" type=\"number\" \nng-model=\"task.intervalo\" min=\"1\" required aria-label=\"tiemporepet\"> <button \nng-click=\"task.intervalo = task.intervalo + 1440\">+1D</button> <button ng-click=\"task.intervalo = task.intervalo + 60\">\n+1H</button> <span>{{task.intervalo|convertMinutesInHHMMSS}}</span></md-input-container><md-input-container \nflex-xs=\"50\" flex><label translate=\"ENVIAR.RANGOINICIO\">Inicio rango</label><input type=\"time\" \nng-model=\"task.rangeInit\"></md-input-container><md-input-container flex-xs=\"50\" flex><label \ntranslate=\"ENVIAR.RANGOFIN\">Fin rango</label><input type=\"time\" ng-model=\"task.rangeEnd\"></md-input-container></div>\n<div ng-if=\"task.type === \'eventProgrammed\'\"><div class=\"md-accent-bg info-temp\"><em>\'Hora mínima\'</em> y <em>\n\'Hora máxima\'</em>\n sirven para restringir el intervalo de horas que se ejecutará la tarea al día. Por ejemplo, si queremos que sólo se les haga entre las 9:00 y las 20:00.\n<br>Si se deja vacío, se podrán mostrar a cualquier hora.</div><div class=\"md-warn-bg info-temp margin-top-5\">\nLa tarea se ejecutará entre el <b>{{task.fIni|date:\'dd/MM/yyyy HH:mm\'}}</b> y el <b>\n{{task.fFin|date:\'dd/MM/yyyy HH:mm\'}}</b><br><span ng-show=\"task.rangeInit && task.rangeEnd\">Solo entre las <b>\n{{task.rangeInit|date:\'HH:mm\'}}</b> y las <b>{{task.rangeEnd|date:\'HH:mm\'}}</b></span></div></div></form></md-tab-body>\n</md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" \ntranslate=\"ENVIAR.ANTERIOR\">Anterior</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado || task.stbs.length < 1\" translate=\"TASKS.LANZAR\">Lanzar tarea\n</md-button><img src=\"/assets/quantionImagenes/cargando.gif\" alt=\"\" ng-if=\"loading\"></div></ms-form-wizard>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/servidor/templates/details.tmpl.html","<md-dialog id=\"aviso-details\" aria-label=\"Detalles aviso\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><div layout=\"row\" layout-align=\"start start\"><div><h2>\n{{::task.title}}</h2><h3>{{::task.description}}</h3><h4 ng-hide=\"!task.fIni\">\n{{::task.fIni|date:\"dd/MM/yyyy HH:mm\"}} - {{::task.fFin|date:\"dd/MM/yyyy HH:mm\"}} ({{::task.displaytime|convertSeconds}}, cada {{::task.intervalo| convertMinutesInHHMMSS}})\n</h4><code>{{::task.command}}</code></div></div><a href=\"#\" ng-click=\"showJson = !showJson\">Ver/ocultar JSON completo\n</a><pre ng-show=\"showJson\" class=\"md-light-blue-50-bg margin-0\">{{::task|json}}</pre></md-content></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/Quantion/tasks/servidor/templates/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenNotif\" aria-label=\"Elegir imagen\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-dialog-content><div layout=\"row\" layout-wrap layout-align=\"start stretch\"><div \nng-repeat=\"obj in listaLogos| filter: {name:logo_}\" layout=\"column\" layout-align=\"start center\" class=\"element\"><div \nclass=\"img-container\"><img ng-src=\"{{::(obj.path|replacePath)}}\" ng-click=\"escogerImagen(obj)\"></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"hide()\" \ntranslate=\"CREAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/servidor/templates/task-template.tmpl.html","<md-dialog id=\"task-template\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"TASKS.INFO\">Info</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.NOMBRE\">Nombre de la tarea</label><input type=\"text\" name=\"title\" ng-model=\"task.title\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DESCRIPCION\">Descripción</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"task.description\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span\n class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"TASKS.ACCION\">Acción</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div><md-checkbox \nng-model=\"task.arguments.taskroot\" aria-label=\"root\">Solo ROOT</md-checkbox><md-input-container class=\"md-block\"><label\n translate=\"TASKS.COMMAND\">Comando</label><input type=\"text\" name=\"command\" ng-model=\"task.arguments.cmdline\" \nmd-maxlength=\"255\" required><div ng-messages=\"paso2.command.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El título debe tener menos de 255 caracteres.</div></div></md-input-container><div>\n<md-subheader class=\"md-no-sticky\">Argumentos</md-subheader><div layout=\"row\" \nng-repeat=\"arg in task.arguments.args track by $index\" class=\"arg-container layout-align-space-between-center\" \nng-class-odd=\"\'md-grey-400-bg\'\"><h2>#{{$index + 1}}</h2><md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>\nNombre del argumento</label><input ng-model=\"arg.name\"></md-input-container><md-checkbox ng-model=\"arg.editable\" \naria-label=\"Editable\">Editable</md-checkbox><md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Tipo</label>\n<md-select ng-model=\"arg.type\"><md-option ng-repeat=\"type in argTypeList\" value=\"{{type}}\">{{type}}</md-option>\n</md-select></md-input-container><md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Valor</label><input \nng-model=\"arg.value\"></md-input-container><md-button class=\"md-icon-button md-accent\" aria-label=\"delete\" \nng-click=\"deleteArgument($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-button \nclass=\"md-icon-button md-primary md-raised\" aria-label=\"add\" ng-click=\"addArgument()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"ENVIAR.ANTERIOR\">Anterior\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"guardar()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado\" translate=\"EDITAR_STB.GUARDAR\">Guardar</md-button><img \nsrc=\"/assets/quantionImagenes/cargando.gif\" alt=\"\" ng-if=\"loading\"></div></ms-form-wizard></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/tasks/servidor/templates/task.tmpl.html","<md-dialog id=\"task-template\" aria-label=\"Detalles aviso\" ng-cloak flex=\"100\" flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" layout=\"column\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$invalid\">1</span>\n <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso1.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\" translate=\"TASKS.INFO\">Info</span></span></md-tab-label><md-tab-body><form \nname=\"paso1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.NOMBRE\">Nombre de la tarea</label><input type=\"text\" name=\"title\" ng-model=\"task.title\" \nmd-maxlength=\"80\" required><div ng-messages=\"paso1.title.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD2\">El título debe tener menos de 80 caracteres.</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DESCRIPCION\">Descripción</label><textarea \nstyle=\"height: 100px\" name=\"message\" ng-model=\"task.description\" md-maxlength=\"255\" rows=\"5\" required></textarea><div \nng-messages=\"paso1.message.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El mensaje debe tener menos de 255 caracteres.</div></div></md-input-container></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"paso1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span\n class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"TASKS.ACCION\">Acción</span></span></md-tab-label><md-tab-body><form \nname=\"paso2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.COMMAND\">Comando</label><input type=\"text\" name=\"command\" ng-model=\"task.arguments.cmdline\" \nmd-maxlength=\"255\" required><div ng-messages=\"paso2.command.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"md-maxlength\" \ntranslate=\"ENVIAR.MAXLONGITUD3\">El título debe tener menos de 255 caracteres.</div></div></md-input-container><div>\n<md-subheader class=\"md-no-sticky\">Argumentos</md-subheader><div layout=\"row\" \nng-repeat=\"arg in task.arguments.args track by $index\" class=\"arg-container layout-align-space-between-center\" \nng-class-odd=\"\'md-grey-400-bg\'\"><h2>#{{$index + 1}}</h2><md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>\nNombre del argumento</label><input ng-model=\"arg.name\" ng-disabled=\"!arg.editable\"></md-input-container>\n<md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Tipo</label><md-select ng-model=\"arg.type\" \nng-disabled=\"!arg.editable\"><md-option ng-repeat=\"type in argTypeList\" value=\"{{type}}\">{{type}}</md-option>\n</md-select></md-input-container><md-input-container class=\"no-errors-spacer\" flex-gt-sm><label>Valor</label><input \nng-model=\"arg.value\" ng-disabled=\"!arg.editable\"></md-input-container><md-button class=\"md-icon-button md-accent\" \naria-label=\"delete\" ng-click=\"deleteArgument($index)\" ng-disabled=\"!arg.editable\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"add\" \nng-click=\"addArgument()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"paso1.$invalid || paso2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\">\n<span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso4.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"paso4.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"ENVIAR.TEMPORIZACION\">Temporización</span></span></md-tab-label>\n<md-tab-body><form name=\"paso4\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" \nlayout-xs=\"column\" layout-align-gt-xs=\"space-between\"><md-input-container flex=\"50\" flex-xs=\"100\"><label \ntranslate=\"ENVIAR.DISPLAY\">Tiempo de visualización (en segundos)</label><input name=\"displaytime\" type=\"number\" \nng-model=\"task.displaytime\" min=\"1\" max=\"100000\" required aria-label=\"displaytime\"><div \nng-messages=\"formulario.displaytime.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"ENVIAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" translate=\"ENVIAR.MINLONGITUD\">\nEl tiempo debe ser mayor que cero.</div><div ng-message=\"max\" translate=\"ENVIAR.MAXLONGITUD4\">\nEl tiempo debe ser menor que 100000.</div></div><span>{{task.displaytime|convertSeconds}}</span></md-input-container>\n<md-radio-group ng-model=\"task.type\" layout=\"row\" layout-xs=\"column\" required><md-radio-button value=\"task\"><span \ntranslate=\"ENVIAR.INMEDIATO\">Inmediato</span></md-radio-button><md-radio-button value=\"taskProgrammed\"><span \ntranslate=\"ENVIAR.PROGRAMADO\">Programado</span></md-radio-button></md-radio-group></div><div class=\"temporizacion\" \nlayout=\"row\" layout-wrap ng-if=\"task.type === \'taskProgrammed\'\"><md-input-container flex-xs=\"50\" flex=\"33\"><label \ntranslate=\"ENVIAR.TINICIO\">Inicio periodo</label><input type=\"datetime-local\" ng-model=\"task.fIni\" required>\n</md-input-container><md-input-container flex-xs=\"50\" flex=\"33\"><label translate=\"ENVIAR.TFIN\">Fin periodo</label>\n<input type=\"datetime-local\" ng-model=\"task.fFin\" required></md-input-container><md-input-container flex-xs=\"100\" \nflex=\"33\"><label translate=\"ENVIAR.REPET\">Repetir cada</label><input name=\"tiemporepet\" type=\"number\" \nng-model=\"task.intervalo\" min=\"1\" required aria-label=\"tiemporepet\"> <button \nng-click=\"task.intervalo = task.intervalo + 1440\">+1D</button> <button ng-click=\"task.intervalo = task.intervalo + 60\">\n+1H</button> <span>{{task.intervalo|convertMinutesInHHMMSS}}</span></md-input-container><md-input-container \nflex-xs=\"50\" flex><label translate=\"ENVIAR.RANGOINICIO\">Inicio rango</label><input type=\"time\" \nng-model=\"task.rangeInit\"></md-input-container><md-input-container flex-xs=\"50\" flex><label \ntranslate=\"ENVIAR.RANGOFIN\">Fin rango</label><input type=\"time\" ng-model=\"task.rangeEnd\"></md-input-container></div>\n<div ng-if=\"task.type === \'taskProgrammed\'\"><div class=\"md-accent-bg info-temp\"><em>\'Hora mínima\'</em> y <em>\n\'Hora máxima\'</em>\n sirven para restringir el intervalo de horas que se ejecutará la tarea al día. Por ejemplo, si queremos que sólo se les haga entre las 9:00 y las 20:00.\n<br>Si se deja vacío, se podrán mostrar a cualquier hora.</div><div class=\"md-warn-bg info-temp margin-top-5\">\nLa tarea se ejecutará entre el <b>{{task.fIni|date:\'dd/MM/yyyy HH:mm\'}}</b> y el <b>\n{{task.fFin|date:\'dd/MM/yyyy HH:mm\'}}</b><br><span ng-show=\"task.rangeInit && task.rangeEnd\">Solo entre las <b>\n{{task.rangeInit|date:\'HH:mm\'}}</b> y las <b>{{task.rangeEnd|date:\'HH:mm\'}}</b></span></div></div></form></md-tab-body>\n</md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" \ntranslate=\"ENVIAR.ANTERIOR\">Anterior</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" translate=\"ENVIAR.SIGUIENTE\">Siguiente</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"enviarEvento()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || yaEnviado\" translate=\"TASKS.LANZAR\">Lanzar tarea</md-button><img \nsrc=\"/assets/quantionImagenes/cargando.gif\" alt=\"\" ng-if=\"loading\"></div></ms-form-wizard></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/asignar-instalacion.tmpl.html","<md-dialog id=\"asignar-servicios\" aria-label=\"Asignar servicios a isntalacion\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.MODALASIGNAR.TITLE\" \ntranslate-values=\"{serviceName:\'{{servicio.name|formatNameDesc}}\'}\">\nAsignar \'{{servicio.name|formatNameDesc}}\' a instalación</h2></div></md-toolbar><md-dialog-content><section \nng-repeat=\"instalacion in listaInstalaciones\"><md-subheader>{{instalacion.name}}</md-subheader><md-list \nclass=\"md-dense\" flex layout=\"column\" layout-gt-sm=\"row\" layout-wrap><md-radio-group \nng-model=\"select[instalacion.idInstallation]\" class=\"layout-gt-sm-row\"><md-radio-button value=\"registerBase\" \nng-if=\"servicio.type !== \'group\' || servicio.type !== \'extra\'\"><span translate=\"SERVICIOS.MODALASIGNAR.BASE\">Base\n</span></md-radio-button><md-radio-button value=\"registerPurchasable\" \nng-if=\"servicio.type !== \'group\' || servicio.type !== \'extra\'\"><span translate=\"SERVICIOS.MODALASIGNAR.COMPRABLE\">\nComprable</span></md-radio-button><md-radio-button value=\"registerExtra\" ng-if=\"servicio.type === \'extra\'\"><span \ntranslate=\"SERVICIOS.MODALASIGNAR.EXTRA\">Extra</span></md-radio-button><md-radio-button value=\"registerGroup\" \nng-if=\"servicio.type === \'group\'\"><span translate=\"SERVICIOS.MODALASIGNAR.GRUPO\">Grupo</span></md-radio-button>\n</md-radio-group></md-list><md-divider ng-if=\"!$last\"></section></md-dialog-content><md-dialog-actions layout=\"row\">\n<img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"SERVICIOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/asignaragrupo.tmpl.html","<md-dialog id=\"asignar-servicios\" aria-label=\"Asignar servicios a paquete\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"SERVICIOS.MODALASIGNARAGRUPO.TITLE\" translate-values=\"{groupName:\'{{::(group.name|formatNameDesc)}}\'}\">\nAsignar servicios al grupo \'{{group.name|formatNameDesc}}\'</h2></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"end center\"><label>Buscar:</label><input ng-model=\"search\" ng-model-options=\"{debounce: 500}\"></div>\n<section ng-repeat=\"(tipo, servicios) in listaServicios\"><md-subheader ng-click=\"fold(tipo)\"><md-icon md-font-icon \nclass=\"margin-right-8 icon-plus\" id=\"icon_{{tipo}}\"></md-icon><span translate=\"PAQUETES.SERVICIOS\">Servicios</span> \n<span class=\"text-uppercase\" translate=\"SERVICIOS.TIPOS.{{tipo}}\">{{tipo}}</span></md-subheader><md-list \nclass=\"md-dense hide\" flex layout=\"row\" layout-xs=\"column\" layout-wrap id=\"grupo_{{tipo}}\"><div class=\"servicio\" \nng-repeat=\"srv in servicios|filter:search\" layout=\"row\" layout-align=\"center\" flex-sm=\"50\"><md-checkbox \nng-checked=\"exists(srv.idService, selected)\" ng-click=\"toggle(srv.idService, selected)\" aria-label=\"seleccionado\">\n</md-checkbox><md-icon md-font-icon class=\"{{group.defaultService === srv.idService?\'icon-star\':\'icon-star-outline\'}}\" \nng-click=\"checkDefault(srv)\"></md-icon><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><h4><b>\n{{::srv.name|formatNameDesc}}</b><br><em>(ACL: {{::srv.acl}})</em></h4></div></md-list-item></div></md-list>\n<md-divider></section></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/asignarcanal.tmpl.html","<md-dialog id=\"servicios\" aria-label=\"Asignar canales a Servicio\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.MODALASIGNARCANAL.TITLE\">Asignar canales al servicio</h2></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"space-around stretch\" layout-margin \nstyle=\"margin-top: 0;min-height: 60vh\"><div layout=\"row\" class=\"busqueda left\"><md-content ms-scroll><div \nlayout=\"column\" layout-padding class=\"md-accent-bg\"><div layout=\"row\"><md-button class=\"md-icon-button md-primary\" \nng-click=\"setAll(true)\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\" class=\"icon\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"SERVICIOS.MODALASIGNARCANAL.SELECCIONARTODO\">Seleccionar todo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"setAll(false)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\" class=\"icon\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.MODALASIGNARCANAL.DESELECCIONARTODO\">Deseleccionar todo</span></md-tooltip></md-button></div>\n<md-input-container class=\"no-errors-spacer\"><label translate=\"SERVICIOS.MODALASIGNARCANAL.FILTRAR\">Filtrar</label>\n<input ng-model=\"busquedaNombre\" ng-model-options=\"{debounce: 500}\"></md-input-container><md-divider \nstyle=\"padding-bottom: 5px\"></md-divider><md-checkbox class=\"md-primary\" ng-repeat=\"item in listaIdiomas\" \nng-checked=\"exists(item, busquedaIdioma)\" ng-click=\"toggle(item, busquedaIdioma)\">{{item}}</md-checkbox><md-divider \nstyle=\"padding-bottom: 5px\"></md-divider><md-radio-group ng-model=\"busquedaTipo\" ng-init=\"busquedaTipo = \'\'\">\n<md-radio-button value=\"\" class=\"md-primary\"><span translate=\"SERVICIOS.MODALASIGNARCANAL.TODOS\">Todos</span>\n</md-radio-button><md-radio-button value=\"hd\" class=\"md-primary\"><span translate=\"SERVICIOS.MODALASIGNARCANAL.HD\">HD\n</span></md-radio-button><md-radio-button value=\"sd\" class=\"md-primary\"><span \ntranslate=\"SERVICIOS.MODALASIGNARCANAL.SD\">SD</span></md-radio-button></md-radio-group></div></md-content><div \nclass=\"md-primary-bg\"><md-icon md-font-icon=\"icon-filter\" style=\"color: white\" layout-margin></md-icon></div></div>\n<md-list class=\"md-dense\" flex layout-gt-sm=\"row\" layout=\"column\" layout-align=\"start start\" layout-wrap><md-list-item \nng-repeat=\"canal in listaCanales| filter: {\'nombre\':busquedaNombre, \'tipo\':busquedaTipo}|filter:filterByLang\" \nclass=\"listaCanales item\" layout-align=\"space-between center\" ng-click=\"toggleSelect(canal)\"><h4>\n[ID {{canal.idCanal}}] <b>{{canal.nombre}}</b> {{canal.idiomas| stringifyArray:true}}</h4><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"iconSelected\" ng-show=\"canal.seleccionado\"></md-icon></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"cancel()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/calendario.tmpl.html","<md-dialog id=\"calendar\" aria-label=\"Calendario\" ng-cloak flex style=\"max-height: 95vh\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.CALENDAR.TITLE\">Eventos de calendario</h2></div>\n</md-toolbar><md-dialog-content><div style=\"min-height: 60vh\"><md-button class=\"md-fab md-mini md-warn\" \nng-click=\"add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.NUEVOELEMENTO\">Nuevo elemento</span></md-tooltip></md-button><md-list \nng-repeat=\"(day, events) in service.dates\"><md-subheader class=\"md-no-sticky\"><span>{{day}}</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"event in events\"><img ng-src=\"{{event.image}}\" class=\"md-avatar\"><div \nclass=\"md-list-item-text\"><h3>{{event.title|formatNameDesc}}</h3></div><md-button class=\"md-fab md-mini\" \nng-click=\"editar(day, $index, event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"SERVICIOS.LISTASAMPLES.MODIFICAR\">Modificar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminar(day, $index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list></div><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\">\n<md-toolbar class=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\"><span translate=\"SERVICIOS.CALENDAR.SIDENAV\">\nDatos del evento</span></h1></md-toolbar><md-content layout-padding><form class=\"edicion layout-column\" name=\"form\">\n<md-tabs md-dynamic-height md-stretch-tabs=\"always\" class=\"pest\" flex><md-tab ng-repeat=\"idioma in listaIdiomas\">\n<md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" style=\"max-height: 24px\"></md-tab-label><md-tab-body><div \nlayout=\"column\"><md-input-container flex><label translate=\"SERVICIOS.CALENDAR.NOMBRE\">Nombre</label><input \nng-model=\"sample.title[idioma.idioma]\"></md-input-container><md-input-container flex><label \ntranslate=\"SERVICIOS.CALENDAR.DESCRIPCION\">Descripción</label><input ng-model=\"sample.description[idioma.idioma]\">\n</md-input-container></div></md-tab-body></md-tab></md-tabs><md-input-container flex=\"100\"><label \ntranslate=\"SERVICIOS.CALENDAR.CATEGORIA\">Categoria</label><input ng-model=\"sample.category\"></md-input-container>\n<md-input-container flex=\"100\"><label translate=\"SERVICIOS.CALENDAR.IMAGE\">Miniatura</label><input \nng-model=\"sample.image\"></md-input-container><div layout-gt-sm=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"SERVICIOS.CALENDAR.FECHA\">Fecha</label><input ng-model=\"sample.date\" type=\"date\" required name=\"date\"><div \nng-messages=\"form.date.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><md-input-container \nflex=\"50\"><label translate=\"SERVICIOS.CALENDAR.HINICIO\">Hora de inicio</label><input ng-model=\"sample.startTime\" \ntype=\"time\" required name=\"time\"><div ng-messages=\"form.time.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"EDITAR_STB.STB.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container>\n</div><md-input-container flex=\"100\"><label translate=\"SERVICIOS.CALENDAR.DURACION\">Duración</label><input \nng-model=\"sample.duration\" type=\"number\" step=\"60\" min=\"0\"> <span>{{sample.duration|convertSeconds}}</span>\n</md-input-container><div layout=\"row\" layout-align=\"end\"><md-button ng-click=\"close()\" translate=\"SERVICIOS.CERRAR\">\nCerrar</md-button><md-button ng-click=\"updateList()\" style=\"margin-right:20px\" \ntranslate=\"SERVICIOS.CALENDAR.ANADIREVENTO\" ng-disabled=\"form.$invalid\">Añadir evento</md-button></div></form>\n</md-content></md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/crearservicio.tmpl.html","<md-dialog id=\"servicios\" aria-label=\"Crear servicio\" ng-cloak flex=\"100\" flex-gt-sm=\"90\" md-theme=\"{{$root.theme}}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"{{title}}\" \ntranslate-values=\'{serviceType:\"{{::(\"SERVICIOS.TIPOS.\" + serviceType|translate)}}\"}\'></h2></div></md-toolbar>\n<md-dialog-content><form name=\"crearServicioForm\" novalidate layout-gt-sm=\"row\" layout=\"column\"><div flex><md-tabs \nmd-dynamic-height md-stretch-tabs=\"always\" class=\"pest\"><md-tab ng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img \nng-src=\"{{idioma.rutaIcono|replacePath}}\" style=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container \nclass=\"md-block no-errors-spacer\"><label translate=\"SERVICIOS.MODALEDITAR.NOMBRE\">Nombre del servicio</label><input \nname=\"name{{idioma.idioma}}\" ng-model=\"service.nameInt[idioma.idioma]\"></md-input-container><md-input-container \nclass=\"md-block margin-0\"><label translate=\"SERVICIOS.MODALEDITAR.DESCRIPCION\">Descripción</label><textarea \nstyle=\"height: 100px\" name=\"description{{idioma.idioma}}\" ng-model=\"service.descriptionInt[idioma.idioma]\" \nmd-maxlength=\"400\" rows=\"5\"></textarea></md-input-container><md-input-container ng-if=\"service.type === \'tv\'\" \nclass=\"md-block\"><label translate=\"SERVICIOS.MODALEDITAR.VIDEOURL\">URL del video promocional</label><input \nname=\"videoUrl{{idioma.idioma}}\" ng-model=\"service.blockedVideoInt[idioma.idioma]\"></md-input-container>\n<md-input-container ng-if=\"service.type === \'tv\'\" class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.VISIBLEVIDEOURL\">URL del video de error</label><input \nname=\"visibleUrl{{idioma.idioma}}\" ng-model=\"service.visibleVideoInt[idioma.idioma]\"></md-input-container>\n</md-tab-body></md-tab></md-tabs><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.ACL\">ACL</label><input name=\"acl\" ng-model=\"service.acl\" required \nng-change=\"watchAcl()\"><div ng-messages=\"crearServicioForm.acl.$error\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"SERVICIOS.MODALEDITAR.REQUIRED\">Este campo es obligatorio.</div></div></md-input-container><div \nlayout=\"column\"><md-input-container class=\"md-block no-errors-spacer margin-bottom-0\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.CATEGORIA\">Categoría</label><input name=\"categoria\" ng-model=\"service.category\">\n</md-input-container><div layout=\"row\" class=\"hint\" layout-wrap><span translate=\"SERVICIOS.MODALEDITAR.CAT_UTILIZADAS\">\nUtilizados:</span><div ng-repeat=\"cat in ::allCategories\" ng-click=\"service.category = cat\">\n{{::cat}}{{$last ? \'\' : \', \'}}</div></div></div><md-input-container class=\"md-block no-errors-spacer margin-top-32\">\n<label translate=\"SERVICIOS.MODALEDITAR.IDIOMA\">Idioma del contenido</label><md-select ng-model=\"service.lang\">\n<md-option ng-value=\"null\"></md-option><md-option ng-repeat=\"lang in listaIdiomas\" value=\"{{lang.idioma}}\"><img \nng-src=\"{{lang.rutaIcono| replacePath}}\" style=\"height: 30px;width:30px;object-fit: contain\"> {{lang.idioma}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.NOMBREVENTANA\">Nombre de ventana</label><input name=\"tag\" ng-model=\"service.tag\"> \n<span class=\"hint\">Ej. -HOME-OFFLINE-SOL-</span></md-input-container><md-input-container \nng-if=\"service.type === \'onlineradio\'\" class=\"md-block\"><label translate=\"SERVICIOS.MODALEDITAR.COUNTRIES\">\nPaises (separados por comas)</label><md-chips ng-model=\"service.countries\" placeholder=\"\"></md-chips>\n</md-input-container><md-input-container ng-if=\"service.type === \'weather\'\" class=\"md-block\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.CITIES\">Ciudades (separadas por comas)</label><md-chips ng-model=\"service.cities\">\n</md-chips></md-input-container><div ng-if=\"service.type === \'group\'\" \nclass=\"md-block layout-row layout-wrap margin-top-15 layout-align-start-center\"><md-checkbox ng-model=\"service.locked\">\n<span translate=\"SERVICIOS.MODALEDITAR.PATRON\">Patrón de desbloqueo</span></md-checkbox><md-input-container \nclass=\"md-block no-errors-spacer\" ng-if=\"service.locked\"><label>Tipo de bloqueo</label><md-select \nng-model=\"service.typeLocked\"><md-option ng-value=\"null\">-</md-option><md-option \nng-repeat=\"t in [\'pattern\', \'login\', \'patternlogin\']\" value=\"{{t}}\">{{t}}</md-option></md-select></md-input-container>\n<md-checkbox ng-model=\"service.visiblePattern\" ng-if=\"service.locked\"><span \ntranslate=\"SERVICIOS.MODALEDITAR.PATRONVISIBLE\">Patrón visible</span></md-checkbox><md-input-container \nclass=\"md-block no-errors-spacer\" ng-if=\"service.locked\" flex=\"100\"><label translate=\"SERVICIOS.MODALEDITAR.PATRONNUM\">\nPuntos del patrón</label><input type=\"number\" ng-model=\"service.serial\" name=\"patronnum\" required><div \nng-messages=\"crearServicioForm.patronnum.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"SERVICIOS.MODALEDITAR.REQUIRED\">Este campo es obligatorio.</div></div><div class=\"hint margin-top-5\">\nEj: 156784923</div><div>1 2 3<br>4 5 6<br>7 8 9</div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\" flex=\"33\" ng-if=\"service.locked\"><label>Visibilidad de usuario (userLocked)</label>\n<md-select ng-model=\"service.userLocked\"><md-option ng-value=\"null\">-</md-option><md-option \nng-repeat=\"t in [\'visible\', \'invisible\']\" value=\"{{t}}\">{{t}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" ng-if=\"service.locked\"><label>\nVisibilidad de contraseña (passwordLocked)</label><md-select ng-model=\"service.passwordLocked\"><md-option \nng-value=\"null\">-</md-option><md-option ng-repeat=\"t in [\'visible\', \'invisible\']\" value=\"{{t}}\">{{t}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\" \nng-if=\"service.locked\"><label>URL de login (urlLocked)</label><input name=\"urlLocked\" ng-model=\"service.urlLocked\">\n</md-input-container></div></div><div flex class=\"servicio-second-div layout-column\"><div class=\"pest\"><md-checkbox \nng-model=\"toActionInputType\" class=\"md-warn\"><span translate=\"SERVICIOS.MODALEDITAR.AVANZADO\">Avanzado</span>\n</md-checkbox><div ng-if=\"toActionInputType\"><md-input-container class=\"md-block no-errors-spacer\"><label>\ntoAction.method</label><md-select ng-model=\"toActionAdv.method\"><md-option \nng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'PATCH\', \'OPTIONS\', \'CONNECT\', \'HEAD\']\" value=\"{{method}}\">\n{{method}}</md-option></md-select></md-input-container><md-divider></md-divider><md-input-container \nclass=\"md-block no-errors-spacer\"><input ng-model=\"toActionAdv.url\" placeholder=\"toAction.url\"><div class=\"hint\">\nEj: https://wc.solertia.sol:8091/browser</div></md-input-container><md-divider></md-divider><md-input-container \nclass=\"md-block no-errors-spacer\"><input ng-model=\"toActionAdv.data\" placeholder=\"toAction.data\"><div class=\"hint\">\nBrowser: {\"url\": \"###\"}</div><div class=\"hint\">Browser: {\"url\": \"###\", \"argv\": [\"###\", \"###\"]}</div><div class=\"hint\">\nJava: {\"path\": \"###\", \"argv\": [\"###\", \"###\"]}</div></md-input-container></div><div ng-if=\"!toActionInputType\">\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"SERVICIOS.MODALEDITAR.TIPO\">Tipo de enlace\n</label><md-select ng-model=\"toActionBasic.url\"><md-option \nng-repeat=\"method in [\'https://wc.solertia.sol:8091/browser\', \'href\', \'iframe\']\" value=\"{{method}}\"><span \ntranslate=\"SERVICIOS.MODALEDITAR.{{method}}\">Enlace externo / Enlace interno</span></md-option></md-select>\n</md-input-container><md-divider></md-divider><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.URL\"></label><input ng-model=\"toActionBasic.data\"></md-input-container></div></div>\n<md-checkbox ng-model=\"service.active\" aria-label=\"Active service\" class=\"margin-top-15\" style=\"margin-left: 0\"><span \ntranslate=\"SERVICIOS.MODALEDITAR.ACTIVO\">Activo</span></md-checkbox><div layout=\"row\" \nng-if=\"service.type === \'group\' || service.type === \'files\'\"><md-input-container class=\"md-block no-errors-spacer\">\n<label translate=\"SERVICIOS.MODALEDITAR.FILAS\">Filas</label><input type=\"number\" ng-model=\"service.nrows\">\n</md-input-container><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.COLUMNAS\">Columnas</label><input type=\"number\" ng-model=\"service.ncolumns\">\n</md-input-container></div><md-input-container class=\"md-block no-errors-spacer\" \nng-if=\"service.type === \'group\' || service.type === \'files\'\"><label translate=\"SERVICIOS.MODALEDITAR.STYLE\">\nEstilo visual</label><md-select ng-model=\"service.style\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"s in [\'normal\', \'horizontal\', \'vertical\']\" value=\"{{s}}\">{{s}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"service.type === \'wifi\'\" class=\"md-block margin-bottom-8 no-errors-spacer\"><label \ntranslate=\"SERVICIOS.MODALEDITAR.MAXCONEXIONES\">Nº máximo de conexiones</label><input name=\"maxConexiones\" \ntype=\"number\" min=\"1\" max=\"2147483647\" ng-model=\"service.maxConnections\" required><div \nng-messages=\"crearServicioForm.maxConexiones.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\" translate=\"SERVICIOS.MODALEDITAR.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" \ntranslate=\"SERVICIOS.MODALEDITAR.MIN\">El valor no puede ser menor que 1</div><div ng-message=\"max\" \ntranslate=\"SERVICIOS.MODALEDITAR.MAX\">El valor no puede ser mayor que 2147483647</div></div></md-input-container>\n<md-input-container ng-if=\"service.type === \'wifi\' && service.portal !== undefined\" class=\"md-block no-errors-spacer\">\n<label translate=\"SERVICIOS.MODALEDITAR.PORTAL\">Portal</label><input name=\"portal\" type=\"text\" \nng-model=\"service.portal\"><div class=\"hint\">\nNombre de la red que provee el servicio de WiFi (en caso de no ser WiFi mediante el terminal)</div>\n</md-input-container><md-checkbox ng-model=\"service.touchable\" aria-label=\"Tactil\" class=\"margin-top-15\" \nstyle=\"margin-left: 0\"><span translate=\"SERVICIOS.MODALEDITAR.TACTIL\">Táctil compatible</span></md-checkbox>\n<md-checkbox ng-model=\"service.openAllowed\" aria-label=\"Open allowed\" class=\"margin-top-15\" style=\"margin-left: 0\">\n<span translate=\"SERVICIOS.MODALEDITAR.OPENALLOWED\">Puede ser abierto sin tenerlo comprado</span></md-checkbox></div>\n</form><div style=\"color: red; text-align: center\" translate=\"{{mensajeError}}\">{{mensajeError}}</div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"crearServicioForm.$invalid || dataLoading\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/dependenciasWidget.tmpl.html","<md-dialog id=\"asignar-servicios\" aria-label=\"Asignar servicios a paquete\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.MODALDEPENDENCIAS.TITLE\" \ntranslate-values=\"{widgetName:\'{{::(widget.name|formatNameDesc)}}\'}\">\nAsignar servicios al widget \'{{widget.name|formatNameDesc}}\'</h2></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" layout-align=\"end center\"><label>Buscar:</label><input ng-model=\"search\" \nng-model-options=\"{debounce: 500}\"></div><section ng-repeat=\"(tipo, servicios) in listaServicios\"><md-subheader \nng-click=\"fold(tipo)\"><md-icon md-font-icon class=\"margin-right-8 icon-plus\" id=\"icon_{{tipo}}\"></md-icon><span \ntranslate=\"PAQUETES.SERVICIOS\">Servicios</span> <span class=\"text-uppercase\" translate=\"SERVICIOS.TIPOS.{{tipo}}\">\n{{tipo}}</span></md-subheader><md-list class=\"md-dense hide\" flex layout=\"row\" layout-xs=\"column\" layout-wrap \nid=\"grupo_{{tipo}}\"><div class=\"servicio\" ng-repeat=\"srv in servicios|filter:search\" layout=\"row\" \nlayout-align=\"center\" flex-sm=\"50\"><md-checkbox ng-checked=\"exists(srv.idService, selected)\" \nng-click=\"toggle(srv.idService, selected)\" aria-label=\"seleccionado\"></md-checkbox><md-list-item><div \nclass=\"md-list-item-text\" layout=\"column\"><h4><b>{{::srv.name|formatNameDesc}}</b><br><em>(ACL: {{::srv.acl}})</em>\n</h4></div></md-list-item></div></md-list><md-divider></section></md-dialog-content><md-dialog-actions layout=\"row\">\n<img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"SERVICIOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/exportServices.tmpl.html","<md-dialog id=\"export-servicios\" aria-label=\"Importar servicios de archivo\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.MODALEXPORTAR.TITLE\">\nImportar servicios</h2></div></md-toolbar><md-dialog-content layout=\"row\"><div layout=\"column\" flex><section \nng-repeat=\"(tipo, servicios) in listaServicios\"><md-subheader class=\"md-accent\"><span \ntranslate=\"SERVICIOS.MODALIMPORTAR.SERVICIOS\">Servicios</span> <span class=\"text-uppercase\">{{tipo}}</span><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"selectAll(tipo)\" aria-label=\"Favorite\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon></md-button><md-button class=\"md-icon-button md-accent\" \nng-click=\"unselectAll(tipo)\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\">\n</md-icon></md-button></md-subheader><md-list class=\"md-dense\" flex layout-gt-sm=\"row\" layout=\"column\" layout-wrap><div\n class=\"servicio\" ng-repeat=\"srv in servicios|orderBy:\'name|formatNameDesc\'\"><md-checkbox \nng-checked=\"exists(srv.idService, selected)\" ng-click=\"toggle(srv.idService, selected)\" aria-label=\"seleccionado\" flex>\n<b>{{::(srv.name|formatNameDesc)}} ({{::srv.acl}})</b></md-checkbox></div></md-list><md-divider></section></div>\n<md-divider class=\"margin-left-10\"></md-divider><md-list class=\"md-dense\" layout=\"column\"><md-subheader><span \ntranslate=\"SERVICIOS.MODALEXPORTAR.TEMAS\">Temas exportados</span></md-subheader><div class=\"servicio\" \nng-repeat=\"tema in listaTemas\"><md-checkbox ng-checked=\"exists(tema, selectedThemes)\" \nng-click=\"toggle(tema, selectedThemes)\" aria-label=\"seleccionado\"><b>{{tema}}</b></md-checkbox></div></md-list>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button translate=\"SERVICIOS.MODALEXPORTAR.EXPORTARJSON\" \nng-click=\"exportJson()\" class=\"md-primary md-raised\" ng-disabled=\"selected.length < 1\">Exportar .json</md-button><a \nhref=\"#\" id=\"json-download-link\" download=\"\" hidden></a><md-button \ntranslate=\"SERVICIOS.MODALEXPORTAR.EXPORTARRECURSOS\" ng-click=\"exportRecursos()\" class=\"md-accent md-raised\" \nng-disabled=\"selectedThemes.length < 1 || selected.length < 1\">Exportar recursos</md-button><a href=\"#\" \nid=\"resources-download-link\" download=\"\"></a> <img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"> \n<span flex></span><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/imagenesServicio.tmpl.html","<md-dialog id=\"imagenes-servicio\" aria-label=\"Crear servicio\" ng-cloak flex=\"100\" flex-gt-sm=\"90\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.MODALIMAGENES.TITLE\">\n</h2></div></md-toolbar><md-dialog-content><form name=\"form1\" novalidate layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><label translate=\"SERVICIOS.MODALIMAGENES.LOGOADMIN\" flex=\"100\" \nclass=\"margin-bottom-8\">Logo del servicio para administrador web</label><div layout=\"row\" layout-align=\"start center\">\n<img ng-src=\"{{imageObj.admin|replacePath}}\" on-error-image><md-icon md-font-icon=\"icon-arrow-right\" \nclass=\"margin-left-15 margin-right-15\"></md-icon><img id=\"previewAdmin\"></div><div><input type=\"file\" accept=\"image/*\" \nid=\"logoInput\" required><md-button class=\"md-raised md-accent\" ng-disabled=\"!adminImageFile || uploadingAdminLogo\" \nng-click=\"uploadAdminLogo()\">Subir imagen</md-button><img ng-if=\"uploadingAdminLogo\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"></div></div></form><md-divider class=\"margin-vertical-16\"></md-divider>\n<form name=\"form2\" novalidate layout=\"column\"><fieldset class=\"standard margin-bottom-15 layout-column\"><legend \ntranslate=\"SERVICIOS.MODALIMAGENES.SUBIRALTEMA\">Subir al tema...</legend><div layout=\"row\" layout-align=\"start center\" \nclass=\"margin-bottom-16\"><md-input-container class=\"md-block no-errors-spacer flex-50 margin-right-16\"><label>\nNombre del archivo (con extensión)</label><md-select ng-model=\"themeFileName\" required name=\"filename\"><md-option \nng-repeat=\"n in imageNames\" value=\"{{n + \'.png\'}}\">{{n + \'.png\'}}</md-option></md-select><div \nng-messages=\"form2.filename.$error\" multiple=\"multiple\"><div ng-message=\"required\" \ntranslate=\"SERVICIOS.MODALEDITAR.REQUIRED\">Campo requerido</div></div></md-input-container><div flex=\"50\" \nclass=\"layout-row layout-align-start-center\"><img id=\"previewTheme\" class=\"margin-right-8\"> <input type=\"file\" \naccept=\"image/*\" id=\"logoInput2\" required></div></div><div layout=\"row\" layout-wrap><md-checkbox \nng-checked=\"exists(tema, selectedThemes)\" ng-click=\"toggle(tema, selectedThemes)\" ng-repeat=\"tema in listaTemas\">\n{{tema}}</md-checkbox></div><div layout=\"row\" class=\"layout-align-start-center\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!themeImageFile || form2.$invalid || selectedThemes.length < 1 || uploadingThemeLogo\" \nng-click=\"uploadThemesLogo()\">Subir imagen</md-button><img ng-if=\"uploadingThemeLogo\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"></div></fieldset><table><tr><th></th><th ng-repeat=\"theme in listaTemas\">\n{{theme}}</th></tr><tr ng-repeat=\"n in imageNames\"><td>{{n}}</td><td ng-repeat=\"theme in listaTemas\"><img \nng-src=\"{{imageObj[theme + \'#\' + n]|replacePath}}\" on-error-image><md-button class=\"md-icon-button\" \naria-label=\"delete image\" ng-click=\"deleteImage(theme, n)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</td></tr></table></form><div style=\"color: red; text-align: center\" translate=\"{{mensajeError}}\">{{mensajeError}}\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">\nCerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/importServices.tmpl.html","<md-dialog id=\"export-servicios\" aria-label=\"Importar servicios de archivo\" ng-cloak flex style=\"max-height: 90vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.MODALIMPORTAR.TITLE\">\nImportar servicios</h2></div></md-toolbar><md-dialog-content><section ng-repeat=\"(tipo, servicios) in listaServicios\">\n<md-subheader class=\"md-accent\"><span translate=\"SERVICIOS.MODALIMPORTAR.SERVICIOS\">Servicios</span> <span \nclass=\"text-uppercase\">{{tipo}}</span><md-button class=\"md-icon-button md-accent\" ng-click=\"selectAll(tipo)\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"unselectAll(tipo)\" aria-label=\"Favorite\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon></md-button></md-subheader><md-list class=\"md-dense\" \nflex layout-gt-sm=\"row\" layout=\"column\" layout-wrap><div class=\"servicio\" \nng-repeat=\"srv in servicios|orderBy:\'name|formatNameDesc\'\"><md-checkbox ng-checked=\"exists(srv.idService, selected)\" \nng-click=\"toggle(srv.idService, selected)\" aria-label=\"seleccionado\" flex><b>\n{{::(srv.name|formatNameDesc)}} ({{::srv.acl}})</b></md-checkbox></div></md-list><md-divider></section>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/listaSamples.tmpl.html","<md-dialog id=\"samples\" aria-label=\"Archivos disponibles\" ng-cloak flex \nstyle=\"max-height: 95vh; height: -webkit-fill-available\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.LISTASAMPLES.TITLE\">Archivos disponibles</h2></div></md-toolbar>\n<md-dialog-content style=\"height: -webkit-fill-available\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.LISTAELEMENTOS\">Lista de elementos</span></md-subheader><md-button \nclass=\"md-fab md-mini md-warn btn-abs\" ng-click=\"add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.NUEVOELEMENTO\">Nuevo elemento</span></md-tooltip>\n</md-button><md-list-item class=\"md-2-line\" ng-repeat=\"smpl in service.samples\"><div class=\"md-list-item-img\"><img \nng-src=\"{{smpl.thumbnail|replacePath}}\" on-error-image=\"/assets/quantionImagenes/img-error.png\"></div><div \nclass=\"md-list-item-text\"><h3>{{smpl.name|formatNameDesc}}</h3><a href=\"{{smpl.url|formatNameDesc|replacePath}}\" \ntarget=\"blank\">{{smpl.url|formatNameDesc}}</a></div><md-button class=\"md-fab md-mini\" ng-click=\"editar($index, smpl)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.MODIFICAR\">Modificar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminar($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list><md-divider></md-divider><div style=\"position: relative\"><md-subheader class=\"md-no-sticky\">\n<span translate=\"SERVICIOS.LISTASAMPLES.LISTAARCHIVOS\">Lista de archivos</span></md-subheader><md-button \nclass=\"md-fab md-mini md-warn btn-abs\" ng-click=\"upload()\"><md-icon md-font-icon=\"icon-upload\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"FILEEXPLORER.SUBIRARCHIVO\">Subir archivo</span></md-tooltip></md-button><input \ntype=\"file\" id=\"uploadFile\" hidden><div layout=\"row\" layout-wrap><div ng-repeat=\"file in listaArchivos\" \nclass=\"enlace-archivo md-warn-bg\"><a ng-href=\"{{file.path|replacePath}}\" target=\"blank\" class=\"md-warn-bg\">\n{{file.name}}</a></div></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\">\n<md-toolbar class=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\"></h1></md-toolbar><md-content layout-padding><form><div \nclass=\"edicion layout-column\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" class=\"pest\" flex><md-tab \nng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><div layout=\"column\"><md-input-container flex><label \ntranslate=\"SERVICIOS.LISTASAMPLES.NOMBRE\">Nombre</label><input ng-model=\"sample.name[idioma.idioma]\">\n</md-input-container><md-input-container flex><label translate=\"SERVICIOS.LISTASAMPLES.DESCRIPCION\">Descripción</label>\n<input ng-model=\"sample.description[idioma.idioma]\"></md-input-container><md-input-container flex><label \ntranslate=\"SERVICIOS.LISTASAMPLES.URL\">URL</label><md-select ng-model=\"sample.url[idioma.idioma]\"><md-option \nng-repeat=\"file in listaArchivos\" value=\"{{file.path}}\">{{file.name}}</md-option></md-select><span \nng-click=\"replicar(sample.url[idioma.idioma])\" translate=\"SERVICIOS.LISTASAMPLES.REPLICAR\" \nclass=\"md-accent-fg replicar\">Pulsa aquí para asignar este recurso a todos los idiomas</span></md-input-container>\n</div></md-tab-body></md-tab></md-tabs><md-input-container flex=\"100\"><label \ntranslate=\"SERVICIOS.LISTASAMPLES.MINIATURA\">Miniatura</label><md-select ng-model=\"sample.thumbnail\"><md-option \nng-repeat=\"file in listaArchivos\" value=\"{{file.path}}\">{{file.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\"><label translate=\"SERVICIOS.LISTASAMPLES.MIME\">Tipo de archivo</label><md-select \nng-model=\"selectedMime\" ng-change=\"mimeChanged(selectedMime)\"><md-option value=\"video\">Video</md-option><md-option \nvalue=\"imagen\">Imagen</md-option><md-option value=\"audio\">Audio</md-option><md-option value=\"doc\">Documento</md-option>\n<md-option value=\"_\">Otro</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nng-show=\"selectedMime === \'_\'\"><label translate=\"SERVICIOS.LISTASAMPLES.CUSTOMMIME\">Indica el tipo</label><input \nng-model=\"customMime\" ng-change=\"mimeChanged(customMime)\"></md-input-container><div layout=\"row\" layout-align=\"end\">\n<md-button ng-click=\"close()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"updateList()\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></div></div></form></md-content>\n</md-sidenav></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/modalService.tmpl.html","<md-dialog id=\"modal-actions\" aria-label=\"Archivos disponibles\" ng-cloak flex \nstyle=\"max-height: 95vh; height: -webkit-fill-available\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.LISTASAMPLES.TITLE\">Archivos disponibles</h2></div></md-toolbar>\n<md-dialog-content style=\"height: -webkit-fill-available\"><form name=\"crearServicioForm\" novalidate><md-tabs \nmd-dynamic-height md-stretch-tabs=\"always\" class=\"pest\"><md-tab ng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img \nng-src=\"{{idioma.rutaIcono|replacePath}}\" style=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Header</label><input name=\"header{{idioma.idioma}}\" \nng-model=\"service.headerInt[idioma.idioma]\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\">\n<label>Subheader</label><input name=\"subheader{{idioma.idioma}}\" ng-model=\"service.subheaderInt[idioma.idioma]\">\n</md-input-container><md-input-container class=\"md-block margin-0\"><label>Body</label><textarea style=\"height: 100px\" \nname=\"body{{idioma.idioma}}\" ng-model=\"service.bodyInt[idioma.idioma]\" md-maxlength=\"1000\" rows=\"5\"></textarea>\n</md-input-container></md-tab-body></md-tab></md-tabs><md-checkbox ng-model=\"service.textBox\" \nclass=\"md-warn margin-top-16\"><span translate=\"SERVICIOS.MODAL.TEXTBOX\">Avanzado</span></md-checkbox></form><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"SERVICIOS.LISTASAMPLES.LISTAELEMENTOS\">Lista de elementos</span>\n</md-subheader><md-button class=\"md-fab md-mini md-warn btn-abs\" ng-click=\"add()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.NUEVOELEMENTO\">Nuevo elemento\n</span></md-tooltip></md-button><md-list-item class=\"md-2-line\" ng-repeat=\"act in service.actions\"><div \nclass=\"md-list-item-text\"><h3>{{act.name}} ({{act.titleInt|formatNameDesc}})</h3></div><md-button \nclass=\"md-fab md-mini\" ng-click=\"editar($index, act)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.MODIFICAR\">Modificar</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"eliminar($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip\n md-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\"><md-toolbar \nclass=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\"></h1></md-toolbar><md-content layout-padding><form \nclass=\"edicion layout-column\"><md-input-container flex><label translate=\"SERVICIOS.LISTASAMPLES.NOMBRE\">Nombre</label>\n<input ng-model=\"action.name\"></md-input-container><md-tabs md-dynamic-height md-stretch-tabs=\"always\" class=\"pest\" \nflex><md-tab ng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><div layout=\"column\"><md-input-container flex><label \ntranslate=\"SERVICIOS.LISTASAMPLES.NOMBRE\">Nombre</label><input ng-model=\"action.titleInt[idioma.idioma]\">\n</md-input-container><md-input-container flex><label translate=\"SERVICIOS.LISTASAMPLES.DESCRIPCION\">Descripción</label>\n<input ng-model=\"action.descriptionInt[idioma.idioma]\"></md-input-container></div></md-tab-body></md-tab></md-tabs>\n<div><md-input-container class=\"md-block no-errors-spacer\"><label>Method</label><md-select ng-model=\"action.method\">\n<md-option ng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'PATCH\', \'OPTIONS\', \'CONNECT\', \'HEAD\']\" \nvalue=\"{{method}}\">{{method}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>URL</label><input ng-model=\"action.url\"><div class=\"hint\">\nEj: https://wc.solertia.sol:8091/browser</div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Data</label><input ng-model=\"action.data\"><div class=\"hint\">\nBrowser: {\"url\": \"###\"}</div><div class=\"hint\">Browser: {\"url\": \"###\", \"argv\": [\"###\", \"###\"]}</div><div class=\"hint\">\nJava: {\"path\": \"###\", \"argv\": [\"###\", \"###\"]}</div></md-input-container></div><div layout=\"row\" layout-align=\"end\">\n<md-button ng-click=\"close()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"updateList()\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></div></form></md-content></md-sidenav>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" ng-disabled=\"crearServicioForm.$invalid || dataLoading\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/orden-grupo.tmpl.html","<md-dialog id=\"servicios\" aria-label=\"Ordenar canales\" ng-cloak flex md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.ORDENGRUPO.TITLE\">Orden</h2></div></md-toolbar><md-dialog-content>\n<div layout-padding style=\"border: 2px solid lightgray\"><md-list ui-sortable=\"sortableOptionsOrden\" \nng-model=\"group.elements\" class=\"md-dense\" flex layout=\"row\" layout-wrap><md-list-item \nng-repeat=\"srv in group.elements\" class=\"listaOrdenGrupo\"><h4>{{$index + 1}})</h4><h4>\n{{::srv.name|formatNameDesc}} (ACL: {{::srv.acl}})</h4></md-list-item></md-list></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/ordenarcanales.tmpl.html","<md-dialog id=\"servicios\" aria-label=\"Ordenar canales\" ng-cloak flex style=\"max-height: 100%\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.ORDENARCANALES.TITLE\">\nOrden de canales</h2></div></md-toolbar><md-dialog-content><div layout-padding-gt-sm \nstyle=\"border: 2px solid lightgray\"><md-tabs md-stretch-tabs=\"always\" md-dynamic-height><md-tab \nng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 100%\"></md-tab-label><md-tab-body><div layout=\"row\"><md-button class=\"md-fab md-mini\" \nng-click=\"copiarOrden(idioma.idioma)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.ORDENARCANALES.COPIAR\">Copiar orden</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini\" ng-click=\"pegarOrden(idioma.idioma)\" ng-disabled=\"!tempOrden\"><md-icon \nmd-font-icon=\"icon-content-paste\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.ORDENARCANALES.PEGAR\">Pegar orden</span></md-tooltip></md-button><md-menu><md-button \nclass=\"md-fab md-mini\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-flag-variant\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.ORDENARCANALES.PRIORIZAR\">Priorizar canales por idioma</span>\n</md-tooltip></md-button><md-menu-content><md-menu-item ng-repeat=\"item in listaCodes\"><md-button \nng-click=\"priorizarIdioma(idioma.idioma, item)\">{{item}}</md-button></md-menu-item></md-menu-content></md-menu></div>\n<md-list ui-sortable=\"sortableOptionsOrden\" ng-model=\"ordenacion[idioma.idioma]\" class=\"md-dense\" flex layout=\"column\" \nlayout-gt-sm=\"row\" layout-wrap><md-list-item ng-repeat=\"canal in ordenacion[idioma.idioma]\" class=\"listaCanales\" \nstyle=\"min-width:0\"><h4>{{$index + 1}})</h4><h4>[ID {{canal.idCanal}}] <b>{{canal.nombre}}</b>\n {{canal.idiomas| stringifyArray:true}}</h4><div layout=\"row\" layout-align=\"end center\" flex hide show-xs show-sm>\n<md-button class=\"md-fab md-mini-mini\" ng-click=\"swap(ordenacion[idioma.idioma], $index, $index - 1)\" \nng-disabled=\"$first\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini-mini\" ng-click=\"swap(ordenacion[idioma.idioma], $index, $index + 1)\" ng-disabled=\"$last\"><md-icon\n md-font-icon=\"icon-arrow-down\"></md-icon></md-button></div></md-list-item></md-list></md-tab-body></md-tab></md-tabs>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"cancel()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/radioCountries.tmpl.html","<md-dialog id=\"radio-countries\" aria-label=\"Radio countries\" ng-cloak flex style=\"max-height: 95vh\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.RADIOCOUNTRIES.TITLE\">\nPaises de la radio online</h2></div></md-toolbar><md-dialog-content><md-grid-list md-cols=\"2\" md-cols-sm=\"4\" \nmd-cols-md=\"6\" md-cols-gt-md=\"12\" md-row-height=\"4:3\" md-gutter=\"8px\" md-gutter-gt-sm=\"4px\"><md-grid-tile \nng-repeat=\"country in countryList|orderBy:\'title.en\'\" md-rowspan=\"1\" md-colspan=\"1\" \nng-class=\"{\'selected\':country.active}\"><img ng-src=\"{{country.img | replacePath}}\"><md-grid-tile-footer>\n{{country.title[\'en\']}} ({{country.code}})</md-grid-tile-footer></md-grid-tile></md-grid-list></md-dialog-content>\n<md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button \nng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/servicios/templates/widgetService.tmpl.html","<md-dialog id=\"modal-actions\" aria-label=\"Archivos disponibles\" ng-cloak flex \nstyle=\"max-height: 95vh; height: -webkit-fill-available\" md-theme=\"{{$root.theme}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"SERVICIOS.LISTASAMPLES.TITLE\">Archivos disponibles</h2></div></md-toolbar>\n<md-dialog-content style=\"height: -webkit-fill-available\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.LISTAELEMENTOS\">Lista de elementos</span></md-subheader><md-button \nclass=\"md-fab md-mini md-warn btn-abs\" ng-click=\"add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.NUEVOELEMENTO\">Nuevo elemento</span></md-tooltip>\n</md-button><md-list-item class=\"md-2-line\" ng-repeat=\"act in service.actions\"><div class=\"md-list-item-text\"><h3>\n{{act.name}} ({{act.titleInt|formatNameDesc}})</h3></div><md-button class=\"md-fab md-mini\" \nng-click=\"editar($index, act)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICIOS.LISTASAMPLES.MODIFICAR\">Modificar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminar($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"SERVICIOS.LISTASAMPLES.ELIMINAR\">Eliminar</span></md-tooltip></md-button>\n</md-list-item></md-list><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\"><md-toolbar \nclass=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\"></h1></md-toolbar><md-content layout-padding><form \nclass=\"edicion layout-column\"><md-input-container flex><label translate=\"SERVICIOS.LISTASAMPLES.NOMBRE\">Nombre</label>\n<input ng-model=\"action.name\"></md-input-container><md-tabs md-dynamic-height md-stretch-tabs=\"always\" class=\"pest\" \nflex><md-tab ng-repeat=\"idioma in listaIdiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><div layout=\"column\"><md-input-container flex><label \ntranslate=\"SERVICIOS.LISTASAMPLES.NOMBRE\">Nombre</label><input ng-model=\"action.titleInt[idioma.idioma]\">\n</md-input-container><md-input-container flex><label translate=\"SERVICIOS.LISTASAMPLES.DESCRIPCION\">Descripción</label>\n<input ng-model=\"action.descriptionInt[idioma.idioma]\"></md-input-container></div></md-tab-body></md-tab></md-tabs>\n<div><md-input-container class=\"md-block no-errors-spacer\"><label>Method</label><md-select ng-model=\"action.method\">\n<md-option ng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'PATCH\', \'OPTIONS\', \'CONNECT\', \'HEAD\']\" \nvalue=\"{{method}}\">{{method}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>URL</label><input ng-model=\"action.url\"><div class=\"hint\">\nEj: https://wc.solertia.sol:8091/browser</div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>Data</label><input ng-model=\"action.data\"><div class=\"hint\">\nBrowser: {\"url\": \"###\"}</div><div class=\"hint\">Browser: {\"url\": \"###\", \"argv\": [\"###\", \"###\"]}</div><div class=\"hint\">\nJava: {\"path\": \"###\", \"argv\": [\"###\", \"###\"]}</div></md-input-container></div><div layout=\"row\" layout-align=\"end\">\n<md-button ng-click=\"close()\" translate=\"SERVICIOS.CERRAR\">Cerrar</md-button><md-button ng-click=\"updateList()\" \nstyle=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button></div></form></md-content></md-sidenav>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"SERVICIOS.CERRAR\">Cerrar\n</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"SERVICIOS.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/asignarservicio.tmpl.html","<md-dialog id=\"asignarServicio\" aria-label=\"Asignar servicios a paquete\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nstyle=\"max-height: 90vh\" md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAQUETES.ASIGNARSERVICIOS.TITLE\">Asignar servicios al paquete</span> \'{{::pkg.name|formatNameDesc}}\'</h2>\n</div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"end center\"><label class=\"margin-right-8\">Buscar:\n</label><input ng-model=\"search\" ng-model-options=\"{debounce: 500}\"></div><section \nng-repeat=\"(tipo,servicios) in listaServicios\"><md-subheader ng-click=\"fold(tipo)\"><md-icon md-font-icon \nclass=\"margin-right-8 icon-plus\" id=\"icon_{{tipo}}\"></md-icon><span translate=\"PAQUETES.SERVICIOS\">Servicios</span> \n<span class=\"text-uppercase\">{{tipo}}</span></md-subheader><md-list class=\"md-dense hide\" flex layout-gt-sm=\"row\" \nlayout=\"column\" layout-wrap id=\"grupo_{{tipo}}\"><div class=\"servicio\" \nng-repeat=\"srv in servicios|filter:search|orderBy:\'name|formatNameDesc\'\" layout=\"row\" layout-align=\"center\">\n<md-checkbox ng-checked=\"exists(srv.idService)\" ng-click=\"toggle(srv.idService)\" aria-label=\"{{srv.idService}}\">\n</md-checkbox><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><h4><b>{{::srv.name|formatNameDesc}}</b><br>\n<em>(ACL: {{::srv.acl}})</em></h4></div></md-list-item></div></md-list></section></md-dialog-content><md-dialog-actions\n layout=\"row\"><img ng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"PAQUETES.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" style=\"margin-right:20px\" \ntranslate=\"PAQUETES.GUARDAR\" ng-disabled=\"dataLoading\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/asignarserviciopromo.tmpl.html","<md-dialog id=\"asignarServicio\" aria-label=\"Asignar servicios a paquete\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nstyle=\"max-height: 90vh\" md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAQUETES.ASIGNARSERVICIOPROMO.TITLE\">Asignar servicios promocionales al paquete</span>\n \'{{::pkg.name|formatNameDesc}}\'</h2></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><md-menu \nng-repeat=\"(tipo, servicios) in listaServicios\"><md-button ng-click=\"$mdOpenMenu()\" style=\"padding: 0 10px\" \ntranslate=\"SERVICIOS.TIPOS.{{tipo}}\" class=\"md-raised md-accent\">{{tipo}}</md-button><md-menu-content \nstyle=\"max-height: 95vh\"><md-menu-item ng-repeat=\"srv in servicios| orderBy:\'name|formatNameDesc\'\" \nstyle=\"height: 36px; min-height: 36px\"><md-button ng-click=\"addService(srv)\">\n{{::srv.name|formatNameDesc}} (ACL: {{::srv.acl}})</md-button></md-menu-item></md-menu-content></md-menu></div><table>\n<tr><th colspan=\"2\"></th><th ng-repeat=\"durationPrice in pkg.durationPrice|orderBy:\'duration\'\">\n{{durationPrice.duration|convertMinutesInHHMMSS}}</th></tr><tr \nng-repeat=\"srv in pkg.promotionalServices|orderBy:\'service.name|formatNameDesc\'\"><td><md-icon \nmd-font-icon=\"icon-close\" ng-click=\"removeService(srv.service.idService)\"></md-icon></td><td>\n{{srv.service.name|formatNameDesc}} (ACL: {{srv.service.acl}})</td><td \nng-repeat=\"durationPrice in pkg.durationPrice|orderBy:\'duration\'\"><div layout=\"column\" style=\"height: 40px\"><input \ntype=\"number\" ng-model=\"srv.conditionalDuration[durationPrice.duration]\" step=\"60\"> <span>\n{{srv.conditionalDuration[durationPrice.duration]|convertMinutesInHHMMSS}}</span></div></td></tr></table>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"PAQUETES.GUARDAR\" ng-disabled=\"dataLoading\">\nGuardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/creareditargateway.tmpl.html","<md-dialog id=\"paquetes\" aria-label=\"Crear paquete\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{::(tituloVentana|translate)}}</h2></div>\n</md-toolbar><md-dialog-content><form name=\"crearPaqueteForm\" layout=\"row\" layout-wrap \nlayout-align=\"space-around start\"><div flex-gt-sm=\"70\" flex=\"100\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nclass=\"pest\"><md-tab ng-repeat=\"idioma in idiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.NOMBRE\"></label><input name=\"name{{idioma.idioma}}\" \nng-model=\"gateway.nameInt[idioma.idioma]\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.DESCRIPCION\"></label><textarea style=\"height: 80px\" \nname=\"description{{idioma.idioma}}\" ng-model=\"gateway.descriptionInt[idioma.idioma]\" md-maxlength=\"400\" rows=\"5\" \nmd-select-on-focus></textarea></md-input-container></md-tab-body></md-tab></md-tabs><md-button \nng-click=\"elegirLogo($event)\" class=\"md-raised md-primary image-md-menu\"><md-icon md-font-icon=\"icon-picture\" \nng-if=\"!gateway.logo\"></md-icon><img ng-src=\"{{gateway.logo|replacePath}}\" ng-if=\"gateway.logo\"></md-button>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"PAQUETES.MODALEDITAR.MINPAGOEXTERNO\">\nImporte mínimo para su uso</label><input type=\"number\" name=\"minexternal\" ng-model=\"gateway.price\" step=\"0.01\">\n</md-input-container></div><div layout=\"column\"><div><md-input-container class=\"md-block no-errors-spacer\"><input \nng-model=\"gateway.toAction.name\" placeholder=\"toAction.name\"></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><label>toAction.method</label><md-select ng-model=\"gateway.toAction.method\">\n<md-option ng-repeat=\"method in [\'GET\', \'POST\', \'PUT\', \'DELETE\', \'PATCH\', \'OPTIONS\', \'CONNECT\', \'HEAD\']\" \nvalue=\"{{method}}\">{{method}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><input ng-model=\"gateway.toAction.url\" placeholder=\"toAction.url\"><div class=\"hint\">\nEj: https://wc.solertia.sol:8091/browser</div></md-input-container><md-input-container \nclass=\"md-block no-errors-spacer\"><input ng-model=\"gateway.toAction.data\" placeholder=\"toAction.data\"><div \nclass=\"hint\">Browser: {\"url\": \"###\"}</div><div class=\"hint\">Browser: {\"url\": \"###\", \"argv\": [\"###\", \"###\"]}</div><div \nclass=\"hint\">Java: {\"path\": \"###\", \"argv\": [\"###\", \"###\"]}</div></md-input-container></div><md-checkbox \nng-model=\"gateway.active\" aria-label=\"activo\" class=\"margin-top-16\"><span translate=\"PAQUETES.MODALEDITAR.ACTIVO\">\nActivo</span></md-checkbox></div></form><div style=\"color: red; text-align: center\">{{mensajeError}}</div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"guardar()\" ng-disabled=\"crearPaqueteForm.$invalid || dataLoading\" style=\"margin-right:20px\" \ntranslate=\"PAQUETES.GUARDAR\">Guardar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/creareditarpaquete.tmpl.html","<md-dialog id=\"paquetes\" aria-label=\"Crear paquete\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{::(tituloVentana|translate)}}</h2></div>\n</md-toolbar><md-dialog-content><form name=\"crearPaqueteForm\" layout=\"row\" layout-wrap \nlayout-align=\"space-around start\"><div flex-gt-sm=\"70\" flex=\"100\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nclass=\"pest\"><md-tab ng-repeat=\"idioma in idiomas\"><md-tab-label><img ng-src=\"{{idioma.rutaIcono|replacePath}}\" \nstyle=\"max-height: 24px\"></md-tab-label><md-tab-body><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.NOMBRE\"></label><input name=\"name{{idioma.idioma}}\" \nng-model=\"package.nameInt[idioma.idioma]\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.DESCRIPCION\"></label><textarea style=\"height: 80px\" \nname=\"description{{idioma.idioma}}\" ng-model=\"package.descriptionInt[idioma.idioma]\" md-maxlength=\"400\" rows=\"5\" \nmd-select-on-focus></textarea></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"PAQUETES.MODALEDITAR.VIDEO\"></label><md-select ng-model=\"package.videoInt[idioma.idioma]\"><md-option \nng-value=\"null\">-</md-option><md-option ng-repeat=\"video in listaVideos\" value=\"{{video.path}}\">{{video.name}}\n</md-option></md-select></md-input-container></md-tab-body></md-tab></md-tabs><div layout=\"column\" \nlayout-align=\"start start\" class=\"margin-top-16\"><span class=\"hint\" translate=\"PAQUETES.MODALEDITAR.SUBIRTIENDA\">\nSubir nuevo video o imagen (de tienda)</span> <input type=\"file\" id=\"videoStore\" accept=\"image/*,video/*\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-click=\"uploadVideo()\" class=\"md-raised md-primary\" \nng-disabled=\"uploading\"><span translate=\"FILEEXPLORER.SUBIRARCHIVO\">Enviar archivo</span></md-button>\n<md-progress-circular md-mode=\"indeterminate\" ng-show=\"uploading\"></md-progress-circular></div></div></div><div \nlayout=\"column\"><md-button ng-click=\"elegirLogo($event, \'normal\')\" class=\"md-raised md-primary image-md-menu\"><md-icon \nmd-font-icon=\"icon-picture\" ng-if=\"!package.logo\"></md-icon><img ng-src=\"{{package.logo|replacePath}}\" \nng-if=\"package.logo\"></md-button><md-button ng-click=\"elegirLogo($event, \'focus\')\" \nclass=\"md-raised md-accent image-md-menu\"><md-icon md-font-icon=\"icon-picture\" ng-if=\"!package.logoFocus\"></md-icon>\n<img ng-src=\"{{package.logoFocus|replacePath}}\" ng-if=\"package.logoFocus\"></md-button><md-checkbox \nng-model=\"package.active\" aria-label=\"activo\" class=\"margin-top-16\"><span translate=\"PAQUETES.MODALEDITAR.ACTIVO\">\nActivo</span></md-checkbox><md-input-container class=\"md-block no-errors-spacer\"><label \ntranslate=\"PAQUETES.MODALEDITAR.ACL\">ACL</label><input name=\"acl\" ng-model=\"package.acl\"></md-input-container>\n<md-input-container class=\"md-block no-errors-spacer\"><label translate=\"PAQUETES.MODALEDITAR.HISTORICAL\">Grupo</label>\n<input name=\"historical\" ng-model=\"package.historical\"></md-input-container></div></form><div \nstyle=\"color: red; text-align: center\">{{mensajeError}}</div></md-dialog-content><md-dialog-actions layout=\"row\"><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" \ntranslate=\"PAQUETES.CERRAR\">Cerrar</md-button><md-button ng-click=\"guardar()\" \nng-disabled=\"crearPaqueteForm.$invalid || dataLoading\" style=\"margin-right:20px\" translate=\"PAQUETES.GUARDAR\">Guardar\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/elegirimagen.tmpl.html","<md-dialog id=\"elegirImagenCanal\" aria-label=\"Elegir imagen\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-dialog-content><div layout=\"row\" layout-align=\"start center\"><input type=\"file\" \nid=\"packageLogo\" required accept=\"image/*\"><md-button ng-click=\"uploadFile()\" class=\"md-raised md-primary\"><span \ntranslate=\"FILEEXPLORER.SUBIRARCHIVO\">Enviar archivo</span></md-button></div><md-divider></md-divider><div \nlayout=\"row\" layout-wrap layout-align=\"start stretch\"><div ng-repeat=\"obj in listaLogos| filter: {name:logo_}\" \nlayout=\"column\" layout-align=\"start center\" class=\"element\" ng-click=\"escogerImagen(obj)\"><div class=\"img-container\">\n<img ng-src=\"{{::(obj.path|replacePath)}}\"></div><span>{{::obj.name}}</span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-icon-float md-block no-errors-spacer\"><label translate=\"BUSCAR.BUSCAR\">Buscar</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"logo_\" type=\"text\" id=\"buscador\" \nng-model-options=\"{debounce: 500}\"></md-input-container><span flex></span><md-button \nng-click=\"escogerImagen({path: \'\'})\" translate=\"\">Eliminar logo</md-button><md-button ng-click=\"hide()\" \ntranslate=\"CREAR.CERRAR\">Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/importPaquetes.tmpl.html","<md-dialog id=\"asignar-servicios\" aria-label=\"Importar paquetes de archivo\" ng-cloak flex=\"70\" \nstyle=\"max-height: 90vh\" md-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"PAQUETES.IMPORTAR.TITLE\">Importar paquetes</h2></div></md-toolbar><md-dialog-content><section><md-subheader>\n<span translate=\"PAQUETES.IMPORTAR.PAQUETES\">Paquetes</span></md-subheader><md-list class=\"md-dense\" flex \nlayout-gt-sm=\"row\" layout=\"column\" layout-wrap><div class=\"servicio\" ng-repeat=\"pkg in listaPaquetes\"><md-checkbox \nng-model=\"pkg.seleccionado\" aria-label=\"seleccionado\"><h4><b>{{::pkg.name|formatNameDesc}}</b></h4></md-checkbox></div>\n</md-list><md-divider></section></md-dialog-content><md-dialog-actions layout=\"row\"><img ng-if=\"dataLoading\" \nsrc=\"/assets/quantionImagenes/cargando.gif\"><md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\">Cerrar</md-button>\n<md-button ng-click=\"guardar()\" style=\"margin-right:20px\" translate=\"PAQUETES.GUARDAR\">Guardar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Quantion/root/gservicios/paquetes/templates/precios.tmpl.html","<md-dialog id=\"paquetes\" aria-label=\"Precios de paquete\" ng-cloak flex flex-xs=\"100\" flex-sm=\"100\" \nmd-theme=\"{{$root.theme}}\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"PAQUETES.MODALPRECIOS.TITLE\">\nPrecios del paquete</span> \'{{::pkg.name|formatNameDesc}}\'</h2></div></md-toolbar><md-dialog-content \nstyle=\"min-height: 250px\"><div class=\"price-tables\" flex layout=\"row\" layout-wrap layout-align=\"start center\"><div \nclass=\"price-table style-1 md-whiteframe-1dp md-primary-bg\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"p in precios|orderBy:\'duracion\'\"><div class=\"package-type\"><span class=\"period\">\n{{::p.duracion|convertMinutesInHHMMSS}}:</span> <span class=\"value\">{{::p.precio}}&nbsp;€</span></div><md-button \nclass=\"md-fab md-mini\" ng-click=\"eliminarPrecio(pkg.idPackage, p.duracion)\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-button class=\"md-fab md-mini md-warn\" ng-click=\"openSidenav()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"margin-top-24\"><md-checkbox \nng-repeat=\"gat in listaGateways\" ng-checked=\"exists(gat.idGateway, selectedGateways)\" \nng-click=\"toggle(gat.idGateway, selectedGateways)\">{{::gat.name|formatNameDesc}} (Min. {{::gat.price}}€)</md-checkbox>\n</div><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\"><md-content layout-padding><form \nname=\"addPrecio\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm><label \ntranslate=\"PAQUETES.MODALPRECIOS.DURACIONMIN\">Duración (en minutos)</label><input type=\"number\" min=\"1\" \nname=\"duracion\" ng-model=\"duracion\" ng-model-options=\"{debounce: 500}\" required><div \nng-messages=\"addPrecio.duracion.$error\"><div ng-message=\"required\" translate=\"PAQUETES.MODALPRECIOS.REQUIRED\">\nEste campo es obligatorio.</div><div ng-message=\"min\" translate=\"PAQUETES.MODALPRECIOS.MIN\">\nLa duración debe ser mayor que cero.</div></div><span class=\"price_\" ng-show=\"duracion\">\n{{duracion|convertMinutesInHHMMSS}}</span><div class=\"hint\" translate=\"PAQUETES.MODALPRECIOS.HINT\">\nSi introduces una duración existente, se sobreescribirá su precio</div></md-input-container><md-button \nclass=\"md-raised md-accent\" ng-click=\"duracion = duracion + 60\">+ 1h</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"duracion = duracion + 1440\">+ 1d</md-button><div flex=\"5\" hide-xs hide-sm></div><md-input-container \nclass=\"md-block\"><label translate=\"PAQUETES.MODALPRECIOS.PRECIO\">Precio</label><input type=\"number\" step=\"0.01\" \nmin=\"0\" name=\"precio\" ng-model=\"precio\" required><div ng-messages=\"addPrecio.precio.$error\"><div ng-message=\"required\" \ntranslate=\"PAQUETES.MODALPRECIOS.REQUIRED\">Este campo es obligatorio.</div><div ng-message=\"min\" \ntranslate=\"PAQUETES.MODALPRECIOS.NEG\">El precio no puede ser negativo.</div></div></md-input-container><img \nng-if=\"dataLoading\" src=\"/assets/quantionImagenes/cargando.gif\"><md-button class=\"md-raised md-primary\" \nng-click=\"guardarNuevoPrecio(pkg.idPackage, duracion, precio)\" ng-disabled=\"addPrecio.$invalid || dataLoading\"><span \ntranslate=\"PAQUETES.MODALPRECIOS.GUARDAR\">Guardar precio</span></md-button></form></md-content></md-sidenav>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"hide()\" translate=\"PAQUETES.CERRAR\">Cerrar\n</md-button></md-dialog-actions></md-dialog>");}]);